_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[97,42],{

/***/ "+I+g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__("aMao")

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),

/***/ "+ZX+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("dEMF")
var ieee754 = __webpack_require__("1TxV")
var isArray = __webpack_require__("Rl48")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "+sR0":
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__("ZK3j");
hash.common = __webpack_require__("roL5");
hash.sha = __webpack_require__("nYca");
hash.ripemd = __webpack_require__("yCYU");
hash.hmac = __webpack_require__("kKSj");

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),

/***/ "//Gm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__("+ZX+").Buffer
var inherits = __webpack_require__("qW1w")
var HashBase = __webpack_require__("i8+T")

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),

/***/ "/FsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_AVAILABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_EXCLUSIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_NO_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_NO_DEPARTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_NOT_BOOKABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_SIBLING_SUMMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_SIBLING_WINTER; });
var API_AVAILABLE = 'available';
var API_CLOSED = 'closed';
var API_EXCLUSIVITY = 'exclusivity';
var API_FULL = 'full';
var API_NO_FLIGHT = 'noFlight';
var API_NO_DEPARTURE = 'noDeparture';
var API_OPEN = 'open';
var API_SIBLING_SUMMER = 'siblingSummer';
var API_SIBLING_WINTER = 'siblingWinter';
var API_NOT_BOOKABLE = [API_CLOSED, API_EXCLUSIVITY, API_FULL, API_NO_DEPARTURE, API_SIBLING_SUMMER, API_SIBLING_WINTER];


/***/ }),

/***/ "/kXe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("r2q8").EventEmitter;


/***/ }),

/***/ "/xi0":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__("Imk+")
var primes = __webpack_require__("Y0Mb")

var DH = __webpack_require__("kkwi")

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("+ZX+").Buffer))

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "04nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ADDITIONAL_TRANSPORTS; });
/* unused harmony export SEARCH_CRITERIA_TRANSPORTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAdditionalTransports; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("70jX");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("NLwV");







var FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
var SEARCH_CRITERIA_TRANSPORTS = 'SEARCH_CRITERIA_TRANSPORTS';

function _runAdditionalTransportsQuery(_ref) {
  var proposalId = _ref.proposalId,
      appContext = _ref.appContext,
      searchCriterias = _ref.searchCriterias;
  var query = "\n    {\n      additionalTransports(proposalId : \"".concat(proposalId, "\" ").concat(searchCriterias ? ", searchCriteria: ".concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_6__[/* graphqlify */ "d"])(searchCriterias)) : '', ") {\n        id\n        price {\n          ...priceDetails\n        }\n        totalDifferentialPrice {\n          ...priceDetails\n        }\n        inbound {\n          ...transportsDetails\n        }\n        outbound {\n          ...transportsDetails\n        }\n      }\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* transportDetailsFragment */ "q"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPriceDetailFragment */ "h"])(appContext.locale), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* PROPOSAL_GET_ADDITIONAL_TRANSPORT */ "Nc"]
  });
}

function fetchAdditionalTransports(_ref2) {
  var proposal = _ref2.proposal,
      transportSearchCriteria = _ref2.transportSearchCriteria,
      appContext = _ref2.appContext;
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(FETCH_ADDITIONAL_TRANSPORTS));
    var defaultTransport = proposal.transports;
    return _runAdditionalTransportsQuery({
      proposalId: proposal.id,
      appContext: appContext,
      searchCriterias: transportSearchCriteria
    }).then(function (_ref3) {
      var additionalTransports = _ref3.additionalTransports;
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["resolve"])(FETCH_ADDITIONAL_TRANSPORTS), {
        additionalTransports: additionalTransports,
        selectedTransport: defaultTransport
      }));
    }, function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["reject"])(FETCH_ADDITIONAL_TRANSPORTS), error));
    });
  };
}



/***/ }),

/***/ "06Jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ additionalAccommodations_action_fetchBookingMoreAccommodations; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CLEAR_ADDITIONAL_ACCOMMODATIONS; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ FETCH_ADDITIONAL_ACCOMMODATIONS; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ TOGGLE_ACCOMMODATIONS_FILTER; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ UPDATE_FILTERED_ACCOMMODATIONS_RESULTS; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ TOGGLE_EXTRA_FEATURES; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ TOGGLE_PMR_CHECKBOX; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ clearAdditionalAccommodations; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ fetchAdditionalAccommodations; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getAlternativeFilteredAccommodations; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ toggleAdditionalAccommodationFilter; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ unselectAdditionalAccommodationsFilterCategory; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ toggleAdditionalAccommodationReducedMobilityFilter; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ togglePMRChecbox; });

// UNUSED EXPORTS: SET_FILTERED_ADDITIONAL_ACCOMMODATIONS

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/find.js
var find = __webpack_require__("6R5o");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/redux-optimist-promise/build/index.js
var build = __webpack_require__("b0q8");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: /opt/webapp/node_modules/stringify-object/index.js
var stringify_object = __webpack_require__("pPFN");
var stringify_object_default = /*#__PURE__*/__webpack_require__.n(stringify_object);

// CONCATENATED MODULE: ./src/client/components/utils/booking/bookingAccommodationsMore.queries.js



var bookingAccommodationsMore_queries_getBookingAccommodationsSearch = function getBookingAccommodationsSearch(appContext, id, options) {
  var body = [{
    attendees: options.attendees
  }];
  return "query {\n  bookingAdditionalAccommodations(bookingId: \"".concat(id, "\", body: ").concat(stringify_object_default()(body, {
    singleQuotes: false
  }), "\n  ) {\n    totalDifferentialPrice(selectedRate: \"").concat(options.selectedRate, "\") {\n      ...priceDetails\n      currency\n    }\n    differentialPriceByNight(\n      nightsNumber: ").concat(options.duration, ", \n      selectedRate: \"").concat(options.selectedRate, "\"\n    ) {\n      formattedValue(precision: 0)\n      value\n    }\n    isUpgradableOnline\n    accommodations {\n      attendeesDistribution {\n        attendees {\n          birthdate\n          customerId\n          id\n          type\n        }\n        id\n        quantity\n      }\n      bathroomEquipments {\n        id\n        label\n      }\n      categories {\n        id\n        label\n      }\n      category\n      categoryId\n      comfortType\n      connectingRoom\n      description\n      equipments {\n        id\n        label\n      }\n      exclusiveCollection\n      floorPlans\n      id\n      label\n\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      minCapacity\n      occupancies {\n        baby_count\n      }\n      occupation\n      outsideFacilities {\n        id\n        label\n      }\n      quantity\n      reducedMobilityAccess\n      roomType\n      services {\n        id\n        label\n      }\n      strengths {\n        id\n        label\n      }\n      surface\n      view {\n        id\n        label\n      }\n    }\n    id\n    remainingStock\n  }\n}\n").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(appContext === null || appContext === void 0 ? void 0 : appContext.locale), "\n");
};
// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js
















var CLEAR_ADDITIONAL_ACCOMMODATIONS = 'CLEAR_ADDITIONAL_ACCOMMODATIONS';
var GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT = 'GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT';
var FETCH_ADDITIONAL_ACCOMMODATIONS = 'FETCH_ADDITIONAL_ACCOMMODATIONS';
var CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var SET_FILTERED_ADDITIONAL_ACCOMMODATIONS = 'SET_FILTERED_ADDITIONAL_ACCOMMODATIONS';
var TOGGLE_ACCOMMODATIONS_FILTER = 'TOGGLE_ACCOMMODATIONS_FILTER';
var UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY';
var UPDATE_FILTERED_ACCOMMODATIONS_RESULTS = 'UPDATE_FILTERED_ACCOMMODATIONS_RESULTS';
var TOGGLE_EXTRA_FEATURES = 'TOGGLE_EXTRA_FEATURES';
var TOGGLE_PMR_CHECKBOX = 'TOGGLE_PMR_CHECKBOX';

function _getSelectedProposal(state) {
  if (!state) {
    return null;
  }

  var proposals = Object(booking_selector["t" /* getProposals */])(state) || [];
  var resort = Object(booking_selector["j" /* getCurrentResort */])(state);
  var selectedProposal = find_default()(proposals, {
    id: Object(booking_selector["v" /* getSelectedProposalId */])(state)
  }) || Object(proposalUtils["d" /* getDefaultProposal */])(proposals, resort);
  return selectedProposal;
}

function _createAdditionalAccommodationsFilters(_ref) {
  var getState = _ref.getState,
      i18n = _ref.i18n,
      product = _ref.product,
      proposal = _ref.proposal,
      shouldPreselectFilters = _ref.shouldPreselectFilters;
  return Object(createAction["b" /* default */])(CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    i18n: i18n,
    product: product,
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState()),
    selectedProposal: proposal,
    shouldPreselectFilters: shouldPreselectFilters
  });
}

function _updateAdditionalAccommodationsFilters(isPmrChecked, getState) {
  return Object(createAction["b" /* default */])(UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(booking_selector["c" /* getAdditionalAccommodationsFilters */])(getState()),
    reducedMobilityVisibility: isPmrChecked !== null && isPmrChecked !== void 0 ? isPmrChecked : Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState())
  });
}

function _toggleFilter(filter, getState) {
  return Object(createAction["b" /* default */])(TOGGLE_ACCOMMODATIONS_FILTER, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState()),
    filter: filter
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(createAction["b" /* default */])(UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState()),
    category: category
  });
}

function _updateFilterAccommodations(getState) {
  return Object(createAction["b" /* default */])(UPDATE_FILTERED_ACCOMMODATIONS_RESULTS, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(booking_selector["c" /* getAdditionalAccommodationsFilters */])(getState()),
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState())
  });
}

function _runAdditionalAccommodationsQuery(_ref2) {
  var proposalId = _ref2.proposalId,
      appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$selectedRate = _ref2.selectedRate,
      selectedRate = _ref2$selectedRate === void 0 ? '' : _ref2$selectedRate;
  var query = "\n    {\n      additionalAccommodations(proposalId: \"".concat(proposalId, "\") {\n        id\n        isUpgradableOnline\n        totalDifferentialPrice(selectedRate: \"").concat(selectedRate, "\") {\n          ...priceDetails\n        }\n        differentialPriceByNight(nightsNumber: ").concat(duration, ", selectedRate: \"").concat(selectedRate, "\") {\n          formattedValue(precision: 0)\n          value\n        }\n        remainingStock\n        accommodations {\n          id\n          categories { id label }\n          category\n          categoryId\n          comfortType\n          exclusiveCollection\n          connectingRoom\n          floorPlans\n          description\n          label\n          maxCapacity\n          roomType\n          media {\n            photos {\n              url\n            }\n          }\n          minCapacity\n          occupation\n          quantity\n          occupancies {\n            baby_count\n          }\n          outsideFacilities {\n            id\n            label\n          }\n          bathroomEquipments {\n            id\n            label\n          }\n          equipments {\n            id\n            label\n          }\n          services { id label }\n          strengths { id label }\n          surface\n          view { id label }\n          reducedMobilityAccess\n          attendeesDistribution {\n            id\n            quantity\n            attendees {\n              id\n              type\n              birthdate\n              customerId\n            }\n          }\n        }\n      }\n      config {\n        filters {\n          configuration {\n            categoryTitle\n            simpleRoom\n            simpleRooms\n            separatedRooms\n            separatedRooms3\n          }\n          comfort {\n            categoryTitle\n          }\n          extraFeatures {\n            categoryTitle\n          }\n          reducedMobility\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(get_default()(appContext, 'locale')), "\n  ");
  return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
    requestName: requestDictionary["Mc" /* PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS */]
  });
}

function clearAdditionalAccommodations() {
  return Object(createAction["b" /* default */])(CLEAR_ADDITIONAL_ACCOMMODATIONS);
}

function getAvailableFilteredAccommodationsByComfort(_ref3) {
  var additionalAccommodations = _ref3.additionalAccommodations;
  return Object(createAction["b" /* default */])(GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT, {
    additionalAccommodations: additionalAccommodations
  });
}

function getAlternativeFilteredAccommodations(_ref4) {
  var proposal = _ref4.proposal,
      appContext = _ref4.appContext;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate
    }).then(function (_ref5) {
      var additionalAccommodations = _ref5.additionalAccommodations;
      dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(getAvailableFilteredAccommodationsByComfort({
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT)));
    })["catch"](function (error) {
      logger_default.a.error('error', error);
    });
  };
}

function fetchAdditionalAccommodations(_ref6) {
  var appContext = _ref6.appContext,
      product = _ref6.product,
      proposal = _ref6.proposal,
      _ref6$roomsArrangemen = _ref6.roomsArrangement,
      roomsArrangement = _ref6$roomsArrangemen === void 0 ? [] : _ref6$roomsArrangemen,
      _ref6$shouldPreselect = _ref6.shouldPreselectFilters,
      shouldPreselectFilters = _ref6$shouldPreselect === void 0 ? true : _ref6$shouldPreselect;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch, getState) {
    dispatch(Object(createAction["b" /* default */])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate,
      roomsArrangement: roomsArrangement
    }).then(function (_ref7) {
      var additionalAccommodations = _ref7.additionalAccommodations,
          i18n = _ref7.config;
      dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(_createAdditionalAccommodationsFilters({
        getState: getState,
        i18n: i18n,
        product: product,
        proposal: proposal,
        shouldPreselectFilters: shouldPreselectFilters
      }));
      dispatch(_updateFilterAccommodations(getState));
    })["catch"](function (error) {
      dispatch(Object(createAction["b" /* default */])(Object(build["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), error));
    });
  };
}

function toggleAdditionalAccommodationFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function unselectAdditionalAccommodationsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function togglePMRChecbox(isChecked, filterValues) {
  return function (dispatch, getState) {
    dispatch(Object(createAction["b" /* default */])(TOGGLE_PMR_CHECKBOX, {
      isChecked: isChecked,
      filterValues: filterValues
    }));
    dispatch(_updateAdditionalAccommodationsFilters(isChecked, getState));
  };
}

function toggleAdditionalAccommodationReducedMobilityFilter(accommodationsSets, visibility) {
  return function (dispatch) {
    Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
      additionalAccommodations: accommodationsSets
    });
    dispatch(Object(createAction["b" /* default */])(TOGGLE_EXTRA_FEATURES, {
      accommodationsSets: accommodationsSets,
      reducedMobilityVisibility: visibility
    }));
  };
}

var additionalAccommodations_action_runMoreAccommodationsQuery = function _runMoreAccommodationsQuery(_ref8) {
  var appContext = _ref8.appContext,
      _ref8$attendees = _ref8.attendees,
      attendees = _ref8$attendees === void 0 ? [] : _ref8$attendees,
      bookingId = _ref8.bookingId,
      duration = _ref8.duration,
      _ref8$selectedRate = _ref8.selectedRate,
      selectedRate = _ref8$selectedRate === void 0 ? '' : _ref8$selectedRate;
  var query = bookingAccommodationsMore_queries_getBookingAccommodationsSearch(appContext, bookingId, {
    attendees: attendees,
    duration: duration,
    selectedRate: selectedRate
  });
  return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
    requestName: requestDictionary["P" /* CUSTOMER_BOOKING_GET_MORE_ACCOMMODATIONS_DATA */],
    cacheFront: {
      key: "".concat(requestDictionary["P" /* CUSTOMER_BOOKING_GET_MORE_ACCOMMODATIONS_DATA */], "_").concat(bookingId)
    }
  });
};

var isNotSelected = function isNotSelected(set, selectedAccommodation) {
  return set.accommodations[0].id !== selectedAccommodation.id && set.totalDifferentialPrice.value !== selectedAccommodation.differentialPrice.amount;
};

var additionalAccommodations_action_fetchBookingMoreAccommodations = function fetchBookingMoreAccommodations(args) {
  var appContext = args.appContext,
      attendees = args.attendees,
      bookingId = args.bookingId,
      duration = args.duration,
      _args$ignoreReducedMo = args.ignoreReducedMobility,
      ignoreReducedMobility = _args$ignoreReducedMo === void 0 ? false : _args$ignoreReducedMo,
      product = args.product,
      _args$selectedAccommo = args.selectedAccommodation,
      selectedAccommodation = _args$selectedAccommo === void 0 ? {} : _args$selectedAccommo,
      _args$selectedRate = args.selectedRate,
      selectedRate = _args$selectedRate === void 0 ? '' : _args$selectedRate,
      _args$shouldPreselect = args.shouldPreselectFilters,
      shouldPreselectFilters = _args$shouldPreselect === void 0 ? false : _args$shouldPreselect;
  return /*#__PURE__*/function () {
    var _ref9 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(dispatch, getState) {
      var _yield$_runMoreAccomm, bookingAdditionalAccommodations;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(Object(createAction["b" /* default */])(FETCH_ADDITIONAL_ACCOMMODATIONS));
              _context.prev = 1;
              _context.next = 4;
              return additionalAccommodations_action_runMoreAccommodationsQuery({
                appContext: appContext,
                attendees: attendees,
                bookingId: bookingId,
                duration: duration,
                selectedRate: selectedRate
              });

            case 4:
              _yield$_runMoreAccomm = _context.sent;
              bookingAdditionalAccommodations = _yield$_runMoreAccomm.bookingAdditionalAccommodations;
              dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
                additionalAccommodations: bookingAdditionalAccommodations.filter(function (set) {
                  return set.remainingStock > 0 && set.totalDifferentialPrice.value > 0 && // only more expensive accommodation
                  Boolean(set.accommodations.length) && isNotSelected(set, selectedAccommodation) && (ignoreReducedMobility ? !set.accommodations.some(function (_ref10) {
                    var reducedMobilityAccess = _ref10.reducedMobilityAccess;
                    return Boolean(reducedMobilityAccess);
                  }) : true);
                })
              }));
              dispatch(_createAdditionalAccommodationsFilters({
                getState: getState,
                i18n: {},
                product: product,
                proposal: {},
                shouldPreselectFilters: shouldPreselectFilters
              }));
              dispatch(_updateFilterAccommodations(getState));
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              dispatch(Object(createAction["b" /* default */])(Object(build["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), _context.t0));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function (_x, _x2) {
      return _ref9.apply(this, arguments);
    };
  }();
};


/***/ }),

/***/ "0770":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(8).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "0I1U":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("KLyV").Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),

/***/ "0a30":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("r2q8").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("xc2Q");
/*</replacement>*/

var Buffer = __webpack_require__("+ZX+").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(6);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__("rgjJ");
var destroyImpl = __webpack_require__("kzMc");
var _require = __webpack_require__("OX+y"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__("1037").codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__("qW1w")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("ulH6");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("2wQW").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__("ulH6");
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("2wQW").StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__("8UHF");
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__("bOHI");
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq"), __webpack_require__("F63i")))

/***/ }),

/***/ "0sSj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__("+sR0");
var curves = __webpack_require__("3870");
var utils = __webpack_require__("EmIl");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__("mC9x");
var Signature = __webpack_require__("ChVH");

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1/tN":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("KLyV").Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "1037":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;


/***/ }),

/***/ "1DEc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__("+sR0");
var utils = __webpack_require__("gdlE");
var assert = __webpack_require__("Y4pH");

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),

/***/ "1DFk":
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__("nXZ9");
var brorand = __webpack_require__("ufvR");

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),

/***/ "1Ll7":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('get', __webpack_require__("2srY"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "1TSG":
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__("sPPR")
var Buffer = __webpack_require__("KLyV").Buffer
var incr32 = __webpack_require__("sXLC")

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),

/***/ "1TxV":
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "1XP9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCivilitiesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getI18nQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLegalInformations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getProfileQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTravelCompanionsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAddressFieldsQuery; });
/* harmony import */ var _store_validation_schema_validationSchemaField_fragment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2GfD");
/* harmony import */ var _utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kH/m");


var getCivilitiesQuery = function getCivilitiesQuery() {
  return "\nquery {\n  civilities {\n    adult {\n      label\n      value: code\n    }\n    child {\n      label\n      value: code\n    }\n  }\n}";
};
var getI18nQuery = function getI18nQuery() {
  return "\nquery {\n  config {\n    booking {\n      common {\n        layer {\n          unknownErrorDescription\n        }\n      }\n      form {\n        dateFormat\n        dayPlaceholder\n        monthPlaceholder\n        yearPlaceholder\n      }\n      participants {\n        labels {\n          birthdate\n          email\n          firstName\n          lastName\n          passportInfo\n          phone\n          unicodeFirstName\n          unicodeLastName\n        }\n      }\n    }\n    common {\n      cancel\n      dateFormatPlaceholder\n      dateFormatTechnicalID\n      form {\n        errors {\n          fieldTooLong\n          fieldTooShort\n          invalidDateField\n          invalidEmailField\n          issuingCountryLength\n          maximumAgeRequired\n          minimumAgeRequired\n          noSpecialCharsField\n          passportMaxMinLength\n          phoneNumberError\n          requiredField\n        }\n      }\n      participants {\n        address {\n          additionalInformation1\n          additionalInformation2\n          addOn\n          city\n          countryCode\n          stateOrDistrict\n          streetNumber\n          streetName\n          town\n          zipCode\n        }\n      }\n      save\n    }\n  }\n}\n";
};
var getLegalInformations = function getLegalInformations() {
  return "query {\n  legalInformations {\n    foryouClubOptins {\n      description\n      id\n      ref\n      title\n    }\n    consentOptins {\n      description\n      id\n      ref\n      title\n    }\n    bookingProcess {\n      id\n      label\n      description\n      url\n      required\n      preChecked\n    }\n    newsletter {\n      id\n      label\n      description\n    }\n  }\n}";
};
var getProfileQuery = function getProfileQuery() {
  return "query {\n  profile {\n    address {\n      ...Address\n    }\n    civility\n    customerId\n    dateOfBirth\n    email\n    firstName\n    secondName\n    thirdName\n    fourthName\n    gmNumber\n    homePhoneNumber\n    identityNumber\n    lastName\n    mobilePhoneNumber\n    optins {\n      channel\n      optin\n    }\n    passport {\n      authority\n      birthCountry\n      birthCity\n      secondName\n      thirdName\n      fourthName\n      birthdate\n      birthplace\n      countryCode\n      documentNumber\n      expirationDate\n      firstName\n      issuingCountry\n      issuingDate\n      nationality\n      residenceCity\n      serialNumber\n      unicodeFirstName\n      unicodeLastName\n    }\n    personalDataUsageAllowed\n    unicodeCivility\n    unicodeFirstName\n    unicodeSecondName\n    unicodeThirdName\n    unicodeFourthName\n    unicodeLastName\n  }\n  }\n  ".concat(_utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__[/* addressFragment */ "a"], "\n  ");
};
var getTravelCompanionsQuery = function getTravelCompanionsQuery() {
  return "query {\n  travelCompanions {\n    customerId\n    civility\n    unicodeCivility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n    dateOfBirth\n    email\n    mobilePhoneNumber\n    passport {\n      secondName\n      thirdName\n      fourthName\n      unicodeSecondName\n      unicodeThirdName\n      unicodeFourthName\n      documentNumber\n      issuingCountry\n      authority\n      issuingDate\n      expirationDate\n    }\n  }\n}";
};
var getAddressFieldsQuery = function getAddressFieldsQuery() {
  return "query {\n  validationSchema(resource : \"profile\", fields: [\"address\"]) {\n    ...ValidationSchemaField\n  }\n}\n".concat(_store_validation_schema_validationSchemaField_fragment__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"], "\n");
};

/***/ }),

/***/ "1sYr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__("qW1w");
const Buffer = __webpack_require__("aikL").Buffer;
const Node = __webpack_require__("4v7C");

// Import DER constants
const der = __webpack_require__("vqf+");

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
  primitive,
  cls,
  content) {
  const encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    const header = Buffer.alloc(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  let lenOctets = 1;
  for (let i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  const header = Buffer.alloc(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    const buf = Buffer.alloc(str.length * 2);
    for (let i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s.]+/g);
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  let size = 0;
  for (let i = 0; i < id.length; i++) {
    let ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  const objid = Buffer.alloc(size);
  let offset = objid.length - 1;
  for (let i = id.length - 1; i >= 0; i--) {
    let ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  let str;
  const date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getUTCFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getUTCFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    const numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = Buffer.from(numArray);
  }

  if (Buffer.isBuffer(num)) {
    let size = num.length;
    if (num.length === 0)
      size++;

    const out = Buffer.alloc(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0;
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  let size = 1;
  for (let i = num; i >= 0x100; i >>= 8)
    size++;

  const out = new Array(size);
  for (let i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(Buffer.from(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  const state = this._baseState;
  let i;
  if (state['default'] === null)
    return false;

  const data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  let res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),

/***/ "1tzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isChineseLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLocaleToDisplayDidomi; });
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("kiXb");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("qFX+");



var isChineseLocale = function isChineseLocale(locale) {
  return locale === _constants__WEBPACK_IMPORTED_MODULE_1__[/* LOCALES */ "a"].EN_CN || locale === _constants__WEBPACK_IMPORTED_MODULE_1__[/* LOCALES */ "a"].ZH_CN;
};

var isLocaleToDisplayDidomi = function isLocaleToDisplayDidomi() {
  return Object(_i18n__WEBPACK_IMPORTED_MODULE_0__[/* getKeyValue */ "d"])('common.activateDidomi');
};



/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2+UM":
/***/ (function(module) {

module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

/***/ }),

/***/ "2Lg3":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ "2dnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FailedPaymentModal; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("EvYw");
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _components_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var FailedPaymentModal = function FailedPaymentModal(_ref) {
  var onClose = _ref.onClose;
  return __jsx(_components_frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_4__[/* Modal */ "a"], {
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('common.close'),
    onClose: onClose,
    size: "small"
  }, __jsx("div", {
    className: "flex flex-col items-center justify-center p-25"
  }, __jsx("div", {
    className: "flex flex-col items-center text-orange"
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].CREDIT_CARD,
    width: "5.25rem",
    className: "w-full pb-95"
  }), __jsx("span", {
    className: "text-24"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.banking.error.paymentFailed.popinInfo1'))), __jsx("span", {
    className: "pb-20 text-14"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.banking.error.paymentFailed.popinInfo2')), __jsx("span", {
    className: "text-14"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.banking.error.paymentFailed.popinInfo3')), __jsx("span", {
    className: "flex items-center text-18 text-saffron"
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].PHONE
  }), " ", Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.counterProposalPopIn.callCenterNumber')), __jsx("span", {
    className: "pb-30 text-12"
  }, "(", Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('navigationBar.contact.toll'), ")"), __jsx(_components_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], {
    colorBg: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].TURQUOISE,
    onClick: onClose
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.priceCalendar.closePopin'))));
};

/***/ }),

/***/ "2p0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPrePaymentDetailsQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _stay_StayView_queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("AjKr");



var getDevice = function getDevice(responsive) {
  if (responsive.isDesktop) {
    return 'DESKTOP';
  }

  if (responsive.isTablet) {
    return 'TABLET';
  }

  return 'MOBILE';
};
var getPrePaymentDetailsQuery = function getPrePaymentDetailsQuery(appContext, bookingId) {
  return "query {\n    customerBooking(id:\"".concat(bookingId, "\") {\n      attendees {\n        birthday\n        customerId\n        email\n        firstName\n        id\n        lastName\n      }\n      categories {\n        isOption\n      }\n      id\n      payment {\n        due {\n          deadlineDate\n          formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__["getBookingPrecision"])(appContext.locale), ")\n          value\n        }\n        total {\n          formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__["getBookingPrecision"])(appContext.locale), ")\n          value\n        }\n      }\n      status {\n        name\n      }\n      stays {\n        accommodationsCount\n        booking {\n          attendees {\n            birthday\n            customerId\n            email\n            firstName\n            id\n            lastName\n          }\n          categories {\n            isOption\n            isTravelPlan\n          }\n          id\n          payment {\n            isEnabled\n            due {\n              deadlineDate\n              formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__["getBookingPrecision"])(appContext.locale), ")\n              value\n            }\n            total {\n              formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__["getBookingPrecision"])(appContext.locale), ")\n              value\n            }\n          }\n          status {\n            name\n          }\n          vendor {\n            isSoldByPartners\n          }    \n        }\n        dates {\n          duration\n          endDate\n          startDate\n        }          \n        id\n        participants {\n          adultsCount\n          attendees {\n            birthday\n            firstname\n            id\n            isAdult\n            isKid\n            lastname\n            unicodeFirstname\n            unicodeLastname\n          }\n          childrenCount\n          totalCount\n        }\n        product {\n          badgeIcon\n          comfort\n          destination {\n            country\n          }\n          hasECSpace\n          href\n          image\n          isCruise\n          isExplicitEC\n          isJoyview\n          name\n        }\n        transport {\n          fromCity\n          fromCityCode\n          inbounds {\n            ...transportsDetails\n          }    \n          outbounds {\n            ...transportsDetails\n          }\n          toCity\n          toCityCode\n          type\n          types\n        }\n        transfers {\n          id\n        }\n        upsells(types: [TRANSFER], withAllSolded: true) {\n          transfers {\n            pricingInfo {\n              id\n              isFullyPaid\n              isFullyRented\n              isIncluded\n              isPartiallyPaid\n              isPartiallyRented\n            }\n          }\n        }\n      }\n      vendor {\n        isSoldByPartners\n      }\n    }\n    legalInformations {\n      optionConfirmation {\n        description\n        id\n        label\n        preChecked\n        required\n        url\n      }\n    }\n    paymentProviders(isCa: true, bookingId: \"").concat(bookingId, "\"){\n      description\n      id\n      label\n      logo\n      categoryPaymentMethod\n      withBillingAddress\n      shouldSkipPayment\n      paymentMethods {\n        category\n        id\n        image\n        label\n        timePaymentConditions {\n          chargePercentage\n          id\n          paymentCount\n        }\n      }\n      requiredDelayBeforeDeparture\n      selectorId\n      token {\n        format\n        value\n      }\n    }\n  }").concat(Object(_stay_StayView_queries__WEBPACK_IMPORTED_MODULE_2__[/* getStayTransportFragment */ "c"])());
};

/***/ }),

/***/ "2wQW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__("KLyV").Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "2z5K":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseIteratee = __webpack_require__("S3pA"),
    baseRest = __webpack_require__("R3TX"),
    baseUniq = __webpack_require__("s+R0"),
    isArrayLikeObject = __webpack_require__("Ndl3"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "34at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToHash; });
/* harmony import */ var _widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1cDg");
/* eslint-env browser */

function goToHash(hash) {
  var scrollUnderNav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */

  function scrollUnderNavBar() {
    var navBar = document.querySelector(_widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_OFFSET_SELECTOR */ "a"]);

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    setTimeout(function () {
      var element = document.querySelector(hash);

      if (element) {
        element.scrollIntoView({
          behavior: behavior
        });

        if (scrollUnderNav) {
          scrollUnderNavBar();
        }
      }
    }, 100);
  }
}

/***/ }),

/***/ "3870":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__("+sR0");
var curve = __webpack_require__("v05O");
var utils = __webpack_require__("EmIl");

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = __webpack_require__("59Hu");
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});


/***/ }),

/***/ "3B0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zytj");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("igjW");









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}






var HocErrorBoundary = function HocErrorBoundary(ChildComponent) {
  var ErrorBoundary = /*#__PURE__*/function (_Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(ErrorBoundary, _Component);

    var _super = _createSuper(ErrorBoundary);

    function ErrorBoundary(props) {
      var _this;

      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, ErrorBoundary);

      _this = _super.call(this, props);
      _this.state = {
        hasError: false
      };
      return _this;
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(ErrorBoundary, [{
      key: "componentDidCatch",
      // eslint-disable-next-line class-methods-use-this
      value: function componentDidCatch(err, info) {
        _logger_logger__WEBPACK_IMPORTED_MODULE_11__["default"].error({
          err: err,
          info: info
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            router = _this$props.router,
            props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this$props, ["router"]);

        if (this.state.hasError) {
          if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_12__[/* isStrictlyProductionEnv */ "f"])()) {
            var locale = router.query.locale;
            router.replace({
              pathname: '/500',
              query: Boolean(locale) && {
                locale: locale
              }
            });
            this.setState({
              hasError: false
            });
          }

          return null;
        }

        return __jsx(ChildComponent, props);
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError() {
        return {
          hasError: true
        };
      }
    }]);

    return ErrorBoundary;
  }(react__WEBPACK_IMPORTED_MODULE_9__["Component"]);

  return Object(next_router__WEBPACK_IMPORTED_MODULE_10__["withRouter"])(ErrorBoundary);
};

/* harmony default export */ __webpack_exports__["a"] = (HocErrorBoundary);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "46hJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*jshint node:true */

var Buffer = __webpack_require__("+ZX+").Buffer; // browserify
var SlowBuffer = __webpack_require__("+ZX+").SlowBuffer;

module.exports = bufferEq;

function bufferEq(a, b) {

  // shortcutting on type is necessary for correctness
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    return false;
  }

  // buffer sizes should be well-known information, so despite this
  // shortcutting, it doesn't leak any information about the *contents* of the
  // buffers.
  if (a.length !== b.length) {
    return false;
  }

  var c = 0;
  for (var i = 0; i < a.length; i++) {
    /*jshint bitwise:false */
    c |= a[i] ^ b[i]; // XOR
  }
  return c === 0;
}

bufferEq.install = function() {
  Buffer.prototype.equal = SlowBuffer.prototype.equal = function equal(that) {
    return bufferEq(this, that);
  };
};

var origBufEqual = Buffer.prototype.equal;
var origSlowBufEqual = SlowBuffer.prototype.equal;
bufferEq.restore = function() {
  Buffer.prototype.equal = origBufEqual;
  SlowBuffer.prototype.equal = origSlowBufEqual;
};


/***/ }),

/***/ "4A3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AsyncLoader_AsyncLoader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center h-full items-center'
  },
  labeled: {
    thRoot: 'flex flex-col justify-center items-center my-0 mx-auto text-center w-320',
    thLabel: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx


var __jsx = react_default.a.createElement;







var AsyncLoader_AsyncLoader = function AsyncLoader(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].TRIDENT1 : _ref$icon,
      iconSize = _ref.iconSize,
      size = _ref.size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "icon", "iconSize", "size", "theme"]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  return __jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), __jsx(Spinner["a" /* Spinner */], {
    iconName: icon,
    iconSize: iconSize,
    size: size
  }), __jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    className: thLabel,
    label: label
  }));
};

/***/ }),

/***/ "4Gsp":
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__("FT8f")
exports.privateDecrypt = __webpack_require__("K4jy")

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),

/***/ "4KA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TeaserCard_TeaserCard; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.themes.js
var themes = {
  "default": {
    thRoot: 'flex flex-col',
    thImage: 'bg-grey isolate order-first overflow-hidden rounded-12 transition-all duration-250 ease-in',
    thImageActive: 'opacity-75 scale-095'
  },
  "short": {
    thRoot: 'flex flex-col h-full isolate overflow-hidden relative rounded-12 shadow-sm transition-all duration-250 ease-in',
    thChildren: 'p-15 md:p-20 h-full',
    thRootActive: 'shadow-md',
    thImage: 'bg-grey order-first overflow-hidden rounded-t-12 shrink-0 duration-250 ease-in transition-all'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.jsx

var __jsx = react_default.a.createElement;






var TeaserCard_TeaserCard = function TeaserCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? ratios_utils["c" /* default */].R_38_BY_28 : _ref$ratio,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var defaultPicture = media[0] || {};
  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thRootActive = _themes$theme.thRootActive,
      thChildren = _themes$theme.thChildren,
      thImage = _themes$theme.thImage,
      thImageActive = _themes$theme.thImageActive;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, Object(defineProperty["a" /* default */])({
      'h-full': media.length <= 1
    }, thRootActive, isActive), className)
  }, __jsx("div", {
    className: thChildren
  }, children), __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thImage, Object(defineProperty["a" /* default */])({}, thImageActive, isActive))
  }, media.length > 1 ? __jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasLazyLoading: true,
    media: media,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratio
  }) : __jsx(Image["b" /* default */], {
    altMsg: defaultPicture.alt,
    groupKey: "thumbnails",
    hasLazyLoading: true,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    ratioKey: ratio,
    ratioDisplay: 1 / 4
  })));
};

/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var SpinnerLabel = function SpinnerLabel(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-20 text-black text-20', {
      'sr-only': !label
    }, className),
    "aria-live": "polite"
  }, label ? label : 'Loading');
};

/***/ }),

/***/ "4Vo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildPostPaymentUrl; });
/* unused harmony export getPaymentTrackingDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFormData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extractPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapTransportResume; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("fGyu");
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("O2W8");
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lz_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_ple_utils_mapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("aMgh");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_query_helper_booking_payment_redirect_paymentRedirectQuery__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("oJjJ");













var buildPostPaymentUrl = function buildPostPaymentUrl(params) {
  var _ref = params || {},
      location = _ref.location,
      bookingStatus = _ref.bookingStatus,
      locale = _ref.locale,
      isCart = _ref.isCart,
      customerNeolaneId = _ref.customerNeolaneId;

  var cartPath = isCart ? '/c' : ''; // Add only 1 letter to limit the url length for the PSPs

  if (!bookingStatus) {
    return null;
  }

  return new urijs__WEBPACK_IMPORTED_MODULE_7___default.a(location).query('').hash('').path(customerNeolaneId ? "pr/{paymentId}/".concat(locale, "/customer/").concat(customerNeolaneId, "/").concat(Object(_utils_ple_utils_mapper__WEBPACK_IMPORTED_MODULE_10__[/* getCodeFromStatus */ "a"])(bookingStatus)).concat(cartPath) : "pr/{paymentId}/".concat(locale, "/").concat(Object(_utils_ple_utils_mapper__WEBPACK_IMPORTED_MODULE_10__[/* getCodeFromStatus */ "a"])(bookingStatus)).concat(cartPath)).toString();
};
var getPaymentTrackingDatas = function getPaymentTrackingDatas(orderId) {
  var value = js_cookie__WEBPACK_IMPORTED_MODULE_6___default.a.get("PRE_PAYMENT_INFOS-".concat(orderId));
  return value ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__["oidc"].fromUriEncodedState(value) : null;
};
var getFormData = function getFormData(params, appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runNoCacheQuery(Object(_utils_graphql_query_helper_booking_payment_redirect_paymentRedirectQuery__WEBPACK_IMPORTED_MODULE_12__[/* paymentRedirectMutation */ "a"])(params), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_11__[/* PAYMENT_PRE_GET_FORM_DATA */ "Dc"]
  });
};
var extractPayload = function extractPayload(payload) {
  if (!payload) {
    return null;
  }

  var value = null;

  try {
    value = lz_string__WEBPACK_IMPORTED_MODULE_5___default.a.decompressFromEncodedURIComponent(payload);
    return JSON.parse(value);
  } catch (e) {
    console.error('extractPayload', e, ' for value:', value); // eslint-disable-line no-console

    return null;
  }
};
var mapTransportResume = function mapTransportResume(transports) {
  return transports ? // $FlowFixMe
  [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(transports.inbounds), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(transports.outbounds)).map(function (_ref2) {
    var travelSections = _ref2.travelSections;
    return travelSections.map(function (_ref3) {
      var _transport$companyOpe, _transport$companyOpe2;

      var transport = _ref3.transport,
          departure = _ref3.departure,
          arrival = _ref3.arrival;
      return {
        company: {
          name: (_transport$companyOpe = transport.companyOperator) === null || _transport$companyOpe === void 0 ? void 0 : _transport$companyOpe.label,
          id: (_transport$companyOpe2 = transport.companyOperator) === null || _transport$companyOpe2 === void 0 ? void 0 : _transport$companyOpe2.id
        },
        origin: departure.cityId,
        destination: arrival.cityId,
        departure: {
          apc: departure.id,
          date: departure.date
        },
        arrival: {
          apc: arrival.id,
          date: arrival.date
        }
      };
    });
  }) : [];
};

/***/ }),

/***/ "4Z+A":
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__("KLyV").Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),

/***/ "4f5z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("w30G");


/***/ }),

/***/ "4rhd":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("KLyV").Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),

/***/ "4ryf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookingNavbarContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingNavbarProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useBookingNavbarContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;

var BookingNavbarContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  setContinueAction: null,
  setHideContinueButton: null,
  setIsPriceLoading: null,
  navbarRef: null,
  setNoEdit: null,
  setOverwriteContinueButton: null,
  setPortalPosition: null,
  setIsDisabled: null,
  setValidationCallback: null,
  validationCallback: function validationCallback() {
    return null;
  },
  setProcessValidation: null,
  setPaymentLabel: null,
  setContinueBtn: null
});
var BookingNavbarProvider = function BookingNavbarProvider(_ref) {
  var setContinueAction = _ref.setContinueAction,
      hideContinueButton = _ref.hideContinueButton,
      setHideContinueButton = _ref.setHideContinueButton,
      setIsPriceLoading = _ref.setIsPriceLoading,
      setShouldDisplay = _ref.setShouldDisplay,
      navbarRef = _ref.navbarRef,
      currentPage = _ref.currentPage,
      validationCallback = _ref.validationCallback,
      setNoEdit = _ref.setNoEdit,
      setOverwriteContinueButton = _ref.setOverwriteContinueButton,
      setContinueBtn = _ref.setContinueBtn,
      setPriceShouldIncludeDonation = _ref.setPriceShouldIncludeDonation,
      setPortalPosition = _ref.setPortalPosition,
      setIsDisabled = _ref.setIsDisabled,
      setValidationCallback = _ref.setValidationCallback,
      setProcessValidation = _ref.setProcessValidation,
      setPaymentLabel = _ref.setPaymentLabel,
      children = _ref.children;
  return __jsx(BookingNavbarContext.Provider, {
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value: {
      setContinueAction: setContinueAction,
      hideContinueButton: hideContinueButton,
      setHideContinueButton: setHideContinueButton,
      setIsPriceLoading: setIsPriceLoading,
      setShouldDisplay: setShouldDisplay,
      setPriceShouldIncludeDonation: setPriceShouldIncludeDonation,
      navbarRef: navbarRef,
      currentPage: currentPage,
      validationCallback: validationCallback,
      setNoEdit: setNoEdit,
      setContinueBtn: setContinueBtn,
      setOverwriteContinueButton: setOverwriteContinueButton,
      setPortalPosition: setPortalPosition,
      setIsDisabled: setIsDisabled,
      setValidationCallback: setValidationCallback,
      setProcessValidation: setProcessValidation,
      setPaymentLabel: setPaymentLabel
    }
  }, children);
};
var useBookingNavbarContext = function useBookingNavbarContext() {
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(BookingNavbarContext);
};

/***/ }),

/***/ "4tGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useExtendedConnect; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var query = "\n  query {\n    facebookConnect {\n      isAvailable\n    }\n    wechatConnect {\n      isAvailable\n    }\n  }\n";
var useExtendedConnect = function useExtendedConnect() {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      isFacebookConnectAvailable = _useState[0],
      setIsFacebookConnectAvailable = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      isWechatConnectAvailable = _useState2[0],
      setIsWechatConnectAvailable = _useState2[1];

  var _useGQL = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_1__[/* useGQL */ "a"])({
    query: query,
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_FACEBOOK_CONNECT_CONFIG */ "d"]
    },
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var _data$facebookConnect, _data$wechatConnect;

    setIsFacebookConnectAvailable(!!(data === null || data === void 0 ? void 0 : (_data$facebookConnect = data.facebookConnect) === null || _data$facebookConnect === void 0 ? void 0 : _data$facebookConnect.isAvailable));
    setIsWechatConnectAvailable(!!(data === null || data === void 0 ? void 0 : (_data$wechatConnect = data.wechatConnect) === null || _data$wechatConnect === void 0 ? void 0 : _data$wechatConnect.isAvailable));
  }, [isLoading]);
  return {
    isFacebookConnectAvailable: isFacebookConnectAvailable,
    isWechatConnectAvailable: isWechatConnectAvailable
  };
};

/***/ }),

/***/ "4v7C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const Reporter = __webpack_require__("aw2z").Reporter;
const EncoderBuffer = __webpack_require__("cVzJ").EncoderBuffer;
const DecoderBuffer = __webpack_require__("cVzJ").DecoderBuffer;
const assert = __webpack_require__("Y4pH");

// Supported tags
const tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
const methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
const overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent, name) {
  const state = {};
  this._baseState = state;

  state.name = name;
  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

const stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  const state = this._baseState;
  const cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  const res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  const state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      const clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  const state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  const state = this._baseState;

  // Filter children and args
  const children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      const res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        const value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    const state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  const state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  const state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  const state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  const state = this._baseState;
  const args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  const state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  const state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  const state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  const state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  let result = state['default'];
  let present = true;

  let prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    let tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      const save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  let prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      const explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    const start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      let save;
      if (state.any)
        save = input.save();
      const body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any) {
      // no-op
    } else if (state.choice === null) {
      result = this._decodeGeneric(state.tag, input, options);
    } else {
      result = this._decodeChoice(input, options);
    }

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      const data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
        ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  const state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
      ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  const state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  const state = this._baseState;
  let result = null;
  let match = false;

  Object.keys(state.choice).some(function(key) {
    const save = input.save();
    const node = state.choice[key];
    try {
      const value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  const state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  const result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  let result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default'];
    else
      return;
  }

  // Encode children first
  let content = null;
  let primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      const prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      const res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      const child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        const state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  if (!state.any && state.choice === null) {
    const tag = state.implicit !== null ? state.implicit : state.tag;
    const cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  const state = this._baseState;

  const node = state.choice[data.type];
  if (!node) {
    assert(
      false,
      data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  const state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "57NP":
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__("L3kw")
var aes = __webpack_require__("jRCX")
var aesModes = __webpack_require__("gEL7")
var desModes = __webpack_require__("ddHj")
var ebtk = __webpack_require__("JvEg")

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "59Hu":
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
      ],
    ],
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
      ],
    ],
  },
};


/***/ }),

/***/ "5MfQ":
/***/ (function(module, exports, __webpack_require__) {

var bufferEqual = __webpack_require__("46hJ");
var Buffer = __webpack_require__("KLyV").Buffer;
var crypto = __webpack_require__("D+ts");
var formatEcdsa = __webpack_require__("WxfE");
var util = __webpack_require__("XLvf");

var MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".'
var MSG_INVALID_SECRET = 'secret must be a string or buffer';
var MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
var MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';

var supportsKeyObjects = typeof crypto.createPublicKey === 'function';
if (supportsKeyObjects) {
  MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
  MSG_INVALID_SECRET += 'or a KeyObject';
}

function checkIsPublicKey(key) {
  if (Buffer.isBuffer(key)) {
    return;
  }

  if (typeof key === 'string') {
    return;
  }

  if (!supportsKeyObjects) {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key !== 'object') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key.type !== 'string') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key.asymmetricKeyType !== 'string') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key.export !== 'function') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }
};

function checkIsPrivateKey(key) {
  if (Buffer.isBuffer(key)) {
    return;
  }

  if (typeof key === 'string') {
    return;
  }

  if (typeof key === 'object') {
    return;
  }

  throw typeError(MSG_INVALID_SIGNER_KEY);
};

function checkIsSecretKey(key) {
  if (Buffer.isBuffer(key)) {
    return;
  }

  if (typeof key === 'string') {
    return key;
  }

  if (!supportsKeyObjects) {
    throw typeError(MSG_INVALID_SECRET);
  }

  if (typeof key !== 'object') {
    throw typeError(MSG_INVALID_SECRET);
  }

  if (key.type !== 'secret') {
    throw typeError(MSG_INVALID_SECRET);
  }

  if (typeof key.export !== 'function') {
    throw typeError(MSG_INVALID_SECRET);
  }
}

function fromBase64(base64) {
  return base64
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}

function toBase64(base64url) {
  base64url = base64url.toString();

  var padding = 4 - base64url.length % 4;
  if (padding !== 4) {
    for (var i = 0; i < padding; ++i) {
      base64url += '=';
    }
  }

  return base64url
    .replace(/\-/g, '+')
    .replace(/_/g, '/');
}

function typeError(template) {
  var args = [].slice.call(arguments, 1);
  var errMsg = util.format.bind(util, template).apply(null, args);
  return new TypeError(errMsg);
}

function bufferOrString(obj) {
  return Buffer.isBuffer(obj) || typeof obj === 'string';
}

function normalizeInput(thing) {
  if (!bufferOrString(thing))
    thing = JSON.stringify(thing);
  return thing;
}

function createHmacSigner(bits) {
  return function sign(thing, secret) {
    checkIsSecretKey(secret);
    thing = normalizeInput(thing);
    var hmac = crypto.createHmac('sha' + bits, secret);
    var sig = (hmac.update(thing), hmac.digest('base64'))
    return fromBase64(sig);
  }
}

function createHmacVerifier(bits) {
  return function verify(thing, signature, secret) {
    var computedSig = createHmacSigner(bits)(thing, secret);
    return bufferEqual(Buffer.from(signature), Buffer.from(computedSig));
  }
}

function createKeySigner(bits) {
 return function sign(thing, privateKey) {
    checkIsPrivateKey(privateKey);
    thing = normalizeInput(thing);
    // Even though we are specifying "RSA" here, this works with ECDSA
    // keys as well.
    var signer = crypto.createSign('RSA-SHA' + bits);
    var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
    return fromBase64(sig);
  }
}

function createKeyVerifier(bits) {
  return function verify(thing, signature, publicKey) {
    checkIsPublicKey(publicKey);
    thing = normalizeInput(thing);
    signature = toBase64(signature);
    var verifier = crypto.createVerify('RSA-SHA' + bits);
    verifier.update(thing);
    return verifier.verify(publicKey, signature, 'base64');
  }
}

function createPSSKeySigner(bits) {
  return function sign(thing, privateKey) {
    checkIsPrivateKey(privateKey);
    thing = normalizeInput(thing);
    var signer = crypto.createSign('RSA-SHA' + bits);
    var sig = (signer.update(thing), signer.sign({
      key: privateKey,
      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
    }, 'base64'));
    return fromBase64(sig);
  }
}

function createPSSKeyVerifier(bits) {
  return function verify(thing, signature, publicKey) {
    checkIsPublicKey(publicKey);
    thing = normalizeInput(thing);
    signature = toBase64(signature);
    var verifier = crypto.createVerify('RSA-SHA' + bits);
    verifier.update(thing);
    return verifier.verify({
      key: publicKey,
      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
    }, signature, 'base64');
  }
}

function createECDSASigner(bits) {
  var inner = createKeySigner(bits);
  return function sign() {
    var signature = inner.apply(null, arguments);
    signature = formatEcdsa.derToJose(signature, 'ES' + bits);
    return signature;
  };
}

function createECDSAVerifer(bits) {
  var inner = createKeyVerifier(bits);
  return function verify(thing, signature, publicKey) {
    signature = formatEcdsa.joseToDer(signature, 'ES' + bits).toString('base64');
    var result = inner(thing, signature, publicKey);
    return result;
  };
}

function createNoneSigner() {
  return function sign() {
    return '';
  }
}

function createNoneVerifier() {
  return function verify(thing, signature) {
    return signature === '';
  }
}

module.exports = function jwa(algorithm) {
  var signerFactories = {
    hs: createHmacSigner,
    rs: createKeySigner,
    ps: createPSSKeySigner,
    es: createECDSASigner,
    none: createNoneSigner,
  }
  var verifierFactories = {
    hs: createHmacVerifier,
    rs: createKeyVerifier,
    ps: createPSSKeyVerifier,
    es: createECDSAVerifer,
    none: createNoneVerifier,
  }
  var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
  if (!match)
    throw typeError(MSG_INVALID_ALGORITHM, algorithm);
  var algo = (match[1] || match[3]).toLowerCase();
  var bits = match[2];

  return {
    sign: signerFactories[algo](bits),
    verify: verifierFactories[algo](bits),
  }
};


/***/ }),

/***/ "5WMi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var e=__webpack_require__("VDhN");exports.default=e.default;


/***/ }),

/***/ "5cvY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),

/***/ "5svr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ productAccommodations_utils_getAllAvailableItems; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ withExclusiveCollectionTag; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ groupAccommodationsByCategory; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getTabsItemsAndPropsFromAccommodations; });

// UNUSED EXPORTS: getSurfaceIconItem, getCapacityIconItem, getViewIconItem, getOutsideFacilitiesIconItems, aggregateIconList, mapAccommodationServices

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/unionBy.js
var unionBy = __webpack_require__("2z5K");
var unionBy_default = /*#__PURE__*/__webpack_require__.n(unionBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/intersectionBy.js
var intersectionBy = __webpack_require__("wyfB");
var intersectionBy_default = /*#__PURE__*/__webpack_require__.n(intersectionBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/compact.js
var compact = __webpack_require__("3dHC");
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.container.jsx + 2 modules
var ProductInformationSlider_container = __webpack_require__("JjZN");

// EXTERNAL MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLauncher.jsx + 3 modules
var ProductRoomsComparatorLauncher = __webpack_require__("9tk8");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/markup/markup.js
var markup = __webpack_require__("Iz3O");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.jsx + 1 modules
var TeaserCard = __webpack_require__("4KA2");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/product-room-card/ProductRoomCard.jsx












var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ProductRoomCard_ProductRoomCard = function ProductRoomCard(_ref) {
  var className = _ref.className,
      isHidden = _ref.isHidden,
      isLarge = _ref.isLarge,
      _ref$labeledIconsList = _ref.labeledIconsList,
      labeledIconsList = _ref$labeledIconsList === void 0 ? [] : _ref$labeledIconsList,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      seeMoreLabel = _ref.seeMoreLabel,
      title = _ref.title;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var TagName = Object(markup["b" /* getLinkTagName */])(link);
  var linkProps = Object(markup["a" /* getLinkProps */])(link);

  var content = __jsx(react["Fragment"], null, __jsx(Title["a" /* Title */], {
    hasEllipsis: true,
    theme: "title-brand-n3"
  }, title), __jsx("ul", {
    className: "space-y-5"
  }, labeledIconsList.map(function (_ref2, index) {
    var labels = _ref2.labels;
    return !!labels && __jsx("li", {
      className: "inline-flex min-h-20 w-full items-center justify-between gap-5 overflow-hidden text-14",
      key: index
    }, labels.map(function (label, labelIndex) {
      return __jsx("span", {
        className: Object(classnames_utils["a" /* classnames */])({
          'text-mediumGrey': labelIndex === 0,
          'text-end font-bold text-black': labelIndex !== 0
        }),
        key: label
      }, label, "\xA0");
    }));
  })), !!seeMoreLabel && __jsx("p", {
    className: "mt-auto text-center text-12 text-black underline"
  }, seeMoreLabel));

  var props = _objectSpread(_objectSpread({}, linkProps), {}, {
    onClick: function onClick() {
      var _linkProps$onClick;

      (_linkProps$onClick = linkProps.onClick) === null || _linkProps$onClick === void 0 ? void 0 : _linkProps$onClick.call(linkProps);
    }
  });

  var ratio = isLarge && isTablet ? ratios_utils["c" /* default */].R_38_BY_58 : ratios_utils["c" /* default */].XL;
  return isDesktop ? __jsx(TeaserCard["a" /* TeaserCard */], {
    "aria-hidden": isHidden,
    className: Object(classnames_utils["a" /* classnames */])('tap-highlight-color-transparent transition-transform w-full duration-250 ease-in', className),
    isActive: isHovering,
    media: media,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratio: ratio,
    theme: "short"
  }, __jsx(TagName, Object(esm_extends["a" /* default */])({}, props, {
    className: "text-initial flex w-full flex-col items-stretch gap-10",
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    },
    tabIndex: isHidden ? -1 : 0
  }), content)) : __jsx(TagName, Object(esm_extends["a" /* default */])({}, props, {
    "aria-hidden": isHidden,
    className: Object(classnames_utils["a" /* classnames */])('tap-highlight-color-transparent text-initial block h-full w-full', className),
    tabIndex: isHidden ? -1 : 0
  }), __jsx(TeaserCard["a" /* TeaserCard */], {
    media: media.slice(0, 1),
    ratio: ratio,
    theme: "short"
  }, content));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// EXTERNAL MODULE: ./src/client/components/frameworks/sheet/Sheet.jsx + 1 modules
var Sheet = __webpack_require__("RHTr");

// EXTERNAL MODULE: ./src/client/components/frameworks/zoom/Zoom.jsx
var Zoom = __webpack_require__("7x6O");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/components/widgets/resort-district/resortDistrict.utils.js
var resortDistrict_utils = __webpack_require__("dAFS");

// CONCATENATED MODULE: ./src/client/components/widgets/resort-district/ResortDistrictContainer.jsx



var ResortDistrictContainer_jsx = react_default.a.createElement;






var ResortDistrict = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(971)]).then(__webpack_require__.bind(null, "V163")).then(function (mod) {
    return mod.ResortDistrict;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("V163")];
    },
    modules: ["./ResortDistrict"]
  }
});
var ResortDistrictContainer_ResortDistrictContainer = function ResortDistrictContainer(props) {
  var _data$resortAreas, _data$resortAreas2;

  var resortId = props.resortId;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: Object(resortDistrict_utils["a" /* getResortDistrictQuery */])(resortId),
    queryOptions: {
      requestName: requestDictionary["W" /* CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS */],
      cacheFront: {
        key: requestDictionary["W" /* CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS */] + resortId
      }
    },
    ignore: !resortId
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  if (isLoading) {
    return ResortDistrictContainer_jsx("div", {
      className: "flex h-full w-full items-center justify-center"
    }, ResortDistrictContainer_jsx(AsyncLoader["a" /* AsyncLoader */], null));
  }

  if (!(data === null || data === void 0 ? void 0 : (_data$resortAreas = data.resortAreas) === null || _data$resortAreas === void 0 ? void 0 : _data$resortAreas.areas) || !(data === null || data === void 0 ? void 0 : (_data$resortAreas2 = data.resortAreas) === null || _data$resortAreas2 === void 0 ? void 0 : _data$resortAreas2.geoData)) {
    return null;
  }

  return ResortDistrictContainer_jsx(ResortDistrict, Object(esm_extends["a" /* default */])({}, data, props));
};
// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToHash.js
var scrollToHash = __webpack_require__("34at");

// CONCATENATED MODULE: ./src/client/components/widgets/product-room-detail/ProductRoomDetail.jsx













var ProductRoomDetail_jsx = react_default.a.createElement;

function ProductRoomDetail_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductRoomDetail_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductRoomDetail_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductRoomDetail_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};
var ProductRoomDetail_ProductRoomDetail = function ProductRoomDetail(_ref) {
  var _ref$areas = _ref.areas,
      areas = _ref$areas === void 0 ? [] : _ref$areas,
      description = _ref.description,
      immersive = _ref.immersive,
      _ref$isExclusiveColle = _ref.isExclusiveCollection,
      isExclusiveCollection = _ref$isExclusiveColle === void 0 ? false : _ref$isExclusiveColle,
      _ref$overviewCompact = _ref.overviewCompact,
      overviewCompact = _ref$overviewCompact === void 0 ? [] : _ref$overviewCompact,
      _ref$overviewAlternat = _ref.overviewAlternate,
      overviewAlternate = _ref$overviewAlternat === void 0 ? [] : _ref$overviewAlternat,
      strengthsLabel = _ref.strengthsLabel,
      amenitiesLabel = _ref.amenitiesLabel,
      _ref$services = _ref.services,
      services = _ref$services === void 0 ? [] : _ref$services,
      _ref$slideshow = _ref.slideshow,
      slideshow = _ref$slideshow === void 0 ? {} : _ref$slideshow,
      _ref$multimedia = _ref.multimedia,
      multimedia = _ref$multimedia === void 0 ? {} : _ref$multimedia,
      _ref$floorPlans = _ref.floorPlans,
      floorPlans = _ref$floorPlans === void 0 ? [] : _ref$floorPlans,
      productId = _ref.productId,
      title = _ref.title,
      subtitle = _ref.subtitle;

  var slideshowProps = ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, slideshow), {}, {
    groupKey: 'roomDetail',
    hasInfiniteScroll: true,
    media: slideshow.media,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratioDisplay: 0.8
  });

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var numberOfPhotos = multimedia && multimedia.photos ? multimedia.photos.length : 0;
  var multimediaProps = {
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    descriptionLabels: {
      photos: '',
      streetViews: Object(src_i18n["h" /* t */])('common.view360Disclaimer')
    },
    galleryLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productGallery', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.galleries.gallery'),
    isOverlay: true,
    labels: {
      photos: Object(src_i18n["h" /* t */])('common.photoTitle')
    },
    medias: multimedia,
    nextLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productNextPicture', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productPreviousPicture', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.previous'),
    pictureAltLabel: Object(src_i18n["h" /* t */])('common.galleries.productPictureItem', {
      total: numberOfPhotos,
      productName: title
    })
  };

  var getHeader = function getHeader(floorPlansLength, index) {
    return floorPlansLength > 1 ? {
      header: {
        title: "".concat(index === 0 ? '' : '+').concat(index)
      }
    } : null;
  };

  var getFloorplansTabs = function getFloorplansTabs() {
    return floorPlans.map(function (floorPlan, index) {
      return ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, getHeader(floorPlans.length, index)), {}, {
        content: ProductRoomDetail_jsx("div", {
          className: "mx-auto w-full max-w-site-small",
          key: index
        }, ProductRoomDetail_jsx("div", {
          className: "flex flex-col"
        }, !isTablet && ProductRoomDetail_jsx(Tooltip["a" /* Tooltip */], {
          trackingData: {
            actionGA: 'layer',
            labelGA: 'floorPlans'
          },
          renderTrigger: function renderTrigger(toggle) {
            return ProductRoomDetail_jsx("button", {
              onClick: function onClick() {
                toggle();
              },
              className: "mb-15 ms-auto rounded-2 bg-white p-5 leading-0 text-black shadow-sm transition-colors duration-250 ease-in hocus:bg-black/60 hocus:text-white",
              type: "button"
            }, ProductRoomDetail_jsx(Icon["a" /* Icon */], {
              name: icons["a" /* ICONS */].EXPAND,
              width: "1.25rem"
            }));
          },
          modalProps: {
            addendum: ProductRoomDetail_jsx(Text["a" /* Text */], {
              className: "px-10 py-20 text-center text-12 leading-tight text-white",
              text: Object(src_i18n["h" /* t */])('common.roomPlan.disclaimer'),
              theme: "none"
            }),
            children: ''
          }
        }, ProductRoomDetail_jsx(Zoom["a" /* Zoom */], {
          alt: "".concat(Object(src_i18n["h" /* t */])('common.roomPlan.title'), " ").concat(title),
          hint: Object(src_i18n["h" /* t */])('common.roomPlan.swipeInstruction'),
          imageUrl: floorPlan
        })), ProductRoomDetail_jsx("div", {
          className: "relative isolate h-0 w-full pb-[60%] md:pb-[50%]"
        }, ProductRoomDetail_jsx(Image["a" /* Image */], {
          altMsg: "".concat(Object(src_i18n["h" /* t */])('common.roomPlan.title'), " ").concat(title),
          className: "absolute flex h-full w-full items-center justify-center",
          dimensions: DIMENSIONS,
          imageUrl: floorPlan,
          transformation: "resize"
        })), ProductRoomDetail_jsx(Text["a" /* Text */], {
          className: "pb-40 pt-30 leading-tight md:pb-80 md:pt-25 md:text-center",
          text: Object(src_i18n["h" /* t */])('common.roomPlan.disclaimer')
        })))
      });
    });
  };

  var color = isExclusiveCollection ? colors["a" /* COLORS */].ULTRAMARINE : colors["a" /* COLORS */].BLACK;
  var hasResortDistrict = Object(src_i18n["e" /* getListValue */])('common.resortDistrict.productIds', 15).includes(productId) && !!(areas === null || areas === void 0 ? void 0 : areas.length);

  var header = ProductRoomDetail_jsx("section", {
    className: "p-20 md:pt-80"
  }, ProductRoomDetail_jsx("p", {
    className: "mb-5 text-16 md:text-20"
  }, subtitle), ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "text-".concat(color),
    theme: "title-brand-n44"
  }, title), ProductRoomDetail_jsx("ul", {
    className: "mb-25 mt-20 flex gap-5 text-14 md:mb-50"
  }, overviewCompact.map(function (item, index) {
    return ProductRoomDetail_jsx("li", {
      className: Object(classnames_utils["a" /* classnames */])('md:basis-1/5', {
        'basis-1/2': !(hasResortDistrict && !!productId && areas.length > 0),
        'basis-1/3': hasResortDistrict && !!productId && areas.length > 0
      }),
      key: index
    }, item.map(function (line, idx) {
      return ProductRoomDetail_jsx("span", {
        className: Object(classnames_utils["a" /* classnames */])('block', {
          'font-bold': idx === 0
        }),
        key: "".concat(index, "-").concat(idx)
      }, line);
    }));
  }), hasResortDistrict && !!productId && areas.length > 0 && ProductRoomDetail_jsx("li", {
    className: "basis-1/3 md:basis-1/5"
  }, ProductRoomDetail_jsx("span", {
    className: "block font-bold"
  }, Object(src_i18n["h" /* t */])('common.resortDistrict.layerDistrictLabel')), areas.map(function (area) {
    return ProductRoomDetail_jsx("div", {
      className: "flex items-center gap-5",
      key: area.id
    }, ProductRoomDetail_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].ADDRESS
    }), ProductRoomDetail_jsx("button", {
      className: "text-initial underline",
      onClick: function onClick() {
        return Object(scrollToHash["a" /* goToHash */])('#room-location', true, 'smooth');
      },
      type: "button"
    }, area.label));
  }))), ProductRoomDetail_jsx(Text["a" /* Text */], {
    className: "mx-auto w-full max-w-site-small md:text-20",
    text: description,
    theme: "text-sans-n3"
  }));

  return ProductRoomDetail_jsx(Sheet["a" /* Sheet */], {
    fullWidthContent: true,
    header: header,
    immersive: immersive,
    isExclusiveCollection: isExclusiveCollection,
    multimedia: multimediaProps,
    slideshow: slideshowProps
  }, !!overviewAlternate.length && ProductRoomDetail_jsx("section", {
    className: "mx-auto max-w-site-medium px-20 pb-20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mb-15 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, strengthsLabel), ProductRoomDetail_jsx("div", {
    className: "mx-auto w-full max-w-site-small"
  }, ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
    color: color,
    items: overviewAlternate
  }))), floorPlans.length > 0 && ProductRoomDetail_jsx("section", {
    className: "mx-auto max-w-site-medium px-20 pb-20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mb-40 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('common.roomPlan.title')), ProductRoomDetail_jsx(Tabs["a" /* Tabs */], {
    id: "product-accommodations-line-tabs",
    isContainerWide: true,
    isContentUnmountedOnCollapse: true,
    items: getFloorplansTabs()
  })), hasResortDistrict && !!productId && ProductRoomDetail_jsx("section", {
    className: "relative pb-20"
  }, ProductRoomDetail_jsx("div", {
    className: "absolute top-0 -mt-60 h-0 w-0",
    id: "room-location"
  }), ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mx-auto mb-40 max-w-site-medium px-20 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('common.resortDistrict.layerDistrictLabel')), ProductRoomDetail_jsx("div", {
    className: "pb-15 pt-60"
  }, ProductRoomDetail_jsx(ResortDistrictContainer_ResortDistrictContainer, {
    access: Object(src_i18n["h" /* t */])('common.resortDistrict.access'),
    resortId: productId,
    roomAreas: areas,
    roomLabel: title,
    trackingData: {
      actionGA: "layer_".concat(subtitle)
    }
  }))), ProductRoomDetail_jsx("section", {
    className: "mx-auto max-w-site-medium px-20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mb-15 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, amenitiesLabel), services.map(function (_ref2) {
    var label = _ref2.label,
        items = _ref2.items;
    return ProductRoomDetail_jsx("section", {
      className: "mx-auto w-full max-w-site-small py-15 md:py-30",
      key: label
    }, ProductRoomDetail_jsx(Title["a" /* Title */], {
      className: "mb-30 border-b-1 border-ultramarine pb-10 md:text-20 text-".concat(color),
      hLevel: 4,
      theme: "title-brand-n4"
    }, label), ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
      color: color,
      items: items,
      theme: "list"
    }));
  })));
};
// EXTERNAL MODULE: ./src/utils/proposal/constants.js
var constants = __webpack_require__("tI+f");

// CONCATENATED MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js






























var productAccommodations_utils_jsx = react_default.a.createElement;

function productAccommodations_utils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function productAccommodations_utils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? productAccommodations_utils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : productAccommodations_utils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES,
    RANKINGS = dist["constants"].RANKINGS;
var DEFAULT_RANKING = RANKINGS.LOW;
function getSurfaceIconItem(i18n, surface, roomType) {
  return {
    icon: icons["a" /* ICONS */][roomType] || null,
    labels: [get_default()(i18n, camelCase_default()(roomType)), surface || roomType && ' ' || '']
  };
}
function getCapacityIconItem(i18n, capacity) {
  var peopleLabel = get_default()(i18n, 'numberOfPeopleLabel');

  if (!capacity || !peopleLabel) {
    return null;
  }

  return {
    icon: icons["a" /* ICONS */].PEOPLE,
    labels: [get_default()(i18n, 'capacityOfPeopleLabel'), Object(dist["messageFormat"])(peopleLabel).format({
      count: capacity
    })]
  };
}
function getViewIconItem(view) {
  return view ? {
    icon: icons["a" /* ICONS */][get_default()(view, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [view.label]
  } : null;
}
function getOutsideFacilitiesIconItems(outsideFacilities) {
  if (isEmpty_default()(outsideFacilities)) {
    return null;
  }

  return outsideFacilities.map(function (item) {
    return {
      icon: icons["a" /* ICONS */][get_default()(item, 'id')],
      labels: [item.label]
    };
  });
}

function getServiceIconItem(service) {
  return service ? {
    icon: icons["a" /* ICONS */][get_default()(service, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [service.label]
  } : null;
}

function aggregateIconList(_ref) {
  var surfaceItem = _ref.surfaceItem,
      capacityItem = _ref.capacityItem,
      outsideFacilitiesItems = _ref.outsideFacilitiesItems,
      strengths = _ref.strengths,
      viewItem = _ref.viewItem;
  var maxAccomodationsToDisplay = 4;
  var accomodationsWithoutStrengthsCount = [capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), [viewItem]).filter(function (item) {
    return get_default()(item, 'labels.0');
  }).length;
  var availableSpacesForStrengths = maxAccomodationsToDisplay - accomodationsWithoutStrengthsCount;
  var strengthsItems = (strengths || []).slice(0, availableSpacesForStrengths).map(function (strength) {
    return {
      icon: icons["a" /* ICONS */][get_default()(strength, 'id')] || icons["a" /* ICONS */].TRIDENT1,
      labels: [get_default()(strength, 'label') || '']
    };
  }); // $FlowFixMe

  return compact_default()([surfaceItem, capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), [viewItem], Object(toConsumableArray["a" /* default */])(strengthsItems))).filter(function (_ref2) {
    var _ref2$labels = _ref2.labels,
        labels = _ref2$labels === void 0 ? [] : _ref2$labels;
    return labels.length && labels[0];
  }).slice(0, 4);
}

function mapAccommodationStrengths(i18n, accommodation) {
  var maxCapacity = accommodation.maxCapacity,
      roomType = accommodation.roomType,
      strengths = accommodation.strengths,
      surface = accommodation.surface,
      view = accommodation.view,
      outsideFacilities = accommodation.outsideFacilities;
  var surfaceItem = getSurfaceIconItem(i18n, surface, roomType);
  var capacityItem = getCapacityIconItem(i18n, maxCapacity);
  var viewItem = getViewIconItem(view);
  var outsideFacilitiesItems = getOutsideFacilitiesIconItems(outsideFacilities);
  return {
    strengths: aggregateIconList({
      surfaceItem: surfaceItem,
      capacityItem: capacityItem
    }),
    strengthsCompact: [surfaceItem === null || surfaceItem === void 0 ? void 0 : surfaceItem.labels, capacityItem === null || capacityItem === void 0 ? void 0 : capacityItem.labels].filter(Boolean),
    strengthsAlternate: aggregateIconList({
      outsideFacilitiesItems: outsideFacilitiesItems,
      viewItem: viewItem,
      strengths: strengths
    })
  };
}

function mapAccommodationServices(i18n, accommodation, isExclusiveCollection) {
  var _accommodation$bathro = accommodation.bathroomEquipments,
      bathroomEquipments = _accommodation$bathro === void 0 ? [] : _accommodation$bathro,
      _accommodation$equipm = accommodation.equipments,
      equipments = _accommodation$equipm === void 0 ? [] : _accommodation$equipm,
      _accommodation$servic = accommodation.services,
      services = _accommodation$servic === void 0 ? [] : _accommodation$servic;
  var isSuiteAccommodation = (accommodation === null || accommodation === void 0 ? void 0 : accommodation.comfortId) === constants["c" /* COMFORT_TYPE_SUITE */];
  return [{
    label: isExclusiveCollection || isSuiteAccommodation ? get_default()(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }, {
    label: get_default()(i18n, 'equipmentLabel', ''),
    items: equipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: get_default()(i18n, 'bathroomLabel', ''),
    items: bathroomEquipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: !(isExclusiveCollection || isSuiteAccommodation) ? get_default()(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }].filter(function (service) {
    return service.label;
  });
}

function getRankingIndex(ranking) {
  return Object.values(RANKINGS).findIndex(function (r) {
    return r === ranking;
  });
}

function isProductExclusiveCollection(comfort) {
  return comfort > 4;
} // eslint-disable-next-line clubmed/no-fake-component


function getAccommodation(_ref3) {
  var accommodation = _ref3.accommodation,
      categoryLabel = _ref3.categoryLabel,
      resortComfort = _ref3.resortComfort,
      streetView = _ref3.streetView,
      i18n = _ref3.i18n;
  var areas = accommodation.areas,
      categoryId = accommodation.categoryId,
      comfortId = accommodation.comfortId,
      comfortType = accommodation.comfortType,
      description = accommodation.description,
      floorPlans = accommodation.floorPlans,
      id = accommodation.id,
      label = accommodation.label,
      photos = accommodation.media.photos,
      productId = accommodation.productId;

  var _mapAccommodationStre = mapAccommodationStrengths(i18n, accommodation),
      strengths = _mapAccommodationStre.strengths,
      strengthsCompact = _mapAccommodationStre.strengthsCompact,
      strengthsAlternate = _mapAccommodationStre.strengthsAlternate;

  var isDisplayable = [comfortType, label].every(function (item) {
    return !!item;
  });
  var isExclusiveCollection = isProductExclusiveCollection(resortComfort) || accommodation.exclusiveCollection;
  var images = photos.map(function (_ref4) {
    var url = _ref4.url;
    return {
      src: url
    };
  });
  var streetViews = !isEmpty_default()(streetView) && !!streetView.streetView ? [streetView.streetView] : undefined;
  var details = {
    areas: areas,
    categoryId: categoryId,
    comfort: resortComfort,
    comfortType: comfortType,
    comfortId: comfortId,
    description: description,
    floorPlans: floorPlans,
    immersive: {
      url: get_default()(photos, '[0].url')
    },
    isExclusiveCollection: isExclusiveCollection,
    label: label,
    categoryLabel: categoryLabel,
    overview: strengths,
    overviewCompact: strengthsCompact,
    overviewAlternate: strengthsAlternate,
    strengthsLabel: i18n.strengthsLabel,
    amenitiesLabel: i18n.amenitiesLabel,
    services: mapAccommodationServices(i18n, accommodation, isExclusiveCollection),
    slideshow: {
      groupeKey: 'roomCard',
      media: images
    },
    multimedia: {
      photos: photos,
      streetViews: streetViews
    },
    productId: productId
  };
  return isDisplayable && productAccommodations_utils_jsx(ProductRoomCard_ProductRoomCard, {
    fetchDetail: function fetchDetail() {
      return Promise.resolve(details);
    },
    isExclusiveCollection: isExclusiveCollection,
    key: id,
    labeledIconsList: strengths,
    media: images,
    seeMoreLabel: i18n.seeMore,
    title: label
  });
}

function renderDetail() {
  return function (_ref5) {
    var areas = _ref5.areas,
        comfort = _ref5.comfort,
        comfortType = _ref5.comfortType,
        description = _ref5.description,
        floorPlans = _ref5.floorPlans,
        isExclusiveCollection = _ref5.isExclusiveCollection,
        immersive = _ref5.immersive,
        label = _ref5.label,
        categoryLabel = _ref5.categoryLabel,
        overview = _ref5.overview,
        overviewCompact = _ref5.overviewCompact,
        overviewAlternate = _ref5.overviewAlternate,
        strengthsLabel = _ref5.strengthsLabel,
        amenitiesLabel = _ref5.amenitiesLabel,
        services = _ref5.services,
        slideshow = _ref5.slideshow,
        multimedia = _ref5.multimedia,
        productId = _ref5.productId;
    var customProps = {
      areas: areas,
      description: description,
      title: label,
      subtitle: categoryLabel,
      diamond: {
        label: comfortType
      },
      floorPlans: floorPlans,
      immersive: immersive,
      isExclusiveCollection: isProductExclusiveCollection(comfort) || isExclusiveCollection,
      overview: overview,
      overviewCompact: overviewCompact,
      overviewAlternate: overviewAlternate,
      strengthsLabel: strengthsLabel,
      amenitiesLabel: amenitiesLabel,
      services: services,
      slideshow: slideshow,
      multimedia: multimedia,
      productId: productId
    };
    return productAccommodations_utils_jsx(ProductRoomDetail_ProductRoomDetail, customProps);
  };
}

var productAccommodations_utils_getAllAvailableItems = function getAllAvailableItems(accommodationCategories, itemType) {
  return Object(dist["sortByRanking"])(accommodationCategories.reduce(function (items, accommodationCategory) {
    return unionBy_default()(items, accommodationCategory[itemType], 'id');
  }, []));
};

var isHighOrVeryHighRanking = function isHighOrVeryHighRanking(_ref6) {
  var ranking = _ref6.ranking;
  return [RANKINGS.VERY_HIGH, RANKINGS.HIGH].includes(ranking);
};

var withExclusiveCollectionTag = function withExclusiveCollectionTag(_ref7) {
  var _ref7$categoryId = _ref7.categoryId,
      categoryId = _ref7$categoryId === void 0 ? '' : _ref7$categoryId,
      isExclusiveCollection = _ref7.isExclusiveCollection;
  return ['typeoflodging_comfort_type_deluxe', 'typeoflodging_comfort_type_suite'].includes(categoryId) && isExclusiveCollection ? "".concat(categoryId, "_EC") : categoryId;
};
function groupAccommodationsByCategory(props) {
  var _props$accommodationC = props.accommodationCategory;
  _props$accommodationC = _props$accommodationC === void 0 ? {} : _props$accommodationC;
  var _props$accommodationC2 = _props$accommodationC.rankedCategories,
      rankedCategories = _props$accommodationC2 === void 0 ? [] : _props$accommodationC2,
      bathroomLabel = props.bathroomLabel,
      capacityOfPeopleLabel = props.capacityOfPeopleLabel,
      strengthsLabel = props.strengthsLabel,
      amenitiesLabel = props.amenitiesLabel,
      equipmentLabel = props.equipmentLabel,
      numberOfPeopleLabel = props.numberOfPeopleLabel,
      _props$resort = props.resort,
      _props$resort$accommo = _props$resort.accommodations,
      accommodations = _props$resort$accommo === void 0 ? [] : _props$resort$accommo,
      _props$resort$areas = _props$resort.areas,
      resortAreas = _props$resort$areas === void 0 ? [] : _props$resort$areas,
      _props$resort$comfort = _props$resort.comfort,
      resortComfort = _props$resort$comfort === void 0 ? 3 : _props$resort$comfort,
      type = _props$resort.type,
      productId = _props$resort.id,
      _props$roomConfigurat = props.roomConfiguration;
  _props$roomConfigurat = _props$roomConfigurat === void 0 ? {} : _props$roomConfigurat;
  var singleRoom = _props$roomConfigurat.singleRoom,
      connectingRooms = _props$roomConfigurat.connectingRooms,
      separatedRooms = _props$roomConfigurat.separatedRooms,
      seeMore = props.seeMore,
      servicesLabel = props.servicesLabel,
      streetViews = props.streetViews;
  var i18n = {
    bathroomLabel: bathroomLabel,
    capacityOfPeopleLabel: capacityOfPeopleLabel,
    strengthsLabel: strengthsLabel,
    amenitiesLabel: amenitiesLabel,
    connectingRooms: connectingRooms,
    equipmentLabel: equipmentLabel,
    numberOfPeopleLabel: numberOfPeopleLabel,
    seeMore: seeMore,
    separatedRooms: separatedRooms,
    servicesLabel: servicesLabel,
    singleRoom: singleRoom,
    surfaceLabel: Object(src_i18n["h" /* t */])('accommodations.surfaceLabel')
  }; // $FlowFixMe

  return Object.values( // $FlowFixMe
  accommodations.reduce(function (categories, accommodation) {
    // Ranking index to sort categories and accommodations within a category
    var rankedCategory = rankedCategories.find(function (c) {
      return c.id === accommodation.categoryId;
    });
    var categoryRanking = rankedCategory ? rankedCategory.ranking : DEFAULT_RANKING;
    var categoryIndex = getRankingIndex(categoryRanking);
    var streetView = streetViews && (streetViews === null || streetViews === void 0 ? void 0 : streetViews.length) > 0 ? streetViews.find(function (sv) {
      return sv.accommodationCategoryId === accommodation.categoryId;
    }) : []; // Accommodation tabs are now based on accommodation comfort, not category...

    var categoryId = accommodation.comfortId;
    var categoryLabel = accommodation.comfortType; // ...except for VILLA products

    if (type === PRODUCT_TYPES.VILLA) {
      // eslint-disable-next-line prefer-destructuring
      categoryId = accommodation.categoryId;
      categoryLabel = accommodation.category;
    }

    if (!categoryId) {
      return categories;
    } // Ranking index to sort accommodations within a category


    var accommodationIndex = getRankingIndex(accommodation.ranking);
    var accommodationProps = {
      accommodation: productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, accommodation), {}, {
        areas: (accommodation.areas || []).map(function (area) {
          var _resortAreas$find;

          return {
            id: area.id,
            label: ((_resortAreas$find = resortAreas.find(function (_ref8) {
              var resortAreaId = _ref8.id;
              return resortAreaId === area.id;
            })) === null || _resortAreas$find === void 0 ? void 0 : _resortAreas$find.label) || ''
          };
        }),
        productId: productId
      }),
      accommodationIndex: accommodationIndex,
      categoryLabel: categoryLabel,
      categoryIndex: categoryIndex,
      colorId: accommodation.categoryId,
      resortComfort: resortComfort,
      streetView: streetView,
      i18n: i18n
    };
    categoryId = withExclusiveCollectionTag({
      categoryId: categoryId,
      isExclusiveCollection: accommodation.exclusiveCollection
    });

    if (categories[categoryId]) {
      var _accommodation$area, _categories$categoryI, _accommodation$area2, _accommodation$area3, _categories$categoryI2; // Add accommodation to category if it exists


      categories[categoryId].categoryAccommodations.push(accommodationProps);

      if (!categories[categoryId].minCapacity || accommodation.minCapacity && categories[categoryId].minCapacity > accommodation.minCapacity) {
        categories[categoryId].minCapacity = accommodation.minCapacity;
      }

      if (!categories[categoryId].maxCapacity || accommodation.maxCapacity && categories[categoryId].maxCapacity < accommodation.maxCapacity) {
        categories[categoryId].maxCapacity = accommodation.maxCapacity;
      }

      if (((_accommodation$area = accommodation.area) === null || _accommodation$area === void 0 ? void 0 : _accommodation$area.min) && accommodation.area.min < ((_categories$categoryI = categories[categoryId].area) === null || _categories$categoryI === void 0 ? void 0 : _categories$categoryI.min)) {
        categories[categoryId].area.min = accommodation.area.min;
      }

      if (((_accommodation$area2 = accommodation.area) === null || _accommodation$area2 === void 0 ? void 0 : _accommodation$area2.max) && ((_accommodation$area3 = accommodation.area) === null || _accommodation$area3 === void 0 ? void 0 : _accommodation$area3.max) > ((_categories$categoryI2 = categories[categoryId].area) === null || _categories$categoryI2 === void 0 ? void 0 : _categories$categoryI2.max)) {
        var _accommodation$area4;

        categories[categoryId].area.max = (_accommodation$area4 = accommodation.area) === null || _accommodation$area4 === void 0 ? void 0 : _accommodation$area4.max;
      }

      categories[categoryId].exclusiveCollection = accommodation.exclusiveCollection && categories[categoryId].exclusiveCollection;
      categories[categoryId].equipments = intersectionBy_default()(categories[categoryId].equipments, accommodation.equipments.filter(isHighOrVeryHighRanking), 'id');
      categories[categoryId].services = intersectionBy_default()(categories[categoryId].services, accommodation.services.filter(isHighOrVeryHighRanking), 'id');
      categories[categoryId].strengths = unionBy_default()(categories[categoryId].strengths, [].concat(Object(toConsumableArray["a" /* default */])((accommodation.view ? [accommodation.view] : []).map(function (v) {
        return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, v), {}, {
          ranking: 1
        });
      })), Object(toConsumableArray["a" /* default */])((accommodation.strengths || []).map(function (strength) {
        return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, strength), {}, {
          ranking: 2
        });
      })), Object(toConsumableArray["a" /* default */])((accommodation.outsideFacilities || []).map(function (outsideFacility) {
        return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, outsideFacility), {}, {
          ranking: 3
        });
      }))), 'id').sort(function (sA, sB) {
        return sA.ranking - sB.ranking;
      });
      categories[categoryId].bathroomEquipments = intersectionBy_default()(categories[categoryId].bathroomEquipments, accommodation.bathroomEquipments, 'id');
    } else {
      // Create category if it doesn't exist
      categories[categoryId] = {
        area: accommodation.area,
        bathroomEquipments: accommodation.bathroomEquipments,
        categoryAccommodations: [accommodationProps],
        categoryId: categoryId,
        categoryIndex: categoryIndex,
        categoryLabel: categoryLabel,
        equipments: accommodation.equipments.filter(isHighOrVeryHighRanking),
        exclusiveCollection: accommodation.exclusiveCollection,
        media: accommodation.media,
        maxCapacity: accommodation.maxCapacity,
        minCapacity: accommodation.minCapacity,
        productId: productId,
        services: accommodation.services.filter(isHighOrVeryHighRanking),
        strengths: [].concat(Object(toConsumableArray["a" /* default */])((accommodation.view ? [accommodation.view] : []).map(function (v) {
          return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, v), {}, {
            ranking: 1
          });
        })), Object(toConsumableArray["a" /* default */])((accommodation.strengths || []).map(function (strength) {
          return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, strength), {}, {
            ranking: 2
          });
        })), Object(toConsumableArray["a" /* default */])((accommodation.outsideFacilities || []).map(function (outsideFacility) {
          return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, outsideFacility), {}, {
            ranking: 3
          });
        })))
      };
    }

    return categories;
  }, {}) // $FlowFixMe
  ).sort(function (a, b) {
    return b.categoryIndex - a.categoryIndex;
  });
}
function getTabsItemsAndPropsFromAccommodations(props, accommodationCategories) {
  var isLineExclusiveCollection = props.isLineExclusiveCollection,
      resortIsExclusiveCollection = props.resort.isExclusiveCollection;
  var hiddenItemsCount = 0;
  var items = // I have no idea what's going on there and to be honest I don't care enough
  // sorry to the person who'll be reading that in the future but I give up
  // $FlowFixMe
  accommodationCategories.map(function (accommodationCategory, index) {
    // $FlowFixMe
    var categoryAccommodations = accommodationCategory.categoryAccommodations,
        categoryLabel = accommodationCategory.categoryLabel; // We need to sort with the upper index first. Since Array.sort is broken client side (why??),
    // we use the lodash function which only sorts from the lower to the upper. We knows that the
    // accomodations are already sorted by accomodationIdex so we have to sort by categoryIndex.
    // The tricky part is here: we cannot reverse the output of lodash.sortBy, so we sort with a
    // negative categoryIndex.

    var categoryAccommodationsProps = sortBy_default()(Object(toConsumableArray["a" /* default */])(categoryAccommodations), function (_ref9) {
      var categoryIndex = _ref9.categoryIndex;
      return -1 * categoryIndex;
    });

    var content = categoryAccommodationsProps.map(getAccommodation).filter(Boolean);

    if (content.length === 0) {
      return null;
    } // $FlowFixMe


    var isLarge = content.every(function (item) {
      return item.props.isExclusiveCollection;
    });
    var shouldDisplayAsExclusiveCollection = isLarge && !resortIsExclusiveCollection || resortIsExclusiveCollection;

    if (isLineExclusiveCollection && isLarge || !isLineExclusiveCollection) {
      return {
        header: {
          title: "".concat(categoryLabel, " ").concat(isLarge && !resortIsExclusiveCollection ? Object(src_i18n["h" /* t */])('common.exclusiveCollectionLabel') : ''),
          trackingData: {
            categoryGA: 'resort',
            actionGA: 'blockInfos',
            labelGA: "".concat(isLineExclusiveCollection ? 'eCollection' : 'accommodations', "_").concat(categoryLabel)
          },
          headerClassNames: shouldDisplayAsExclusiveCollection ? {
            active: 'font-sans text-ultramarine',
            inactive: 'font-sans'
          } : {}
        },
        content: [productAccommodations_utils_jsx(ProductInformationSlider_container["a" /* ProductInformationSliderContainer */], {
          backNavigationLabel: Object(src_i18n["h" /* t */])('common.backNavigation'),
          theme: "short",
          errorMessage: "error",
          isLarge: isLarge,
          key: "ProductAccommodationsSlider_".concat(categoryLabel),
          queryLayer: isLineExclusiveCollection ? 'accommodationLayerEC' : 'accommodationLayer',
          renderDetail: renderDetail(),
          scrollBackwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
          scrollForwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward'),
          sliderIndex: index - hiddenItemsCount
        }, content)]
      };
    }

    hiddenItemsCount++;
    return null;
  }).filter(function (item) {
    return item !== null;
  });

  var slot = function slot(activeIndexes) {
    return productAccommodations_utils_jsx(ProductRoomsComparatorLauncher["a" /* ProductRoomsComparatorLauncher */], {
      accommodationCategories: accommodationCategories,
      activeIndex: activeIndexes[0],
      exclusiveCollectionLabel: Object(src_i18n["h" /* t */])('common.exclusiveCollectionLabel'),
      resortIsExclusiveCollection: resortIsExclusiveCollection
    });
  };

  return {
    items: items,
    slot: slot
  };
}

/***/ }),

/***/ "5yTO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__("1037").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ "5zYZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("ZK3j");
var common = __webpack_require__("roL5");
var shaCommon = __webpack_require__("xy6B");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "695J":
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "6CUh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pollWrapper = exports.pollWrapper = function pollWrapper(_ref) {
  var request = _ref.request,
      pollingPeriod = _ref.pollingPeriod,
      shouldStop = _ref.shouldStop;

  var canceled = false;
  var cancel = function cancel() {
    canceled = true;
  };

  var poll = function poll(resolve, reject) {
    if (canceled) {
      reject(new Error('Polling has been manually canceled'));
      return;
    }

    request().then(function (response) {
      if (shouldStop(response)) {
        resolve(response);
      } else {
        setTimeout(function () {
          poll(resolve, reject);
        }, pollingPeriod);
      }
    }).catch(function (error) {
      return reject(error);
    });
  };

  return { future: new Promise(poll), cancel: cancel };
};

exports.default = pollWrapper;

/***/ }),

/***/ "6PUI":
/***/ (function(module, exports) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ "6dwG":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__("r2q8").EventEmitter;
var inherits = __webpack_require__("qW1w");

inherits(Stream, EE);
Stream.Readable = __webpack_require__("G+mE");
Stream.Writable = __webpack_require__("4f5z");
Stream.Duplex = __webpack_require__("eWVS");
Stream.Transform = __webpack_require__("pjey");
Stream.PassThrough = __webpack_require__("VkvE");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ "6kWf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("r2q8").EventEmitter;


/***/ }),

/***/ "6sN/":
/***/ (function(module, exports, __webpack_require__) {

/*global module*/
var Buffer = __webpack_require__("+ZX+").Buffer;

module.exports = function toString(obj) {
  if (typeof obj === 'string')
    return obj;
  if (typeof obj === 'number' || Buffer.isBuffer(obj))
    return obj.toString();
  return JSON.stringify(obj);
};


/***/ }),

/***/ "6yhU":
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "7IvJ":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("KLyV").Buffer
var Transform = __webpack_require__("6dwG").Transform
var StringDecoder = __webpack_require__("2wQW").StringDecoder
var inherits = __webpack_require__("qW1w")

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),

/***/ "7Z8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openToast; });
/* unused harmony export showTemporaryToast */
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rJ95");



var CLOSE_TOAST = 'CLOSE_TOAST';
var OPEN_TOAST = 'OPEN_TOAST';

function openToast(toastLabel, className, style) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(OPEN_TOAST, {
    className: className,
    toastLabel: toastLabel,
    style: style
  });
}

function closeToast() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(CLOSE_TOAST);
}

var showTemporaryToast = function showTemporaryToast(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 2000 : _ref$timeout,
      toastLabel = _ref.toastLabel;
  return function (dispatch) {
    return Promise.resolve(dispatch(openToast(toastLabel, className, style))).then(function () {
      setTimeout(function () {
        return dispatch(closeToast());
      }, timeout);
    });
  };
};



/***/ }),

/***/ "7m0K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__("YbGV");
__webpack_require__("qW1w")(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "8HVW":
/***/ (function(module, exports, __webpack_require__) {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = __webpack_require__("KLyV").Buffer
var BN = __webpack_require__("zuLC")
var EC = __webpack_require__("jggy").ec
var parseKeys = __webpack_require__("cJUb")
var curves = __webpack_require__("gbEP")

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [1]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = Buffer.from(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = Buffer.from(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify


/***/ }),

/***/ "8N5j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("qW1w")
var HashBase = __webpack_require__("i8+T")
var Buffer = __webpack_require__("KLyV").Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),

/***/ "8UHF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__("5yTO");
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "8soX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isSymbol2 = __webpack_require__("a88S");

var _isSymbol3 = _interopRequireDefault(_isSymbol2);

var _isString2 = __webpack_require__("nDih");

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = __webpack_require__("Kkar");

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFSA(action) {
  return (0, _isPlainObject3.default)(action) && ((0, _isString3.default)(action.type) || (0, _isSymbol3.default)(action.type)) && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "954z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("Y4pH");
var inherits = __webpack_require__("qW1w");

var utils = __webpack_require__("5cvY");
var Cipher = __webpack_require__("cHVg");

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),

/***/ "9BmX":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("dw5g");

/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return toString(value).toUpperCase();
}

module.exports = toUpper;


/***/ }),

/***/ "9FfZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__("aMao")

exports.certificate = __webpack_require__("+I+g")

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),

/***/ "9TIw":
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__("qW1w")
var Hash = __webpack_require__("4rhd")
var Buffer = __webpack_require__("KLyV").Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),

/***/ "9tk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductRoomsComparatorLauncher_ProductRoomsComparatorLauncher; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("LqLs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js + 3 modules
var productAccommodations_utils = __webpack_require__("5svr");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparator.utils.js
var ITEMS_ORDER = ['services', 'equipments', 'bathroomEquipments'];
var SECTION_LABELS = {
  equipments: 'common.accommodations.equipments',
  services: 'common.accommodations.services',
  bathroomEquipments: 'common.accommodations.bathroomEquipments'
};
var sortCategoriesItems = function sortCategoriesItems(_ref, _ref2) {
  var rankingA = _ref.ranking;
  var rankingB = _ref2.ranking;

  if (rankingB < rankingA) {
    return 1;
  }

  if (rankingB > rankingA) {
    return -1;
  }
};
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLarge.jsx



var __jsx = react_default.a.createElement;









var ProductRoomsComparatorLarge_ProductRoomsComparatorLarge = function ProductRoomsComparatorLarge(_ref) {
  var allCategoriesItems = _ref.allCategoriesItems,
      availabilityBoards = _ref.availabilityBoards,
      columns = _ref.columns;
  var _thTitle$thInfoTitle$ = {
    thTitle: 'font-brand text-20 text-black text-center',
    thInfoTitle: 'text-mediumGrey flex gap-15 items-center py-10',
    thInfo: 'font-bold text-16 flex items-center justify-center',
    thStrength: 'py-10 flex items-center justify-center',
    thSectionHeader: 'flex mb-20',
    thSectionTitle: 'font-bold text-22 text-black',
    thSectionHeaderItem: 'flex items-center justify-center',
    thIcon: 'text-black me-15 shrink-0',
    thTableCell: 'px-10',
    thCheck: 'flex items-center justify-center'
  },
      thTitle = _thTitle$thInfoTitle$.thTitle,
      thInfoTitle = _thTitle$thInfoTitle$.thInfoTitle,
      thInfo = _thTitle$thInfoTitle$.thInfo,
      thStrength = _thTitle$thInfoTitle$.thStrength,
      thSectionHeader = _thTitle$thInfoTitle$.thSectionHeader,
      thSectionTitle = _thTitle$thInfoTitle$.thSectionTitle,
      thSectionHeaderItem = _thTitle$thInfoTitle$.thSectionHeaderItem,
      thIcon = _thTitle$thInfoTitle$.thIcon,
      thTableCell = _thTitle$thInfoTitle$.thTableCell,
      thCheck = _thTitle$thInfoTitle$.thCheck;
  var columnWidth = "".concat(100 / (columns.length + 1), "%");

  var getHorizontalAvailabilityLinesFromItemType = function getHorizontalAvailabilityLinesFromItemType(itemType) {
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].sort(sortCategoriesItems).map(function (item, index) {
      return __jsx("div", {
        className: "flex",
        key: index
      }, __jsx("div", {
        className: "flex items-center py-10 text-16",
        style: {
          width: columnWidth
        }
      }, __jsx(Icon["a" /* Icon */], {
        alt: "",
        className: thIcon,
        name: icons["a" /* ICONS */][item.id] || icons["a" /* ICONS */].TRIDENT1,
        width: "1.25rem"
      }), item.label), availabilityBoards.map(function (board, boardIndex) {
        return __jsx("div", {
          key: boardIndex,
          className: Object(classnames_utils["a" /* classnames */])(thTableCell, thCheck),
          style: {
            width: columnWidth
          }
        }, __jsx(Icon["a" /* Icon */], {
          className: board[itemType][index] ? 'text-green' : 'text-grey',
          name: board[itemType][index] ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS,
          width: "1rem"
        }));
      }));
    });
  };

  return __jsx("div", {
    className: "mx-auto max-w-site px-20 pt-60"
  }, __jsx("div", {
    className: "flex justify-end"
  }, columns.map(function (column, index) {
    var _column$picture;

    return __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('text-center', thTableCell),
      key: index,
      style: {
        width: columnWidth
      }
    }, __jsx("div", {
      className: "mb-30 max-h-30"
    }, __jsx("div", {
      className: thTitle
    }, column.title), column.price && __jsx("div", {
      className: "font-sans font-bold text-black"
    }, column.price)), __jsx("div", {
      className: "overflow-hidden rounded-12"
    }, __jsx(Image["a" /* Image */], {
      altMsg: column.title,
      hasLazyLoading: true,
      imageUrl: (_column$picture = column.picture) === null || _column$picture === void 0 ? void 0 : _column$picture.url,
      ratioKey: ratios_utils["c" /* default */].XL
    })));
  })), __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, __jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].SINGLE_ROOM,
    width: "1.875rem"
  }), Object(i18n["h" /* t */])('common.accommodations.size')), columns.map(function (column, index) {
    return __jsx("div", {
      key: index,
      className: Object(classnames_utils["a" /* classnames */])(thTableCell, thInfo),
      style: {
        width: columnWidth
      }
    }, column.surface);
  })), __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, __jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].PEOPLE_DOUBLE,
    width: "1.875rem"
  }), Object(i18n["h" /* t */])('common.accommodations.capacity')), columns.map(function (column, index) {
    return __jsx("div", {
      key: index,
      className: Object(classnames_utils["a" /* classnames */])(thTableCell, thInfo),
      style: {
        width: columnWidth
      }
    }, column.capacity);
  })), __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, Object(i18n["h" /* t */])('common.accommodations.strengths')), columns.map(function (column, index) {
    return __jsx("div", {
      key: index,
      className: Object(classnames_utils["a" /* classnames */])(thTableCell, thStrength),
      style: {
        width: columnWidth
      }
    }, __jsx(LabeledIconsList["a" /* LabeledIconsList */], {
      items: column.strengths.map(function (strength) {
        return {
          icon: icons["a" /* ICONS */][strength.id] || icons["a" /* ICONS */].TRIDENT1,
          labels: [strength.label]
        };
      }),
      theme: "comparator"
    }));
  })), ITEMS_ORDER.map(function (itemType) {
    return !!allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].length && __jsx("div", {
      key: itemType,
      className: "border-t-1 border-lightGrey py-30"
    }, __jsx("div", {
      className: thSectionHeader
    }, __jsx("div", {
      className: thSectionTitle,
      style: {
        width: columnWidth
      }
    }, Object(i18n["h" /* t */])(SECTION_LABELS[itemType])), columns.map(function (column, index) {
      return __jsx("div", {
        key: index,
        className: Object(classnames_utils["a" /* classnames */])(thTitle, thSectionHeaderItem, thTableCell),
        style: {
          width: columnWidth
        }
      }, column.title);
    })), getHorizontalAvailabilityLinesFromItemType(itemType));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorNarrow.jsx



var ProductRoomsComparatorNarrow_jsx = react_default.a.createElement;









var ProductRoomsComparatorNarrow_ProductRoomsComparatorNarrow = function ProductRoomsComparatorNarrow(_ref) {
  var allCategoriesItems = _ref.allCategoriesItems,
      availabilityBoards = _ref.availabilityBoards,
      columns = _ref.columns;
  var _thColumn$thTitle$thI = {
    thColumn: 'bg-white border-1 border-lightGrey rounded-12 shadow-diffuse',
    thTitle: 'p-15 leading-tight font-brand text-20 text-black',
    thInfoTitle: 'flex items-center pt-10 text-mediumGrey text-14',
    thInfo: 'ms-auto font-bold text-16',
    thSectionHeader: 'flex',
    thSectionTitle: 'font-bold text-18 text-black',
    thIcon: 'text-black shrink-0',
    thCheck: 'flex items-center justify-center'
  },
      thColumn = _thColumn$thTitle$thI.thColumn,
      thTitle = _thColumn$thTitle$thI.thTitle,
      thInfoTitle = _thColumn$thTitle$thI.thInfoTitle,
      thInfo = _thColumn$thTitle$thI.thInfo,
      thSectionHeader = _thColumn$thTitle$thI.thSectionHeader,
      thSectionTitle = _thColumn$thTitle$thI.thSectionTitle,
      thIcon = _thColumn$thTitle$thI.thIcon,
      thCheck = _thColumn$thTitle$thI.thCheck;

  var getItemsAvailability = function getItemsAvailability(itemType, columnIndex) {
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].sort(sortCategoriesItems).map(function (item, index) {
      return ProductRoomsComparatorNarrow_jsx("div", {
        key: index,
        className: "flex items-baseline justify-between"
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: "flex items-center gap-15 pt-20 text-16"
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        alt: "",
        className: thIcon,
        name: icons["a" /* ICONS */][item.id] || icons["a" /* ICONS */].TRIDENT1,
        width: "1.25rem"
      }), item.label), ProductRoomsComparatorNarrow_jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])(thCheck)
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        className: availabilityBoards[columnIndex][itemType][index] ? 'text-green' : 'text-grey',
        name: availabilityBoards[columnIndex][itemType][index] ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS,
        width: "1rem"
      })));
    });
  };

  return ProductRoomsComparatorNarrow_jsx("div", {
    className: "mx-auto max-w-site px-20 pt-30"
  }, ProductRoomsComparatorNarrow_jsx(Slider["a" /* Slider */], {
    cols: 0,
    navPosition: "center",
    nbItemsToScroll: 1,
    scrollAreaClassName: "overflow-hidden -mx-10",
    scrollAreaContainerClassName: "overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory",
    scrollItemClassName: "overflow-hidden px-10 pb-20 flex-none max-w-full"
  }, columns.map(function (column, columnIndex) {
    var _column$picture;

    return ProductRoomsComparatorNarrow_jsx("div", {
      key: columnIndex,
      className: Object(classnames_utils["a" /* classnames */])(thColumn, 'w-[80vw]')
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: thTitle
    }, column.title, column.price && ProductRoomsComparatorNarrow_jsx("div", {
      className: "font-sans"
    }, column.price)), ProductRoomsComparatorNarrow_jsx(Image["a" /* Image */], {
      altMsg: column.title,
      hasLazyLoading: true,
      imageUrl: (_column$picture = column.picture) === null || _column$picture === void 0 ? void 0 : _column$picture.url,
      ratioKey: ratios_utils["c" /* default */].XL
    }), ProductRoomsComparatorNarrow_jsx("p", {
      className: "flex items-baseline gap-5 px-15"
    }, ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfoTitle
    }, Object(i18n["h" /* t */])('common.accommodations.size')), ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfo
    }, column.surface)), ProductRoomsComparatorNarrow_jsx("p", {
      className: "flex items-baseline gap-5 px-15"
    }, ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfoTitle
    }, Object(i18n["h" /* t */])('common.accommodations.capacity')), ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfo
    }, column.capacity)), column.strengths.length > 0 && ProductRoomsComparatorNarrow_jsx("div", {
      className: "px-15 pb-15 pt-10"
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: thInfoTitle
    }, Object(i18n["h" /* t */])('common.accommodations.strengths')), column.strengths.map(function (strength) {
      return ProductRoomsComparatorNarrow_jsx("div", {
        key: strength.id,
        className: "flex items-center gap-5 pt-5"
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        className: "text-black",
        name: icons["a" /* ICONS */][strength.id],
        width: "1rem"
      }), strength.label);
    })), ITEMS_ORDER.map(function (itemType, itemIndex) {
      return !!allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].length && ProductRoomsComparatorNarrow_jsx("div", {
        key: itemIndex,
        className: Object(classnames_utils["a" /* classnames */])('border-t-1 border-lightGrey px-15 pb-30 pt-20', {
          'mt-10': itemIndex === 0
        })
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: thSectionHeader
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: thSectionTitle
      }, Object(i18n["h" /* t */])(SECTION_LABELS[itemType]))), getItemsAvailability(itemType, columnIndex));
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLauncher.jsx










var ProductRoomsComparatorLauncher_jsx = react_default.a.createElement;

















var PriceBlock = function PriceBlock(_ref) {
  var _category$price6;

  var category = _ref.category,
      forceDiffPrice = _ref.forceDiffPrice,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive;

  if (isActive && !forceDiffPrice) {
    var _category$price, _category$price2, _category$price2$init, _category$price3, _category$price3$best, _category$price4, _category$price4$init, _category$price5, _category$price5$best;

    return ProductRoomsComparatorLauncher_jsx("div", {
      className: "text-18 font-bold"
    }, ((_category$price = category.price) === null || _category$price === void 0 ? void 0 : _category$price.initialPrice) && ((_category$price2 = category.price) === null || _category$price2 === void 0 ? void 0 : (_category$price2$init = _category$price2.initialPrice) === null || _category$price2$init === void 0 ? void 0 : _category$price2$init.value) !== ((_category$price3 = category.price) === null || _category$price3 === void 0 ? void 0 : (_category$price3$best = _category$price3.bestPrice) === null || _category$price3$best === void 0 ? void 0 : _category$price3$best.value) ? ProductRoomsComparatorLauncher_jsx("span", {
      className: "text-14 line-through text-sienna font-normal pe-5"
    }, (_category$price4 = category.price) === null || _category$price4 === void 0 ? void 0 : (_category$price4$init = _category$price4.initialPrice) === null || _category$price4$init === void 0 ? void 0 : _category$price4$init.formattedValue) : null, (_category$price5 = category.price) === null || _category$price5 === void 0 ? void 0 : (_category$price5$best = _category$price5.bestPrice) === null || _category$price5$best === void 0 ? void 0 : _category$price5$best.formattedValue);
  }

  return ProductRoomsComparatorLauncher_jsx("div", {
    className: "text-18 font-bold"
  }, (_category$price6 = category.price) === null || _category$price6 === void 0 ? void 0 : _category$price6.diffPrice);
};

var ProductRoomsComparatorLauncher_ProductRoomsComparatorLauncher = function ProductRoomsComparatorLauncher(_ref2) {
  var accommodationCategories = _ref2.accommodationCategories,
      activeIndex = _ref2.activeIndex,
      className = _ref2.className,
      exclusiveCollectionLabel = _ref2.exclusiveCollectionLabel,
      _ref2$forceDiffPrice = _ref2.forceDiffPrice,
      forceDiffPrice = _ref2$forceDiffPrice === void 0 ? false : _ref2$forceDiffPrice,
      _ref2$resortIsExclusi = _ref2.resortIsExclusiveCollection,
      resortIsExclusiveCollection = _ref2$resortIsExclusi === void 0 ? false : _ref2$resortIsExclusi;

  var _useState = Object(react["useState"])(false),
      isLayerOpened = _useState[0],
      setIsLayerOpened = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var allCategoriesItems = ITEMS_ORDER.map(function (itemType) {
    return Object(productAccommodations_utils["a" /* getAllAvailableItems */])(accommodationCategories, itemType);
  });
  var columns = accommodationCategories.map(function (category, index) {
    var _category$price7, _category$area, _category$area2, _category$area3, _category$area4;

    var hasPrice = ((_category$price7 = category.price) === null || _category$price7 === void 0 ? void 0 : _category$price7.bestPrice) || forceDiffPrice;
    return {
      title: "".concat(category.categoryLabel, " ").concat(category.exclusiveCollection && !resortIsExclusiveCollection ? ' ' + exclusiveCollectionLabel : ''),
      picture: category.media.photos[0],
      price: hasPrice ? ProductRoomsComparatorLauncher_jsx(PriceBlock, {
        category: category,
        forceDiffPrice: forceDiffPrice,
        isActive: index === activeIndex
      }) : null,
      isExclusiveCollection: category.exclusiveCollection || resortIsExclusiveCollection,
      isExclusiveCollectionSpace: category.exclusiveCollection && !resortIsExclusiveCollection,
      surface: ((_category$area = category.area) === null || _category$area === void 0 ? void 0 : _category$area.min) !== ((_category$area2 = category.area) === null || _category$area2 === void 0 ? void 0 : _category$area2.max) ? ProductRoomsComparatorLauncher_jsx(TemplateString["a" /* TemplateString */], {
        template: Object(i18n["h" /* t */])('common.accommodations.sizeFrom'),
        values: {
          min_area: "".concat(category.area.min).concat(category.area.unit),
          max_area: "".concat(category.area.max).concat(category.area.unit)
        }
      }) : "".concat((_category$area3 = category.area) === null || _category$area3 === void 0 ? void 0 : _category$area3.max).concat((_category$area4 = category.area) === null || _category$area4 === void 0 ? void 0 : _category$area4.unit),
      capacity: ProductRoomsComparatorLauncher_jsx(TemplateString["a" /* TemplateString */], {
        template: Object(i18n["h" /* t */])('common.accommodations.capacityFrom'),
        values: {
          min_capacity: "".concat(category.minCapacity),
          max_capacity: "".concat(category.maxCapacity)
        }
      }),
      strengths: Object(productAccommodations_utils["a" /* getAllAvailableItems */])([category], 'strengths').slice(0, 4)
    };
  });

  var getAvailabilityBoard = function getAvailabilityBoard(set, itemType) {
    var availableInCategory = new Set(set.map(function (_ref3) {
      var id = _ref3.id;
      return id;
    }));
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].sort(sortCategoriesItems).map(function (_ref4) {
      var id = _ref4.id;
      return availableInCategory.has(id);
    });
  };

  var availabilityBoards = accommodationCategories.map(function (category) {
    var availableEquipments = category.equipments;
    var availableServices = category.services;
    var availableBathroomEquipments = category.bathroomEquipments;
    var equipmentsAvailability = getAvailabilityBoard(availableEquipments, 'equipments');
    var servicesAvailability = getAvailabilityBoard(availableServices, 'services');
    var bathroomEquipmentsAvailability = getAvailabilityBoard(availableBathroomEquipments, 'bathroomEquipments');
    return {
      equipments: equipmentsAvailability,
      services: servicesAvailability,
      bathroomEquipments: bathroomEquipmentsAvailability
    };
  });
  return ProductRoomsComparatorLauncher_jsx(react["Fragment"], null, ProductRoomsComparatorLauncher_jsx(Button["a" /* Button */], {
    className: Object(classnames_utils["a" /* classnames */])('w-full', className),
    iconLeft: {
      name: icons["a" /* ICONS */].COMPARE
    },
    onClick: function onClick() {
      setIsLayerOpened(true);
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'compare_rooms'
      });
    }
  }, Object(i18n["h" /* t */])('common.accommodations.compareRooms')), isLayerOpened && ProductRoomsComparatorLauncher_jsx(Layer["b" /* Layer */], {
    ariaLabel: Object(i18n["h" /* t */])('common.accommodations.compareRooms'),
    bgColor: colors["a" /* COLORS */].WHITE,
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(i18n["h" /* t */])('common.backNavigation'),
      onClick: function onClick() {
        setIsLayerOpened(false);
      }
    },
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    hasAnimateEnter: true,
    hasContainerHeader: true,
    header: ProductRoomsComparatorLauncher_jsx(Title["a" /* Title */], {
      className: "justify-center",
      theme: "title-brand-n3"
    }, Object(i18n["h" /* t */])('common.accommodations.compareRooms')),
    onClose: function onClose() {
      setIsLayerOpened(false);
    }
  }, isDesktop ? ProductRoomsComparatorLauncher_jsx(ProductRoomsComparatorLarge_ProductRoomsComparatorLarge, {
    columns: columns,
    availabilityBoards: availabilityBoards,
    allCategoriesItems: allCategoriesItems,
    accommodationCategories: accommodationCategories
  }) : ProductRoomsComparatorLauncher_jsx(ProductRoomsComparatorNarrow_ProductRoomsComparatorNarrow, {
    columns: columns,
    availabilityBoards: availabilityBoards,
    allCategoriesItems: allCategoriesItems,
    accommodationCategories: accommodationCategories
  })));
};

/***/ }),

/***/ "A110":
/***/ (function(module, exports, __webpack_require__) {

var JsonWebTokenError = __webpack_require__("hXSc");

var TokenExpiredError = function (message, expiredAt) {
  JsonWebTokenError.call(this, message);
  this.name = 'TokenExpiredError';
  this.expiredAt = expiredAt;
};

TokenExpiredError.prototype = Object.create(JsonWebTokenError.prototype);

TokenExpiredError.prototype.constructor = TokenExpiredError;

module.exports = TokenExpiredError;

/***/ }),

/***/ "A8dA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("qW1w")
var Legacy = __webpack_require__("jL7K")
var Base = __webpack_require__("7IvJ")
var Buffer = __webpack_require__("KLyV").Buffer
var md5 = __webpack_require__("KGlL")
var RIPEMD160 = __webpack_require__("//Gm")

var sha = __webpack_require__("guqX")

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),

/***/ "Aa57":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getParamSize(keySize) {
	var result = ((keySize / 8) | 0) + (keySize % 8 === 0 ? 0 : 1);
	return result;
}

var paramBytesForAlg = {
	ES256: getParamSize(256),
	ES384: getParamSize(384),
	ES512: getParamSize(521)
};

function getParamBytesForAlg(alg) {
	var paramBytes = paramBytesForAlg[alg];
	if (paramBytes) {
		return paramBytes;
	}

	throw new Error('Unknown algorithm "' + alg + '"');
}

module.exports = getParamBytesForAlg;


/***/ }),

/***/ "Aa7t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__("wYax");

/*<replacement>*/
var util = Object.create(__webpack_require__("a1wc"));
util.inherits = __webpack_require__("qW1w");
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ "AbLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePrevious; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var usePrevious = function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(value); // Store current value in ref

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
};

/***/ }),

/***/ "BGO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Childcare_Childcare; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/hooks/use-disclosure/useDisclosure.js
var useDisclosure = __webpack_require__("Re84");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/service-block/ServiceBlockCTA.jsx



var __jsx = react_default.a.createElement;




var ServiceBlockCTA_ServiceBlockCTA = function ServiceBlockCTA(_ref) {
  var addLabel = _ref.addLabel,
      button = _ref.button,
      dataSelector = _ref.dataSelector,
      equipment = _ref.equipment,
      includedLabel = _ref.includedLabel,
      price = _ref.price,
      removeLabel = _ref.removeLabel,
      type = _ref.type;
  var labelAdd = price ? "".concat(addLabel, " +").concat(price) : addLabel;
  var labelRemove = price ? "".concat(removeLabel, " -").concat(price) : removeLabel;
  var dataSelectorTestID = "".concat(dataSelector, "-").concat(type !== null && type !== void 0 ? type : '');

  var _useState = Object(react["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _button$onClick;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return (_button$onClick = button.onClick) === null || _button$onClick === void 0 ? void 0 : _button$onClick.call(button);

            case 3:
              setIsLoading(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  switch (type) {
    case 'add':
      return __jsx(Button["a" /* Button */], {
        className: "w-full",
        "data-cs-override-idd": button === null || button === void 0 ? void 0 : button.dataCsOverrideId,
        "data-selector": "".concat(equipment.id, "-ADD"),
        "data-testid": dataSelectorTestID,
        isLoading: isLoading,
        onClick: function onClick() {
          handleClick();
        },
        size: "medium"
      }, labelAdd);

    case 'remove':
    case 'edit':
      return __jsx(Button["a" /* Button */], {
        className: "w-full",
        color: colors["a" /* COLORS */].BLACK,
        colorBg: colors["a" /* COLORS */].TRANSPARENT,
        colorBorder: colors["a" /* COLORS */].BLACK,
        "data-cs-override-id": button === null || button === void 0 ? void 0 : button.dataCsOverrideId,
        "data-selector": "".concat(equipment.id, "-EDIT"),
        "data-testid": "".concat(dataSelector, "-").concat(type),
        isLoading: isLoading,
        onClick: function onClick() {
          handleClick();
        },
        size: "medium"
      }, labelRemove);

    case 'disabled':
      return __jsx(Button["a" /* Button */], {
        className: "w-full",
        "data-cs-override-id": button === null || button === void 0 ? void 0 : button.dataCsOverrideId,
        "data-selector": "".concat(dataSelector, "-").concat(type),
        "data-testid": "".concat(dataSelector, "-").concat(type),
        isDisabled: true,
        onClick: handleClick,
        size: "medium"
      }, (button === null || button === void 0 ? void 0 : button.label) || includedLabel);

    case 'full':
      return __jsx(Button["a" /* Button */], {
        className: "w-full",
        "data-cs-override-id": button === null || button === void 0 ? void 0 : button.dataCsOverrideId,
        "data-selector": "".concat(dataSelector, "-").concat(type),
        "data-testid": "".concat(dataSelector, "-").concat(type),
        isDisabled: true,
        onClick: handleClick,
        size: "medium"
      }, (button === null || button === void 0 ? void 0 : button.label) || includedLabel);

    default:
      return null;
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/service-block/ServiceBlock.jsx


var ServiceBlock_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */









var ServiceBlock_ServiceBlock = function ServiceBlock(_ref) {
  var _ref$addLabel = _ref.addLabel,
      addLabel = _ref$addLabel === void 0 ? '' : _ref$addLabel,
      button = _ref.button,
      className = _ref.className,
      _ref$dataSelector = _ref.dataSelector,
      dataSelector = _ref$dataSelector === void 0 ? 'ServiceBlock' : _ref$dataSelector,
      equipment = _ref.equipment,
      header = _ref.header,
      image = _ref.image,
      _ref$includedLabel = _ref.includedLabel,
      includedLabel = _ref$includedLabel === void 0 ? '' : _ref$includedLabel,
      intro = _ref.intro,
      isPriceForAdultOnly = _ref.isPriceForAdultOnly,
      isValidated = _ref.isValidated,
      lastAvailabilities = _ref.lastAvailabilities,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? '' : _ref$price,
      _ref$removeLabel = _ref.removeLabel,
      removeLabel = _ref$removeLabel === void 0 ? '' : _ref$removeLabel,
      slots = _ref.slots,
      style = _ref.style,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'add' : _ref$type,
      urgentisation = _ref.urgentisation,
      rentedAmount = _ref.rentedAmount;

  var _useState = Object(react["useState"])(false),
      shouldDisplayMoreDetails = _useState[0],
      setShouldDisplayMoreDetails = _useState[1];

  var isDisabled = type === 'disabled';
  var isFull = type === 'full';
  var additionalStyle = {
    label: {
      fontSize: '14px'
    },
    icon: {
      display: 'flex',
      width: '1rem'
    }
  };

  var toggleDisplayMoreDetails = function toggleDisplayMoreDetails() {
    setShouldDisplayMoreDetails(!shouldDisplayMoreDetails);
  };

  return ServiceBlock_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(className, 'isolate flex-none py-5'),
    "data-testid": "ServiceBlock",
    style: style
  }, ServiceBlock_jsx(Capsule["a" /* Capsule */], Object(esm_extends["a" /* default */])({}, header, {
    additionalStyle: additionalStyle
  }), !!image && ServiceBlock_jsx("div", {
    className: "relative isolate z-1"
  }, ServiceBlock_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('bg-cover bg-center bg-no-repeat', {
      'opacity-1 pt-[calc((4/7)*100%)]': !shouldDisplayMoreDetails,
      'opacity-0': shouldDisplayMoreDetails
    }),
    style: {
      backgroundImage: "url(".concat(image, ")"),
      transition: 'padding-top 0.2s linear, opacity 0.2s linear'
    }
  }), !shouldDisplayMoreDetails ? lastAvailabilities : null), ServiceBlock_jsx("div", {
    className: "relative p-10 font-sans text-14"
  }, isValidated && !isFull ? ServiceBlock_jsx("div", {
    className: "relative"
  }, ServiceBlock_jsx("div", {
    className: "absolute left-[-23px] right-[-23px] top-[-26px] flex justify-end"
  }, ServiceBlock_jsx(Icon["a" /* Icon */], {
    className: "text-success",
    name: icons["a" /* ICONS */].CHECK_OUTLINE,
    width: "3.75rem"
  }))) : null, ServiceBlock_jsx("h3", {
    className: "font-brand text-20 font-bold leading-1 text-black"
  }, equipment.label), (slots === null || slots === void 0 ? void 0 : slots.length) > 0 && ServiceBlock_jsx("ul", {
    className: "pt-10"
  }, slots.map(function (slot) {
    return ServiceBlock_jsx("li", {
      className: "flex gap-10 py-5",
      "data-testid": slot.key || slot.label,
      key: slot.key || slot.label
    }, ServiceBlock_jsx(Icon["a" /* Icon */], {
      className: "shrink-0 text-sienna",
      name: slot.icon,
      width: "1.5rem"
    }), ServiceBlock_jsx("div", null, ServiceBlock_jsx("p", {
      className: "text-14"
    }, slot.label), !!slot.disclaimer && ServiceBlock_jsx("p", {
      className: "text-12"
    }, slot.disclaimer)));
  })), equipment.longDescription ? ServiceBlock_jsx(react["Fragment"], null, ServiceBlock_jsx(lib["Collapse"], {
    theme: {
      content: 'flex flex-col gap-10'
    },
    isOpened: shouldDisplayMoreDetails
  }, intro ? ServiceBlock_jsx("p", {
    className: "text-12"
  }, intro) : null, typeof equipment.longDescription === 'string' ? ServiceBlock_jsx(Text["a" /* Text */], {
    text: equipment.longDescription,
    theme: "text-sans-n2"
  }) : equipment.longDescription), ServiceBlock_jsx("button", {
    className: "ms-auto inline-flex items-center gap-5 py-10 text-14 text-black underline",
    onClick: toggleDisplayMoreDetails,
    type: "button"
  }, shouldDisplayMoreDetails ? ServiceBlock_jsx(react["Fragment"], null, Object(i18n["h" /* t */])('common.loadLess'), "\xA0", ServiceBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MINUS,
    width: "0.625rem"
  })) : ServiceBlock_jsx(react["Fragment"], null, Object(i18n["h" /* t */])('common.loadMore'), "\xA0", ServiceBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PLUS,
    width: "0.625rem"
  })))) : null, urgentisation && !isFull && ServiceBlock_jsx("div", {
    className: "flex items-center justify-center",
    "data-testid": "urgentisationBlock"
  }, urgentisation), isFull && Object(i18n["h" /* t */])('booking.services.childcare.babySittingService') !== '' && ServiceBlock_jsx("p", {
    className: "mb-15 text-12 text-orange"
  }, Object(i18n["h" /* t */])('booking.services.childcare.babySittingService')), ServiceBlock_jsx(ServiceBlockCTA_ServiceBlockCTA, {
    addLabel: addLabel,
    button: button,
    dataSelector: dataSelector,
    equipment: equipment,
    includedLabel: includedLabel,
    price: type === 'remove' || type === 'edit' ? rentedAmount : price,
    removeLabel: removeLabel,
    type: type
  }), !isDisabled && !isFull && button && ServiceBlock_jsx("p", {
    className: "mt-10 text-center text-10"
  }, isPriceForAdultOnly ? Object(i18n["h" /* t */])('booking.common.pricePerAdult') : Object(i18n["h" /* t */])('booking.common.pricePerPerson')))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/reservation-block/PopInReservationBlock.jsx + 7 modules
var PopInReservationBlock = __webpack_require__("YOo2");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/client/components/widgets/reservation-block/PopInReservationBlockMorningAfternoonExclusive.jsx
var PopInReservationBlockMorningAfternoonExclusive = __webpack_require__("fYIP");

// EXTERNAL MODULE: ./src/client/context/ChildcareContext.js
var ChildcareContext = __webpack_require__("7afx");

// CONCATENATED MODULE: ./src/client/tracking/events/cart.tracking.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var TRACK_ACTION_CART_ADD = {
  actionGA: 'addToCart'
};
var TRACK_ACTION_CART_REMOVE = {
  actionGA: 'removeFromCart'
}; // ADD/REMOVE

var TRACK_CLICK_EVENT_CART_ADD_RENTAL = _objectSpread(_objectSpread({}, TRACK_ACTION_CART_ADD), {}, {
  labelGA: 'ski'
});
var TRACK_CLICK_EVENT_CART_REMOVE_RENTAL = _objectSpread(_objectSpread({}, TRACK_ACTION_CART_REMOVE), {}, {
  labelGA: 'ski'
});
// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/childcare/childcare.utils.js
var childcare_utils = __webpack_require__("erJz");

// EXTERNAL MODULE: ./src/utils/childcare/childcare.consts.js
var childcare_consts = __webpack_require__("gzwZ");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare/UrgentisationChildcareBlock.jsx



var UrgentisationChildcareBlock_jsx = react_default.a.createElement;





var UrgentisationChildcareBlock_getMinRemainingStock = function getMinRemainingStock(_ref) {
  var _childcare$pricingInf, _childcare$pricingInf2, _childcare$pricingInf3;

  var childcare = _ref.childcare;

  if (!((_childcare$pricingInf = childcare.pricingInfo) === null || _childcare$pricingInf === void 0 ? void 0 : _childcare$pricingInf.schedules)) {
    return 0;
  }

  var remainingStockSchedules = (_childcare$pricingInf2 = childcare.pricingInfo) === null || _childcare$pricingInf2 === void 0 ? void 0 : (_childcare$pricingInf3 = _childcare$pricingInf2.schedules) === null || _childcare$pricingInf3 === void 0 ? void 0 : _childcare$pricingInf3.map(function (_ref2) {
    var _slots$map;

    var slots = _ref2.slots;
    var stockSlots = (slots === null || slots === void 0 ? void 0 : (_slots$map = slots.map(function (_ref3) {
      var remainingStock = _ref3.remainingStock;
      return remainingStock;
    })) === null || _slots$map === void 0 ? void 0 : _slots$map.filter(function (rs) {
      return rs > 0;
    })) || [];
    var minStockSlots = stockSlots.length > 0 ? Math.min.apply(Math, Object(toConsumableArray["a" /* default */])(stockSlots)) : 0;
    return minStockSlots;
  });
  var minRemainingStock = Math.min.apply(Math, Object(toConsumableArray["a" /* default */])(remainingStockSchedules));
  return minRemainingStock;
};
var UrgentisationChildcareBlock_UrgentisationChildcareBlock = function UrgentisationChildcareBlock(_ref4) {
  var childcare = _ref4.childcare,
      type = _ref4.type,
      _ref4$isByDayChildcar = _ref4.isByDayChildcare,
      isByDayChildcare = _ref4$isByDayChildcar === void 0 ? false : _ref4$isByDayChildcar,
      _ref4$isFullStayHalfD = _ref4.isFullStayHalfDayChildcare,
      isFullStayHalfDayChildcare = _ref4$isFullStayHalfD === void 0 ? false : _ref4$isFullStayHalfD;
  // here we show the min remaining stock of all schedules slots of the childcare
  var minRemainingStock = UrgentisationChildcareBlock_getMinRemainingStock({
    childcare: childcare
  });

  if (type === 'add' && !!minRemainingStock) {
    if (isByDayChildcare || isFullStayHalfDayChildcare) {
      return UrgentisationChildcareBlock_jsx("p", {
        className: "flex gap-5 items-center justify-center my-10 text-orange",
        "data-testid": "urgentisationBlock"
      }, UrgentisationChildcareBlock_jsx("span", {
        "data-testid": "urgentisationBlock-label"
      }, Object(i18n["h" /* t */])('booking.services.childcare.urgentisation')));
    }

    return UrgentisationChildcareBlock_jsx("p", {
      className: "flex gap-5 items-center justify-center my-10 text-orange",
      "data-testid": "urgentisationBlock"
    }, minRemainingStock <= childcare_consts["b" /* CHILDCARE_STOCK_THRESHOLD */] && UrgentisationChildcareBlock_jsx(Icon["a" /* Icon */], {
      "data-testid": "ServiceBlock-icon-urgentisation",
      name: icons["a" /* ICONS */].WARNING,
      width: "1.5em"
    }), UrgentisationChildcareBlock_jsx("span", {
      "data-testid": "urgentisationBlock-label"
    }, minRemainingStock <= childcare_consts["b" /* CHILDCARE_STOCK_THRESHOLD */] ? Object(i18n["h" /* t */])('booking.services.childcare.childcareAvailabilities', {
      count: minRemainingStock
    }) : Object(i18n["h" /* t */])('booking.services.childcare.urgentisation')));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/childcare/ChildcareServiceBlock.jsx















var ChildcareServiceBlock_jsx = react_default.a.createElement;


function ChildcareServiceBlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ChildcareServiceBlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ChildcareServiceBlock_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ChildcareServiceBlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















// tag showing for last 10 availabilities
var ChildcareServiceBlock_LastAvailabilitiesTag = function LastAvailabilitiesTag(_ref) {
  var childcare = _ref.childcare,
      type = _ref.type;
  var minRemainingStock = UrgentisationChildcareBlock_getMinRemainingStock({
    childcare: childcare
  });
  var hasMoreStockThanThreshold = Object(childcare_utils["d" /* isBabyOrPetitCM */])(childcare) && minRemainingStock > childcare_consts["b" /* CHILDCARE_STOCK_THRESHOLD */];

  if (type === 'full' || type === 'remove' || childcare.productInfo.isIncluded || hasMoreStockThanThreshold) {
    return null;
  }

  return ChildcareServiceBlock_jsx("div", {
    className: "absolute bottom-0 m-10 rounded-pill bg-lightSand px-10 py-5 text-12 font-bold text-orange"
  }, Object(i18n["h" /* t */])('booking.services.childcare.lastAvailabilities'));
};

var ChildcareServiceBlock_ChildcareServiceBlock = function ChildcareServiceBlock(_ref2) {
  var _childcare$pricingInf2, _childcare$pricingInf3, _childcare$pricingInf4, _childcare$pricingInf5, _childcare$pricingInf6, _childcare$productInf, _childcare$productInf2;

  var className = _ref2.className,
      dataCsOverrideId = _ref2.dataCsOverrideId,
      isIncluded = _ref2.isIncluded,
      childcare = _ref2.childcare,
      childId = _ref2.childId,
      childBirthdateMessage = _ref2.childBirthdateMessage,
      onCtaClick = _ref2.onCtaClick,
      type = _ref2.type,
      blockMinHeight = _ref2.blockMinHeight,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? '' : _ref2$dataTestId,
      _ref2$shouldTriggerCh = _ref2.shouldTriggerChildcareAdvancedReservationBlockOnClick,
      shouldTriggerChildcareAdvancedReservationBlockOnClick = _ref2$shouldTriggerCh === void 0 ? false : _ref2$shouldTriggerCh,
      _ref2$shouldTriggerCh2 = _ref2.shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick,
      shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick = _ref2$shouldTriggerCh2 === void 0 ? false : _ref2$shouldTriggerCh2;

  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isChildcareAdvancedReservationBlockOpen = _useDisclosure.isOpen,
      setChildcareBlockAdvancedClosed = _useDisclosure.onClose,
      setChildcareAdvancedBlockOpen = _useDisclosure.onOpen;

  var _useDisclosure2 = Object(useDisclosure["a" /* useDisclosure */])(),
      isChildcareMorningAfternoonExclusiveRBOpen = _useDisclosure2.isOpen,
      setChildcareMorningAfternoonExclusiveRBClosed = _useDisclosure2.onClose,
      setChildcareMorningAfternoonExclusiveRBOpen = _useDisclosure2.onOpen;

  var _useState = Object(react["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useContext = Object(react["useContext"])(ChildcareContext["a" /* ChildcareContext */]),
      updateService = _useContext.updateService,
      deleteAttendeeChildcare = _useContext.deleteAttendeeChildcare;

  var router = Object(next_router["useRouter"])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var track = Object(useTracking["a" /* useTracking */])(); // to remove once the comparator is fully migrated to ga4

  var isComparatorView = router.pathname === '/comparator';

  var onClickChildcareButton = function onClickChildcareButton() {
    var _childcare$pricingInf;

    var currentAttendee = (_childcare$pricingInf = childcare.pricingInfo.attendees) === null || _childcare$pricingInf === void 0 ? void 0 : _childcare$pricingInf.find(function (_ref3) {
      var id = _ref3.id;
      return id === childId;
    });

    if (shouldTriggerChildcareAdvancedReservationBlockOnClick) {
      var noRemainingStockAdvanced = currentAttendee === null || currentAttendee === void 0 ? void 0 : currentAttendee.schedules.every(function (_ref4) {
        var timeSlots = _ref4.timeSlots;
        return timeSlots.every(function (_ref5) {
          var remainingStock = _ref5.remainingStock;
          return remainingStock === 0;
        });
      });
      return ChildcareServiceBlock_objectSpread({
        onClick: function onClick() {
          // to remove once the comparator is fully migrated to ga4
          isComparatorView ? track(ChildcareServiceBlock_objectSpread(ChildcareServiceBlock_objectSpread({}, TRACK_ACTION_CART_ADD), {}, {
            labelGA: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
          })) : trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
            detail_click: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
          });
          setChildcareAdvancedBlockOpen();
        }
      }, noRemainingStockAdvanced && {
        label: Object(i18n["h" /* t */])('booking.services.childcare.childcareFull')
      });
    }

    if (shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick) {
      return ChildcareServiceBlock_objectSpread(ChildcareServiceBlock_objectSpread({
        onClick: function () {
          var _onClick = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            var _currentAttendee$sche, _currentAttendee$sche2, _currentAttendee$sche3;

            var currentAttendeeHasRentedSomeSlot;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    currentAttendeeHasRentedSomeSlot = currentAttendee === null || currentAttendee === void 0 ? void 0 : (_currentAttendee$sche = currentAttendee.schedules) === null || _currentAttendee$sche === void 0 ? void 0 : (_currentAttendee$sche2 = _currentAttendee$sche[0]) === null || _currentAttendee$sche2 === void 0 ? void 0 : (_currentAttendee$sche3 = _currentAttendee$sche2.timeSlots) === null || _currentAttendee$sche3 === void 0 ? void 0 : _currentAttendee$sche3.some(function (_ref6) {
                      var isRented = _ref6.isRented;
                      return isRented;
                    });

                    if (!currentAttendeeHasRentedSomeSlot) {
                      _context.next = 6;
                      break;
                    }

                    _context.next = 4;
                    return deleteAttendeeChildcare({
                      attendeeId: childId || '',
                      pricingInfo: childcare.pricingInfo
                    });

                  case 4:
                    _context.next = 8;
                    break;

                  case 6:
                    // to remove once the comparator is fully migrated to ga4
                    isComparatorView ? track(ChildcareServiceBlock_objectSpread(ChildcareServiceBlock_objectSpread({}, TRACK_ACTION_CART_ADD), {}, {
                      labelGA: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
                    })) : trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
                      detail_click: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
                    });
                    setChildcareMorningAfternoonExclusiveRBOpen();

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onClick() {
            return _onClick.apply(this, arguments);
          }

          return onClick;
        }()
      }, type === 'full' && {
        label: Object(i18n["h" /* t */])('booking.services.childcare.childcareFull')
      }), {}, {
        onClose: setChildcareMorningAfternoonExclusiveRBClosed,
        isLoading: isLoading
      });
    }

    if (onCtaClick) {
      return ChildcareServiceBlock_objectSpread({
        dataCsOverrideId: dataCsOverrideId,
        onClick: function () {
          var _onClick2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
            return regenerator_default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    setIsLoading(true);
                    _context2.next = 3;
                    return onCtaClick();

                  case 3:
                    setIsLoading(false);

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function onClick() {
            return _onClick2.apply(this, arguments);
          }

          return onClick;
        }()
      }, type === 'full' && {
        label: Object(i18n["h" /* t */])('booking.services.childcare.childcareFull')
      });
    }
  };

  var buttonCfg = onClickChildcareButton();

  var onSubmit = /*#__PURE__*/function () {
    var _ref7 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3(updatedService, serviceIds, attendeeIds) {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setIsLoading(true);
              _context3.prev = 1;
              _context3.next = 4;
              return updateService(updatedService, childcare.pricingInfo, serviceIds, attendeeIds);

            case 4:
              _context3.next = 9;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              logger["default"].error(_context3.t0);

            case 9:
              _context3.prev = 9;
              setIsLoading(false);
              return _context3.finish(9);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 6, 9, 12]]);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref7.apply(this, arguments);
    };
  }();

  var openingHoursLabels = ChildcareServiceBlock_jsx(childcare_utils["a" /* DurationSlotsLabels */], {
    timeSlots: childcare.productInfo.timeSlots || [],
    closingWeekdays: childcare.productInfo.closingWeekdays || [] || [],
    isPetitCM: Object(childcare_utils["e" /* isPetitClubMed */])(childcare)
  });

  return ChildcareServiceBlock_jsx("div", {
    className: className,
    "data-testid": dataTestId
  }, ChildcareServiceBlock_jsx("p", {
    className: "text-16",
    "data-testid": "ChildcareServiceBlock-childBirthdateMessage",
    style: {
      minHeight: blockMinHeight
    }
  }, childBirthdateMessage), ChildcareServiceBlock_jsx(ServiceBlock_ServiceBlock, {
    addLabel: Object(i18n["h" /* t */])('booking.services.childcare.addChildcare'),
    attendeeId: childId,
    showOnlyCurrentAttendeeSlots: true,
    button: buttonCfg,
    dataSelector: "Childcare",
    equipment: {
      id: childcare.pricingInfo.id,
      label: childcare.productInfo.label,
      longDescription: childcare.productInfo.description
    },
    header: {
      color: isIncluded ? '#1E2643' : '#924833',
      header: 'large',
      icon: isIncluded ? icons["a" /* ICONS */].ALL_INCLUSIVE : icons["a" /* ICONS */].ON_DEMAND,
      label: isIncluded ? Object(i18n["h" /* t */])('booking.childcarePopIn.includedChildcare') : Object(i18n["h" /* t */])('booking.childcarePopIn.onDemandChildcare')
    },
    image: childcare.productInfo.images[0],
    includedLabel: Object(i18n["h" /* t */])('common.included'),
    intro: !isIncluded ? Object(i18n["h" /* t */])('booking.services.childcare.babyClubMedReassurance') : undefined,
    isValidated: ['disabled', 'remove', 'full', 'none'].includes(type),
    lastAvailabilities: ChildcareServiceBlock_jsx(ChildcareServiceBlock_LastAvailabilitiesTag, {
      childcare: childcare,
      type: type
    }),
    price: (_childcare$pricingInf2 = childcare.pricingInfo) === null || _childcare$pricingInf2 === void 0 ? void 0 : (_childcare$pricingInf3 = _childcare$pricingInf2.startingPricePerAdult) === null || _childcare$pricingInf3 === void 0 ? void 0 : _childcare$pricingInf3.formattedValue,
    rentedAmount: (_childcare$pricingInf4 = childcare.pricingInfo) === null || _childcare$pricingInf4 === void 0 ? void 0 : (_childcare$pricingInf5 = _childcare$pricingInf4.attendees) === null || _childcare$pricingInf5 === void 0 ? void 0 : (_childcare$pricingInf6 = _childcare$pricingInf5.find(function (_ref8) {
      var id = _ref8.id;
      return id === childId;
    })) === null || _childcare$pricingInf6 === void 0 ? void 0 : _childcare$pricingInf6.rentedAmount.formattedValue,
    removeLabel: Object(i18n["h" /* t */])('booking.services.childcare.removeChildcare'),
    slots: [{
      disclaimer: Object(i18n["h" /* t */])('booking.services.childcare.openingDisclaimer'),
      icon: icons["a" /* ICONS */].DURATION,
      label: openingHoursLabels,
      key: 'duration-description'
    }, {
      icon: icons["a" /* ICONS */].DATE_STAR,
      label: Object(product_utils["f" /* getServiceAgesLabel */])(childcare.productInfo.ageInMonths),
      key: 'date-star'
    }].filter(function (slot) {
      return slot.label;
    }),
    type: type,
    urgentisation: childcare.productInfo.isIncluded || childcare.pricingInfo.isFullyPaid ? undefined : ChildcareServiceBlock_jsx(UrgentisationChildcareBlock_UrgentisationChildcareBlock, {
      childcare: childcare,
      type: type,
      isByDayChildcare: shouldTriggerChildcareAdvancedReservationBlockOnClick,
      isFullStayHalfDayChildcare: shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick
    })
  }), ChildcareServiceBlock_jsx("div", null, childcare && isChildcareAdvancedReservationBlockOpen && ChildcareServiceBlock_jsx(PopInReservationBlock["a" /* PopInReservationBlock */], {
    attendeeId: childId,
    showOnlyCurrentAttendeeSlots: true,
    headerLabel: (_childcare$productInf = childcare.productInfo) === null || _childcare$productInf === void 0 ? void 0 : _childcare$productInf.label,
    introductionLabel: Object(i18n["h" /* t */])('booking.activities.childcare.chooseWhen'),
    onClose: setChildcareBlockAdvancedClosed,
    onSubmit: onSubmit,
    rentButtonLabel: Object(i18n["h" /* t */])('booking.common.addPrice'),
    service: childcare.pricingInfo
  })), ChildcareServiceBlock_jsx("div", null, childcare && isChildcareMorningAfternoonExclusiveRBOpen && ChildcareServiceBlock_jsx(PopInReservationBlockMorningAfternoonExclusive["a" /* PopInReservationBlockMorningAfternoonExclusive */], {
    slots: childcare.pricingInfo.schedules[0].slots,
    headerLabel: (_childcare$productInf2 = childcare.productInfo) === null || _childcare$productInf2 === void 0 ? void 0 : _childcare$productInf2.label,
    onClose: setChildcareMorningAfternoonExclusiveRBClosed,
    service: childcare.pricingInfo
  })));
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/childcare.helper.js
var childcare_helper = __webpack_require__("YVWi");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare/Childcare.jsx













var Childcare_jsx = react_default.a.createElement;

function Childcare_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Childcare_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Childcare_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Childcare_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var Childcare_getBlockMinHeight = function getBlockMinHeight(wrapper) {
  if (!wrapper) {
    return 0;
  }

  var nodeHeightsList = Object(toConsumableArray["a" /* default */])(wrapper.querySelectorAll('[data-testid="ChildcareServiceBlock-childBirthdateMessage"]')).map(function (node) {
    return node.clientHeight || 0;
  });

  return Math.max.apply(Math, Object(toConsumableArray["a" /* default */])(nodeHeightsList));
};

var Childcare_handleClick = function handleClick(_ref) {
  var _childcare$pricingInf, _childcare$pricingInf2, _childcare$pricingInf5;

  var proposals = _ref.proposals,
      childcare = _ref.childcare,
      addChildcare = _ref.addChildcare,
      deleteChildcare = _ref.deleteChildcare,
      trackClickEvent = _ref.trackClickEvent,
      ga3Track = _ref.ga3Track,
      isComparatorView = _ref.isComparatorView;
  // this triggers only when there is only one schedule and one slot
  // if looking for advanced cases check the contextchildcare
  var overloadChildcareIdForChalet = proposals && Object(childcare_helper["e" /* getOverloadChildcareDataForChalet */])({
    proposals: proposals,
    currentChildcareId: childcare.pricingInfo.schedules[0].slots[0].id,
    currentChildId: childcare.pricingInfo.childId || ''
  });
  var currentAttendeeHasRentedChildcare = ((_childcare$pricingInf = childcare.pricingInfo.attendees.find(function (_ref2) {
    var _childcare$pricingInf3;

    var id = _ref2.id;
    return id === ((_childcare$pricingInf3 = childcare.pricingInfo) === null || _childcare$pricingInf3 === void 0 ? void 0 : _childcare$pricingInf3.childId);
  } // $FlowFixMe : always int and found
  )) === null || _childcare$pricingInf === void 0 ? void 0 : (_childcare$pricingInf2 = _childcare$pricingInf.rentedAmount) === null || _childcare$pricingInf2 === void 0 ? void 0 : _childcare$pricingInf2.value) > 0;

  if (currentAttendeeHasRentedChildcare) {
    var _childcare$pricingInf4;

    isComparatorView ? ga3Track(Childcare_objectSpread(Childcare_objectSpread({}, TRACK_ACTION_CART_REMOVE), {}, {
      labelGA: constants["f" /* CHILDCARE_TRACKING */].REMOVE_CHILDCARE
    })) : trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
      detail_click: constants["f" /* CHILDCARE_TRACKING */].REMOVE_CHILDCARE
    });
    return deleteChildcare({
      childcareId: childcare.pricingInfo.progId || '',
      attendeeId: ((_childcare$pricingInf4 = childcare.pricingInfo) === null || _childcare$pricingInf4 === void 0 ? void 0 : _childcare$pricingInf4.childId) || '',
      startDate: childcare.pricingInfo.schedules[0].startDate,
      endDate: childcare.pricingInfo.schedules[0].startDate,
      overloadChildcareIdForChalet: overloadChildcareIdForChalet
    });
  }

  isComparatorView ? ga3Track(Childcare_objectSpread(Childcare_objectSpread({}, TRACK_ACTION_CART_ADD), {}, {
    labelGA: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
  })) : trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
    detail_click: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
  }); // Those are regular childcares only one schedule and no slots

  return addChildcare({
    childcareId: childcare.pricingInfo.progId || '',
    attendeeId: ((_childcare$pricingInf5 = childcare.pricingInfo) === null || _childcare$pricingInf5 === void 0 ? void 0 : _childcare$pricingInf5.childId) || '',
    startDate: childcare.pricingInfo.schedules[0].startDate,
    endDate: childcare.pricingInfo.schedules[0].endDate,
    overloadChildcareIdForChalet: overloadChildcareIdForChalet
  });
};

var Childcare_Childcare = function Childcare(_ref3) {
  var addChildcare = _ref3.addChildcare,
      attendees = _ref3.attendees,
      childcareAdditionalServices = _ref3.childcareAdditionalServices,
      deleteChildcare = _ref3.deleteChildcare,
      _ref3$isCartLocked = _ref3.isCartLocked,
      isCartLocked = _ref3$isCartLocked === void 0 ? false : _ref3$isCartLocked,
      isCondensed = _ref3.isCondensed,
      proposals = _ref3.proposals,
      _ref3$shouldTrack = _ref3.shouldTrack,
      shouldTrack = _ref3$shouldTrack === void 0 ? true : _ref3$shouldTrack;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var includedBlocks = Object(react["useRef"])();
  var notIncludedBlocks = Object(react["useRef"])();

  var _useState = Object(react["useState"])(0),
      includedMinHeight = _useState[0],
      setIncludedMinHeight = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      notIncludedMinHeight = _useState2[0],
      setNotIncludedMinHeight = _useState2[1];

  var router = Object(next_router["useRouter"])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var ga3Track = Object(useTracking["a" /* useTracking */])();
  var isComparatorView = router.pathname === '/comparator';
  Object(react["useEffect"])(function () {
    setIncludedMinHeight(Childcare_getBlockMinHeight(includedBlocks.current));
    setNotIncludedMinHeight(Childcare_getBlockMinHeight(notIncludedBlocks.current));
  });

  var _includedAndNotInclud = Object(childcare_helper["g" /* includedAndNotIncludedChildcares */])(childcareAdditionalServices),
      includedChildcares = _includedAndNotInclud.includedChildcares,
      notIncludedChildcares = _includedAndNotInclud.notIncludedChildcares;

  if (attendees.length === 0) {
    return null;
  }

  var getChildBirthDateMessage = function getChildBirthDateMessage(childAttendeeId) {
    if (!childAttendeeId) {
      return '';
    }

    var currentKid = Object(childcare_helper["b" /* getCurrentChild */])(attendees, childAttendeeId);

    if (currentKid && currentKid.firstName && currentKid.lastName) {
      return Object(i18n["h" /* t */])('booking.services.childcare.firstnameLastnameBornOn', {
        lastName: currentKid.lastName,
        firstName: currentKid.firstName,
        birthdate: Object(childcare_helper["d" /* getFormatDate */])(currentKid, Object(i18n["h" /* t */])('common.dateFormatTechnicalID'))
      });
    }

    return Object(i18n["h" /* t */])('booking.services.childcare.forWhatKid', {
      birthdate: Object(childcare_helper["d" /* getFormatDate */])(currentKid, Object(i18n["h" /* t */])('common.dateFormatTechnicalID'))
    });
  };

  return Childcare_jsx("div", {
    "data-testid": "PackageChildcare"
  }, childcareAdditionalServices.length === 0 ? Childcare_jsx(Notification["a" /* Notification */], {
    className: "text-orange",
    text: Object(i18n["h" /* t */])('booking.form.warnings.noChildcareMessage')
  }) : Childcare_jsx("div", null, Childcare_jsx(Title["a" /* Title */], {
    className: "mb-10 w-full md:whitespace-nowrap",
    theme: "title-brand-n2"
  }, Object(i18n["h" /* t */])('booking.services.childcare.childcareTitle', {
    number: childcareAdditionalServices.length
  })), !!notIncludedChildcares.length && Childcare_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('-mx-10 flex flex-wrap', {
      'mb-20': !isDesktop,
      'mb-80': isDesktop
    }),
    ref: notIncludedBlocks
  }, notIncludedChildcares.sort(function (childcareEl, nextChildcareEl) {
    var _childcareEl$pricingI, _nextChildcareEl$pric;

    return (// $FlowFixMe : always found
      ((_childcareEl$pricingI = childcareEl.pricingInfo) === null || _childcareEl$pricingI === void 0 ? void 0 : _childcareEl$pricingI.childId) > ((_nextChildcareEl$pric = nextChildcareEl.pricingInfo) === null || _nextChildcareEl$pric === void 0 ? void 0 : _nextChildcareEl$pric.childId)
    );
  }).map(function (childcare, index) {
    var _childcare$pricingInf6, _childcare$pricingInf7, _childcare$pricingInf8;

    var childId = childcare.pricingInfo.childId;
    var childcareCta = Object(childcare_helper["a" /* getCtaTypeChildcare */])(childcare);
    var shouldTriggerChildcareAdvancedReservationBlockOnClick = ((_childcare$pricingInf6 = childcare.pricingInfo.schedules) === null || _childcare$pricingInf6 === void 0 ? void 0 : _childcare$pricingInf6.length) > 1;
    var shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick = ((_childcare$pricingInf7 = childcare.pricingInfo.schedules) === null || _childcare$pricingInf7 === void 0 ? void 0 : _childcare$pricingInf7.length) === 1 && ((_childcare$pricingInf8 = childcare.pricingInfo.schedules[0].slots) === null || _childcare$pricingInf8 === void 0 ? void 0 : _childcare$pricingInf8.length) >= 1 && childcare.pricingInfo.schedules[0].slots.length <= 3 && childcare.pricingInfo.schedules[0].slots.some(function (_ref4) {
      var type = _ref4.type;
      return type === 'MORNING' || type === 'AFTERNOON';
    }); // one schedule on slot ( the classic case )

    var isSimpleChildcare = !shouldTriggerChildcareAdvancedReservationBlockOnClick && !shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick; // When cart is locked, force disabled type and skip click handlers

    var effectiveType = isCartLocked ? 'disabled' : childcareCta.type;
    var effectiveOnCtaClick = isCartLocked ? undefined : function () {
      return Childcare_handleClick({
        proposals: proposals,
        childcare: childcare,
        addChildcare: addChildcare,
        deleteChildcare: deleteChildcare,
        trackClickEvent: trackClickEvent,
        isComparatorView: isComparatorView,
        ga3Track: ga3Track
      });
    };
    return Childcare_jsx(ChildcareServiceBlock_ChildcareServiceBlock, {
      blockMinHeight: notIncludedMinHeight,
      childId: childId,
      childBirthdateMessage: getChildBirthDateMessage(childId),
      childcare: childcare,
      className: Object(classnames_utils["a" /* classnames */])('w-full p-10', {
        'sm:w-1/2 md:w-1/3': !isCondensed
      }),
      dataCsOverrideId: "Childcare-".concat(index),
      dataTestId: "childcare-block",
      isIncluded: false,
      key: childId,
      onCtaClick: effectiveOnCtaClick,
      shouldTriggerChildcareAdvancedReservationBlockOnClick: isCartLocked ? false : shouldTriggerChildcareAdvancedReservationBlockOnClick,
      shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick: isCartLocked ? false : shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick,
      shouldTrack: shouldTrack && isSimpleChildcare,
      trackingType: childcareCta.tracking,
      type: effectiveType
    });
  })), !!includedChildcares.length && Childcare_jsx("div", {
    className: "-mx-10 flex flex-wrap",
    ref: includedBlocks
  }, includedChildcares.map(function (childcare, index) {
    return Childcare_jsx(ChildcareServiceBlock_ChildcareServiceBlock, {
      blockMinHeight: includedMinHeight,
      childBirthdateMessage: getChildBirthDateMessage(childcare.pricingInfo.childId),
      childcare: childcare,
      childId: childcare.pricingInfo.childId,
      className: Object(classnames_utils["a" /* classnames */])('w-full p-10', {
        'sm:w-1/2 md:w-1/3': !isCondensed
      }),
      dataCsOverrideId: "Childcare-".concat(index),
      dataTestId: "childcare-block",
      isIncluded: true,
      key: childcare.pricingInfo.childId,
      shouldTrack: shouldTrack,
      type: "disabled"
    });
  }))));
};

/***/ }),

/***/ "CYED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiscountsLine; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);



var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;





var OFFERS = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].OFFERS;
var DiscountsLine = function DiscountsLine(_ref) {
  var discounts = _ref.discounts;

  if (!(discounts === null || discounts === void 0 ? void 0 : discounts.length)) {
    return null;
  }

  return __jsx("div", {
    className: "my-10"
  }, discounts.map(function (discount) {
    var _discount$currentProp, _discount$currentProp2, _discount$currentProp3;

    return __jsx("div", {
      className: "mb-20 rounded-12 border-1 border-success bg-white p-20",
      key: discount.offerId
    }, __jsx("div", {
      className: "flex w-full justify-between"
    }, __jsx("div", {
      className: "flex w-2/3 md:gap-10"
    }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
      name: discount.offerId !== OFFERS.PROMO_CODE ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].PROMOTION : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].PROMO_CODE,
      width: "1.875rem"
    }), __jsx("div", {
      className: "flex flex-col"
    }, __jsx("p", {
      className: "mb-0 font-bold leading-normal",
      style: {
        color: discount.offerColor
      }
    }, discount.offerId !== 'AVA' ? Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.summary.discount.discountLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.summary.discount.discountCodeLabel')), __jsx("p", {
      className: "mb-0 leading-tight"
    }, ((_discount$currentProp = discount.currentProposalCode) === null || _discount$currentProp === void 0 ? void 0 : _discount$currentProp.label) || discount.offerLabel), ((_discount$currentProp2 = discount.currentProposalCode) === null || _discount$currentProp2 === void 0 ? void 0 : _discount$currentProp2.description) || discount.offerDescription && __jsx("p", {
      className: "mb-0 leading-tight"
    }, ((_discount$currentProp3 = discount.currentProposalCode) === null || _discount$currentProp3 === void 0 ? void 0 : _discount$currentProp3.description) || discount.offerDescription))), __jsx("div", null, __jsx("p", {
      className: "text-14 font-bold text-success",
      style: {
        color: discount.offerColor
      }
    }, "- ", discount.amount.formattedValue))));
  }));
};

/***/ }),

/***/ "CgxS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__("qW1w");

const bignum = __webpack_require__("nXZ9");
const DecoderBuffer = __webpack_require__("cVzJ").DecoderBuffer;
const Node = __webpack_require__("4v7C");

// Import DER constants
const der = __webpack_require__("vqf+");

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!DecoderBuffer.isDecoderBuffer(data)) {
    data = new DecoderBuffer(data, options);
  }

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  const state = buffer.save();
  const decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  const decodedTag = derDecodeTag(buffer,
    'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  let len = derDecodeLen(buffer,
    decodedTag.primitive,
    'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  const state = buffer.save();
  const res = this._skipUntilEnd(
    buffer,
    'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  for (;;) {
    const tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    const len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    let res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len);
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
  options) {
  const result = [];
  while (!buffer.isEmpty()) {
    const possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    const res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    const unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    const raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    let str = '';
    for (let i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    const numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    const printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  let result;
  const identifiers = [];
  let ident = 0;
  let subident = 0;
  while (!buffer.isEmpty()) {
    subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  const first = (identifiers[0] / 40) | 0;
  const second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    let tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  const str = buffer.raw().toString();

  let year;
  let mon;
  let day;
  let hour;
  let min;
  let sec;
  if (tag === 'gentime') {
    year = str.slice(0, 4) | 0;
    mon = str.slice(4, 6) | 0;
    day = str.slice(6, 8) | 0;
    hour = str.slice(8, 10) | 0;
    min = str.slice(10, 12) | 0;
    sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    year = str.slice(0, 2) | 0;
    mon = str.slice(2, 4) | 0;
    day = str.slice(4, 6) | 0;
    hour = str.slice(6, 8) | 0;
    min = str.slice(8, 10) | 0;
    sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull() {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  const res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  const raw = buffer.raw();
  let res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  let tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  const cls = der.tagClass[tag >> 6];
  const primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    let oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  const tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  let len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  const num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (let i = 0; i < num; i++) {
    len <<= 8;
    const j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),

/***/ "ChVH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("nXZ9");
var utils = __webpack_require__("EmIl");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength),
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),

/***/ "CwJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterAccommodations; });
/* unused harmony export sortAccommodations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterReducedMobilityAccomodation; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("OOYD");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_reject__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("u6DZ");
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("lZ21");

















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



function sortAccommodations(accommodationsSets) {
  return lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default()(accommodationsSets, function (set) {
    // sort accommodations by comfort level: Standard, Deluxe, Suite
    return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_16__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(set, 'accommodations[0].categoryId'));
  }).map(function (set, index) {
    // accommodationSetNumber was set to index + 1 in accommodationsSetsReducer
    // need to be updated after filtering & sorting
    return _objectSpread(_objectSpread({}, set), {}, {
      accommodationSetNumber: index + 1
    });
  });
}

function filterAccommodations(proposal, accommodationsSets) {
  var proposalAccommodations = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(proposal, 'accommodations', []); // remove additional accommodation if already exists in selected proposal


  var filteredAccommodations = lodash_reject__WEBPACK_IMPORTED_MODULE_12___default()(accommodationsSets, function (_ref) {
    var accommodations = _ref.accommodations;
    return lodash_isEqual__WEBPACK_IMPORTED_MODULE_14___default()(accommodations, proposalAccommodations);
  }); // sort additional accommodations by comfort level: Standard, Deluxe, Suite


  return sortAccommodations(filteredAccommodations);
}

function filterReducedMobilityAccomodation(visibility, filteredAccommodations) {
  if (visibility) {
    return filteredAccommodations;
  }

  var pmr = filteredAccommodations.reduce(function (acc, filteredAccommodation) {
    var accommodations = filteredAccommodation.accommodations;

    if (accommodations.filter(function (_ref2) {
      var reducedMobilityAccess = _ref2.reducedMobilityAccess;
      return reducedMobilityAccess === true;
    }).length === 0) {
      return acc.concat(filteredAccommodation);
    }

    return acc;
  }, []);
  return pmr;
}



/***/ }),

/***/ "D+ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__("i+/A")
exports.createHash = exports.Hash = __webpack_require__("Deve")
exports.createHmac = exports.Hmac = __webpack_require__("A8dA")

var algos = __webpack_require__("qvEg")
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__("iRos")
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__("57NP")

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__("/xi0")

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__("cTV+")

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__("NN9k")

var publicEncrypt = __webpack_require__("4Gsp")

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__("TKGf")

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),

/***/ "DROp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onKeyDownDataForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFieldVisibilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isSchemaHasUnicodeFields; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("1IsZ");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("S0cN");
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_camelCase__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("RUiN");
/* harmony import */ var _ContactInfoUtils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("ZHrn");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("05v4");






















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





var onKeyDownDataForm = function onKeyDownDataForm(dataForm) {
  return function (e) {
    if (e.which === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_24__[/* ENTER */ "f"]) {
      var inputs = document.querySelectorAll("[data-form=\"".concat(dataForm, "\"] input, [data-form=\"").concat(dataForm, "\"] select"));

      if (inputs) {
        // $FlowFixMe : flow does not reccognize id key in EventTarget
        var currentIndex = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])(inputs).findIndex(function (i) {
          return i.name === e.target.name;
        });

        if (currentIndex < inputs.length - 1) {
          var selector = inputs[currentIndex + 1].name;
          var next = document.querySelector("[name=\"".concat(selector, "\"]"));

          if (next) {
            next.focus();
            Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_21__[/* scrollToElement */ "a"])("[for=\"".concat(selector, "\"]"), 100);
          }
        }
      }
    }
  };
};
var getFieldVisibilities = function getFieldVisibilities(attendeeSchema, locale, arrivalDate, departureDate) {
  var checkIfVisible = function checkIfVisible(fieldName) {
    return (attendeeSchema || []).map(function (_ref) {
      var name = _ref.name;
      return name;
    }).includes(fieldName);
  };

  var checkIfRequired = function checkIfRequired(fieldName) {
    var _attendeeSchema$find;

    return !!(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : (_attendeeSchema$find = attendeeSchema.find(function (_ref2) {
      var name = _ref2.name;
      return name === fieldName;
    })) === null || _attendeeSchema$find === void 0 ? void 0 : _attendeeSchema$find.required);
  };

  var validators = Object(_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_22__[/* getTravelDocumentsValidators */ "p"])({
    attendeeSchema: attendeeSchema,
    locale: locale,
    arrivalDate: arrivalDate,
    departureDate: departureDate
  });
  var travelDocumentLabelsMap = {
    idcard_document_number: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.id'),
    idcard_expiration_date: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.expirationDate'),
    idcard_issuing_date: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.issuingDate'),
    idcard_authority: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.issuingPlace'),
    idcard_birth_country: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.birthCountry'),
    idcard_birth_city: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.birthCity'),
    idcard_second_name: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.secondName'),
    idcard_third_name: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.thirdName'),
    idcard_fourth_name: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.fourthName'),
    idcard_nationality: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.idcard.nationality'),
    passport_document_number: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.id'),
    passport_expiration_date: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.expirationDate'),
    passport_issuing_date: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.issuingDate'),
    passport_authority: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.issuingPlace'),
    passport_birth_country: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.birthCountry'),
    passport_birth_city: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.birthCity'),
    passport_second_name: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.secondName'),
    passport_third_name: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.thirdName'),
    passport_fourth_name: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.fourthName'),
    passport_nationality: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.passport.nationality'),
    identity_number: Object(_i18n__WEBPACK_IMPORTED_MODULE_23__[/* t */ "h"])('booking.participants.labels.identityNumber')
  };

  var getTypeOfDocument = function getTypeOfDocument(document) {
    return document.split('_')[0];
  };

  var documentFieldsObject = Object.keys(travelDocumentLabelsMap).reduce(function (acc, val) {
    return _objectSpread(_objectSpread({}, acc), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])({}, lodash_camelCase__WEBPACK_IMPORTED_MODULE_20___default()(val), {
      isVisible: checkIfVisible(val),
      isRequired: checkIfRequired(val),
      label: travelDocumentLabelsMap[val],
      type: getTypeOfDocument(val),
      validator: validators[lodash_camelCase__WEBPACK_IMPORTED_MODULE_20___default()(val)]
    }));
  }, {});
  return {
    civilityField: {
      isVisible: checkIfVisible('civility'),
      isRequired: checkIfRequired('civility')
    },
    firstNameField: {
      isVisible: checkIfVisible('first_name'),
      isRequired: checkIfRequired('first_name')
    },
    lastNameField: {
      isVisible: checkIfVisible('last_name'),
      isRequired: checkIfRequired('last_name')
    },
    unicodeFirstNameField: {
      isVisible: checkIfVisible('unicode_first_name'),
      isRequired: checkIfRequired('unicode_first_name')
    },
    unicodeLastNameField: {
      isVisible: checkIfVisible('unicode_last_name'),
      isRequired: checkIfRequired('unicode_last_name')
    },
    emailField: {
      isVisible: checkIfVisible('email'),
      isRequired: checkIfRequired('email')
    },
    birthdateField: {
      isVisible: checkIfVisible('birthdate'),
      isRequired: checkIfRequired('birthdate')
    },
    gmNumberField: {
      isVisible: checkIfVisible('gm_number'),
      isRequired: checkIfRequired('gm_number')
    },
    phonesField: {
      isVisible: checkIfVisible('phones'),
      isRequired: checkIfRequired('phones')
    },
    sanitaryIdField: {
      isVisible: checkIfVisible('health_pass_id'),
      isRequired: checkIfRequired('health_pass_id')
    },
    documentFieldsVisibilities: documentFieldsObject,
    shouldDisplayLegalInfo: !!Object.values(documentFieldsObject).find( // $FlowFixMe
    function (_ref3) {
      var isVisible = _ref3.isVisible;
      return isVisible;
    })
  };
};
var isSchemaHasUnicodeFields = function isSchemaHasUnicodeFields(attendeeSchema) {
  var attendeeSchemaFields = (attendeeSchema || []).map(function (_ref4) {
    var name = _ref4.name;
    return name;
  });
  return attendeeSchemaFields.includes('unicode_first_name') && attendeeSchemaFields.includes('unicode_last_name');
};

/***/ }),

/***/ "DehW":
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__("sPPR")

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),

/***/ "Deve":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("qW1w")
var MD5 = __webpack_require__("8N5j")
var RIPEMD160 = __webpack_require__("//Gm")
var sha = __webpack_require__("guqX")
var Base = __webpack_require__("7IvJ")

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),

/***/ "DhzB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PersonInfoFormContent_PersonInfoFormContent; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 14 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/context/OptinsProvider.js
var OptinsProvider = __webpack_require__("H8tl");

// EXTERNAL MODULE: ./src/utils/use-gql-errors-handler/useGQLErrorsHandler.js
var useGQLErrorsHandler = __webpack_require__("Kl3I");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/client/views/account/profile/ProfileView.queries.js
var ProfileView_queries = __webpack_require__("1XP9");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/hooks/use-country-list/useCountryList.js
var useCountryList = __webpack_require__("IGWl");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/LegalInfo.jsx

var __jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */




var LegalInfo_LegalInfo = function LegalInfo(_ref) {
  var attendeeIdentifier = _ref.attendeeIdentifier,
      dateFormat = _ref.dateFormat,
      dayPlaceholder = _ref.dayPlaceholder,
      documentFieldsVisibilities = _ref.documentFieldsVisibilities,
      monthPlaceholder = _ref.monthPlaceholder,
      onKeyDown = _ref.onKeyDown,
      yearPlaceholder = _ref.yearPlaceholder,
      hideErrorMessage = _ref.hideErrorMessage;
  var nationalitiesByLocale = Object(useCountryList["a" /* useCountryList */])();
  var idcardDocumentNumber = documentFieldsVisibilities.idcardDocumentNumber,
      idcardExpirationDate = documentFieldsVisibilities.idcardExpirationDate,
      idcardIssuingDate = documentFieldsVisibilities.idcardIssuingDate,
      idcardAuthority = documentFieldsVisibilities.idcardAuthority,
      idcardBirthCountry = documentFieldsVisibilities.idcardBirthCountry,
      idcardBirthCity = documentFieldsVisibilities.idcardBirthCity,
      idcardNationality = documentFieldsVisibilities.idcardNationality,
      passportDocumentNumber = documentFieldsVisibilities.passportDocumentNumber,
      passportExpirationDate = documentFieldsVisibilities.passportExpirationDate,
      passportIssuingDate = documentFieldsVisibilities.passportIssuingDate,
      passportAuthority = documentFieldsVisibilities.passportAuthority,
      passportBirthCountry = documentFieldsVisibilities.passportBirthCountry,
      passportBirthCity = documentFieldsVisibilities.passportBirthCity,
      passportNationality = documentFieldsVisibilities.passportNationality,
      identityNumber = documentFieldsVisibilities.identityNumber;

  var renderDocumentNumber = function renderDocumentNumber(documentNumber) {
    return (documentNumber === null || documentNumber === void 0 ? void 0 : documentNumber.isVisible) && __jsx("div", {
      className: "p-10"
    }, __jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "".concat(documentNumber.type, "_documentNumber_input"),
      hideErrorMessage: hideErrorMessage,
      isRequired: documentNumber.isRequired,
      label: documentNumber.label,
      name: "".concat(attendeeIdentifier, ".document.").concat(documentNumber.type, ".documentNumber"),
      onKeyDown: onKeyDown,
      type: "text",
      validate: documentNumber.validator
    }));
  };

  var renderExpirationDate = function renderExpirationDate(expirationDate) {
    return (expirationDate === null || expirationDate === void 0 ? void 0 : expirationDate.isVisible) && __jsx("div", {
      className: "p-10"
    }, __jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "".concat(expirationDate.type, "_expirationDate"),
      dateFormat: dateFormat,
      dayPlaceholder: dayPlaceholder,
      hideErrorMessage: hideErrorMessage,
      isRequired: expirationDate.isRequired,
      label: expirationDate.label,
      monthPlaceholder: monthPlaceholder,
      name: "".concat(attendeeIdentifier, ".document.").concat(expirationDate.type, ".expirationDate"),
      onKeyDown: onKeyDown,
      type: "birthdate",
      validate: expirationDate.validator,
      yearPlaceholder: yearPlaceholder
    }));
  };

  var renderIssuingDate = function renderIssuingDate(issuingDate) {
    return (issuingDate === null || issuingDate === void 0 ? void 0 : issuingDate.isVisible) && __jsx("div", {
      className: "p-10"
    }, __jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "".concat(issuingDate.type, "_issuingDate"),
      dateFormat: dateFormat,
      dayPlaceholder: dayPlaceholder,
      hideErrorMessage: hideErrorMessage,
      isRequired: issuingDate.isRequired,
      label: issuingDate.label,
      monthPlaceholder: monthPlaceholder,
      name: "".concat(attendeeIdentifier, ".document.").concat(issuingDate.type, ".issuingDate"),
      onKeyDown: onKeyDown,
      type: "birthdate",
      validate: issuingDate.validator,
      yearPlaceholder: yearPlaceholder
    }));
  };

  var renderBirthCountry = function renderBirthCountry(birthCountry) {
    return (birthCountry === null || birthCountry === void 0 ? void 0 : birthCountry.isVisible) && __jsx("div", {
      className: "p-10"
    }, __jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "".concat(birthCountry.type, "_birthCountry_input"),
      hideErrorMessage: hideErrorMessage,
      isRequired: birthCountry.isRequired,
      label: birthCountry.label,
      name: "".concat(attendeeIdentifier, ".document.").concat(birthCountry.type, ".birthCountry"),
      onClick: onKeyDown,
      type: "select",
      validate: birthCountry.validator,
      options: nationalitiesByLocale
    }));
  };

  var renderBirthCity = function renderBirthCity(birthCity) {
    return (birthCity === null || birthCity === void 0 ? void 0 : birthCity.isVisible) && __jsx("div", {
      className: "p-10"
    }, __jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "".concat(birthCity.type, "_birthCity_input"),
      hideErrorMessage: hideErrorMessage,
      isRequired: birthCity.isRequired,
      label: birthCity.label,
      name: "".concat(attendeeIdentifier, ".document.").concat(birthCity.type, ".birthCity"),
      onKeyDown: onKeyDown,
      type: "text",
      validate: birthCity.validator
    }));
  };

  var renderAuthority = function renderAuthority(authority) {
    return (authority === null || authority === void 0 ? void 0 : authority.isVisible) && __jsx("div", {
      className: "p-10"
    }, __jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "".concat(authority.type, "_documentIssuingPlace_input"),
      hideErrorMessage: hideErrorMessage,
      isRequired: authority.isRequired,
      label: authority.label,
      name: "".concat(attendeeIdentifier, ".document.").concat(authority.type, ".issuingCountry"),
      onClick: onKeyDown,
      type: "select",
      validate: authority.validator,
      options: nationalitiesByLocale
    }));
  };

  var renderNationality = function renderNationality(nationality) {
    return (nationality === null || nationality === void 0 ? void 0 : nationality.isVisible) && __jsx("div", {
      className: "p-10"
    }, __jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "".concat(nationality.type, "_nationalitiesDropDown"),
      hideErrorMessage: hideErrorMessage,
      isRequired: nationality.isRequired,
      label: nationality.label,
      name: "".concat(attendeeIdentifier, ".document.").concat(nationality.type, ".nationality"),
      onKeyDown: onKeyDown,
      options: nationalitiesByLocale,
      type: "select",
      validate: nationality.validator
    }));
  };

  return __jsx("fieldset", {
    className: "p-10"
  }, renderBirthCity(idcardBirthCity), renderDocumentNumber(idcardDocumentNumber), renderExpirationDate(idcardExpirationDate), renderIssuingDate(idcardIssuingDate), renderBirthCountry(idcardBirthCountry), renderAuthority(idcardAuthority), renderNationality(idcardNationality), renderBirthCity(passportBirthCity), renderDocumentNumber(passportDocumentNumber), renderExpirationDate(passportExpirationDate), renderIssuingDate(passportIssuingDate), renderBirthCountry(passportBirthCountry), renderAuthority(passportAuthority), renderNationality(passportNationality), (identityNumber === null || identityNumber === void 0 ? void 0 : identityNumber.isVisible) && __jsx("div", {
    className: "p-10"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "identityNumber_input",
    hideErrorMessage: hideErrorMessage,
    isRequired: identityNumber.isRequired,
    label: identityNumber.label,
    name: "".concat(attendeeIdentifier, ".identityNumber"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: identityNumber.validator
  }), __jsx(Text["a" /* Text */], {
    className: "mt-10",
    text: identityNumber.label,
    theme: "text-sans-n2"
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/countries/countries.queries.js
var countries_queries = __webpack_require__("Z2BD");

// EXTERNAL MODULE: ./src/client/components/widgets/user-address-form/UserAddressForm.jsx + 1 modules
var UserAddressForm = __webpack_require__("MUzb");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/AdditionalContactInfos.jsx






var AdditionalContactInfos_jsx = react_default.a.createElement;









var AdditionalContactInfos_AdditionalContactInfos = function AdditionalContactInfos(_ref) {
  var _isFeatureFlipped, _isFeatureFlipped2;

  var addressSchema = _ref.addressSchema,
      attendeeIdentifier = _ref.attendeeIdentifier,
      connectedUserInfo = _ref.connectedUserInfo,
      formik = _ref.formik,
      hasAddress = _ref.hasAddress,
      onKeyDown = _ref.onKeyDown,
      validators = _ref.validators,
      isMain = _ref.isMain,
      isChild = _ref.isChild,
      isEmailVisible = _ref.isEmailVisible,
      isEmailRequired = _ref.isEmailRequired,
      isPhonesVisible = _ref.isPhonesVisible,
      isPhonesRequired = _ref.isPhonesRequired,
      _ref$hideErrorMessage = _ref.hideErrorMessage,
      hideErrorMessage = _ref$hideErrorMessage === void 0 ? false : _ref$hideErrorMessage;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var shouldShowPhoneWithSeparatePhoneCodeField = (_isFeatureFlipped = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.participants.phone.showWithSeparatePhoneCodeField')) !== null && _isFeatureFlipped !== void 0 ? _isFeatureFlipped : false;
  var shouldFetchCountriesFromApi = (_isFeatureFlipped2 = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.participants.address.shouldFetchCountryListFromApiCountries')) !== null && _isFeatureFlipped2 !== void 0 ? _isFeatureFlipped2 : false;
  var needsCountriesData = shouldShowPhoneWithSeparatePhoneCodeField || shouldFetchCountriesFromApi;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: Object(countries_queries["a" /* getCountriesQuery */])(),
    queryOptions: {
      cacheFront: {
        key: 'REQUEST_COUNTRIES'
      },
      requestName: 'REQUEST_COUNTRIES'
    },
    cache: true,
    map: function map(res) {
      return res.countries;
    },
    ignore: !needsCountriesData
  }),
      countriesData = _useGQL.data,
      isLoadingCountries = _useGQL.isLoading;

  var phoneCodeOptions = Object(react["useMemo"])(function () {
    if (!countriesData) {
      return [{
        value: '',
        name: '',
        shortName: '',
        countryCode: ''
      }];
    }

    var emptyOption = {
      value: '',
      name: '',
      shortName: '',
      countryCode: ''
    };
    var countryOptions = countriesData.filter(function (country) {
      return country.phoneCode;
    }).map(function (country) {
      return {
        value: country.phoneCode,
        name: "".concat(country.name, " (+").concat(country.phoneCode, ")"),
        shortName: "".concat(country.value, " (+").concat(country.phoneCode, ")"),
        countryCode: country.value
      };
    });
    return [emptyOption].concat(Object(toConsumableArray["a" /* default */])(countryOptions));
  }, [countriesData]);
  return AdditionalContactInfos_jsx(react["Fragment"], null, (isEmailVisible || isPhonesVisible) && AdditionalContactInfos_jsx("fieldset", {
    className: "mt-10 p-10 sm:flex sm:flex-wrap"
  }, isEmailVisible && AdditionalContactInfos_jsx("div", {
    className: "p-10 sm:w-1/2"
  }, AdditionalContactInfos_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: hideErrorMessage,
    isDisabled: Object(ContactInfoUtils["w" /* shouldHideField */])({
      connectedUserInfo: connectedUserInfo,
      fieldName: 'email',
      formInitialValues: formik.initialValues,
      isMain: isMain,
      isChild: isChild
    }),
    isRequired: isEmailRequired,
    label: Object(src_i18n["h" /* t */])('booking.participants.labels.email'),
    name: "".concat(attendeeIdentifier, ".email"),
    onKeyDown: onKeyDown,
    type: "email",
    validate: isEmailRequired ? validators.email : validators.emailNotRequired
  })), isPhonesVisible && (!shouldShowPhoneWithSeparatePhoneCodeField || !countriesData || isLoadingCountries) && AdditionalContactInfos_jsx("div", {
    className: "p-10 sm:w-1/2"
  }, AdditionalContactInfos_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: hideErrorMessage,
    isDisabled: Object(ContactInfoUtils["w" /* shouldHideField */])({
      connectedUserInfo: connectedUserInfo,
      fieldName: 'mobile',
      fieldNameConnectedUserOverride: 'mobilePhoneNumber',
      isMain: isMain,
      isChild: isChild
    }) || isLoadingCountries,
    isRequired: isPhonesRequired,
    label: Object(src_i18n["h" /* t */])('booking.participants.labels.phone'),
    name: "".concat(attendeeIdentifier, ".mobile"),
    onKeyDown: onKeyDown,
    type: "tel",
    validate: isPhonesRequired ? validators.mobile : validators.mobileNotRequired
  }))), isPhonesVisible && shouldShowPhoneWithSeparatePhoneCodeField && countriesData && !isLoadingCountries && AdditionalContactInfos_jsx("fieldset", {
    className: "mt-10 p-10 sm:flex sm:flex-wrap"
  }, AdditionalContactInfos_jsx("div", {
    className: "p-10"
  }, AdditionalContactInfos_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: hideErrorMessage,
    isDisabled: Object(ContactInfoUtils["w" /* shouldHideField */])({
      connectedUserInfo: connectedUserInfo,
      fieldName: 'mobile',
      fieldNameConnectedUserOverride: 'mobilePhoneNumber',
      isMain: isMain,
      isChild: isChild
    }),
    isRequired: isPhonesRequired,
    name: "".concat(attendeeIdentifier, ".mobile"),
    onKeyDown: onKeyDown,
    type: "telWithCode",
    phoneCodeFieldName: "".concat(attendeeIdentifier, ".mobileCode"),
    phoneCodeLabel: Object(src_i18n["h" /* t */])('common.participants.address.countryCode'),
    countryFieldName: hasAddress ? "".concat(attendeeIdentifier, ".address.countryCode") : undefined,
    phoneCodeOptions: phoneCodeOptions,
    phoneCodePlaceholder: "",
    label: Object(src_i18n["h" /* t */])('booking.participants.labels.phone'),
    validate: isPhonesRequired ? validators.mobile : validators.mobileNotRequired
  }))), isMain && !isChild && hasAddress && AdditionalContactInfos_jsx("fieldset", {
    className: "mt-10 p-10 sm:flex sm:flex-wrap"
  }, AdditionalContactInfos_jsx(UserAddressForm["a" /* UserAddressForm */], {
    fields: addressSchema,
    fieldsValues: get_default()(formik, "values.".concat(attendeeIdentifier, ".address")),
    hideErrorMessage: hideErrorMessage,
    namePrefix: "".concat(attendeeIdentifier, ".address."),
    onKeyDown: onKeyDown,
    validators: validators.address,
    fetchCountriesFromApi: shouldFetchCountriesFromApi,
    countriesData: countriesData || undefined,
    isLoadingCountries: isLoadingCountries
  })));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/Subscriptions.jsx




var Subscriptions_jsx = react_default.a.createElement;






var Subscriptions_Subscriptions = function Subscriptions(_ref) {
  var attendeeIdentifier = _ref.attendeeIdentifier,
      formik = _ref.formik,
      i18n = _ref.i18n,
      isSeller = _ref.isSeller;
  var optins = Object(ContactInfoUtils["m" /* getOptinsInfos */])(i18n.bookingProcess);
  var showOptinEmail = get_default()(formik.values, "".concat(attendeeIdentifier, ".optinEmail")) !== undefined;
  var showOptinSms = get_default()(formik.values, "".concat(attendeeIdentifier, ".optinSms")) !== undefined;
  var showOptinMail = get_default()(formik.values, "".concat(attendeeIdentifier, ".optinMail")) !== undefined;
  var showOptinFosun = get_default()(formik.values, "".concat(attendeeIdentifier, ".optinFosun")) !== undefined;
  var showOptinPhone = get_default()(formik.values, "".concat(attendeeIdentifier, ".optinPhone")) !== undefined;
  var showOptinClubmedPlus = get_default()(formik.values, "".concat(attendeeIdentifier, ".optinClubmedPlus")) !== undefined;
  var subscriptionTitle = isSeller ? Object(src_i18n["h" /* t */])('booking.partners.participants.subscription.title') : Object(src_i18n["h" /* t */])('booking.participants.subscription.title');

  if (!showOptinEmail && !showOptinSms && !showOptinMail && !showOptinFosun && !showOptinPhone && !showOptinClubmedPlus) {
    return null;
  }

  return Subscriptions_jsx("fieldset", {
    className: "mt-10 p-10 py-15",
    "data-testid": "participant-form-optionout"
  }, Subscriptions_jsx("div", {
    className: "px-10 py-5 font-bold"
  }, subscriptionTitle), showOptinEmail && optins.email && Subscriptions_jsx("div", {
    className: "px-10 py-5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLACK,
    iconName: icons["a" /* ICONS */].INTERNET,
    label: optins.email.label,
    name: "".concat(attendeeIdentifier, ".optinEmail"),
    type: "checkbox"
  })), showOptinPhone && optins.phone && Subscriptions_jsx("div", {
    className: "px-10 py-5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLACK,
    iconName: icons["a" /* ICONS */].PHONE,
    label: optins.phone.label,
    name: "".concat(attendeeIdentifier, ".optinPhone"),
    type: "checkbox"
  })), showOptinSms && optins.sms && Subscriptions_jsx("div", {
    className: "px-10 py-5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLACK,
    iconName: icons["a" /* ICONS */].PHONE,
    label: optins.sms.label,
    name: "".concat(attendeeIdentifier, ".optinSms"),
    type: "checkbox"
  })), showOptinMail && optins.mail && Subscriptions_jsx("div", {
    className: "px-10 py-5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLACK,
    iconName: icons["a" /* ICONS */].MAIL,
    label: optins.mail.label,
    name: "".concat(attendeeIdentifier, ".optinMail"),
    type: "checkbox"
  })), showOptinFosun && optins.fosun && Subscriptions_jsx("div", {
    className: "px-10 py-5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLACK,
    label: optins.fosun.label,
    name: "".concat(attendeeIdentifier, ".optinFosun"),
    type: "checkbox"
  })), showOptinClubmedPlus && optins.clubmedPlus && Subscriptions_jsx("div", {
    className: "px-10 py-5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].SAND,
    iconName: icons["a" /* ICONS */].CLUBMED_PLUS,
    label: optins.clubmedPlus.label,
    name: "".concat(attendeeIdentifier, ".optinClubmedPlus"),
    type: "checkbox"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/UnicodeFields.jsx
var UnicodeFields_jsx = react_default.a.createElement;






var UnicodeFields_UnicodeFields = function UnicodeFields(_ref) {
  var attendeeIdentifier = _ref.attendeeIdentifier,
      connectedUserInfo = _ref.connectedUserInfo,
      onKeyDown = _ref.onKeyDown,
      validators = _ref.validators,
      isUnicodeFirstNameVisible = _ref.isUnicodeFirstNameVisible,
      isUnicodeFirstNameRequired = _ref.isUnicodeFirstNameRequired,
      isUnicodeLastNameVisible = _ref.isUnicodeLastNameVisible,
      isUnicodeLastNameRequired = _ref.isUnicodeLastNameRequired,
      hideErrorMessage = _ref.hideErrorMessage,
      isMain = _ref.isMain,
      isChild = _ref.isChild;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isLastnameFirst = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.lastnameFirst');

  var unicodeFirstNameInputs = UnicodeFields_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: hideErrorMessage,
    isDisabled: Object(ContactInfoUtils["w" /* shouldHideField */])({
      connectedUserInfo: connectedUserInfo,
      fieldName: 'unicodeFirstName',
      isMain: isMain,
      isChild: isChild
    }),
    isRequired: isUnicodeFirstNameRequired,
    label: Object(src_i18n["h" /* t */])('booking.participants.labels.unicodeFirstName'),
    name: "".concat(attendeeIdentifier, ".unicodeFirstName"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.unicodeFirstName
  });

  var unicodeLastNameInputs = UnicodeFields_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: hideErrorMessage,
    isDisabled: Object(ContactInfoUtils["w" /* shouldHideField */])({
      connectedUserInfo: connectedUserInfo,
      fieldName: 'unicodeLastName',
      isMain: isMain,
      isChild: isChild
    }),
    isRequired: isUnicodeLastNameRequired,
    label: Object(src_i18n["h" /* t */])('booking.participants.labels.unicodeLastName'),
    name: "".concat(attendeeIdentifier, ".unicodeLastName"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.unicodeLastName
  });

  return UnicodeFields_jsx(react["Fragment"], null, (isLastnameFirst ? isUnicodeLastNameVisible : isUnicodeFirstNameVisible) && UnicodeFields_jsx("div", {
    className: "p-10 sm:w-1/2"
  }, isLastnameFirst ? unicodeLastNameInputs : unicodeFirstNameInputs), (isLastnameFirst ? isUnicodeFirstNameVisible : isUnicodeLastNameVisible) && UnicodeFields_jsx("div", {
    className: "p-10 sm:w-1/2"
  }, isLastnameFirst ? unicodeFirstNameInputs : unicodeLastNameInputs));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/capitalize.js
var capitalize = __webpack_require__("h++M");
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/RadioGroup.jsx
var RadioGroup = __webpack_require__("eMTQ");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineContext.js
var BookingEngineContext = __webpack_require__("EEyx");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/CivilityInputBlock.jsx











var CivilityInputBlock_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var CivilityInputBlock_CivilityInputBlock = function CivilityInputBlock(_ref) {
  var _beEngineContext$curr;

  var attendeeIdentifier = _ref.attendeeIdentifier,
      childCivilities = _ref.childCivilities,
      adultCivilities = _ref.adultCivilities,
      isChild = _ref.isChild,
      validators = _ref.validators,
      hideErrorMessage = _ref.hideErrorMessage,
      isDisabled = _ref.isDisabled;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var beEngineContext = Object(react["useContext"])(BookingEngineContext["a" /* BookingEngineContext */]);
  var displayParticipantsSelectInput = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayCivilityDropdown') && (beEngineContext === null || beEngineContext === void 0 ? void 0 : (_beEngineContext$curr = beEngineContext.currentStep) === null || _beEngineContext$curr === void 0 ? void 0 : _beEngineContext$curr.name) === 'participants';
  return displayParticipantsSelectInput ? CivilityInputBlock_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "participantsSelectInput",
    className: "p-10 sm:w-2/3",
    hideErrorMessage: hideErrorMessage,
    isRequired: true,
    label: capitalize_default()(Object(src_i18n["h" /* t */])('booking.participants.labels.civility')),
    type: "select",
    name: "".concat(attendeeIdentifier, ".civility"),
    placeholder: capitalize_default()(Object(src_i18n["h" /* t */])('booking.participants.labels.civility')),
    options: (isChild ? childCivilities : adultCivilities).map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        name: option.label
      });
    }),
    validate: isChild ? validators.childCivilities : validators.adultCivilities,
    isDisabled: isDisabled
  }) : // $FlowFixMe set the optionsIsDisabledRadio
  CivilityInputBlock_jsx(RadioGroup["a" /* RadioGroup */], {
    className: "p-10 sm:w-2/3",
    isRequired: true,
    name: "".concat(attendeeIdentifier, ".civility"),
    options: isChild ? childCivilities : adultCivilities,
    validate: isChild ? validators.childCivilities : validators.adultCivilities,
    hideErrorMessage: hideErrorMessage,
    isDisabled: isDisabled
  });
};
// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfoUtils.js
var PersonInfoUtils = __webpack_require__("DROp");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfoFormContent.jsx














var PersonInfoFormContent_jsx = react_default.a.createElement;

function PersonInfoFormContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PersonInfoFormContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PersonInfoFormContent_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PersonInfoFormContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable clubmed/no-fake-component */




















var PersonInfoFormContent_PersonInfoFormContent = function PersonInfoFormContent(_ref) {
  var _formik$values, _formik$values$, _formik$values$$adult;

  var arrivalDate = _ref.arrivalDate,
      addressSchema = _ref.addressSchema,
      attendeeSchema = _ref.attendeeSchema,
      attendeeIdentifier = _ref.attendeeIdentifier,
      connectedUserInfo = _ref.connectedUserInfo,
      hasAddress = _ref.hasAddress,
      i18n = _ref.i18n,
      id = _ref.id,
      isChild = _ref.isChild,
      isMain = _ref.isMain,
      hideErrorMessage = _ref.hideErrorMessage,
      isDisabled = _ref.isDisabled;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var optinsContext = Object(react["useContext"])(OptinsProvider["a" /* OptinsContext */]);
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var isUserLogged = appContext.isUserLogged;
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["i" /* getCurrentProposal */]);
  var isLastnameFirst = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.lastnameFirst');

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: Object(ProfileView_queries["b" /* getCivilitiesQuery */])(),
    queryOptions: {
      cacheFront: {
        key: 'REQUEST_CIVILITIES'
      },
      requestName: 'REQUEST_CIVILITIES',
      locale: connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.locale
    },
    cache: false,
    map: function map(res) {
      return res.civilities;
    }
  }),
      civilitiesData = _useGQL.data,
      civilitiesError = _useGQL.error;

  Object(useGQLErrorsHandler["a" /* useGQLErrorsHandler */])(civilitiesError, {
    catchAuthError: true
  }); // $FlowFixMe

  var adultCivilities = Object(ContactInfoUtils["e" /* getAdultCivilities */])(civilitiesData === null || civilitiesData === void 0 ? void 0 : civilitiesData.adult, appContext.locale);
  var childCivilities = Object(ContactInfoUtils["g" /* getChildCivilities */])(civilitiesData === null || civilitiesData === void 0 ? void 0 : civilitiesData.child, appContext.locale);
  var validators = Object(react["useMemo"])(function () {
    return Object(ContactInfoUtils["q" /* getValidators */])({
      arrivalDate: arrivalDate,
      attendeeSchema: attendeeSchema,
      addressSchema: addressSchema,
      locale: appContext.locale,
      adultCivilities: adultCivilities.map(function (_ref2) {
        var value = _ref2.value;
        return value;
      }),
      childCivilities: childCivilities.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      })
    });
  }, [attendeeSchema, adultCivilities, childCivilities]);

  var _getFieldVisibilities = Object(PersonInfoUtils["a" /* getFieldVisibilities */])(attendeeSchema, appContext.locale, arrivalDate, selectedProposal.departureDate),
      civilityField = _getFieldVisibilities.civilityField,
      firstNameField = _getFieldVisibilities.firstNameField,
      lastNameField = _getFieldVisibilities.lastNameField,
      unicodeFirstNameField = _getFieldVisibilities.unicodeFirstNameField,
      unicodeLastNameField = _getFieldVisibilities.unicodeLastNameField,
      emailField = _getFieldVisibilities.emailField,
      birthdateField = _getFieldVisibilities.birthdateField,
      phonesField = _getFieldVisibilities.phonesField,
      sanitaryIdField = _getFieldVisibilities.sanitaryIdField,
      documentFieldsVisibilities = _getFieldVisibilities.documentFieldsVisibilities,
      shouldDisplayLegalInfo = _getFieldVisibilities.shouldDisplayLegalInfo;

  var adult = (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : (_formik$values$ = _formik$values[0]) === null || _formik$values$ === void 0 ? void 0 : (_formik$values$$adult = _formik$values$.adults) === null || _formik$values$$adult === void 0 ? void 0 : _formik$values$$adult[0];
  Object(react["useEffect"])(function () {
    if ((adult === null || adult === void 0 ? void 0 : adult.optinEmail) !== undefined || (adult === null || adult === void 0 ? void 0 : adult.optinMail) !== undefined || (adult === null || adult === void 0 ? void 0 : adult.optinPhone) !== undefined || (adult === null || adult === void 0 ? void 0 : adult.optinSms) !== undefined || (adult === null || adult === void 0 ? void 0 : adult.optinClubmedPlus) !== undefined) {
      optinsContext.setOptins(PersonInfoFormContent_objectSpread(PersonInfoFormContent_objectSpread({}, optinsContext.optins), {}, {
        optinEmail: Boolean(formik.values[0].adults[0].optinEmail),
        optinMail: Boolean(formik.values[0].adults[0].optinMail),
        optinPhone: Boolean(formik.values[0].adults[0].optinPhone),
        optinSms: Boolean(formik.values[0].adults[0].optinSms),
        optinClubmedPlus: Boolean(formik.values[0].adults[0].optinClubmedPlus)
      }));
    }
  }, [adult]);

  var attendeeBirthdate = get_default()(formik.values, "".concat(attendeeIdentifier, ".birthdate"));

  var isChildToBeAdult = arrivalDate && Object(ContactInfoUtils["s" /* isChildWillBeAdultByArrivalDate */])(attendeeBirthdate, arrivalDate);
  var dataForm = "PersonInfo-".concat(id);
  var onKeyDown = Object(PersonInfoUtils["c" /* onKeyDownDataForm */])(dataForm);
  var shouldDisplayUnicodeFields = unicodeFirstNameField.isVisible || unicodeLastNameField.isVisible;
  var idcardSecondName = documentFieldsVisibilities.idcardSecondName,
      idcardThirdName = documentFieldsVisibilities.idcardThirdName,
      idcardFourthName = documentFieldsVisibilities.idcardFourthName,
      passportSecondName = documentFieldsVisibilities.passportSecondName,
      passportThirdName = documentFieldsVisibilities.passportThirdName,
      passportFourthName = documentFieldsVisibilities.passportFourthName;

  var firstNameInputs = PersonInfoFormContent_jsx(FormikInput["a" /* FormikInput */], {
    autoComplete: "given-name",
    hideErrorMessage: hideErrorMessage,
    isDisabled: isDisabled || Object(ContactInfoUtils["w" /* shouldHideField */])({
      connectedUserInfo: connectedUserInfo,
      isChild: isChild,
      attendeeIdentifier: attendeeIdentifier,
      fieldName: 'firstName',
      formInitialValues: formik.initialValues,
      isMain: isMain
    }) || isMain && isUserLogged,
    isRequired: firstNameField.isRequired,
    label: Object(src_i18n["h" /* t */])('booking.participants.labels.firstName'),
    labelAdditionalInfo: Object(src_i18n["h" /* t */])('common.form.notes.matchingPassport'),
    name: "".concat(attendeeIdentifier, ".firstName"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.firstName
  });

  var lastNameInputs = PersonInfoFormContent_jsx(FormikInput["a" /* FormikInput */], {
    autoComplete: "family-name",
    hideErrorMessage: hideErrorMessage,
    isDisabled: isDisabled || Object(ContactInfoUtils["w" /* shouldHideField */])({
      connectedUserInfo: connectedUserInfo,
      isChild: isChild,
      fieldName: 'lastName',
      attendeeIdentifier: attendeeIdentifier,
      formInitialValues: formik.initialValues,
      isMain: isMain
    }) || isMain && isUserLogged,
    isRequired: lastNameField.isRequired,
    label: Object(src_i18n["h" /* t */])('booking.participants.labels.lastName'),
    labelAdditionalInfo: Object(src_i18n["h" /* t */])('common.form.notes.matchingPassport'),
    name: "".concat(attendeeIdentifier, ".lastName"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.lastName
  });

  var renderSecondName = function renderSecondName(secondName) {
    return (secondName === null || secondName === void 0 ? void 0 : secondName.isVisible) && PersonInfoFormContent_jsx("div", {
      className: "p-10 sm:w-1/2"
    }, PersonInfoFormContent_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "documentSecondName_input",
      hideErrorMessage: hideErrorMessage,
      isRequired: secondName.isRequired,
      label: secondName.label,
      name: "".concat(attendeeIdentifier, ".document.").concat(secondName.type, ".secondName"),
      onClick: onKeyDown,
      type: "text",
      validate: secondName.validator
    }));
  };

  var renderThirdName = function renderThirdName(thirdName) {
    return (thirdName === null || thirdName === void 0 ? void 0 : thirdName.isVisible) && PersonInfoFormContent_jsx("div", {
      className: "p-10 sm:w-1/2"
    }, PersonInfoFormContent_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "documentSecondName_input",
      hideErrorMessage: hideErrorMessage,
      isRequired: thirdName.isRequired,
      label: thirdName.label,
      name: "".concat(attendeeIdentifier, ".document.").concat(thirdName.type, ".thirdName"),
      onClick: onKeyDown,
      type: "text",
      validate: thirdName.validator
    }));
  };

  var renderFourthName = function renderFourthName(fourthName) {
    return (fourthName === null || fourthName === void 0 ? void 0 : fourthName.isVisible) && PersonInfoFormContent_jsx("div", {
      className: "p-10 sm:w-1/2"
    }, PersonInfoFormContent_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "documentSecondName_input",
      hideErrorMessage: hideErrorMessage,
      isRequired: fourthName.isRequired,
      label: fourthName.label,
      name: "".concat(attendeeIdentifier, ".document.").concat(fourthName.type, ".fourthName"),
      onClick: onKeyDown,
      type: "text",
      validate: fourthName.validator
    }));
  };

  return PersonInfoFormContent_jsx("div", {
    "data-testid": isMain ? 'main-participant-form' : 'other-participant-form'
  }, PersonInfoFormContent_jsx("p", {
    className: "start-0 mx-20 mt-5 text-right text-12 text-black sm:absolute"
  }, Object(src_i18n["h" /* t */])('common.form.notes.mandatoryFields')), PersonInfoFormContent_jsx("form", {
    "data-form": dataForm
  }, PersonInfoFormContent_jsx("fieldset", {
    className: "flex flex-col p-10 pt-5 sm:flex-row sm:flex-wrap sm:pt-10"
  }, civilityField.isVisible && PersonInfoFormContent_jsx("div", {
    className: "-mx-5 w-full py-10"
  }, PersonInfoFormContent_jsx(CivilityInputBlock_CivilityInputBlock, {
    adultCivilities: adultCivilities,
    attendeeIdentifier: attendeeIdentifier,
    childCivilities: childCivilities,
    isChild: !!isChild,
    isDisabled: isDisabled || isMain && isUserLogged,
    validators: validators
  })), (isLastnameFirst ? lastNameField : firstNameField).isVisible && PersonInfoFormContent_jsx("div", {
    className: "p-10 sm:w-1/2"
  }, isLastnameFirst ? lastNameInputs : firstNameInputs), (isLastnameFirst ? firstNameField : lastNameField).isVisible && PersonInfoFormContent_jsx("div", {
    className: "p-10 sm:w-1/2"
  }, isLastnameFirst ? firstNameInputs : lastNameInputs), renderSecondName(idcardSecondName), renderSecondName(passportSecondName), renderThirdName(idcardThirdName), renderThirdName(passportThirdName), renderFourthName(idcardFourthName), renderFourthName(passportFourthName), shouldDisplayUnicodeFields && PersonInfoFormContent_jsx(UnicodeFields_UnicodeFields, {
    attendeeIdentifier: attendeeIdentifier,
    connectedUserInfo: connectedUserInfo,
    onKeyDown: onKeyDown,
    validators: validators,
    isUnicodeFirstNameVisible: unicodeFirstNameField.isVisible,
    isUnicodeFirstNameRequired: unicodeFirstNameField.isRequired,
    isUnicodeLastNameVisible: unicodeLastNameField.isVisible,
    isUnicodeLastNameRequired: unicodeLastNameField.isRequired,
    isMain: isMain,
    isChild: isChild
  }), birthdateField.isVisible && PersonInfoFormContent_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('p-10 sm:w-full', {
      'order-first': isChild && !isChildToBeAdult
    })
  }, PersonInfoFormContent_jsx(FormikInput["a" /* FormikInput */], {
    dateFormat: Object(src_i18n["h" /* t */])('booking.form.dateFormat'),
    dayPlaceholder: Object(src_i18n["h" /* t */])('booking.form.dayPlaceholder'),
    isDisabled: isDisabled || isChild && !isChildToBeAdult,
    hideErrorMessage: hideErrorMessage,
    isRequired: birthdateField.isRequired,
    label: Object(src_i18n["h" /* t */])('booking.participants.labels.birthdate'),
    labelAdditionalInfo: Object(src_i18n["h" /* t */])('common.form.notes.matchingPassport'),
    monthPlaceholder: Object(src_i18n["h" /* t */])('booking.form.monthPlaceholder'),
    name: "".concat(attendeeIdentifier, ".birthdate"),
    onKeyDown: onKeyDown,
    type: "birthdate",
    validate: isChild ? validators.childBirthDate : validators.adultBirthDate,
    yearPlaceholder: Object(src_i18n["h" /* t */])('booking.form.yearPlaceholder'),
    errorMessage: !attendeeBirthdate && Object(src_i18n["h" /* t */])('booking.participants.errorMessage.birthdate')
  }))), PersonInfoFormContent_jsx(AdditionalContactInfos_AdditionalContactInfos, {
    addressSchema: addressSchema,
    attendeeIdentifier: attendeeIdentifier,
    connectedUserInfo: connectedUserInfo,
    formik: formik,
    hasAddress: !!hasAddress,
    onKeyDown: onKeyDown,
    validators: validators,
    isMain: !!isMain,
    isChild: !!isChild,
    isEmailVisible: emailField.isVisible,
    isEmailRequired: emailField.isRequired,
    isPhonesVisible: phonesField.isVisible,
    isPhonesRequired: phonesField.isRequired,
    hideErrorMessage: hideErrorMessage
  }), sanitaryIdField.isVisible && PersonInfoFormContent_jsx("fieldset", {
    className: "mt-10 p-10 sm:flex sm:flex-wrap"
  }, PersonInfoFormContent_jsx("div", {
    className: "p-10 sm:w-1/2"
  }, PersonInfoFormContent_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: hideErrorMessage,
    isDisabled: false,
    isRequired: sanitaryIdField.isRequired,
    label: Object(src_i18n["h" /* t */])('booking.participants.labels.sanitaryPass'),
    name: "".concat(attendeeIdentifier, ".healthPassId"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.healthPassId
  }))), shouldDisplayLegalInfo && PersonInfoFormContent_jsx(LegalInfo_LegalInfo, {
    attendeeIdentifier: attendeeIdentifier,
    dateFormat: Object(src_i18n["h" /* t */])('booking.form.dateFormat'),
    dayPlaceholder: Object(src_i18n["h" /* t */])('booking.form.dayPlaceholder'),
    documentFieldsVisibilities: documentFieldsVisibilities,
    hideErrorMessage: hideErrorMessage,
    monthPlaceholder: Object(src_i18n["h" /* t */])('booking.form.monthPlaceholder'),
    onKeyDown: onKeyDown,
    yearPlaceholder: Object(src_i18n["h" /* t */])('booking.form.yearPlaceholder')
  }), isMain && PersonInfoFormContent_jsx(Subscriptions_Subscriptions, {
    attendeeIdentifier: attendeeIdentifier,
    formik: formik,
    i18n: i18n,
    isSeller: appContext.isSeller,
    "data-testid": "participant-form-optionout"
  })));
};

/***/ }),

/***/ "Dzy0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("L7Jg");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("bQLV");
exports.Duplex = __webpack_require__("ekAB");
exports.Transform = __webpack_require__("YbGV");
exports.PassThrough = __webpack_require__("7m0K");
exports.finished = __webpack_require__("FRav");
exports.pipeline = __webpack_require__("EEjm");


/***/ }),

/***/ "EEjm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = __webpack_require__("VYiD").codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__("FRav");
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ "EEyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingEngineContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // $FlowFixMe

var BookingEngineContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])(undefined);

/***/ }),

/***/ "EmIl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__("nXZ9");
var minAssert = __webpack_require__("Y4pH");
var minUtils = __webpack_require__("gdlE");

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),

/***/ "F5Sq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("nXZ9");
var inherits = __webpack_require__("qW1w");
var Base = __webpack_require__("QoQd");

var utils = __webpack_require__("EmIl");

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),

/***/ "F5c/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setOptionValidity; });
/* unused harmony export unsetOptionValidity */
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_option_validity_OptionValidityUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nT1c");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rJ95");
/* harmony import */ var _optionValidity_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("O7yO");





var setOptionValidity = function setOptionValidity(appContext) {
  return /*#__PURE__*/function () {
    var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee(dispatch) {
      var data;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(_utils_option_validity_OptionValidityUtils__WEBPACK_IMPORTED_MODULE_2__[/* loadDurationValidity */ "d"])(appContext);

            case 2:
              data = _context.sent;
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])(_optionValidity_reducer__WEBPACK_IMPORTED_MODULE_4__[/* SET_OPTION_VALIDITY */ "a"], data)));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var unsetOptionValidity = function unsetOptionValidity() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])(_optionValidity_reducer__WEBPACK_IMPORTED_MODULE_4__[/* UNSET_OPTION_VALIDITY */ "b"]);
};

/***/ }),

/***/ "F5eH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPhoneCodeByCountryId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countriesToPhoneCodeList; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);

var countriesToPhoneCodeList = [{
  id: 'AF',
  phoneCode: '93'
}, {
  id: 'DZ',
  phoneCode: '213'
}, {
  id: 'AR',
  phoneCode: '54'
}, {
  id: 'AU',
  phoneCode: '61'
}, {
  id: 'BH',
  phoneCode: '973'
}, {
  id: 'BE',
  phoneCode: '32'
}, {
  id: 'BO',
  phoneCode: '591'
}, {
  id: 'BR',
  phoneCode: '55'
}, {
  id: 'BG',
  phoneCode: '359'
}, {
  id: 'CA',
  phoneCode: '1'
}, {
  id: 'CL',
  phoneCode: '56'
}, {
  id: 'CN',
  phoneCode: '86'
}, {
  id: 'CO',
  phoneCode: '57'
}, {
  id: 'CR',
  phoneCode: '506'
}, {
  id: 'HR',
  phoneCode: '385'
}, {
  id: 'CY',
  phoneCode: '357'
}, {
  id: 'CZ',
  phoneCode: '420'
}, {
  id: 'DK',
  phoneCode: '45'
}, {
  id: 'DO',
  phoneCode: '1'
}, {
  id: 'EC',
  phoneCode: '593'
}, {
  id: 'EG',
  phoneCode: '20'
}, {
  id: 'SV',
  phoneCode: '503'
}, {
  id: 'FI',
  phoneCode: '358'
}, {
  id: 'FR',
  phoneCode: '33'
}, {
  id: 'DE',
  phoneCode: '49'
}, {
  id: 'GR',
  phoneCode: '30'
}, {
  id: 'GT',
  phoneCode: '502'
}, {
  id: 'HK',
  phoneCode: '852'
}, {
  id: 'HU',
  phoneCode: '36'
}, {
  id: 'IN',
  phoneCode: '91'
}, {
  id: 'ID',
  phoneCode: '62'
}, {
  id: 'IL',
  phoneCode: '972'
}, {
  id: 'IT',
  phoneCode: '39'
}, {
  id: 'JP',
  phoneCode: '81'
}, {
  id: 'JO',
  phoneCode: '962'
}, {
  id: 'KE',
  phoneCode: '254'
}, {
  id: 'KW',
  phoneCode: '965'
}, {
  id: 'LU',
  phoneCode: '352'
}, {
  id: 'MY',
  phoneCode: '60'
}, {
  id: 'MV',
  phoneCode: '960'
}, {
  id: 'MX',
  phoneCode: '52'
}, {
  id: 'MA',
  phoneCode: '212'
}, {
  id: 'NL',
  phoneCode: '31'
}, {
  id: 'NZ',
  phoneCode: '64'
}, {
  id: 'OM',
  phoneCode: '968'
}, {
  id: 'PA',
  phoneCode: '507'
}, {
  id: 'PE',
  phoneCode: '51'
}, {
  id: 'PH',
  phoneCode: '63'
}, {
  id: 'PL',
  phoneCode: '48'
}, {
  id: 'PT',
  phoneCode: '351'
}, {
  id: 'QA',
  phoneCode: '974'
}, {
  id: 'RO',
  phoneCode: '40'
}, {
  id: 'RU',
  phoneCode: '7'
}, {
  id: 'SA',
  phoneCode: '966'
}, {
  id: 'SN',
  phoneCode: '221'
}, {
  id: 'RS',
  phoneCode: '381'
}, {
  id: 'SG',
  phoneCode: '65'
}, {
  id: 'ZA',
  phoneCode: '27'
}, {
  id: 'KR',
  phoneCode: '82'
}, {
  id: 'ES',
  phoneCode: '34'
}, {
  id: 'LK',
  phoneCode: '94'
}, {
  id: 'SE',
  phoneCode: '46'
}, {
  id: 'CH',
  phoneCode: '41'
}, {
  id: 'TW',
  phoneCode: '886'
}, {
  id: 'TH',
  phoneCode: '66'
}, {
  id: 'TN',
  phoneCode: '216'
}, {
  id: 'TR',
  phoneCode: '90'
}, {
  id: 'AE',
  phoneCode: '971'
}, {
  id: 'GB',
  phoneCode: '44'
}, {
  id: 'US',
  phoneCode: '1'
}, {
  id: 'UY',
  phoneCode: '598'
}, {
  id: 'VN',
  phoneCode: '84'
}, {
  id: 'BD',
  phoneCode: '880'
}, {
  id: 'BN',
  phoneCode: '673'
}, {
  id: 'KH',
  phoneCode: '855'
}, {
  id: 'LA',
  phoneCode: '856'
}, {
  id: 'MV',
  phoneCode: '960'
}, {
  id: 'NP',
  phoneCode: '977'
}, {
  id: 'PK',
  phoneCode: '92'
}, {
  id: 'LK',
  phoneCode: '94'
}, {
  id: 'HR',
  phoneCode: '385'
}, {
  id: 'SI',
  phoneCode: '386'
}, {
  id: 'RS',
  phoneCode: '381'
}, {
  id: 'AL',
  phoneCode: '355'
}, {
  id: 'LT',
  phoneCode: '370'
}, {
  id: 'IS',
  phoneCode: '354'
}, {
  id: 'LY',
  phoneCode: '218'
}, {
  id: 'ET',
  phoneCode: '251'
}, {
  id: 'KE',
  phoneCode: '254'
}, {
  id: 'NG',
  phoneCode: '234'
}, {
  id: 'GH',
  phoneCode: '233'
}, {
  id: 'TZ',
  phoneCode: '255'
}];
var getPhoneCodeByCountryId = function getPhoneCodeByCountryId(countryId) {
  var country = countriesToPhoneCodeList.find(function (c) {
    return c.id === countryId;
  });
  return country === null || country === void 0 ? void 0 : country.phoneCode;
};


/***/ }),

/***/ "FBOC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = __webpack_require__("1037").codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__("5yTO");
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ "FRav":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__("VYiD").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ "FT8f":
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__("cJUb")
var randomBytes = __webpack_require__("i+/A")
var createHash = __webpack_require__("Deve")
var mgf = __webpack_require__("Ttg3")
var xor = __webpack_require__("fXPz")
var BN = __webpack_require__("nXZ9")
var withPublic = __webpack_require__("HzNb")
var crt = __webpack_require__("ZsTA")
var Buffer = __webpack_require__("KLyV").Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),

/***/ "FbvT":
/***/ (function(module, exports, __webpack_require__) {

/*global exports*/
var SignStream = __webpack_require__("pc5U");
var VerifyStream = __webpack_require__("ZP1f");

var ALGORITHMS = [
  'HS256', 'HS384', 'HS512',
  'RS256', 'RS384', 'RS512',
  'PS256', 'PS384', 'PS512',
  'ES256', 'ES384', 'ES512'
];

exports.ALGORITHMS = ALGORITHMS;
exports.sign = SignStream.sign;
exports.verify = VerifyStream.verify;
exports.decode = VerifyStream.decode;
exports.isValid = VerifyStream.isValid;
exports.createSign = function createSign(opts) {
  return new SignStream(opts);
};
exports.createVerify = function createVerify(opts) {
  return new VerifyStream(opts);
};


/***/ }),

/***/ "Fmrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Confirmation; });
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("jD8k");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;









var getDefaultIcon = function getDefaultIcon(status) {
  return status === 'success' ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CHECK_OUTLINE : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].WARNING;
};

var Confirmation = function Confirmation(_ref) {
  var _ref$button = _ref.button,
      button = _ref$button === void 0 ? {} : _ref$button,
      className = _ref.className,
      icon = _ref.icon,
      link = _ref.link,
      status = _ref.status,
      text = _ref.text,
      title = _ref.title;

  if (!status || !title) {
    return null;
  }

  var colors = {
    error: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].RED,
    neutral: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLACK,
    success: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].GREEN
  };
  var iconName = icon ? icon : getDefaultIcon(status);
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('flex gap-20 items-start sm:items-center text-12 sm:text-20', "text-".concat(colors[status]), className)
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "shrink-0",
    name: iconName,
    width: "4em"
  }), __jsx("div", {
    className: "flex-auto"
  }, __jsx("p", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('font-bold text-16 sm:text-20', "text-".concat(colors[status]))
  }, title), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    text: text
  }), __jsx("p", null, __jsx(_frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__[/* TextLink */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, link, {
    className: "mt-10 underline"
  }))), button && button.children && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, button, {
    className: "mt-10"
  }), button.children)));
};

/***/ }),

/***/ "FtZA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__("KLyV").Buffer;
var util = __webpack_require__(1);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),

/***/ "G+mE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("qw6+");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("w30G");
exports.Duplex = __webpack_require__("wYax");
exports.Transform = __webpack_require__("Aa7t");
exports.PassThrough = __webpack_require__("vF8l");


/***/ }),

/***/ "Gh9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL; });
var TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL = {
  actionGA: 'activities',
  labelGA: 'chooseSkiEquipment',
  versionBooking: 'responsive'
};

/***/ }),

/***/ "Gqxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ResponsiveContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("1JJ2");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function Responsiveness(WrappedComponent) {
  var Responsive = /*#__PURE__*/function (_Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Responsive, _Component);

    var _super = _createSuper(Responsive);

    function Responsive() {
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, Responsive);

      return _super.apply(this, arguments);
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Responsive, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            ref = _this$props.forwardRef,
            props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_this$props, ["forwardRef"]);

        return __jsx(_ResponsiveContext__WEBPACK_IMPORTED_MODULE_11__[/* ResponsiveContext */ "a"].Consumer, null, function (responsive) {
          return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({
            ref: ref
          }, props, {
            responsive: responsive
          }));
        });
      }
    }]);

    return Responsive;
  }(react__WEBPACK_IMPORTED_MODULE_10__["Component"]);

  return /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_10__["forwardRef"])(function (props, ref) {
    return __jsx(Responsive, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, props, {
      forwardRef: ref
    }));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Responsiveness);

/***/ }),

/***/ "H8tl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptinsContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OptinsProvider; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;

var OptinsContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  optins: {},
  setOptins: function setOptins() {}
});
var OptinsProvider = function OptinsProvider(_ref) {
  var children = _ref.children;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])({}),
      optins = _useState[0],
      setOptins = _useState[1];

  var value = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
    return {
      optins: optins,
      setOptins: setOptins
    };
  }, [optins]);
  return __jsx(OptinsContext.Provider, {
    value: value
  }, children);
};

/***/ }),

/***/ "HQvT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__("qW1w");
const Buffer = __webpack_require__("aikL").Buffer;

const DERDecoder = __webpack_require__("CgxS");

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  const lines = data.toString().split(/[\r\n]+/g);

  const label = options.label.toUpperCase();

  const re = /^-----(BEGIN|END) ([^-]+)-----$/;
  let start = -1;
  let end = -1;
  for (let i = 0; i < lines.length; i++) {
    const match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  const base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9+/=]+/gi, '');

  const input = Buffer.from(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),

/***/ "Hv+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackDelCredereBanking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackNavigation; });
/* unused harmony export trackSaveCriteria */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return trackShareContextDesktopPopin; });
/* unused harmony export trackShareContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackShareContextMobilePopin; });
/* unused harmony export trackPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetTrackingStorageBE; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("K0Lv");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("d1HQ");
/* harmony import */ var _utils_booking_engine_pages_BookingPagesUtils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("rcxx");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_tracking_resort__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("zCbR");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("taV1");













function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}











function storeTracking(params) {
  var resortTrackingProps = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_15__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_14__[/* BE_TRACKING */ "c"]);

  var bookingCriteriaProps = _objectSpread(_objectSpread({}, lodash_omit__WEBPACK_IMPORTED_MODULE_10___default()(resortTrackingProps, 'children')), params);

  _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_15__[/* set */ "c"](bookingCriteriaProps);
}

function trackDelCredereBanking(dataObject, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    actionGA: 'banking',
    agenceType: 'Ducroire'
  }, dataObject), appContext);
}
function trackNavigation(actionGA, labelGA, appContext) {
  var addAgencyType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    actionGA: actionGA,
    labelGA: labelGA
  }, addAgencyType && {
    agenceType: appContext.cmta.isDelCredere ? 'Ducroire' : 'NonDucroire'
  }), appContext);
}
function trackSaveCriteria(actionGA, labelGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    categoryGA: 'saveMyCriteria',
    actionGA: actionGA,
    labelGA: labelGA
  }), appContext);
}
function trackShareContextDesktopPopin(actionGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    labelGA: 'shareValidate',
    actionGA: actionGA
  }), appContext);
}
function trackShareContext(actionGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    labelGA: 'shareClick',
    actionGA: actionGA
  }), appContext);
}
function trackShareContextMobilePopin(actionGA, socialNetworkName, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    labelGA: "shareValidate_".concat(socialNetworkName),
    actionGA: actionGA
  }), appContext);
}
function trackPage(trackingParams, appContext) {
  var _objectSpread2, _userInfo$loyaltyProg;

  var basePriceLabel = trackingParams.basePriceLabel,
      pageName = trackingParams.pageName,
      resort = trackingParams.resort,
      userInfo = trackingParams.userInfo,
      selectedProposal = trackingParams.selectedProposal,
      leadScore = trackingParams.leadScore,
      _trackingParams$custo = trackingParams.customEventName,
      customEventName = _trackingParams$custo === void 0 ? null : _trackingParams$custo;

  var transportDeparture = lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(selectedProposal.transports, 'inbound.travelSections[0].departure', {});

  var storedTracking = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_15__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_14__[/* BE_TRACKING */ "c"]);

  var departureDate = lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(selectedProposal, 'departureDate', null);

  var departureDateTimestamp = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_18__[/* apiDateToTimestamp */ "e"])(departureDate);
  var computedPageName = pageName === _utils_booking_engine_pages_BookingPagesUtils__WEBPACK_IMPORTED_MODULE_17__[/* PAGE_BE_SERVICES */ "d"] && resort.isJoyview ? _utils_booking_engine_pages_BookingPagesUtils__WEBPACK_IMPORTED_MODULE_17__[/* PAGE_BE_SERVICES_ALL_INCLUSIVE */ "e"] : pageName;

  var trackingDataToStore = _objectSpread((_objectSpread2 = {
    resortCode: resort.id,
    resortName: resort.name,
    resortTrident: resort.comfort,
    resortCountry: resort.destination.country,
    resortRegion: resort.destination.area,
    resortAdult: selectedProposal.attendees.adults.length,
    resortChildren: selectedProposal.attendees.children.length,
    resortDefaultPrice: lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(resort, 'price.initialPrice.value'),
    resortDepartureCityCode: transportDeparture.cityId || 'WITHOUT TRANSPORT',
    resortDepartureCityName: transportDeparture.label,
    resortDepartureDate: selectedProposal.arrivalDate,
    resortNightNumber: selectedProposal.duration,
    resortOldPrice: lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(resort, 'price.initialPrice.value'),
    resortSeasonType: lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(resort, 'seasonName'),
    resortTotalParticipant: selectedProposal.attendees.list.length,
    resortTransport: selectedProposal.transports ? 'with Transport' : 'without Transport',
    resortUrlImage: resort.image,
    versionBooking: 'responsive',
    resortSeason: departureDateTimestamp && Object(_utils_tracking_resort__WEBPACK_IMPORTED_MODULE_19__[/* isSummer */ "f"])(new Date(departureDateTimestamp)) ? 'Summer' : 'Winter',
    resortYearSeason: moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate, 'YYYYMMDD').format('YYYY')
  }, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, basePriceLabel, selectedProposal.price.total.value), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "contextNumber", selectedProposal.id), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "currencyCode", selectedProposal.price.currency), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "daysBeforeDeparture", moment__WEBPACK_IMPORTED_MODULE_12___default()(selectedProposal.arrivalDate).diff(moment__WEBPACK_IMPORTED_MODULE_12___default()(), 'days')), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "upsellExcursion", selectedProposal.additionalServices.activities.some(function (_ref) {
    var pricingInfo = _ref.pricingInfo;
    return pricingInfo.isPartiallyRented;
  }) ? 'yes' : 'no'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_objectSpread2, "BE_customerStatus", storedTracking.BE_customerStatus), _objectSpread2), leadScore ? {
    leadScore: leadScore
  } : null);

  storeTracking(trackingDataToStore);
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_16__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({
    categoryGA: _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE_CATEGORY_GA */ "b"],
    locale: appContext.locale,
    event: customEventName || computedPageName,
    fidelityStatus: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$loyaltyProg = userInfo.loyaltyProgram) === null || _userInfo$loyaltyProg === void 0 ? void 0 : _userInfo$loyaltyProg.status) || '',
    valueGA: 0,
    environment: _config__WEBPACK_IMPORTED_MODULE_13___default.a.get('tracking.environment')
  }, appContext.isCmta && {
    agenceType: appContext.cmta.isDelCredere ? 'Ducroire' : 'NonDucroire'
  }), {}, {
    nonInteraction: 0,
    pageName: "BE_".concat(computedPageName),
    siteSection: 'Booking Engine'
  }, trackingDataToStore), appContext);
}
var resetTrackingStorageBE = function resetTrackingStorageBE() {
  var isTravelPlan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  storeTracking({
    BE_customerStatus: null,
    is_travel_plan: isTravelPlan
  });
};

/***/ }),

/***/ "HzNb":
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__("nXZ9")
var Buffer = __webpack_require__("KLyV").Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),

/***/ "I3mq":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("KLyV").Buffer

module.exports = function (thing, encoding, name) {
  if (Buffer.isBuffer(thing)) {
    return thing
  } else if (typeof thing === 'string') {
    return Buffer.from(thing, encoding)
  } else if (ArrayBuffer.isView(thing)) {
    return Buffer.from(thing.buffer)
  } else {
    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
  }
}


/***/ }),

/***/ "I7/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAutoScrollToError; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RUiN");

 // scroll to error after a submit and a validation

var useAutoScrollToError = function useAutoScrollToError(formik) {
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var isSubmitting = formik.isSubmitting,
        isValidating = formik.isValidating,
        isValid = formik.isValid;
    var formikErrored = '.formik-errored';

    if (isSubmitting && !isValidating && !isValid) {
      Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_1__[/* scrollToElement */ "a"])(formikErrored);
      var firstErroredElement = document.querySelector(formikErrored);
      firstErroredElement && firstErroredElement.focus();
    }
  });
};

/***/ }),

/***/ "ICjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncPolling; });
/* harmony import */ var poll_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6CUh");
/* harmony import */ var poll_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(poll_js__WEBPACK_IMPORTED_MODULE_0__);


function asyncPolling(config) {
  var startOfPoll = new Date();
  var timeout = config.timeout || 120000; // 2min

  var _pollWrapper = Object(poll_js__WEBPACK_IMPORTED_MODULE_0__["pollWrapper"])({
    request: function request() {
      return config.pollingFunction();
    },
    pollingPeriod: config.delay,
    shouldStop: function shouldStop(response) {
      var pollDuration = new Date() - startOfPoll;

      if (pollDuration > timeout) {
        throw new Error('Request timeout');
      }

      return !config.shouldPollAgain(response);
    }
  }),
      future = _pollWrapper.future;

  return future.then(function (response) {
    return config.onResponse(response);
  });
}



/***/ }),

/***/ "IGVP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccommodationOptionCurrent; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e0Ti");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var AccommodationOptionCurrent = function AccommodationOptionCurrent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$isUpgradableOnli = _ref.isUpgradableOnline,
      isUpgradableOnline = _ref$isUpgradableOnli === void 0 ? true : _ref$isUpgradableOnli,
      onSelect = _ref.onSelect,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "isUpgradableOnline", "onSelect"]);

  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__[/* classnames */ "a"])('bg-white border-1 border-lightGrey flex flex-col isolate relative rounded-12', className),
    "data-testid": "AccommodationOptionCurrent"
  }), __jsx("div", {
    className: "flex-1 overflow-y-auto"
  }, children), __jsx("div", {
    className: "border-t-1 border-lightGrey flex gap-10 items-center justify-center p-20"
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "a"], {
    className: "w-auto",
    onClick: onSelect
  }, isUpgradableOnline ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.confirm') : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.accommodation.upgradeRoom.contactATED'))));
};

/***/ }),

/***/ "IGWl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useCountryList; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ub5k");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_7__);








var nationalitiesLanguageKey = {
  fr: 'fr-CH',
  de: 'de-CH',
  en: 'en-CH',
  zh: 'zh-TW',
  ru: 'ru-RU'
};
var DEFAULT_LANGUAGE = 'en';
var useCountryList = function useCountryList() {
  var appContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__[/* useAppContext */ "c"])();
  var exactLocaleNationalities = Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_7__["getNationalities"])(appContext.locale);

  if (exactLocaleNationalities.length) {
    return exactLocaleNationalities.map(function (_ref) {
      var country = _ref.country,
          codeIso2 = _ref.codeIso2;
      return {
        name: country,
        value: codeIso2
      };
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }

  var language = appContext.locale.split('-')[0];
  var locale = (nationalitiesLanguageKey === null || nationalitiesLanguageKey === void 0 ? void 0 : nationalitiesLanguageKey[language]) || nationalitiesLanguageKey[DEFAULT_LANGUAGE];
  return (Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_7__["getNationalities"])(locale) || []).map(function (_ref2) {
    var country = _ref2.country,
        codeIso2 = _ref2.codeIso2;
    return {
      name: country,
      value: codeIso2
    };
  }).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
};

/***/ }),

/***/ "IOWS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useBookingNavbar; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zwLB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _BookingNavbarContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4ryf");




var defaultBookingNavbar = {
  continueAction: null,
  hideContinueButton: false,
  isPriceLoading: false,
  navbarRef: null,
  priceShouldIncludeDonation: true,
  noEdit: true,
  overwriteContinueButton: false,
  portalPosition: undefined,
  isDisabled: false,
  validationCallback: null,
  shouldDisplay: true,
  paymentLabel: undefined
};
var useBookingNavbar = function useBookingNavbar(props) {
  var context = Object(_BookingNavbarContext__WEBPACK_IMPORTED_MODULE_3__[/* useBookingNavbarContext */ "b"])();

  var useSetter = function useSetter(_ref) {
    var name = _ref.name;
    var value = props === null || props === void 0 ? void 0 : props[name];
    var setter = context['set' + Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_1__[/* pascalCase */ "q"])(name)];
    Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
      if (value !== undefined && setter) {
        setter(function () {
          return value;
        });
        return function () {
          setter(defaultBookingNavbar[name]);
        };
      }
    }, [value]);
  };

  useSetter({
    name: 'validationCallback'
  });
  useSetter({
    name: 'processValidation'
  });
  useSetter({
    name: 'priceShouldIncludeDonation'
  });
  useSetter({
    name: 'paymentLabel'
  });
  useSetter({
    name: 'isDisabled'
  });
  useSetter({
    name: 'continueBtn'
  });
  useSetter({
    name: 'isPriceLoading'
  });
  useSetter({
    name: 'hideContinueButton'
  });
  useSetter({
    name: 'noEdit'
  });
  useSetter({
    name: 'overwriteContinueButton'
  });
  useSetter({
    name: 'portalPosition'
  });
  useSetter({
    name: 'continueAction'
  });
  useSetter({
    name: 'shouldDisplay'
  });
};

/***/ }),

/***/ "IP+5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const encoders = __webpack_require__("Quze");
const decoders = __webpack_require__("qqtw");
const inherits = __webpack_require__("qW1w");

const api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
}

Entity.prototype._createNamed = function createNamed(Base) {
  const name = this.name;

  function Generated(entity) {
    this._initNamed(entity, name);
  }
  inherits(Generated, Base);
  Generated.prototype._initNamed = function _initNamed(entity, name) {
    Base.call(this, entity, name);
  };

  return new Generated(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),

/***/ "IS/a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("nXZ9");
var HmacDRBG = __webpack_require__("1DEc");
var utils = __webpack_require__("EmIl");
var curves = __webpack_require__("3870");
var rand = __webpack_require__("ufvR");
var assert = utils.assert;

var KeyPair = __webpack_require__("ocZH");
var Signature = __webpack_require__("mFNI");

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(Object.prototype.hasOwnProperty.call(curves, options),
      'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  for (;;) {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),

/***/ "Imk+":
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__("i+/A");
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__("nXZ9");
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__("1DFk");
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),

/***/ "Iz3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLinkTagName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLinkProps; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("i5Mr");










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var getLinkTagName = function getLinkTagName(link) {
  if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(link)) {
    return 'div';
  }

  return link.url ? _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"] : 'button';
};
var getLinkProps = function getLinkProps(link) {
  return (link === null || link === void 0 ? void 0 : link.url) ? _objectSpread({}, link) : _objectSpread(_objectSpread({}, link), {}, {
    type: 'button'
  });
};

/***/ }),

/***/ "JjZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductInformationSlider_container_ProductInformationSliderContainer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationLayer.jsx








var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ProductInformationLayer_ProductInformationLayer = function ProductInformationLayer(_ref) {
  var activeItem = _ref.activeItem,
      backNavigationLabel = _ref.backNavigationLabel,
      children = _ref.children,
      errorMessage = _ref.errorMessage,
      renderDetail = _ref.renderDetail,
      toggleLayer = _ref.toggleLayer;

  var _useState = Object(react["useState"])({
    activeItem: activeItem,
    isLoading: false,
    isOpen: false
  }),
      state = _useState[0],
      setState = _useState[1];

  Object(react["useEffect"])(function () {
    loadDetails();
  }, [activeItem]);

  var closeLayer = function closeLayer() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isLoading: false,
      isOpen: false
    })); // -1 to indicate that no product has been selected

    toggleLayer(-1, false);
  };

  var updateDetail = function updateDetail(active, detailInfo) {
    setState({
      activeItem: active,
      detail: detailInfo,
      isLoading: false,
      isOpen: true
    });
  };

  var getItem = function getItem(index) {
    return react["Children"].toArray(children)[index];
  };

  var loadDetails = function loadDetails() {
    var item = getItem(activeItem) || {};
    var props = item.props;

    if (props && props.fetchDetail) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      }));
      props.fetchDetail().then(function (data) {
        updateDetail(activeItem, data);
      }).catch(function () {
        updateDetail(activeItem, null);
      });
    }
  };

  var renderActiveDetail = function renderActiveDetail() {
    var item = getItem(activeItem);

    if (!item) {
      return null;
    }

    var leftButton = {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      onClick: closeLayer,
      label: backNavigationLabel
    };
    var ariaLabel = state.detail ? state.detail.label || state.detail.title : '';
    return __jsx(Layer["b" /* Layer */], {
      ariaLabel: ariaLabel,
      bgColor: colors["a" /* COLORS */].WHITE,
      buttonLeft: leftButton,
      closeLabel: Object(i18n["h" /* t */])('common.close'),
      hasAnimateEnter: true,
      hasContainerHeader: true,
      onClose: closeLayer
    }, state.detail ? renderDetail(state.detail) : __jsx("div", {
      "data-testid": "error",
      className: "p-20"
    }, __jsx("div", {
      className: "mx-auto flex max-w-site justify-center"
    }, __jsx(Confirmation["a" /* Confirmation */], {
      status: "error",
      title: errorMessage
    }))));
  };

  return state.isOpen && !state.isLoading ? renderActiveDetail() : state.isLoading && __jsx("div", {
    id: "loading",
    className: "relative z-4"
  }, __jsx(Backdrop["a" /* Backdrop */], {
    className: "bg-white opacity-90"
  }, __jsx("div", {
    "aria-live": "polite",
    className: "absolute left-1/2 top-1/2 w-[208px] -translate-x-1/2 -translate-y-1/2 transform text-center"
  }, __jsx("span", {
    className: "sr-only"
  }, "Loading"), __jsx(Spinner["a" /* Spinner */], {
    "data-testid": "Spinner",
    iconName: icons["a" /* ICONS */].TRIDENT1
  }))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.jsx




















var ProductInformationSlider_jsx = react_default.a.createElement;

function ProductInformationSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductInformationSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductInformationSlider_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductInformationSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var themes = {
  default: {
    largeCols: 2,
    desktopCols: 4,
    tabletCols: 3,
    navPosition: ''
  },
  short: {
    largeCols: 2,
    desktopCols: 3,
    tabletCols: 3,
    navPosition: 'center'
  }
};
var ProductInformationSlider_ProductInformationSlider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ProductInformationSlider, _Component);

  var _super = _createSuper(ProductInformationSlider);

  function ProductInformationSlider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ProductInformationSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openLayer", function (activeItem) {
      return _this.props.toggleLayer ? _this.props.toggleLayer(activeItem, true) : null;
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ProductInformationSlider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          isLarge = _this$props.isLarge,
          _this$props$theme = _this$props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme,
          queryLayer = _this$props.queryLayer,
          scrollBackwardLabel = _this$props.scrollBackwardLabel,
          scrollForwardLabel = _this$props.scrollForwardLabel;

      if (!react["Children"].count(children)) {
        return null;
      }

      var _this$context = this.context,
          isDesktop = _this$context.isDesktop,
          isTablet = _this$context.isTablet;
      var _themes$theme = themes[theme],
          largeCols = _themes$theme.largeCols,
          desktopCols = _themes$theme.desktopCols,
          tabletCols = _themes$theme.tabletCols,
          navPosition = _themes$theme.navPosition;

      var renderItem = function renderItem(element, index) {
        var _element$props$link = element.props.link,
            link = _element$props$link === void 0 ? {} : _element$props$link;

        if (!link.url) {
          link = ProductInformationSlider_objectSpread(ProductInformationSlider_objectSpread({}, link), {}, {
            onClick: function onClick() {
              return _this2.openLayer && _this2.openLayer(index);
            }
          });
        }

        return /*#__PURE__*/react_default.a.createElement('div', {
          className: 'h-full w-280 md:w-auto'
        }, /*#__PURE__*/react_default.a.cloneElement(element, {
          link: link,
          isLarge: isLarge
        }));
      };

      var getCols = function getCols() {
        if (isTablet) {
          if (isLarge) {
            return largeCols;
          }

          if (isDesktop) {
            return desktopCols;
          }

          return tabletCols;
        }

        return 0;
      };

      var clonedChildren = react["Children"].map(children, renderItem);
      return ProductInformationSlider_jsx("section", null, ProductInformationSlider_jsx(Slider["a" /* Slider */], {
        cols: getCols(),
        hasControls: isTablet,
        id: queryLayer,
        navPosition: navPosition || (isTablet ? 'top' : 'center'),
        nbItemsToScroll: isTablet ? 2 : 1,
        nextLabel: scrollForwardLabel,
        previousLabel: scrollBackwardLabel,
        scrollAreaClassName: "overflow-hidden -mx-10",
        scrollAreaContainerClassName: "overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory",
        scrollItemClassName: "overflow-hidden px-10 pb-10 flex-none max-w-full"
      }, clonedChildren));
    }
  }]);

  return ProductInformationSlider;
}(react["Component"]);

Object(defineProperty["a" /* default */])(ProductInformationSlider_ProductInformationSlider, "contextType", ResponsiveContext["a" /* ResponsiveContext */]);
// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.container.jsx








var ProductInformationSlider_container_jsx = react_default.a.createElement;






var ProductInformationSlider_container_ProductInformationSliderContainer = function ProductInformationSliderContainer(props) {
  // -1 to init activeItem (it means no item has been selected yet), 0 is the index of first element
  var _useState = Object(react["useState"])(-1),
      activeItem = _useState[0],
      setActiveItem = _useState[1];

  var router = Object(next_router["useRouter"])();
  var queryLayer = props.queryLayer,
      sliderIndex = props.sliderIndex;
  var asPath = router.asPath;

  var _getOpenLayersFromLoc = Object(uriUtils["h" /* getOpenLayersFromLocation */])(asPath, queryLayer),
      _getOpenLayersFromLoc2 = Object(slicedToArray["a" /* default */])(_getOpenLayersFromLoc, 2),
      uriSliderIndex = _getOpenLayersFromLoc2[0],
      uriActiveItem = _getOpenLayersFromLoc2[1];

  var uri = new URI_default.a(asPath);
  Object(react["useEffect"])(function () {
    if (uri.hasQuery(queryLayer) && Number(uriSliderIndex) === sliderIndex) {
      setActiveItem(uriActiveItem);
    }
  }, [asPath]);
  /**
   * Close the layer from back navigation button
   */

  var closeLayer = function closeLayer() {
    setActiveItem(-1);
  };

  Object(react["useEffect"])(function () {
    window.addEventListener('popstate', closeLayer);
    return function () {
      window.removeEventListener('popstate', closeLayer);
    };
  }, []);

  var toggleLayer = function toggleLayer(item, layer) {
    var newUrl = uri.clone();

    if (layer) {
      newUrl = newUrl.hash('').addQuery(queryLayer, "".concat(sliderIndex, "_").concat(item));
      router.push(newUrl.toString(), undefined, {
        shallow: true
      });
    } else {
      newUrl = newUrl.removeQuery(queryLayer);
      router.replace(newUrl.toString(), undefined, {
        shallow: true
      });
    }

    setActiveItem(item);
  };

  return ProductInformationSlider_container_jsx(react["Fragment"], null, ProductInformationSlider_container_jsx(ProductInformationSlider_ProductInformationSlider, Object(esm_extends["a" /* default */])({}, props, {
    toggleLayer: toggleLayer
  })), ProductInformationSlider_container_jsx(ProductInformationLayer_ProductInformationLayer, Object(esm_extends["a" /* default */])({}, props, {
    activeItem: activeItem,
    toggleLayer: toggleLayer
  })));
};

/***/ }),

/***/ "JvEg":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("KLyV").Buffer
var MD5 = __webpack_require__("8N5j")

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),

/***/ "Jzv7":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('map', __webpack_require__("mbB6"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "K4jy":
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__("cJUb")
var mgf = __webpack_require__("Ttg3")
var xor = __webpack_require__("fXPz")
var BN = __webpack_require__("nXZ9")
var crt = __webpack_require__("ZsTA")
var createHash = __webpack_require__("Deve")
var withPublic = __webpack_require__("HzNb")
var Buffer = __webpack_require__("KLyV").Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),

/***/ "K7hX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_TYPE_IFRAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IframeCallbackView; });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("HbGN");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3yYM");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _routes_constants_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("dNxv");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("829J");








var EVENT_TYPE_IFRAME = 'paymentIframe';
var IframeCallbackView = function IframeCallbackView(iframeMessage) {
  var parentWindow = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].get('parent');

  if (parentWindow) {
    parentWindow.postMessage(iframeMessage, '*');
  }

  return null;
};

var getCMInitialProps = /*#__PURE__*/function () {
  var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee(_ref) {
    var req, _req$query, callbackUrl, paymentId, providerResponse;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = _ref.req;

            if (!req) {
              _context.next = 4;
              break;
            }

            _req$query = req.query, callbackUrl = _req$query.callbackUrl, paymentId = _req$query.paymentId, providerResponse = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_req$query, ["callbackUrl", "paymentId"]);
            return _context.abrupt("return", {
              eventType: EVENT_TYPE_IFRAME,
              callbackUrl: callbackUrl,
              paymentId: paymentId,
              providerResponse: providerResponse
            });

          case 4:
            return _context.abrupt("return", undefined);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCMInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();

IframeCallbackView.getCMInitialProps = getCMInitialProps;
IframeCallbackView.pageId = _routes_constants_js__WEBPACK_IMPORTED_MODULE_6__[/* IFRAME_CALLBACK_PAGE_ID */ "f"];
IframeCallbackView.pageType = _tracking_constants__WEBPACK_IMPORTED_MODULE_7__[/* STATIC_PAGE_TYPES */ "C"].BE;
IframeCallbackView.disableFooter = true;
IframeCallbackView.disableHeader = true;

/***/ }),

/***/ "KGlL":
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__("8N5j")

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),

/***/ "KLYN":
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("qW1w")
var Hash = __webpack_require__("4rhd")
var Buffer = __webpack_require__("KLyV").Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),

/***/ "KLyV":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("+ZX+")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "Kk8D":
/***/ (function(module) {

module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

/***/ }),

/***/ "KqwS":
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__("kbrz");

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

module.exports = lowerFirst;


/***/ }),

/***/ "KucK":
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__("qW1w")
var Hash = __webpack_require__("4rhd")
var Buffer = __webpack_require__("KLyV").Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),

/***/ "KxdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ filterUtils_getFilters; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ filterUtils_updateFilters; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ createFilters; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ unselectCategory; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ handleReducedMobilityFilter; });

// UNUSED EXPORTS: COMFORT_CATEGORY, EXTRA_FEATURES_CATEGORY, CONFIGURATION_CATEGORY, REDUCED_MOBILITY_CATEGORY, REDUCED_MOBILITY_FILTER_ID, matchConfiguration, matchComfort, matchExtraFeatures, createConfigurationFilters, createComfortFilters, createExtraFeaturesFilters, matchExtraFeaturesReducedMobility

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/uniqBy.js
var uniqBy = __webpack_require__("z+NW");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/compact.js
var compact = __webpack_require__("LVnT");
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/flatten.js
var flatten = __webpack_require__("Z/bG");
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/path.js
var path = __webpack_require__("Z0Tt");
var path_default = /*#__PURE__*/__webpack_require__.n(path);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/map.js
var map = __webpack_require__("Jzv7");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/pipe.js
var pipe = __webpack_require__("eYK6");
var pipe_default = /*#__PURE__*/__webpack_require__.n(pipe);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js + 1 modules
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js + 1 modules
var additionalAccommodations_action = __webpack_require__("06Jt");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-mobility/FilterMobility.jsx
var __jsx = react_default.a.createElement;






var FilterMobility_FilterMobility = function FilterMobility(_ref) {
  var className = _ref.className,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      onChange = _ref.onChange,
      _ref$selectedOptions = _ref.selectedOptions,
      selectedOptions = _ref$selectedOptions === void 0 ? [] : _ref$selectedOptions;
  var result = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.additionalAccommodations;
  });
  var isActive = Boolean(result === null || result === void 0 ? void 0 : result.isPmrChecked);

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var handleCheck = function handleCheck() {
    onChange('reducedMobilityVisibility', selectedOptions, null);
    trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
      detail_click: 'filter_mobility'
    });
  };

  return __jsx(InputSwitch["a" /* InputSwitch */], {
    checked: isActive,
    className: className,
    isDisabled: isDisabled,
    label: Object(i18n["h" /* t */])('filters.reducedMobilityCheckbox'),
    name: "filters.reducedMobility",
    onChange: handleCheck,
    size: "small"
  });
};
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js























var filterUtils_jsx = react_default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}









var COMFORT_CATEGORY = 'accommodations';
var EXTRA_FEATURES_CATEGORY = 'extra';
var CONFIGURATION_CATEGORY = 'configuration';
var REDUCED_MOBILITY_CATEGORY = 'reduced_mobility';
var REDUCED_MOBILITY_FILTER_ID = 'reduced_mobility_access';

var getOptions = function getOptions(v, c) {
  return v.filter(function (_ref) {
    var category = _ref.category;
    return category === c;
  }).map(function (o) {
    var _o$meta, _o$meta2;

    return {
      iconName: (_o$meta = o.meta) === null || _o$meta === void 0 ? void 0 : _o$meta.icon,
      id: o.id,
      isDisabled: !o.matchedOccurrences,
      isSelected: o.selected,
      label: (_o$meta2 = o.meta) === null || _o$meta2 === void 0 ? void 0 : _o$meta2.label,
      matched: o.matchedOccurrences || 0,
      value: o.value
    };
  });
};

var filterUtils_getFilters = function getFilters(product) {
  var filterValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 ? arguments[2] : undefined;
  return [{
    id: COMFORT_CATEGORY,
    label: Object(i18n["h" /* t */])('filters.comfort.categoryTitle'),
    options: getOptions(filterValues, COMFORT_CATEGORY)
  }, {
    id: CONFIGURATION_CATEGORY,
    label: Object(bookingUtils["u" /* tAlt */])({
      cruiseKeyPath: 'filters.configuration.categoryTitleCruise',
      product: product,
      resortKeyPath: 'filters.configuration.categoryTitle'
    }),
    options: getOptions(filterValues, CONFIGURATION_CATEGORY)
  }, {
    id: EXTRA_FEATURES_CATEGORY,
    label: Object(i18n["h" /* t */])('filters.extraFeatures.categoryTitle'),
    options: getOptions(filterValues, EXTRA_FEATURES_CATEGORY)
  }, (options === null || options === void 0 ? void 0 : options.ignoreReducedMobility) ? null : {
    id: REDUCED_MOBILITY_CATEGORY,
    label: '',
    options: getOptions(filterValues, EXTRA_FEATURES_CATEGORY),
    // eslint-disable-next-line clubmed/no-fake-component
    customRenderParent: function customRenderParent(selectedOptions, onChange, isDisabled) {
      return filterUtils_jsx(FilterMobility_FilterMobility, {
        isDisabled: isDisabled,
        onChange: onChange,
        selectedOptions: selectedOptions
      });
    }
  }].filter(Boolean);
};

var matchConfiguration = function matchConfiguration(accommodations, roomType) {
  var SINGLE_ROOM = 'SINGLE_ROOM',
      SEPARATE_ROOMS = 'SEPARATE_ROOMS',
      SEPARATE_ROOMS_3 = 'SEPARATE_ROOMS_3',
      CONNECTING_ROOMS = 'CONNECTING_ROOMS';
  var matchSingleConfiguration = roomType === SINGLE_ROOM;
  var matchSeparatedConfiguration = roomType === SEPARATE_ROOMS;
  var matchSeparated3Configuration = roomType === SEPARATE_ROOMS_3;
  var matchCommunicatingConfiguration = roomType === CONNECTING_ROOMS;

  if (matchSingleConfiguration) {
    return accommodations.length === 1 && accommodations[0].roomType === SINGLE_ROOM;
  }

  if (matchSeparatedConfiguration) {
    var separateConfigurations = accommodations.length === 2 && accommodations.every(function (accommodation) {
      return accommodation.roomType === SEPARATE_ROOMS || accommodation.roomType === SINGLE_ROOM;
    }) || // some combinations of two or more rooms come in one accommodation with ex : C4+C4 but roomtype is SEPARATE_ROOMS
    accommodations.length === 1 && accommodations[0].roomType === SEPARATE_ROOMS;
    return separateConfigurations;
  }

  if (matchSeparated3Configuration) {
    var _separateConfigurations = accommodations.length >= 3 && accommodations.every(function (accommodation) {
      return accommodation.roomType === SEPARATE_ROOMS || accommodation.roomType === SEPARATE_ROOMS_3 || accommodation.roomType === SINGLE_ROOM;
    }) || accommodations.length === 1 && accommodations[0].roomType === SEPARATE_ROOMS_3;

    return _separateConfigurations;
  }

  if (matchCommunicatingConfiguration) {
    var communicatingConfigurations = accommodations.length >= 1 && accommodations.some(function (accommodation) {
      return accommodation.roomType === CONNECTING_ROOMS;
    });
    return communicatingConfigurations;
  } // default case for all other room types ( we never know what to expect )


  return accommodations.some(function (accommodation) {
    return accommodation.roomType === roomType;
  });
};

var filterUtils_matchComfort = function matchComfort(accommodations, categoryId) {
  return accommodations.some(function (accommodation) {
    return get_default()(accommodation, 'categories').find(function (category) {
      return get_default()(category, 'id') === categoryId;
    });
  });
};

var filterUtils_matchExtraFeatures = function matchExtraFeatures(accommodations, strengthId) {
  return accommodations.some(function (accommodation) {
    return get_default()(accommodation, 'view.id', null) === strengthId || get_default()(accommodation, 'strengths', []).find(function (strength) {
      return get_default()(strength, 'id') === strengthId;
    });
  });
};

var matchExtraFeaturesReducedMobility = function matchExtraFeaturesReducedMobility(accommodations) {
  return accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
};

function createConfigurationFilters(accommodationsSets, product) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, uniqBy_default()('roomType')])(accommodationsSets);

  var roomTypes = accommodations.map(function (_ref2) {
    var roomType = _ref2.roomType;
    return roomType;
  }); // even we dont have the SEPARATE_ROOMS in the roomTypes, we need to show the filter
  // because two or more with SINGLE_ROOM can be combined to form SEPARATE_ROOMS
  // same for SEPARATE_ROOMS_3

  var roomTypesSR = roomTypes.includes('SEPARATE_ROOMS') ? roomTypes : [].concat(Object(toConsumableArray["a" /* default */])(roomTypes), ['SEPARATE_ROOMS']);
  var completeRoomTypes = roomTypes.includes('SEPARATE_ROOMS_3') ? roomTypesSR : [].concat(Object(toConsumableArray["a" /* default */])(roomTypesSR), ['SEPARATE_ROOMS_3']);
  return completeRoomTypes.map(function (roomType) {
    return {
      id: shortid_default.a.generate(),
      category: CONFIGURATION_CATEGORY,
      match: matchConfiguration,
      meta: {
        label: Object(bookingUtils["u" /* tAlt */])({
          cruiseKeyPath: "filters.configuration.".concat(accommodation_constants["b" /* CABIN_TYPE */][roomType]),
          product: product,
          resortKeyPath: "filters.configuration.".concat(accommodation_constants["e" /* ROOM_TYPE */][roomType])
        }),
        icon: icons["a" /* ICONS */][roomType]
      },
      path: 'accommodations',
      selected: false,
      value: roomType
    };
  });
}

function createComfortFilters(accommodationsSets) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, compact_default.a, uniqBy_default()('categoryId')])(accommodationsSets);

  var comfortSeen = [];
  return accommodations.map(function (accommodation) {
    /**
     * in some cases we have differents categories with same comfort type
     * it causes a duplicate filter
     * Concat comfort type & category, as label for teh second one
     */
    var comfortType = accommodation.comfortType,
        category = accommodation.category;
    var label = comfortSeen.includes(comfortType) ? "".concat(comfortType, " ").concat(category) : comfortType || category;
    comfortSeen.push(accommodation.comfortType);
    return {
      id: shortid_default.a.generate(),
      category: COMFORT_CATEGORY,
      match: filterUtils_matchComfort,
      meta: {
        label: label
      },
      path: 'accommodations',
      selected: false,
      value: accommodation.categoryId
    };
  });
}

function createExtraFeaturesFilters(accommodationsSets) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, uniqBy_default()('id')])(accommodationsSets);

  var strengths = pipe_default()([map_default()(path_default()('strengths')), flatten_default.a, compact_default.a, uniqBy_default()('id')])(accommodations);

  var views = pipe_default()([map_default()(path_default()('view')), compact_default.a, uniqBy_default()('id')])(accommodations);

  var features = [].concat(Object(toConsumableArray["a" /* default */])(strengths), Object(toConsumableArray["a" /* default */])(views));
  return features.map(function (feature) {
    return {
      id: shortid_default.a.generate(),
      category: EXTRA_FEATURES_CATEGORY,
      match: feature.id === REDUCED_MOBILITY_FILTER_ID ? matchExtraFeaturesReducedMobility : filterUtils_matchExtraFeatures,
      meta: {
        label: feature.label,
        icon: icons["a" /* ICONS */][feature.id],
        iconClassName: "icon--".concat(feature.id),
        iconInheritColor: true
      },
      path: 'accommodations',
      selected: false,
      value: feature.id
    };
  });
}

function handleReducedMobilityFilter(accommodationsSets, reducedMobilityVisibility, state) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, uniqBy_default()('id')])(accommodationsSets);

  var isReducedMobility = accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
  var matchedReducedMobility = isReducedMobility ? accommodationsSets.filter(function (filteredAccomodation) {
    return filteredAccomodation.accommodations.filter(function (acc) {
      return acc.reducedMobilityAccess === true;
    }).length > 0;
  }).length : 0;
  var newItem = {
    id: shortid_default.a.generate(),
    category: EXTRA_FEATURES_CATEGORY,
    match: matchExtraFeaturesReducedMobility,
    matchedOccurrences: matchedReducedMobility,
    meta: {
      label: Object(i18n["h" /* t */])('filters.reducedMobility'),
      icon: icons["a" /* ICONS */].reduced_mobility_access,
      iconClassName: 'icon--reduced_mobility_access',
      iconInheritColor: true
    },
    path: 'accommodations',
    selected: false,
    value: 'reduced_mobility_access'
  };
  return !reducedMobilityVisibility ? [].concat(Object(toConsumableArray["a" /* default */])(state), [newItem]) : state.filter(function (feature) {
    return feature.value !== 'reduced_mobility_access';
  });
}

function createFilters(accommodationsSets, product) {
  return [].concat(Object(toConsumableArray["a" /* default */])(createExtraFeaturesFilters(accommodationsSets)), Object(toConsumableArray["a" /* default */])(createConfigurationFilters(accommodationsSets, product)), Object(toConsumableArray["a" /* default */])(createComfortFilters(accommodationsSets)));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (filter) {
      return _objectSpread(_objectSpread({}, filter), {}, {
        selected: filter.category === category ? false : filter.selected
      });
    });
  };
}

var filterUtils_updateFilters = function updateFilters(_ref3, dispatch, setVisibility) {
  var accommodationsSets = _ref3.accommodationsSets,
      filterValues = _ref3.filterValues,
      visibility = _ref3.visibility;
  return function (name, opts, updatedValue) {
    if (filterValues && updatedValue) {
      var f = filterValues.find(function (v) {
        return v.value === updatedValue;
      });

      if (f) {
        dispatch(Object(additionalAccommodations_action["o" /* toggleAdditionalAccommodationFilter */])(f));
      }
    } else {
      setVisibility(function (shown) {
        return !shown;
      });
      dispatch(Object(additionalAccommodations_action["q" /* togglePMRChecbox */])(!visibility, filterValues));

      if (opts.length === 1 && opts[0] === 'reduced_mobility_access' && visibility) {
        var _f = filterValues.find(function (v) {
          return v.value === 'reduced_mobility_access';
        });

        dispatch(Object(additionalAccommodations_action["p" /* toggleAdditionalAccommodationReducedMobilityFilter */])(accommodationsSets, visibility));

        if (_f) {
          dispatch(Object(additionalAccommodations_action["o" /* toggleAdditionalAccommodationFilter */])(_f));
        }
      } else {
        dispatch(Object(additionalAccommodations_action["p" /* toggleAdditionalAccommodationReducedMobilityFilter */])(accommodationsSets, visibility));
      }
    }
  };
};


/***/ }),

/***/ "L3kw":
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__("7IvJ")
var des = __webpack_require__("cQOy")
var inherits = __webpack_require__("qW1w")
var Buffer = __webpack_require__("KLyV").Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),

/***/ "L7Jg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("r2q8").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("6kWf");
/*</replacement>*/

var Buffer = __webpack_require__("+ZX+").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(2);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__("ibuU");
var destroyImpl = __webpack_require__("tizd");
var _require = __webpack_require__("nnjZ"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__("VYiD").codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__("qW1w")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("ekAB");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("2wQW").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__("ekAB");
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("2wQW").StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__("PRbV");
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__("6PUI");
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq"), __webpack_require__("F63i")))

/***/ }),

/***/ "LVnT":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('compact', __webpack_require__("3dHC"), __webpack_require__("zUlE"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "LhnV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TermsAndConditions; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ljKo");
/* harmony import */ var _frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DwNm");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("MWZw");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("RUiN");
/* harmony import */ var _utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("aWOT");
/* harmony import */ var _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("BU6i");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("kiXb");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("/HC4");






var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;











var TermsAndConditions = function TermsAndConditions(_ref) {
  var _formik$errors, _formik$errors$termsA, _formik$touched, _formik$touched$terms, _formik$errors2, _formik$errors2$terms, _formik$touched2, _formik$touched2$term;

  var i18n = _ref.i18n,
      shouldDisplayDonationTerms = _ref.shouldDisplayDonationTerms,
      shouldSubmitFormOnAccept = _ref.shouldSubmitFormOnAccept,
      isDisabled = _ref.isDisabled,
      _ref$hasNoPaymentMeth = _ref.hasNoPaymentMethods,
      hasNoPaymentMethods = _ref$hasNoPaymentMeth === void 0 ? false : _ref$hasNoPaymentMeth;
  var formik = Object(formik__WEBPACK_IMPORTED_MODULE_7__[/* useFormikContext */ "e"])();
  var legalMessage = Object(_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_11__[/* getCGVFromLegalInfos */ "d"])(i18n.bookingProcess);

  var submitFormOnAccept = function submitFormOnAccept(_ref2) {
    var currentTarget = _ref2.currentTarget;
    var shouldProceedToSubmit = currentTarget.checked && (!shouldDisplayDonationTerms || formik.values.termsAndConditions.donation || formik.values.termsAndConditions.cgv);

    if (shouldSubmitFormOnAccept && shouldProceedToSubmit && formik.values.paymentMethodId) {
      // submit form if asked and all the cgv are checked and a paymentMethodId is selected
      // should wait for validation to be done
      setTimeout(formik.submitForm, 0);
    }

    if (hasNoPaymentMethods && shouldProceedToSubmit && formik.values.paymentProviderId === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_12__[/* HIPAY_PSP_ID */ "f"]) {
      setTimeout(function () {
        Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_10__[/* scrollToElement */ "a"])('#payment-form-iframe');
      }, 500);
    }
  };

  var hasCGVOrDonationError = ((_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : (_formik$errors$termsA = _formik$errors.termsAndConditions) === null || _formik$errors$termsA === void 0 ? void 0 : _formik$errors$termsA.cgv) && ((_formik$touched = formik.touched) === null || _formik$touched === void 0 ? void 0 : (_formik$touched$terms = _formik$touched.termsAndConditions) === null || _formik$touched$terms === void 0 ? void 0 : _formik$touched$terms.cgv) || ((_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : (_formik$errors2$terms = _formik$errors2.termsAndConditions) === null || _formik$errors2$terms === void 0 ? void 0 : _formik$errors2$terms.donation) && ((_formik$touched2 = formik.touched) === null || _formik$touched2 === void 0 ? void 0 : (_formik$touched2$term = _formik$touched2.termsAndConditions) === null || _formik$touched2$term === void 0 ? void 0 : _formik$touched2$term.donation);
  var checkboxProps = {
    isDisabled: isDisabled,
    isRequired: true,
    onChange: submitFormOnAccept,
    type: 'checkbox',
    validate: yup__WEBPACK_IMPORTED_MODULE_14__["boolean"]().oneOf([true]),
    ariaDescribedBy: 'termsAndConditions-cgv-error'
  };
  return __jsx("div", {
    "data-testid": "CGV-block"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_9__[/* Title */ "a"], {
    className: "mb-10",
    id: "termsAndConditionsTitleId",
    theme: "title-brand-n2"
  }, legalMessage.label), __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_15__[/* Capsule */ "a"], {
    header: "none",
    contentClassName: "p-20"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_16__[/* FormikInput */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])({}, checkboxProps, {
    label: __jsx(react__WEBPACK_IMPORTED_MODULE_6___default.a.Fragment, null, __jsx("span", null, legalMessage.description), __jsx("br", null), __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('booking.banking.termsAndConditions.acceptCGV'), "\xA0", __jsx("a", {
      className: "text-inherit underline",
      href: legalMessage.url,
      rel: "noreferrer noopener",
      target: "_blank"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('booking.banking.termsAndConditions.termsOfSales')))),
    name: "termsAndConditions.cgv"
  })), shouldDisplayDonationTerms && __jsx("div", {
    className: "mt-20"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_16__[/* FormikInput */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])({}, checkboxProps, {
    label: __jsx(react__WEBPACK_IMPORTED_MODULE_6___default.a.Fragment, null, Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('booking.banking.donation.acceptCGU'), "\xA0", __jsx("a", {
      className: "text-inherit underline",
      href: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('booking.banking.donation.linkDonationTerms'),
      rel: "noreferrer noopener",
      target: "_blank"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('booking.banking.donation.donationTerms'))),
    name: "termsAndConditions.donation"
  })))), hasCGVOrDonationError && __jsx("div", {
    "aria-live": "polite",
    id: "termsAndConditions-cgv-error"
  }, __jsx(_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_8__[/* FormFeedback */ "a"], {
    isError: true,
    message: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('booking.banking.termsAndConditions.errorMessage')
  })));
};

/***/ }),

/***/ "LoHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildcareOnDemandEquipmentCapsule; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_product_product_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C9cF");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("gA51");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;







var EQUIPMENT_ID_MAPPING = {
  ACT_CANC_CHILD_baby_sitting: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].BABYSITTING,
  ACT_CANC_CHILD_pyjamas_club: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].PAJAMAS,
  ACT_CANC_CHILD_teen_spa: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].SPA,
  ACT_CANC_CHILD_swimming_lessons: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].SWIMMINGPOOL,
  ACT_CANC_CHILD_pleasures_of_snow_course: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].SKI
};
var ChildcareOnDemandEquipmentCapsule = function ChildcareOnDemandEquipmentCapsule(_ref) {
  var activities = _ref.activities,
      isSeller = _ref.isSeller;
  return __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_7__[/* Capsule */ "a"], {
    className: "mb-100",
    color: "#924833",
    header: "large",
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.childcarePopIn.onDemandChildcare')
  }, __jsx("p", {
    className: "p-20 text-14 font-bold"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])(isSeller ? 'booking.partners.services.childcare.additionalServicesReassuranceMessage' : 'booking.services.childcare.additionalServicesReassuranceMessage')), activities.map(function (activity) {
    return __jsx("div", {
      className: "border-t-1 border-lightGrey font-bold",
      key: activity.id
    }, __jsx(_frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_8__[/* CollapsePanel */ "a"], {
      collapseIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ARROW_DOWN,
      expandIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ARROW_DOWN,
      theme: "limpidSmall",
      title: __jsx("span", {
        className: "flex items-center gap-15 text-14 font-bold text-sienna"
      }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
        className: "shrink-0",
        name: EQUIPMENT_ID_MAPPING[activity.id] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].TRIDENT1,
        width: "1.875rem"
      }), __jsx("span", null, activity.label, !!activity.ageInMonths && __jsx("span", {
        className: "block text-12 font-normal text-black"
      }, Object(_utils_product_product_utils__WEBPACK_IMPORTED_MODULE_5__[/* getServiceAgesLabel */ "f"])(activity.ageInMonths))))
    }, __jsx("p", {
      className: "p-20 pt-0 text-14 font-normal leading-tight"
    }, activity.description)));
  }));
};

/***/ }),

/***/ "M/0w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInfoBannerQuery; });
var getInfoBannerQuery = function getInfoBannerQuery(productId) {
  return "query {\n    productInformationBanners(productId:\"".concat(productId, "\") {\n        productId\n        salesChannel {\n          context\n          tags\n        }\n        countdown {\n          dateTimeEnd\n          daysLabel\n          hoursLabel\n          minutesLabel\n          secondsLabel\n        }\n        popin {\n          title\n          subtitle\n          text: description\n          buttonLabel\n          url\n          image\n          color\n        }\n        startDate\n        endDate\n        toaster {\n          title\n          subtitle: description\n          iconName\n          illustration: picto\n          color\n        }\n    }\n  }");
};

/***/ }),

/***/ "M3jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTransport; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C/y5");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1JJ2");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("7amT");





var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

/* eslint-disable clubmed/no-fake-component */








var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["constants"].NO_TRANSPORT_VALUE;
var FilterTransport = function FilterTransport(_ref) {
  var changeDepartureCity = _ref.changeDepartureCity,
      className = _ref.className,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'FilterTransport' : _ref$dataTestId,
      departureCity = _ref.departureCity,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      optionsDepartureCities = _ref.optionsDepartureCities,
      toggleCriteriaExpansion = _ref.toggleCriteriaExpansion,
      validateDepartureCity = _ref.validateDepartureCity,
      withNoTransport = _ref.withNoTransport,
      _ref$shouldShowNoTran = _ref.shouldShowNoTransportButtonMobile,
      shouldShowNoTransportButtonMobile = _ref$shouldShowNoTran === void 0 ? true : _ref$shouldShowNoTran;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var value = departureCity || '';
  var loading = isLoading || optionsDepartureCities.length === 0;
  var otherDepartureCities = withNoTransport ? optionsDepartureCities : optionsDepartureCities.filter(function (_ref2) {
    var departureCityCode = _ref2.value;
    return departureCityCode !== NO_TRANSPORT_VALUE;
  });
  var mainCities = Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* getListValue */ "e"])('faceting.transport.departureCities.mainCitiesList') || [];
  var optionsMainDepartureCities = optionsDepartureCities.filter(function (_ref3) {
    var cityCode = _ref3.value;
    return mainCities.includes(cityCode);
  });

  var renderTitle = function renderTitle(shouldShowNoTransportButton) {
    if (!isDesktop) {
      return __jsx("div", {
        className: "flex flex-col"
      }, shouldShowNoTransportButton && __jsx("div", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('px-20 py-15', {
          'font-bold text-success': value === NO_TRANSPORT_VALUE
        })
      }, __jsx("label", {
        className: "flex cursor-pointer items-baseline justify-between rounded-2 hocus:bg-lightGrey",
        htmlFor: NO_TRANSPORT_VALUE
      }, __jsx("input", {
        checked: value === NO_TRANSPORT_VALUE,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(NO_TRANSPORT_VALUE),
        disabled: isDisabled,
        id: NO_TRANSPORT_VALUE,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        onClick: function onClick(e) {
          return validateDepartureCity(e.target.value);
        },
        type: "radio",
        value: NO_TRANSPORT_VALUE
      }), Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.noTransportNeededMobile'), value === NO_TRANSPORT_VALUE && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      }))), __jsx("div", {
        className: "border-b-1 border-lightGrey p-20 py-15"
      }, __jsx("p", {
        className: "text-16 font-bold"
      }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.transportNeededMobile'))));
    }

    return __jsx("div", {
      className: "border-b-1 border-lightGrey p-20 py-15"
    }, __jsx("p", {
      className: "text-16 font-bold"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.when.from')));
  };

  var renderDepartureCitiesOptions = function renderDepartureCitiesOptions(departureCities) {
    return departureCities.map(function (o) {
      return __jsx("li", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])({
          'font-bold text-success': o.value === value
        }),
        key: o.value,
        "data-testid": "filterTransport-city"
      }, __jsx("label", {
        className: "-mx-20 flex cursor-pointer items-baseline justify-between rounded-2 px-20 py-5 hocus:bg-lightGrey",
        htmlFor: o.value
      }, __jsx("input", {
        checked: o.value === value,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(o.value),
        disabled: o.isDisabled || isDisabled,
        id: o.value,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        type: "radio",
        value: o.value
      }), o.label, o.value === value && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      })));
    });
  };

  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('flex flex-col', className),
    "data-testid": "FilterTransport"
  }, renderTitle(shouldShowNoTransportButtonMobile), loading ? __jsx("div", {
    className: "flex flex-1 items-center justify-center p-20 leading-0"
  }, __jsx(_frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__[/* Spinner */ "a"], {
    size: "small"
  })) : __jsx("div", {
    className: "max-h-none overflow-y-auto px-20 text-14 lg:max-h-240"
  }, optionsMainDepartureCities.length > 0 && __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx("p", {
    className: "border-b-1 border-dashed border-grey py-5 text-mediumGrey"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.mainCities')), __jsx("ul", {
    className: "mb-10 flex-1 pb-5 lg:flex-none"
  }, renderDepartureCitiesOptions(optionsMainDepartureCities)), __jsx("p", {
    className: "border-b-1 border-dashed border-grey py-5 text-mediumGrey"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.allCities'))), __jsx("ul", {
    className: "flex-1 lg:flex-none"
  }, renderDepartureCitiesOptions(otherDepartureCities))));
};

/***/ }),

/***/ "MUzb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ UserAddressForm_UserAddressForm; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("LqLs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 14 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var constants = __webpack_require__("ZOp8");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// CONCATENATED MODULE: ./src/client/components/widgets/user-address-form/UserAddressForm.utils.js


var ADDRESS_FIELDS_ORDER = ['streetNumber', 'streetName', 'zipCode', 'city', 'additionalInformation1', 'additionalInformation2', 'addOn', 'town', 'stateOrDistrict', 'countryCode'];
var fieldsSort = function fieldsSort(field1, field2) {
  return ADDRESS_FIELDS_ORDER.indexOf(field1.name) - ADDRESS_FIELDS_ORDER.indexOf(field2.name);
};
// CONCATENATED MODULE: ./src/client/components/widgets/user-address-form/UserAddressForm.jsx














var __jsx = react_default.a.createElement;











var MAIN_FIELDS_NAMES = ['streetNumber', 'streetName', 'zipCode', 'city', 'stateOrDistrict'];
var IGNORED_FIELDS = ['countryCode', 'health_pass_id'];

var UserAddressForm_AddressInput = function AddressInput(_ref) {
  var _computedOptions;

  var autoComplete = _ref.autoComplete,
      fieldName = _ref.fieldName,
      fieldsValues = _ref.fieldsValues,
      options = _ref.options,
      _ref$hideErrorMessage = _ref.hideErrorMessage,
      hideErrorMessage = _ref$hideErrorMessage === void 0 ? false : _ref$hideErrorMessage,
      _ref$isCountry = _ref.isCountry,
      isCountry = _ref$isCountry === void 0 ? false : _ref$isCountry,
      _ref$fetchCountriesFr = _ref.fetchCountriesFromApi,
      fetchCountriesFromApi = _ref$fetchCountriesFr === void 0 ? false : _ref$fetchCountriesFr,
      countriesData = _ref.countriesData,
      _ref$isLoadingCountri = _ref.isLoadingCountries,
      isLoadingCountries = _ref$isLoadingCountri === void 0 ? false : _ref$isLoadingCountri,
      _ref$namePrefix = _ref.namePrefix,
      namePrefix = _ref$namePrefix === void 0 ? '' : _ref$namePrefix,
      onKeyDown = _ref.onKeyDown,
      required = _ref.required,
      validator = _ref.validator;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var computedOptions = options || [];

  if (isCountry) {
    // Get locale-specific countries from domainsService
    var getLocaleSpecificCountries = function getLocaleSpecificCountries() {
      return dist_default.a.getLocaleCountries(locale).map(function (_ref2) {
        var code = _ref2.code,
            name = _ref2.name;
        return {
          value: code,
          name: name
        };
      });
    };

    if (fetchCountriesFromApi && countriesData) {
      // Get locale countries for top of the list
      var localeCountries = getLocaleSpecificCountries();
      var localeCountryCodes = new Set(localeCountries.map(function (c) {
        return c.value;
      })); // Filter API countries to exclude locale countries

      var otherCountries = countriesData.filter(function (country) {
        return !localeCountryCodes.has(country.value);
      }); // Add separator between locale and other countries

      var separator = {
        value: '',
        name: '─────────────────────────',
        isDisabled: true
      }; // Combine: locale countries + separator + other countries from API

      computedOptions = [].concat(Object(toConsumableArray["a" /* default */])(localeCountries), [separator], Object(toConsumableArray["a" /* default */])(otherCountries));
    } else if (!fetchCountriesFromApi) {
      // Use countries from domainsService only
      computedOptions = getLocaleSpecificCountries();
    }
  }

  var shouldValidate = required || validator && (fieldsValues === null || fieldsValues === void 0 ? void 0 : fieldsValues[fieldName]) !== '';

  if (fetchCountriesFromApi && isCountry && isLoadingCountries) {
    return __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('p-10', constants["b" /* ADDRESS_FIELDS_CLASSES */][fieldName] || 'w-full')
    }, __jsx(FormikInput["a" /* FormikInput */], {
      autoComplete: autoComplete,
      hideErrorMessage: hideErrorMessage,
      isDisabled: true,
      isRequired: !!required,
      label: Object(i18n["h" /* t */])("common.participants.address.".concat(fieldName)),
      name: "".concat(namePrefix).concat(fieldName),
      onKeyDown: onKeyDown,
      options: [],
      placeholder: Object(i18n["h" /* t */])('common.participants.address.selectCountry.label'),
      type: "select" // $FlowFixMe
      ,
      validate: shouldValidate ? validator : false
    }));
  }

  return (// $FlowFixMe : flow does not understand fallback
    __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('p-10', constants["b" /* ADDRESS_FIELDS_CLASSES */][fieldName] || 'w-full')
    }, __jsx(FormikInput["a" /* FormikInput */], {
      autoComplete: autoComplete,
      hideErrorMessage: hideErrorMessage,
      isDisabled: computedOptions.length === 1,
      isRequired: !!required,
      label: Object(i18n["h" /* t */])("common.participants.address.".concat(fieldName)),
      name: "".concat(namePrefix).concat(fieldName),
      onKeyDown: onKeyDown,
      options: computedOptions,
      placeholder: isCountry ? Object(i18n["h" /* t */])('common.participants.address.selectCountry.label') : undefined,
      type: ((_computedOptions = computedOptions) === null || _computedOptions === void 0 ? void 0 : _computedOptions.length) ? 'select' : 'text' // $FlowFixMe
      ,
      validate: shouldValidate ? validator : false
    }))
  );
};

var UserAddressForm_AdditionalAddress = function AdditionalAddress(_ref3) {
  var _ref3$hideErrorMessag = _ref3.hideErrorMessage,
      hideErrorMessage = _ref3$hideErrorMessag === void 0 ? false : _ref3$hideErrorMessag,
      isExpanded = _ref3.isExpanded,
      additionnalFields = _ref3.additionnalFields,
      setIsExpanded = _ref3.setIsExpanded,
      fieldsValues = _ref3.fieldsValues,
      namePrefix = _ref3.namePrefix,
      onKeyDown = _ref3.onKeyDown,
      validators = _ref3.validators;
  return __jsx(react["Fragment"], null, __jsx(lib["UnmountClosed"], {
    isOpened: isExpanded,
    theme: {
      collapse: 'collapse-transition w-full',
      content: 'pt-20'
    }
  }, additionnalFields.map(function (_ref4) {
    var fieldName = _ref4.name,
        required = _ref4.required;
    return __jsx(UserAddressForm_AddressInput, {
      autoComplete: "nope",
      fieldName: fieldName,
      fieldsValues: fieldsValues,
      hideErrorMessage: hideErrorMessage,
      key: fieldName,
      namePrefix: namePrefix,
      onKeyDown: onKeyDown,
      required: required,
      validator: validators === null || validators === void 0 ? void 0 : validators[fieldName]
    });
  })), __jsx("button", {
    "data-testid": "participants-collapsable",
    className: "ms-auto flex items-center gap-5 p-10 pb-0 text-14 text-black underline",
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    },
    type: "button"
  }, isExpanded ? Object(i18n["h" /* t */])('common.close') : Object(i18n["h" /* t */])('common.participants.address.additionalInformationLegend'), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    rotation: isExpanded ? 180 : 0,
    width: "0.5em"
  })));
};

var UserAddressForm_UserAddressForm = function UserAddressForm(_ref5) {
  var _sortedFields$find;

  var fields = _ref5.fields,
      fieldsValues = _ref5.fieldsValues,
      _ref5$hideErrorMessag = _ref5.hideErrorMessage,
      hideErrorMessage = _ref5$hideErrorMessag === void 0 ? false : _ref5$hideErrorMessag,
      _ref5$fetchCountriesF = _ref5.fetchCountriesFromApi,
      fetchCountriesFromApi = _ref5$fetchCountriesF === void 0 ? false : _ref5$fetchCountriesF,
      countriesDataProp = _ref5.countriesData,
      _ref5$isLoadingCountr = _ref5.isLoadingCountries,
      isLoadingCountriesProp = _ref5$isLoadingCountr === void 0 ? false : _ref5$isLoadingCountr,
      namePrefix = _ref5.namePrefix,
      onKeyDown = _ref5.onKeyDown,
      validators = _ref5.validators;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var sortedFields = fields.sort(fieldsSort);
  var mainFields = sortedFields.filter(function (f) {
    return (MAIN_FIELDS_NAMES.includes(f.name) || f.required) && !IGNORED_FIELDS.includes(f.name);
  });
  var additionnalFields = sortedFields.filter(function (f) {
    return !MAIN_FIELDS_NAMES.includes(f.name) && !IGNORED_FIELDS.includes(f.name) && !f.required;
  });
  var hasAdditionalAddress = additionnalFields.length > 0;
  return __jsx(react["Fragment"], null, mainFields.map(function (_ref6) {
    var fieldName = _ref6.name,
        required = _ref6.required,
        values = _ref6.values;
    return __jsx(UserAddressForm_AddressInput, Object(esm_extends["a" /* default */])({}, fieldName === 'streetNumber' ? {
      autoComplete: 'nope'
    } : null, {
      fieldName: fieldName,
      fieldsValues: fieldsValues,
      options: values === null || values === void 0 ? void 0 : values.map(function (_ref7) {
        var code = _ref7.code,
            label = _ref7.label;
        return {
          name: label,
          value: code
        };
      }),
      hideErrorMessage: hideErrorMessage,
      key: fieldName,
      namePrefix: namePrefix,
      onKeyDown: onKeyDown,
      required: required,
      validator: validators === null || validators === void 0 ? void 0 : validators[fieldName]
    }));
  }), hasAdditionalAddress && __jsx(UserAddressForm_AdditionalAddress, {
    isExpanded: isExpanded,
    additionnalFields: additionnalFields,
    setIsExpanded: setIsExpanded,
    fieldsValues: fieldsValues,
    namePrefix: namePrefix,
    onKeyDown: onKeyDown,
    validators: validators
  }), __jsx(UserAddressForm_AddressInput, {
    fieldName: "countryCode",
    fieldsValues: fieldsValues,
    isCountry: true,
    fetchCountriesFromApi: fetchCountriesFromApi,
    countriesData: countriesDataProp,
    isLoadingCountries: isLoadingCountriesProp,
    namePrefix: namePrefix,
    required: (_sortedFields$find = sortedFields.find(function (f) {
      return f.name === 'countryCode';
    })) === null || _sortedFields$find === void 0 ? void 0 : _sortedFields$find.required,
    validator: validators === null || validators === void 0 ? void 0 : validators.countryCode
  }));
};

/***/ }),

/***/ "NKBa":
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.5.4\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

/***/ }),

/***/ "NN9k":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__("jggy")
var BN = __webpack_require__("nXZ9")

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("+ZX+").Buffer))

/***/ }),

/***/ "NhVp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__("X05J");
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        pna.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        pna.nextTick(emitErrorNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, _this, err);
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ "NiGL":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("KLyV").Buffer
var xor = __webpack_require__("sPPR")

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),

/***/ "O7yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_OPTION_VALIDITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSET_OPTION_VALIDITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return optionValidityReducer; });
var SET_OPTION_VALIDITY = 'SET_OPTION_VALIDITY';
var UNSET_OPTION_VALIDITY = 'UNSET_OPTION_VALIDITY';
var initialState = null;
var optionValidityReducer = function optionValidityReducer() {
  var _action$payload$local, _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_OPTION_VALIDITY:
      /**
       * TODO: fix async tests with payload missing
       * broke:
       * - src/client/components/widgets/price-remote/PriceRemote.spec.js
       * - src/client/views/booking/booking-confirmation/BookingConfirmationView.spec.js
       */
      return (_action$payload$local = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.locale.optionValidity) !== null && _action$payload$local !== void 0 ? _action$payload$local : null;

    case UNSET_OPTION_VALIDITY:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "OTqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RentalsBooking; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rentals_Rentals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("3AZ6");
/* harmony import */ var _context_ServicesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2Odu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var RentalsBooking = function RentalsBooking(_ref) {
  var contextValue = _ref.contextValue,
      rentals = _ref.rentals,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["contextValue", "rentals"]);

  return __jsx(_context_ServicesContext__WEBPACK_IMPORTED_MODULE_4__[/* ServicesContext */ "a"].Provider, {
    value: contextValue
  }, __jsx(_rentals_Rentals__WEBPACK_IMPORTED_MODULE_3__[/* Rentals */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    rentalsTree: rentals
  })));
};

/***/ }),

/***/ "OX+y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = __webpack_require__("1037").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ "OwY5":
/***/ (function(module, exports, __webpack_require__) {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = __webpack_require__("KLyV").Buffer
var createHmac = __webpack_require__("A8dA")
var crt = __webpack_require__("ZsTA")
var EC = __webpack_require__("jggy").ec
var BN = __webpack_require__("zuLC")
var parseKeys = __webpack_require__("cJUb")
var curves = __webpack_require__("gbEP")

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [0, 1]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return Buffer.from(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [0].concat(r)
  if (s[0] & 0x80) s = [0].concat(s)

  var total = r.length + s.length + 4
  var res = [0x30, total, 0x02, r.length]
  res = res.concat(r, [0x02, s.length], s)
  return Buffer.from(res)
}

function getKey (x, q, hash, algo) {
  x = Buffer.from(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length)
    x = Buffer.concat([zeros, x])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = Buffer.alloc(hlen)
  v.fill(1)
  var k = Buffer.alloc(hlen)
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = Buffer.from(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length)
    out = Buffer.concat([zeros, out])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = Buffer.alloc(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([t, kv.v])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey


/***/ }),

/***/ "PRbV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__("FRav");
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "PwcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTENDEES_ROLES; });
/* unused harmony export getAttendeeValidationSchema */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAttendeeValidationSchemaByRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAddressValidationSchema; });
/* unused harmony export getAttendeesValidationSchema */
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zygG");


var ATTENDEES_ROLES = {
  MAIN: 'MAIN',
  OTHER_ADULT: 'OTHER_ADULT',
  KID: 'KID'
};

var getAttendeeValidationSchema = function getAttendeeValidationSchema(role) {
  return function (_ref) {
    var validationSchema = _ref.validationSchema;

    if (Object(ATTENDEES_ROLES).hasOwnProperty(role)) {
      return validationSchema[role];
    }

    throw new Error('USER ROLE DOES NOT EXIST');
  };
};

var getAttendeeValidationSchemaByRole = function getAttendeeValidationSchemaByRole(isMain, isChild) {
  var role = ATTENDEES_ROLES.OTHER_ADULT;

  if (isChild) {
    role = ATTENDEES_ROLES.KID;
  } else if (isMain) {
    role = ATTENDEES_ROLES.MAIN;
  }

  return getAttendeeValidationSchema(role);
};

var getAddressValidationSchema = function getAddressValidationSchema(_ref2) {
  var validationSchema = _ref2.validationSchema;
  return validationSchema.address;
};

var getAttendeesValidationSchema = function getAttendeesValidationSchema(_ref3) {
  var validationSchema = _ref3.validationSchema;
  var schemaByType = {};

  for (var _i = 0, _Object$entries = Object.entries(validationSchema); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        schema = _Object$entries$_i[1];

    if (Object(ATTENDEES_ROLES).hasOwnProperty(key)) {
      schemaByType[key] = schema;
    }
  }

  return schemaByType;
};



/***/ }),

/***/ "PxjX":
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__("aeZB")
var Buffer = __webpack_require__("KLyV").Buffer
var MODES = __webpack_require__("gEL7")
var StreamCipher = __webpack_require__("y0P9")
var Transform = __webpack_require__("7IvJ")
var aes = __webpack_require__("4Z+A")
var ebtk = __webpack_require__("JvEg")
var inherits = __webpack_require__("qW1w")

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),

/***/ "Q10v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AccommodationOption_AccommodationOption; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-option/AccommodationOptionPrice.jsx
var __jsx = react_default.a.createElement;






var AccommodationOptionPrice_AccommodationOptionPrice = function AccommodationOptionPrice(_ref) {
  var className = _ref.className,
      currency = _ref.currency,
      nigthly = _ref.nigthly,
      total = _ref.total,
      _ref$isUpgradableOnli = _ref.isUpgradableOnline,
      isUpgradableOnline = _ref$isUpgradableOnli === void 0 ? true : _ref$isUpgradableOnli;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var locale = appContext.locale;
  var displayPricePerNightB2C = Object(i18n["d" /* getKeyValue */])('booking.accommodation.moreRooms.displayPricePerNight_B2C');
  var displayPricePerNightB2B = Object(i18n["d" /* getKeyValue */])('booking.accommodation.moreRooms.displayPricePerNight_B2B');
  var displayPricePerNight = !Object(sellerUtils["f" /* isSeller */])(appContext) && displayPricePerNightB2C || Object(sellerUtils["f" /* isSeller */])(appContext) && displayPricePerNightB2B;
  var testId;
  var labelText;

  if (!isUpgradableOnline) {
    testId = 'AccommodationOptionPrice-notUpgradable';
    labelText = Object(i18n["h" /* t */])('booking.accommodation.upgradeRoom.villaPricing');
  } else if (displayPricePerNight && nigthly !== 0) {
    testId = 'AccommodationOptionPrice-perNight';
    labelText = Object(i18n["h" /* t */])('booking.accommodation.moreRooms.perNight');
  } else if (total === 0) {
    testId = 'AccommodationOptionPrice-mention';
    labelText = Object(i18n["h" /* t */])('booking.accommodation.moreRooms.includedRoom');
  }

  var label = labelText ? __jsx("span", {
    "data-testid": testId
  }, labelText) : '';
  return __jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])('flex font-bold gap-5 text-18 text-sienna', className),
    "data-testid": "AccommodationOptionPrice"
  }, isUpgradableOnline && Object(proposalUtils["e" /* getFormatedPriceByLocale */])(displayPricePerNight ? nigthly : total, locale, currency), label);
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-option/AccommodationOption.jsx
var AccommodationOption_jsx = react_default.a.createElement;






var AccommodationOption_AccommodationOption = function AccommodationOption(_ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      onSelect = _ref.onSelect,
      price = _ref.price;
  return AccommodationOption_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate rounded-12 border-1 border-lightGrey bg-white', className),
    "data-testid": "AccommodationOption",
    id: id
  }, AccommodationOption_jsx("div", {
    className: "absolute bottom-full z-1 mx-10"
  }, AccommodationOption_jsx(StripButton["a" /* StripButton */], {
    className: "font-sans text-10",
    height: 20
  }, Object(i18n["h" /* t */])('common.proposalLabel'), "\xA0", index)), children, AccommodationOption_jsx("div", {
    className: "flex items-center justify-end gap-10 border-t-1 border-lightGrey p-20",
    "data-testid": "AccommodationOption-footer"
  }, AccommodationOption_jsx(AccommodationOptionPrice_AccommodationOptionPrice, price), AccommodationOption_jsx(Button["a" /* Button */], {
    className: "w-auto",
    "data-testid": "AccommodationOption-select",
    onClick: onSelect
  }, (price === null || price === void 0 ? void 0 : price.isUpgradableOnline) ? Object(i18n["h" /* t */])('booking.accommodation.moreRooms.selectNewRoom') : Object(i18n["h" /* t */])('booking.accommodation.upgradeRoom.contactATED'))));
};

/***/ }),

/***/ "Q8Qh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("C/y5");

var themes = function themes(_ref) {
  var _ref$hasArrow = _ref.hasArrow,
      hasArrow = _ref$hasArrow === void 0 ? true : _ref$hasArrow;
  return {
    "default": {
      thBody: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_0__[/* classnames */ "a"])('bg-white border-1 border-lightGrey mt-15 p-10 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-grey': hasArrow
      })
    },
    hollow: {
      thBody: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_0__[/* classnames */ "a"])('bg-white border-1 border-lightGrey rounded-12 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-lightGrey': hasArrow
      })
    }
  };
};

/***/ }),

/***/ "QkOM":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9JhN");
var trim = __webpack_require__("Ya2h").trim;
var whitespaces = __webpack_require__("+/eK");

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "QoQd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("nXZ9");
var utils = __webpack_require__("EmIl");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),

/***/ "Quze":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const encoders = exports;

encoders.der = __webpack_require__("1sYr");
encoders.pem = __webpack_require__("cg3U");


/***/ }),

/***/ "RCYE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("EmIl");
var BN = __webpack_require__("nXZ9");
var inherits = __webpack_require__("qW1w");
var Base = __webpack_require__("QoQd");

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),

/***/ "RHTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Sheet; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx + 7 modules
var Multimedia = __webpack_require__("h3D+");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasDiamond = _ref.hasDiamond,
        hasSlideshow = _ref.hasSlideshow,
        isExclusiveCollection = _ref.isExclusiveCollection,
        fullWidthContent = _ref.fullWidthContent;
    return {
      thRoot: 'bg-white',
      thHeader: '',
      thHeaderContainer: 'mx-auto w-full max-w-site-medium',
      thTop: Object(classnames_utils["a" /* classnames */])('relative', {
        'mb-35 lg:mb-55': hasDiamond,
        'md:mb-[11px] md:mt-54': !hasDiamond
      }),
      thHero: hasSlideshow ? 'absolute overflow-hidden inset-0' : '',
      thHeroImmersive: hasSlideshow ? 'min-h-[102%] filter-[blur(10px)] opacity-25' : '',
      thSlideshow: "my-0 mx-auto w-full ".concat(isExclusiveCollection ? 'bg-ultramarine' : 'bg-darkGrey'),
      thMultimediaOverlay: 'absolute inset-0 mb-10',
      thDiamond: 'absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 -mb-2',
      thDiamondClassName: 'font-bold uppercase text-10 sm:text-12 size-60 lg:size-75',
      thBody: "".concat(fullWidthContent ? '' : 'px-20', " py-20 lg:py-15"),
      thContent: "".concat(fullWidthContent ? '' : 'max-w-site-medium', " mx-auto w-full"),
      thFooter: 'bg-pearl overflow-hidden px-20'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.jsx



var __jsx = react_default.a.createElement;









function Sheet(_ref) {
  var children = _ref.children,
      header = _ref.header,
      className = _ref.className,
      diamond = _ref.diamond,
      immersive = _ref.immersive,
      isExclusiveCollection = _ref.isExclusiveCollection,
      footer = _ref.footer,
      fullWidthContent = _ref.fullWidthContent,
      multimedia = _ref.multimedia,
      _ref$slideshow = _ref.slideshow,
      slideshow = _ref$slideshow === void 0 ? {} : _ref$slideshow,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useState = Object(react["useState"])(0),
      imageIndex = _useState[0],
      setImageIndex = _useState[1];

  if (!react["Children"].count(children)) {
    return null;
  }

  var hasSlideshow = !isEmpty_default()(slideshow.media);
  var hasDiamond = !isEmpty_default()(diamond);

  var _themes$theme = themes[theme]({
    hasDiamond: hasDiamond,
    hasSlideshow: hasSlideshow,
    isExclusiveCollection: isExclusiveCollection,
    fullWidthContent: fullWidthContent
  }),
      thBody = _themes$theme.thBody,
      thContent = _themes$theme.thContent,
      thDiamond = _themes$theme.thDiamond,
      thDiamondClassName = _themes$theme.thDiamondClassName,
      thFooter = _themes$theme.thFooter,
      thHeader = _themes$theme.thHeader,
      thHeaderContainer = _themes$theme.thHeaderContainer,
      thHero = _themes$theme.thHero,
      thHeroImmersive = _themes$theme.thHeroImmersive,
      thMultimediaOverlay = _themes$theme.thMultimediaOverlay,
      thRoot = _themes$theme.thRoot,
      thSlideshow = _themes$theme.thSlideshow,
      thTop = _themes$theme.thTop;

  return __jsx("section", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, header && __jsx("div", {
    className: thHeaderContainer,
    "data-testid": "Sheet-header"
  }, __jsx("div", {
    className: thHeader
  }, header)), (!isEmpty_default()(immersive) || hasSlideshow) && __jsx("div", {
    className: thTop
  }, !isEmpty_default()(immersive) && !hasSlideshow && __jsx("div", {
    className: thHero
  }, __jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, immersive, {
    className: Object(classnames_utils["a" /* classnames */])(thHeroImmersive, immersive.className),
    size: "medium"
  }))), hasSlideshow && __jsx(react_default.a.Fragment, null, __jsx("div", {
    className: thSlideshow
  }, __jsx(ImageSlideShow["a" /* ImageSlideShow */], Object(esm_extends["a" /* default */])({
    media: slideshow.media,
    nbItemsToShow: 1,
    centerPadding: isTablet ? 0.25 : 0,
    fadeUnseenItems: isTablet,
    spacerWidth: isTablet ? 5 : 0,
    ratio: ratios_utils["c" /* default */].XL,
    onChangeIndex: setImageIndex
  }, slideshow)), __jsx("div", {
    className: "absolute start-0 top-0 mx-10 my-10 rounded-4 bg-darkGrey/80 px-15 py-10 text-14 text-white shadow-sm md:bottom-0 md:top-auto md:mx-20"
  }, "".concat(imageIndex + 1, "/").concat(slideshow.media.length))), !isEmpty_default()(multimedia) && __jsx("div", {
    className: thMultimediaOverlay
  }, __jsx(Multimedia["a" /* Multimedia */], Object(esm_extends["a" /* default */])({}, multimedia, {
    className: "flex h-full flex-col",
    hasFullScreenButton: true,
    initialIndex: imageIndex
  })))), hasDiamond && __jsx("div", {
    className: thDiamond
  }, __jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({}, diamond, {
    className: Object(classnames_utils["a" /* classnames */])(thDiamondClassName, diamond === null || diamond === void 0 ? void 0 : diamond.className),
    variant: "diamond"
  })))), __jsx("div", {
    className: thBody,
    "data-testid": "Sheet-body"
  }, __jsx("div", {
    className: thContent
  }, children)), !!footer && __jsx("footer", {
    className: thFooter
  }, __jsx("div", {
    className: thContent
  }, footer)));
}

/***/ }),

/***/ "Rl48":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "RmUC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserInfoSummary; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("E8Xq");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("L7OA");
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;








var UserInfoSummary = function UserInfoSummary(_ref) {
  var _isFeatureFlipped;

  var className = _ref.className,
      onClickEdit = _ref.onClickEdit,
      user = _ref.user;
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__[/* useAppContext */ "c"])();

  if (!user) {
    return null;
  }

  var shouldShowPhoneWithSeparatePhoneCodeField = (_isFeatureFlipped = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_7__[/* isFeatureFlipped */ "a"])(appContext)('booking.participants.phone.showWithSeparatePhoneCodeField')) !== null && _isFeatureFlipped !== void 0 ? _isFeatureFlipped : false;
  var _user$address = user.address,
      address = _user$address === void 0 ? {} : _user$address,
      civility = user.civility,
      email = user.email,
      firstName = user.firstName,
      lastName = user.lastName,
      mobilePhoneNumber = user.mobilePhoneNumber,
      unicodeFirstName = user.unicodeFirstName,
      unicodeLastName = user.unicodeLastName; // -ignore - mobileCode may be present when feature flag is enabled

  var mobileCode = user.mobileCode;
  var city = address.city,
      stateOrDistrict = address.stateOrDistrict,
      streetName = address.streetName,
      streetNumber = address.streetNumber,
      zipCode = address.zipCode;
  var hasUnicode = !!unicodeFirstName && !!unicodeLastName;
  var formatedCivility = civility ? "".concat(civility, ". ") : '';
  var names = hasUnicode ? [unicodeFirstName, unicodeLastName] : [Object(_utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_5__[/* capitalizeWordFirstCaracter */ "c"])(firstName), Object(_utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_5__[/* capitalizeWordFirstCaracter */ "c"])(lastName)];
  var name = [formatedCivility].concat(names).join(' '); // Format phone number for display

  var displayPhoneNumber = shouldShowPhoneWithSeparatePhoneCodeField && mobileCode && mobilePhoneNumber ? "+".concat(mobileCode, " ").concat(mobilePhoneNumber) : mobilePhoneNumber || '';
  return __jsx("div", {
    className: className
  }, __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_8__[/* Capsule */ "a"], {
    header: "none",
    dataTestId: "PreCompletedForm"
  }, __jsx("div", {
    className: "air360-replay-ignore flex px-10 md:px-5",
    "data-cs-mask": true
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
    className: "m-20 hidden text-sienna md:block",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ICON_45,
    width: "2.375rem"
  }), __jsx("div", {
    className: "pb-15 pt-10"
  }, __jsx("div", {
    className: "flex flex-col"
  }, __jsx("strong", null, name), __jsx("span", {
    className: "me-30"
  }, email || ''), __jsx("span", null, displayPhoneNumber), __jsx("span", {
    className: "me-25"
  }, "".concat(streetNumber || '', " ").concat(streetName || '')), __jsx("span", null, "".concat(zipCode || '', " ").concat(stateOrDistrict || '', " ").concat(city || '')))))), onClickEdit && __jsx("div", {
    className: "mt-10 flex justify-end"
  }, __jsx("button", {
    className: "cursor-pointer text-14 underline",
    onClick: onClickEdit,
    type: "button"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('common.edit'))));
};

/***/ }),

/***/ "RqHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRICE_COLOR_CLASS_NAMES; });
/* unused harmony export mixedToMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateDiff; });
/* unused harmony export stringToDateFormatted */
/* unused harmony export momentToInt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return maxDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return minDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closedDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return firstSiblingOpenDayOfSelectedMonthFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return siblingOpenDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDisabledDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flattenPrices; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("dLd+");
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("VtPb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("sW3P");
















var PRICE_COLOR_CLASS_NAMES = {
  DARK_GREY: 'text-black hocus:text-black-active',
  GREEN: 'text-green',
  GREEN_OPACITY_45: 'text-green bestPrice',
  GREY: 'text-grey hocus:text-black-active',
  ORANGE: 'text-orange',
  ORANGE_OPACITY_45: 'text-orange lastAvailability',
  WHITE: 'text-white',
  TURQUOISE: 'text-turquoise'
};
var mixedToMoment = function mixedToMoment(mixedDate) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(mixedDate);
};
var dateToInt = function dateToInt(d) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(mixedToMoment(d).format(format), 10);
};
var dateDiff = function dateDiff(day1, day2) {
  return Math.abs(moment__WEBPACK_IMPORTED_MODULE_12___default()(day2).diff(moment__WEBPACK_IMPORTED_MODULE_12___default()(day1), 'days'));
};
var stringToDateFormatted = function stringToDateFormatted(date, format) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(date).format(format);
};
var momentToInt = function momentToInt(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(date.format(format), 10);
};
var maxDatepickerDate = function maxDatepickerDate() {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_DATE_MAX_DATE */ "t"]).toDate();
};
var minDatepickerDate = function minDatepickerDate() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add({
    days: offset
  }).toDate();
};

function daysWithoutDepartureFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver = resolver(dateToInt(day)),
        _resolver$exclusivity = _resolver.exclusivity,
        exclusivity = _resolver$exclusivity === void 0 ? false : _resolver$exclusivity,
        _resolver$noFlight = _resolver.noFlight,
        noFlight = _resolver$noFlight === void 0 ? false : _resolver$noFlight,
        _resolver$full = _resolver.full,
        full = _resolver$full === void 0 ? false : _resolver$full;

    var available = !exclusivity && !noFlight && !full;

    if (!fromDate && !toDate) {
      return !available;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && !available;
  };
}

var daysWithNoAvailabilityFactory = function daysWithNoAvailabilityFactory(resolver) {
  return function (day) {
    var data = resolver(dateToInt(day));
    return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(data) || data.noAvailability;
  };
};

var closedDaysFactory = function closedDaysFactory(resolver, fromDate, toDate, shouldAllowSelectingSiblingOpenDays) {
  return function (day) {
    var _resolver2 = resolver(dateToInt(day)),
        _resolver2$closed = _resolver2.closed,
        closed = _resolver2$closed === void 0 ? false : _resolver2$closed,
        _resolver2$siblingOpe = _resolver2.siblingOpen,
        siblingOpen = _resolver2$siblingOpe === void 0 ? false : _resolver2$siblingOpe;

    if (!fromDate && !toDate) {
      return closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && (closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  };
};
var firstSiblingOpenDayOfSelectedMonthFactory = function firstSiblingOpenDayOfSelectedMonthFactory(resolver, selectedMonth) {
  var firstSiblingOpenDayFound;
  return function (day) {
    var _resolver3;

    if (!selectedMonth) {
      return false;
    }

    var firstDayOfSelectedMonth = "".concat(selectedMonth.toString(), "01");
    var firstDayOfSelectedMonthAsDate = moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonth, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]);
    var firstDisplayedDayOfSelectedMonthAsInt = firstDayOfSelectedMonthAsDate.weekday() > 0 ? momentToInt(firstDayOfSelectedMonthAsDate.subtract(firstDayOfSelectedMonthAsDate.weekday(), 'days')) : momentToInt(firstDayOfSelectedMonthAsDate);
    var lastDisplayedDayOfSelectedMonthAsInt = momentToInt(moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonthAsDate).add(41, 'days'));
    var currentDayDateAsInt = dateToInt(day);

    if (firstSiblingOpenDayFound && firstSiblingOpenDayFound !== dateToInt(day) || currentDayDateAsInt < firstDisplayedDayOfSelectedMonthAsInt || currentDayDateAsInt > lastDisplayedDayOfSelectedMonthAsInt) {
      return false;
    }

    var hasSiblingOpen = ((_resolver3 = resolver(currentDayDateAsInt)) === null || _resolver3 === void 0 ? void 0 : _resolver3.siblingOpen) || false;

    if (hasSiblingOpen) {
      firstSiblingOpenDayFound = dateToInt(day);
    }

    return hasSiblingOpen;
  };
};
var siblingOpenDaysFactory = function siblingOpenDaysFactory(resolver) {
  return function (day) {
    var _resolver4;

    return ((_resolver4 = resolver(dateToInt(day))) === null || _resolver4 === void 0 ? void 0 : _resolver4.siblingOpen) || false;
  };
};

var unavailableReturnDaysFactory = function unavailableReturnDaysFactory(fromDate) {
  var durations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (day) {
    if (day < fromDate) {
      return false;
    }

    var duration = dateDiff(day, fromDate); // rule of max 30 days of reservation

    if (duration > 30) {
      return true;
    }

    return !!duration && !durations.includes(duration);
  };
};

function getDisabledDays(_ref) {
  var from = _ref.from,
      isSeller = _ref.isSeller,
      optionsDuration = _ref.optionsDuration,
      openingDates = _ref.openingDates,
      prices = _ref.prices,
      resolvePrice = _ref.resolvePrice,
      shouldAllowSelectingSiblingOpenDays = _ref.shouldAllowSelectingSiblingOpenDays,
      to = _ref.to;
  var disabledDays = [];
  var pricesIds = Object.keys(prices || {});
  var hasPrices = pricesIds.length > 0;
  var allClosedDays = pricesIds.filter(function (priceKey) {
    return prices && (prices[priceKey].closed || prices[priceKey].siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  }).map(function (priceKey) {
    return parseInt(priceKey, 10);
  });

  if (hasPrices) {
    var dayIsWithoutDeparture = daysWithoutDepartureFactory(resolvePrice, from, to);
    var dayIsClosed = closedDaysFactory(resolvePrice, from, to, shouldAllowSelectingSiblingOpenDays);
    var dayIsSiblingOpen = siblingOpenDaysFactory(resolvePrice);
    var dayIsWithoutData = daysWithNoAvailabilityFactory(resolvePrice);
    disabledDays.push(dayIsWithoutDeparture);
    disabledDays.push(dayIsClosed);

    if (!shouldAllowSelectingSiblingOpenDays) {
      disabledDays.push(dayIsSiblingOpen);
    }

    disabledDays.push(dayIsWithoutData);
  }

  if (from && !to) {
    var fromDay = dateToInt(from);
    var closedDaysAfterFromDay = allClosedDays.filter(function (closedDay) {
      return closedDay > fromDay;
    });
    var firstClosedDay = hasPrices && closedDaysAfterFromDay.length > 0 && Math.min.apply(null, closedDaysAfterFromDay);
    disabledDays.push({
      before: moment__WEBPACK_IMPORTED_MODULE_12___default()(from).toDate(),
      after: firstClosedDay ? moment__WEBPACK_IMPORTED_MODULE_12___default()(firstClosedDay.toString()).toDate() : moment__WEBPACK_IMPORTED_MODULE_12___default()(from).add(30, 'days').toDate()
    });
  }

  if (from && !to && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(optionsDuration) && !isSeller) {
    disabledDays.push(unavailableReturnDaysFactory(from, optionsDuration));
  }

  if (openingDates === null || openingDates === void 0 ? void 0 : openingDates.length) {
    disabledDays.push.apply(disabledDays, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__[/* getClosingDatesRanges */ "b"])(openingDates)));
  }

  return disabledDays;
}
function getPriceColor(_ref2) {
  var classColor = _ref2.classColor,
      from = _ref2.from,
      hasPrices = _ref2.hasPrices,
      resolvePrice = _ref2.resolvePrice,
      selectedMonth = _ref2.selectedMonth,
      to = _ref2.to;
  return function (day) {
    var dayAsInt = dateToInt(day);

    if (selectedMonth) {
      var firstDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "01"), 10);
      var lastDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "31"), 10); // Handle dates outside current month & without prices

      var isDayBeforeSelectedMonth = Boolean(dayAsInt < firstDayOfCurrentMonth);
      var isDayAfterSelectedMonth = Boolean(dayAsInt > lastDayOfCurrentMonth);

      if (isDayBeforeSelectedMonth || !from && isDayAfterSelectedMonth || !hasPrices) {
        return classColor === PRICE_COLOR_CLASS_NAMES.GREY;
      }
    }

    if (from) {
      var fromDateAsInt = dateToInt(from);

      if (to) {
        var toDateAsInt = dateToInt(to); // Handle dates between from and to dates

        if (dayAsInt >= fromDateAsInt && dayAsInt <= toDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        }
      } else {
        if (dayAsInt === fromDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        } // Handle dates before and after from date


        switch (classColor) {
          case PRICE_COLOR_CLASS_NAMES.WHITE:
            return false;

          case PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45:
          case PRICE_COLOR_CLASS_NAMES.GREY:
          case PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45:
            if (dayAsInt >= fromDateAsInt) {
              return false;
            }

            break;

          default:
            if (dayAsInt < fromDateAsInt) {
              return false;
            }

            break;
        }
      }
    } // Get the correct color based on price


    if (resolvePrice) {
      var dayWithPrice = resolvePrice(dateToInt(day)) || {
        isBestPrice: false,
        lastAvailability: false,
        price: ''
      };
      var isBestPrice = dayWithPrice.isBestPrice,
          lastAvailability = dayWithPrice.lastAvailability,
          price = dayWithPrice.price,
          siblingOpen = dayWithPrice.siblingOpen;

      if (siblingOpen) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE || classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE : classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE;
      }

      if (lastAvailability) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.ORANGE || classColor === PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.ORANGE;
      }

      if (isBestPrice) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.GREEN || classColor === PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.GREEN;
      }

      if (price) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY || classColor === PRICE_COLOR_CLASS_NAMES.GREY : classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY;
      }
    }

    return false;
  };
}
function flattenPrices(prices) {
  var pricesIds = Object.keys(prices);
  return pricesIds.map(function (priceId) {
    return prices[priceId].oldPrice;
  }).join();
}

/***/ }),

/***/ "S4CH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaidBankingFormContent; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("qBqs");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var PaidBankingFormContent = function PaidBankingFormContent() {
  return __jsx("div", {
    className: "flex items-center"
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_1__[/* Icon */ "a"], {
    className: "mr-10 text-green",
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].SMALL_CIRCLE_CHECK,
    width: "2em"
  }), __jsx("div", {
    className: "text-3xl mt-0 font-brand text-saffron"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.partners.participants.multiGM.bookingConfirmed')));
};

/***/ }),

/***/ "SjZQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = __webpack_require__("1037").codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__("ulH6");
__webpack_require__("qW1w")(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ "T0Kn":
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__("gEL7")
var AuthCipher = __webpack_require__("aeZB")
var Buffer = __webpack_require__("KLyV").Buffer
var StreamCipher = __webpack_require__("y0P9")
var Transform = __webpack_require__("7IvJ")
var aes = __webpack_require__("4Z+A")
var ebtk = __webpack_require__("JvEg")
var inherits = __webpack_require__("qW1w")

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),

/***/ "TKGf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__("KLyV")
var randombytes = __webpack_require__("i+/A")
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !true) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (true) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq"), __webpack_require__("F63i")))

/***/ }),

/***/ "Ttg3":
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__("Deve")
var Buffer = __webpack_require__("KLyV").Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),

/***/ "TxDk":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var Buffer = __webpack_require__("KLyV").Buffer

var checkParameters = __webpack_require__("wKb0")
var defaultEncoding = __webpack_require__("yRAD")
var sync = __webpack_require__("U9DI")
var toBuffer = __webpack_require__("I3mq")

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  sha: 'SHA-1',
  'sha-1': 'SHA-1',
  sha1: 'SHA-1',
  sha256: 'SHA-256',
  'sha-256': 'SHA-256',
  sha384: 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  sha512: 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}
var nextTick
function getNextTick () {
  if (nextTick) {
    return nextTick
  }
  if (global.process && global.process.nextTick) {
    nextTick = global.process.nextTick
  } else if (global.queueMicrotask) {
    nextTick = global.queueMicrotask
  } else if (global.setImmediate) {
    nextTick = global.setImmediate
  } else {
    nextTick = global.setTimeout
  }
  return nextTick
}
function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    getNextTick()(function () {
      callback(null, out)
    })
  }, function (e) {
    getNextTick()(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    getNextTick()(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
    return
  }

  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "Tz41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/find.js
var find = __webpack_require__("6R5o");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/client/store/lead-info/leadInfo.selector.js
var leadInfo_selector = __webpack_require__("8fx4");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/streetViews/constants.js
var constants = __webpack_require__("Xvk6");

// CONCATENATED MODULE: ./src/client/store/streetViews/streetViews.action.js



function fetchStreetViewsByAccommodationCategoryId(_ref) {
  var productId = _ref.productId,
      accommodationCategoryIds = _ref.accommodationCategoryIds,
      appContext = _ref.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(constants["a" /* FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID */], {}, {
      optimist: true,
      promise: Object(BookingEngine_query["f" /* streetViewsByAccommodationCategoryId */])({
        productId: productId,
        accommodationCategoryIds: accommodationCategoryIds
      }, appContext)
    }));
  };
}
// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/hoc/errorBoundary/errorBoundary.js
var errorBoundary = __webpack_require__("3B0E");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reverse.js
var es_array_reverse = __webpack_require__("wFPu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__("Qavd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("LqLs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isNil.js
var isNil = __webpack_require__("2Lg3");
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/invariant/invariant.js
var invariant = __webpack_require__("UQkB");

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors_errors = __webpack_require__("wNDy");

// EXTERNAL MODULE: ./src/client/local-storage-api/index.js
var local_storage_api = __webpack_require__("1RIK");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/client/components/widgets/header-lite/HeaderLite.jsx + 1 modules
var HeaderLite = __webpack_require__("W5pp");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-accessible-title/BookingAccessibleTitle.jsx
var __jsx = react_default.a.createElement;




var BookingAccessibleTitle_BookingAccessibleTitle = function BookingAccessibleTitle(_ref) {
  var title = _ref.title;
  var titleRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, [title]);
  return __jsx(Portal["a" /* default */], {
    name: Portal_constants["a" /* ACCESSIBLE_TITLE */]
  }, __jsx(head_default.a, null, __jsx("title", {
    key: "title"
  }, title)), __jsx("p", {
    ref: titleRef,
    className: "sr-only",
    tabIndex: "-1"
  }, title));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.utils.js
var BookingEngine_utils = __webpack_require__("47Eh");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/widgets/booking-breadcrumb/BookingBreadcrumb.jsx + 16 modules
var BookingBreadcrumb = __webpack_require__("oMl1");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineContext.js
var BookingEngineContext = __webpack_require__("EEyx");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineTrackingContext.js
var BookingEngineTrackingContext = __webpack_require__("v+bK");

// EXTERNAL MODULE: ./src/client/views/quick-search/QuickSearchUnavailability.jsx
var QuickSearchUnavailability = __webpack_require__("jEE5");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");
var domains_service_dist_default = /*#__PURE__*/__webpack_require__.n(domains_service_dist);

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// CONCATENATED MODULE: ./src/client/views/booking/BlockMismatchProposalCountry.jsx





var BlockMismatchProposalCountry_jsx = react_default.a.createElement;













var BlockMismatchProposalCountry_BlockMismatchProposalCountry = function BlockMismatchProposalCountry(_ref) {
  var _URI$addQuery;

  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  if (!selectedProposal.originalLocale || selectedProposal.originalLocale.split('-')[1] === appContext.country) {
    return null;
  }

  return BlockMismatchProposalCountry_jsx(Modal["a" /* Modal */], {
    ariaLabelledby: identifiers_constants["s" /* ID_MODAL_HEADER__BE__MISMATCH_COUNTRY */],
    ariaLabel: Object(src_i18n["h" /* t */])('booking.participants.mismatchLocalePLE.title'),
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: function onClose() {
      var redirectUrl = new URI_default.a(window.location.href).setQuery({
        locale: selectedProposal.originalLocale
      });

      if (Object(contextUtils["f" /* isStrictlyProductionEnv */])() || Object(contextUtils["g" /* isStrictlyStagingEnv */])()) {
        redirectUrl = redirectUrl.tld(domains_service_dist_default.a.getTldFromLocale(selectedProposal.originalLocale));
      }

      if (appContext.isUserLogged || appContext.isUserQuickLogged) {
        redirectUrl = new URI_default.a(window.location.href).resource(routeBuilder["a" /* buildUrl */]('signout', {}, {
          redirectUri: redirectUrl
        }));
      } // heroku or local env


      window.location.href = redirectUrl.toString();
    }
  }, BlockMismatchProposalCountry_jsx("div", {
    className: "p-20 text-center"
  }, BlockMismatchProposalCountry_jsx(Title["a" /* Title */], {
    className: "my-15 justify-center",
    hLevel: 1,
    id: identifiers_constants["s" /* ID_MODAL_HEADER__BE__MISMATCH_COUNTRY */],
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.participants.mismatchLocalePLE.title')), BlockMismatchProposalCountry_jsx("p", {
    className: "mb-20"
  }, Object(src_i18n["h" /* t */])('booking.participants.mismatchLocalePLE.label')), BlockMismatchProposalCountry_jsx(Button["a" /* Button */], {
    url: new URI_default.a(resort.href).addQuery((_URI$addQuery = {
      locale: appContext.locale
    }, Object(defineProperty["a" /* default */])(_URI$addQuery, uri_constants["l" /* QUERY_NUMBER_OF_ADULTS */], selectedProposal.attendees.adults.length), Object(defineProperty["a" /* default */])(_URI$addQuery, uri_constants["h" /* QUERY_DURATION */], selectedProposal.duration), Object(defineProperty["a" /* default */])(_URI$addQuery, uri_constants["g" /* QUERY_DEPARTURE_DATE */], selectedProposal.arrivalDate), _URI$addQuery)).removeQuery(dist["appQueryParameters"].booking.selectedProposalId, dist["appQueryParameters"].booking.proposalIds).toString()
  }, Object(src_i18n["h" /* t */])('common.continue'))));
};
// EXTERNAL MODULE: ./src/client/context/ABTestContext.js
var ABTestContext = __webpack_require__("hfZn");

// EXTERNAL MODULE: ./src/client/components/widgets/booking-footer/BookingFooter.jsx + 2 modules
var BookingFooter = __webpack_require__("dATv");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// CONCATENATED MODULE: ./src/utils/product-comparison/constants.js

var BOOKING_STEPS = {
  PARTICIPANTS: {
    BE_LEGACY: 'payment/participants',
    BE_RESPONSIVE: BookingPagesUtils["c" /* PAGE_BE_PARTICIPANTS */],
    CXO: 'book'
  },
  ACCOMMODATIONS: {
    BE_LEGACY: 'accommodations',
    BE_RESPONSIVE: BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */],
    CXO: 'configure'
  },
  ACTIVITIES: {
    BE_LEGACY: 'activities',
    BE_RESPONSIVE: BookingPagesUtils["b" /* PAGE_BE_ACTIVITIES */],
    CXO: 'configure'
  },
  TRANSPORT: {
    BE_LEGACY: 'transport',
    BE_RESPONSIVE: BookingPagesUtils["f" /* PAGE_BE_TRANSPORT */],
    CXO: 'configure'
  }
};

// EXTERNAL MODULE: ./src/client/tracking/track-page/TrackPage.jsx
var TrackPage = __webpack_require__("tZiC");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// CONCATENATED MODULE: ./src/client/views/booking/save-criteria/SaveCriteriaConfirmation.jsx

var SaveCriteriaConfirmation_jsx = react_default.a.createElement;








var SaveCriteriaConfirmation_SaveCriteriaConfirmation = function SaveCriteriaConfirmation(_ref) {
  var i18n = _ref.i18n,
      closeModal = _ref.closeModal,
      newAccount = _ref.newAccount,
      persistenceExtended = _ref.persistenceExtended;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isCmta = _useAppContext.isCmta;

  var _get2 = get_default()(i18n, 'booking.saveMyCriteria', {}),
      dataProtectionPolicyUrl = _get2.dataProtectionPolicyUrl,
      dataProtectionPolicyLabel = _get2.dataProtectionPolicyLabel;

  var getModalTitle = function getModalTitle() {
    if (isCmta) {
      return get_default()(i18n, persistenceExtended ? 'booking.saveMyProposal.seller.saveConfirmation' : 'booking.saveMyProposal.seller.unsaveConfirmation');
    }

    return newAccount ? get_default()(i18n, 'booking.saveMyCriteria.saveConfirmationNewAccount') : get_default()(i18n, 'booking.saveMyCriteria.saveConfirmation');
  };

  var legalInfos = isCmta ? get_default()(i18n, 'booking.saveMyProposal.seller.info') : get_default()(i18n, 'booking.saveMyCriteria.legalInfo');
  return SaveCriteriaConfirmation_jsx(Modal["a" /* Modal */], {
    ariaLabel: getModalTitle(),
    ariaLabelledby: identifiers_constants["v" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION */],
    closeLabel: get_default()(i18n, 'common.close'),
    onClose: closeModal,
    size: "small"
  }, SaveCriteriaConfirmation_jsx("div", {
    className: "overflow-hidden bg-white px-50 py-20 text-center",
    "data-testid": "SaveCriteriaLogin--confirmation"
  }, SaveCriteriaConfirmation_jsx("div", null, SaveCriteriaConfirmation_jsx(Icon["a" /* Icon */], {
    className: "text-success",
    name: icons["a" /* ICONS */].CHECK,
    width: "3rem"
  })), SaveCriteriaConfirmation_jsx("div", {
    className: "w-full text-center text-22 font-bold text-black",
    "data-testid": "SaveCriteria-confirmation",
    id: identifiers_constants["v" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION */]
  }, getModalTitle()), SaveCriteriaConfirmation_jsx("div", null, SaveCriteriaConfirmation_jsx(Button["a" /* Button */], {
    className: "mb-15 mt-50 min-w-[250px]",
    onClick: closeModal
  }, get_default()(i18n, 'booking.saveMyCriteria.continue'))), !isCmta && SaveCriteriaConfirmation_jsx(DynamicLink["a" /* default */], {
    className: "m-auto flex items-center justify-center text-16 font-bold text-black hocus:text-black-active",
    "data-selector": "SaveCriteria-link",
    target: "_blank",
    url: "/account"
  }, get_default()(i18n, 'booking.saveMyCriteria.accessAccount'), SaveCriteriaConfirmation_jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    width: "1rem"
  })), SaveCriteriaConfirmation_jsx("div", {
    className: "mt-30 flex flex-col items-center",
    "data-testid": "SaveCriteria-popinLegalInfo"
  }, isCmta && persistenceExtended && SaveCriteriaConfirmation_jsx("p", {
    className: "w-full text-center"
  }, legalInfos), !isCmta && SaveCriteriaConfirmation_jsx(DynamicLink["a" /* default */], {
    className: "text-inherit underline",
    url: dataProtectionPolicyUrl
  }, dataProtectionPolicyLabel))));
};
// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 2 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/widgets/member-nav/member-sign-in/useExtendedConnect.js
var useExtendedConnect = __webpack_require__("4tGX");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/views/booking/save-criteria/SaveCriteriaLogin.jsx


var SaveCriteriaLogin_jsx = react_default.a.createElement;

















function SaveCriteriaLogin(_ref) {
  var closeModal = _ref.closeModal,
      clickOrigin = _ref.clickOrigin;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useExtendedConnect = Object(useExtendedConnect["a" /* useExtendedConnect */])(),
      isFacebookConnectAvailable = _useExtendedConnect.isFacebookConnectAvailable;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var trackClick = function trackClick(detailClick) {
    trackClickEvent(clickOrigin === 'bottomBar' ? tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_BOTTOM_BAR : tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
      detail_click: detailClick
    });
  };

  var currentUri = dist["windowWrapper"].getLocation();
  var redirectUri = new URI_default.a(currentUri).addSearch(booking_constants["f" /* BE_SAVE_CRITERIA_QUERY */], 'true').toString();
  var redirectUriSignup = new URI_default.a(currentUri).addSearch(booking_constants["f" /* BE_SAVE_CRITERIA_QUERY */], 'true').addSearch(booking_constants["e" /* BE_SAVE_CRITERIA_NEW_ACCOUNT_QUERY */], 'true').toString();
  return SaveCriteriaLogin_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["h" /* t */])('account.authentication.newToClubMed'),
    ariaLabelledby: identifiers_constants["w" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, SaveCriteriaLogin_jsx("p", {
    className: "flex items-center gap-10 border-b-1 border-lightGrey px-10 py-15"
  }, SaveCriteriaLogin_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-sienna",
    name: icons["a" /* ICONS */].STAR_HOLLOW,
    width: "1.625rem"
  }), Object(src_i18n["h" /* t */])('booking.saveMyCriteria.createAccount')), SaveCriteriaLogin_jsx("div", {
    className: "flex flex-col items-center bg-white px-10 py-40",
    "data-testid": "SaveCriteriaLogin-signin"
  }, SaveCriteriaLogin_jsx(Button["a" /* Button */], {
    className: "w-full max-w-220",
    "data-selector": "saveCriteriaLogin-member-signIn",
    isExternalLink: true,
    onClick: function onClick() {
      return trackClick('travel_plans_login');
    },
    target: "_self",
    url: ple_utils["f" /* buildSigninUrl */]({
      redirectUri: redirectUri,
      locale: appContext.locale
    })
  }, Object(src_i18n["h" /* t */])('account.authentication.signin')), isFacebookConnectAvailable && SaveCriteriaLogin_jsx(Button["a" /* Button */], {
    className: "mt-10 w-full max-w-220 border-[#4267b2] bg-[#4267b2]",
    color: colors["a" /* COLORS */].WHITE,
    "data-selector": "saveCriteriaLogin-member-signIn-facebook",
    iconLeft: {
      name: icons["a" /* ICONS */].FACEBOOK,
      width: '1.5rem'
    },
    isExternalLink: true,
    target: "_self",
    url: ple_utils["d" /* buildFacebookConnectUrl */]({
      redirectUri: redirectUri,
      locale: appContext.locale
    })
  }, Object(src_i18n["h" /* t */])('account.authentication.connectionIncentive.facebookConnectButtonLabel'))), SaveCriteriaLogin_jsx("div", {
    className: "flex flex-col items-center gap-20 border-t-1 border-lightGrey bg-white px-10 py-25"
  }, SaveCriteriaLogin_jsx(Title["a" /* Title */], {
    hLevel: 2,
    id: identifiers_constants["w" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN */],
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('account.authentication.newToClubMed')), SaveCriteriaLogin_jsx(Button["a" /* Button */], {
    "data-selector": "saveCriteriaLogin-member-signUp",
    isExternalLink: true,
    onClick: function onClick() {
      return trackClick('travel_plans_sign_up');
    },
    target: "_self",
    url: ple_utils["h" /* buildSignupUrl */]({
      redirectUri: redirectUriSignup,
      locale: appContext.locale
    })
  }, Object(src_i18n["h" /* t */])('account.authentication.createAccountLinkLabel'))));
}
// CONCATENATED MODULE: ./src/client/views/booking/refresh-proposal-modal/RefreshProposalModal.jsx














var RefreshProposalModal_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var RefreshProposalModal_useRefreshProposal = function useRefreshProposal(refreshedProposal, selectedProposal) {
  var proposal = refreshedProposal.proposal,
      errors = refreshedProposal.errors;

  var _useState = Object(react["useState"])(errors && errors.length && errors.some(function (error) {
    return ['noAccommodation', 'noTransport', 'noService'].includes(error.errorKey);
  })),
      hasError = _useState[0];

  var _useState2 = Object(react["useState"])(proposal && selectedProposal && proposal.id === selectedProposal.id && proposal.price.total.value !== selectedProposal.price.total.value),
      hasDifferentPrice = _useState2[0];

  return {
    hasError: hasError,
    hasDifferentPrice: hasDifferentPrice
  };
};

function RefreshProposalModal(_ref) {
  var refreshedProposal = _ref.refreshedProposal,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal;
  var router = Object(next_router["useRouter"])();

  var _useState3 = Object(react["useState"])(false),
      isOpen = _useState3[0],
      setIsOpen = _useState3[1];

  var imageUrl = resort.image,
      destination = resort.destination,
      name = resort.name;

  var _useRefreshProposal = RefreshProposalModal_useRefreshProposal(refreshedProposal, selectedProposal),
      hasError = _useRefreshProposal.hasError,
      hasDifferentPrice = _useRefreshProposal.hasDifferentPrice;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var errorMessage = hasError ? Object(src_i18n["h" /* t */])('booking.saveMyCriteria.refreshPopIn.noAvailability') : Object(src_i18n["h" /* t */])('booking.saveMyCriteria.refreshPopIn.updatedProposal');

  var redirectToResort = function redirectToResort() {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_NEW_PROPOSALS, {
      detail_click: 'error_%400'
    });
    var resortUri = new URI_default.a(resort === null || resort === void 0 ? void 0 : resort.href).query(_objectSpread(_objectSpread({}, omit_default()(router.query, ['bookingStep', 'proposalIds', 'selectedProposalId', 'date', 'duration'])), {}, {
      date: moment_default()(selectedProposal.arrivalDate).format('YYYY-MM-DD'),
      duration: selectedProposal.duration
    })).toString();
    router.push(dist["url"].normalizeUrl(resortUri));
  };

  var refreshPage = function refreshPage() {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_NEW_PROPOSALS, {
      detail_click: 'new_price'
    });
    window.location.reload();
  };

  var buttonText = hasError ? Object(src_i18n["h" /* t */])('common.chooseNewCriteria') : Object(src_i18n["h" /* t */])('common.continue');
  var buttonAction = hasError ? redirectToResort : refreshPage;
  Object(react["useEffect"])(function () {
    if (hasError || hasDifferentPrice) {
      setIsOpen(true);
    }
  }, [hasError, hasDifferentPrice]);

  if (!hasError && !hasDifferentPrice) {
    return null;
  }

  return isOpen ? RefreshProposalModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["h" /* t */])('booking.saveMyCriteria.refreshPopIn.title'),
    ariaLabelledby: identifiers_constants["r" /* ID_MODAL_HEADER__BE_REFRESH_PROPOSAL */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: buttonAction,
    size: "small"
  }, RefreshProposalModal_jsx("div", {
    className: "overflow-hidden",
    "data-testid": "RefreshProposalModal"
  }, RefreshProposalModal_jsx("div", {
    className: "relative h-228 overflow-hidden"
  }, !!imageUrl && RefreshProposalModal_jsx("img", {
    src: imageUrl,
    className: "w-full",
    alt: ""
  }), RefreshProposalModal_jsx("div", {
    className: "absolute inset-0 flex items-end justify-center bg-[linear-gradient(180deg,rgba(36,36,36,0)_50%,rgba(36,36,36,0.8)_100%)] text-center text-white"
  }, RefreshProposalModal_jsx("div", {
    className: "mb-20"
  }, RefreshProposalModal_jsx("p", {
    className: "text-20 font-semibold"
  }, name), RefreshProposalModal_jsx("p", {
    className: "text-16 font-normal"
  }, destination.country)))), RefreshProposalModal_jsx("div", {
    className: "m-25 text-center"
  }, RefreshProposalModal_jsx("div", {
    className: "mb-10 font-brand text-24 text-black"
  }, Object(src_i18n["h" /* t */])('booking.saveMyCriteria.refreshPopIn.title')), RefreshProposalModal_jsx("div", {
    className: "p-20 text-14 text-black"
  }, errorMessage), RefreshProposalModal_jsx(Button["a" /* Button */], {
    className: "mb-15 mt-30 min-w-200",
    "data-testid": "pauseOptionModalButton",
    onClick: buttonAction
  }, buttonText)))) : null;
}
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.tracking.js
var BookingEngine_tracking = __webpack_require__("Hv+8");

// CONCATENATED MODULE: ./src/client/views/booking/share-context/ShareContext.jsx












var ShareContext_jsx = react["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }












var ShareContext_ShareContext = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(ShareContext, _React$Component);

  var _super = _createSuper(ShareContext);

  function ShareContext() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ShareContext);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "textInput", /*#__PURE__*/react["createRef"]());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onCopyLinkClick", function () {
      var _this$props = _this.props,
          i18n = _this$props.i18n,
          displayToastOnContextShare = _this$props.displayToastOnContextShare,
          actionGA = _this$props.actionGA; // $FlowFixMe current should never be undefined

      _this.textInput.current.select();

      document.execCommand('copy');
      Object(BookingEngine_tracking["d" /* trackShareContextDesktopPopin */])(actionGA, _this.context);
      displayToastOnContextShare(get_default()(i18n, 'booking.common.share.linkCopied'));
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleOnNavigatorShareClick", function () {
      if (navigator.share) {
        Object(BookingEngine_tracking["d" /* trackShareContextDesktopPopin */])(_this.props.actionGA, _this.context); // $FlowFixMe

        navigator.share({
          url: dist["windowWrapper"].getLocation()
        }).then(function () {
          _this.props.onToggleModal();
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleMediaLinkClick", function (event) {
      var msg = dist["windowWrapper"].getLocation();
      var media = event.currentTarget.dataset.media;
      Object(BookingEngine_tracking["e" /* trackShareContextMobilePopin */])(_this.props.actionGA, media, _this.context);

      if (media === 'messenger') {
        return window.open("fb-messenger://share/?link=".concat(encodeURIComponent(msg), "&app_id=").concat(config_default.a.get('facebookMessenger.appId')), '_self');
      }

      if (media === 'whatsapp') {
        return window.open("whatsapp://send?text=".concat(encodeURIComponent(msg)), '_self');
      }

      if (media === 'sms') {
        return window.open("sms:?&body=".concat(encodeURIComponent(msg)), '_self');
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ShareContext, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onToggleModal = _this$props2.onToggleModal,
          i18n = _this$props2.i18n;
      return ShareContext_jsx(Modal["a" /* Modal */], {
        ariaLabel: get_default()(i18n, 'booking.common.share.title'),
        ariaLabelledby: identifiers_constants["x" /* ID_MODAL_HEADER__BE__SHARE_CONTEXT */],
        closeLabel: get_default()(i18n, 'common.close'),
        onClose: onToggleModal,
        size: "small"
      }, ShareContext_jsx("h1", {
        className: "flex items-center gap-10 border-b-1 border-lightGrey p-20 text-20",
        id: identifiers_constants["x" /* ID_MODAL_HEADER__BE__SHARE_CONTEXT */]
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "text-sienna",
        name: icons["a" /* ICONS */].SHARE,
        width: "2rem"
      }), get_default()(i18n, 'booking.common.share.title')), ShareContext_jsx("div", {
        className: "max-w-full overflow-hidden bg-white p-20"
      }, ShareContext_jsx("input", {
        // ⚠️ this input should not be hidden otherwise the copy func will not work
        className: "absolute -z-1 h-0",
        ref: this.textInput,
        value: dist["windowWrapper"].getLocation(),
        readOnly: true,
        "aria-hidden": "true"
      }), this.props.responsive.isTablet ? ShareContext_jsx(react["Fragment"], null, ShareContext_jsx("p", {
        className: "text-16"
      }, get_default()(i18n, 'booking.common.share.info')), ShareContext_jsx("p", {
        className: "mt-5 text-12"
      }, get_default()(i18n, 'booking.common.share.copyPaste')), ShareContext_jsx("div", {
        className: "mt-10 flex items-center",
        "data-testid": "ShareContext-shareLink"
      }, ShareContext_jsx("button", {
        className: "w-full max-w-full truncate text-14 underline",
        "data-testid": "ShareContext-desktopUrl",
        onClick: this.onCopyLinkClick,
        type: "button"
      }, dist["windowWrapper"].getLocation()), ShareContext_jsx("button", {
        onClick: this.onCopyLinkClick,
        type: "button"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-darkGrey p-10 text-white",
        name: icons["a" /* ICONS */].LINK,
        width: "3rem"
      })))) : ShareContext_jsx("div", {
        className: "flex flex-col items-center",
        "data-testid": "ShareContext-mobileContent"
      }, ShareContext_jsx("p", {
        className: "my-20 px-20 text-center text-14"
      }, get_default()(i18n, 'booking.common.share.info')), navigator.share ? ShareContext_jsx(Button["a" /* Button */], {
        className: "mb-10",
        "data-testid": "ShareContext-shareButton",
        onClick: this.handleOnNavigatorShareClick
      }, get_default()(i18n, 'booking.common.share.label')) : ShareContext_jsx("div", {
        className: "flex w-full justify-center gap-10 border-t-1 border-lightGrey py-25"
      }, ShareContext_jsx("button", {
        type: "button",
        "data-media": "messenger",
        onClick: this.handleMediaLinkClick,
        "data-testid": "ShareContext-messenger"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-[#1984ff] p-10 text-white",
        name: icons["a" /* ICONS */].MESSENGER,
        width: "3rem"
      })), ShareContext_jsx("button", {
        type: "button",
        "data-media": "whatsapp",
        onClick: this.handleMediaLinkClick,
        "data-testid": "ShareContext-whatsapp"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-[#52cc5d] p-10 text-white",
        name: icons["a" /* ICONS */].WHATSAPP,
        width: "3rem"
      })), ShareContext_jsx("button", {
        type: "button",
        "data-media": "sms",
        onClick: this.handleMediaLinkClick,
        "data-testid": "ShareContext-12s"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-[#f69a3f] p-10 text-white",
        name: icons["a" /* ICONS */].SMS,
        width: "3rem"
      })), ShareContext_jsx("button", {
        type: "button",
        onClick: this.onCopyLinkClick
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        className: "rounded-full bg-darkGrey p-10 text-white",
        name: icons["a" /* ICONS */].LINK,
        width: "3rem"
      }))))));
    }
  }]);

  return ShareContext;
}(react["Component"]);

Object(defineProperty["a" /* default */])(ShareContext_ShareContext, "contextType", ReactAppContext["a" /* B2CAppContext */]);

/* harmony default export */ var share_context_ShareContext = (Object(Responsive["a" /* default */])(ShareContext_ShareContext));
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/infoBanner.query.js
var infoBanner_query = __webpack_require__("M/0w");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.repeat.js
var es_string_repeat = __webpack_require__("FwaZ");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/infoBanner.utils.js + 1 modules
var infoBanner_utils = __webpack_require__("UpHs");

// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js + 1 modules
var additionalAccommodations_action = __webpack_require__("06Jt");

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js + 1 modules
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: ./src/client/components/widgets/overlaid-action-provider/OverlaidActionProvider.jsx



var OverlaidActionProvider_jsx = react_default.a.createElement;


var OverlaidActionProvider_OverlaidActionProvider = function OverlaidActionProvider(_ref) {
  var _ref$button = _ref.button,
      button = _ref$button === void 0 ? {} : _ref$button,
      children = _ref.children,
      _ref$dataSelector = _ref.dataSelector,
      dataSelector = _ref$dataSelector === void 0 ? 'OverlaidActionProvider' : _ref$dataSelector,
      label = _ref.label;
  var shouldRender = button.onClick && button.onClick !== noop_default.a || button.link;

  if (!shouldRender) {
    return null;
  }

  return OverlaidActionProvider_jsx(react["Fragment"], null, OverlaidActionProvider_jsx("div", {
    "data-selector": "".concat(dataSelector, "--oapOuterContent")
  }, children), OverlaidActionProvider_jsx("div", {
    className: "mt-20 flex flex-col items-center"
  }, !!label && OverlaidActionProvider_jsx("div", {
    className: "font-brand text-20",
    "data-selector": "".concat(dataSelector, "--oapLabel")
  }, label), OverlaidActionProvider_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({
    className: "m-5",
    "data-selector": "".concat(dataSelector, "-button"),
    size: "medium"
  }, button), button.label)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/notification/SimpleNotification.jsx
var SimpleNotification = __webpack_require__("qOTJ");

// EXTERNAL MODULE: ./src/client/components/widgets/booking-navbar/useBookingNavbar.js
var useBookingNavbar = __webpack_require__("IOWS");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodations/attendees-distribution/AttendeesDistributionUtils.js











function AttendeesDistributionUtils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function AttendeesDistributionUtils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? AttendeesDistributionUtils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AttendeesDistributionUtils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var ATTENDEE_CATEGORIES = {
  BABY: 'BABY',
  CHILD: 'CHILD',
  ADULT: 'ADULT'
};
var AttendeesDistributionUtils_getAttendeeCategory = function getAttendeeCategory(attendee, arrivalDate) {
  if (attendee.birthdate && moment_default()(arrivalDate).diff(moment_default()(attendee.birthdate), 'months') < 24) {
    return ATTENDEE_CATEGORIES.BABY;
  }

  if (attendee.birthdate && moment_default()(arrivalDate).diff(moment_default()(attendee.birthdate), 'months') >= 24 && moment_default()(arrivalDate).diff(moment_default()(attendee.birthdate), 'years') < 18) {
    return ATTENDEE_CATEGORIES.CHILD;
  }

  return ATTENDEE_CATEGORIES.ADULT;
};
var getAttendeesByDistributionCategory = function getAttendeesByDistributionCategory(attendees) {
  var sortAttendeesByIndex = function sortAttendeesByIndex(attendee1, attendee2) {
    return attendee1.index - attendee2.index;
  };

  return {
    adults: attendees.filter(function (_ref) {
      var type = _ref.type;
      return type.toUpperCase() === ATTENDEE_CATEGORIES.ADULT;
    }).sort(sortAttendeesByIndex),
    children: attendees.filter(function (_ref2) {
      var type = _ref2.type;
      return type.toUpperCase() === ATTENDEE_CATEGORIES.CHILD;
    }).sort(sortAttendeesByIndex),
    babies: attendees.filter(function (_ref3) {
      var type = _ref3.type;
      return type.toUpperCase() === ATTENDEE_CATEGORIES.BABY;
    }).sort(sortAttendeesByIndex)
  };
};
var addDistributionDataToAttendees = function addDistributionDataToAttendees(attendees, arrivalDate) {
  var distributionIndex = {
    ADULT: 0,
    CHILD: 0,
    BABY: 0
  };
  return attendees.map(function (attendee) {
    var type = AttendeesDistributionUtils_getAttendeeCategory(attendee, arrivalDate); // $FlowFixMe

    return AttendeesDistributionUtils_objectSpread(AttendeesDistributionUtils_objectSpread({}, attendee), {}, {
      type: type,
      index: distributionIndex[type]++
    });
  });
};
// EXTERNAL MODULE: ./src/client/store/booking/attendees/attendees.selector.js
var attendees_selector = __webpack_require__("eZ08");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation/Accommodation.jsx + 15 modules
var Accommodation = __webpack_require__("OWQs");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodationsUtils.js
var BookingAccommodationsUtils = __webpack_require__("cb6o");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodations/BookingAccommodations.jsx















var BookingAccommodations_jsx = react_default.a.createElement;

function BookingAccommodations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingAccommodations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingAccommodations_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingAccommodations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var BookingAccommodations_BookingAccommodations = function BookingAccommodations(_ref) {
  var _ref$accommodations = _ref.accommodations,
      accommodations = _ref$accommodations === void 0 ? [] : _ref$accommodations,
      accommodationsCount = _ref.accommodationsCount,
      _ref$isInMoreRoomLaye = _ref.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref$isInMoreRoomLaye === void 0 ? false : _ref$isInMoreRoomLaye,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      proposal = _ref.proposal,
      remainingStock = _ref.remainingStock,
      product = _ref.product,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers,
      theme = _ref.theme,
      accommodationsComparator = _ref.accommodationsComparator;
  var tripInformationAttendees = Object(es["e" /* useSelector */])(storeHelper["d" /* tripInformationSelector */]);
  var connectedUserInfo = Object(es["e" /* useSelector */])(booking_selector["h" /* getConnectedUserInfoSelector */]);

  var _useState = Object(react["useState"])({
    adults: [],
    children: []
  }),
      attendees = _useState[0],
      setAttendees = _useState[1];

  var router = Object(next_router["useRouter"])();
  var isComparator = router.pathname === '/comparator';
  var alternatives = Object(es["e" /* useSelector */])(booking_selector["m" /* getFilteredAccommodationsAlternativesByComfort */]);
  Object(react["useEffect"])(function () {
    var _addInfosToProposalAt = Object(attendees_selector["a" /* addInfosToProposalAttendees */])({
      proposal: proposal,
      tripInformationAttendees: tripInformationAttendees,
      connectedUserInfo: connectedUserInfo
    }),
        formattedAttendees = _addInfosToProposalAt.attendees;

    setAttendees(formattedAttendees);
  }, []);
  var attendeesWithInfos = [].concat(Object(toConsumableArray["a" /* default */])(attendees.adults), Object(toConsumableArray["a" /* default */])(attendees.children));

  var sortedAccommodations = Object(toConsumableArray["a" /* default */])(accommodations).sort(proposalUtils["b" /* compareAccommodationsByComfort */]);

  var arrangementAttendees = sortedAccommodations.reduce(function (attendeesList, accommodation) {
    if (accommodation.attendeesDistribution && accommodation.attendeesDistribution.attendees) {
      return [].concat(Object(toConsumableArray["a" /* default */])(attendeesList), Object(toConsumableArray["a" /* default */])(accommodation.attendeesDistribution.attendees));
    }

    return Object(toConsumableArray["a" /* default */])(attendeesList);
  }, []);
  /**
   * On accommodations view, when accommodations have arrangement, we would like to have index related
   * to accommodations order (first accommodation attendees with first indexes)
   */

  var sortedAttendeesWithInfos = !isInMoreRoomLayer && arrangementAttendees && arrangementAttendees.length ? arrangementAttendees.map(function (attendee) {
    var attendeeData = attendeesWithInfos.find(function (_ref2) {
      var id = _ref2.id;
      return attendee.id === id;
    }) || {}; // $FlowFixMe: flow cannot handle this spread...

    return BookingAccommodations_objectSpread(BookingAccommodations_objectSpread({}, attendee), attendeeData);
  }) : attendeesWithInfos;
  var attendeesWithDistributionData = addDistributionDataToAttendees(sortedAttendeesWithInfos, proposal.arrivalDate);
  return BookingAccommodations_jsx(Accommodation["a" /* Accommodation */], Object(esm_extends["a" /* default */])({}, Object(BookingAccommodationsUtils["b" /* getAccommodationProps */])({
    accommodations: accommodations,
    accommodationsCount: accommodationsCount,
    alternatives: alternatives,
    attendeesWithDistributionData: attendeesWithDistributionData,
    isComparator: isComparator,
    isInMoreRoomLayer: isInMoreRoomLayer,
    proposal: proposal,
    remainingStock: remainingStock,
    product: product,
    streetViews: streetViews
  }), {
    accommodationsComparator: accommodationsComparator,
    isInMoreRoomLayer: isInMoreRoomLayer,
    isLoading: isLoading,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    switchOffers: switchOffers,
    theme: theme
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ExclusiveCollectionBadge.jsx
var ExclusiveCollectionBadge = __webpack_require__("7knX");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniq.js
var uniq = __webpack_require__("jLkM");
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: ./src/utils/proposal/constants.js
var proposal_constants = __webpack_require__("tI+f");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/ProposalAccommodationTitleUtils.js
















var getDiscountValueFromProposal = function getDiscountValueFromProposal(proposal) {
  var _proposal$price$disco, _proposal$price$disco2;

  return (_proposal$price$disco = proposal.price.discounts.find(function (_ref) {
    var currentProposalCode = _ref.currentProposalCode;
    return !!(currentProposalCode === null || currentProposalCode === void 0 ? void 0 : currentProposalCode.value);
  })) === null || _proposal$price$disco === void 0 ? void 0 : (_proposal$price$disco2 = _proposal$price$disco.currentProposalCode) === null || _proposal$price$disco2 === void 0 ? void 0 : _proposal$price$disco2.value;
};

var ProposalAccommodationTitleUtils_getUniqDiscountProposals = function getUniqDiscountProposals(proposals) {
  return uniq_default()(proposals.map(function (proposal) {
    return getDiscountValueFromProposal(proposal);
  }).filter(Boolean));
};

var getDiscountDetailFromProposal = function getDiscountDetailFromProposal(proposal) {
  var _discount$currentProp;

  var discount = proposal.price.discounts.find(function (_ref2) {
    var currentProposalCode = _ref2.currentProposalCode;
    return !!(currentProposalCode === null || currentProposalCode === void 0 ? void 0 : currentProposalCode.value);
  });

  if (!(discount === null || discount === void 0 ? void 0 : (_discount$currentProp = discount.currentProposalCode) === null || _discount$currentProp === void 0 ? void 0 : _discount$currentProp.value)) {
    return null;
  }

  return {
    value: discount.currentProposalCode.value,
    description: discount.currentProposalCode.description || ''
  };
};

var ProposalAccommodationTitleUtils_getUniqDiscountDetails = function getUniqDiscountDetails(proposals) {
  return uniqBy_default()(proposals.map(function (proposal) {
    return getDiscountDetailFromProposal(proposal);
  }).filter(Boolean), 'value');
};

function getAccommodationTitle(proposal, product) {
  var _accommodations$, _accommodations$2, _accommodations$3, _accommodations$4;

  var accommodations = Object(toConsumableArray["a" /* default */])(proposal.accommodations).sort(proposalUtils["b" /* compareAccommodationsByComfort */]).reverse();

  var category = (accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$ = accommodations[0]) === null || _accommodations$ === void 0 ? void 0 : _accommodations$.category) || '';
  var comfort = (accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$2 = accommodations[0]) === null || _accommodations$2 === void 0 ? void 0 : _accommodations$2.comfortType) || '';
  var label = (accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$3 = accommodations[0]) === null || _accommodations$3 === void 0 ? void 0 : _accommodations$3.label) || '';
  var isVillettaRoom = product.id.toLowerCase() === proposal_constants["a" /* CEFALU_RESORT */].toLowerCase() && accommodation_constants["f" /* VILLETA_ROOM_REGEX */].test(accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$4 = accommodations[0]) === null || _accommodations$4 === void 0 ? void 0 : _accommodations$4.id);
  return isVillettaRoom ? label || comfort || category : comfort || category;
}

function getExclusiveCollectionInAccommodations(proposal, product) {
  var indexOfExclusiveCollectionRoom = proposal === null || proposal === void 0 ? void 0 : proposal.accommodations.findIndex(function (accommodation) {
    return accommodation.exclusiveCollection;
  });
  return indexOfExclusiveCollectionRoom !== -1 && (product === null || product === void 0 ? void 0 : product.comfort) === 4;
}

var isSuperiorComfortAccommodation = function isSuperiorComfortAccommodation(accommodations) {
  var _accommodations$5, _accommodations$5$cat;

  return accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$5 = accommodations[0]) === null || _accommodations$5 === void 0 ? void 0 : (_accommodations$5$cat = _accommodations$5.categories) === null || _accommodations$5$cat === void 0 ? void 0 : _accommodations$5$cat.every(function (_ref3) {
    var id = _ref3.id;
    return id === '000017' || id === '000022';
  });
};


// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/ProposalAccommodationTitle.themes.js

var ProposalAccommodationTitle_themes_themes = function themes(isExclusiveCollection) {
  return {
    "default": {
      thRoot: 'flex flex-col w-full justify-center sm:flex-row sm:flex-wrap gap-x-10 py-10 sm:py-20 px-5 sm:px-20 sm:items-baseline text-14 sm:text-16',
      thTitle: Object(classnames_utils["a" /* classnames */])('font-bold font-brand leading-1 text-18', {
        'text-black': !isExclusiveCollection,
        'text-ultramarine': isExclusiveCollection
      }),
      thLabel: 'leading-1 font-bold font-sans text-sienna'
    },
    column: {
      thRoot: 'flex flex-col items-center py-10 px-5 text-12 w-full',
      thTitle: Object(classnames_utils["a" /* classnames */])('font-bold font-brand leading-1 text-18', {
        'text-black': !isExclusiveCollection,
        'text-ultramarine': isExclusiveCollection
      }),
      thLabel: 'leading-1 font-bold font-sans text-sienna'
    }
  };
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/PromotionTag.jsx



var PromotionTag_jsx = react_default.a.createElement;







var PromotionTag_PromotionTag = function PromotionTag(_ref) {
  var proposal = _ref.proposal,
      uniqDiscounts = _ref.uniqDiscounts;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var isHappyFirstEnabled = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.promotionHappyFirst') || true;
  var discountValue = getDiscountValueFromProposal(proposal);
  var discountIndex = uniqDiscounts.indexOf(discountValue);
  var showDisclamer = Object(src_i18n["d" /* getKeyValue */])('booking.accommodation.promotion.showDisclamer');
  var disclamerStars = showDisclamer ? '*'.repeat(discountIndex + 1) : '';
  var proposalHasHappyFirstOffer = !!discountValue;
  var shouldShowHappyFirstTags = isHappyFirstEnabled && proposalHasHappyFirstOffer;

  if (!shouldShowHappyFirstTags) {
    return null;
  }

  var chargePercentage = Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.chargePercentage', {
    charge_percentage: discountValue || 0
  });
  var promotionLabel = isRTL ? "".concat(disclamerStars, " ").concat(chargePercentage, " -") : "- ".concat(chargePercentage, " ").concat(disclamerStars);
  return PromotionTag_jsx("div", {
    className: "mt-8 flex justify-center sm:mt-0 sm:justify-end"
  }, PromotionTag_jsx(Tag["a" /* Tag */], {
    "data-testid": "promotion-tag",
    className: "border-sienna bg-sienna leading-normal text-white"
  }, promotionLabel));
};
// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/ProposalAccommodationTitle.jsx
var ProposalAccommodationTitle_jsx = react_default.a.createElement;







var ProposalAccommodationTitle_ProposalAccommodationTitle = function ProposalAccommodationTitle(_ref) {
  var includedLabel = _ref.includedLabel,
      priceLabel = _ref.priceLabel,
      product = _ref.product,
      proposal = _ref.proposal,
      uniqDiscounts = _ref.uniqDiscounts,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isExclusiveCollection = getExclusiveCollectionInAccommodations(proposal, product);
  var _themes$theme = ProposalAccommodationTitle_themes_themes(isExclusiveCollection)[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thTitle = _themes$theme.thTitle;
  var discountValue = getDiscountValueFromProposal(proposal);
  var proposalHasHappyFirstOffer = !!discountValue;
  var hasNoShownHappyFirst = !proposalHasHappyFirstOffer || !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.promotionHappyFirst');
  return ProposalAccommodationTitle_jsx("span", {
    className: thRoot,
    "data-testid": "ProposalAccommodationTitle"
  }, ProposalAccommodationTitle_jsx("span", {
    className: thTitle
  }, getAccommodationTitle(proposal, product)), hasNoShownHappyFirst && ProposalAccommodationTitle_jsx("span", {
    className: thLabel,
    "data-testid": "price-accommodationsTabs"
  }, priceLabel, includedLabel), isExclusiveCollection && ProposalAccommodationTitle_jsx(ExclusiveCollectionBadge["a" /* ExclusiveCollectionBadge */], null), ProposalAccommodationTitle_jsx(PromotionTag_PromotionTag, {
    proposal: proposal,
    uniqDiscounts: uniqDiscounts
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flatten.js
var flatten = __webpack_require__("1xil");
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);

// EXTERNAL MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js + 3 modules
var productAccommodations_utils = __webpack_require__("5svr");

// CONCATENATED MODULE: ./src/client/views/booking/accommodation/AccommodationsComparator.jsx


















var AccommodationsComparator_jsx = react_default.a.createElement;

function AccommodationsComparator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AccommodationsComparator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccommodationsComparator_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccommodationsComparator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var RANKINGS = dist["constants"].RANKINGS;

var AccommodationsComparator_AccommodationsComparator = function AccommodationsComparator(_ref) {
  var activeIndexes = _ref.activeIndexes,
      formatedPrices = _ref.formatedPrices,
      product = _ref.product,
      proposals = _ref.proposals,
      resolvedProposals = _ref.resolvedProposals;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var displayRoomsComparator = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('displayRoomsComparator');

  if (!displayRoomsComparator) {
    return null;
  }

  var allAccommodations = uniqBy_default()(flatten_default()(proposals.map(function (_ref2) {
    var accommodations = _ref2.accommodations,
        price = _ref2.price;
    var pricedAccommodations = accommodations;
    return pricedAccommodations.map(function (acc) {
      return AccommodationsComparator_objectSpread(AccommodationsComparator_objectSpread({}, acc), {}, {
        price: price
      });
    });
  })), 'id');

  var proposalAccommodationCategory = allAccommodations.map(function (_ref3, index) {
    var categoryId = _ref3.categoryId;
    return {
      id: categoryId,
      ranking: Object.values(RANKINGS)[index]
    };
  }); // $FlowFixMe

  var props = {
    accommodationCategory: {
      rankedCategories: proposalAccommodationCategory
    },
    resort: product
  };

  var _allAccommodations$re = allAccommodations.reduce(function (acc, _ref4) {
    var categoryId = _ref4.categoryId,
        comfortId = _ref4.comfortId,
        exclusiveCollection = _ref4.exclusiveCollection;
    acc.proposalAccommodationById.push(categoryId);
    acc.proposalAccommodationByType.push(Object(productAccommodations_utils["d" /* withExclusiveCollectionTag */])({
      categoryId: comfortId,
      isExclusiveCollection: exclusiveCollection
    }));
    return acc;
  }, {
    proposalAccommodationById: [],
    proposalAccommodationByType: []
  }),
      proposalAccommodationById = _allAccommodations$re.proposalAccommodationById,
      proposalAccommodationByType = _allAccommodations$re.proposalAccommodationByType;

  var accommodationCategories = Object(productAccommodations_utils["c" /* groupAccommodationsByCategory */])(props).filter(function (category) {
    return category.categoryAccommodations.some(function (categoryAccommodation) {
      return proposalAccommodationById.includes(categoryAccommodation.accommodation.categoryId);
    }) && proposalAccommodationByType.includes(category.categoryId);
  }).sort(function (current, next) {
    var currentIndex = proposals.findIndex(function (_proposal) {
      var _current$categoryAcco, _current$categoryAcco2, _proposal$accommodati, _proposal$accommodati2;

      return ((_current$categoryAcco = current.categoryAccommodations) === null || _current$categoryAcco === void 0 ? void 0 : (_current$categoryAcco2 = _current$categoryAcco[0]) === null || _current$categoryAcco2 === void 0 ? void 0 : _current$categoryAcco2.accommodation.categoryId) === ((_proposal$accommodati = _proposal.accommodations) === null || _proposal$accommodati === void 0 ? void 0 : (_proposal$accommodati2 = _proposal$accommodati[0]) === null || _proposal$accommodati2 === void 0 ? void 0 : _proposal$accommodati2.categoryId);
    });
    var nextIndex = proposals.findIndex(function (_proposal) {
      var _next$categoryAccommo, _next$categoryAccommo2, _proposal$accommodati3, _proposal$accommodati4;

      return ((_next$categoryAccommo = next.categoryAccommodations) === null || _next$categoryAccommo === void 0 ? void 0 : (_next$categoryAccommo2 = _next$categoryAccommo[0]) === null || _next$categoryAccommo2 === void 0 ? void 0 : _next$categoryAccommo2.accommodation.categoryId) === ((_proposal$accommodati3 = _proposal.accommodations) === null || _proposal$accommodati3 === void 0 ? void 0 : (_proposal$accommodati4 = _proposal$accommodati3[0]) === null || _proposal$accommodati4 === void 0 ? void 0 : _proposal$accommodati4.categoryId);
    });
    return currentIndex - nextIndex;
  }).map(function (category) {
    var proposal = resolvedProposals[category.categoryIndex];
    category.price = {
      initialPrice: proposal === null || proposal === void 0 ? void 0 : proposal.price.totalWithoutDiscount,
      bestPrice: proposal === null || proposal === void 0 ? void 0 : proposal.price.total,
      diffPrice: formatedPrices[category.categoryIndex] || ''
    };
    return category;
  });

  if (accommodationCategories.length <= 1) {
    return null;
  }

  var _getTabsItemsAndProps = Object(productAccommodations_utils["b" /* getTabsItemsAndPropsFromAccommodations */])(props, accommodationCategories),
      slot = _getTabsItemsAndProps.slot;

  return AccommodationsComparator_jsx("div", {
    className: "ml-auto mb-5"
  }, slot([activeIndexes]));
};


// CONCATENATED MODULE: ./src/client/views/booking/accommodation/AccommodationsTabs.jsx













var AccommodationsTabs_jsx = react_default.a.createElement;

function AccommodationsTabs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AccommodationsTabs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccommodationsTabs_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccommodationsTabs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var FLEX_RATES = dist["constants"].FLEX_RATES;

var AccommodationsTabs_AccommodationsTabs = function AccommodationsTabs(_ref) {
  var isComparatorView = _ref.isComparatorView,
      isLoading = _ref.isLoading,
      product = _ref.product,
      proposals = _ref.proposals,
      selectedProposal = _ref.selectedProposal,
      selectedRate = _ref.selectedRate,
      selectProposal = _ref.selectProposal,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers,
      tabTheme = _ref.tabTheme;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var locale = appContext.locale;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var uniqDiscounts = ProposalAccommodationTitleUtils_getUniqDiscountProposals(proposals);

  var updateUpsellRevenue = function updateUpsellRevenue() {
    var upsellRevenue = selectedProposal.price.total.value - Math.min.apply(Math, Object(toConsumableArray["a" /* default */])(proposals.map(function (_ref2) {
      var value = _ref2.price.total.value;
      return value;
    })));
    var rateType = '';

    switch (selectedRate) {
      case FLEX_RATES.STANDARD:
        rateType = 'standard';
        break;

      case FLEX_RATES.FLR:
        rateType = 'FlexibleRate';
        break;

      default:
        rateType = 'nonRefundableRate';
        break;
    }
    /*
      We need this information on BookingConfirmationView.
      To handle external payment provider redirection we have to store it outside of redux
     */


    tracking_storage_api["c" /* set */](AccommodationsTabs_objectSpread(AccommodationsTabs_objectSpread({}, tracking_storage_api["b" /* get */](tracking_constants["c" /* BE_TRACKING */])), {}, {
      rateType: rateType,
      upsellRevenue: upsellRevenue
    }));
  };

  Object(react["useEffect"])(function () {
    updateUpsellRevenue();
  }, [selectedProposal]);

  var onProposalSelection = function onProposalSelection(itemIndex) {
    var proposal = proposals[itemIndex];

    if ((proposal === null || proposal === void 0 ? void 0 : proposal.id) && !proposal.errorCode) {
      var _proposal$accommodati, _proposal$accommodati2;

      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'change_comfort',
        room_type: (_proposal$accommodati = proposal.accommodations[0].comfortId) === null || _proposal$accommodati === void 0 ? void 0 : (_proposal$accommodati2 = _proposal$accommodati.split('_')) === null || _proposal$accommodati2 === void 0 ? void 0 : _proposal$accommodati2.pop()
      });
      selectProposal(proposal.id);
      setSelectedRate(proposal.price.selectedRate);
    }
  };

  var initialSelectedItem = Math.max(0, proposals.indexOf(selectedProposal));
  var selectedProposalPrice = Object(proposalUtils["m" /* getTotalValue */])(selectedProposal);
  var proposalsLength = proposals.length;
  var resolvedProposals = Object(proposalUtils["k" /* getResolvedProposals */])(proposals);
  var formatedPrices = resolvedProposals.map(function (proposal) {
    return Object(proposalUtils["i" /* getPriceDiff */])(Object(proposalUtils["m" /* getTotalValue */])(proposal), selectedProposalPrice, locale, selectedProposal.price.currency);
  });
  var formattedPricesPerNight = resolvedProposals.map(function (proposal) {
    return Object(proposalUtils["i" /* getPriceDiff */])(Object(proposalUtils["m" /* getTotalValue */])(proposal) / proposal.duration, selectedProposalPrice / proposal.duration, locale, selectedProposal.price.currency);
  });
  var displayPrice = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.pricePerNight') ? formattedPricesPerNight : formatedPrices;

  var getPriceLabel = function getPriceLabel(formatedPrice) {
    var priceLabel = '';

    if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.pricePerNight')) {
      priceLabel = " ".concat(Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.perNight'));
    }

    if (formatedPrice === null) {
      priceLabel = Object(src_i18n["h" /* t */])('booking.accommodation.packageContent.included');
    }

    return priceLabel;
  };

  var items = resolvedProposals.map(function (proposal, index) {
    var formatedPrice = displayPrice[index];
    return {
      header: {
        title: AccommodationsTabs_jsx(ProposalAccommodationTitle_ProposalAccommodationTitle, {
          includedLabel: getPriceLabel(displayPrice[index]),
          numberOfTabs: proposalsLength,
          priceLabel: formatedPrice,
          product: product,
          proposal: proposal,
          theme: tabTheme,
          uniqDiscounts: uniqDiscounts
        })
      },
      content: [AccommodationsTabs_jsx(BookingAccommodations_BookingAccommodations, {
        accommodations: proposal.accommodations,
        isLoading: isLoading,
        key: proposal.id,
        product: product,
        proposal: proposal,
        selectedRate: selectedRate,
        setSelectedRate: setSelectedRate,
        streetViews: streetViews,
        switchOffers: switchOffers,
        theme: isComparatorView ? 'default' : 'large',
        accommodationsComparator: AccommodationsTabs_jsx(AccommodationsComparator_AccommodationsComparator, {
          activeIndexes: index,
          formatedPrices: formatedPrices,
          product: product,
          proposals: proposals,
          resolvedProposals: resolvedProposals
        })
      })]
    };
  });
  return AccommodationsTabs_jsx(Tabs["a" /* Tabs */], {
    initialSelectedItem: initialSelectedItem,
    isContainerWide: true,
    items: items,
    onSelect: onProposalSelection,
    theme: "rounded"
  });
};


// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js + 1 modules
var filterUtils = __webpack_require__("KxdP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: ./src/client/components/widgets/flex-rates/FlexRates.jsx + 1 modules
var FlexRates = __webpack_require__("ExLU");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/client/components/widgets/filters-bar/FiltersBar.jsx + 7 modules
var FiltersBar = __webpack_require__("jFIS");

// EXTERNAL MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodationsUtils.js
var AdditionalAccommodationsUtils = __webpack_require__("CwJu");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodations.tracking.js









function AdditionalAccommodations_tracking_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function AdditionalAccommodations_tracking_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? AdditionalAccommodations_tracking_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdditionalAccommodations_tracking_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




function trackSelectRoom(accommodationsSet, appContext) {
  var roomType = Object(utils["l" /* getTrackingRoomType */])(accommodationsSet.accommodations);
  tracking_api["b" /* setDataLayer */](AdditionalAccommodations_tracking_objectSpread(AdditionalAccommodations_tracking_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    versionBooking: 'responsive',
    actionGA: 'moreRooms',
    labelGA: "confirmRoom_".concat(roomType)
  }), appContext);
}
// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.utils.js
var accommodation_utils = __webpack_require__("Djgd");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-option/AccommodationOption.jsx + 1 modules
var AccommodationOption = __webpack_require__("Q10v");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-option-current/AccommodationOptionCurrent.jsx
var AccommodationOptionCurrent = __webpack_require__("IGVP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__("ssvU");

// CONCATENATED MODULE: ./src/client/components/utils/style/style.util.js


function remToPx(rem) {
  var _document;

  if ((_document = document) === null || _document === void 0 ? void 0 : _document.documentElement) {
    var fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return Number.isNaN(fontSize) ? rem * 16 : rem * fontSize;
  }

  return rem * 16;
}
// EXTERNAL MODULE: ./tailwind.config.js
var tailwind_config = __webpack_require__("0mz7");

// CONCATENATED MODULE: ./src/client/components/widgets/double-col-layer/DoubleColLayer.jsx


var DoubleColLayer_jsx = react_default.a.createElement;





var START_COL_CMP = 'StartCol';
var END_COL_CMP = 'EndCol';
var MARGIN_TOP = 0.875;
var HEADER_HEIGHT = 4;
var FIX_SCROLL_OFFSET = 2;
var DoubleColLayer_StartCol = function StartCol(_ref) {
  var children = _ref.children,
      additionalClasses = _ref.additionalClasses,
      dataTestId = _ref.dataTestId,
      activeCol = _ref.activeCol,
      isTablet = _ref.isTablet,
      isColSticky = _ref.isColSticky,
      headerOffset = _ref.headerOffset;
  var startColRef = Object(react["useRef"])();
  var stickyStyle = isTablet && isColSticky ? {
    position: 'fixed',
    top: "".concat(headerOffset || 5, "rem"),

    /**
     * have fun
     * comparing max-width container to half viewport size minus padding
     * react will remove calc() and expose the result for us
     * leaving min(maxWidth, halfViewport)
     */
    maxWidth: "calc(".concat(tailwind_config["theme"].maxWidth.site, " / 2)"),
    width: "calc(50vw - ".concat(tailwind_config["theme"].padding['5'], ")")
  } : null;
  return activeCol === START_COL_CMP || isTablet ? DoubleColLayer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('sm:w-1/2 mb-20', additionalClasses, {
      'w-full': !isTablet
    }),
    "data-testid": dataTestId,
    style: stickyStyle,
    ref: startColRef
  }, children) : null;
};
var DoubleColLayer_EndCol = function EndCol(_ref2) {
  var children = _ref2.children,
      additionalClasses = _ref2.additionalClasses,
      dataTestId = _ref2.dataTestId,
      activeCol = _ref2.activeCol,
      isTablet = _ref2.isTablet,
      isColSticky = _ref2.isColSticky;
  return activeCol === END_COL_CMP || isTablet ? DoubleColLayer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('sm:w-1/2 sm:ps-20 pb-40', additionalClasses, {
      'w-full': !isTablet,
      'sm:ms-auto': isColSticky
    }),
    "data-testid": dataTestId
  }, children) : null;
};
DoubleColLayer_StartCol.displayName = START_COL_CMP;
DoubleColLayer_EndCol.displayName = END_COL_CMP;
var DoubleColLayer_DoubleColLayer = function DoubleColLayer(_ref3) {
  var children = _ref3.children,
      _ref3$initialActiveCo = _ref3.initialActiveCol,
      initialActiveCol = _ref3$initialActiveCo === void 0 ? START_COL_CMP : _ref3$initialActiveCo,
      leftButtonLabel = _ref3.leftButtonLabel,
      rightButtonLabel = _ref3.rightButtonLabel,
      stickyTopPosition = _ref3.stickyTopPosition;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useState = Object(react["useState"])(initialActiveCol),
      activeCol = _useState[0],
      setActiveCol = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isSticky = _useState2[0],
      setIsSticky = _useState2[1];

  var _useState3 = Object(react["useState"])(0),
      currentScrollY = _useState3[0],
      setCurrentScrollY = _useState3[1];

  var stickyHeaderButtons = Object(react["useRef"])();
  var containerRef = Object(react["useRef"])();
  var layer = document.querySelector('[data-testid="Layer-body"]');
  var headerHeight = remToPx(HEADER_HEIGHT); // Header height

  var marginTop = remToPx(MARGIN_TOP); // Wrapper div has a parent with a margin of 0.875rem

  var baseScrollLimit = headerHeight + marginTop; // Reset active col when switching inbound/outbound

  Object(react["useEffect"])(function () {
    setActiveCol(initialActiveCol);
  }, [initialActiveCol]); // EasyComparison Mobile

  Object(react["useEffect"])(function () {
    var containerElement = containerRef.current;

    var handleScrollEasyComparison = function handleScrollEasyComparison() {
      if (activeCol === END_COL_CMP && containerElement != null) {
        setCurrentScrollY(containerElement.getBoundingClientRect().top);
      }
    };

    if (!isTablet && layer) {
      layer.addEventListener('scroll', handleScrollEasyComparison);
    }

    return function () {
      if (!isTablet && layer) {
        layer.removeEventListener('scroll', handleScrollEasyComparison);
      }
    };
  }, [activeCol]); // Sticky Buttons

  Object(react["useEffect"])(function () {
    var containerElement = containerRef.current;

    var handleScroll = function handleScroll() {
      if (containerElement != null) {
        var _stickyHeaderButtons$;

        // When the buttons are "fixed", it is not calculated in wrapperElement dimensions anymore
        var scrollTop = ((_stickyHeaderButtons$ = stickyHeaderButtons.current) === null || _stickyHeaderButtons$ === void 0 ? void 0 : _stickyHeaderButtons$.style.position) === 'fixed' ? baseScrollLimit + stickyHeaderButtons.current.getBoundingClientRect().height : baseScrollLimit;
        setIsSticky(containerElement.getBoundingClientRect().top <= scrollTop);
      }
    };

    if (layer) {
      layer.addEventListener('scroll', handleScroll);
    }

    return function () {
      if (layer) {
        layer.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  var childrenAsArray = react["Children"].toArray(children);
  var StartColCmp = childrenAsArray.find(function (_ref4) {
    var type = _ref4.type;
    return type.displayName === START_COL_CMP;
  });
  var EndColCmp = childrenAsArray.find(function (_ref5) {
    var type = _ref5.type;
    return type.displayName === END_COL_CMP;
  });

  if (react["Children"].count(children) !== 2 || !StartColCmp || !EndColCmp) {
    return null;
  }

  var isColSticky = isSticky && isTablet;
  var isHeaderSticky = isSticky && !isTablet;

  if (isHeaderSticky && stickyHeaderButtons.current) {
    stickyHeaderButtons.current.style.position = 'fixed';
    stickyHeaderButtons.current.style.top = "".concat(stickyTopPosition);
  }

  if (!isHeaderSticky && stickyHeaderButtons.current) {
    stickyHeaderButtons.current.style.position = 'static';
  }

  var childrenWithProps = react["Children"].map(children, function (child) {
    return /*#__PURE__*/Object(react["cloneElement"])(child, {
      isColSticky: isColSticky,
      activeCol: activeCol,
      isTablet: isTablet
    });
  });

  var onClickHandler = function onClickHandler() {
    setActiveCol(END_COL_CMP);

    if (currentScrollY && layer && stickyHeaderButtons.current) {
      // waiting for the col change Left / right
      setTimeout(function () {
        var buttons = stickyHeaderButtons.current;

        if (layer != null && buttons != null) {
          layer.scrollTo(0, Math.abs(currentScrollY) + // last scroll
          baseScrollLimit + buttons.getBoundingClientRect().height + remToPx(FIX_SCROLL_OFFSET));
        }
      }, 0);
    }
  };

  return DoubleColLayer_jsx("div", {
    ref: containerRef
  }, !isTablet && DoubleColLayer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex mb-40 z-1', {
      'bg-white border-b-1 border-lightGrey inset-x-0 px-20 my-15 shadow-diffuse': isHeaderSticky
    }),
    ref: stickyHeaderButtons
  }, DoubleColLayer_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('border-0 border-r-1 border-solid border-grey flex-1 font-bold px-20 py-5 text-14 underline', {
      'no-underline text-sienna': activeCol === START_COL_CMP
    }),
    onClick: function onClick() {
      return setActiveCol(START_COL_CMP);
    },
    type: "button"
  }, leftButtonLabel), DoubleColLayer_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('flex-1 font-bold px-20 py-5 text-14 underline', {
      'no-underline text-sienna': activeCol === END_COL_CMP
    }),
    onClick: onClickHandler,
    type: "button"
  }, rightButtonLabel)), DoubleColLayer_jsx("div", {
    className: "flex flex-row"
  }, childrenWithProps));
};
// EXTERNAL MODULE: ./src/client/components/widgets/paginate/Paginate.jsx + 1 modules
var Paginate = __webpack_require__("aGPO");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/list/AdditionalAccommodationsList.jsx


var AdditionalAccommodationsList_jsx = react_default.a.createElement;













var AdditionalAccommodationsList_AdditionalAccommodationsList = function AdditionalAccommodationsList(_ref) {
  var accommodationsSets = _ref.accommodationsSets,
      currency = _ref.currency,
      filteredAccommodationSets = _ref.filteredAccommodationSets,
      onAddAccommodation = _ref.onAddAccommodation,
      proposal = _ref.proposal,
      product = _ref.product,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var iterationNumber = 5;

  var _useState = Object(react["useState"])(iterationNumber),
      forceInitialShowingItemsNumber = _useState[0],
      setForceInitialShowingItemsNumber = _useState[1];

  if (accommodationsSets.length < 1) {
    return null;
  }

  var headerHeight = 60 + 70;
  var titleHeight = 27.5;
  var paddingHeight = 40;
  return AdditionalAccommodationsList_jsx(DoubleColLayer_DoubleColLayer, {
    leftButtonLabel: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.roomRecommendation'),
    rightButtonLabel: "".concat(Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.otherProposals'), " (").concat(filteredAccommodationSets.length, "\n    )"),
    initialActiveCol: isTablet ? START_COL_CMP : END_COL_CMP,
    stickyTopPosition: "140px"
  }, AdditionalAccommodationsList_jsx(DoubleColLayer_StartCol, {
    headerOffset: 8.75
  }, AdditionalAccommodationsList_jsx(Title["a" /* Title */], {
    className: "mb-20 hidden sm:flex",
    hLevel: 3,
    iconName: icons["a" /* ICONS */].CHECK,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.roomRecommendation')), AdditionalAccommodationsList_jsx(AccommodationOptionCurrent["a" /* AccommodationOptionCurrent */], {
    onSelect: function onSelect() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
        detail_click: 'current_room_validate'
      });
      onAddAccommodation();
    },
    style: isTablet ? {
      maxHeight: "calc(100vh - ".concat(titleHeight, "px - ").concat(headerHeight, "px - ").concat(paddingHeight, "px)")
    } : null
  }, AdditionalAccommodationsList_jsx(BookingAccommodations_BookingAccommodations, {
    accommodations: proposal.accommodations,
    isInMoreRoomLayer: true,
    product: product,
    proposal: proposal,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    streetViews: streetViews,
    theme: "medium"
  }))), AdditionalAccommodationsList_jsx(DoubleColLayer_EndCol, {
    dataTestId: "AdditionalAccommodationsList"
  }, AdditionalAccommodationsList_jsx(Title["a" /* Title */], {
    className: "mb-20 hidden sm:flex",
    hLevel: 3,
    theme: "title-brand-n3"
  }, filteredAccommodationSets.length, "\xA0", Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.otherProposals')), AdditionalAccommodationsList_jsx(Paginate["a" /* Paginate */], {
    forceInitialShowingItemsNumber: !isTablet ? forceInitialShowingItemsNumber : 0,
    iterationNumber: iterationNumber,
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.viewMore'),
    setForceInitialShowingItemsNumber: setForceInitialShowingItemsNumber
  }, filteredAccommodationSets.map(function (accommodationsSet, idx) {
    var _accommodationsSet$di, _accommodationsSet$to;

    return AdditionalAccommodationsList_jsx(AccommodationOption["a" /* AccommodationOption */], {
      className: "mb-40",
      id: accommodationsSet.id,
      index: idx + 1,
      key: accommodationsSet.id,
      onSelect: function onSelect() {
        trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
          detail_click: 'edit_room_validate'
        });
        onAddAccommodation(accommodationsSet.id);
      },
      price: {
        currency: currency,
        nigthly: ((_accommodationsSet$di = accommodationsSet.differentialPriceByNight) === null || _accommodationsSet$di === void 0 ? void 0 : _accommodationsSet$di.value) || 0,
        total: ((_accommodationsSet$to = accommodationsSet.totalDifferentialPrice) === null || _accommodationsSet$to === void 0 ? void 0 : _accommodationsSet$to.value) || 0,
        isUpgradableOnline: accommodationsSet.isUpgradableOnline
      }
    }, AdditionalAccommodationsList_jsx(BookingAccommodations_BookingAccommodations, {
      accommodations: accommodationsSet.accommodations,
      accommodationsCount: Object(accommodation_utils["a" /* getNbAccommodations */])(accommodationsSet),
      isInMoreRoomLayer: true,
      product: product,
      proposal: proposal,
      remainingStock: accommodationsSet.remainingStock,
      selectedRate: selectedRate,
      setSelectedRate: setSelectedRate,
      streetViews: streetViews,
      theme: "medium"
    }));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/list/AdditionalAccommodationsListWrapper.jsx

var AdditionalAccommodationsListWrapper_jsx = react_default.a.createElement;





var AdditionalAccommodationsListWrapper_AdditionalAccommodationsListWrapper = function AdditionalAccommodationsListWrapper(_ref) {
  var accommodationsSets = _ref.accommodationsSets,
      error = _ref.error,
      filteredAccommodationSets = _ref.filteredAccommodationSets,
      isDataFetched = _ref.isDataFetched,
      onAddAccommodation = _ref.onAddAccommodation,
      product = _ref.product,
      proposal = _ref.proposal,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews;

  if (isEmpty_default()(error)) {
    return AdditionalAccommodationsListWrapper_jsx(react["Fragment"], null, isDataFetched && accommodationsSets.length === 0 && AdditionalAccommodationsListWrapper_jsx("div", {
      className: "max-w-site-small mb-40 mx-auto"
    }, AdditionalAccommodationsListWrapper_jsx(Confirmation["a" /* Confirmation */], {
      icon: icons["a" /* ICONS */].CIRCLED_ACCOMMODATION,
      status: "neutral",
      text: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.noMoreRoomsAvailableDescription'),
      title: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.noMoreRoomsAvailableTitle')
    })), AdditionalAccommodationsListWrapper_jsx(AdditionalAccommodationsList_AdditionalAccommodationsList, {
      accommodationsSets: accommodationsSets,
      currency: proposal.price.currency,
      filteredAccommodationSets: filteredAccommodationSets,
      onAddAccommodation: onAddAccommodation,
      product: product,
      proposal: proposal,
      selectedRate: selectedRate,
      setSelectedRate: setSelectedRate,
      streetViews: streetViews
    }));
  }

  var errorMessageKey = 'booking.common.layer.unknownErrorDescription';

  if (error.errorCode === 'INVALID_BOOKING_CRITERIA') {
    errorMessageKey = 'booking.accommodation.moreRooms.seller.InvalidBookingCriteria';
  }

  return AdditionalAccommodationsListWrapper_jsx("div", {
    className: "max-w-site-small mx-auto"
  }, AdditionalAccommodationsListWrapper_jsx(Confirmation["a" /* Confirmation */], {
    status: "error",
    text: Object(src_i18n["h" /* t */])(errorMessageKey),
    title: Object(src_i18n["h" /* t */])('booking.common.layer.unknownErrorTitle')
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodations.jsx


















var AdditionalAccommodations_jsx = react_default.a.createElement;

function AdditionalAccommodations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AdditionalAccommodations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AdditionalAccommodations_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AdditionalAccommodations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


























var AdditionalAccommodations_AdditionalAccommodations = function AdditionalAccommodations(_ref) {
  var filters = _ref.filters,
      filterValues = _ref.filterValues,
      loaderClassName = _ref.loaderClassName,
      onClose = _ref.onClose,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? noop_default.a : _ref$onSubmit,
      _ref$processChangeAcc = _ref.processChangeAccommodation,
      processChangeAccommodation = _ref$processChangeAcc === void 0 ? true : _ref$processChangeAcc,
      product = _ref.product,
      proposal = _ref.proposal,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var dispatch = Object(es["d" /* useDispatch */])();
  var isLoading = Object(es["e" /* useSelector */])(booking_selector["p" /* getIsLoadingAdditionalAccommodations */]) || false;
  var accommodationsSets = Object(es["e" /* useSelector */])(booking_selector["a" /* getAdditionalAccommodations */]) || [];
  var filteredAccommodations = Object(es["e" /* useSelector */])(booking_selector["n" /* getFilteredAdditionalAccommodationsSets */]);
  var error = Object(es["e" /* useSelector */])(booking_selector["b" /* getAdditionalAccommodationsError */]);
  var isDataFetched = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.additionalAccommodations.isDataFetched;
  });

  var _useState = Object(react["useState"])(false),
      visibility = _useState[0],
      setVisibility = _useState[1];

  var options = Object(FlexRates["b" /* getFlexRatesOptions */])(proposal, appContext, 'medium');
  var selectedOption = options.find(function (option) {
    return option.id === selectedRate;
  });
  var withoutProposalAccommodationSets = Object(AdditionalAccommodationsUtils["a" /* filterAccommodations */])(proposal, accommodationsSets) || [];
  var filteredAccommodationSets = Object(AdditionalAccommodationsUtils["b" /* filterReducedMobilityAccomodation */])(visibility, filteredAccommodations);
  var accomodationsIdWithLowerCategories = accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].slice(0, accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].findIndex(function (id) {
    var _proposal$accommodati, _proposal$accommodati2;

    return id === ((_proposal$accommodati = proposal.accommodations) === null || _proposal$accommodati === void 0 ? void 0 : (_proposal$accommodati2 = _proposal$accommodati[0]) === null || _proposal$accommodati2 === void 0 ? void 0 : _proposal$accommodati2.categoryId);
  }));
  var filteredAccommodationsSetsWithHigherCategories = filteredAccommodationSets.filter(function (accomodationSets) {
    var _accomodationSets$acc, _accomodationSets$acc2;

    return accomodationSets.totalDifferentialPrice.value >= 0 && !accomodationsIdWithLowerCategories.includes((_accomodationSets$acc = accomodationSets.accommodations) === null || _accomodationSets$acc === void 0 ? void 0 : (_accomodationSets$acc2 = _accomodationSets$acc[0]) === null || _accomodationSets$acc2 === void 0 ? void 0 : _accomodationSets$acc2.categoryId);
  });
  /* We need to clean roomFilters from storage since we changed the proposal, and update the roomOptions */

  var updateUpsellRevenue = function updateUpsellRevenue(accommodationSet, proposalQuantity) {
    var storage = tracking_storage_api["b" /* get */](tracking_constants["c" /* BE_TRACKING */]); // $FlowFixMe

    var selectedProposalId = storage.contextNumber;
    var totalDifferentialPrice = accommodationSet.totalDifferentialPrice || {}; // $FlowFixMe

    var roomFilters = (storage.roomFilters || []).filter(function (roomFilter) {
      return roomFilter.proposalId === selectedProposalId;
    });
    var roomFiltersTotalUpsellRevenue = roomFilters.reduce(function (acc, _ref2) {
      var upsellRevenue = _ref2.upsellRevenue;
      return acc + upsellRevenue;
    }, 0); // $FlowFixMe

    var roomOptions = storage.roomOptions || {};
    var shouldClearOptions = proposal.id !== roomOptions.proposalId;
    var newUpsellRevenue = roomFiltersTotalUpsellRevenue + totalDifferentialPrice.value + (shouldClearOptions ? 0 : roomOptions.upsellRevenue || 0);
    /*
      We need this information on BookingConfirmationView.
      To handle external payment provider redirection we have to store it outside of redux
     */

    tracking_storage_api["c" /* set */](AdditionalAccommodations_objectSpread(AdditionalAccommodations_objectSpread({}, storage), {}, {
      roomFilters: [],
      roomOptions: {
        upsell: newUpsellRevenue > 0 ? 'yes' : 'no',
        upsellCategory: 'room',
        upsellRevenue: newUpsellRevenue,
        upsellQuantity: proposalQuantity,
        upsellName: accommodationSet.accommodations[0].id,
        proposalId: proposal.id
      }
    }));
  };

  var handleAddAccommodation = function handleAddAccommodation(accommodationId) {
    if (!accommodationId) {
      if (selectedRate !== proposal.price.selectedRate) {
        // $FlowFixMe offers always defined
        switchOffers(selectedOption.offers);
      }

      return onClose();
    } // $FlowFixMe there's always an AccommodationsSet


    var accommodationSet = find_default()(withoutProposalAccommodationSets, {
      id: accommodationId
    });

    var arrangement = accommodationSet.accommodations.map(function (_ref3) {
      var attendeesDistribution = _ref3.attendeesDistribution;
      return attendeesDistribution;
    }).filter(Boolean);
    updateUpsellRevenue(accommodationSet, withoutProposalAccommodationSets.length);

    if (!processChangeAccommodation) {
      return onSubmit(arrangement);
    }

    trackSelectRoom(accommodationSet, appContext);
    onSubmit(proposal.id);
    dispatch(Object(proposals_action["a" /* addAccommodation */])({
      arrangement: arrangement,
      globalLoaderLabel: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.loaderLabelUpdate'),
      isJoyview: product.isJoyview,
      isUrbanOasis: product.isUrbanOasis,
      proposalsId: Object(BookingEngine_utils["b" /* getAllProposalsIdWithAlternative */])(proposal),
      toastLabel: Object(bookingUtils["u" /* tAlt */])({
        cruiseKeyPath: 'booking.accommodation.newCabinSelection',
        product: product,
        resortKeyPath: 'booking.accommodation.newRoomSelection'
      }),
      appContext: appContext
    })).then(function () {
      if (selectedRate !== proposal.price.selectedRate) {
        // $FlowFixMe offers always defined
        switchOffers(selectedOption.offers);
      }
    });
  };

  var hasFiltersEnabled = filters.some(function (filter) {
    return filter.options.some(function (_ref4) {
      var isSelected = _ref4.isSelected;
      return isSelected;
    });
  });
  var handleUpdateAccomodationFilters = Object(filterUtils["e" /* updateFilters */])({
    accommodationsSets: accommodationsSets,
    filterValues: filterValues,
    visibility: visibility
  }, dispatch, setVisibility);
  Object(react["useEffect"])(function () {
    setTimeout(function () {
      var target = document.querySelector('#room-proposal-title');

      if (target) {
        target.scrollIntoView(); // the header is on top of the element that we targeted, so we have to scroll down the height of the header

        var container = document.querySelector('.scroll-y');

        if (container) {
          container.scrollTop -= Navigation_constants["d" /* heights */].NAVIGATION_LARGE_HEIGHT;
        }
      }
    }, 100);
  }, [isLoading]);
  return isLoading ? AdditionalAccommodations_jsx(AsyncLoader["a" /* AsyncLoader */], {
    className: Object(classnames_utils["a" /* classnames */])('mt-[25vh]', loaderClassName),
    "data-scroll-anchor": "loaderAdditionalAccommodations",
    icon: icons["a" /* ICONS */].STANDALONE_MAGNIFYING_GLASS,
    iconSize: "3rem",
    label: Object(bookingUtils["u" /* tAlt */])({
      cruiseKeyPath: 'booking.accommodation.moreRooms.moreCabinLoaderLabel',
      product: product,
      resortKeyPath: 'booking.accommodation.moreRooms.moreRoomLoaderLabel'
    }),
    theme: "labeled"
  }) : AdditionalAccommodations_jsx(react["Fragment"], null, AdditionalAccommodations_jsx("div", {
    className: "fixed inset-x-0 top-[60px] z-2"
  }, AdditionalAccommodations_jsx(FiltersBar["a" /* FiltersBar */], {
    caption: Object(src_i18n["h" /* t */])('filters.label'),
    dataTestid: "AccommodationsFilters",
    filters: filters,
    hasForceClose: true,
    isLarge: true,
    onChange: handleUpdateAccomodationFilters,
    onClear: function onClear(name) {
      dispatch(Object(additionalAccommodations_action["r" /* unselectAdditionalAccommodationsFilterCategory */])(name));
    },
    onClick: function onClick(name) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
        detail_click: "filter_".concat(utils["b" /* TRACKING_ACCOMMODATION_FILTER_TYPES */][name])
      });
    },
    onClickOption: function onClickOption(option) {
      if (option.isSelected) {
        var _TRACKING_ROOM_TYPE_B, _option$value;

        trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
          detail_click: "advanced_filter_".concat((_TRACKING_ROOM_TYPE_B = utils["c" /* TRACKING_ROOM_TYPE_BY_ACCOMMODATION_CATEGORY */][option.value]) !== null && _TRACKING_ROOM_TYPE_B !== void 0 ? _TRACKING_ROOM_TYPE_B : (_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.toLowerCase())
        });
      }
    },
    portalName: "AccommodationsFilterOptions"
  })), AdditionalAccommodations_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "mt-100 md:mt-80"
  }, AdditionalAccommodations_jsx(AdditionalAccommodationsListWrapper_AdditionalAccommodationsListWrapper, {
    accommodationsSets: withoutProposalAccommodationSets,
    error: error,
    filteredAccommodationSets: hasFiltersEnabled ? filteredAccommodationSets : filteredAccommodationsSetsWithHigherCategories,
    isDataFetched: isDataFetched,
    onAddAccommodation: handleAddAccommodation,
    proposal: proposal,
    product: product,
    streetViews: streetViews,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/utils/transport/transportUtils.js
var transportUtils = __webpack_require__("pdPG");

// CONCATENATED MODULE: ./src/client/components/widgets/layer-header-proposal/LayerHeaderProposal.jsx

var LayerHeaderProposal_jsx = react_default.a.createElement;




var LayerHeaderProposal_getTransportSummary = function getTransportSummary(proposal) {
  var currentTransport = proposal.transports;
  var inboundDeparture = Object(transportUtils["d" /* getInboundDeparture */])(currentTransport);
  var outboundDeparture = Object(transportUtils["e" /* getOutboundDeparture */])(currentTransport);
  var departureSummary = Object(transportUtils["i" /* getTravelSectionBoundSummary */])(inboundDeparture);
  var arrivalSummary = Object(transportUtils["i" /* getTravelSectionBoundSummary */])(outboundDeparture);
  return departureSummary && arrivalSummary ? "".concat(departureSummary, " - ").concat(arrivalSummary) : '';
};

var LayerHeaderProposal_getProposalSummary = function getProposalSummary(proposal, dateFormat) {
  var arrivalDate = Object(proposalUtils["f" /* getFormattedArrivalDate */])(proposal, dateFormat);
  var departureDate = Object(proposalUtils["g" /* getFormattedDepartureDate */])(proposal, dateFormat);
  return "".concat(arrivalDate, " - ").concat(departureDate);
};

var LayerHeaderProposal_LayerHeaderProposal = function LayerHeaderProposal(_ref) {
  var dateFormat = _ref.dateFormat,
      id = _ref.id,
      _ref$layerTitle = _ref.layerTitle,
      layerTitle = _ref$layerTitle === void 0 ? '' : _ref$layerTitle,
      numberResults = _ref.numberResults,
      proposal = _ref.proposal,
      _ref$totalPrice = _ref.totalPrice,
      totalPrice = _ref$totalPrice === void 0 ? '' : _ref$totalPrice;
  var summary = proposal.transports ? LayerHeaderProposal_getTransportSummary(proposal) : LayerHeaderProposal_getProposalSummary(proposal, dateFormat);
  return LayerHeaderProposal_jsx("div", {
    className: "flex gap-10 items-end justify-between mx-10 text-mediumGrey"
  }, LayerHeaderProposal_jsx("span", {
    className: "hidden lg:block font-bold text-16",
    "data-testid": "LayerHeaderProposal-summary"
  }, summary), LayerHeaderProposal_jsx("span", {
    className: "flex flex-1 gap-5 font-sans font-semibold items-center justify-center leading-tight text-20 text-black",
    "data-testid": "LayerHeaderProposal-title",
    id: id
  }, layerTitle, numberResults && LayerHeaderProposal_jsx("span", {
    className: "text-12"
  }, "(", numberResults, ")")), LayerHeaderProposal_jsx("span", {
    className: "hidden md:flex font-bold gap-10 items-end text-16"
  }, LayerHeaderProposal_jsx("span", {
    "data-testid": "LayerHeaderProposal-totalLabel"
  }, totalPrice), LayerHeaderProposal_jsx("span", {
    className: "text-sienna text-20",
    "data-testid": "LayerHeaderProposal-total"
  }, Object(proposalUtils["l" /* getTotalPriceFormatted */])(proposal))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/layers/AdditionalAccommodationsLayer.jsx








var AdditionalAccommodationsLayer_jsx = react_default.a.createElement;

function AdditionalAccommodationsLayer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AdditionalAccommodationsLayer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AdditionalAccommodationsLayer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AdditionalAccommodationsLayer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var AdditionalAccommodationsLayer_AdditionalAccommodationsLayer = function AdditionalAccommodationsLayer(_ref) {
  var children = _ref.children,
      filters = _ref.filters,
      filterValues = _ref.filterValues,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      portalName = _ref.portalName,
      _ref$processChangeAcc = _ref.processChangeAccommodation,
      processChangeAccommodation = _ref$processChangeAcc === void 0 ? true : _ref$processChangeAcc,
      product = _ref.product,
      proposal = _ref.proposal,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers;
  var beEngineTrackingContext = Object(react["useContext"])(BookingEngineTrackingContext["a" /* BookingEngineTrackingContext */]);
  var layerTitle = Object(bookingUtils["u" /* tAlt */])({
    cruiseKeyPath: 'booking.accommodation.moreRooms.modifyHeaderTitleCruise',
    product: product,
    resortKeyPath: 'booking.accommodation.moreRooms.modifyHeaderTitle'
  });
  return AdditionalAccommodationsLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerTitle,
    ariaLabelledby: identifiers_constants["a" /* ID_LAYER_HEADER__BE__ACCOMMODATIONS */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: onClose
    },
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    hasContainerHeader: true,
    header: AdditionalAccommodationsLayer_jsx(LayerHeaderProposal_LayerHeaderProposal, {
      id: identifiers_constants["a" /* ID_LAYER_HEADER__BE__ACCOMMODATIONS */],
      layerTitle: layerTitle,
      proposal: proposal,
      totalPrice: Object(src_i18n["h" /* t */])('booking.accommodation.moreRooms.totalPackagePriceLabel')
    }),
    onClose: onClose,
    portalName: portalName
  }, AdditionalAccommodationsLayer_jsx(TrackPage["a" /* TrackPage */], {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */].BE_LAYER_ACCOMMODATION,
    payload: AdditionalAccommodationsLayer_objectSpread({}, beEngineTrackingContext)
  }), children, AdditionalAccommodationsLayer_jsx(AdditionalAccommodations_AdditionalAccommodations, {
    filters: filters,
    filterValues: filterValues,
    loaderClassName: "mt-[10vh]",
    onClose: onClose,
    onSubmit: onSubmit,
    processChangeAccommodation: processChangeAccommodation,
    proposal: proposal,
    product: product,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    streetViews: streetViews,
    switchOffers: switchOffers
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/accommodation/more-rooms/MoreRooms.jsx
var MoreRooms_jsx = react_default.a.createElement;







var MoreRooms_MoreRooms = function MoreRooms(_ref) {
  var onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      portalName = _ref.portalName,
      _ref$processChangeAcc = _ref.processChangeAccommodation,
      processChangeAccommodation = _ref$processChangeAcc === void 0 ? true : _ref$processChangeAcc,
      product = _ref.product,
      proposal = _ref.proposal,
      streetViews = _ref.streetViews,
      switchOffers = _ref.switchOffers;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useState = Object(react["useState"])(proposal.price.selectedRate),
      selectedRate = _useState[0],
      setSelectedRate = _useState[1];

  var filterValues = Object(es["e" /* useSelector */])(booking_selector["c" /* getAdditionalAccommodationsFilters */]);
  var filters = Object(filterUtils["b" /* getFilters */])(product, filterValues || []);
  Object(react["useEffect"])(function () {
    dispatch(Object(additionalAccommodations_action["l" /* fetchAdditionalAccommodations */])({
      appContext: appContext,
      proposal: proposal,
      product: product,
      shouldPreselectFilters: false
    }));
    return function () {
      dispatch(Object(additionalAccommodations_action["k" /* clearAdditionalAccommodations */])());
    };
  }, []);
  var props = {
    filters: filters,
    filterValues: filterValues,
    onClose: onClose,
    onSubmit: onSubmit,
    portalName: portalName,
    processChangeAccommodation: processChangeAccommodation,
    product: product,
    proposal: proposal,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    streetViews: streetViews,
    switchOffers: switchOffers
  };
  return MoreRooms_jsx(AdditionalAccommodationsLayer_AdditionalAccommodationsLayer, props);
};
// CONCATENATED MODULE: ./src/client/views/booking/accommodation/AccommodationView.jsx
















var AccommodationView_jsx = react_default.a.createElement;


























var AccommodationView_AccommodationView = function AccommodationView(_ref) {
  var closeLayer = _ref.closeLayer,
      infoBannerData = _ref.infoBannerData,
      openLayer = _ref.openLayer,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      streetViews = _ref.streetViews;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      isLoading = _React$useState2[0],
      setIsLoading = _React$useState2[1];

  var _React$useState3 = react_default.a.useState(selectedProposal.price.selectedRate),
      _React$useState4 = Object(slicedToArray["a" /* default */])(_React$useState3, 2),
      selectedRate = _React$useState4[0],
      setSelectedRate = _React$useState4[1];

  var _React$useState5 = react_default.a.useState(selectedProposal),
      _React$useState6 = Object(slicedToArray["a" /* default */])(_React$useState5, 2),
      proposal = _React$useState6[0],
      setProposal = _React$useState6[1];

  var _React$useState7 = react_default.a.useState({
    proposal: null,
    errors: null
  }),
      _React$useState8 = Object(slicedToArray["a" /* default */])(_React$useState7, 2),
      refreshedProposal = _React$useState8[0],
      setRefreshedProposal = _React$useState8[1];

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var showDisclamer = Object(src_i18n["d" /* getKeyValue */])('booking.accommodation.promotion.showDisclamer');
  var uniqDiscountDetails = ProposalAccommodationTitleUtils_getUniqDiscountDetails(proposals);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    isPriceLoading: isLoading,
    noEdit: false
  });

  var getAlternativesForFilters = function getAlternativesForFilters() {
    var isAlternativeFiltersModeActive = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.AlternativeFiltersModeActive');

    if (isAlternativeFiltersModeActive && additionalAccommodations_action["n" /* getAlternativeFilteredAccommodations */]) {
      dispatch(Object(additionalAccommodations_action["n" /* getAlternativeFilteredAccommodations */])({
        appContext: appContext,
        proposal: selectedProposal
      }));
    }
  };

  Object(react["useEffect"])(function () {
    getAlternativesForFilters();
  }, []);
  Object(react["useEffect"])(function () {
    if (proposal.id !== selectedProposal.id || proposal.accommodations !== selectedProposal.accommodations) {
      setProposal(selectedProposal);
      getAlternativesForFilters();
    }
  }, [selectedProposal]);

  var onMoreRoomsClickOpen = function onMoreRoomsClickOpen() {
    return function () {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'see_more_rooms'
      });
      openLayer(booking_constants["a" /* BE_ACCOMMODATIONS_LAYER_NAME */]);
    };
  };

  var onMoreRoomsSelect = function onMoreRoomsSelect(proposalId) {
    var hasFlexRates = selectedProposal.price.hasFlexRates;
    closeLayer(!hasFlexRates, proposalId);
  };

  var onSelectProposal = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(proposalId) {
      var updatedUri, refreshProposal;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              updatedUri = new URI_default.a(router.asPath).setQuery(dist["appQueryParameters"].booking.selectedProposalId, proposalId);
              router.replace(updatedUri.toString());
              dispatch(Object(selectedProposalId_action["d" /* selectProposal */])(proposalId));
              _context.next = 5;
              return dispatch(Object(proposals_action["m" /* fetchRefreshProposal */])(proposalId, undefined, appContext));

            case 5:
              refreshProposal = _context.sent;
              return _context.abrupt("return", setRefreshedProposal(refreshProposal === null || refreshProposal === void 0 ? void 0 : refreshProposal.refreshProposal));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSelectProposal(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var switchOffers = function switchOffers(offers) {
    setIsLoading(true);
    dispatch(Object(proposals_action["y" /* switchProposalsOffers */])(offers, appContext)).finally(function () {
      return setIsLoading(false);
    });
  };

  if (isEmpty_default()(Object(proposalUtils["k" /* getResolvedProposals */])(proposals))) {
    return null;
  }

  var buttonProps = {
    label: Object(bookingUtils["u" /* tAlt */])({
      cruiseKeyPath: 'booking.accommodation.moreCabinsLabel',
      product: resort,
      resortKeyPath: 'booking.accommodation.moreRoomsLabel'
    }),
    trackingData: {
      appContext: appContext,
      baseProposal: proposals[0],
      selectedProposal: selectedProposal
    }
  };

  var participantCount = get_default()(selectedProposal, 'attendees.list.length', 0);

  var shouldDisplayMoreRoomsLayer = router.query[dist["appQueryParameters"].openLayer] === booking_constants["a" /* BE_ACCOMMODATIONS_LAYER_NAME */];
  return proposal && AccommodationView_jsx(react_default.a.Fragment, null, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'accommodation'
  }), AccommodationView_jsx(OverlaidActionProvider_OverlaidActionProvider, {
    button: {
      label: buttonProps.label,
      onClick: onMoreRoomsClickOpen()
    },
    dataSelector: "MoreRooms",
    label: Object(src_i18n["h" /* t */])('booking.accommodation.teasingMoreRooms')
  }, AccommodationView_jsx(AccommodationsTabs_AccommodationsTabs, {
    isLoading: isLoading,
    participantCount: participantCount,
    product: resort,
    proposals: proposals,
    selectedProposal: selectedProposal,
    selectedRate: selectedRate,
    selectProposal: onSelectProposal,
    setSelectedRate: setSelectedRate,
    switchOffers: switchOffers,
    streetViews: streetViews
  })), showDisclamer && uniqDiscountDetails.length > 0 && AccommodationView_jsx(SimpleNotification["a" /* SimpleNotification */], {
    id: "AccomodationDisclamer",
    title: Object(src_i18n["h" /* t */])('booking.accommodation.promotion.disclamerTitle'),
    className: "mt-40",
    content: AccommodationView_jsx("ul", {
      className: "list-none"
    }, uniqDiscountDetails.map(function (_ref3, index) {
      var discount = _ref3.value,
          description = _ref3.description;
      return AccommodationView_jsx("li", {
        key: "AccomodationDisclamer-".concat(index * 1)
      }, "".concat('*'.repeat(index + 1)).concat(Object(src_i18n["h" /* t */])('booking.accommodation.promotion.disclamer', {
        discount: discount
      })), description && " ".concat(description));
    })),
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }), shouldDisplayMoreRoomsLayer && AccommodationView_jsx(MoreRooms_MoreRooms, {
    onClose: function onClose(proposalId) {
      return closeLayer(false, proposalId);
    } // $FlowFixMe string is compatible with string | AccommodationArrangement
    ,
    onSubmit: onMoreRoomsSelect,
    proposal: selectedProposal,
    product: resort,
    streetViews: streetViews,
    switchOffers: switchOffers
  }), AccommodationView_jsx(RefreshProposalModal, {
    refreshedProposal: refreshedProposal,
    resort: resort,
    selectedProposal: selectedProposal
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/components/utils/booking/booking-additional-services/BookingAddtionalServices.utils.js
var BookingAddtionalServices_utils = __webpack_require__("JOeK");

// EXTERNAL MODULE: ./src/client/tracking/events/be.tracking.js
var be_tracking = __webpack_require__("fXWa");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/widgets/activities-categories/ActivitiesCategories.jsx + 2 modules
var ActivitiesCategories = __webpack_require__("RO1R");

// EXTERNAL MODULE: ./src/client/components/widgets/activities-thematics/ActivitiesThematics.jsx + 1 modules
var ActivitiesThematics = __webpack_require__("rNwk");

// EXTERNAL MODULE: ./src/client/components/widgets/rentals-cta/RentalsCta.jsx
var RentalsCta = __webpack_require__("38qS");

// EXTERNAL MODULE: ./src/client/components/utils/layers/layers.constants.js
var layers_constants = __webpack_require__("RDfq");

// EXTERNAL MODULE: ./src/hooks/use-layer/useLayer.js
var useLayer = __webpack_require__("1CQ+");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/ski-package-reassurance/SkiPackageReassurance.jsx

var SkiPackageReassurance_jsx = react_default.a.createElement;














var SkiPackageReassurance_SkiPackageReassurance = function SkiPackageReassurance(_ref) {
  var className = _ref.className,
      _ref$hasRentals = _ref.hasRentals,
      hasRentals = _ref$hasRentals === void 0 ? false : _ref$hasRentals;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useLayer = Object(useLayer["a" /* useLayer */])(layers_constants["h" /* LAYER_NAME_UPSELL_RENTALS */]),
      nextUri = _useLayer.nextUri;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var items = [{
    title: Object(src_i18n["h" /* t */])('booking.activities.skiPackage.skiPass'),
    text: Object(src_i18n["h" /* t */])('booking.activities.skiPackage.skiPassDescription')
  }, {
    title: Object(src_i18n["h" /* t */])('booking.activities.skiPackage.groupLessons'),
    text: Object(src_i18n["h" /* t */])('booking.activities.skiPackage.groupLessonsDescription')
  }];
  return isTablet ? SkiPackageReassurance_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('overflow-hidden rounded-12 bg-white p-20 shadow', className)
  }, SkiPackageReassurance_jsx(Title["a" /* Title */], {
    className: "mb-10",
    hLevel: 3,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('booking.activities.skiPackage.title')), items.map(function (_ref2, i) {
    var text = _ref2.text,
        title = _ref2.title;
    return SkiPackageReassurance_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('py-15', {
        'border-b-1 border-dashed': hasRentals || i !== items.length - 1
      }),
      key: title
    }, SkiPackageReassurance_jsx(Title["a" /* Title */], {
      className: "mb-5 !items-center",
      theme: "title-sans-n2"
    }, SkiPackageReassurance_jsx(Badge["a" /* Badge */], {
      className: "size-28",
      iconName: icons["a" /* ICONS */].SKI,
      variant: "pill"
    }), title, SkiPackageReassurance_jsx("span", {
      className: "ms-auto font-brand text-12 text-green"
    }, Object(src_i18n["h" /* t */])('common.included'))), SkiPackageReassurance_jsx(Text["a" /* Text */], {
      text: text,
      theme: "text-sans-n1"
    }));
  }), hasRentals && SkiPackageReassurance_jsx(DynamicLink["a" /* default */], {
    className: "block text-center",
    onClick: function onClick() {
      return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACTIVITIES, {
        detail_click: 'right_sidebar'
      });
    },
    shallow: true,
    url: nextUri
  }, SkiPackageReassurance_jsx(Badge["a" /* Badge */], {
    className: "mt-15 size-30 border-grey bg-white text-grey",
    iconName: icons["a" /* ICONS */].SKI_EQUIPMENTS,
    variant: "pill"
  }), SkiPackageReassurance_jsx(Text["a" /* Text */], {
    className: "mb-5",
    text: Object(src_i18n["h" /* t */])('booking.activities.skiEquipment.description'),
    theme: "text-sans-n1"
  }), SkiPackageReassurance_jsx("p", {
    className: "text-14 text-black underline"
  }, Object(src_i18n["h" /* t */])('booking.activities.skiEquipment.chooseCTA')))) : SkiPackageReassurance_jsx(Scrollable["a" /* Scrollable */], {
    className: Object(classnames_utils["a" /* classnames */])('-mx-20', className)
  }, SkiPackageReassurance_jsx("div", {
    className: "flex p-10"
  }, items.map(function (_ref3) {
    var text = _ref3.text,
        title = _ref3.title;
    return SkiPackageReassurance_jsx("div", {
      className: "last:scroll-x-ghost-m-20 last:scroll-x-ghost-m mx-10 w-[calc(100vw-60px)] flex-none rounded-12 bg-white p-10 shadow",
      key: title
    }, SkiPackageReassurance_jsx(Title["a" /* Title */], {
      className: "mb-5 !items-center",
      theme: "title-sans-n2"
    }, SkiPackageReassurance_jsx(Badge["a" /* Badge */], {
      className: "size-28",
      iconName: icons["a" /* ICONS */].SKI,
      variant: "pill"
    }), title, SkiPackageReassurance_jsx("span", {
      className: "ms-auto font-brand text-12 text-green"
    }, Object(src_i18n["h" /* t */])('common.included'))), SkiPackageReassurance_jsx(Text["a" /* Text */], {
      text: text,
      theme: "text-sans-n1"
    }));
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/activities-booking/ActivitiesBooking.jsx
var ActivitiesBooking = __webpack_require__("5YQs");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-booking/ProposalActivitiesBooking.jsx













var ProposalActivitiesBooking_jsx = react_default.a.createElement;

function ProposalActivitiesBooking_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProposalActivitiesBooking_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProposalActivitiesBooking_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProposalActivitiesBooking_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var ProposalActivitiesBooking_ProposalActivitiesBooking = function ProposalActivitiesBooking(_ref) {
  var categories = _ref.categories,
      hasRentals = _ref.hasRentals,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      thematics = _ref.thematics,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["categories", "hasRentals", "proposals", "resort", "selectedProposal", "thematics"]);

  var _useState = Object(react["useState"])(null),
      updateInfo = _useState[0],
      setUpdateInfo = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useSelector = Object(es["e" /* useSelector */])(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */]),
      attendeesWithInfos = _useSelector.attendees;

  var track = Object(useTracking["a" /* useTracking */])(be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */]);
  Object(react["useEffect"])(function () {
    var timer;

    if (updateInfo) {
      timer = setTimeout(function () {
        return setUpdateInfo(null);
      }, BookingAddtionalServices_utils["a" /* TOAST_DURATION */]);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [updateInfo]);
  var activitiesCategoriesWithAdditionnalServices = Object(BookingAddtionalServices_utils["i" /* mapActivitiesCategoriesWithAdditionnalServices */])(categories, selectedProposal.additionalServices.activities, {
    filtered: false
  });
  var activitiesThematicsWithAdditionnalServices = Object(BookingAddtionalServices_utils["i" /* mapActivitiesCategoriesWithAdditionnalServices */])(thematics, selectedProposal.additionalServices.activities, {
    filtered: false
  });
  return ProposalActivitiesBooking_jsx(ActivitiesBooking["a" /* ActivitiesBooking */], Object(esm_extends["a" /* default */])({}, rest, {
    categories: activitiesCategoriesWithAdditionnalServices,
    contextValue: {
      attendeesList: [].concat(Object(toConsumableArray["a" /* default */])(attendeesWithInfos.adults), Object(toConsumableArray["a" /* default */])(attendeesWithInfos.children.map(function (child) {
        return ProposalActivitiesBooking_objectSpread(ProposalActivitiesBooking_objectSpread({}, child), {}, {
          isChild: true
        });
      }))),
      availableActivities: selectedProposal.additionalServices.activities,
      currency: selectedProposal.price.currency,
      dates: {
        arrivalDate: moment_default()(selectedProposal.arrivalDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf(),
        departureDate: moment_default()(selectedProposal.departureDate, apiDate["a" /* API_DATE_FORMAT */]).valueOf()
      },
      isPriceForAdultOnly: true,
      hasRentals: hasRentals,
      scheduleReservationMessage: Object(src_i18n["h" /* t */])('booking.activities.sportActivities.changeSchedule'),
      setUpdateInfo: setUpdateInfo,
      trackingData: be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */],
      updateInfo: updateInfo,
      updateService: function updateService(attendees, pricingInfo, serviceIds, attendeeIds) {
        var info = {
          itemsNumber: attendees.length,
          message: attendees.length ? Object(src_i18n["h" /* t */])('booking.activities.newActivityAdded') : Object(src_i18n["h" /* t */])('booking.activities.newActivityRemoved')
        };

        if (attendees.length === 0) {
          return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
            appContext: appContext,
            attendeeIds: attendeeIds,
            serviceIds: serviceIds,
            showNotification: true
          })).then(function () {
            return setUpdateInfo(info);
          });
        }

        return dispatch(Object(proposals_action["d" /* addOrReplaceAdditionalServices */])({
          appContext: appContext,
          attendees: attendees,
          showNotification: true
        })).then(function () {
          return setUpdateInfo(info);
        }).catch(function (error) {
          return Object(BookingEngine_utils["i" /* trackErrorOnAddService */])(error, track, 'RENTAL_NOT_FOUND');
        });
      },
      showRentAllSchedules: true
    },
    thematics: activitiesThematicsWithAdditionnalServices
  }), ProposalActivitiesBooking_jsx("div", {
    className: "justify-between md:flex"
  }, resort.isWinter && !resort.isTour && !resort.isCruise && ProposalActivitiesBooking_jsx("aside", {
    className: "order-1 mb-20 md:mb-0 md:w-1/4",
    "data-testid": "Activities-asideText"
  }, ProposalActivitiesBooking_jsx(SkiPackageReassurance_SkiPackageReassurance, {
    hasRentals: hasRentals
  })), ProposalActivitiesBooking_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-col gap-20', {
      'md:w-2/3': resort.isWinter
    }),
    "data-testid": "activities-rentals"
  }, hasRentals && ProposalActivitiesBooking_jsx(RentalsCta["a" /* RentalsCta */], {
    className: "h-310",
    onClick: function onClick() {
      return track(be_tracking["b" /* TRACK_CLICK_EVENT_BE_RENTALS */]);
    }
  }), ProposalActivitiesBooking_jsx(ActivitiesCategories["a" /* ActivitiesCategories */], Object(esm_extends["a" /* default */])({}, rest, {
    categories: activitiesCategoriesWithAdditionnalServices,
    colsNumber: resort.isWinter && isDesktop ? 4 : 6,
    hasCounters: true,
    hasOnlineBookableCount: true,
    onClickCard: function onClickCard(type, hasOnlineBooking) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACTIVITIES, {
        detail_click: 'cards',
        availability: hasOnlineBooking ? 'yes' : 'no',
        activity_type: type === null || type === void 0 ? void 0 : type.toLowerCase()
      });
    }
  })))), activitiesThematicsWithAdditionnalServices.length > 0 && ProposalActivitiesBooking_jsx("div", {
    className: "mt-40"
  }, ProposalActivitiesBooking_jsx("p", {
    className: "mb-10 text-16 text-mediumGrey",
    "data-testid": "Activites-title"
  }, Object(src_i18n["h" /* t */])('common.activities.findYourThematic')), ProposalActivitiesBooking_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('common.activities.thematicTitle')), ProposalActivitiesBooking_jsx(ActivitiesThematics["a" /* ActivitiesThematics */], Object(esm_extends["a" /* default */])({}, rest, {
    hasCounters: true,
    isProposal: true,
    thematics: activitiesThematicsWithAdditionnalServices
  }))));
};
// CONCATENATED MODULE: ./src/client/tracking/tracking-api/useBETracking.js









function useBETracking_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function useBETracking_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? useBETracking_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : useBETracking_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var useBETracking_useBETracking = function useBETracking() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = {
    categoryGA: 'bookingEngine'
  };
  var track = Object(useTracking["a" /* useTracking */])(Object(utils["d" /* formatPayload */])(payload, options));
  return function (p) {
    return track(useBETracking_objectSpread(useBETracking_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), Object(utils["d" /* formatPayload */])(p, options)));
  };
};
// EXTERNAL MODULE: ./src/client/components/widgets/rentals-booking/RentalsBooking.jsx
var RentalsBooking = __webpack_require__("OTqw");

// CONCATENATED MODULE: ./src/client/components/widgets/rentals-booking/ProposalRentalsBooking.jsx













var ProposalRentalsBooking_jsx = react_default.a.createElement;

function ProposalRentalsBooking_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProposalRentalsBooking_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProposalRentalsBooking_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProposalRentalsBooking_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var ProposalRentalsBooking_ProposalRentalsBooking = function ProposalRentalsBooking(_ref) {
  var _selectedProposal$add, _selectedProposal$add2;

  var proposals = _ref.proposals,
      rentals = _ref.rentals,
      selectedProposal = _ref.selectedProposal,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["proposals", "rentals", "selectedProposal"]);

  var _useState = Object(react["useState"])(null),
      updateInfo = _useState[0],
      setUpdateInfo = _useState[1];

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var track = useBETracking_useBETracking();

  var _useSelector = Object(es["e" /* useSelector */])(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */]),
      attendeesWithInfos = _useSelector.attendees;

  Object(react["useEffect"])(function () {
    var timer;

    if (updateInfo) {
      timer = setTimeout(function () {
        return setUpdateInfo(null);
      }, BookingAddtionalServices_utils["a" /* TOAST_DURATION */]);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [updateInfo]);
  var contextValue = Object(react["useMemo"])(function () {
    return {
      attendeesList: [].concat(Object(toConsumableArray["a" /* default */])(attendeesWithInfos.adults), Object(toConsumableArray["a" /* default */])(attendeesWithInfos.children.map(function (child) {
        return ProposalRentalsBooking_objectSpread(ProposalRentalsBooking_objectSpread({}, child), {}, {
          isChild: true
        });
      }))),
      currency: selectedProposal.price.currency,
      hideAgeServiceSlot: true,
      setUpdateInfo: setUpdateInfo,
      showRentAllSchedules: true,
      trackingData: be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */],
      updateInfo: updateInfo,
      updateService: function updateService(attendees, pricingInfo, serviceIds, attendeeIds) {
        var info = {
          itemsNumber: attendees.length,
          message: attendees.length ? Object(src_i18n["h" /* t */])('booking.activities.skiEquipment.newEquipmentAdded') : Object(src_i18n["h" /* t */])('booking.activities.skiEquipment.newEquipmentRemoved')
        };

        if (attendees.length === 0) {
          return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
            showNotification: true,
            serviceIds: serviceIds,
            attendeeIds: attendeeIds,
            appContext: appContext
          })).then(function () {
            return setUpdateInfo(info);
          });
        }

        return dispatch(Object(proposals_action["d" /* addOrReplaceAdditionalServices */])({
          showNotification: true,
          attendees: attendees,
          appContext: appContext
        })).then(function () {
          return setUpdateInfo(info);
        }).catch(function (error) {
          return Object(BookingEngine_utils["i" /* trackErrorOnAddService */])(error, track, 'RENTAL_NOT_FOUND');
        });
      }
    };
  }, [appContext, attendeesWithInfos, selectedProposal, updateInfo]);

  if ((selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$add = selectedProposal.additionalServices) === null || _selectedProposal$add === void 0 ? void 0 : (_selectedProposal$add2 = _selectedProposal$add.rentals) === null || _selectedProposal$add2 === void 0 ? void 0 : _selectedProposal$add2.length) === 0) {
    return null;
  }

  var rentalsWithAdditionnalServices = Object(BookingAddtionalServices_utils["j" /* mapRentalsWithAdditionnalServices */])(rentals, selectedProposal.additionalServices.rentals, {
    filtered: true
  });
  return ProposalRentalsBooking_jsx(RentalsBooking["a" /* RentalsBooking */], Object(esm_extends["a" /* default */])({}, rest, {
    contextValue: contextValue,
    rentals: rentalsWithAdditionnalServices
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/booking-navbar/BookingNavbarContext.jsx
var BookingNavbarContext = __webpack_require__("4ryf");

// CONCATENATED MODULE: ./src/client/views/booking/activities/ActivitiesView.jsx

var ActivitiesView_jsx = react_default.a.createElement;









var ActivitiesView_ActivitiesView = function ActivitiesView(_ref) {
  var _resort$rentalsTree;

  var infoBannerData = _ref.infoBannerData,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal;

  var _useBookingNavbarCont = Object(BookingNavbarContext["b" /* useBookingNavbarContext */])(),
      navbarRef = _useBookingNavbarCont.navbarRef;

  var hasRentals = Boolean(resort === null || resort === void 0 ? void 0 : (_resort$rentalsTree = resort.rentalsTree) === null || _resort$rentalsTree === void 0 ? void 0 : _resort$rentalsTree.length);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    noEdit: false,
    portalPosition: Portal_constants["b" /* AFTER_APP */],
    navbarRef: navbarRef
  });
  return ActivitiesView_jsx(react["Fragment"], null, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'activities'
  }), ActivitiesView_jsx(Title["a" /* Title */], {
    className: "mb-30",
    dataTestId: "Activities-title",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('common.activities.activitiesUpsellTitle', {
    productName: resort === null || resort === void 0 ? void 0 : resort.name
  })), hasRentals && ActivitiesView_jsx(ProposalRentalsBooking_ProposalRentalsBooking, {
    className: "mb-20",
    "data-testid": "rentals",
    forwardRef: navbarRef,
    proposals: proposals,
    rentals: resort.rentalsTree,
    selectedProposal: selectedProposal
  }), ActivitiesView_jsx(ProposalActivitiesBooking_ProposalActivitiesBooking, {
    categories: resort.activityTree,
    forwardRef: navbarRef,
    hasRentals: hasRentals,
    proposals: proposals,
    resort: resort,
    selectedProposal: selectedProposal,
    thematics: resort.thematicActivityTree
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.jsx + 48 modules
var PaymentInfo = __webpack_require__("yzIS");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfoContext.js
var PaymentInfoContext = __webpack_require__("lr0Z");

// EXTERNAL MODULE: ./src/client/views/booking/banking/Reassurance.jsx
var Reassurance = __webpack_require__("oGbU");

// EXTERNAL MODULE: ./src/client/views/booking/banking/FailedPaymentModal.jsx
var FailedPaymentModal = __webpack_require__("2dnA");

// EXTERNAL MODULE: ./src/client/views/booking/banking/PaidBankingFormContent.jsx
var PaidBankingFormContent = __webpack_require__("S4CH");

// EXTERNAL MODULE: ./src/client/views/booking/banking/useBankingView.jsx + 1 modules
var useBankingView = __webpack_require__("sZKc");

// CONCATENATED MODULE: ./src/client/views/booking/banking/BankingView.jsx
var BankingView_jsx = react_default.a.createElement;












var BankingView_BankingView = function BankingView(_ref) {
  var i18n = _ref.i18n,
      selectedProposal = _ref.selectedProposal,
      _ref$additionalProvid = _ref.additionalProviders,
      additionalProviders = _ref$additionalProvid === void 0 ? [] : _ref$additionalProvid,
      resort = _ref.resort,
      infoBannerData = _ref.infoBannerData,
      attendeesPaymentStatus = _ref.attendeesPaymentStatus;

  var _useBankingView = Object(useBankingView["a" /* useBankingView */])({
    selectedProposal: selectedProposal,
    additionalProviders: additionalProviders,
    resort: resort,
    attendeesPaymentStatus: attendeesPaymentStatus
  }),
      openFailedPaymentModal = _useBankingView.openFailedPaymentModal,
      handleFailedPaymentModalClose = _useBankingView.handleFailedPaymentModalClose,
      paymentInfoValue = _useBankingView.paymentInfoValue,
      hasBasePaymentData = _useBankingView.hasBasePaymentData,
      hasPaid = _useBankingView.hasPaid,
      paymentProvidersWithValidMethods = _useBankingView.paymentProvidersWithValidMethods,
      household = _useBankingView.household,
      payingHousehold = _useBankingView.payingHousehold;

  return BankingView_jsx(react["Fragment"], null, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'banking'
  }), BankingView_jsx(SimpleNotification["a" /* SimpleNotification */], {
    id: "BankingViewInformations",
    content: Object(src_i18n["h" /* t */])('booking.banking.paymentEmergency'),
    iconName: icons["a" /* ICONS */].CLOCK_SPEED,
    className: "mb-20"
  }), openFailedPaymentModal && BankingView_jsx(FailedPaymentModal["a" /* FailedPaymentModal */], {
    onClose: handleFailedPaymentModalClose
  }), BankingView_jsx(PaymentInfoContext["b" /* PaymentInfoProvider */], {
    value: paymentInfoValue
  }, hasBasePaymentData ? BankingView_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, BankingView_jsx("div", {
    className: "xs:w-full px-5 md:w-full"
  }, hasPaid ? BankingView_jsx(PaidBankingFormContent["a" /* PaidBankingFormContent */], null) : BankingView_jsx(PaymentInfo["a" /* PaymentInfo */], {
    i18n: i18n,
    paymentProviders: paymentProvidersWithValidMethods // $FlowFixMe flow can't understand that at this point there is always a paymentSchedule
    ,
    paymentSchedule: household.paymentSchedule,
    price: household.paymentSchedule.total,
    payingHousehold: payingHousehold
  }))) : null), BankingView_jsx(Reassurance["a" /* Reassurance */], {
    className: "mt-20",
    i18n: i18n
  }));
};


// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("aLgo");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("hCOa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/crypto-js/index.js
var crypto_js = __webpack_require__("wIp5");
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// EXTERNAL MODULE: ./src/client/store/validation-schema/validationSchema.selectors.js
var validationSchema_selectors = __webpack_require__("PwcU");

// EXTERNAL MODULE: ./src/utils/phone/phoneCode.utils.js
var phoneCode_utils = __webpack_require__("F5eH");

// EXTERNAL MODULE: ./src/client/context/OptinsProvider.js
var OptinsProvider = __webpack_require__("H8tl");

// EXTERNAL MODULE: /opt/webapp/node_modules/lz-string/libs/lz-string.js
var lz_string = __webpack_require__("O2W8");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/ScrollToErrorHook.js
var ScrollToErrorHook = __webpack_require__("I7/a");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__("6LKR");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 14 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/MultiCGUBlock.jsx























var MultiCGUBlock_jsx = react_default.a.createElement;

function MultiCGUBlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MultiCGUBlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MultiCGUBlock_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MultiCGUBlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/prefer-exact-props */








 // types

// CGU ITEM
var MultiCGUBlock_CGUItem = function CGUItem(_ref) {
  var cguItem = _ref.cguItem,
      i18n = _ref.i18n;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  return MultiCGUBlock_jsx("div", {
    className: "mb-20",
    "data-testid": "multiCGUBlock-cguItem"
  }, MultiCGUBlock_jsx("div", {
    className: "mb-10 text-20 font-bold text-saffron"
  }, cguItem.title), MultiCGUBlock_jsx("div", {
    className: "mb-10 whitespace-pre-wrap text-black"
  }, cguItem.description), MultiCGUBlock_jsx(FormikInput["a" /* FormikInput */], {
    label: i18n.booking.participants.agreeButton,
    name: "adults.0.optinsCGU.".concat(cguItem.id, ".optin"),
    type: "checkbox",
    additionnalClasses: "text-16",
    onChange: function onChange() {
      var _formik$values$adults, _formik$values$adults2;

      formik.setFieldValue("adults.0.optinsCGU.".concat(cguItem.id), {
        channel: cguItem.id,
        optin: !((_formik$values$adults = formik.values.adults[0].optinsCGU) === null || _formik$values$adults === void 0 ? void 0 : (_formik$values$adults2 = _formik$values$adults[cguItem.id]) === null || _formik$values$adults2 === void 0 ? void 0 : _formik$values$adults2.optin),
        optin_partners: false
      });
    },
    validate: Object(ContactInfoUtils["k" /* getLegalAgreementValidator */])(),
    isRequired: cguItem.required
  }));
}; // MULTICGUs BLOCK


var MultiCGUBlock_MultiCGUBlock = function MultiCGUBlock(_ref2) {
  var _formik$values$adults6;

  var i18n = _ref2.i18n,
      idsCGU = _ref2.idsCGU;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var CGUs = i18n.bookingProcess; // filter the CGU to show in the block ( omitting phone/mail optin ... )

  var desiredCGUS = CGUs === null || CGUs === void 0 ? void 0 : CGUs.filter(function (cguItem) {
    return idsCGU.includes(cguItem.id);
  });
  Object(react["useEffect"])(function () {
    if (desiredCGUS.length > 0) {
      var initialOptins = desiredCGUS.reduce(function (acc, cguItem) {
        if (cguItem.required) {
          acc[cguItem.id] = {
            channel: cguItem.id,
            optin: cguItem.preChecked || false,
            optin_partners: false
          };
        }

        return acc;
      }, {});
      formik.setFieldValue('adults.0.optinsCGU', initialOptins);
    }
  }, []);
  Object(react["useEffect"])(function () {
    var _formik$values$adults3, _formik$values$adults4, _formik$values$adults5;

    var optins = ((_formik$values$adults3 = formik.values.adults) === null || _formik$values$adults3 === void 0 ? void 0 : (_formik$values$adults4 = _formik$values$adults3[0]) === null || _formik$values$adults4 === void 0 ? void 0 : _formik$values$adults4.optinsCGU) || {}; // $FlowFixMe - we know optins is an object with .optin booleans

    var allChecked = Object.values(optins).every(function (item) {
      return (item === null || item === void 0 ? void 0 : item.optin) === true;
    });

    if (((_formik$values$adults5 = formik.values.adults[0]) === null || _formik$values$adults5 === void 0 ? void 0 : _formik$values$adults5.checkAll) !== allChecked) {
      formik.setFieldValue('adults.0.checkAll', allChecked);
    }
  }, [(_formik$values$adults6 = formik.values.adults[0]) === null || _formik$values$adults6 === void 0 ? void 0 : _formik$values$adults6.optinsCGU]);

  var checkAll = function checkAll(e) {
    var _formik$values$adults7, _formik$values$adults8;

    var isChecked = e.currentTarget.checked;
    var currentOptins = ((_formik$values$adults7 = formik.values.adults) === null || _formik$values$adults7 === void 0 ? void 0 : (_formik$values$adults8 = _formik$values$adults7[0]) === null || _formik$values$adults8 === void 0 ? void 0 : _formik$values$adults8.optinsCGU) || {};
    var updatedOptins = Object.fromEntries(Object.entries(currentOptins).map(function (_ref3) {
      var _ref4 = Object(slicedToArray["a" /* default */])(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      return [key, MultiCGUBlock_objectSpread(MultiCGUBlock_objectSpread({}, value), {}, {
        optin: isChecked
      })];
    }));
    formik.setFieldValue('adults.0.optinsCGU', updatedOptins);
    formik.setFieldValue('adults.0.checkAll', isChecked);
  };

  if (desiredCGUS.length > 1) {
    return MultiCGUBlock_jsx("div", {
      className: "mt-10 text-12",
      "data-testid": "multiCGUBlock-checkAll"
    }, MultiCGUBlock_jsx(Capsule["a" /* Capsule */], {
      header: "none",
      additionalStyle: {
        content: {
          padding: '1.25rem'
        }
      }
    }, MultiCGUBlock_jsx(FormikInput["a" /* FormikInput */], {
      additionnalClasses: "text-18 mb-10",
      className: "text-18 text-black",
      label: i18n.booking.participants.agreeAll,
      name: "adults.0.checkAll",
      onChange: checkAll,
      type: "checkbox"
    }), MultiCGUBlock_jsx("div", {
      className: "mb-10"
    }, i18n.booking.participants.personalDataIntroduction), desiredCGUS.map(function (desiredCGUItem, index) {
      return MultiCGUBlock_jsx(MultiCGUBlock_CGUItem, {
        key: "CGUItem-".concat(index + 1),
        cguItem: desiredCGUItem,
        i18n: i18n
      });
    }), MultiCGUBlock_jsx("div", null, i18n.booking.participants.disagreePersonalDataCollection, MultiCGUBlock_jsx(DynamicLink["a" /* default */], {
      target: "_blank",
      url: i18n.booking.participants.personalDataCollectURL
    }, i18n.booking.participants.personalDataCollectLink))));
  } // Existant (EX : 1 GCU Russia CNIL)


  if (desiredCGUS.length === 1) {
    if (desiredCGUS[0].required) {
      var _uniqueCguItem$url;

      var uniqueCguItem = desiredCGUS[0];
      var cleanUrl = (uniqueCguItem === null || uniqueCguItem === void 0 ? void 0 : (_uniqueCguItem$url = uniqueCguItem.url) === null || _uniqueCguItem$url === void 0 ? void 0 : _uniqueCguItem$url.startsWith('http')) ? uniqueCguItem.url : "https://".concat(uniqueCguItem.url);
      return MultiCGUBlock_jsx("div", {
        className: "mt-10",
        "data-testid": "multiCGUBlock-cguItem"
      }, MultiCGUBlock_jsx(Title["a" /* Title */], {
        className: "mb-10",
        theme: "title-brand-n2"
      }, uniqueCguItem.label), MultiCGUBlock_jsx(Capsule["a" /* Capsule */], {
        header: "none",
        className: "flex",
        additionalStyle: {
          content: {
            padding: '1.25rem'
          }
        }
      }, MultiCGUBlock_jsx("div", {
        className: "flex"
      }, MultiCGUBlock_jsx(FormikInput["a" /* FormikInput */], {
        isRequired: true,
        className: "flex-none p-20",
        name: "adults.0.optinsCGU.".concat(uniqueCguItem.id, ".optin"),
        type: "checkbox",
        onChange: function onChange() {
          var _formik$values$adults9, _formik$values$adults10;

          formik.setFieldValue("adults.0.optinsCGU.".concat(uniqueCguItem.id), {
            channel: uniqueCguItem.id,
            optin: !((_formik$values$adults9 = formik.values.adults[0].optinsCGU) === null || _formik$values$adults9 === void 0 ? void 0 : (_formik$values$adults10 = _formik$values$adults9[uniqueCguItem.id]) === null || _formik$values$adults10 === void 0 ? void 0 : _formik$values$adults10.optin),
            optin_partners: false
          });
        },
        validate: Object(ContactInfoUtils["k" /* getLegalAgreementValidator */])(),
        isFlex: false
      }), MultiCGUBlock_jsx("div", {
        className: "mb-10 whitespace-pre-wrap text-black"
      }, MultiCGUBlock_jsx("span", null, uniqueCguItem.description), MultiCGUBlock_jsx("br", null), cleanUrl && (uniqueCguItem === null || uniqueCguItem === void 0 ? void 0 : uniqueCguItem.urlLabel) && MultiCGUBlock_jsx("a", {
        href: cleanUrl,
        rel: "noopener noreferrer",
        target: "_blank"
      }, MultiCGUBlock_jsx("span", {
        className: "underline"
      }, uniqueCguItem.urlLabel))))));
    }

    return MultiCGUBlock_jsx("div", {
      className: "mt-10",
      "data-testid": "multiCGUBlock-cguItem"
    }, MultiCGUBlock_jsx("div", null, desiredCGUS[0].label), MultiCGUBlock_jsx(TextSeeMore["a" /* TextSeeMore */], {
      text: "".concat(desiredCGUS[0].description, " \n\n(2) ").concat(Object(src_i18n["h" /* t */])('booking.participants.subscription.condition')),
      theme: "text-sans-n2",
      seeMoreLabel: i18n.booking.participants.legalMessage.seeMoreLabel
    }));
  }

  return null;
};
// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// EXTERNAL MODULE: ./src/client/components/frameworks/heading/Heading.jsx + 1 modules
var Heading = __webpack_require__("3jv5");

// EXTERNAL MODULE: ./src/client/components/widgets/user-info-summary/UserInfoSummary.jsx
var UserInfoSummary = __webpack_require__("RmUC");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfoFormContent.jsx + 5 modules
var PersonInfoFormContent = __webpack_require__("DhzB");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/store/booking/travel-companion/travel-companion.reducer.js
var travel_companion_reducer = __webpack_require__("dGyR");

// CONCATENATED MODULE: ./src/client/store/booking/travel-companion/travel-companion.action.js


var travel_companion_action_addTravelCompanion = function addTravelCompanion(payload) {
  return Object(createAction["b" /* default */])(travel_companion_reducer["a" /* ADD_TRAVEL_COMPANION */], payload);
};
var travel_companion_action_editTravelCompanion = function editTravelCompanion(payload) {
  return Object(createAction["b" /* default */])(travel_companion_reducer["b" /* EDIT_TRAVEL_COMPANION */], payload);
};
var travel_companion_action_selectTravelCompanion = function selectTravelCompanion(payload) {
  return Object(createAction["b" /* default */])(travel_companion_reducer["c" /* SELECT_TRAVEL_COMPANION */], payload);
};
var travel_companion_action_unselectTravelCompanion = function unselectTravelCompanion(payload) {
  return Object(createAction["b" /* default */])(travel_companion_reducer["d" /* UNSELECT_TRAVEL_COMPANION */], payload);
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/TravelCompanionBlock.themes.js
var TravelCompanionBlock_themes_themes = {
  selectable: function selectable(_ref) {
    var isHovering = _ref.isHovering;
    return {
      thRoot: "bg-white text-black duration-250 ease-in transition-all ".concat(isHovering ? 'border-grey' : 'border-white'),
      theNameLabel: ' text-black text-14 truncate w-full font-bold',
      theBirthdateLabel: ' text-black text-12 mb-10'
    };
  },
  selected: function selected() {
    return {
      thRoot: 'text-success border-success',
      theNameLabel: ' text-black text-14 truncate w-full font-bold',
      theBirthdateLabel: ' text-black text-12 mb-10'
    };
  },
  disabled: function disabled() {
    return {
      thRoot: 'text-mediumGrey border-mediumGrey pointer-events-none',
      theNameLabel: ' text-mediumGrey text-14 truncate w-full font-bold',
      theBirthdateLabel: ' text-mediumGrey text-12 mb-10'
    };
  },
  hidden: function hidden() {
    return {};
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/TravelCompanionBlock.jsx








var TravelCompanionBlock_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */














var STATUS = {
  SELECTED: 'selected',
  DISABLED: 'disabled',
  SELECTABLE: 'selectable',
  HIDDEN: 'hidden'
};

var TravelCompanionBlock_IconBlock = function IconBlock(_ref) {
  var status = _ref.status;

  if (status === STATUS.SELECTED) {
    return TravelCompanionBlock_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].CHECK,
      width: "1.2em",
      className: "text-green"
    });
  }

  if (status === STATUS.DISABLED) {
    return TravelCompanionBlock_jsx("div", {
      className: "rounded-full border-1 border-mediumGrey p-5 leading-0"
    }, TravelCompanionBlock_jsx(Icon["a" /* Icon */], {
      className: "text-mediumGrey",
      name: icons["a" /* ICONS */].PLUS,
      width: "1.2em"
    }));
  }

  return TravelCompanionBlock_jsx("div", {
    className: "rounded-full border-1 border-saffron bg-saffron p-5 leading-0"
  }, TravelCompanionBlock_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].PLUS,
    width: "1.2em"
  }));
};

var TravelCompanionBlock_TravelCompanionBlock = function TravelCompanionBlock(_ref2) {
  var travelCompanion = _ref2.travelCompanion,
      isChild = _ref2.isChild,
      position = _ref2.position,
      parentIndex = _ref2.parentIndex,
      isDisabled = _ref2.isDisabled,
      setIsDisabled = _ref2.setIsDisabled,
      setShowCompanionForm = _ref2.setShowCompanionForm,
      clearAttendeeData = _ref2.clearAttendeeData,
      includedInSelectedIndexes = _ref2.includedInSelectedIndexes,
      attendeeIdentifier = _ref2.attendeeIdentifier;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setIsHovering = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isFormDisplayed = _useState2[0],
      setIsFormDisplayed = _useState2[1];

  var dispatch = Object(es["d" /* useDispatch */])();

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue,
      setFieldTouched = _useFormikContext.setFieldTouched;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var companionId = travelCompanion.companionId,
      firstName = travelCompanion.firstName,
      lastName = travelCompanion.lastName,
      birthdate = travelCompanion.birthdate,
      isSelected = travelCompanion.isSelected;
  var isSelectedAndIncludedInSelectedIndexes = isSelected && includedInSelectedIndexes;

  var fillAttendeeWithCompanionData = function fillAttendeeWithCompanionData() {
    return Object(ContactInfoUtils["v" /* setTravelCompanionField */])({
      attendeeIdentifier: attendeeIdentifier,
      travelCompanion: travelCompanion,
      isChild: isChild,
      parentIndex: parentIndex,
      values: values,
      setFieldValue: setFieldValue
    });
  };

  var statusReducer = function statusReducer() {
    if (isSelectedAndIncludedInSelectedIndexes) {
      // setting attendee infos in form in order to generate an ID for API
      fillAttendeeWithCompanionData();
      return STATUS.SELECTED;
    }

    if (isSelected && !includedInSelectedIndexes) {
      return STATUS.HIDDEN;
    }

    if (isDisabled && !includedInSelectedIndexes) {
      return STATUS.DISABLED;
    }

    return STATUS.SELECTABLE;
  };

  var _useReducer = Object(react["useReducer"])(statusReducer, STATUS.SELECTABLE),
      status = _useReducer[0],
      updateStatus = _useReducer[1];

  Object(react["useEffect"])(function () {
    updateStatus();
  }, [isSelected, isDisabled]);
  Object(react["useEffect"])(function () {
    if (isFormDisplayed) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'see_more'
      });
      fillAttendeeWithCompanionData();
      setShowCompanionForm('EDIT');
    } else {
      setShowCompanionForm('');
    }
  }, [isFormDisplayed]);

  var handleSelection = function handleSelection() {
    if (status !== STATUS.DISABLED) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: isSelectedAndIncludedInSelectedIndexes ? 'remove_companion' : 'add_companion'
      });
      setIsDisabled === null || setIsDisabled === void 0 ? void 0 : setIsDisabled(true);

      if (isSelectedAndIncludedInSelectedIndexes) {
        dispatch(travel_companion_action_unselectTravelCompanion({
          companionId: companionId,
          parentIndex: parentIndex,
          position: position
        }));
        clearAttendeeData();
        setShowCompanionForm('');
      } else {
        var _fillAttendeeWithComp;

        dispatch(travel_companion_action_selectTravelCompanion({
          companionId: companionId,
          parentIndex: parentIndex,
          position: position
        }));
        (_fillAttendeeWithComp = fillAttendeeWithCompanionData()) === null || _fillAttendeeWithComp === void 0 ? void 0 : _fillAttendeeWithComp.then(function (newFormErrors) {
          var fieldErrorNames = Object.keys(get_default()(newFormErrors, attendeeIdentifier, {}));

          if (fieldErrorNames.length) {
            fieldErrorNames.forEach(function (fieldErrorName) {
              setFieldTouched("".concat(attendeeIdentifier, ".").concat(fieldErrorName), true);
            });
            setShowCompanionForm('EDIT');
          } else {
            Object(scrollToElement["a" /* scrollToElement */])("#attendee-".concat(parentIndex + 1), 500);
          }
        });
      }
    }
  };

  var shouldShowSeeMoreButton = (status === STATUS.SELECTABLE || status === STATUS.SELECTED) && !isChild;

  var _themes$status = TravelCompanionBlock_themes_themes[status]({
    isHovering: isHovering
  }),
      thRoot = _themes$status.thRoot,
      theNameLabel = _themes$status.theNameLabel,
      theBirthdateLabel = _themes$status.theBirthdateLabel;

  return TravelCompanionBlock_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('pe-20', {
      'order-first': status === STATUS.SELECTED
    }, {
      hidden: status === STATUS.HIDDEN
    }, {
      'pointer-events-none': isChild
    }),
    "data-testid": "TravelCompanion-".concat(status)
  }, TravelCompanionBlock_jsx("div", {
    "data-testid": "TravelCompanionBlock",
    onClick: handleSelection,
    className: Object(classnames_utils["a" /* classnames */])('flex w-full flex-col items-center rounded-12 border-1 border-solid bg-white p-10 text-center shadow-md', thRoot, 'h-140 w-120'),
    onMouseEnter: function onMouseEnter() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    }
  }, TravelCompanionBlock_jsx("div", {
    className: "mb-15 flex h-30 flex-col items-center justify-end"
  }, TravelCompanionBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PEOPLE,
    width: isChild ? '1.375rem' : '1.8125rem',
    className: "text-current"
  })), TravelCompanionBlock_jsx("p", {
    "data-testid": "TravelCompanionBlockName",
    className: theNameLabel
  }, firstName + ' ' + lastName), TravelCompanionBlock_jsx("p", {
    className: theBirthdateLabel
  }, birthdate && moment_default()(birthdate).format(Object(src_i18n["h" /* t */])('booking.form.dateFormat'))), TravelCompanionBlock_jsx(TravelCompanionBlock_IconBlock, {
    status: status
  })), shouldShowSeeMoreButton && TravelCompanionBlock_jsx("button", {
    onClick: function onClick() {
      setIsDisabled === null || setIsDisabled === void 0 ? void 0 : setIsDisabled(true);
      setIsFormDisplayed(function (hidden) {
        return !hidden;
      });
    },
    className: "mx-auto block py-10 text-14 leading-tight underline",
    type: "button"
  }, isFormDisplayed ? Object(src_i18n["h" /* t */])('common.loadLess') : Object(src_i18n["h" /* t */])('booking.participants.seeMoreLabel')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfoForm.jsx

















var PersonInfoForm_jsx = react_default.a.createElement;

function PersonInfoForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PersonInfoForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PersonInfoForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PersonInfoForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var PersonInfoForm_PersonInfoForm = function PersonInfoForm(_ref) {
  var _values$adults, _values$adults2;

  var parentIndex = _ref.parentIndex,
      isUserConnected = _ref.isUserConnected,
      isMain = _ref.isMain,
      isChild = _ref.isChild,
      personalInfoFormContent = _ref.personalInfoFormContent,
      attendeeIdentifier = _ref.attendeeIdentifier,
      setIsDisabled = _ref.setIsDisabled;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      errors = _useFormikContext.errors,
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue,
      setTouched = _useFormikContext.setTouched,
      setFieldTouched = _useFormikContext.setFieldTouched;

  var _useState = Object(react["useState"])(''),
      showCompanionForm = _useState[0],
      setShowCompanionForm = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isAdded = _useState2[0],
      setIsAdded = _useState2[1];

  var isValid = !get_default()(errors, attendeeIdentifier, false);
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var travelCompanionSelector = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.travelCompanion;
  });

  var _getTravelCompanionIn = Object(ContactInfoUtils["o" /* getTravelCompanionInfos */])({
    travelCompanionSelector: travelCompanionSelector,
    isChild: isChild,
    parentIndex: parentIndex
  }),
      travelCompanionList = _getTravelCompanionIn.travelCompanionList,
      hasParentIndexInSelectedIndexes = _getTravelCompanionIn.hasParentIndexInSelectedIndexes,
      isDisabled = _getTravelCompanionIn.isDisabled;

  var travelCompanionIndex = isChild ? parentIndex - ((values === null || values === void 0 ? void 0 : (_values$adults = values.adults) === null || _values$adults === void 0 ? void 0 : _values$adults.length) || 0) : parentIndex;
  var formList = isChild ? values.children : values.adults;
  var valuesList = isChild ? values === null || values === void 0 ? void 0 : values.children : values === null || values === void 0 ? void 0 : (_values$adults2 = values.adults) === null || _values$adults2 === void 0 ? void 0 : _values$adults2.slice(1);
  var selectedCompanions = travelCompanionList.filter(function (_ref2) {
    var isSelected = _ref2.isSelected;
    return isSelected;
  });
  var selectedNumber = selectedCompanions.length;
  var notSelectedNumber = travelCompanionList.filter(function (_ref3) {
    var isSelected = _ref3.isSelected;
    return !isSelected;
  }).length;
  var showRegularForm = // In case we have the number of attendees greater than the travel companions
  // then we show the rest of those attendees to the old regular form block
  notSelectedNumber === 0 && selectedNumber < (valuesList === null || valuesList === void 0 ? void 0 : valuesList.length) && !hasParentIndexInSelectedIndexes;
  var shouldDisplayTravelCompanion = isUserConnected && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.travelCompanions') && !showRegularForm;
  var dispatch = Object(es["d" /* useDispatch */])();
  var isCompanionAddForm = showCompanionForm === 'ADD';
  var shouldDisplayAddCompanionButton = showCompanionForm !== 'EDIT';

  var handleAddTravelCompanion = function handleAddTravelCompanion() {
    if (isValid) {
      var newCompanionId = travelCompanionSelector.list.length;

      var newTravelCompanion = PersonInfoForm_objectSpread(PersonInfoForm_objectSpread({}, formList.map(ContactInfoUtils["A" /* travelCompanionMapper */])[travelCompanionIndex]), {}, {
        companionId: newCompanionId,
        isSelected: true,
        isChild: isChild
      });

      dispatch(travel_companion_action_addTravelCompanion(newTravelCompanion));
      setIsAdded(true);
      setShowCompanionForm('');
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'validate_new_companion'
      }); // Select it immediatly after Adding it

      dispatch(travel_companion_action_selectTravelCompanion({
        companionId: newCompanionId,
        parentIndex: parentIndex,
        position: travelCompanionList.length
      }));
      Object(scrollToElement["a" /* scrollToElement */])("#attendee-".concat(parentIndex), 500);
    } else {
      Object(ContactInfoUtils["u" /* setTravelCompanionBlockFormErrors */])({
        errors: errors,
        isChild: isChild,
        travelCompanionIndex: travelCompanionIndex,
        setFieldTouched: setFieldTouched
      });
    }
  };

  var clearAttendeeData = function clearAttendeeData() {
    setTouched({});
    setFieldValue(attendeeIdentifier, isChild ? {} : {
      civility: 'MR'
    });
  };

  if (isMain || !shouldDisplayTravelCompanion) {
    return personalInfoFormContent;
  }

  return PersonInfoForm_jsx(react["Fragment"], null, isAdded && PersonInfoForm_jsx(Toast["a" /* Toast */], {
    color: colors["a" /* COLORS */].GREEN,
    icon: icons["a" /* ICONS */].CHECK_OUTLINE,
    label: Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.adultAdded'),
    onClose: function onClose() {
      return setIsAdded(false);
    },
    visible: isAdded
  }), PersonInfoForm_jsx("div", {
    className: "max-w-[90vw] p-20"
  }, PersonInfoForm_jsx("div", {
    className: "mb-10"
  }, PersonInfoForm_jsx("p", {
    className: "mb-20 text-14 font-bold"
  }, !isChild ? Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.selectAdult') : Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.selectChildren')), PersonInfoForm_jsx(Scrollable["a" /* Scrollable */], {
    className: "-mx-20 flex border-b-1 border-grey",
    navPosition: "center"
  }, PersonInfoForm_jsx("div", {
    className: "flex flex-row p-10 px-20"
  }, travelCompanionList.map(function (attendee, index) {
    return PersonInfoForm_jsx(TravelCompanionBlock_TravelCompanionBlock, {
      travelCompanion: attendee,
      isChild: isChild,
      key: "".concat(((attendee === null || attendee === void 0 ? void 0 : attendee.id) || '').toString(), "+").concat(attendee.firstName, "+").concat(attendee.lastName),
      position: index,
      parentIndex: parentIndex,
      setIsDisabled: setIsDisabled,
      isDisabled: isDisabled,
      setShowCompanionForm: setShowCompanionForm,
      includedInSelectedIndexes: !!find_default()(travelCompanionSelector.selectedIndexes, {
        index: parentIndex,
        position: index
      }),
      attendeeIdentifier: attendeeIdentifier,
      clearAttendeeData: clearAttendeeData
    });
  })))), shouldDisplayAddCompanionButton && PersonInfoForm_jsx("div", {
    className: "flex justify-end pt-10"
  }, PersonInfoForm_jsx(Button["a" /* Button */], {
    iconLeft: {
      name: icons["a" /* ICONS */].PEOPLE
    },
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_RIGHT,
      rotation: isCompanionAddForm ? 90 : 0,
      width: '0.875rem'
    },
    isDisabled: isDisabled,
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'add_new_companion'
      });
      setIsDisabled(false);
      setFieldValue(attendeeIdentifier, isChild ? {} : {
        civility: 'MR',
        document: {
          passport: {
            type: 'PASSPORT'
          },
          idcard: {
            type: 'IDCARD'
          }
        }
      });
      setShowCompanionForm(!showCompanionForm ? 'ADD' : '');
    },
    size: "small"
  }, Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.newCompanion'))), PersonInfoForm_jsx(lib["Collapse"], {
    isOpened: showCompanionForm
  }, PersonInfoForm_jsx("div", {
    className: "-mx-20 mt-20"
  }, personalInfoFormContent), PersonInfoForm_jsx("div", {
    className: "flex justify-end"
  }, isCompanionAddForm && PersonInfoForm_jsx(Button["a" /* Button */], {
    className: "mt-10",
    onClick: handleAddTravelCompanion,
    isDisabled: false
  }, Object(src_i18n["h" /* t */])('booking.participants.travelCompanion.addNewCompanion'))))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfoUtils.js
var PersonInfoUtils = __webpack_require__("DROp");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfo.jsx














var PersonInfo_jsx = react_default.a.createElement;

function PersonInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PersonInfo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PersonInfo_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PersonInfo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-lonely-if */





















var PersonInfo_CommonTitle = function CommonTitle(_ref) {
  var isMain = _ref.isMain,
      headerTitle = _ref.headerTitle,
      id = _ref.id;
  return PersonInfo_jsx("div", {
    className: "ml-20 mt-20"
  }, PersonInfo_jsx(Title["a" /* Title */], Object(esm_extends["a" /* default */])({
    id: "attendee-".concat(id),
    className: Object(classnames_utils["a" /* classnames */])('air360-replay-ignore', {
      'mb-10': isMain
    }),
    theme: "title-brand-n4"
  }, {
    'data-cs-mask': true
  }), headerTitle), isMain && PersonInfo_jsx("p", {
    className: "mb-10 text-14"
  }, Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.mainContactDescription')));
};

var PersonInfo_PersonInfo = function PersonInfo(_ref2) {
  var _i18n$account, _i18n$account$authent;

  var parentIndex = _ref2.parentIndex,
      isUserConnected = _ref2.isUserConnected,
      arrivalDate = _ref2.arrivalDate,
      attendeeIdentifier = _ref2.attendeeIdentifier,
      attendeeIndex = _ref2.attendeeIndex,
      connectedUserInfo = _ref2.connectedUserInfo,
      hasMainAttendeeErrors = _ref2.hasMainAttendeeErrors,
      hasPerformValidation = _ref2.hasPerformValidation,
      hasAddress = _ref2.hasAddress,
      i18n = _ref2.i18n,
      id = _ref2.id,
      isChild = _ref2.isChild,
      isMain = _ref2.isMain,
      listIdentifier = _ref2.listIdentifier;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      errors = _useFormikContext.errors;

  var isQuickLogged = appContext.isUserQuickLogged;
  var loginUrl = isQuickLogged ? ple_utils["i" /* buildStepupUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  }) : ple_utils["f" /* buildSigninUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  });
  var isMiniaturizedLoginButton = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('participantPageConnection.miniaturizedButton');
  var attendeeSchema = Object(es["e" /* useSelector */])(Object(validationSchema_selectors["c" /* getAttendeeValidationSchemaByRole */])(isMain, isChild));
  var addressSchema = Object(es["e" /* useSelector */])(validationSchema_selectors["b" /* getAddressValidationSchema */]);

  var _useState = Object(react["useState"])(true),
      isExpandedMode = _useState[0],
      setIsExpandedMode = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isDisabled = _useState2[0],
      setIsDisabled = _useState2[1];

  var attendeeSchemaIndex = Object(ContactInfoUtils["c" /* findAlphabetIndex */])(id);
  var isValid = !get_default()(errors, attendeeIdentifier, false);
  var userLogged = appContext.isUserLogged;
  var displayMiniaturizedButton = !userLogged && (i18n === null || i18n === void 0 ? void 0 : (_i18n$account = i18n.account) === null || _i18n$account === void 0 ? void 0 : (_i18n$account$authent = _i18n$account.authenticated) === null || _i18n$account$authent === void 0 ? void 0 : _i18n$account$authent.greeting);
  var headerTitle = Object(ContactInfoUtils["i" /* getHeaderContactInfoTitle */])({
    attendeeIdentifier: attendeeIdentifier,
    attendeeIndex: attendeeIndex,
    hasUnicodeFields: Object(PersonInfoUtils["b" /* isSchemaHasUnicodeFields */])(attendeeSchema),
    formValues: values,
    isChild: isChild,
    isMain: isMain,
    isValid: isValid
  });
  Object(react["useEffect"])(function () {
    if (hasPerformValidation) {
      if (isMain) {
        setIsExpandedMode(hasMainAttendeeErrors);
      } else {
        if (isChild) {
          var isChildValid = !get_default()(errors, attendeeIdentifier, false);
          isChildValid ? setIsExpandedMode(false) : setIsExpandedMode(true);
        }
      }
    }
  }, [hasPerformValidation]);

  var personInfoFormContent = PersonInfo_jsx(PersonInfoFormContent["a" /* PersonInfoFormContent */], {
    arrivalDate: arrivalDate,
    addressSchema: addressSchema,
    attendeeSchema: attendeeSchema,
    attendeeIdentifier: attendeeIdentifier,
    connectedUserInfo: connectedUserInfo,
    hasAddress: hasAddress,
    i18n: i18n,
    id: id,
    isChild: isChild,
    isMain: isMain,
    isDisabled: isDisabled
  });

  return PersonInfo_jsx("div", {
    "data-testid": isMain ? 'main-participant-block' : 'other-participant-block'
  }, !isExpandedMode && !isEmpty_default()(connectedUserInfo) ? PersonInfo_jsx(react["Fragment"], null, PersonInfo_jsx(PersonInfo_CommonTitle, {
    headerTitle: headerTitle,
    isMain: isMain,
    id: attendeeSchemaIndex
  }), PersonInfo_jsx(UserInfoSummary["a" /* UserInfoSummary */], {
    onClickEdit: function onClickEdit() {
      setIsExpandedMode(true);
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'edit_main_traveler'
      });
    },
    user: PersonInfo_objectSpread(PersonInfo_objectSpread({}, get_default()(values, attendeeIdentifier)), {}, {
      mobilePhoneNumber: get_default()(values, attendeeIdentifier, {}).mobile
    })
  })) : PersonInfo_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, PersonInfo_jsx("div", null, isMiniaturizedLoginButton && attendeeIndex === 0 && displayMiniaturizedButton && !isChild && PersonInfo_jsx("div", {
    className: "float-right pl-20 pr-20 text-center"
  }, PersonInfo_jsx(Button["a" /* Button */], {
    className: "mx-auto max-w-full",
    "data-testid": "loggin-button",
    isExternalLink: true,
    onClick: function onClick() {
      return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'login_form_participants'
      });
    },
    url: loginUrl
  }, Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.buttonLabel'))), PersonInfo_jsx(PersonInfo_CommonTitle, {
    headerTitle: headerTitle,
    isMain: isMain,
    id: attendeeSchemaIndex
  })), PersonInfo_jsx(PersonInfoForm_PersonInfoForm, {
    parentIndex: parentIndex,
    isUserConnected: isUserConnected,
    isMain: isMain,
    isChild: isChild,
    personalInfoFormContent: personInfoFormContent,
    listIdentifier: listIdentifier,
    attendee: get_default()(values, attendeeIdentifier, {}),
    attendeeIdentifier: attendeeIdentifier,
    setIsDisabled: setIsDisabled
  })), !isEmpty_default()(connectedUserInfo) && isExpandedMode && isMain ? PersonInfo_jsx("div", {
    className: "mt-10 flex justify-end"
  }, PersonInfo_jsx(Button["a" /* Button */], {
    isDisabled: !isValid,
    onClick: function onClick() {
      setIsExpandedMode(!isExpandedMode);
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_PARTICIPANTS, {
        detail_click: 'edit_main_traveler_validate'
      });
    },
    size: "medium"
  }, Object(src_i18n["h" /* t */])('booking.common.validate'))) : null);
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/AttendeesForms.jsx



var AttendeesForms_jsx = react_default.a.createElement;







var AttendeesForms_AttendeeBlock = function AttendeeBlock(_ref) {
  var attendee = _ref.attendee,
      attendeeIndexInList = _ref.attendeeIndexInList,
      i18n = _ref.i18n,
      connectedUserInfo = _ref.connectedUserInfo,
      hasMainAttendeeErrors = _ref.hasMainAttendeeErrors,
      hasPerformValidation = _ref.hasPerformValidation,
      hasAddress = _ref.hasAddress,
      arrivalDate = _ref.arrivalDate;
  var id = attendee.id,
      _attendee$isMain = attendee.isMain,
      isMain = _attendee$isMain === void 0 ? false : _attendee$isMain,
      _attendee$isChild = attendee.isChild,
      isChild = _attendee$isChild === void 0 ? false : _attendee$isChild,
      attendeeIndex = attendee.attendeeIndex;
  var listIdentifier = isChild ? 'children' : 'adults';
  var attendeeIdentifier = "".concat(listIdentifier, ".").concat(attendeeIndex);
  return AttendeesForms_jsx("div", {
    className: "mt-20",
    key: attendeeIdentifier
  }, AttendeesForms_jsx(PersonInfo_PersonInfo, {
    attendeeIdentifier: attendeeIdentifier,
    listIdentifier: listIdentifier,
    attendeeIndex: attendeeIndex,
    connectedUserInfo: connectedUserInfo,
    hasMainAttendeeErrors: hasMainAttendeeErrors,
    hasPerformValidation: hasPerformValidation,
    hasAddress: hasAddress,
    i18n: i18n,
    id: id,
    isChild: isChild,
    isMain: isMain,
    arrivalDate: arrivalDate,
    parentIndex: attendeeIndexInList,
    isUserConnected: !isEmpty_default()(connectedUserInfo)
  }));
};

var AttendeesForms_AttendeesForms = function AttendeesForms(_ref2) {
  var list = _ref2.list,
      arrivalDate = _ref2.arrivalDate,
      connectedUserInfo = _ref2.connectedUserInfo,
      hasMainAttendeeErrors = _ref2.hasMainAttendeeErrors,
      hasPerformValidation = _ref2.hasPerformValidation,
      hasAddress = _ref2.hasAddress,
      i18n = _ref2.i18n;
  return AttendeesForms_jsx("div", {
    className: "my-20"
  }, list.map(function (attendee, attendeeIndexInList) {
    return AttendeesForms_jsx("div", {
      key: attendee.id
    }, AttendeesForms_jsx(AttendeesForms_AttendeeBlock, {
      attendee: {
        gmNumber: attendee.gmNumber,
        id: attendee.id,
        isMain: attendee.isMain,
        isChild: !attendee.isAdult,
        attendeeIndex: attendee.attendeeIndex
      },
      attendeeIndexInList: attendeeIndexInList,
      arrivalDate: arrivalDate,
      connectedUserInfo: connectedUserInfo,
      hasMainAttendeeErrors: hasMainAttendeeErrors,
      hasPerformValidation: hasPerformValidation,
      hasAddress: hasAddress,
      i18n: i18n
    }), attendeeIndexInList === 0 && list.length > 1 && !isEmpty_default()(connectedUserInfo) && AttendeesForms_jsx(react["Fragment"], null, AttendeesForms_jsx(Heading["a" /* Heading */], {
      className: "mb-20 mt-40",
      hLevel: 3,
      theme: "heading-brand-1"
    }, Object(src_i18n["h" /* t */])('booking.participants.travelCompanions')), AttendeesForms_jsx(SimpleNotification["a" /* SimpleNotification */], {
      id: "ContactInfoFormInformations",
      title: Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.identityPapersMatchingTitle'),
      content: Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.identityPapersMatching'),
      iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
    })));
  }));
};

/* harmony default export */ var contact_info_AttendeesForms = (AttendeesForms_AttendeesForms);
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfoForm.jsx





var ContactInfoForm_jsx = react_default.a.createElement;













var ContactInfoForm_ContactInfoForm = function ContactInfoForm(_ref) {
  var proposal = _ref.proposal,
      connectedUserInfo = _ref.connectedUserInfo,
      hasAddress = _ref.hasAddress,
      i18n = _ref.i18n,
      attendees = _ref.attendees,
      setErrorMessage = _ref.setErrorMessage,
      setHasUnselectedTravelCompanions = _ref.setHasUnselectedTravelCompanions;
  var formik = Object(formik_esm["e" /* useFormikContext */])(); // we need a ref for formik for the unmount to have access to the formik bag (the formik bag ref change at every render 😭)

  var formikRef = Object(react["useRef"])();

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isUserLogged = _useAppContext.isUserLogged;

  var _useState = Object(react["useState"])(false),
      hasMainAttendeeErrors = _useState[0],
      setHasMainAttendeesError = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      hasPerformValidation = _useState2[0],
      setHasPerformValidation = _useState2[1];

  Object(ScrollToErrorHook["a" /* useAutoScrollToError */])(formik);

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackEvent = _useTrackEvent.trackEvent;

  formikRef.current = formik;
  Object(ScrollToErrorHook["a" /* useAutoScrollToError */])(formik);
  var arrivalDate = proposal.arrivalDate;
  var validationCallback = Object(react["useCallback"])(function () {
    var _formik$errors, _formik$errors$adults, _formik$errors$adults2;

    formik.submitForm();
    var legalAgreementError = (_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : (_formik$errors$adults = _formik$errors.adults) === null || _formik$errors$adults === void 0 ? void 0 : (_formik$errors$adults2 = _formik$errors$adults[0]) === null || _formik$errors$adults2 === void 0 ? void 0 : _formik$errors$adults2.optinsCGU;
    var hasLegalAgreementError = legalAgreementError !== null && legalAgreementError !== undefined;

    if (hasLegalAgreementError) {
      setHasMainAttendeesError(true);
      setErrorMessage(Object(src_i18n["h" /* t */])('booking.participants.errorMessage.legalAgreement'));
    }

    Object(ContactInfoUtils["z" /* trackAttendeesFormError */])(trackEvent, formik);

    if (isUserLogged) {
      var _formik$errors$adults3;

      var hasError = (_formik$errors$adults3 = formik.errors.adults) === null || _formik$errors$adults3 === void 0 ? void 0 : _formik$errors$adults3.slice(1).some(function (adult) {
        return !!adult;
      });

      if (hasError) {
        if (hasLegalAgreementError) {
          setHasMainAttendeesError(true);
          setErrorMessage(Object(src_i18n["h" /* t */])('booking.participants.errorMessage.legalAgreement'));
        }

        setErrorMessage(Object(src_i18n["h" /* t */])('booking.participants.errorMessage.travelCompanionsNotSelected'));
      }

      setHasUnselectedTravelCompanions(hasError);
    }

    return Promise.reject();
  }, [formik.errors]);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    validationCallback: validationCallback
  });
  Object(react["useEffect"])(function () {
    /* We need to validate the form when the user is connected and the form is displayed before showing the preview */
    formik.validateForm().then(function (errors) {
      var _errors$adults;

      // $FlowFixMe
      if (!isEmpty_default()(errors) && !isEmpty_default()((_errors$adults = errors.adults) === null || _errors$adults === void 0 ? void 0 : _errors$adults[0])) {
        setHasMainAttendeesError(true);
      }

      setHasPerformValidation(true);
    });
  }, []);
  return ContactInfoForm_jsx(react["Fragment"], null, ContactInfoForm_jsx("div", null, ContactInfoForm_jsx(SimpleNotification["a" /* SimpleNotification */], {
    id: "ContactInfoFormInformations",
    title: Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.identityPapersMatchingTitle'),
    content: Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.identityPapersMatching'),
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }), ContactInfoForm_jsx(contact_info_AttendeesForms, {
    list: attendees.list,
    arrivalDate: arrivalDate,
    connectedUserInfo: connectedUserInfo,
    hasMainAttendeeErrors: hasMainAttendeeErrors,
    hasPerformValidation: hasPerformValidation,
    hasAddress: hasAddress,
    i18n: i18n
  })), ContactInfoForm_jsx(MultiCGUBlock_MultiCGUBlock, {
    i18n: i18n,
    idsCGU: contact_info_constants["a" /* ACCEPTED_CGUS */] // ids of the CGUs to show in the block

  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfo.jsx






























var ContactInfo_jsx = react_default.a.createElement;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ContactInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ContactInfo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ContactInfo_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ContactInfo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


























var ContactInfo_mapAttendeesWithPersistedProfille = function mapAttendeesWithPersistedProfille(attendees) {
  var persistedProfile = JSON.parse(Object(lz_string["decompressFromBase64"])(Object(sessionStorageApi["b" /* getFromSessionStorage */])('profile') || ''));
  return ContactInfo_objectSpread(ContactInfo_objectSpread({}, attendees), {}, {
    adults: [ContactInfo_objectSpread(ContactInfo_objectSpread({}, attendees.adults[0]), persistedProfile)].concat(Object(toConsumableArray["a" /* default */])(attendees.adults.slice(1)))
  });
};

var ContactInfo_ErrorHandler = function ErrorHandler(_ref) {
  var concernedAttendees = _ref.concernedAttendees,
      proposalAttendees = _ref.proposalAttendees,
      setErrors = _ref.setErrors;
  Object(react["useEffect"])(function () {
    Object(ContactInfoUtils["r" /* handleSetErrorsForConcernedAttendees */])({
      concernedAttendees: concernedAttendees,
      proposalAttendees: proposalAttendees,
      setErrors: setErrors
    });
  }, [concernedAttendees, proposalAttendees, setErrors]);
  return null;
};

var ContactInfo_ContactInfo = function _ContactInfo(_ref2) {
  var _beEngineContext$curr, _isFeatureFlipped;

  var i18n = _ref2.i18n,
      proposal = _ref2.proposal,
      updateAttendees = _ref2.updateAttendees,
      connectedUserInfo = _ref2.connectedUserInfo,
      addressSchema = _ref2.addressSchema,
      goToNextStep = _ref2.goToNextStep,
      getAttendeeSchema = _ref2.getAttendeeSchema;
  var track = Object(useTracking["a" /* useTracking */])();
  var beEngineContext = Object(react["useContext"])(BookingEngineContext["a" /* BookingEngineContext */]);
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isUserLogged = appContext.isUserLogged,
      isUserQuickLogged = appContext.isUserQuickLogged;
  var optinsContext = Object(react["useContext"])(OptinsProvider["a" /* OptinsContext */]);

  var _useState = Object(react["useState"])(),
      errorMessage = _useState[0],
      setErrorMessage = _useState[1];

  var _useState2 = Object(react["useState"])([]),
      concernedAttendees = _useState2[0],
      setConcernedAteendees = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      hasUnselectedTravelCompanions = _useState3[0],
      setHasUnselectedTravelCompanions = _useState3[1];

  var _useSelector = Object(es["e" /* useSelector */])(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */]),
      attendees = _useSelector.attendees;

  var hasAddress = addressSchema.every(function (_ref3) {
    var display = _ref3.display;
    return display;
  });
  var displayParticipantsSelectInput = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayCivilityDropdown') && (beEngineContext === null || beEngineContext === void 0 ? void 0 : (_beEngineContext$curr = beEngineContext.currentStep) === null || _beEngineContext$curr === void 0 ? void 0 : _beEngineContext$curr.name) === 'participants';
  var shouldShowPhoneWithSeparatePhoneCodeField = (_isFeatureFlipped = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.participants.phone.showWithSeparatePhoneCodeField')) !== null && _isFeatureFlipped !== void 0 ? _isFeatureFlipped : false; // if initialValues change (the object ref change) that trigger an undesirable validation with initial values

  var initialValues = Object(react["useMemo"])(function () {
    var _i18n$booking, _i18n$booking$partici, _i18n$booking$partici2, _i18n$booking$partici3, _i18n$booking$partici4, _i18n$booking2, _i18n$booking2$partic, _i18n$booking2$partic2, _i18n$booking2$partic3, _i18n$booking2$partic4;

    var values = Object(ContactInfoUtils["j" /* getInitialFormValues */])({
      bookingProcess: i18n.bookingProcess,
      adultCivilityDefaultValue: i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$partici = _i18n$booking.participants) === null || _i18n$booking$partici === void 0 ? void 0 : (_i18n$booking$partici2 = _i18n$booking$partici.civilities) === null || _i18n$booking$partici2 === void 0 ? void 0 : (_i18n$booking$partici3 = _i18n$booking$partici2.adult) === null || _i18n$booking$partici3 === void 0 ? void 0 : (_i18n$booking$partici4 = _i18n$booking$partici3[0]) === null || _i18n$booking$partici4 === void 0 ? void 0 : _i18n$booking$partici4.value,
      childCivilityDefaultValue: i18n === null || i18n === void 0 ? void 0 : (_i18n$booking2 = i18n.booking) === null || _i18n$booking2 === void 0 ? void 0 : (_i18n$booking2$partic = _i18n$booking2.participants) === null || _i18n$booking2$partic === void 0 ? void 0 : (_i18n$booking2$partic2 = _i18n$booking2$partic.civilities) === null || _i18n$booking2$partic2 === void 0 ? void 0 : (_i18n$booking2$partic3 = _i18n$booking2$partic2.child) === null || _i18n$booking2$partic3 === void 0 ? void 0 : (_i18n$booking2$partic4 = _i18n$booking2$partic3[0]) === null || _i18n$booking2$partic4 === void 0 ? void 0 : _i18n$booking2$partic4.value,
      attendees: isUserLogged ? attendees : ContactInfo_mapAttendeesWithPersistedProfille(attendees),
      connectedUserInfo: connectedUserInfo,
      hasAddress: hasAddress,
      locale: appContext.locale,
      getAttendeeSchema: getAttendeeSchema,
      displayParticipantsSelectInput: displayParticipantsSelectInput,
      preCheckedOptins: optinsContext.optins
    }); // Split phone number only when showWithSeparatePhoneCodeField is true

    if (shouldShowPhoneWithSeparatePhoneCodeField) {
      var splitPhoneNumber = function splitPhoneNumber(attendee) {
        var _attendee$address;

        var mobile = attendee.mobile;

        if (!mobile || typeof mobile !== 'string') {
          return attendee;
        }

        var sortedCodes = phoneCode_utils["a" /* countriesToPhoneCodeList */].map(function (c) {
          return c.phoneCode;
        }).sort(function (a, b) {
          return b.length - a.length;
        });

        if (mobile.startsWith('+')) {
          var numberWithoutPlus = mobile.substring(1);

          var _iterator = _createForOfIteratorHelper(sortedCodes),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var code = _step.value;

              if (numberWithoutPlus.startsWith(code)) {
                return ContactInfo_objectSpread(ContactInfo_objectSpread({}, attendee), {}, {
                  mobileCode: code,
                  mobile: numberWithoutPlus.substring(code.length)
                });
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else if (mobile.startsWith('00')) {
          var numberWithout00 = mobile.substring(2);

          var _iterator2 = _createForOfIteratorHelper(sortedCodes),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _code = _step2.value;

              if (numberWithout00.startsWith(_code)) {
                return ContactInfo_objectSpread(ContactInfo_objectSpread({}, attendee), {}, {
                  mobileCode: _code,
                  mobile: numberWithout00.substring(_code.length)
                });
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else if ((_attendee$address = attendee.address) === null || _attendee$address === void 0 ? void 0 : _attendee$address.countryCode) {
          var phoneCode = Object(phoneCode_utils["b" /* getPhoneCodeByCountryId */])(attendee.address.countryCode);

          if (phoneCode && mobile.startsWith(phoneCode)) {
            return ContactInfo_objectSpread(ContactInfo_objectSpread({}, attendee), {}, {
              mobileCode: phoneCode,
              mobile: mobile.substring(phoneCode.length)
            });
          }
        }

        return attendee;
      };

      return {
        adults: values.adults.map(splitPhoneNumber),
        children: values.children.map(splitPhoneNumber)
      };
    }

    return values;
  }, [attendees]);

  var validateAttendees = function validateAttendees(_ref4) {
    var adults = _ref4.adults,
        children = _ref4.children;
    var hasErrors = false;
    var fieldsOnError = {
      firstName: true,
      lastName: true,
      birthdate: true
    };
    var errors = {
      adults: Array(adults === null || adults === void 0 ? void 0 : adults.length),
      children: Array((children === null || children === void 0 ? void 0 : children.length) || 0)
    };
    var adultsDuplicates = (adults === null || adults === void 0 ? void 0 : adults.length) ? Object(ContactInfoUtils["d" /* findDuplicateAttendees */])(adults) : [];
    var childrenDuplicates = (children === null || children === void 0 ? void 0 : children.length) ? Object(ContactInfoUtils["d" /* findDuplicateAttendees */])(children) : [];

    if (!isEmpty_default()(childrenDuplicates) || !isEmpty_default()(adultsDuplicates)) {
      hasErrors = true;
      setErrorMessage(i18n.booking.participants.labels.warningNames);
      adultsDuplicates.forEach(function (duplicateIndex) {
        errors.adults[duplicateIndex] = fieldsOnError;
      });
      childrenDuplicates.forEach(function (duplicateIndex) {
        errors.children[duplicateIndex] = fieldsOnError;
      });
    } else if (hasUnselectedTravelCompanions) {
      setErrorMessage(Object(src_i18n["h" /* t */])('booking.participants.errorMessage.travelCompanionsNotSelected'));
      setHasUnselectedTravelCompanions(false);
    } else {
      setErrorMessage(undefined);
    }

    if (hasErrors) {
      return errors;
    }
  };

  var putAttendees = function putAttendees(_ref5, actions) {
    var _adults$;

    var adults = _ref5.adults,
        children = _ref5.children;
    actions.setSubmitting(false); // remove the intermediate id values to send the correct values to the API

    adults[0].optinsCGU = Object.values(adults[0].optinsCGU || {}); // keep only those in CGUS_ACCEPTED_BY_API fix : #23104 until the API is updated to accept all CGUs

    adults[0].optinsCGU = adults[0].optinsCGU.filter(function (optin) {
      return (// eslint-disable-next-line flowtype/no-weak-types
        contact_info_constants["c" /* CGUS_ACCEPTED_BY_API */].includes(optin === null || optin === void 0 ? void 0 : optin.channel)
      );
    }); // Calculate and store SHA-256 hash of email for tracking

    if ((_adults$ = adults[0]) === null || _adults$ === void 0 ? void 0 : _adults$.email) {
      var emailSha256 = crypto_js_default.a.SHA256(adults[0].email.toLowerCase().trim()).toString(); // eslint-disable-line new-cap

      var storedTracking = tracking_storage_api["b" /* get */](tracking_constants["c" /* BE_TRACKING */]);
      tracking_storage_api["c" /* set */](ContactInfo_objectSpread(ContactInfo_objectSpread({}, storedTracking), {}, {
        email_sha_256: emailSha256
      }));
    }

    if (shouldShowPhoneWithSeparatePhoneCodeField) {
      var formatPhoneNumber = function formatPhoneNumber(attendee) {
        if (attendee.mobileCode && attendee.mobile) {
          return ContactInfo_objectSpread(ContactInfo_objectSpread({}, attendee), {}, {
            mobile: "+".concat(attendee.mobileCode).concat(attendee.mobile),
            mobileCode: undefined
          });
        }

        return attendee;
      };

      adults = adults.map(formatPhoneNumber);
      children = children.map(formatPhoneNumber);
    }

    updateAttendees({
      appContext: appContext,
      proposalId: proposal.id,
      attendees: {
        adults: adults,
        children: children
      }
    }).then(function () {
      if (isUserLogged || isUserQuickLogged) {
        return goToNextStep();
      }

      Object(sessionStorageApi["d" /* setInSessionStorage */])('profile', Object(lz_string["compressToBase64"])(JSON.stringify(pick_default()(adults[0], ['firstName', 'lastName', 'address']))));
      goToNextStep({
        queryParams: {
          a: Object(lz_string["compressToEncodedURIComponent"])(JSON.stringify(adults.map(function (_ref6) {
            var firstName = _ref6.firstName,
                lastName = _ref6.lastName,
                birthdate = _ref6.birthdate;
            return {
              firstName: firstName,
              lastName: lastName,
              dateOfBirth: birthdate
            };
          })))
        }
      });
    }).catch(function (error) {
      var _error$errors, _error$errors$;

      setErrorMessage(Object(ContactInfoUtils["t" /* renderErrorUpdatingAttendees */])(error));
      setConcernedAteendees(Object(ContactInfoUtils["h" /* getConcernedAttendees */])(error) || []);
      track(ContactInfo_objectSpread(ContactInfo_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
        actionGA: 'participant',
        labelGA: (error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.errorCode) === 'fieldCannotBeModifiedDueToUpcomingBooking' ? 'error_cannotMatchAttendeeNames' : 'error_serverError'
      }));
    });
  };

  return ContactInfo_jsx(react["Fragment"], null, ContactInfo_jsx(formik_esm["d" /* Formik */], {
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: putAttendees,
    validate: validateAttendees,
    validateOnBlur: true
  }, function (_ref7) {
    var setErrors = _ref7.setErrors;
    return ContactInfo_jsx(react["Fragment"], null, ContactInfo_jsx(ContactInfo_ErrorHandler, {
      concernedAttendees: concernedAttendees,
      proposalAttendees: attendees,
      setErrors: setErrors
    }), ContactInfo_jsx(ContactInfoForm_ContactInfoForm, {
      i18n: i18n,
      proposal: proposal,
      hasAddress: hasAddress,
      connectedUserInfo: connectedUserInfo,
      addressSchema: addressSchema,
      setErrorMessage: setErrorMessage,
      setHasUnselectedTravelCompanions: setHasUnselectedTravelCompanions,
      attendees: attendees
    }));
  }), errorMessage && ContactInfo_jsx(FormFeedback["a" /* FormFeedback */], {
    hasAutoScroll: true,
    isError: true,
    message: errorMessage
  }));
};

function getConnectedUserInfo(state) {
  var userInfo = Object(userInfo_selectors["a" /* userInfoSelector */])(state);
  return userInfo.isQuickLoggedIn ? {} : userInfo;
}

var ContactInfo = Object(es["c" /* connect */])(function (state) {
  return {
    connectedUserInfo: getConnectedUserInfo(state),
    addressSchema: Object(validationSchema_selectors["b" /* getAddressValidationSchema */])(state),
    getAttendeeSchema: function getAttendeeSchema(isMain, isChild) {
      return Object(validationSchema_selectors["c" /* getAttendeeValidationSchemaByRole */])(isMain, isChild)(state);
    }
  };
}, {
  updateAttendees: proposals_action["z" /* updateAttendees */]
})(ContactInfo_ContactInfo);
// CONCATENATED MODULE: ./src/client/views/booking/participants/login-to-ple/NotificationLoginToPle.jsx









var NotificationLoginToPle_jsx = react_default.a.createElement;

function NotificationLoginToPle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NotificationLoginToPle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NotificationLoginToPle_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NotificationLoginToPle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var NotificationLoginToPle_NotificationLoginToPle = function NotificationLoginToPle(_ref) {
  var className = _ref.className,
      isQuickLogged = _ref.isQuickLogged;
  var track = Object(useTracking["a" /* useTracking */])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var loginUrl = isQuickLogged ? ple_utils["i" /* buildStepupUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  }) : ple_utils["f" /* buildSigninUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  });
  var bulletpoints = [Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.bulletpoint1'), Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.bulletpoint2'), Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.bulletpoint3')];
  return NotificationLoginToPle_jsx("aside", {
    className: Object(classnames_utils["a" /* classnames */])('rounded-12 border-1 border-lightGrey bg-white', className),
    "data-testid": "loggin-block"
  }, NotificationLoginToPle_jsx("div", {
    className: "flex flex-col sm:flex-row sm:flex-wrap"
  }, NotificationLoginToPle_jsx("div", {
    className: "p-20 pb-0 sm:w-1/2 sm:pb-20 sm:pe-10"
  }, NotificationLoginToPle_jsx("div", {
    className: "flex items-end gap-20 font-brand text-14 text-black"
  }, NotificationLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 sm:mx-10",
    name: icons["a" /* ICONS */].ICON_45,
    width: "2.5em"
  }), NotificationLoginToPle_jsx(Text["a" /* Text */], {
    text: Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.message'),
    theme: "none"
  }))), NotificationLoginToPle_jsx("div", {
    className: "p-20 py-15 sm:w-1/2 sm:py-20 sm:ps-10"
  }, NotificationLoginToPle_jsx("ul", null, bulletpoints.map(function (bulletpoint) {
    return bulletpoint ? NotificationLoginToPle_jsx("li", {
      className: "flex items-baseline gap-10 text-12",
      key: bulletpoint
    }, NotificationLoginToPle_jsx(Icon["a" /* Icon */], {
      className: "shrink-0 align-middle text-green",
      name: icons["a" /* ICONS */].CHECK,
      width: "0.625rem"
    }), bulletpoint) : null;
  }))), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayFutureTravelCredit') && NotificationLoginToPle_jsx("div", {
    className: "mx-auto flex w-full flex-wrap p-20 pt-0 sm:flex-nowrap sm:py-20 sm:pt-0"
  }, NotificationLoginToPle_jsx("div", {
    className: "flex items-center gap-20 font-brand text-14 text-sienna sm:w-1/2 sm:pe-10"
  }, NotificationLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icons["a" /* ICONS */].PROMO_CODE,
    width: "2.5rem"
  }), Object(src_i18n["h" /* t */])('booking.summary.futureTravelCredit.popinFtcTitle')), NotificationLoginToPle_jsx("div", {
    className: "ps-60 text-12 sm:w-1/2 sm:ps-10"
  }, Object(src_i18n["h" /* t */])('booking.summary.futureTravelCredit.signIn')))), NotificationLoginToPle_jsx("div", {
    className: "border-t-1 border-lightGrey p-20 text-center"
  }, NotificationLoginToPle_jsx(Button["a" /* Button */], {
    className: "mx-auto max-w-full",
    "data-testid": "loggin-button",
    isExternalLink: true,
    onClick: function onClick() {
      return track(NotificationLoginToPle_objectSpread(NotificationLoginToPle_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
        actionGA: 'participant',
        labelGA: 'connectionParticipant'
      }));
    },
    url: loginUrl
  }, Object(src_i18n["h" /* t */])('booking.participants.connectToPLE.buttonLabel'))));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/login-to-ple/PopinLoginToPle.jsx









var PopinLoginToPle_jsx = react_default.a.createElement;

function PopinLoginToPle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PopinLoginToPle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PopinLoginToPle_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PopinLoginToPle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var PopinLoginToPle_PopinLoginToPle = function PopinLoginToPle(_ref) {
  var i18n = _ref.i18n,
      onClose = _ref.onClose;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var _i18n$booking$partici = i18n.booking.participants.connectToPLE,
      message = _i18n$booking$partici.message,
      bulletpoint1 = _i18n$booking$partici.bulletpoint1,
      bulletpoint2 = _i18n$booking$partici.bulletpoint2,
      bulletpoint3 = _i18n$booking$partici.bulletpoint3,
      buttonLabel = _i18n$booking$partici.buttonLabel,
      noAccountSentence = _i18n$booking$partici.noAccountSentence,
      noAccount = _i18n$booking$partici.noAccount;
  return PopinLoginToPle_jsx(Modal["a" /* Modal */], {
    ariaLabel: message,
    ariaLabelledby: identifiers_constants["A" /* ID_MODAL_HEADER__PLE__LOGIN */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: onClose,
    size: "small",
    dataTestId: "connexion-popin"
  }, PopinLoginToPle_jsx("div", {
    className: "font-sans"
  }, PopinLoginToPle_jsx("div", {
    className: "bg-lightSand p-20 text-center font-bold"
  }, PopinLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "text-sienna",
    isNotSquare: true,
    name: icons["a" /* ICONS */].PEOPLE,
    width: "3.5625rem"
  }), PopinLoginToPle_jsx(Title["a" /* Title */], {
    className: "mt-10 justify-center text-sienna",
    hLevel: 1,
    id: identifiers_constants["A" /* ID_MODAL_HEADER__PLE__LOGIN */],
    theme: "title-sans-n4"
  }, message)), PopinLoginToPle_jsx("ul", {
    className: "p-20"
  }, [bulletpoint1, bulletpoint2, bulletpoint3].map(function (bulletpoint) {
    return bulletpoint ? PopinLoginToPle_jsx("li", {
      key: bulletpoint
    }, PopinLoginToPle_jsx(Icon["a" /* Icon */], {
      className: "me-10 align-middle text-green",
      name: icons["a" /* ICONS */].CHECK
    }), bulletpoint) : null;
  })), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayFutureTravelCredit') && PopinLoginToPle_jsx("div", {
    className: "mx-auto flex w-full max-w-440 flex-wrap justify-center p-20 pt-0"
  }, PopinLoginToPle_jsx("div", {
    className: "flex items-center gap-20 font-brand text-14 text-lavender"
  }, PopinLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icons["a" /* ICONS */].PROMO_CODE,
    width: "2.5rem"
  }), Object(src_i18n["h" /* t */])('booking.summary.futureTravelCredit.popinFtcTitle')), PopinLoginToPle_jsx("div", {
    className: "text-12"
  }, Object(src_i18n["h" /* t */])('resort.futureTravelCredit.genericDescription'))), PopinLoginToPle_jsx("div", {
    className: "pb-20 text-center"
  }, PopinLoginToPle_jsx(Button["a" /* Button */], {
    className: "mb-20 w-3/4",
    "data-testid": "loggin-button",
    isExternalLink: true,
    onClick: function onClick() {
      tracking_api["b" /* setDataLayer */](PopinLoginToPle_objectSpread(PopinLoginToPle_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
        actionGA: 'participant',
        labelGA: 'popin_connectionParticipant',
        versionBooking: 'responsive'
      }), appContext);
    },
    url: ple_utils["f" /* buildSigninUrl */]({
      locale: appContext.locale,
      redirectUri: dist["windowWrapper"].getLocation()
    })
  }, buttonLabel), PopinLoginToPle_jsx("div", {
    className: "px-20"
  }, PopinLoginToPle_jsx("p", {
    className: "font-bold"
  }, noAccount), PopinLoginToPle_jsx("p", null, noAccountSentence)))));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/ParticipantsView.jsx


var ParticipantsView_jsx = react_default.a.createElement;










var SESSION_STORAGE_ITEM = 'seenProposalsForPopin';
var ParticipantsView_ParticipantsView = function ParticipantsView(_ref) {
  var _i18n$account, _i18n$account$authent;

  var goToNextStep = _ref.goToNextStep,
      i18n = _ref.i18n,
      proposals = _ref.proposals,
      selectedProposal = _ref.selectedProposal,
      infoBannerData = _ref.infoBannerData;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useState = Object(react["useState"])(false),
      isAlreadySeen = _useState[0],
      setIsAlreadySeen = _useState[1];

  var customerSearchResult = Object(es["e" /* useSelector */])(booking_selector["k" /* getCustomerSearchResult */]);
  var concatProposalIds = proposals.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  }).join('');

  var _useState2 = Object(react["useState"])(Object(sessionStorageApi["b" /* getFromSessionStorage */])(SESSION_STORAGE_ITEM) !== concatProposalIds),
      shouldShowConnectToPlePopin = _useState2[0],
      setShouldShowConnectToPlePopin = _useState2[1];

  Object(react["useEffect"])(function () {
    if (Object(sessionStorageApi["b" /* getFromSessionStorage */])(SESSION_STORAGE_ITEM) !== concatProposalIds) {
      Object(sessionStorageApi["d" /* setInSessionStorage */])(SESSION_STORAGE_ITEM, concatProposalIds);
    }
  }, [concatProposalIds]);
  Object(react["useEffect"])(function () {
    if (customerSearchResult.data && isAlreadySeen === false) {
      setIsAlreadySeen(true);
    }
  }, [customerSearchResult]);
  var userLogged = appContext.isUserLogged;
  var isPopinPleEnabled = !userLogged && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('connectionPopinPLE.isEnabled');
  var isMiniaturizedLoginButton = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('participantPageConnection.miniaturizedButton');
  var displayNotification = !userLogged && (i18n === null || i18n === void 0 ? void 0 : (_i18n$account = i18n.account) === null || _i18n$account === void 0 ? void 0 : (_i18n$account$authent = _i18n$account.authenticated) === null || _i18n$account$authent === void 0 ? void 0 : _i18n$account$authent.greeting);

  var closeLoginToPLEModal = function closeLoginToPLEModal() {
    setShouldShowConnectToPlePopin(false);
  };

  return ParticipantsView_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-start"
  }, isPopinPleEnabled && shouldShowConnectToPlePopin && ParticipantsView_jsx(PopinLoginToPle_PopinLoginToPle, {
    i18n: i18n,
    onClose: closeLoginToPLEModal
  }), ParticipantsView_jsx("div", {
    className: "max-w-site-mini sm:mx-auto"
  }, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'participants'
  }), displayNotification && !isMiniaturizedLoginButton && ParticipantsView_jsx("div", {
    className: "w-full"
  }, ParticipantsView_jsx(NotificationLoginToPle_NotificationLoginToPle, {
    className: "mb-20",
    isQuickLogged: appContext.isUserQuickLogged,
    i18n: i18n
  })), ParticipantsView_jsx(ContactInfo, {
    goToNextStep: goToNextStep,
    i18n: i18n,
    proposal: selectedProposal
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/paid-service/PaidService.jsx
var PaidService = __webpack_require__("o8kQ");

// EXTERNAL MODULE: ./src/client/components/widgets/package/alternative-packages/AlternativePackageToolTip.jsx
var AlternativePackageToolTip = __webpack_require__("bn3Y");

// CONCATENATED MODULE: ./src/client/components/widgets/package/alternative-packages/AlternativePackages.jsx








var _MAPPING_PACKAGE_INFO;

var AlternativePackages_jsx = react_default.a.createElement;












var _constants$PACKAGES = dist["constants"].PACKAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;
var MAPPING_PACKAGE_INFOS = (_MAPPING_PACKAGE_INFO = {}, Object(defineProperty["a" /* default */])(_MAPPING_PACKAGE_INFO, JOYVIEW_ALL_INCLUSIVE, {
  color: colors["a" /* COLORS */].SAFFRON,
  icon: icons["a" /* ICONS */].ALL_INCLUSIVE,
  imageUrl: 'https://ns.clubmed.com/it/2019/be/joyview/Images.jpg',
  labelGA: 'AllInclusive',
  title: 'PAIBlockTitle'
}), Object(defineProperty["a" /* default */])(_MAPPING_PACKAGE_INFO, JOYVIEW_FOOD_AND_BEVERAGES, {
  color: colors["a" /* COLORS */].ORANGE,
  icon: icons["a" /* ICONS */].DISHES,
  imageUrl: 'https://ns.clubmed.com/it/2019/be/joyview/FFB-JoyVIew.png',
  labelGA: 'FoodBeverage',
  title: 'FFBBlockTitle'
}), _MAPPING_PACKAGE_INFO);

var AlternativePackages_getCtaType = function getCtaType(selectedProposal, packageId, basePackageId) {
  if (!selectedProposal.alternativePackages || basePackageId === packageId) {
    return PaidService["b" /* ctaActionTypes */].included;
  }

  if (selectedProposal.packageId === packageId) {
    return PaidService["b" /* ctaActionTypes */].remove;
  }

  return PaidService["b" /* ctaActionTypes */].add;
};

var findAlternativeProposalByPackage = function findAlternativeProposalByPackage(alternativePackages, packageId) {
  return alternativePackages.find(function (bundle) {
    return bundle.packageId === packageId;
  });
};

var AlternativePackages_AlternativePackages = function AlternativePackages(_ref) {
  var _selectedProposal$pac;

  var allProposals = _ref.allProposals,
      isColumn = _ref.isColumn,
      selectedProposal = _ref.selectedProposal,
      selectProposal = _ref.selectProposal;
  var allProposalsFromStore = Object(es["e" /* useSelector */])(booking_selector["y" /* proposalsSelector */]);

  if ((!allProposals || !allProposals.length) && !allProposalsFromStore.length) {
    throw new Error('AlternativePackages should have allProposals props provided or the store should contains proposals');
  }

  var basePackageId = (allProposals || allProposalsFromStore)[0].packageId;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent; // $FlowFixMe always found


  var RONPackage = selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$pac = selectedProposal.packages) === null || _selectedProposal$pac === void 0 ? void 0 : _selectedProposal$pac.find(function (selectedProposalPackage) {
    return (selectedProposalPackage === null || selectedProposalPackage === void 0 ? void 0 : selectedProposalPackage.id) === JOYVIEW_ROOM_ONLY;
  });
  return (// $FlowFixMe package always defined here when the resort is joyview
    selectedProposal.packages.filter(function (bundle) {
      return bundle && bundle.id !== JOYVIEW_ROOM_ONLY && (selectedProposal.alternativePackages && findAlternativeProposalByPackage(selectedProposal.alternativePackages, bundle.id) || bundle.id === selectedProposal.packageId);
    }) // $FlowFixMe package always defined here, we filtered it just before
    .map(function (otherPackage, index, mappedArray) {
      var _alternativePackage2;

      var packageInfos = MAPPING_PACKAGE_INFOS[otherPackage.id]; // if there is no alternativePackage that means that it's already selected and that we want to reset the package

      var alternativePackage;

      if (selectedProposal.alternativePackages) {
        alternativePackage = findAlternativeProposalByPackage(selectedProposal.alternativePackages, otherPackage.id) || selectedProposal.alternativePackages[0];
      }

      var ctaType = AlternativePackages_getCtaType(selectedProposal, otherPackage.id, basePackageId);
      return AlternativePackages_jsx(react["Fragment"], {
        key: otherPackage.id
      }, AlternativePackages_jsx(Title["a" /* Title */], {
        className: "mb-20 text-saffron",
        theme: "title-sans-n4"
      }, Object(src_i18n["h" /* t */])("booking.services.".concat(packageInfos.title))), AlternativePackages_jsx(PaidService["a" /* PaidService */], {
        addLabel: Object(src_i18n["h" /* t */])('booking.common.add'),
        ctaType: ctaType,
        headColor: packageInfos.color,
        icon: packageInfos.icon,
        imageUrl: packageInfos.imageUrl,
        includedLabel: Object(src_i18n["h" /* t */])('booking.common.included'),
        isColumn: isColumn,
        label: otherPackage.label,
        text: otherPackage.description,
        tooltip: {
          children: AlternativePackages_jsx("div", {
            className: "text-initial flex w-full"
          }, AlternativePackages_jsx(AlternativePackageToolTip["a" /* AlternativePackageToolTip */], {
            bundle: RONPackage
          }), AlternativePackages_jsx(AlternativePackageToolTip["a" /* AlternativePackageToolTip */], {
            bundle: otherPackage
          })),
          dataSelector: 'JoyviewUpsellTooltip',
          modalProps: {
            ariaLabel: otherPackage.label,
            closeLabel: Object(src_i18n["h" /* t */])('common.close')
          }
        },
        onClick: function onClick() {
          var _alternativePackage;

          switch (ctaType) {
            case 'add':
              trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
                detail_click: 'add_joyview_packages'
              });
              break;

            case 'remove':
              trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
                detail_click: 'remove_joyview_packages'
              });
              break;

            default:
              noop_default()();

              break;
          }

          return selectProposal((_alternativePackage = alternativePackage) === null || _alternativePackage === void 0 ? void 0 : _alternativePackage.proposalId);
        },
        price: (_alternativePackage2 = alternativePackage) === null || _alternativePackage2 === void 0 ? void 0 : _alternativePackage2.upsellPrice,
        removeLabel: Object(src_i18n["h" /* t */])('booking.common.remove')
      }), index < mappedArray.length - 1 && AlternativePackages_jsx("div", {
        className: "mb-15 mt-20 text-center text-20 sm:mb-0 sm:mt-40"
      }, Object(src_i18n["h" /* t */])('booking.services.JVPackagesOr')));
    })
  );
};
// EXTERNAL MODULE: ./src/client/components/widgets/childcare/childcare.helper.js
var childcare_helper = __webpack_require__("YVWi");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/Childcare.jsx + 5 modules
var Childcare = __webpack_require__("BGO8");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/ChildcareIncludedEquipmentCapsule.jsx
var ChildcareIncludedEquipmentCapsule = __webpack_require__("UnYQ");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/ChildcareOnDemandEquipmentCapsule.jsx
var ChildcareOnDemandEquipmentCapsule = __webpack_require__("LoHR");

// EXTERNAL MODULE: ./src/client/context/ChildcareContext.js
var ChildcareContext = __webpack_require__("7afx");

// EXTERNAL MODULE: ./src/client/context/ServicesContext.js
var ServicesContext = __webpack_require__("2Odu");

// EXTERNAL MODULE: ./src/hooks/use-childcare-context/useChildcareContext.js
var useChildcareContext = __webpack_require__("V+KB");

// CONCATENATED MODULE: ./src/client/views/booking/services/ServicesView.jsx
















var ServicesView_jsx = react_default.a.createElement;

function ServicesView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ServicesView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ServicesView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ServicesView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var ServicesView_ServicesView = function ServicesView(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      proposals = _ref.proposals,
      infoBannerData = _ref.infoBannerData;
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    noEdit: false
  });
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var trackingDefaultPayload = {
    actionGA: 'services'
  };
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var tripInformation = Object(es["e" /* useSelector */])(storeHelper["d" /* tripInformationSelector */]);
  var trackError = Object(useTracking["a" /* useTracking */])(ServicesView_objectSpread(ServicesView_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'service'
  }));

  var _useSelector = Object(es["e" /* useSelector */])(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */]),
      attendeesWithInfos = _useSelector.attendees;

  var attendeesList = [].concat(Object(toConsumableArray["a" /* default */])(attendeesWithInfos.adults), Object(toConsumableArray["a" /* default */])(attendeesWithInfos.children.map(function (child) {
    return ServicesView_objectSpread(ServicesView_objectSpread({}, child), {}, {
      isChild: true
    });
  })));

  var _useChidcareContext = Object(useChildcareContext["a" /* useChidcareContext */])({
    appContext: appContext,
    proposals: proposals
  }),
      childcareContextServicesValuesBE = _useChidcareContext.childcareContextServicesValuesBE;

  var servicesContextValuesBE = Object(react["useMemo"])(function () {
    return {
      attendeesList: attendeesList,
      arrivalDate: selectedProposal.arrivalDate,
      departureDate: selectedProposal.departureDate,
      showRentAllSchedules: true
    };
  }, [selectedProposal]);

  var onAddChildcare = function onAddChildcare(_ref2) {
    var childcareId = _ref2.childcareId,
        attendeeId = _ref2.attendeeId,
        startDate = _ref2.startDate,
        endDate = _ref2.endDate,
        overloadChildcareIdForChalet = _ref2.overloadChildcareIdForChalet;
    var addChildcareAction = Object(proposals_action["b" /* addAdditionalService */])({
      proposalIds: proposals.map(function (_ref3) {
        var id = _ref3.id;
        return id;
      }),
      serviceId: childcareId,
      attendeeIds: attendeeId,
      schedules: [{
        startDate: startDate,
        endDate: endDate
      }],
      overloadForSpecificProposalIds: overloadChildcareIdForChalet,
      appContext: appContext
    });
    return dispatch(addChildcareAction).catch(function (error) {
      return Object(BookingEngine_utils["i" /* trackErrorOnAddService */])(error, trackError, 'UNKNOWN_CHILDCARE');
    });
  };

  var onDeleteChildcare = function onDeleteChildcare(_ref4) {
    var childcareId = _ref4.childcareId,
        attendeeId = _ref4.attendeeId,
        overloadChildcareIdForChalet = _ref4.overloadChildcareIdForChalet;
    return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
      serviceIds: [childcareId],
      attendeeIds: attendeeId,
      overloadForSpecificProposalIds: overloadChildcareIdForChalet,
      appContext: appContext
    }));
  };

  var dispatchSelectProposal = function dispatchSelectProposal(proposalId) {
    var updatedUri = new URI_default.a(router.asPath).setQuery(dist["appQueryParameters"].booking.selectedProposalId, proposalId);
    router.replace(updatedUri.toString());
    return dispatch(Object(selectedProposalId_action["d" /* selectProposal */])(proposalId));
  };

  var renderJoyView = function renderJoyView() {
    return ServicesView_jsx(AlternativePackages_AlternativePackages, {
      selectedProposal: selectedProposal,
      selectProposal: dispatchSelectProposal
    });
  };

  var renderChildcare = function renderChildcare() {
    var childrenAttendees = get_default()(selectedProposal, 'attendees.children');

    var includedChildrenActivities = resort.childrenActivities.filter(function (activity) {
      return activity.equipments.length > 1;
    });
    var onDemandChildrenActivities = resort.childrenActivities.filter(function (activity) {
      return !activity.isIncluded;
    });
    var shouldShowIncludedEquipments = Object(childcare_helper["f" /* hasChildrenAgedXOrLess */])(childrenAttendees, 6);
    return ServicesView_jsx("div", {
      className: "-mx-10 flex flex-wrap"
    }, ServicesView_jsx("div", {
      className: "w-full p-10 sm:w-2/3 md:w-3/4"
    }, ServicesView_jsx(ChildcareContext["a" /* ChildcareContext */].Provider, {
      value: childcareContextServicesValuesBE
    }, ServicesView_jsx(ServicesContext["a" /* ServicesContext */].Provider, {
      value: servicesContextValuesBE
    }, ServicesView_jsx(Childcare["a" /* Childcare */], {
      addChildcare: onAddChildcare,
      attendees: selectedProposal.attendees.children.map(function (child) {
        var referedChild = Object(childcare_helper["c" /* getCurrentKid */])(tripInformation.kids, child);
        return ServicesView_objectSpread(ServicesView_objectSpread({}, child), {}, {
          firstName: referedChild && referedChild.firstName,
          lastName: referedChild && referedChild.lastName
        });
      }),
      childcareAdditionalServices: selectedProposal.additionalServices.childcares,
      deleteChildcare: onDeleteChildcare,
      proposals: proposals
    })))), ServicesView_jsx("div", {
      className: "w-full p-10 sm:order-first sm:w-1/3 md:w-1/4"
    }, shouldShowIncludedEquipments && ServicesView_jsx(ChildcareIncludedEquipmentCapsule["a" /* ChildcareIncludedEquipmentCapsule */], {
      className: "mb-20",
      facilities: [].concat(Object(toConsumableArray["a" /* default */])(includedChildrenActivities), Object(toConsumableArray["a" /* default */])(resort.facilities))
    }), ServicesView_jsx(ChildcareOnDemandEquipmentCapsule["a" /* ChildcareOnDemandEquipmentCapsule */], {
      activities: onDemandChildrenActivities
    })));
  };

  return ServicesView_jsx(react["Fragment"], null, !(resort.isJoyview || resort.isUrbanOasis) && Object(infoBanner_utils["a" /* renderInfoBanner */])(ServicesView_objectSpread({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'services'
  }, trackingDefaultPayload)), resort.isJoyview || resort.isUrbanOasis ? renderJoyView() : renderChildcare());
};

/* harmony default export */ var services_ServicesView = (ServicesView_ServicesView);
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("IAdD");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/kebabCase.js
var kebabCase = __webpack_require__("s2Gj");
var kebabCase_default = /*#__PURE__*/__webpack_require__.n(kebabCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/values.js
var lodash_values = __webpack_require__("0iyY");
var values_default = /*#__PURE__*/__webpack_require__.n(lodash_values);

// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/PromoCode.jsx + 2 modules
var PromoCode = __webpack_require__("mCPI");

// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/DiscountsLine.jsx
var DiscountsLine = __webpack_require__("CYED");

// EXTERNAL MODULE: ./src/client/components/widgets/reserved-services-wrapper/ReservedServicesList.jsx + 3 modules
var ReservedServicesList = __webpack_require__("toM8");

// EXTERNAL MODULE: ./src/client/store/booking/option-validity/optionvalidity.action.js
var optionvalidity_action = __webpack_require__("F5c/");

// EXTERNAL MODULE: ./src/utils/option-validity/constants.js
var option_validity_constants = __webpack_require__("l/UU");

// EXTERNAL MODULE: ./src/client/components/widgets/accordion-block/AccordionBlock.jsx
var AccordionBlock = __webpack_require__("sORq");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-summary/AccommodationSummary.jsx
var AccommodationSummary = __webpack_require__("g5cf");

// EXTERNAL MODULE: ./src/client/components/widgets/price-detail-block-lines/PriceDetailLines.jsx
var PriceDetailLines = __webpack_require__("y0X/");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/widgets/great-members-loyalty-points/GreatMembersLoyaltyPoints.jsx
var GreatMembersLoyaltyPoints = __webpack_require__("b45f");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/insurance.constantes.js
var ADD_INSURANCE = 'addInsurance';
var DELETE_INSURANCE = 'deleteInsurance';
var INVALID_INSURANCE = 'invalidInsurance';
// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/InsuranceBody.jsx



var InsuranceBody_jsx = react_default.a.createElement;




var FormatedClause = function FormatedClause(_ref) {
  var clause = _ref.clause;
  var clauseParts = clause.split(':');

  if (clauseParts && clauseParts.length === 2) {
    return InsuranceBody_jsx("span", null, InsuranceBody_jsx("span", {
      className: "font-bold"
    }, clauseParts[0], " :"), clauseParts[1]);
  }

  return InsuranceBody_jsx("span", null, clause);
};

var InsuranceBody_InsuranceBody = function InsuranceBody(_ref2) {
  var company = _ref2.company,
      coverageDescriptions = _ref2.coverageDescriptions,
      label = _ref2.label,
      shortDescription = _ref2.shortDescription,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? '' : _ref2$dataTestId;
  return InsuranceBody_jsx("div", {
    className: "p-20 sm:flex",
    "data-testid": dataTestId
  }, InsuranceBody_jsx("div", {
    className: "text-black md:pe-20"
  }, InsuranceBody_jsx("h3", {
    className: "mb-20 font-bold text-sienna"
  }, label), InsuranceBody_jsx("p", {
    className: "mb-20 text-16 font-bold"
  }, shortDescription), InsuranceBody_jsx("div", {
    className: "gap-20 md:flex"
  }, company.logo && InsuranceBody_jsx("div", {
    className: "mb-15 border-1 border-pearl px-80 py-30 md:mb-0"
  }, company ? InsuranceBody_jsx("img", {
    alt: company.label,
    src: company.logo
  }) : null), InsuranceBody_jsx("ul", null, coverageDescriptions.map(function (clause) {
    return InsuranceBody_jsx("li", {
      className: "mb-10 text-14 leading-tight",
      key: clause
    }, InsuranceBody_jsx(Icon["a" /* Icon */], {
      className: "me-5 text-blueWave",
      name: icons["a" /* ICONS */].CHECK,
      width: "1em"
    }), InsuranceBody_jsx(FormatedClause, {
      clause: clause
    }));
  })))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/radio-button/RadioButton.jsx
var RadioButton = __webpack_require__("zwQs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/insurance.utils.js
var insuranceFieldName = 'insurance-terms-checkbox-insurance-';

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/InsuranceCTA.jsx




var InsuranceCTA_jsx = react_default.a.createElement;




















var InsuranceCTA_FormatedInformationAndTerms = function FormatedInformationAndTerms(_ref) {
  var attachedDocuments = _ref.attachedDocuments,
      isChecked = _ref.isChecked;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isSeller = _useAppContext.isSeller;

  return InsuranceCTA_jsx(react["Fragment"], null, InsuranceCTA_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('me-5', {
      'text-red': !isChecked
    }, {
      'text-black': isChecked
    })
  }, Object(src_i18n["h" /* t */])(isSeller ? 'booking.partners.insurance.termsAndCondition' : 'booking.insurance.addInsurance'), ":"), attachedDocuments.map(function (_ref2) {
    var label = _ref2.label,
        url = _ref2.url;
    return InsuranceCTA_jsx(TextLink["a" /* TextLink */], {
      color: isChecked ? colors["a" /* COLORS */].BLACK : colors["a" /* COLORS */].RED,
      className: "me-5",
      "data-testid": "insurance-cgv-pdf",
      key: label,
      label: label,
      url: url
    });
  }));
};

function InsuranceCTA(_ref3) {
  var attachedDocuments = _ref3.attachedDocuments,
      id = _ref3.id,
      insurance = _ref3.insurance,
      isLoading = _ref3.isLoading,
      onChange = _ref3.onChange,
      setAddedInsuranceNow = _ref3.setAddedInsuranceNow,
      _ref3$dataTestId = _ref3.dataTestId,
      dataTestId = _ref3$dataTestId === void 0 ? '' : _ref3$dataTestId;
  var isAdded = false;
  var termsChecked = false;
  var isDeleted = false;
  var insurancesStore = Object(es["e" /* useSelector */])(booking_selector["o" /* getInsurancesStore */]);

  if (insurancesStore[id]) {
    isAdded = insurancesStore[id].isAdded;
    isDeleted = insurancesStore[id].isDeleted;
    termsChecked = insurancesStore[id].termsChecked;
  }

  var dispatch = Object(es["d" /* useDispatch */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var refuseInsurance = function refuseInsurance() {
    if (!isDeleted) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
        detail_click: 'remove_insurance'
      });
      onChange(insurance, DELETE_INSURANCE);
    }
  };

  var addInsuranceAction = function addInsuranceAction() {
    if (!isAdded && !insurance.pricingInfo.isPartiallyRented) {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
        detail_click: 'add_insurance'
      });
      setAddedInsuranceNow(true);
      onChange(insurance, ADD_INSURANCE);
    }
  };

  return InsuranceCTA_jsx("div", {
    className: "px-20 pt-20",
    "data-testid": dataTestId
  }, InsuranceCTA_jsx("div", {
    className: "mb-20"
  }, InsuranceCTA_jsx(formik_esm["d" /* Formik */], {
    initialValues: Object(defineProperty["a" /* default */])({}, insuranceFieldName + id, termsChecked)
  }, function () {
    var _insurance$pricingInf;

    return InsuranceCTA_jsx(formik_esm["c" /* Form */], null, InsuranceCTA_jsx("div", {
      role: "group",
      "aria-labelledby": "insurance-group",
      id: "form-".concat(insuranceFieldName).concat(kebabCase_default()(id))
    }, InsuranceCTA_jsx("div", {
      className: "mb-10 grid grid-cols-2 items-center rounded-12 border-1 border-lightGrey bg-white px-20 py-10"
    }, Object(src_i18n["h" /* t */])('booking.insurance.addInsuranceButton'), InsuranceCTA_jsx("div", {
      className: "flex items-center justify-end gap-10"
    }, InsuranceCTA_jsx("p", {
      className: "text-12 font-bold text-sienna md:text-14"
    }, "+ ", (_insurance$pricingInf = insurance.pricingInfo.totalPrice) === null || _insurance$pricingInf === void 0 ? void 0 : _insurance$pricingInf.formattedValue), isLoading && InsuranceCTA_jsx(Spinner["a" /* Spinner */], {
      size: "small"
    }), InsuranceCTA_jsx(RadioButton["a" /* RadioButton */], {
      dataTestid: "add-insurance-button",
      isChecked: isAdded,
      isDisabled: isLoading,
      onClick: function onClick() {
        addInsuranceAction();
      }
    }))), InsuranceCTA_jsx("div", {
      className: "grid grid-cols-2 items-center rounded-12 border-1 border-lightGrey bg-white px-20 py-10"
    }, Object(src_i18n["h" /* t */])('booking.insurance.removeInsurance'), InsuranceCTA_jsx("div", {
      className: "flex justify-end gap-10"
    }, isLoading && InsuranceCTA_jsx(Spinner["a" /* Spinner */], {
      size: "small"
    }), InsuranceCTA_jsx(RadioButton["a" /* RadioButton */], {
      dataTestid: "remove-insurance-button",
      isChecked: isDeleted,
      isDisabled: isLoading,
      onClick: function onClick() {
        refuseInsurance();
      }
    }))), InsuranceCTA_jsx(lib["UnmountClosed"], {
      isOpened: isAdded
    }, InsuranceCTA_jsx(formik_esm["c" /* Form */], null, InsuranceCTA_jsx(FormikInput["a" /* FormikInput */], {
      className: "mt-20 inline",
      dataTestId: "insuranceTerms",
      label: InsuranceCTA_jsx(InsuranceCTA_FormatedInformationAndTerms, {
        attachedDocuments: attachedDocuments,
        isChecked: !isAdded || termsChecked || isDeleted
      }),
      name: insuranceFieldName + id,
      onChange: function onChange() {
        dispatch(Object(createAction["b" /* default */])(proposals_constants["I" /* TOGGLE_TERMS */], id));
      },
      type: "checkbox"
    })))));
  })));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/InsuranceFeedback.jsx

var InsuranceFeedback_jsx = react_default.a.createElement;




var InsuranceFeedback_InsuranceFeedback = function InsuranceFeedback(_ref) {
  var name = _ref.name,
      text = _ref.text,
      type = _ref.type;
  var isError = type === 'error';
  var icon = isError ? icons["a" /* ICONS */].WARNING : icons["a" /* ICONS */].CHECK_OUTLINE;
  return InsuranceFeedback_jsx(Notification["a" /* Notification */], {
    className: Object(classnames_utils["a" /* classnames */])('bg-transparent', isError ? 'text-red' : 'text-green'),
    "data-testid": name,
    iconName: icon,
    iconWidth: "1.25rem"
  }, InsuranceFeedback_jsx("p", {
    className: "m-0 font-sans text-14 leading-normal"
  }, text));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/Insurance.jsx

var Insurance_jsx = react_default.a.createElement;











var Insurance_Insurance = function Insurance(_ref) {
  var _insurance$productInf;

  var errorMessageCode = _ref.errorMessageCode,
      insurance = _ref.insurance,
      isContinueActionClicked = _ref.isContinueActionClicked,
      isLoading = _ref.isLoading,
      onChange = _ref.onChange,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;

  var _useState = Object(react["useState"])(false),
      addedInsuranceNow = _useState[0],
      setAddedInsuranceNow = _useState[1];

  var _insurance$pricingInf = insurance.pricingInfo,
      id = _insurance$pricingInf.id,
      price = _insurance$pricingInf.totalPrice;
  var label = insurance.productInfo.label;

  var _ref2 = (insurance === null || insurance === void 0 ? void 0 : (_insurance$productInf = insurance.productInfo.insuranceDetails) === null || _insurance$productInf === void 0 ? void 0 : _insurance$productInf.find(function (detail) {
    return detail.id === id;
  })) || {},
      _ref2$coverageDescrip = _ref2.coverageDescriptions,
      coverageDescriptions = _ref2$coverageDescrip === void 0 ? [] : _ref2$coverageDescrip,
      _ref2$attachedDocumen = _ref2.attachedDocuments,
      attachedDocuments = _ref2$attachedDocumen === void 0 ? [] : _ref2$attachedDocumen,
      shortDescription = _ref2.shortDescription,
      company = _ref2.company;

  var isAdded = false;
  var termsChecked = false;
  var isDeleted = false;
  var insurancesStore = Object(es["e" /* useSelector */])(booking_selector["o" /* getInsurancesStore */]);

  if (insurancesStore[id]) {
    isAdded = insurancesStore[id].isAdded;
    isDeleted = insurancesStore[id].isDeleted;
    termsChecked = insurancesStore[id].termsChecked;
  }

  var hasJustSubscribedToInsurance = isAdded && !isDeleted && addedInsuranceNow;
  var submittedWithInsuranceWithoutTermsChecked = isAdded && !termsChecked && !isDeleted && isContinueActionClicked;
  return Insurance_jsx("div", {
    "data-testid": dataTestId
  }, Insurance_jsx("div", {
    className: "mb-15"
  }, Insurance_jsx("div", {
    className: "pb-25 bg-pearl rounded-12"
  }, !!price && Insurance_jsx(InsuranceBody_InsuranceBody, {
    label: label,
    shortDescription: shortDescription,
    coverageDescriptions: coverageDescriptions,
    company: company,
    price: price,
    dataTestId: "insurance-info"
  }), Insurance_jsx(InsuranceCTA, {
    id: id,
    insurance: insurance,
    isLoading: isLoading,
    onChange: onChange,
    attachedDocuments: attachedDocuments,
    setAddedInsuranceNow: setAddedInsuranceNow,
    dataTestId: "insurance-choice"
  }), isContinueActionClicked && errorMessageCode === INVALID_INSURANCE && Insurance_jsx("div", {
    className: "px-20"
  }, Insurance_jsx(InsuranceFeedback_InsuranceFeedback, {
    name: "insurance-invalid-error",
    text: Object(src_i18n["h" /* t */])('booking.insurance.errorMessage2'),
    type: "error"
  })), isContinueActionClicked && (isDeleted || isAdded && termsChecked) && Insurance_jsx("div", {
    className: "px-20"
  }, Insurance_jsx(InsuranceFeedback_InsuranceFeedback, {
    name: "insurance-added",
    text: Object(src_i18n["h" /* t */])('booking.insurance.noInsurance'),
    type: "notice"
  })), submittedWithInsuranceWithoutTermsChecked && Insurance_jsx("div", {
    className: "px-20"
  }, Insurance_jsx(InsuranceFeedback_InsuranceFeedback, {
    name: "insurance-terms-error",
    text: Object(src_i18n["h" /* t */])('booking.insurance.errorMessage3'),
    type: "error"
  })))), hasJustSubscribedToInsurance && Insurance_jsx(Toast["a" /* Toast */], {
    color: colors["a" /* COLORS */].GREEN,
    icon: icons["a" /* ICONS */].CHECK_OUTLINE,
    label: Object(src_i18n["h" /* t */])('booking.insurance.insuranceTaken'),
    onClose: function onClose() {
      return setAddedInsuranceNow(false);
    },
    visible: addedInsuranceNow
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/SummaryView.tracking.js









function SummaryView_tracking_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function SummaryView_tracking_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? SummaryView_tracking_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SummaryView_tracking_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



function SummaryView_tracking_trackClick(labelGA, appContext) {
  tracking_api["b" /* setDataLayer */](SummaryView_tracking_objectSpread(SummaryView_tracking_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    versionBooking: 'responsive',
    actionGA: 'summary',
    labelGA: labelGA
  }), appContext);
}
// CONCATENATED MODULE: ./src/client/components/frameworks/banner-with-button/BannerWithButton.jsx
var BannerWithButton_jsx = react_default.a.createElement;






var BannerWithButton_BannerWithButton = function BannerWithButton(_ref) {
  var ctaText = _ref.ctaText,
      ctaAction = _ref.ctaAction,
      bannerTitle = _ref.bannerTitle,
      _ref$bannerPadding = _ref.bannerPadding,
      bannerPadding = _ref$bannerPadding === void 0 ? 'p-0' : _ref$bannerPadding,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? 'inherit' : _ref$iconColor,
      iconName = _ref.iconName,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? '3rem' : _ref$iconWidth,
      middleTextTitle = _ref.middleTextTitle,
      middleTextDesc = _ref.middleTextDesc,
      rightTextDesc = _ref.rightTextDesc,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var isMobile = !isTablet;
  return BannerWithButton_jsx("div", {
    "data-testid": dataTestId
  }, BannerWithButton_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n2"
  }, bannerTitle), BannerWithButton_jsx("div", {
    className: "rounded-12 border-1 border-lightGrey bg-white"
  }, BannerWithButton_jsx("div", {
    className: "flex flex-col gap-10 md:flex-row md:justify-between ".concat(bannerPadding)
  }, BannerWithButton_jsx("div", {
    className: "flex w-full items-center gap-20 md:items-start"
  }, BannerWithButton_jsx(Icon["a" /* Icon */], {
    className: "text-".concat(iconColor),
    hasRtl: true,
    name: iconName,
    width: iconWidth
  }), BannerWithButton_jsx("div", {
    className: "w-full"
  }, BannerWithButton_jsx("div", {
    className: "flex w-full items-center justify-between text-14"
  }, middleTextTitle, middleTextDesc, BannerWithButton_jsx("p", {
    className: "w-1/3 text-right text-14 font-bold"
  }, Object(src_i18n["h" /* t */])('common.freeService'))), !isMobile && BannerWithButton_jsx("div", {
    className: "flex-1 text-14"
  }, rightTextDesc))), isMobile && BannerWithButton_jsx("div", {
    className: "flex-1 text-14"
  }, rightTextDesc)), BannerWithButton_jsx("div", {
    className: "mx-20 mb-20 mt-15 flex justify-center md:justify-end"
  }, BannerWithButton_jsx(Button["a" /* Button */], {
    className: "text-12 font-bold",
    "data-selector": "bannerWithButton-cta",
    "data-testid": "bannerWithButtonCta",
    onClick: ctaAction,
    size: "medium"
  }, ctaText))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/views/booking/summary/option-modal/OptionModal.jsx
var OptionModal_jsx = react_default.a.createElement;








var OptionModal_OptionModal = function OptionModal(_ref) {
  var imageUrl = _ref.imageUrl,
      proposalId = _ref.proposalId,
      onClose = _ref.onClose,
      onClick = _ref.onClick,
      _ref$isOptionAllowed = _ref.isOptionAllowed,
      isOptionAllowed = _ref$isOptionAllowed === void 0 ? false : _ref$isOptionAllowed,
      optionDuration = _ref.optionDuration,
      disclaimer = _ref.disclaimer;
  return OptionModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["h" /* t */])(isOptionAllowed ? 'booking.option.popin.header' : 'booking.callCenterPopIn.title'),
    ariaLabelledby: identifiers_constants["t" /* ID_MODAL_HEADER__BE__OPTION */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: onClose
  }, OptionModal_jsx("div", {
    className: "overflow-hidden",
    "data-testid": "SummaryView-optionModal"
  }, OptionModal_jsx("div", {
    className: "relative h-228 overflow-hidden"
  }, !!imageUrl && OptionModal_jsx("img", {
    src: imageUrl,
    className: "w-full",
    alt: ""
  }), OptionModal_jsx("div", {
    className: "absolute inset-0 flex items-center justify-center"
  }, OptionModal_jsx(Icon["a" /* Icon */], {
    className: "text-white",
    hasRtl: true,
    name: icons["a" /* ICONS */].CALENDAR_OPTION,
    width: "7rem"
  }))), OptionModal_jsx("div", {
    className: "m-25 text-center"
  }, OptionModal_jsx("div", {
    id: identifiers_constants["t" /* ID_MODAL_HEADER__BE__OPTION */],
    className: "mb-10 font-brand text-24 text-black"
  }, Object(src_i18n["h" /* t */])(isOptionAllowed ? 'booking.option.popin.header' : 'booking.callCenterPopIn.title')), isOptionAllowed ? OptionModal_jsx("div", {
    className: "mb-5 flex flex-col justify-center"
  }, OptionModal_jsx("div", {
    className: "p-10 text-16"
  }, Object(src_i18n["h" /* t */])('booking.option.popinDescription'), disclaimer), optionDuration && OptionModal_jsx("p", {
    className: "m-auto max-w-280 p-10 text-16"
  }, OptionModal_jsx(TemplateString["a" /* TemplateString */], {
    dataTestId: "optionEndDate",
    className: "font-bold text-sienna",
    template: Object(src_i18n["h" /* t */])('booking.summary.optionDuration'),
    values: {
      duration: optionDuration
    }
  }))) : OptionModal_jsx(react["Fragment"], null, OptionModal_jsx("p", {
    className: "mb-10 inline-flex items-center rounded-12 border-2 border-sienna p-10 text-sienna"
  }, OptionModal_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "2em"
  }), OptionModal_jsx("span", {
    className: "block font-bold"
  }, " ", Object(src_i18n["h" /* t */])('booking.callCenterPopIn.number'))), OptionModal_jsx("span", {
    className: "block text-10 text-black"
  }, Object(src_i18n["h" /* t */])('booking.callCenterPopIn.cost')), OptionModal_jsx("div", {
    className: "p-10 text-16"
  }, Object(src_i18n["h" /* t */])('booking.callCenterPopIn.useProposalIdLabel'))), OptionModal_jsx(Button["a" /* Button */], {
    className: "mb-15 mt-30 min-w-200",
    "data-testid": "pauseOptionModalButton",
    onClick: onClick
  }, Object(src_i18n["h" /* t */])('booking.option.buttonLabel')), OptionModal_jsx("div", {
    className: "font-bold"
  }, Object(src_i18n["h" /* t */])('common.reference'), " : ", proposalId))));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/option-block/OptionBlock.jsx
var OptionBlock_jsx = react_default.a.createElement;










var OptionBlock_OptionBlock = function OptionBlock(_ref) {
  var showOptionButton = _ref.showOptionButton,
      onOptionTaking = _ref.onOptionTaking,
      duration = _ref.duration,
      isBookingAlreadyExistsErrorMessageOpen = _ref.isBookingAlreadyExistsErrorMessageOpen,
      proposalId = _ref.proposalId,
      resortImage = _ref.resortImage,
      isOptionAllowed = _ref.isOptionAllowed,
      onOptionButtonClick = _ref.onOptionButtonClick,
      onOptionModalClose = _ref.onOptionModalClose,
      toggleOptionModal = _ref.toggleOptionModal,
      _ref$disclaimer = _ref.disclaimer,
      disclaimer = _ref$disclaimer === void 0 ? '' : _ref$disclaimer,
      durationDisclaimer = _ref.durationDisclaimer;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var onOptionModalButtonClick = function onOptionModalButtonClick() {
    onOptionTaking();
    onOptionModalClose();
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY, {
      detail_click: 'hold_option_validate'
    });
  };

  return OptionBlock_jsx(react_default.a.Fragment, null, OptionBlock_jsx("div", {
    className: "mx-auto mb-20 max-w-site-medium",
    "data-testid": "bloc-option",
    id: "bloc-option"
  }, showOptionButton && OptionBlock_jsx(BannerWithButton_BannerWithButton, {
    bannerPadding: "px-20 pt-20",
    bannerTitle: Object(src_i18n["h" /* t */])('booking.option.title'),
    ctaText: Object(src_i18n["h" /* t */])('booking.option.buttonLabel'),
    ctaAction: onOptionButtonClick,
    iconName: icons["a" /* ICONS */].CALENDAR_OPTION,
    iconColor: colors["a" /* COLORS */].SIENNA,
    iconWidth: "1.875rem",
    middleTextDesc: OptionBlock_jsx("p", {
      className: "text-16 font-bold"
    }, Object(src_i18n["h" /* t */])('booking.option.subLabel2')),
    rightTextDesc: OptionBlock_jsx("div", {
      className: "flex flex-col"
    }, "".concat(Object(src_i18n["h" /* t */])('booking.option.description')), duration && OptionBlock_jsx("div", null, !durationDisclaimer && OptionBlock_jsx("p", {
      "data-testid": "optionEndDate"
    }, Object(src_i18n["h" /* t */])('booking.option.DurationDisclaimer')), OptionBlock_jsx("p", {
      className: "font-bold"
    }, Object(src_i18n["h" /* t */])('booking.summary.optionDuration', {
      duration: duration
    })))),
    dataTestId: "option-block"
  }), isBookingAlreadyExistsErrorMessageOpen && OptionBlock_jsx(Notification["a" /* Notification */], {
    className: "bg-transparent text-red",
    iconName: icons["a" /* ICONS */].WARNING
  }, OptionBlock_jsx("p", {
    className: "m-0 font-sans text-14 leading-normal text-red"
  }, Object(src_i18n["h" /* t */])('booking.cxo.warning.bookingExists')))), toggleOptionModal && OptionBlock_jsx(OptionModal_OptionModal, {
    onClose: onOptionModalClose,
    imageUrl: resortImage,
    onClick: onOptionModalButtonClick,
    proposalId: proposalId,
    isOptionAllowed: isOptionAllowed,
    optionDuration: duration,
    disclaimer: disclaimer
  }));
};

/* harmony default export */ var option_block_OptionBlock = (OptionBlock_OptionBlock);
// CONCATENATED MODULE: ./src/client/components/frameworks/modal-with-image-icon/ModalWithImageIcon.jsx
var ModalWithImageIcon_jsx = react_default.a.createElement;




var ModalWithImageIcon_ModalWithImageIcon = function ModalWithImageIcon(_ref) {
  var imageUrl = _ref.imageUrl,
      icon = _ref.icon,
      onClose = _ref.onClose,
      children = _ref.children;
  return ModalWithImageIcon_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: onClose
  }, ModalWithImageIcon_jsx("div", {
    className: "overflow-hidden"
  }, ModalWithImageIcon_jsx("div", {
    className: "left-0 top-0 -z-1 flex h-228 w-full items-center justify-center bg-cover bg-center bg-no-repeat",
    "data-testid": "Modal-backgroundImage",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }, ModalWithImageIcon_jsx(Icon["a" /* Icon */], {
    className: "text-white",
    dataTestid: "Modal-icon",
    name: icon,
    width: "7em"
  })), children));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/option-modal/FtcOptionModal.jsx
var FtcOptionModal_jsx = react_default.a.createElement;






var FtcOptionModal_FtcOptionModal = function FtcOptionModal(_ref) {
  var imageUrl = _ref.imageUrl,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].PROMO_CODE : _ref$icon,
      proposalId = _ref.proposalId,
      onClose = _ref.onClose,
      onClick = _ref.onClick;
  var ftcPopinTitle = 'booking.summary.futureTravelCredit.popinTitle';
  var ftcPopinDescription = 'booking.summary.futureTravelCredit.popinDescription';
  var ftcPopinDescription2 = 'booking.summary.futureTravelCredit.popinDescription2';
  return FtcOptionModal_jsx(ModalWithImageIcon_ModalWithImageIcon, {
    onClose: onClose,
    imageUrl: imageUrl,
    icon: icon
  }, FtcOptionModal_jsx("div", {
    className: "m-25 text-center"
  }, FtcOptionModal_jsx("div", {
    id: identifiers_constants["t" /* ID_MODAL_HEADER__BE__OPTION */],
    className: "mb-10 font-brand text-28 text-saffron"
  }, Object(src_i18n["h" /* t */])(ftcPopinTitle)), FtcOptionModal_jsx("div", {
    className: "m-0 p-10 pb-0 text-18 font-bold"
  }, FtcOptionModal_jsx("span", {
    className: "block text-red"
  }, Object(src_i18n["h" /* t */])(ftcPopinDescription))), FtcOptionModal_jsx("div", {
    className: "m-0 p-10 text-16"
  }, Object(src_i18n["h" /* t */])(ftcPopinDescription2)), FtcOptionModal_jsx(Button["a" /* Button */], {
    className: "my-15 min-w-280 text-16 uppercase",
    "data-testid": "pauseFtcOptionModalButton",
    onClick: onClick,
    size: "medium"
  }, Object(src_i18n["h" /* t */])('booking.summary.futureTravelCredit.callToAction')), FtcOptionModal_jsx("div", {
    className: "font-bold"
  }, Object(src_i18n["h" /* t */])('common.reference'), " : ", proposalId)));
};
// EXTERNAL MODULE: ./src/client/views/booking/summary/SummaryView.utils.js
var SummaryView_utils = __webpack_require__("X3Cs");

// CONCATENATED MODULE: ./src/client/views/booking/summary/SummaryView.jsx




















var SummaryView_jsx = react_default.a.createElement;


function SummaryView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SummaryView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SummaryView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SummaryView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












































var SummaryView_constants$PACKAGES = dist["constants"].PACKAGES,
    SummaryView_JOYVIEW_ALL_INCLUSIVE = SummaryView_constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    SummaryView_JOYVIEW_FOOD_AND_BEVERAGES = SummaryView_constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;
var initialState = {
  isLoading: false,
  toggleOptionModal: false,
  isFtcPopinOpened: false,
  isContinueActionClicked: false,
  openBookingAlreadyExistsErrorMessage: false,
  duration: null
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'toggleLoading':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        isLoading: !state.isLoading
      });

    case 'updateInsuranceError':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        // $FlowFixMe
        insuranceError: SummaryView_objectSpread(SummaryView_objectSpread({}, state.insuranceError), action.payload)
      });

    case 'openOptionModal':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        toggleOptionModal: !state.toggleOptionModal
      });

    case 'toggleFtcPopin':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        isFtcPopinOpened: !state.isFtcPopinOpened
      });

    case 'setContinueActionClicked':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        isContinueActionClicked: action.payload
      });

    case 'setOpenBookingAlreadyExistsErrorMessage':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        openBookingAlreadyExistsErrorMessage: action.payload
      });

    case 'setDuration':
      return SummaryView_objectSpread(SummaryView_objectSpread({}, state), {}, {
        duration: action.payload
      });

    default:
      return state;
  }
};

var SummaryView_SummaryView = function SummaryView(_ref) {
  var _selectedProposal$pri;

  var i18n = _ref.i18n,
      infoBannerData = _ref.infoBannerData,
      isOptionHoldOnly = _ref.isOptionHoldOnly,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      setTimerInitialValue = _ref.setTimerInitialValue,
      showTimer = _ref.showTimer;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var router = Object(next_router["useRouter"])();
  var context = Object(react["useContext"])(ReactAppContext["a" /* B2CAppContext */]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var isMobile = !isTablet;
  var priceWithDonation = Object(price_util["c" /* getTotalPriceWithDonation */])(selectedProposal.price, context.locale);
  var isJoyview = resort.isJoyview,
      isUrbanOasis = resort.isUrbanOasis;
  var isJoyViewAllInclusive = selectedProposal.packageId === SummaryView_JOYVIEW_ALL_INCLUSIVE && isJoyview;
  var isUrbanOasisAllInclusive = selectedProposal.packageId === SummaryView_JOYVIEW_ALL_INCLUSIVE && isUrbanOasis;
  var isUrbanOasisFoodAndBeverage = selectedProposal.packageId === SummaryView_JOYVIEW_FOOD_AND_BEVERAGES && isUrbanOasis;

  var _getOffersAndDiscount = Object(SummaryView_utils["a" /* getOffersAndDiscounts */])((selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$pri = selectedProposal.price) === null || _selectedProposal$pri === void 0 ? void 0 : _selectedProposal$pri.discounts) || []),
      discounts = _getOffersAndDiscount.discounts,
      offers = _getOffersAndDiscount.offers;

  var dispatch = Object(es["d" /* useDispatch */])();

  var onLoadingStart = function onLoadingStart() {
    return dispatch(Object(globalLoader_action["d" /* startLoading */])());
  };

  var onLoadingEnd = function onLoadingEnd() {
    return dispatch(Object(globalLoader_action["c" /* endLoading */])());
  };

  var onDeleteInsuranceFromProposals = function onDeleteInsuranceFromProposals(addOrRemoveInsuranceParams) {
    return dispatch(Object(proposals_action["h" /* deleteInsurances */])(addOrRemoveInsuranceParams));
  };

  var onAddInsuranceToProposals = function onAddInsuranceToProposals(addOrRemoveInsuranceParams) {
    return dispatch(Object(proposals_action["c" /* addInsurances */])(addOrRemoveInsuranceParams));
  };

  var onSetOptionValidity = function onSetOptionValidity() {
    return dispatch(Object(optionvalidity_action["a" /* setOptionValidity */])(context));
  };

  var onRefuseInsuranceAction = function onRefuseInsuranceAction(insuranceId) {
    return dispatch(Object(proposals_action["s" /* refuseInsuranceAction */])(insuranceId));
  };

  var getInitialInsuranceState = function getInitialInsuranceState() {
    var _selectedProposal$add;

    var insuranceError = (_selectedProposal$add = selectedProposal.additionalServices.insurance) === null || _selectedProposal$add === void 0 ? void 0 : _selectedProposal$add.reduce(function (acc, ins) {
      var _ins$pricingInfo = ins.pricingInfo,
          id = _ins$pricingInfo.id,
          isPartiallyRented = _ins$pricingInfo.isPartiallyRented;
      return SummaryView_objectSpread(SummaryView_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, id, isPartiallyRented ? ADD_INSURANCE : ''));
    }, {});
    return insuranceError;
  };

  var _useReducer = Object(react["useReducer"])(reducer, SummaryView_objectSpread(SummaryView_objectSpread({}, initialState), {}, {
    insuranceError: getInitialInsuranceState()
  })),
      state = _useReducer[0],
      componentDispatch = _useReducer[1];

  var reservedServicesByAttendee = Object(es["e" /* useSelector */])(booking_selector["u" /* getReservedServicesByAttendee */]);
  var insurances = Object(es["e" /* useSelector */])(booking_selector["o" /* getInsurancesStore */]);

  var hasNotRefusedNeitherCheckedCgusOfSomeInsurances = function hasNotRefusedNeitherCheckedCgusOfSomeInsurances() {
    return values_default()(insurances).some(function (ins) {
      return !(ins === null || ins === void 0 ? void 0 : ins.termsChecked) && !(ins === null || ins === void 0 ? void 0 : ins.isDeleted);
    });
  };

  Object(react["useEffect"])(function () {
    if (showTimer) {
      var newDateTime = moment_default()().add(15, 'minutes').unix(); // initialize timer only in summary step for chinese locale and proposals with transport

      setTimerInitialValue(newDateTime);
      sessionStorage.setItem(getChinaTimerSessionKey(selectedProposal.id), newDateTime.toString());
    }

    onSetOptionValidity();

    if (selectedProposal.expirationDateTime) {
      componentDispatch({
        type: 'setDuration',
        payload: Object(apiDate["i" /* getDiffFromNowTo */])(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.expirationDateTime)
      });
    }
  }, []);
  var areInsurancesChoicesValid = Object(react["useCallback"])(function () {
    var _selectedProposal$add2;

    var hasError = false;
    var insurancesActualState = state.insuranceError;
    var insurancesStateToCheck = state.insuranceError;

    for (var insuranceId in insurancesActualState) {
      if ((isEmpty_default()(insurancesActualState[insuranceId]) || insurancesActualState[insuranceId] === INVALID_INSURANCE) && !insurances[insuranceId].isDeleted) {
        hasError = true;
        Object(scrollToElement["a" /* scrollToElement */])('#form-' + insuranceFieldName + kebabCase_default()(insuranceId));
        Object.assign(insurancesStateToCheck, Object(defineProperty["a" /* default */])({}, insuranceId, INVALID_INSURANCE));
      }
    }

    if (hasError || (selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$add2 = selectedProposal.additionalServices.insurance) === null || _selectedProposal$add2 === void 0 ? void 0 : _selectedProposal$add2.length) !== 0 && hasNotRefusedNeitherCheckedCgusOfSomeInsurances()) {
      Object(BookingEngine_tracking["c" /* trackNavigation */])('summary', 'insuranceError', context);
      componentDispatch({
        type: 'updateInsuranceError',
        payload: {
          insurancesStateToCheck: insurancesStateToCheck
        }
      });
      componentDispatch({
        type: 'setContinueActionClicked',
        payload: true
      });
      return Promise.reject();
    }

    return Promise.resolve();
  }, [selectedProposal, state.insuranceError, insurances]);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    isPriceLoading: state.isLoading,
    noEdit: false,
    overwriteContinueButton: isOptionHoldOnly,
    validationCallback: areInsurancesChoicesValid
  }); // add, remove or refuse an insurance

  var insuranceActions = function insuranceActions(insurance, action) {
    componentDispatch({
      type: 'toggleLoading'
    });
    var insuranceId = insurance.pricingInfo.id;
    var proposalIds = proposals.map(function (_ref2) {
      var id = _ref2.id;
      return id;
    });
    var lightAttendee = selectedProposal.attendees ? selectedProposal.attendees.list.map(function (_ref3) {
      var id = _ref3.id;
      return {
        id: id
      };
    }) : [];
    var addOrRemoveInsuranceParams = {
      proposalIds: proposalIds,
      insurance: insurance,
      attendeeIds: lightAttendee.map(function (_ref4) {
        var id = _ref4.id;
        return id;
      }),
      appContext: context
    };

    if (action === ADD_INSURANCE) {
      Object(BookingEngine_tracking["c" /* trackNavigation */])('summary', 'insuranceSubscribe', context);

      var addInsuranceStateById = function addInsuranceStateById() {
        componentDispatch({
          type: 'toggleLoading'
        });
        componentDispatch({
          type: 'updateInsuranceError',
          payload: Object(defineProperty["a" /* default */])({}, insuranceId, ADD_INSURANCE)
        });
      };

      onAddInsuranceToProposals(addOrRemoveInsuranceParams).then(addInsuranceStateById);
    } else {
      // ACTION REMOVE
      Object(BookingEngine_tracking["c" /* trackNavigation */])('summary', 'insuranceNotSubscribe', context);

      var deleteInsuranceStateById = function deleteInsuranceStateById() {
        componentDispatch({
          type: 'toggleLoading'
        });
        componentDispatch({
          type: 'updateInsuranceError',
          payload: Object(defineProperty["a" /* default */])({}, insuranceId, DELETE_INSURANCE)
        });
      };

      var isInsuranceAlreadyAddedToProposal = insurance.pricingInfo.isPartiallyRented;

      if (isInsuranceAlreadyAddedToProposal) {
        onDeleteInsuranceFromProposals(addOrRemoveInsuranceParams).then(deleteInsuranceStateById);
      } else {
        // equivalent to just refuse the insurance, no request is involved in this case
        deleteInsuranceStateById();
      }

      onRefuseInsuranceAction(insuranceId);
    }
  };

  var takeAnOption = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var withfutureTravelCredits,
          status,
          _args = arguments;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              withfutureTravelCredits = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              SummaryView_tracking_trackClick('saveOption_popin', context);
              onLoadingStart();
              _context.next = 5;
              return Object(ContactInfoUtils["x" /* submitOption */])({
                appContext: context,
                router: router,
                hasSaveOption: true,
                withfutureTravelCredits: withfutureTravelCredits
              })(selectedProposal.id);

            case 5:
              status = _context.sent;

              if (!(status === null || status === void 0 ? void 0 : status.isRedirectionPerfomed) && (status === null || status === void 0 ? void 0 : status.reason) === option_validity_constants["a" /* BOOKING_ALREADY_EXISTS */]) {
                componentDispatch({
                  type: 'toggleLoading'
                });
                componentDispatch({
                  type: 'setOpenBookingAlreadyExistsErrorMessage',
                  payload: true
                });
                onLoadingEnd();
                setTimeout(function () {
                  return Object(scrollToElement["a" /* scrollToElement */])('#bloc-option');
                });
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function takeAnOption() {
      return _ref5.apply(this, arguments);
    };
  }();

  var loadAndTakeAnOption = /*#__PURE__*/function () {
    var _ref6 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(boolean) {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (state.isLoading) {
                _context2.next = 5;
                break;
              }

              onLoadingStart;
              _context2.next = 4;
              return takeAnOption(boolean);

            case 4:
              onLoadingEnd;

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function loadAndTakeAnOption(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  var shouldShowOptionButton = function shouldShowOptionButton() {
    return Object(featureFlippingUtils["a" /* isFeatureFlipped */])(context, isMobile)('booking.option') && Object(proposalUtils["u" /* isOptionAllowed */])(selectedProposal);
  };

  var isPromoCodeEnabled = Object(src_i18n["d" /* getKeyValue */])('booking.priceDetails.promoCode.enabled');

  var openOptionModal = function openOptionModal() {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY, {
      detail_click: 'hold_option'
    });
    componentDispatch({
      type: 'openOptionModal'
    });
  };

  var getDisclaimer = function getDisclaimer() {
    return (selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.durationDisclaimer) === false ? Object(src_i18n["h" /* t */])('booking.option.DurationDisclaimer') : '';
  };

  var roomQuantity = selectedProposal.accommodations.filter(function (accommodation) {
    return accommodation.quantity > 1;
  }).map(function (accommodation) {
    return accommodation.quantity;
  });
  var shouldShowPriceDetails = isJoyViewAllInclusive || isUrbanOasisAllInclusive || !isJoyview && !isUrbanOasis;
  return SummaryView_jsx(react["Fragment"], null, SummaryView_jsx(head_default.a, null, SummaryView_jsx("title", {
    key: "title"
  }, Object(src_i18n["h" /* t */])('booking.summary.seo.title'))), Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: 'summary'
  }), SummaryView_jsx("p", {
    className: "mb-10 font-brand text-24 text-black"
  }, Object(src_i18n["h" /* t */])('booking.summary.pageTitle')), SummaryView_jsx("div", {
    className: "mb-20 flex items-center gap-10"
  }, SummaryView_jsx(Icon["a" /* Icon */], {
    className: "text-green",
    name: icons["a" /* ICONS */].CHECK_FILLED,
    width: "1.875rem"
  }), SummaryView_jsx("p", {
    className: "mt-2 font-brand text-green"
  }, Object(src_i18n["h" /* t */])('booking.summary.discount.bestRateGuarantee'))), SummaryView_jsx("div", {
    className: "mb-60 rounded-12 bg-white p-20 shadow-sm",
    "data-testid": "stay-summary-ticket"
  }, SummaryView_jsx(AccordionBlock["a" /* AccordionBlock */], {
    trackingEventName: tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY,
    lines: Object(SummaryView_utils["c" /* getSummaryViewLinesByProposal */])({
      accommodationSummary: SummaryView_jsx(AccommodationSummary["a" /* AccommodationSummary */], {
        accommodations: selectedProposal.accommodations,
        resort: resort,
        roomQuantity: roomQuantity
      }),
      locale: context.locale,
      selectedProposal: selectedProposal,
      isJoyViewOrUrbanOasisAllInclusive: isJoyViewAllInclusive || isUrbanOasisAllInclusive,
      isUrbanOasisFoodAndBeverage: isUrbanOasisFoodAndBeverage,
      i18n: i18n
    })
  }, SummaryView_jsx("div", {
    className: "mt-40"
  }, shouldShowPriceDetails && SummaryView_jsx("p", {
    className: "mb-20 font-bold"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.priceDetails')), SummaryView_jsx(PriceDetailLines["a" /* PriceDetailLines */], {
    trackingEventName: tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY,
    priceDetail: Object(SummaryView_utils["b" /* getPriceDetail */])({
      selectedProposal: selectedProposal,
      priceWithDonation: priceWithDonation,
      showPriceDetailLines: shouldShowPriceDetails,
      promoCode: SummaryView_jsx("div", {
        className: "mb-20"
      }, SummaryView_jsx(DiscountsLine["a" /* DiscountsLine */], {
        discounts: offers
      }), isPromoCodeEnabled && !!selectedProposal && SummaryView_jsx(PromoCode["a" /* PromoCode */], {
        proposalId: selectedProposal.id,
        customerId: parseInt(selectedProposal.attendees.list[0].customerId, 10),
        discounts: discounts
      })),
      insurance: SummaryView_jsx("div", {
        className: "mb-20"
      }, selectedProposal.additionalServices.insurance ? selectedProposal.additionalServices.insurance.map(function (insurance) {
        return SummaryView_jsx(Insurance_Insurance, {
          isLoading: state.isLoading,
          errorMessageCode: state.insuranceError[insurance.pricingInfo.id],
          key: insurance.pricingInfo.id,
          insurance: insurance,
          onChange: insuranceActions,
          isContinueActionClicked: state.isContinueActionClicked,
          dataTestId: "insurance-block"
        });
      }) : null)
    })
  }), !!selectedProposal.greatMembersLoyaltyPoints && SummaryView_jsx(GreatMembersLoyaltyPoints["a" /* GreatMembersLoyaltyPoints */], {
    loyaltyPoints: selectedProposal.greatMembersLoyaltyPoints,
    dataTestId: "greatMembersLoyaltyPoints"
  })))), reservedServicesByAttendee.length > 0 && SummaryView_jsx("div", {
    className: "mb-20"
  }, SummaryView_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.activities.myPackage.title')), SummaryView_jsx(ReservedServicesList["a" /* ReservedServicesList */], {
    reservedServicesByAttendee: reservedServicesByAttendee,
    noEditMode: true,
    currency: selectedProposal.price.currency,
    scrollBackwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  })), SummaryView_jsx(option_block_OptionBlock, {
    showOptionButton: shouldShowOptionButton(),
    onOptionTaking: function onOptionTaking() {
      return loadAndTakeAnOption(false);
    },
    duration: state.duration,
    disclaimer: getDisclaimer(),
    isBookingAlreadyExistsErrorMessageOpen: state.openBookingAlreadyExistsErrorMessage,
    durationDisclaimer: selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.durationDisclaimer,
    proposalId: selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.id,
    isOptionAllowed: Object(proposalUtils["u" /* isOptionAllowed */])(selectedProposal),
    resortImage: resort.image,
    onOptionButtonClick: openOptionModal,
    onOptionModalClose: function onOptionModalClose() {
      return componentDispatch({
        type: 'openOptionModal'
      });
    },
    toggleOptionModal: state.toggleOptionModal
  }), state.isFtcPopinOpened && SummaryView_jsx(FtcOptionModal_FtcOptionModal, {
    onClose: function onClose() {
      return componentDispatch({
        type: 'toggleFtcPopin'
      });
    },
    imageUrl: resort.image,
    icon: icons["a" /* ICONS */].PROMO_CODE,
    onClick: function onClick() {
      return loadAndTakeAnOption(true);
    },
    proposalId: selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.id
  }));
};

/* harmony default export */ var summary_SummaryView = (SummaryView_SummaryView);
// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/BeTransportDetails.jsx
var BeTransportDetails = __webpack_require__("a2Xc");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transport_details_transportUtils = __webpack_require__("z8xc");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransportLayerIcons.jsx
var AdditionalTransportLayerIcons_jsx = react_default.a.createElement;



var AdditionalTransportLayerIcons_AdditionalTransportLayerIcons = function AdditionalTransportLayerIcons() {
  return AdditionalTransportLayerIcons_jsx("div", {
    "data-testid": "AdditionalTransportLayerIcons",
    className: "pointer-events-none absolute inset-0 -z-1 bg-pearl text-lightGrey"
  }, AdditionalTransportLayerIcons_jsx("div", {
    className: "fixed bottom-0 left-0 -mb-100 -translate-x-1/2 transform sm:mb-0"
  }, AdditionalTransportLayerIcons_jsx(Icon["a" /* Icon */], {
    isNotSquare: true,
    name: icons["a" /* ICONS */].PLANE_AND_CIRCLE,
    rotation: 180,
    width: "25rem"
  })), AdditionalTransportLayerIcons_jsx("div", {
    className: "fixed right-0 top-0 -mt-100 translate-x-1/2 transform sm:mt-0"
  }, AdditionalTransportLayerIcons_jsx(Icon["a" /* Icon */], {
    isNotSquare: true,
    name: icons["a" /* ICONS */].PLANE_AND_CIRCLE,
    width: "25rem"
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// EXTERNAL MODULE: ./src/hooks/use-disclosure/useDisclosure.js
var useDisclosure = __webpack_require__("Re84");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/ArrivalDepartureRangeFilter.utils.js

var MAX_MINUTES_IN_CURRENT_HOUR = 59; // case 23h OR 23h59

var getNextHourOrEndOfDay = function getNextHourOrEndOfDay(date) {
  var nextHour = date.clone().add(1, 'hour').startOf('hour');
  return nextHour.isSame(date, 'day') ? nextHour : date.clone().endOf('day');
}; // calculate the range of time graduations and steps number for marks

var getRangeTimeGraduations = function getRangeTimeGraduations(_ref) {
  var startTime = _ref.startTime,
      endTime = _ref.endTime;
  var graduations = [];
  var numHours = endTime.diff(startTime, 'hours'); // Iterate through the time range, incrementing by one hour

  for (var i = 0; i <= numHours; i++) {
    graduations.push(startTime.clone().add(i, 'hours').format('HH[h]'));
  } // add the last graduation
  // it's the next hour or the end of the day


  var lastGraduation = getNextHourOrEndOfDay(startTime.clone().add(numHours, 'hours'));
  var timeFormat = lastGraduation.minutes() === MAX_MINUTES_IN_CURRENT_HOUR ? 'HH[h]mm' : 'HH[h]';
  graduations.push(lastGraduation.format(timeFormat)); // Display the graduations

  var stepsNumber = graduations.length;
  return {
    graduations: graduations,
    stepsNumber: stepsNumber
  };
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/groupBy.js
var groupBy = __webpack_require__("Rj53");
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// CONCATENATED MODULE: ./src/hooks/use-transport-filters/transportFiltersReducer.utils.js

















function transportFiltersReducer_utils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function transportFiltersReducer_utils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? transportFiltersReducer_utils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : transportFiltersReducer_utils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var defaultState = {
  transports: [],
  filteredTransports: [],
  stopovers: [{
    label: 'direct',
    min: 0,
    max: 0,
    value: '0',
    isSelected: false,
    flightIdList: []
  }, {
    label: 'stop.label_1',
    min: 0,
    max: 0,
    value: '1',
    isSelected: false,
    flightIdList: []
  }, {
    label: 'stop.label_n',
    min: 0,
    max: 0,
    value: '2',
    isSelected: false,
    flightIdList: []
  }],
  companies: [],
  connectingCities: [],
  inboundDepartureTimeRange: {
    start: moment_default()().startOf('day'),
    end: moment_default()().endOf('day')
  },
  outboundDepartureTimeRange: {
    start: moment_default()().startOf('day'),
    end: moment_default()().endOf('day')
  },
  durationRanges: [{
    label: 'label_2h',
    value: '0',
    min: 0,
    max: 120,
    isSelected: false,
    flightIdList: []
  }, {
    label: 'label_4h',
    value: '1',
    min: 120,
    max: 240,
    isSelected: false,
    flightIdList: []
  }, {
    label: 'label_8h',
    value: '2',
    min: 240,
    max: 480,
    isSelected: false,
    flightIdList: []
  }, {
    label: 'label_8h_more',
    value: '3',
    min: 480,
    max: 6000,
    isSelected: false,
    flightIdList: []
  }],
  totalFiltersSelected: 0
};
var computeDurationRangeFilters = function computeDurationRangeFilters(id, durationInMin, durationRanges) {
  if (durationInMin < 120) {
    durationRanges.firstDurationRangeIdList.push(id);
  } else if (durationInMin < 240) {
    durationRanges.secondDurationRangeIdList.push(id);
  } else if (durationInMin < 480) {
    durationRanges.thirdDurationRangeIdList.push(id);
  } else {
    durationRanges.fourthDurationRangeIdList.push(id);
  }
};
var computeStopoverFilters = function computeStopoverFilters(id, travelSections, stopovers) {
  if (travelSections.length === 1) {
    stopovers.transportsWithNoStopoversIdList.push(id);
  } else if (travelSections.length === 2) {
    stopovers.transportsWith1StopoversIdList.push(id);
  } else {
    stopovers.transportsWith2StopoversIdList.push(id);
  }
};
var transportFiltersReducer_utils_computeCompaniesFilters = function computeCompaniesFilters(id, travelSections, companies) {
  companies.push.apply(companies, Object(toConsumableArray["a" /* default */])(Object(transport_details_transportUtils["i" /* getCompanyOperators */])(travelSections).map(function (company) {
    return transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, company), {}, {
      flightId: id
    });
  })));
};
var computeConnectingCitiesFilters = function computeConnectingCitiesFilters(id, travelSections, connectingCities) {
  if (travelSections.length < 2) {
    return;
  }

  var citiesArrival = travelSections.map(function (travelSection) {
    return travelSection.arrival;
  }).slice(0, -1);
  citiesArrival.forEach(function (cityArrival) {
    connectingCities.push({
      label: cityArrival.label,
      cityId: cityArrival.cityId,
      flightId: id
    });
  });
};
var transportFiltersReducer_utils_computeDepartureTimeRangesFilters = function computeDepartureTimeRangesFilters(travelSections, computedDepartureTimeRanges) {
  var departureTime = moment_default()(travelSections[0].departure.time, 'HH:mm:ss');
  computedDepartureTimeRanges.push(departureTime);
};
var computeTransportDetailFilters = function computeTransportDetailFilters(id, transportDetail, computedFilters) {
  var computedStopovers = computedFilters.computedStopovers,
      computedDurationRange = computedFilters.computedDurationRange,
      computedCompanies = computedFilters.computedCompanies,
      computedConnectingCities = computedFilters.computedConnectingCities,
      computedDepartureTimeRanges = computedFilters.computedDepartureTimeRanges;
  computeStopoverFilters(id, transportDetail.travelSections, computedStopovers);
  computeDurationRangeFilters(id, Number(transportDetail.durationInMin), computedDurationRange);
  transportFiltersReducer_utils_computeCompaniesFilters(id, transportDetail.travelSections, computedCompanies);
  computeConnectingCitiesFilters(id, transportDetail.travelSections, computedConnectingCities);
  transportFiltersReducer_utils_computeDepartureTimeRangesFilters(transportDetail.travelSections, computedDepartureTimeRanges);
};
var transportFiltersReducer_utils_computeFilters = function computeFilters(computedStopovers, computedDurationRange, computedCompanies, computedConnectingCities, computedInboundDepartureTimeRanges, computedOutboundDepartureTimeRanges) {
  var stopovers = values_default()(computedStopovers).map(function (stopoverIdList, index) {
    return transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, defaultState.stopovers[index]), {}, {
      flightIdList: uniq_default()(stopoverIdList)
    });
  });
  var durationRanges = values_default()(computedDurationRange).map(function (durationRangesIdList, index) {
    return transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, defaultState.durationRanges[index]), {}, {
      flightIdList: uniq_default()(durationRangesIdList)
    });
  });
  var groupedCompanies = groupBy_default()(computedCompanies, 'id');
  var companies = sortBy_default()(Object.keys(groupedCompanies).map(function (companyId) {
    return {
      value: groupedCompanies[companyId][0].id,
      label: Object(labelUtils["a" /* capitalizeName */])(groupedCompanies[companyId][0].label),
      flightIdList: uniq_default()(groupedCompanies[companyId].map(function (company) {
        return company.flightId;
      })),
      isSelected: false,
      min: 0,
      max: 0
    };
  }), 'label');
  var groupedConnectingCities = groupBy_default()(computedConnectingCities, 'cityId');
  var connectingCities = sortBy_default()(Object.keys(groupedConnectingCities).map(function (connectingCityId) {
    return {
      value: groupedConnectingCities[connectingCityId][0].cityId,
      label: Object(labelUtils["a" /* capitalizeName */])(groupedConnectingCities[connectingCityId][0].label),
      flightIdList: uniq_default()(groupedConnectingCities[connectingCityId].map(function (connectingCity) {
        return connectingCity.flightId;
      })),
      isSelected: false,
      min: 0,
      max: 0
    };
  }), 'label');
  var inboundDepartureTimeRange = {
    start: moment_default.a.min(computedInboundDepartureTimeRanges).startOf('hour'),
    end: moment_default.a.max(computedInboundDepartureTimeRanges).startOf('hour')
  };
  var outboundDepartureTimeRange = {
    start: moment_default.a.min(computedOutboundDepartureTimeRanges).startOf('hour'),
    end: moment_default.a.max(computedOutboundDepartureTimeRanges).startOf('hour')
  };
  return {
    stopovers: stopovers,
    durationRanges: durationRanges,
    companies: companies,
    connectingCities: connectingCities,
    inboundDepartureTimeRange: inboundDepartureTimeRange,
    outboundDepartureTimeRange: outboundDepartureTimeRange
  };
};
var transportFiltersReducer_utils_applyFilters = function applyFilters(state) {
  var transports = state.transports,
      stopovers = state.stopovers,
      durationRanges = state.durationRanges,
      companies = state.companies,
      connectingCities = state.connectingCities,
      inboundDepartureTimeRange = state.inboundDepartureTimeRange,
      outboundDepartureTimeRange = state.outboundDepartureTimeRange;
  var totalFiltersSelected = stopovers.filter(function (stopover) {
    return stopover.isSelected;
  }).length + durationRanges.filter(function (durationRange) {
    return durationRange.isSelected;
  }).length + companies.filter(function (company) {
    return company.isSelected;
  }).length + connectingCities.filter(function (connectingCity) {
    return connectingCity.isSelected;
  }).length;
  var filteredTransports = transports.filter(function (transport) {
    var id = transport.id,
        inbound = transport.inbound,
        outbound = transport.outbound;
    var inboundStopovers = inbound.travelSections.length - 1;
    var outboundStopovers = outbound.travelSections.length - 1;
    var inboundDurationInMin = Number(inbound.durationInMin);
    var outboundDurationInMin = Number(outbound.durationInMin);
    var inboundCompanyIds = Object(transport_details_transportUtils["i" /* getCompanyOperators */])(inbound.travelSections).map(function (company) {
      return company.id;
    });
    var outboundCompanyIds = Object(transport_details_transportUtils["i" /* getCompanyOperators */])(outbound.travelSections).map(function (company) {
      return company.id;
    });
    var inboundConnectingCityIds = inbound.travelSections.map(function (travelSection) {
      return travelSection.arrival.cityId;
    }).slice(0, -1);
    var outboundConnectingCityIds = outbound.travelSections.map(function (travelSection) {
      return travelSection.arrival.cityId;
    }).slice(0, -1); // add rule for all filters to check if none is selected

    var allStopoversNotSelected = stopovers.every(function (stopover) {
      return !stopover.isSelected;
    });
    var allDurationRangesNotSelected = durationRanges.every(function (durationRange) {
      return !durationRange.isSelected;
    });
    var allCompaniesNotSelected = companies.every(function (company) {
      return !company.isSelected;
    });
    var allConnectingCitiesNotSelected = connectingCities.every(function (connectingCity) {
      return !connectingCity.isSelected;
    });
    var isInboundStopoverSelected = stopovers.some(function (stopover) {
      return stopover.isSelected && stopover.flightIdList.includes(id) && Number(stopover.value) <= inboundStopovers;
    });
    var isOutboundStopoverSelected = stopovers.some(function (stopover) {
      return stopover.isSelected && stopover.flightIdList.includes(id) && Number(stopover.value) <= outboundStopovers;
    });
    var isInboundDurationRangeSelected = durationRanges.some(function (durationRange) {
      return durationRange.isSelected && durationRange.flightIdList.includes(id) && durationRange.min <= inboundDurationInMin && durationRange.max > inboundDurationInMin;
    });
    var isOutboundDurationRangeSelected = durationRanges.some(function (durationRange) {
      return durationRange.isSelected && durationRange.flightIdList.includes(id) && durationRange.min <= outboundDurationInMin && durationRange.max > outboundDurationInMin;
    });
    var isInboundCompanySelected = companies.some(function (company) {
      return company.isSelected && company.flightIdList.includes(id) && inboundCompanyIds.includes(company.value);
    });
    var isOutboundCompanySelected = companies.some(function (company) {
      return company.isSelected && company.flightIdList.includes(id) && outboundCompanyIds.includes(company.value);
    });
    var isInboundConnectingCitySelected = connectingCities.some(function (connectingCity) {
      return connectingCity.isSelected && connectingCity.flightIdList.includes(id) && inboundConnectingCityIds.includes(connectingCity.value);
    });
    var isOutboundConnectingCitySelected = connectingCities.some(function (connectingCity) {
      return connectingCity.isSelected && connectingCity.flightIdList.includes(id) && outboundConnectingCityIds.includes(connectingCity.value);
    });
    var isInboundDepartureTimeInRange = moment_default()(inbound.travelSections[0].departure.time, 'HH:mm:ss').isBetween(inboundDepartureTimeRange.start, inboundDepartureTimeRange.end, 'minute', '[]');
    var isOutboundDepartureTimeInRange = moment_default()(outbound.travelSections[0].departure.time, 'HH:mm:ss').isBetween(outboundDepartureTimeRange.start, outboundDepartureTimeRange.end, 'minute', '[]');
    return (isInboundStopoverSelected || isOutboundStopoverSelected || allStopoversNotSelected) && (isInboundDurationRangeSelected || isOutboundDurationRangeSelected || allDurationRangesNotSelected) && (isInboundCompanySelected || isOutboundCompanySelected || allCompaniesNotSelected) && (isInboundConnectingCitySelected || isOutboundConnectingCitySelected || allConnectingCitiesNotSelected) && isInboundDepartureTimeInRange && isOutboundDepartureTimeInRange;
  });
  return {
    filteredTransports: filteredTransports,
    totalFiltersSelected: totalFiltersSelected
  };
};
var transportFiltersReducer_utils_initReducer = function initReducer(state, transports) {
  var computedStopovers = {
    transportsWithNoStopoversIdList: [],
    transportsWith1StopoversIdList: [],
    transportsWith2StopoversIdList: []
  };
  var computedDurationRange = {
    firstDurationRangeIdList: [],
    secondDurationRangeIdList: [],
    thirdDurationRangeIdList: [],
    fourthDurationRangeIdList: []
  };
  var computedCompanies = [];
  var computedConnectingCities = [];
  var computedInboundDepartureTimeRanges = [];
  var computedOutboundDepartureTimeRanges = [];

  if (!transports) {
    return state;
  }

  transports.forEach(function (transport) {
    var id = transport.id,
        inbound = transport.inbound,
        outbound = transport.outbound;
    var computedFilters = {
      computedStopovers: computedStopovers,
      computedDurationRange: computedDurationRange,
      computedCompanies: computedCompanies,
      computedConnectingCities: computedConnectingCities
    };
    computeTransportDetailFilters(id, inbound, transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, computedFilters), {}, {
      computedDepartureTimeRanges: computedInboundDepartureTimeRanges
    }));
    computeTransportDetailFilters(id, outbound, transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, computedFilters), {}, {
      computedDepartureTimeRanges: computedOutboundDepartureTimeRanges
    }));
  });

  var _computeFilters = transportFiltersReducer_utils_computeFilters(computedStopovers, computedDurationRange, computedCompanies, computedConnectingCities, computedInboundDepartureTimeRanges, computedOutboundDepartureTimeRanges),
      stopovers = _computeFilters.stopovers,
      durationRanges = _computeFilters.durationRanges,
      companies = _computeFilters.companies,
      connectingCities = _computeFilters.connectingCities,
      inboundDepartureTimeRange = _computeFilters.inboundDepartureTimeRange,
      outboundDepartureTimeRange = _computeFilters.outboundDepartureTimeRange;

  return transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, state), {}, {
    stopovers: stopovers,
    durationRanges: durationRanges,
    companies: companies,
    connectingCities: connectingCities,
    inboundDepartureTimeRange: transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, inboundDepartureTimeRange), {}, {
      end: getNextHourOrEndOfDay(inboundDepartureTimeRange.end)
    }),
    outboundDepartureTimeRange: transportFiltersReducer_utils_objectSpread(transportFiltersReducer_utils_objectSpread({}, outboundDepartureTimeRange), {}, {
      end: getNextHourOrEndOfDay(outboundDepartureTimeRange.end)
    }),
    defaultInboundDepartureTimeRange: inboundDepartureTimeRange,
    defaultOutboundDepartureTimeRange: outboundDepartureTimeRange,
    transports: transports,
    filteredTransports: transports
  });
};
// CONCATENATED MODULE: ./src/hooks/use-transport-filters/transportFiltersReducer.js











function transportFiltersReducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function transportFiltersReducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? transportFiltersReducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : transportFiltersReducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var TRANSPORT_FILTERS_ACTIONS = {
  UPDATE: 'UPDATE',
  RESET: 'RESET'
};
var transportFiltersReducer_transportFiltersReducer = function transportFiltersReducer(state, action) {
  var payload = action.payload;

  switch (action.type) {
    case TRANSPORT_FILTERS_ACTIONS.UPDATE:
      {
        var value = payload.value,
            key = payload.key;
        var filters = state[key];
        var updatedFilter = ['inboundDepartureTimeRange', 'outboundDepartureTimeRange'].includes(key) ? value : // $FlowFixMe
        filters.map(function (filter) {
          if (filter.value === value) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, filter), {}, {
              isSelected: !filter.isSelected
            });
          }

          return filter;
        });

        var newState = transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, key, updatedFilter));

        var _applyFilters = transportFiltersReducer_utils_applyFilters(newState),
            filteredTransports = _applyFilters.filteredTransports,
            totalFiltersSelected = _applyFilters.totalFiltersSelected;

        return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, newState), {}, {
          filteredTransports: filteredTransports,
          totalFiltersSelected: totalFiltersSelected
        });
      }

    case TRANSPORT_FILTERS_ACTIONS.RESET:
      {
        var transports = state.transports,
            stopovers = state.stopovers,
            durationRanges = state.durationRanges,
            companies = state.companies,
            connectingCities = state.connectingCities;

        var _newState = transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, state), {}, {
          filteredTransports: transports,
          stopovers: stopovers.map(function (stopover) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, stopover), {}, {
              isSelected: false
            });
          }),
          durationRanges: durationRanges.map(function (durationRange) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, durationRange), {}, {
              isSelected: false
            });
          }),
          companies: companies.map(function (company) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, company), {}, {
              isSelected: false
            });
          }),
          connectingCities: connectingCities.map(function (connectingCity) {
            return transportFiltersReducer_objectSpread(transportFiltersReducer_objectSpread({}, connectingCity), {}, {
              isSelected: false
            });
          }),
          inboundDepartureTimeRange: {
            start: (state.defaultInboundDepartureTimeRange || defaultState.inboundDepartureTimeRange).start,
            end: getNextHourOrEndOfDay((state.defaultInboundDepartureTimeRange || defaultState.inboundDepartureTimeRange).end)
          },
          outboundDepartureTimeRange: {
            start: (state.defaultOutboundDepartureTimeRange || defaultState.outboundDepartureTimeRange).start,
            end: getNextHourOrEndOfDay((state.defaultOutboundDepartureTimeRange || defaultState.outboundDepartureTimeRange).end)
          },
          totalFiltersSelected: 0
        });

        return _newState;
      }

    default:
      throw new Error();
  }
};
// CONCATENATED MODULE: ./src/hooks/use-transport-filters/useTransportFilters.js



var useTransportFilters_useTransportFilters = function useTransportFilters(transports) {
  var _useReducer = Object(react["useReducer"])(transportFiltersReducer_transportFiltersReducer, transportFiltersReducer_utils_initReducer(defaultState, transports)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var updateFilters = function updateFilters(key, value) {
    dispatch({
      type: TRANSPORT_FILTERS_ACTIONS.UPDATE,
      payload: {
        key: key,
        value: value
      }
    });
  };

  var resetFilters = function resetFilters() {
    dispatch({
      type: TRANSPORT_FILTERS_ACTIONS.RESET
    });
  };

  return {
    state: state,
    updateFilters: updateFilters,
    resetFilters: resetFilters
  };
};
// EXTERNAL MODULE: ./src/client/components/frameworks/hr/Hr.jsx
var Hr = __webpack_require__("3+yQ");

// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/TransportTicket.jsx + 3 modules
var TransportTicket = __webpack_require__("k52x");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportListOrderButton.jsx
var AdditionalTransportListOrderButton_jsx = react_default.a.createElement;







var AdditionalTransportListOrderButton_AdditionalTransportListOrderButton = function AdditionalTransportListOrderButton(_ref) {
  var isDisabled = _ref.isDisabled,
      isSelected = _ref.isSelected,
      type = _ref.type,
      setSelectedOrder = _ref.setSelectedOrder,
      price = _ref.price,
      time = _ref.time;
  var isActive = isSelected && !isDisabled;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportListOrderButton_jsx("button", {
    "data-testid": "AdditionalTransportListOrderButton",
    disabled: isDisabled,
    type: "button",
    className: Object(classnames_utils["a" /* classnames */])({
      'min-h-100 rounded-12 border-1 p-15 text-start': true,
      'cursor-pointer': !isDisabled,
      'border-none bg-saffron': isActive,
      'cursor-not-allowed bg-lightGrey': isDisabled
    }),
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'change_flight_type',
        flight_type: type
      });
      setSelectedOrder();
    }
  }, AdditionalTransportListOrderButton_jsx("p", {
    className: "mb-4 text-14 font-semibold"
  }, Object(src_i18n["h" /* t */])("booking.transport.sort.".concat(type, "Flight")), isActive && AdditionalTransportListOrderButton_jsx(Icon["a" /* Icon */], {
    className: "-mb-3 ms-5",
    name: icons["a" /* ICONS */].CHECK,
    width: "1rem"
  })), AdditionalTransportListOrderButton_jsx("p", {
    className: "text-20 font-semibold"
  }, price), time && AdditionalTransportListOrderButton_jsx("p", {
    className: "text-12 font-normal"
  }, time));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportListFilters.jsx
var AdditionalTransportListFilters_jsx = react_default.a.createElement;






var AdditionalTransportListFilters_AdditionalTransportListFilters = function AdditionalTransportListFilters(_ref) {
  var totalTransports = _ref.totalTransports,
      cheapestTransport = _ref.cheapestTransport,
      fastestTransport = _ref.fastestTransport,
      selectedOrder = _ref.selectedOrder,
      _setSelectedOrder = _ref.setSelectedOrder;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var isDisabled = totalTransports <= 1;
  var cheapestTransportTime = Object(transportUtils["h" /* getTransportAverageDuration */])(cheapestTransport);
  var fastestTransportTime = Object(transportUtils["h" /* getTransportAverageDuration */])(fastestTransport);
  return AdditionalTransportListFilters_jsx("div", {
    className: "my-20"
  }, AdditionalTransportListFilters_jsx("div", {
    "data-testid": "AdditionalTransportListFilters",
    className: "flex items-center gap-15"
  }, AdditionalTransportListFilters_jsx(AdditionalTransportListOrderButton_AdditionalTransportListOrderButton, {
    isDisabled: isDisabled,
    type: "cheapest",
    isSelected: selectedOrder === 'cheapest',
    setSelectedOrder: function setSelectedOrder() {
      _setSelectedOrder('cheapest');
    },
    price: cheapestTransport ? Object(transportUtils["g" /* getTotalDifferentialPrice */])(cheapestTransport === null || cheapestTransport === void 0 ? void 0 : cheapestTransport.totalDifferentialPrice) : '0',
    time: cheapestTransportTime > 0 ? Object(src_i18n["h" /* t */])('booking.transport.averageFlightDuration', {
      time: Object(transport_details_transportUtils["p" /* transformMinutesInHours */])(Object(transportUtils["h" /* getTransportAverageDuration */])(cheapestTransport), isRTL)
    }) : undefined
  }), AdditionalTransportListFilters_jsx(AdditionalTransportListOrderButton_AdditionalTransportListOrderButton, {
    isDisabled: isDisabled,
    type: "fastest",
    isSelected: selectedOrder === 'fastest',
    setSelectedOrder: function setSelectedOrder() {
      _setSelectedOrder('fastest');
    },
    price: fastestTransport ? Object(transportUtils["g" /* getTotalDifferentialPrice */])(fastestTransport === null || fastestTransport === void 0 ? void 0 : fastestTransport.totalDifferentialPrice) : '0',
    time: fastestTransportTime > 0 ? Object(src_i18n["h" /* t */])('booking.transport.averageFlightDuration', {
      time: Object(transport_details_transportUtils["p" /* transformMinutesInHours */])(Object(transportUtils["h" /* getTransportAverageDuration */])(fastestTransport), isRTL)
    }) : undefined
  })), AdditionalTransportListFilters_jsx("p", {
    className: "mt-10 font-normal text-12"
  }, Object(src_i18n["h" /* t */])('booking.transport.sort.label')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransportSelectedTransport.jsx

var AdditionalTransportSelectedTransport_jsx = react_default.a.createElement;









var AdditionalTransportSelectedTransport_AdditionalTransportSelectedTransport = function AdditionalTransportSelectedTransport(_ref) {
  var proposal = _ref.proposal,
      selectedTransport = _ref.selectedTransport;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      toggleSelectedTransport = _React$useState2[0],
      setToggleSelectedTransport = _React$useState2[1];

  var isTransportRecommended = Object(proposalUtils["w" /* isRecommendedTransport */])(selectedTransport, proposal.id);
  var theme = !isTablet ? 'mobile' : 'desktop';
  return AdditionalTransportSelectedTransport_jsx("div", {
    "data-testid": "AdditionalTransportSelectedTransport"
  }, AdditionalTransportSelectedTransport_jsx("button", {
    "data-testid": "ToggleSelectedTransportButton",
    type: "button",
    onClick: function onClick() {
      return setToggleSelectedTransport(!toggleSelectedTransport);
    },
    className: "flex w-full items-center justify-between"
  }, AdditionalTransportSelectedTransport_jsx("div", {
    className: "flex items-center gap-10 text-14 font-semibold"
  }, AdditionalTransportSelectedTransport_jsx(Badge["a" /* Badge */], {
    className: "size-48 border-black bg-black text-white",
    iconName: icons["a" /* ICONS */].ALL_INCLUSIVE,
    variant: "pill"
  }), Object(src_i18n["h" /* t */])('booking.transport.selectedFlight.title')), AdditionalTransportSelectedTransport_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_TOP,
    rotation: toggleSelectedTransport ? 0 : 180
  })), AdditionalTransportSelectedTransport_jsx(lib["UnmountClosed"], {
    isOpened: toggleSelectedTransport
  }, AdditionalTransportSelectedTransport_jsx("div", {
    className: "py-15"
  }, AdditionalTransportSelectedTransport_jsx(TransportTicket["a" /* TransportTicket */], {
    theme: theme,
    isTransportRecommended: isTransportRecommended,
    transport: selectedTransport,
    isSelected: true
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportsList.jsx

var AdditionalTransportsList_jsx = react_default.a.createElement;














var AdditionalTransportsList_AdditionalTransportsList = function AdditionalTransportsList(_ref) {
  var proposal = _ref.proposal,
      setSelectedTransport = _ref.setSelectedTransport,
      alternativeTransports = _ref.alternativeTransports;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var theme = !isTablet ? 'mobile' : 'desktop';
  var iterationNumber = 5;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["e" /* getAdditionalTransports */]),
      selectedTransport = _useSelector.selectedTransport;

  var _useState = Object(react["useState"])('cheapest'),
      selectedOrder = _useState[0],
      setSelectedOrder = _useState[1];

  var cheapestTransport = Object(transportUtils["k" /* orderTransportByPrice */])(alternativeTransports)[0];
  var fastestTransport = Object(transportUtils["j" /* orderTransportByDuration */])(alternativeTransports)[0];
  var orderedAlternativeTransports = Object(transportUtils["l" /* orderTransportByType */])(alternativeTransports, selectedOrder);
  var hasStrictTransportOrder = Object(transportUtils["c" /* getHasStrictTransportOrder */])(orderedAlternativeTransports, selectedOrder);

  var _useState2 = Object(react["useState"])(iterationNumber),
      forceInitialShowingItemsNumber = _useState2[0],
      setForceInitialShowingItemsNumber = _useState2[1];

  return AdditionalTransportsList_jsx("div", {
    "data-testid": "AdditionalTransportsList",
    className: "overflow-auto py-20 px-15 sm:px-60"
  }, orderedAlternativeTransports.length > 0 && AdditionalTransportsList_jsx(react_default.a.Fragment, null, AdditionalTransportsList_jsx(AdditionalTransportListFilters_AdditionalTransportListFilters, {
    totalTransports: orderedAlternativeTransports.length,
    cheapestTransport: cheapestTransport,
    fastestTransport: fastestTransport,
    selectedOrder: selectedOrder,
    setSelectedOrder: setSelectedOrder
  }), AdditionalTransportsList_jsx(AdditionalTransportSelectedTransport_AdditionalTransportSelectedTransport, {
    selectedTransport: selectedTransport,
    proposal: proposal
  }), AdditionalTransportsList_jsx(Hr["a" /* Hr */], {
    className: "mt-20"
  }), AdditionalTransportsList_jsx(Paginate["a" /* Paginate */], {
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.viewMore'),
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'see_more_new_flight'
      });
    },
    iterationNumber: iterationNumber,
    setForceInitialShowingItemsNumber: setForceInitialShowingItemsNumber,
    forceInitialShowingItemsNumber: !isTablet ? forceInitialShowingItemsNumber : 0
  }, orderedAlternativeTransports.map(function (transport, index) {
    return AdditionalTransportsList_jsx(react_default.a.Fragment, {
      key: "transport-".concat(index * 2)
    }, AdditionalTransportsList_jsx("br", null), AdditionalTransportsList_jsx(TransportTicket["a" /* TransportTicket */], {
      tag: index === 0 && hasStrictTransportOrder ? selectedOrder : undefined,
      theme: theme,
      transport: {
        inbound: transport.inbound,
        outbound: transport.outbound
      },
      alternativeTransportPrice: {
        id: transport.id,
        price: transport.price,
        totalDifferentialPrice: transport.totalDifferentialPrice
      },
      setSelectedTransport: setSelectedTransport,
      isTransportRecommended: Object(proposalUtils["w" /* isRecommendedTransport */])({
        inbound: transport.inbound,
        outbound: transport.outbound
      }, proposal.id)
    }));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilter.jsx

var AdditionalTransportFilter_jsx = react_default.a.createElement;





var AdditionalTransportFilter_AdditionalTransportFilter = function AdditionalTransportFilter(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      title = _ref.title,
      children = _ref.children;

  var _React$useState = react_default.a.useState(isOpen),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      toggleFilter = _React$useState2[0],
      setToggleFilter = _React$useState2[1];

  return AdditionalTransportFilter_jsx("div", {
    "data-testid": "AdditionalTransportFilter"
  }, AdditionalTransportFilter_jsx("button", {
    "data-testid": "ToggleAdditionalTransportFilter",
    type: "button",
    onClick: function onClick() {
      return setToggleFilter(!toggleFilter);
    },
    className: "flex items-center justify-between w-full"
  }, AdditionalTransportFilter_jsx("span", {
    className: "text-20 font-semibold"
  }, title), AdditionalTransportFilter_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_TOP,
    rotation: toggleFilter ? 0 : 180
  })), AdditionalTransportFilter_jsx(lib["UnmountClosed"], {
    isOpened: toggleFilter
  }, AdditionalTransportFilter_jsx("div", {
    className: "pt-30"
  }, children)), AdditionalTransportFilter_jsx(Hr["a" /* Hr */], {
    className: "my-20"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFiltersHeader.jsx
var AdditionalTransportFiltersHeader_jsx = react_default.a.createElement;





var AdditionalTransportFiltersHeader_AdditionalTransportFiltersHeader = function AdditionalTransportFiltersHeader(_ref) {
  var state = _ref.state,
      resetFilters = _ref.resetFilters;
  var totalFiltersSelected = state.totalFiltersSelected;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportFiltersHeader_jsx("div", {
    "data-testid": "AdditionalTransportFiltersHeader",
    className: "flex items-center justify-between"
  }, AdditionalTransportFiltersHeader_jsx("div", {
    className: "flex items-center gap-10 text-20 font-semibold"
  }, Object(src_i18n["h" /* t */])('booking.common.layer.filtersTitle'), AdditionalTransportFiltersHeader_jsx(Badge["a" /* Badge */], {
    className: "size-32 border-saffron bg-saffron text-14 text-black",
    label: "".concat(totalFiltersSelected),
    variant: "pill"
  })), AdditionalTransportFiltersHeader_jsx("button", {
    type: "button",
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'filter_remove_all'
      });
      resetFilters();
    },
    className: "cursor-pointer text-16 font-semibold underline"
  }, Object(src_i18n["h" /* t */])('filters.removeAll')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilterButton.jsx
var AdditionalTransportFilterButton_jsx = react_default.a.createElement;




var AdditionalTransportFilterButton_AdditionalTransportFilterButton = function AdditionalTransportFilterButton(_ref) {
  var label = _ref.label,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick;
  return AdditionalTransportFilterButton_jsx("div", {
    "data-testid": "AdditionalTransportFilterButton"
  }, AdditionalTransportFilterButton_jsx(Button["a" /* Button */], {
    className: "text-16 font-semibold",
    "data-selector": "AdditionalTransportFilterButton-button",
    iconRight: isSelected ? {
      name: icons["a" /* ICONS */].CHECK
    } : undefined,
    onClick: onClick,
    color: colors["a" /* COLORS */].BLACK,
    colorBg: isSelected ? colors["a" /* COLORS */].SAFFRON : colors["a" /* COLORS */].WHITE,
    colorBorder: isSelected ? colors["a" /* COLORS */].SAFFRON : colors["a" /* COLORS */].BLACK,
    size: "medium"
  }, label));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilterDurationRange.jsx


var AdditionalTransportFilterDurationRange_jsx = react_default.a.createElement;





var AdditionalTransportFilterDurationRange_AdditionalTransportFilterDurationRange = function AdditionalTransportFilterDurationRange(_ref) {
  var durationRanges = _ref.durationRanges,
      updateFilters = _ref.updateFilters;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportFilterDurationRange_jsx("div", {
    "data-testid": "AdditionalTransportFilterDurationRange",
    className: "grid grid-rows-2 gap-10"
  }, AdditionalTransportFilterDurationRange_jsx("div", {
    className: "flex items-center gap-10"
  }, durationRanges.slice(0, 2).map(function (durationRange) {
    return AdditionalTransportFilterDurationRange_jsx("div", {
      key: "durationRange-".concat(durationRange.value)
    }, AdditionalTransportFilterDurationRange_jsx(AdditionalTransportFilterButton_AdditionalTransportFilterButton, {
      label: Object(src_i18n["h" /* t */])("faceting.filters.flightDuration.".concat(durationRange.label)),
      isSelected: durationRange.isSelected,
      onClick: function onClick() {
        trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
          detail_click: 'filter_flight_time'
        });
        updateFilters('durationRanges', durationRange.value);
      }
    }));
  })), AdditionalTransportFilterDurationRange_jsx("div", {
    className: "flex items-center gap-10"
  }, durationRanges.slice(2).map(function (durationRange) {
    return AdditionalTransportFilterDurationRange_jsx("div", {
      key: "durationRange-".concat(durationRange.value)
    }, AdditionalTransportFilterDurationRange_jsx(AdditionalTransportFilterButton_AdditionalTransportFilterButton, {
      label: Object(src_i18n["h" /* t */])("faceting.filters.flightDuration.".concat(durationRange.label)),
      isSelected: durationRange.isSelected,
      onClick: function onClick() {
        trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
          detail_click: 'filter_flight_time'
        });
        updateFilters('durationRanges', durationRange.value);
      }
    }));
  })));
};
// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/additionalTransports.action.js
var additionalTransports_action = __webpack_require__("04nu");

// EXTERNAL MODULE: ./src/utils/string/stringUtils.js
var stringUtils = __webpack_require__("E8Xq");

// EXTERNAL MODULE: ./src/client/store/booking/transport-stations/transportStations.action.js
var transportStations_action = __webpack_require__("ldqU");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-search/AdditionalTransportAdvancedSearchFormFields.jsx














var AdditionalTransportAdvancedSearchFormFields_jsx = react_default.a.createElement;

function AdditionalTransportAdvancedSearchFormFields_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AdditionalTransportAdvancedSearchFormFields_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AdditionalTransportAdvancedSearchFormFields_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AdditionalTransportAdvancedSearchFormFields_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













function getCityTransportsByGroupName(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      cityId = _ref.cityId;
  var _data$airports = data.airports,
      airports = _data$airports === void 0 ? [] : _data$airports,
      _data$trainStations = data.trainStations,
      trainStations = _data$trainStations === void 0 ? [] : _data$trainStations,
      _data$ports = data.ports,
      ports = _data$ports === void 0 ? [] : _data$ports;
  return {
    previousCityId: cityId,
    cityTransports: [{
      groupName: Object(src_i18n["h" /* t */])('booking.transport.departure.airport'),
      groupOptions: airports.map(function (airport) {
        return AdditionalTransportAdvancedSearchFormFields_objectSpread(AdditionalTransportAdvancedSearchFormFields_objectSpread({}, airport), {}, {
          name: Object(stringUtils["a" /* capitalize */])(airport.name)
        });
      })
    }, {
      groupName: Object(src_i18n["h" /* t */])('booking.transport.departure.trainStation'),
      groupOptions: trainStations.map(function (trainStation) {
        return AdditionalTransportAdvancedSearchFormFields_objectSpread(AdditionalTransportAdvancedSearchFormFields_objectSpread({}, trainStation), {}, {
          name: Object(stringUtils["a" /* capitalize */])(trainStation.label)
        });
      })
    }, {
      groupName: Object(src_i18n["h" /* t */])('booking.transport.departure.port'),
      groupOptions: ports.map(function (port) {
        return AdditionalTransportAdvancedSearchFormFields_objectSpread(AdditionalTransportAdvancedSearchFormFields_objectSpread({}, port), {}, {
          name: Object(stringUtils["a" /* capitalize */])(port.label)
        });
      })
    }]
  };
}

function getTransportClassesByGroupName(hasPlane, hasTrain) {
  return {
    transportClasses: [{
      groupName: Object(src_i18n["h" /* t */])('common.transport.planeLabel'),
      groupOptions: transport_details_transportUtils["b" /* FLIGHT_CLASS_AVAILABLE_TO_SEARCH */].map(function (value) {
        return {
          value: value,
          name: Object(src_i18n["h" /* t */])("common.transport.transportClass.".concat(transport_details_transportUtils["f" /* TRANSPORT_CLASS_TO_I18N */][value])),
          isDisabled: !hasPlane
        };
      })
    }, {
      groupName: Object(src_i18n["h" /* t */])('common.transport.trainLabel'),
      groupOptions: transport_details_transportUtils["e" /* TRAIN_CLASS_AVAILABLE_TO_SEARCH */].map(function (value) {
        return {
          value: value,
          name: Object(src_i18n["h" /* t */])("common.transport.transportClass.".concat(transport_details_transportUtils["f" /* TRANSPORT_CLASS_TO_I18N */][value])),
          isDisabled: !hasTrain
        };
      })
    }]
  };
}

var AdditionalTransportAdvancedSearchFormFields_AdditionalTransportAdvancedSearchFormFields = function AdditionalTransportAdvancedSearchFormFields(_ref2) {
  var _proposal$transports, _proposal$transports$, _travelSections$;

  var proposal = _ref2.proposal;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var travelSections = (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : (_proposal$transports$ = _proposal$transports.inbound) === null || _proposal$transports$ === void 0 ? void 0 : _proposal$transports$.travelSections;
  var flightDeparture = travelSections === null || travelSections === void 0 ? void 0 : (_travelSections$ = travelSections[0]) === null || _travelSections$ === void 0 ? void 0 : _travelSections$.departure;
  var hasFlight = travelSections === null || travelSections === void 0 ? void 0 : travelSections.some(function (travelSection) {
    return (travelSection === null || travelSection === void 0 ? void 0 : travelSection.transport.type) === 'PLANE';
  });
  var hasTrain = travelSections === null || travelSections === void 0 ? void 0 : travelSections.some(function (travelSection) {
    return (travelSection === null || travelSection === void 0 ? void 0 : travelSection.transport.type) === 'TRAIN';
  });

  var _getCityTransportsByG = getCityTransportsByGroupName(Object(es["e" /* useSelector */])(booking_selector["g" /* getCityTransportsSelector */])),
      cityTransports = _getCityTransportsByG.cityTransports,
      previousCityId = _getCityTransportsByG.previousCityId;

  var _getTransportClassesB = getTransportClassesByGroupName(hasFlight, hasTrain),
      transportClasses = _getTransportClassesB.transportClasses;

  Object(react["useEffect"])(function () {
    if (previousCityId !== (flightDeparture === null || flightDeparture === void 0 ? void 0 : flightDeparture.cityId)) {
      dispatch(Object(transportStations_action["b" /* fetchTransportStations */])(flightDeparture === null || flightDeparture === void 0 ? void 0 : flightDeparture.cityId, appContext));
    }
  }, []);
  return AdditionalTransportAdvancedSearchFormFields_jsx("div", {
    className: "block",
    "data-testid": "AdditionalTransportAdvancedSearchFormFields"
  }, AdditionalTransportAdvancedSearchFormFields_jsx("div", {
    className: "flex items-center justify-between py-10"
  }, AdditionalTransportAdvancedSearchFormFields_jsx("span", {
    className: "block leading-1"
  }, Object(src_i18n["h" /* t */])('booking.transport.criteria.directFlights')), AdditionalTransportAdvancedSearchFormFields_jsx(InputSwitch["a" /* InputSwitch */], {
    isChecked: values.directFlights,
    value: values.directFlights,
    onChange: function onChange(name, isChecked) {
      return setFieldValue('directFlights', isChecked);
    },
    isSwitch: true,
    name: "directFlights",
    inputTestId: "directFlights"
  })), AdditionalTransportAdvancedSearchFormFields_jsx("div", {
    className: "w-full py-10"
  }, AdditionalTransportAdvancedSearchFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "capitalize",
    dataTestId: "departure",
    label: Object(src_i18n["h" /* t */])('booking.transport.criteria.departure'),
    name: "departure",
    options: cityTransports,
    withOptionGroup: true,
    type: "select"
  })), AdditionalTransportAdvancedSearchFormFields_jsx("div", {
    className: "w-full py-10"
  }, AdditionalTransportAdvancedSearchFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "flightClass",
    label: Object(src_i18n["h" /* t */])('booking.transport.criteria.class'),
    name: "flightClass",
    options: transportClasses,
    withOptionGroup: true,
    type: "select"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-search/AdditionalTransportAdvancedSearchForm.jsx











var AdditionalTransportAdvancedSearchForm_jsx = react_default.a.createElement;

function AdditionalTransportAdvancedSearchForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AdditionalTransportAdvancedSearchForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AdditionalTransportAdvancedSearchForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AdditionalTransportAdvancedSearchForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var getTripCriteria = function getTripCriteria(_ref) {
  var _proposal$transports, _proposal$transports$, _inboundTravelSection;

  var proposal = _ref.proposal;
  var inboundTravelSection = (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : (_proposal$transports$ = _proposal$transports.inbound) === null || _proposal$transports$ === void 0 ? void 0 : _proposal$transports$.travelSections[0];
  return {
    departure: inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : (_inboundTravelSection = inboundTravelSection.departure) === null || _inboundTravelSection === void 0 ? void 0 : _inboundTravelSection.cityId,
    directFlights: false,
    flightClass: inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : inboundTravelSection.transport.class
  };
};

var AdditionalTransportAdvancedSearchForm_AdditionalTransportAdvancedSearchForm = function AdditionalTransportAdvancedSearchForm(_ref2) {
  var proposal = _ref2.proposal;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var departureCity = router.query.departure_city;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var handleSubmit = function handleSubmit(_ref3) {
    var directFlights = _ref3.directFlights,
        flightClass = _ref3.flightClass,
        departure = _ref3.departure;
    var formattedTransportSearchCriteria = Object(proposals_action["o" /* getTransportSearchCriteria */])({
      proposal: proposal,
      departureCity: departureCity
    });
    var inbound = formattedTransportSearchCriteria.journeys[0];
    var outbound = formattedTransportSearchCriteria.journeys[1];
    var firstTravelSection = inbound === null || inbound === void 0 ? void 0 : inbound.travelSections[0];
    var otherTravelSections = (inbound === null || inbound === void 0 ? void 0 : inbound.travelSections.slice(1)) || [];
    var enrichedTravelSections = [AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, firstTravelSection), {}, {
      departure: AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, firstTravelSection.departure), {}, {
        location: AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, firstTravelSection.departure.location), {}, {
          id: departure
        })
      })
    })].concat(Object(toConsumableArray["a" /* default */])(otherTravelSections));

    var enrichedInbound = AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, inbound), {}, {
      travelSections: enrichedTravelSections
    });

    var transportSearchCriteria = AdditionalTransportAdvancedSearchForm_objectSpread(AdditionalTransportAdvancedSearchForm_objectSpread({}, formattedTransportSearchCriteria), {}, {
      journeys: [enrichedInbound, outbound],
      transportClass: flightClass,
      isDirectFlightOnly: directFlights,
      maxConnections: directFlights ? 0 : undefined
    });

    dispatch(Object(additionalTransports_action["b" /* fetchAdditionalTransports */])({
      proposal: proposal,
      transportSearchCriteria: transportSearchCriteria,
      appContext: appContext
    }));
  };

  return AdditionalTransportAdvancedSearchForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: getTripCriteria({
      proposal: proposal
    }),
    onSubmit: handleSubmit
  }, function (_ref4) {
    var isValid = _ref4.isValid;
    return AdditionalTransportAdvancedSearchForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "AdditionalTransportAdvancedSearchForm"
    }, AdditionalTransportAdvancedSearchForm_jsx(AdditionalTransportAdvancedSearchFormFields_AdditionalTransportAdvancedSearchFormFields, {
      proposal: proposal
    }), AdditionalTransportAdvancedSearchForm_jsx("div", {
      className: "mt-20 flex items-center justify-start"
    }, AdditionalTransportAdvancedSearchForm_jsx(Button["a" /* Button */], {
      colorBg: colors["a" /* COLORS */].BLACK,
      colorBorder: colors["a" /* COLORS */].BLACK,
      color: colors["a" /* COLORS */].WHITE,
      "data-testid": "event-submit",
      isDisabled: !isValid,
      onClick: function onClick() {
        return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
          detail_click: 'flight_advanced_search'
        });
      },
      type: "submit"
    }, Object(src_i18n["h" /* t */])('remote.searchAction'))));
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilterWithButtons.jsx





var AdditionalTransportFilterWithButtons_jsx = react_default.a.createElement;






var filterType = {
  stopovers: 'stop_number',
  companies: 'flight_company',
  connectingCities: 'connecting_flight_city'
};

var AdditionalTransportFilterWithButtons_getStopoverLabel = function getStopoverLabel(stopovers) {
  switch (stopovers) {
    case '0':
      return Object(src_i18n["h" /* t */])('filters.layovers.direct');

    case '1':
      return "".concat(stopovers, " ").concat(Object(src_i18n["h" /* t */])('filters.layovers.stop.label_1'));

    default:
      return "".concat(stopovers, " ").concat(Object(src_i18n["h" /* t */])('filters.layovers.stop.label_n'));
  }
};

var AdditionalTransportFilterWithButtons_FilterWithButtons = function FilterWithButtons(_ref) {
  var type = _ref.type,
      filter = _ref.filter,
      withLength = _ref.withLength,
      updateFilters = _ref.updateFilters;
  var label = type === 'stopovers' ? AdditionalTransportFilterWithButtons_getStopoverLabel(filter.value) : filter.label;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportFilterWithButtons_jsx("div", {
    className: "mb-10"
  }, AdditionalTransportFilterWithButtons_jsx(AdditionalTransportFilterButton_AdditionalTransportFilterButton, {
    label: "".concat(label, " ").concat(withLength ? "(".concat(filter.flightIdList.length, ")") : ''),
    isSelected: filter.isSelected,
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: "filter_".concat(filterType[type])
      });
      updateFilters(type, filter.value);
    }
  }));
};

var AdditionalTransportFilterWithButtons_AdditionalTransportFilterWithButtons = function AdditionalTransportFilterWithButtons(_ref2) {
  var type = _ref2.type,
      updateFilters = _ref2.updateFilters,
      filters = _ref2.filters,
      withLength = _ref2.withLength;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      toggleMoreFilters = _React$useState2[0],
      setToggleMoreFilters = _React$useState2[1];

  return AdditionalTransportFilterWithButtons_jsx("div", {
    "data-testid": "AdditionalTransportFilterWithButtons",
    className: "block"
  }, AdditionalTransportFilterWithButtons_jsx("div", {
    className: "block"
  }, filters.slice(0, 3).map(function (filter) {
    return AdditionalTransportFilterWithButtons_jsx(AdditionalTransportFilterWithButtons_FilterWithButtons, {
      type: type,
      key: "filter-".concat(filter.value),
      filter: filter,
      withLength: withLength,
      updateFilters: updateFilters
    });
  }), AdditionalTransportFilterWithButtons_jsx(lib["UnmountClosed"], {
    isOpened: toggleMoreFilters
  }, filters.slice(3).map(function (filter) {
    return AdditionalTransportFilterWithButtons_jsx(AdditionalTransportFilterWithButtons_FilterWithButtons, {
      type: type,
      key: "filter-".concat(filter.value),
      filter: filter,
      withLength: withLength,
      updateFilters: updateFilters
    });
  }))), filters.length > 3 && AdditionalTransportFilterWithButtons_jsx("button", {
    type: "button",
    onClick: function onClick() {
      return setToggleMoreFilters(!toggleMoreFilters);
    },
    className: "text-16 font-semibold underline cursor-pointer"
  }, toggleMoreFilters ? Object(src_i18n["h" /* t */])('common.loadLess') : Object(src_i18n["h" /* t */])('common.loadMore')));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-slider/dist/cjs/index.js
var cjs = __webpack_require__("Z2QO");
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/ArrivalDepartureRangeFilter.jsx



var ArrivalDepartureRangeFilter_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */









/**
 * LOCAL COMPONENT RENDERERS
 */
// render the slider track

var ArrivalDepartureRangeFilter_renderTrack = function renderTrack(props, state) {
  var bgClass;

  switch (state.index) {
    case 0:
      bgClass = 'bg-lightGrey';
      break;

    case 1:
      bgClass = 'bg-saffron';
      break;

    default:
      bgClass = 'bg-lightGrey';
      break;
  }

  return ArrivalDepartureRangeFilter_jsx("div", Object(esm_extends["a" /* default */])({}, props, {
    className: 'example-track h-4 ' + bgClass
  }));
};
/**
 * END LOCAL COMPONENT RENDERERS
 */


var ArrivalDepartureRangeFilter_ArrivalDepartureRangeFilter = function ArrivalDepartureRangeFilter(_ref) {
  var _selectedRange$start, _selectedRange$end;

  var startTime = _ref.startTime,
      endTime = _ref.endTime,
      setRange = _ref.setRange,
      selectedRange = _ref.selectedRange,
      _ref$showSelectedTime = _ref.showSelectedTimeUnderSlider,
      showSelectedTimeUnderSlider = _ref$showSelectedTime === void 0 ? true : _ref$showSelectedTime;

  var _getRangeTimeGraduati = getRangeTimeGraduations({
    startTime: startTime,
    endTime: endTime
  }),
      graduations = _getRangeTimeGraduati.graduations,
      stepsNumber = _getRangeTimeGraduati.stepsNumber;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent; // thumb component : min max visual component


  var renderThumb = function renderThumb(props, state) {
    var graduationIndex = state.valueNow === 0 ? 0 : state.valueNow - 1;
    var selectedTime = graduations[graduationIndex];
    return ArrivalDepartureRangeFilter_jsx("div", Object(esm_extends["a" /* default */])({
      "data-testid": "ArrivalDepartureRangeFilter-thumb"
    }, props), ArrivalDepartureRangeFilter_jsx("div", {
      "data-testid": "ArrivalDepartureRangeFilter-thumbIncon",
      className: "h-24 w-24 rounded-2 border-1 items-center justify-center flex bg-white"
    }, ArrivalDepartureRangeFilter_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].PAUSE,
      width: ".5rem"
    })), !showSelectedTimeUnderSlider && ArrivalDepartureRangeFilter_jsx("div", {
      "data-testid": "ArrivalDepartureRangeFilter-timeUnderThumb",
      className: "absolute text-center w-full"
    }, ArrivalDepartureRangeFilter_jsx("span", {
      className: "font-bold text-10 "
    }, selectedTime)));
  }; // on change handler


  var handleChangeSliderValues = function handleChangeSliderValues(values) {
    var _values = Object(slicedToArray["a" /* default */])(values, 2),
        start = _values[0],
        end = _values[1];

    var _ref2 = [graduations[start - 1], graduations[end - 1]],
        startedAt = _ref2[0],
        endedAt = _ref2[1]; // transform to moment date

    var startedAtMoment = moment_default()(startedAt, 'HH[h]mm');
    var endedAtMoment = moment_default()(endedAt, 'HH[h]mm'); // set the selected Range to the parent component

    setRange && setRange({
      start: startedAtMoment,
      end: endedAtMoment
    });
  }; // on change handler


  var getValueFromRange = function getValueFromRange(range) {
    var start = range.start.format('HH[h]');
    var timeFormat = range.end.minutes() === MAX_MINUTES_IN_CURRENT_HOUR ? 'HH[h]mm' : 'HH[h]';
    var end = range.end.format(timeFormat);
    return [graduations.indexOf(start) + 1, graduations.indexOf(end) + 1];
  };

  return ArrivalDepartureRangeFilter_jsx("div", null, ArrivalDepartureRangeFilter_jsx("div", {
    "data-testid": "ArrivalDepartureRangeFilter-departureDate"
  }, ArrivalDepartureRangeFilter_jsx("span", {
    className: "text-14 font-bold"
  }, Object(src_i18n["h" /* t */])('booking.transport.departureNextDay'))), ArrivalDepartureRangeFilter_jsx(cjs_default.a, {
    className: "horizontal-slider relative w-full h-16 py-30 flex items-center",
    trackClassName: "bg-gray-200",
    min: 1,
    max: stepsNumber,
    defaultValue: [0, stepsNumber],
    renderThumb: renderThumb,
    renderTrack: ArrivalDepartureRangeFilter_renderTrack,
    onChange: handleChangeSliderValues,
    onAfterChange: function onAfterChange() {
      return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'filter_schedule'
      });
    },
    value: getValueFromRange(selectedRange),
    minDistance: 1
  }), showSelectedTimeUnderSlider && ArrivalDepartureRangeFilter_jsx("div", {
    className: "flex justify-between",
    "data-testid": "ArrivalDepartureRangeFilter-timeUnderSlider"
  }, ArrivalDepartureRangeFilter_jsx("div", {
    "data-testid": "ArrivalDepartureRangeFilter-minRange",
    className: ""
  }, ArrivalDepartureRangeFilter_jsx("span", {
    className: "font-bold text-14"
  }, (_selectedRange$start = selectedRange.start) === null || _selectedRange$start === void 0 ? void 0 : _selectedRange$start.format('HH[h]mm'))), ArrivalDepartureRangeFilter_jsx("div", {
    "data-testid": "ArrivalDepartureRangeFilter-maxRange",
    className: ""
  }, ArrivalDepartureRangeFilter_jsx("span", {
    className: "font-bold text-14"
  }, (_selectedRange$end = selectedRange.end) === null || _selectedRange$end === void 0 ? void 0 : _selectedRange$end.format('HH[h]mm')))));
};
// EXTERNAL MODULE: ./src/hooks/use-feature-flip/useFeatureFlip.js
var useFeatureFlip = __webpack_require__("xu+1");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFilters.jsx

var AdditionalTransportFilters_jsx = react_default.a.createElement;










var AdditionalTransportFilters_AdditionalTransportFilters = function AdditionalTransportFilters(_ref) {
  var hasNoAlternativeTransport = _ref.hasNoAlternativeTransport,
      hasOnlyTrain = _ref.hasOnlyTrain,
      proposal = _ref.proposal,
      state = _ref.state,
      updateFilters = _ref.updateFilters,
      resetFilters = _ref.resetFilters;
  var stopovers = state.stopovers,
      connectingCities = state.connectingCities,
      durationRanges = state.durationRanges,
      companies = state.companies,
      defaultInboundDepartureTimeRange = state.defaultInboundDepartureTimeRange,
      defaultOutboundDepartureTimeRange = state.defaultOutboundDepartureTimeRange,
      inboundDepartureTimeRange = state.inboundDepartureTimeRange,
      outboundDepartureTimeRange = state.outboundDepartureTimeRange;
  var openFilterDefault = !(hasNoAlternativeTransport || hasOnlyTrain);
  var isAdvancedSearchOpened = Object(useFeatureFlip["a" /* useFeatureFlip */])('booking.transport.advancedSearchOpened');
  return AdditionalTransportFilters_jsx("div", {
    "data-testid": "AdditionalTransportFilters",
    className: "px-20 py-30"
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: hasNoAlternativeTransport && !hasOnlyTrain || isAdvancedSearchOpened,
    title: Object(src_i18n["h" /* t */])('booking.transport.criteria.advancedSearch')
  }, AdditionalTransportFilters_jsx(AdditionalTransportAdvancedSearchForm_AdditionalTransportAdvancedSearchForm, {
    proposal: proposal
  })), AdditionalTransportFilters_jsx(AdditionalTransportFiltersHeader_AdditionalTransportFiltersHeader, {
    state: state,
    resetFilters: resetFilters
  }), AdditionalTransportFilters_jsx(Hr["a" /* Hr */], {
    className: "my-20"
  }), AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.layovers.categoryTitle')
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilterWithButtons_AdditionalTransportFilterWithButtons, {
    type: "stopovers",
    filters: stopovers.filter(function (stopover) {
      return stopover.flightIdList.length > 0;
    }),
    updateFilters: updateFilters,
    withLength: true
  })), AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.companiesCategoryTitle')
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilterWithButtons_AdditionalTransportFilterWithButtons, {
    type: "companies",
    filters: companies,
    updateFilters: updateFilters,
    withLength: true
  })), connectingCities.length > 0 && AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.layovers.stop.connectionCities')
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilterWithButtons_AdditionalTransportFilterWithButtons, {
    type: "connectingCities",
    filters: connectingCities,
    updateFilters: updateFilters,
    withLength: true
  })), AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.departureArrival.times')
  }, defaultInboundDepartureTimeRange && AdditionalTransportFilters_jsx("div", {
    className: "mb-20"
  }, AdditionalTransportFilters_jsx("span", {
    className: "text-16 font-semibold"
  }, Object(src_i18n["h" /* t */])('booking.transport.inbound')), AdditionalTransportFilters_jsx(ArrivalDepartureRangeFilter_ArrivalDepartureRangeFilter, {
    startTime: defaultInboundDepartureTimeRange.start,
    endTime: defaultInboundDepartureTimeRange.end,
    setRange: function setRange(value) {
      return updateFilters('inboundDepartureTimeRange', value);
    },
    selectedRange: inboundDepartureTimeRange
  })), defaultOutboundDepartureTimeRange && AdditionalTransportFilters_jsx("div", null, AdditionalTransportFilters_jsx("span", {
    className: "text-16 font-semibold"
  }, Object(src_i18n["h" /* t */])('booking.transport.outbound')), AdditionalTransportFilters_jsx(ArrivalDepartureRangeFilter_ArrivalDepartureRangeFilter, {
    startTime: defaultOutboundDepartureTimeRange.start,
    endTime: defaultOutboundDepartureTimeRange.end,
    setRange: function setRange(value) {
      return updateFilters('outboundDepartureTimeRange', value);
    },
    selectedRange: outboundDepartureTimeRange
  }))), AdditionalTransportFilters_jsx(AdditionalTransportFilter_AdditionalTransportFilter, {
    isOpen: openFilterDefault,
    title: Object(src_i18n["h" /* t */])('filters.flightDurationTitle')
  }, AdditionalTransportFilters_jsx(AdditionalTransportFilterDurationRange_AdditionalTransportFilterDurationRange, {
    durationRanges: durationRanges.filter(function (range) {
      return range.flightIdList.length > 0;
    }),
    updateFilters: updateFilters
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-filters/AdditionalTransportFiltersLayer.jsx
var AdditionalTransportFiltersLayer_jsx = react_default.a.createElement;







var AdditionalTransportFiltersLayer_AdditionalTransportFiltersLayer = function AdditionalTransportFiltersLayer(_ref) {
  var hasNoAlternativeTransport = _ref.hasNoAlternativeTransport,
      hasOnlyTrain = _ref.hasOnlyTrain,
      proposal = _ref.proposal,
      onClose = _ref.onClose,
      state = _ref.state,
      updateFilters = _ref.updateFilters,
      resetFilters = _ref.resetFilters;
  var layerRef = Object(react["useRef"])(null);
  var layerTitle = Object(src_i18n["h" /* t */])('faceting.filters.filtersButton');
  return AdditionalTransportFiltersLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerTitle,
    ariaLabelledby: "testId",
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: onClose
    },
    header: AdditionalTransportFiltersLayer_jsx(LayerHeaderProposal_LayerHeaderProposal, {
      id: identifiers_constants["c" /* ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE */],
      layerTitle: layerTitle,
      proposal: proposal,
      totalPrice: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.totalPrice')
    }),
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: onClose,
    ref: layerRef,
    dataTestId: "AdditionalTransportLayer"
  }, AdditionalTransportFiltersLayer_jsx(AdditionalTransportFilters_AdditionalTransportFilters, {
    hasNoAlternativeTransport: hasNoAlternativeTransport,
    hasOnlyTrain: hasOnlyTrain,
    state: state,
    updateFilters: updateFilters,
    resetFilters: resetFilters,
    proposal: proposal
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportComplexFlights.jsx
var AdditionalTransportComplexFlights_jsx = react_default.a.createElement;





var AdditionalTransportComplexFlights_AdditionalTransportComplexFlights = function AdditionalTransportComplexFlights(_ref) {
  var proposalId = _ref.proposalId;
  var phoneNumber = Object(src_i18n["h" /* t */])('travelAdvisor.phoneNumber'); // One space is because phone number can not be empty

  var hasPhoneNumber = phoneNumber && phoneNumber !== ' ';
  return AdditionalTransportComplexFlights_jsx("div", {
    "data-testid": "AdditionalTransportComplexFlights",
    className: "h-full rounded-12 border-1 border-lightGrey bg-white p-20"
  }, AdditionalTransportComplexFlights_jsx("div", {
    className: "flex items-start gap-20"
  }, AdditionalTransportComplexFlights_jsx(Badge["a" /* Badge */], {
    className: "size-48 border-lightSand bg-lightSand text-black",
    iconName: icons["a" /* ICONS */].TAKE_OFF
  }), AdditionalTransportComplexFlights_jsx("div", {
    className: "text-start text-16"
  }, AdditionalTransportComplexFlights_jsx("p", {
    className: "font-semibold leading-normal"
  }, Object(src_i18n["h" /* t */])('booking.transport.trip.title')), AdditionalTransportComplexFlights_jsx("p", {
    className: "mt-8 leading-normal"
  }, Object(src_i18n["h" /* t */])('booking.transport.trip.information')), AdditionalTransportComplexFlights_jsx("div", {
    className: "flex items-center leading-normal"
  }, AdditionalTransportComplexFlights_jsx("p", null, Object(src_i18n["h" /* t */])('booking.transport.trip.referenceNumberInformation')), "\xA0", AdditionalTransportComplexFlights_jsx("p", {
    className: "font-semibold"
  }, proposalId)), hasPhoneNumber && AdditionalTransportComplexFlights_jsx("a", {
    href: "tel:".concat(phoneNumber),
    className: "mt-8 flex w-fit cursor-pointer items-center"
  }, AdditionalTransportComplexFlights_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PHONE,
    width: "24px"
  }), "\xA0", AdditionalTransportComplexFlights_jsx("p", {
    className: "font-semibold"
  }, phoneNumber)))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/additional-transports-list/AdditionalTransportListHeader.jsx
var AdditionalTransportListHeader_jsx = react_default.a.createElement;








var AdditionalTransportListHeader_AdditionalTransportListHeader = function AdditionalTransportListHeader(_ref) {
  var proposalId = _ref.proposalId,
      totalTransports = _ref.totalTransports,
      onOpenLayer = _ref.onOpenLayer;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return AdditionalTransportListHeader_jsx("div", {
    "data-testid": "AdditionalTransportListHeader",
    className: "bg-white px-15 py-20 sm:px-60"
  }, AdditionalTransportListHeader_jsx(AdditionalTransportComplexFlights_AdditionalTransportComplexFlights, {
    proposalId: proposalId
  }), AdditionalTransportListHeader_jsx("br", null), AdditionalTransportListHeader_jsx("span", {
    className: "flex w-full justify-start font-brand text-24 font-semibold sm:text-28"
  }, Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.others', {
    count: totalTransports
  })), AdditionalTransportListHeader_jsx(Button["a" /* Button */], {
    className: "mt-15 block min-w-auto text-16 font-semibold md:hidden",
    color: colors["a" /* COLORS */].BLACK,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].BLACK,
    iconRight: {
      name: icons["a" /* ICONS */].FILTERS
    },
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'advanced_filter_mobile'
      });
      onOpenLayer();
    }
  }, Object(src_i18n["h" /* t */])('faceting.filters.filtersButton')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransports.jsx

var AdditionalTransports_jsx = react_default.a.createElement;

















var AdditionalTransports_AdditionalTransports = function AdditionalTransports(_ref) {
  var proposal = _ref.proposal,
      setSelectedTransport = _ref.setSelectedTransport;

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["e" /* getAdditionalTransports */]),
      alternativeTransports = _useSelector.alternativeTransports;

  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isOpen = _useDisclosure.isOpen,
      onClose = _useDisclosure.onClose,
      onOpen = _useDisclosure.onOpen;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useTransportFilters = useTransportFilters_useTransportFilters(alternativeTransports),
      state = _useTransportFilters.state,
      updateFilters = _useTransportFilters.updateFilters,
      resetFilters = _useTransportFilters.resetFilters;

  var filteredTransports = state.filteredTransports;
  var hasNoAlternativeTransport = alternativeTransports.length === 0;
  var hasOnlyTrain = alternativeTransports.every(function (transport) {
    return Object(transport_details_transportUtils["o" /* isTransportTrain */])(transport.inbound, transport.outbound);
  });
  return AdditionalTransports_jsx("div", {
    "data-testid": "AdditionalTransports",
    className: "flex h-auto min-h-full bg-white"
  }, AdditionalTransports_jsx("div", {
    className: "hidden w-1/4 border-r-1 border-lightGrey md:block"
  }, AdditionalTransports_jsx(AdditionalTransportFilters_AdditionalTransportFilters, {
    hasNoAlternativeTransport: hasNoAlternativeTransport,
    hasOnlyTrain: hasOnlyTrain,
    updateFilters: updateFilters,
    resetFilters: resetFilters,
    state: state,
    proposal: proposal
  })), AdditionalTransports_jsx("div", {
    className: "block w-full bg-pearl"
  }, filteredTransports.length === 0 ? AdditionalTransports_jsx("div", null, AdditionalTransports_jsx("div", {
    className: "px-60 py-20"
  }, AdditionalTransports_jsx(Button["a" /* Button */], {
    className: "mb-20 block min-w-auto text-16 font-semibold md:hidden",
    color: colors["a" /* COLORS */].BLACK,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].BLACK,
    iconRight: {
      name: icons["a" /* ICONS */].FILTERS
    },
    onClick: function onClick() {
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'advanced_filter_mobile'
      });
      onOpen();
    }
  }, Object(src_i18n["h" /* t */])('faceting.filters.filtersButton')), AdditionalTransports_jsx(Confirmation["a" /* Confirmation */], {
    icon: icons["a" /* ICONS */].CIRCLED_PLANE,
    status: "neutral",
    text: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.noAdditionalTransportAvailableDescription'),
    title: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.noAdditionalTransportAvailableTitle')
  }))) : AdditionalTransports_jsx(react_default.a.Fragment, null, AdditionalTransports_jsx(AdditionalTransportListHeader_AdditionalTransportListHeader, {
    proposalId: proposal.id,
    totalTransports: filteredTransports.length,
    onOpenLayer: onOpen
  }), AdditionalTransports_jsx(AdditionalTransportsList_AdditionalTransportsList, {
    proposal: proposal,
    setSelectedTransport: setSelectedTransport,
    alternativeTransports: filteredTransports
  }))), isOpen && AdditionalTransports_jsx(AdditionalTransportFiltersLayer_AdditionalTransportFiltersLayer, {
    hasNoAlternativeTransport: hasNoAlternativeTransport,
    hasOnlyTrain: hasOnlyTrain,
    updateFilters: updateFilters,
    resetFilters: resetFilters,
    state: state,
    proposal: proposal,
    onClose: onClose
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransportsWrapper.jsx


var AdditionalTransportsWrapper_jsx = react_default.a.createElement;











var TRANSPORT_COMPANIES_LOGOS = [{
  url: 'https://ns.clubmed.com/it/2018/be/transport/airfrance.png',
  alt: 'Air France'
}, {
  url: 'https://ns.clubmed.com/it/2018/be/transport/flyemirates.png',
  alt: 'Fly Emirates'
}, {
  url: 'https://ns.clubmed.com/it/2018/be/transport/aircaraibes.png',
  alt: 'Air Caraïbes'
}, {
  alt: 'Singapore Airlines',
  url: 'https://ns.clubmed.com/it/2018/be/transport/singaporeairlines.png'
}, {
  url: 'https://ns.clubmed.com/it/2018/be/transport/qatarairways.png',
  alt: 'Qatar Airways'
}]; // hardcoded for now, there wasn't a compelling enough argument why this should be dynamic

var AdditionalTransportsWrapper_AdditionalTransportsWrapper = function AdditionalTransportsWrapper(_ref) {
  var proposal = _ref.proposal,
      setSelectedTransport = _ref.setSelectedTransport;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var error = Object(es["e" /* useSelector */])(booking_selector["f" /* getAdditionalTransportsError */]);
  var isLoading = Object(es["e" /* useSelector */])(booking_selector["q" /* getIsLoadingAdditionalTransports */]);
  return AdditionalTransportsWrapper_jsx("div", {
    "data-testid": "AdditionalTransportsWrapper",
    className: "relative z-1 h-full"
  }, isLoading && AdditionalTransportsWrapper_jsx(react["Fragment"], null, AdditionalTransportsWrapper_jsx(AsyncLoader["a" /* AsyncLoader */], {
    className: "mt-[18vh]",
    icon: icons["a" /* ICONS */].STANDALONE_MAGNIFYING_GLASS,
    iconSize: "3rem",
    label: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.loaderLabel'),
    theme: "labeled"
  }), AdditionalTransportsWrapper_jsx("div", {
    className: "m-auto mt-30 w-200"
  }, AdditionalTransportsWrapper_jsx(SliderHandler["a" /* SliderHandler */], {
    hasAutoplay: true,
    hasInfiniteScroll: true,
    hasLazyload: true,
    items: TRANSPORT_COMPANIES_LOGOS.map(function (medium) {
      return AdditionalTransportsWrapper_jsx("img", {
        alt: medium.alt,
        className: "w-full",
        key: medium.url,
        src: medium.url
      });
    })
  }, function (_ref2) {
    var itemsNode = _ref2.itemsNode;
    return itemsNode;
  }))), !isLoading && isEmpty_default()(error) && AdditionalTransportsWrapper_jsx(AdditionalTransports_AdditionalTransports, {
    proposal: proposal,
    setSelectedTransport: setSelectedTransport
  }), !isLoading && !isEmpty_default()(error) && AdditionalTransportsWrapper_jsx(SiteContainer["a" /* SiteContainer */], null, AdditionalTransportsWrapper_jsx(Confirmation["a" /* Confirmation */], {
    status: "error",
    text: Object(src_i18n["h" /* t */])("booking.".concat(appContext.isCmta ? 'partners' : 'common.layer', ".unknownErrorDescription")),
    title: Object(src_i18n["h" /* t */])('booking.common.layer.unknownErrorTitle')
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransportLayer.jsx
var AdditionalTransportLayer_jsx = react_default.a.createElement;











var AdditionalTransportLayer_AdditionalTransportLayer = function AdditionalTransportLayer(_ref) {
  var onClose = _ref.onClose,
      proposal = _ref.proposal,
      setSelectedTransport = _ref.setSelectedTransport,
      errorTitle = _ref.errorTitle;
  var layerRef = Object(react["useRef"])(null);
  var layerTitle = Object(src_i18n["h" /* t */])('booking.transport.alternativeSelection');
  var isLoading = Object(es["e" /* useSelector */])(booking_selector["q" /* getIsLoadingAdditionalTransports */]);
  return AdditionalTransportLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerTitle,
    ariaLabelledby: identifiers_constants["b" /* ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: onClose
    },
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    header: AdditionalTransportLayer_jsx(LayerHeaderProposal_LayerHeaderProposal, {
      id: identifiers_constants["b" /* ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP */],
      layerTitle: layerTitle,
      proposal: proposal,
      totalPrice: Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.totalPrice')
    }),
    onClose: onClose,
    ref: layerRef,
    dataTestId: "AdditionalTransportLayer"
  }, AdditionalTransportLayer_jsx(AdditionalTransportLayerIcons_AdditionalTransportLayerIcons, null), !!errorTitle && !isLoading && AdditionalTransportLayer_jsx(Title["a" /* Title */], {
    className: "mx-25 mt-30",
    theme: "title-sans-n4"
  }, errorTitle), AdditionalTransportLayer_jsx(AdditionalTransportsWrapper_AdditionalTransportsWrapper, {
    proposal: proposal,
    setSelectedTransport: setSelectedTransport
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/more-transports/MoreTransports.jsx








var MoreTransports_jsx = react_default.a.createElement;

function MoreTransports_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MoreTransports_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MoreTransports_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MoreTransports_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * * More transports modal [find transport page]
 */












var MoreTransports_MoreTransports = function MoreTransports(_ref) {
  var proposal = _ref.proposal,
      _onClose = _ref.onClose,
      _ref$setSelectedTrans = _ref.setSelectedTransport,
      setSelectedTransport = _ref$setSelectedTrans === void 0 ? function (transportId) {
    return _onClose(true, transportId);
  } : _ref$setSelectedTrans;
  var beEngineTrackingContext = Object(react["useContext"])(BookingEngineTrackingContext["a" /* BookingEngineTrackingContext */]);
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var error = Object(es["e" /* useSelector */])(booking_selector["f" /* getAdditionalTransportsError */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var departureCity = router.query.departure_city;
  Object(react["useEffect"])(function () {
    if (proposal.transports) {
      var transportSearchCriteria = Object(proposals_action["o" /* getTransportSearchCriteria */])({
        proposal: proposal,
        departureCity: departureCity
      });
      dispatch(Object(additionalTransports_action["b" /* fetchAdditionalTransports */])({
        proposal: proposal,
        transportSearchCriteria: transportSearchCriteria,
        appContext: appContext
      }));
    }
  }, [proposal.id]);
  var errorTitle = error ? Object(src_i18n["h" /* t */])('booking.transport.additionalTransports.unknownErrorHeaderTitle') : undefined;
  return MoreTransports_jsx(react_default.a.Fragment, null, MoreTransports_jsx(TrackPage["a" /* TrackPage */], {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */].BE_LAYER_TRANSPORT,
    payload: MoreTransports_objectSpread({}, beEngineTrackingContext)
  }), MoreTransports_jsx(AdditionalTransportLayer_AdditionalTransportLayer, {
    onClose: function onClose(proposalId) {
      return _onClose(false, proposalId);
    },
    setSelectedTransport: setSelectedTransport,
    proposal: proposal,
    errorTitle: errorTitle
  }));
};
// EXTERNAL MODULE: ./src/client/views/booking/transport/TransferBulletPoints.jsx
var TransferBulletPoints = __webpack_require__("mYZO");

// CONCATENATED MODULE: ./src/client/views/booking/transport/TransportsSection.jsx


var TransportsSection_jsx = react_default.a.createElement;

/**
 * * Booking search transport page [find transport page]
 * * using fetchProposalsById method to get proposals[0].transports (inbound & outbound)
 */













var PRODUCT_TYPE = {
  CRUISE: 'CRUISE'
};
var TransportsSection_TransportsSection = function TransportsSection(_ref) {
  var _transports$inbound;

  var i18n = _ref.i18n,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      onMoreTransportsClick = _ref.onMoreTransportsClick,
      closeLayer = _ref.closeLayer,
      shouldShowLayer = _ref.shouldShowLayer;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();

  var _ref2 = selectedProposal || {},
      transports = _ref2.transports;

  var isTransportRecommended = Object(proposalUtils["w" /* isRecommendedTransport */])(transports, selectedProposal.id);

  var handleAddTransport = function handleAddTransport(transportId) {
    var transportI18n = i18n.booking.transport;
    Promise.resolve(closeLayer(true, selectedProposal.id)).then(function () {
      if (transportId === selectedProposal.id) {
        // no need to call the addTransportMutation because the recommended flight is selected by default
        setTimeout(function () {
          return dispatch(Object(toast_actions["d" /* openToast */])(transportI18n.newTransportSelection));
        }, 1000);
      } else {
        dispatch(Object(proposals_action["r" /* putTransportAndDispatchProposals */])(transportId, Object(BookingEngine_utils["b" /* getAllProposalsIdWithAlternative */])(selectedProposal), resort.isJoyview, resort.isUrbanOasis, appContext, transportI18n.additionalTransports.loaderLabelUpdate, transportI18n.newTransportSelection));
      }
    });
  };

  var isPlane = Object(transport_details_transportUtils["n" /* hasOnlyPlanes */])(transports === null || transports === void 0 ? void 0 : (_transports$inbound = transports.inbound) === null || _transports$inbound === void 0 ? void 0 : _transports$inbound.travelSections);
  return TransportsSection_jsx(react["Fragment"], null, TransportsSection_jsx(OverlaidActionProvider_OverlaidActionProvider, {
    label: Object(src_i18n["h" /* t */])('booking.transport.headlineCTA'),
    button: {
      label: Object(src_i18n["h" /* t */])(isPlane ? 'booking.transport.additionalTransports.otherProposals' : 'booking.otherTransport'),
      onClick: onMoreTransportsClick
    }
  }, TransportsSection_jsx("div", {
    className: "TransportsView-context mt-20"
  }, TransportsSection_jsx(BeTransportDetails["a" /* BeTransportDetails */], {
    transport: selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.transports,
    isTransportRecommended: isTransportRecommended
  }), TransportsSection_jsx("div", {
    className: "mt-20"
  }, TransportsSection_jsx(TransferBulletPoints["a" /* TransferBulletPoints */], {
    title: "common.transport.transfer.information",
    bulletPoints: ['common.transport.transfer.cancellationReinsurance', 'common.transport.transfer.tripTogether', 'common.transport.transfer.arrivalPickup', 'common.transport.transfer.luggage']
  })))), shouldShowLayer && TransportsSection_jsx(MoreTransports_MoreTransports, {
    proposal: selectedProposal,
    onClose: closeLayer,
    setSelectedTransport: handleAddTransport
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/package/transfers-section/TransfersSection.jsx + 3 modules
var TransfersSection = __webpack_require__("ptRt");

// CONCATENATED MODULE: ./src/client/views/booking/transport/TransferInDetails.jsx


var TransferInDetails_jsx = react_default.a.createElement;


var TransferInDetails_TransferInDetails = function TransferInDetails(_ref) {
  var iconName = _ref.iconName,
      description = _ref.description,
      detail = _ref.detail;
  return TransferInDetails_jsx("div", {
    "data-testid": "TransferInDetails",
    className: "h-full bg-white"
  }, TransferInDetails_jsx("div", {
    "data-testid": "TransferInDetails-icon",
    className: "flex items-start gap-20"
  }, TransferInDetails_jsx(Badge["a" /* Badge */], {
    className: "size-48 border-lightSand bg-lightSand text-black",
    iconName: iconName,
    iconSize: "24px",
    variant: "pill"
  }), TransferInDetails_jsx("div", {
    className: "text-start text-16 leading-normal"
  }, TransferInDetails_jsx("p", {
    className: "mb-8"
  }, description), TransferInDetails_jsx("p", {
    className: "text-14 text-mediumGrey"
  }, detail))));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/TransfersInfos.jsx

var TransfersInfos_jsx = react_default.a.createElement;





var TransfersInfos_TransfersInfos = function TransfersInfos(_ref) {
  var _resort$facilities, _selectedProposal$add;

  var hasSelectedTransfer = _ref.hasSelectedTransfer,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal;
  var hasParking = resort === null || resort === void 0 ? void 0 : (_resort$facilities = resort.facilities) === null || _resort$facilities === void 0 ? void 0 : _resort$facilities.some(function (facility) {
    return facility.type && facility.type === 'PARKING';
  });
  var firstTransfer = (_selectedProposal$add = selectedProposal.additionalServices.transfers) === null || _selectedProposal$add === void 0 ? void 0 : _selectedProposal$add[0];

  var _ref2 = (firstTransfer === null || firstTransfer === void 0 ? void 0 : firstTransfer.pricingInfo.schedules[0]) || {},
      firstTransferStartDate = _ref2.startDate,
      firstTransferEndDate = _ref2.endDate;

  var isOneWayTransfer = (firstTransfer === null || firstTransfer === void 0 ? void 0 : firstTransfer.pricingInfo.schedules.length) === 1;
  var transferBulletPointTitle = 'common.transport.transfer.title';
  var transferBulletPoints = ['common.transport.transfer.arrivalPoint', 'common.transport.transfer.roundTrip'];

  if (isOneWayTransfer) {
    var isOutBoundTransfer = firstTransferStartDate === selectedProposal.departureDate;
    var isInBoundTransfer = firstTransferEndDate === selectedProposal.arrivalDate;

    if (isOutBoundTransfer) {
      transferBulletPoints = ['common.transport.transfer.outboundOnlyIncluded'];
    }

    if (isInBoundTransfer) {
      transferBulletPoints = ['common.transport.transfer.arrivalPoint', 'common.transport.transfer.inboundOnlyIncluded'];
    }
  }

  return TransfersInfos_jsx("div", {
    className: "mt-40"
  }, TransfersInfos_jsx(TransferBulletPoints["a" /* TransferBulletPoints */], {
    title: transferBulletPointTitle,
    bulletPoints: transferBulletPoints
  }), TransfersInfos_jsx("div", {
    className: "mt-40 items-start justify-between md:flex"
  }, hasSelectedTransfer && TransfersInfos_jsx("div", {
    className: "mb-20 md:mb-0 md:w-2/5"
  }, TransfersInfos_jsx(TransferInDetails_TransferInDetails, {
    iconName: icons["a" /* ICONS */].LIGHTBULB,
    description: Object(src_i18n["h" /* t */])('common.transport.transfer.reassuranceTransportDescription'),
    detail: Object(src_i18n["h" /* t */])('common.transport.transfer.reassuranceTransportDetails')
  })), hasParking && TransfersInfos_jsx("div", {
    className: "md:w-2/5"
  }, TransfersInfos_jsx(TransferInDetails_TransferInDetails, {
    iconName: icons["a" /* ICONS */].CAR_PARK,
    description: Object(src_i18n["h" /* t */])('booking.transport.transfer.parking.insterDescription'),
    detail: Object(src_i18n["h" /* t */])('booking.transport.transfer.parking.insterDetails')
  }))));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/TransfersView.jsx




var TransfersView_jsx = react_default.a.createElement;












var TransfersView_TransfersView = function TransfersView(_ref) {
  var _selectedProposal$tra, _selectedProposal$tra2, _selectedProposal$tra3, _selectedProposal$tra4;

  var proposals = _ref.proposals,
      selectedProposal = _ref.selectedProposal,
      resort = _ref.resort;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var track = useBETracking_useBETracking();
  var availableTransfers = selectedProposal.additionalServices.transfers;
  var selectedTransfers = (selectedProposal.additionalServices.transfers || []).filter(function (transfer) {
    return transfer.pricingInfo.isFullyRented;
  });
  var isTransferIncluded = ((_selectedProposal$tra = selectedProposal.transports) === null || _selectedProposal$tra === void 0 ? void 0 : (_selectedProposal$tra2 = _selectedProposal$tra.inbound) === null || _selectedProposal$tra2 === void 0 ? void 0 : _selectedProposal$tra2.transferIncluded) || ((_selectedProposal$tra3 = selectedProposal.transports) === null || _selectedProposal$tra3 === void 0 ? void 0 : (_selectedProposal$tra4 = _selectedProposal$tra3.outbound) === null || _selectedProposal$tra4 === void 0 ? void 0 : _selectedProposal$tra4.transferIncluded) || (availableTransfers === null || availableTransfers === void 0 ? void 0 : availableTransfers.some(function (transfer) {
    return transfer.pricingInfo.isIncluded;
  })) || false;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      hasSelectedTransfer = _React$useState2[0],
      setHasSelectedTransfer = _React$useState2[1];

  var onAddTransfer = function onAddTransfer(transfer) {
    var _getProposalIdsAndOve = Object(transportUtils["f" /* getProposalIdsAndOverloadForAdditionalServiceQuery */])(proposals, transfer),
        proposalIds = _getProposalIdsAndOve.proposalIds,
        overloadForSpecificProposalIds = _getProposalIdsAndOve.overloadForSpecificProposalIds;

    var addTransferAction = Object(proposals_action["b" /* addAdditionalService */])({
      proposalIds: proposalIds,
      serviceId: transfer.pricingInfo.id,
      schedules: transfer.pricingInfo.schedules.map(function (_ref2) {
        var startDate = _ref2.startDate,
            endDate = _ref2.endDate;
        return {
          startDate: startDate,
          endDate: endDate
        };
      }),
      attendeeIds: transfer.pricingInfo.schedules[0].attendees.map(function (_ref3) {
        var id = _ref3.id;
        return id;
      }),
      overloadForSpecificProposalIds: overloadForSpecificProposalIds,
      appContext: appContext
    });
    return dispatch(addTransferAction).catch(function (error) {
      return Object(BookingEngine_utils["i" /* trackErrorOnAddService */])(error, track({
        actionGA: 'transport'
      }), 'TRANSFER_NOT_FOUND');
    });
  };

  var onRemoveTransfer = function onRemoveTransfer(transfer) {
    var _getProposalIdsAndOve2 = Object(transportUtils["f" /* getProposalIdsAndOverloadForAdditionalServiceQuery */])(proposals, transfer),
        overloadForSpecificProposalIds = _getProposalIdsAndOve2.overloadForSpecificProposalIds;

    return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
      serviceIds: [transfer.productInfo.id],
      attendeeIds: transfer.pricingInfo.schedules[0].attendees.map(function (attendee) {
        return attendee.id;
      }),
      overloadForSpecificProposalIds: overloadForSpecificProposalIds,
      appContext: appContext
    }));
  };

  return TransfersView_jsx("div", null, TransfersView_jsx(Tag["a" /* Tag */], {
    className: isTransferIncluded ? 'mb-10 border-green bg-green text-white' : 'mb-10 border-sienna bg-sienna text-white'
  }, isTransferIncluded ? Object(src_i18n["h" /* t */])('booking.common.included') : Object(src_i18n["h" /* t */])('booking.confirmation.onDemand')), TransfersView_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n0"
  }, isTransferIncluded ? Object(src_i18n["h" /* t */])('common.transport.transfer.withTransferLabel') : Object(src_i18n["h" /* t */])('common.transport.transfer.transferOnDemand')), TransfersView_jsx(TransfersSection["a" /* TransfersSection */], {
    isBE: true,
    availableTransfers: availableTransfers,
    selectedTransfers: selectedTransfers,
    addTransfer: onAddTransfer,
    removeTransfer: onRemoveTransfer,
    setHasSelectedTransfer: setHasSelectedTransfer
  }), TransfersView_jsx(TransfersInfos_TransfersInfos, {
    hasSelectedTransfer: hasSelectedTransfer,
    resort: resort,
    selectedProposal: selectedProposal
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/TransportsView.jsx

var TransportsView_jsx = react_default.a.createElement;

/**
 * * Booking search transport page [find transport page]
 */










var TRANSPORTS_LAYER_NAME = 'AdditionalTransportsLayer';
var TransportsView_TransportsView = function TransportsView(_ref) {
  var i18n = _ref.i18n,
      proposals = _ref.proposals,
      selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      infoBannerData = _ref.infoBannerData,
      closeLayer = _ref.closeLayer,
      openLayer = _ref.openLayer;
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    noEdit: false
  });
  var router = Object(next_router["useRouter"])();
  var queryParams = router.query;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var onMoreTransportsClick = function onMoreTransportsClick() {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT, {
      detail_click: 'see_more_transport'
    });
    openLayer(TRANSPORTS_LAYER_NAME);
  };

  return TransportsView_jsx(react["Fragment"], null, Object(infoBanner_utils["a" /* renderInfoBanner */])({
    infoBannerData: infoBannerData,
    departureDate: selectedProposal.departureDate,
    arrivalDate: selectedProposal.arrivalDate,
    currentStep: selectedProposal.transports ? 'transport' : 'transfert'
  }), TransportsView_jsx(head_default.a, null, TransportsView_jsx("title", {
    key: "title"
  }, get_default()(i18n, selectedProposal.transports ? 'booking.transport.seo.title' : 'booking.transport.transfer.seo.title'))), selectedProposal.transports ? TransportsView_jsx(TransportsSection_TransportsSection, {
    i18n: i18n,
    proposals: proposals,
    selectedProposal: selectedProposal,
    onMoreTransportsClick: onMoreTransportsClick,
    shouldShowLayer: queryParams[dist["appQueryParameters"].openLayer] === TRANSPORTS_LAYER_NAME,
    closeLayer: closeLayer,
    resort: resort
  }) : TransportsView_jsx(TransfersView_TransfersView, {
    proposals: proposals,
    selectedProposal: selectedProposal,
    resort: resort
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/BookingStep.jsx

















var BookingStep_jsx = react_default.a.createElement;

function BookingStep_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingStep_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingStep_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingStep_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






























var getChinaTimerSessionKey = function getChinaTimerSessionKey(id) {
  return "china-summary-timer_".concat(id);
};

var BookingStep_BookingStepContent = function BookingStepContent(_ref) {
  var actionGA = _ref.actionGA,
      closeLayer = _ref.closeLayer,
      currentStep = _ref.currentStep,
      goToNextStep = _ref.goToNextStep,
      i18n = _ref.i18n,
      isFavorite = _ref.isFavorite,
      openLayer = _ref.openLayer,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      setTimerInitialValue = _ref.setTimerInitialValue,
      showTimer = _ref.showTimer,
      streetViews = _ref.streetViews,
      timerInitialValue = _ref.timerInitialValue,
      infoBannerData = _ref.infoBannerData,
      isOptionHoldOnly = _ref.isOptionHoldOnly,
      attendeesPaymentStatus = _ref.attendeesPaymentStatus;
  var sharedProps = {
    proposals: proposals,
    selectedProposal: selectedProposal,
    resort: resort,
    infoBannerData: infoBannerData
  };

  switch (currentStep) {
    case 'accommodation':
      return BookingStep_jsx(AccommodationView_AccommodationView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        closeLayer: closeLayer,
        openLayer: openLayer,
        streetViews: streetViews
      }));

    case 'transport':
      return BookingStep_jsx(TransportsView_TransportsView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        closeLayer: closeLayer,
        i18n: i18n,
        openLayer: openLayer
      }));

    case 'participants':
      return BookingStep_jsx(ParticipantsView_ParticipantsView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        closeLayer: closeLayer,
        goToNextStep: goToNextStep,
        i18n: i18n,
        openLayer: openLayer
      }));

    case 'summary':
      return BookingStep_jsx(summary_SummaryView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        actionGA: actionGA,
        bookingStep: currentStep,
        goToNextStep: goToNextStep,
        i18n: i18n,
        isFavorite: isFavorite,
        showTimer: showTimer && !timerInitialValue,
        setTimerInitialValue: setTimerInitialValue,
        isOptionHoldOnly: isOptionHoldOnly
      }));

    case 'banking':
      return BookingStep_jsx(BankingView_BankingView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        i18n: i18n,
        attendeesPaymentStatus: attendeesPaymentStatus
      }));

    case 'services':
      return BookingStep_jsx(services_ServicesView, sharedProps);

    case 'activities':
      return BookingStep_jsx(ActivitiesView_ActivitiesView, sharedProps);

    default:
      // eslint-disable-next-line no-console
      console.error("The booking engine doesn't know how to handle the step ".concat(currentStep));
      return null;
  }
};

var BookingStep_BookingStep = function BookingStep(props) {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var trackingStorage = Object(tracking_storage_api["b" /* get */])(tracking_constants["c" /* BE_TRACKING */]);

  var _useState = Object(react["useState"])({
    productInformationBanners: []
  }),
      infoBannerData = _useState[0],
      setInfoBannerData = _useState[1];

  var fetchInfoBannerData = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var response;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return graphqlClient["a" /* default */].runNoCacheQuery(Object(infoBanner_query["a" /* getInfoBannerQuery */])(props.resort.id), appContext, {
                requestName: requestDictionary["pd" /* WIDGET_PRODUCT_FETCH_INFORMATION_BANNERS */]
              });

            case 2:
              response = _context.sent;
              setInfoBannerData(response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchInfoBannerData() {
      return _ref2.apply(this, arguments);
    };
  }();

  Object(react["useEffect"])(function () {
    fetchInfoBannerData();
  }, [props.resort.id]);
  var currentStep = props.currentStep,
      resort = props.resort,
      selectedProposal = props.selectedProposal;
  var router = Object(next_router["useRouter"])();

  var _useState2 = Object(react["useState"])(false),
      redirecting = _useState2[0],
      setRedirecting = _useState2[1];

  var isChineseLocales = Object(localeUtils["a" /* isChineseLocale */])(appContext.locale);
  var chinaTimerSessionKey = sessionStorage.getItem(getChinaTimerSessionKey(selectedProposal.id));

  var _useState3 = Object(react["useState"])(isChineseLocales ? Number(chinaTimerSessionKey) : 0),
      timerInitialValue = _useState3[0],
      setTimerInitialValue = _useState3[1];

  var showTimer = isChineseLocales && !!(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.transports);
  var insurancesStore = Object(es["e" /* useSelector */])(booking_selector["o" /* getInsurancesStore */]);
  Object(react["useEffect"])(function () {
    var storePrice = function storePrice() {
      return Object(tracking_storage_api["c" /* set */])(BookingStep_objectSpread(BookingStep_objectSpread({}, trackingStorage), {}, {
        base_price: BookingStep_objectSpread(BookingStep_objectSpread({}, trackingStorage.base_price), {}, Object(defineProperty["a" /* default */])({
          proposalId: selectedProposal.id
        }, "base_price_".concat(currentStep), selectedProposal.price.total.value))
      }));
    };

    var basePrice = trackingStorage.base_price;

    if (basePrice && basePrice.proposalId !== selectedProposal.id) {
      Object(tracking_storage_api["c" /* set */])(BookingStep_objectSpread(BookingStep_objectSpread({}, trackingStorage), {}, {
        base_price: null
      }));
    }

    storePrice();
  }, [currentStep, selectedProposal.id]);
  Object(react["useEffect"])(function () {
    if (isEmpty_default()(insurancesStore)) {
      var _selectedProposal$add;

      var insurancesInitialState = {};
      (_selectedProposal$add = selectedProposal.additionalServices.insurance) === null || _selectedProposal$add === void 0 ? void 0 : _selectedProposal$add.forEach(function (ins) {
        insurancesInitialState[ins.pricingInfo.id] = {
          isAdded: ins.pricingInfo.isPartiallyRented,
          isDeleted: false,
          termsChecked: false
        };
      });
      dispatch(Object(createAction["b" /* default */])(proposals_constants["q" /* INIT_INSURANCES */], insurancesInitialState));
    }
  }, []);

  var redirectToResort = function redirectToResort() {
    var resortUri = new URI_default.a(resort === null || resort === void 0 ? void 0 : resort.href).query(BookingStep_objectSpread({}, omit_default()(router.query, ['bookingStep', 'proposalIds', 'selectedProposalId']))).toString();
    setRedirecting(true);
    router.push(dist["url"].normalizeUrl(resortUri));
  };

  var bookingStepContentProps = BookingStep_objectSpread(BookingStep_objectSpread({}, props), {}, {
    setTimerInitialValue: setTimerInitialValue,
    showTimer: showTimer,
    timerInitialValue: timerInitialValue,
    infoBannerData: infoBannerData
  });

  return BookingStep_jsx(react["Fragment"], null, showTimer && timerInitialValue > 0 && BookingStep_jsx("div", {
    className: "font-brand"
  }, BookingStep_jsx(Countdown["a" /* Countdown */], {
    className: "pt-10",
    color: colors["a" /* COLORS */].ORANGE,
    theme: "timer",
    dateTimeEnd: moment_default.a.unix(timerInitialValue),
    description: Object(src_i18n["h" /* t */])('booking.transport.countdown.proposalTimeGuaranty'),
    showTimer: currentStep === 'summary' || currentStep === 'banking',
    units: ['minutes', 'seconds'],
    expiredRender: !redirecting && BookingStep_jsx(Modal["a" /* Modal */], {
      size: "small",
      hasCloseButton: false
    }, BookingStep_jsx("div", {
      className: "rounded-12 text-center"
    }, BookingStep_jsx("div", {
      className: "bg-lightGrey p-10 font-bold"
    }, Object(src_i18n["h" /* t */])('booking.transport.countdown.countdownExpired')), BookingStep_jsx("div", {
      className: "p-30 font-bold"
    }, "00".concat(Object(src_i18n["h" /* t */])('common.countdownMinute'), " 0").concat(Object(src_i18n["h" /* t */])('common.countdownSecond'))), BookingStep_jsx("div", {
      className: "pb-20 pt-10"
    }, Object(src_i18n["h" /* t */])('booking.transport.countdown.countdownExpiredInformation')), BookingStep_jsx(Button["a" /* Button */], {
      className: "mb-20",
      onClick: redirectToResort
    }, Object(src_i18n["h" /* t */])('booking.transport.countdown.retryNewProposal')))),
    minutes: Object(src_i18n["h" /* t */])('common.countdownMinute'),
    seconds: Object(src_i18n["h" /* t */])('common.countdownSecond')
  })), BookingStep_jsx(BookingStep_BookingStepContent, bookingStepContentProps));
};
// EXTERNAL MODULE: ./src/client/views/booking/BookingLayout.jsx + 2 modules
var BookingLayout = __webpack_require__("idSt");

// EXTERNAL MODULE: ./src/utils/resort/resortUtils.js
var resortUtils = __webpack_require__("1qsz");

// CONCATENATED MODULE: ./src/client/views/booking/participants/candy-bar/CandyBar.jsx
var CandyBar_jsx = react_default.a.createElement;





var IMAGE_URLS = {
  summer: {
    className: "bg-[url('https://assets.dream.clubmed/pm_7531_772_772587-4bhfwl77ek-swhr.jpg')]",
    position: '50% -430px'
  },
  winter: {
    className: "bg-[url('https://assets.dream.clubmed/pm_7531_554_554209-cir0irc6yx-swhr.jpg')]",
    position: '50% -100px'
  }
};
var CandyBar_CandyBar = function CandyBar(_ref) {
  var allInclusive = _ref.allInclusive,
      fidelity = _ref.fidelity,
      spreadPayment = _ref.spreadPayment,
      type = _ref.type;
  return CandyBar_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex h-[572px] flex-col items-center rounded-12 bg-cover bg-no-repeat text-center font-sans font-bold text-white text-shadow-1 sm:flex-row md:h-170', IMAGE_URLS[type].className),
    style: {
      backgroundPosition: IMAGE_URLS[type].position
    }
  }, CandyBar_jsx("div", {
    className: "flex flex-col items-center justify-around py-20 sm:w-7/10 sm:flex-row sm:items-end"
  }, spreadPayment.number ? CandyBar_jsx("div", {
    className: "w-2/3 py-15 sm:w-auto sm:px-20"
  }, CandyBar_jsx("div", null, CandyBar_jsx("span", {
    className: "font-brand text-60 font-normal leading-1"
  }, spreadPayment.number), CandyBar_jsx("span", {
    className: "font-brand text-40 font-normal leading-1"
  }, "\xD7")), CandyBar_jsx("div", {
    className: "w-full"
  }, CandyBar_jsx(TemplateString["a" /* TemplateString */], {
    template: spreadPayment.text,
    values: {
      number: spreadPayment.number
    }
  }))) : null, CandyBar_jsx("div", {
    className: "relative w-2/3 py-15 sm:w-auto sm:px-20"
  }, CandyBar_jsx(Icon["a" /* Icon */], {
    className: "mb-10",
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED_GREAT_MEMBERS_WITH_SHADOW,
    width: "6.875rem"
  }), CandyBar_jsx("div", {
    className: "w-full"
  }, fidelity.text)), allInclusive.text ? CandyBar_jsx("div", {
    className: "w-2/3 py-15 sm:w-auto sm:px-20"
  }, CandyBar_jsx(Icon["a" /* Icon */], {
    className: "mb-10",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE_WITH_SHADOW,
    width: "2.6875rem"
  }), CandyBar_jsx("div", {
    className: "w-full"
  }, allInclusive.text)) : null));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/candy-bar/ParticipantsReassurance.jsx
var ParticipantsReassurance_jsx = react_default.a.createElement;



var ParticipantsReassurance_ParticipantsReassurance = function ParticipantsReassurance(_ref) {
  var i18n = _ref.i18n,
      resort = _ref.resort,
      proposal = _ref.proposal;
  return ParticipantsReassurance_jsx(CandyBar_CandyBar, {
    allInclusive: {
      text: (proposal === null || proposal === void 0 ? void 0 : proposal.packageId) === 'RON' ? null : i18n.booking.participants.rassurance.allInclusive
    },
    fidelity: {
      text: i18n.booking.participants.rassurance.fidelity
    },
    spreadPayment: {
      number: i18n.booking.participants.rassurance.paymentHeader,
      text: i18n.booking.participants.rassurance.paymentText
    },
    type: Object(resortUtils["b" /* isWinterResort */])(resort) ? 'winter' : 'summer'
  });
};
// EXTERNAL MODULE: ./src/client/context/FavoriteProductListContext.js
var FavoriteProductListContext = __webpack_require__("XGb2");

// CONCATENATED MODULE: ./src/client/views/booking/travel-plans/TravelPlans.jsx


 // Transform it to a hook after BookingEngine migration to functional component

var TravelPlans_TravelPlansComponent = function TravelPlansComponent(_ref) {
  var savedProposal = _ref.savedProposal,
      selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      setFavorite = _ref.setFavorite;

  var _useContext = Object(react["useContext"])(FavoriteProductListContext["a" /* FavoriteProductListContext */]),
      favoriteProductList = _useContext.favoriteProductsState.favoriteProductList,
      addTravelPlan = _useContext.addTravelPlan;

  Object(react["useEffect"])(function () {
    setFavorite(favoriteProductList.some(function (_ref2) {
      var reference = _ref2.reference;
      return reference === selectedProposal.id;
    }));
  }, [selectedProposal]);
  Object(react["useEffect"])(function () {
    if (savedProposal) {
      addTravelPlan(savedProposal, resort);
    }
  }, [savedProposal]);
  return null;
};
// CONCATENATED MODULE: ./src/client/views/booking/BookingEngine.jsx


















































var BookingEngine_jsx = react_default.a.createElement;

function BookingEngine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingEngine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingEngine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingEngine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



function BookingEngine_createSuper(Derived) { var hasNativeReflectConstruct = BookingEngine_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function BookingEngine_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable clubmed/no-fake-component */

















































var SHOW_LAYER_QUERY_NAME = dist["appQueryParameters"].openLayer;
var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;

/**
 * Global Wrapper for booking engine purchase process
 * Breadcrumb component display current step
 * Each step represents a component linked to process
 * Button next/back allow users to navigate through step
 */
var BookingEngine_BookingEngineComponent = /*#__PURE__*/function (_React$PureComponent) {
  Object(inherits["a" /* default */])(BookingEngineComponent, _React$PureComponent);

  var _super = BookingEngine_createSuper(BookingEngineComponent);

  function BookingEngineComponent() {
    var _this$props$selectedP, _this$props$selectedP2;

    var _this;

    Object(classCallCheck["a" /* default */])(this, BookingEngineComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      criteriaOpened: null,
      previousSelectedProposalId: _this.props.selectedProposal.id,
      unlockedStep: 0,
      step: 0,
      shouldShowSaveCriteriaConfirmation: false,
      shouldShowSaveCriteriaLogin: false,
      shouldShowShareContext: false,
      shouldRefreshProposalModal: false,
      persistenceExtended: false,
      isDataFetched: !_this.shouldFetchData(),
      displayActivities: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context)('booking.displayActivities'),
      optionHoldOnly: (((_this$props$selectedP = _this.props.selectedProposal) === null || _this$props$selectedP === void 0 ? void 0 : (_this$props$selectedP2 = _this$props$selectedP.households) === null || _this$props$selectedP2 === void 0 ? void 0 : _this$props$selectedP2.length) > 1 && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context)('booking.multiHouseholdOptionOnly') || Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context)('booking.optionHoldOnly')) && _this.props.selectedProposal.price && _this.props.selectedProposal.price.currency !== 'MXN',
      savedProposal: null,
      refreshedProposal: undefined,
      shouldOpenPanel: false,
      isProposalFavorite: false,
      isNextStep: false,
      displayRefreshProposalError: false,
      hasInternalServerError: false,
      attendeesPaymentStatus: [],
      clickOrigin: null
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setFavorite", function (isFavorite) {
      _this.setState({
        isProposalFavorite: isFavorite
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "checkIfFavoriFromShopping", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _this$props$selectedP3, _this$props$selectedP4, _this$props$selectedP5, _this$props$selectedP6, _this$props$selectedP7;

      var arrivalDateToTimestamp, departureCity, favoriteProductList, isShoppingFavorite;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Check if favori from shopping
              // $FlowFixMe
              arrivalDateToTimestamp = new Date(moment_default()(_this.props.selectedProposal.arrivalDate)).getTime();
              departureCity = ((_this$props$selectedP3 = _this.props.selectedProposal.transports) === null || _this$props$selectedP3 === void 0 ? void 0 : (_this$props$selectedP4 = _this$props$selectedP3.inbound) === null || _this$props$selectedP4 === void 0 ? void 0 : (_this$props$selectedP5 = _this$props$selectedP4.travelSections) === null || _this$props$selectedP5 === void 0 ? void 0 : (_this$props$selectedP6 = _this$props$selectedP5[0]) === null || _this$props$selectedP6 === void 0 ? void 0 : (_this$props$selectedP7 = _this$props$selectedP6.departure) === null || _this$props$selectedP7 === void 0 ? void 0 : _this$props$selectedP7.cityId) || 'NO';
              favoriteProductList = Object(local_storage_api["a" /* getFromLocalStorage */])(_this.context.isUserLogged ? tracking_constants["A" /* SHOPPING_REMOTE_FAVORITE_PRODUCTS */] : tracking_constants["w" /* SHOPPING_FAVORITE_PRODUCTS */]) || [];
              isShoppingFavorite = favoriteProductList.some(function (item) {
                var _this$props$selectedP8, _this$props$selectedP9, _item$kids, _this$props$selectedP10, _this$props$selectedP11;

                return item.adultsNumber === ((_this$props$selectedP8 = _this.props.selectedProposal.attendees) === null || _this$props$selectedP8 === void 0 ? void 0 : (_this$props$selectedP9 = _this$props$selectedP8.adults) === null || _this$props$selectedP9 === void 0 ? void 0 : _this$props$selectedP9.length) && item.departureDate === arrivalDateToTimestamp && item.duration === _this.props.selectedProposal.duration && item.departureCity === departureCity && ((_item$kids = item.kids) === null || _item$kids === void 0 ? void 0 : _item$kids.length) === ((_this$props$selectedP10 = _this.props.selectedProposal.attendees) === null || _this$props$selectedP10 === void 0 ? void 0 : (_this$props$selectedP11 = _this$props$selectedP10.children) === null || _this$props$selectedP11 === void 0 ? void 0 : _this$props$selectedP11.length) && item.product.id === _this.props.selectedProposal.productId && item.reference !== _this.props.selectedProposal.id;
              });

              if (isShoppingFavorite && !_this.state.isProposalFavorite) {
                _this.showSavedCriteriaPopIn(false);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleABTastyUpdate", function () {
      console.info('CM_AB: handleABTastyUpdate called'); // force the update of the steps

      _this.updateStepsFromProps(); // force rerender


      _this.forceUpdate();

      console.info('CM_AB: handleABTastyUpdate completed');
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "forceUpdateFromABTasty", function () {
      console.info('CM_AB: forceUpdateFromABTasty called');

      _this.updateStepsFromProps();

      _this.forceUpdate();

      console.info('CM_AB: forceUpdateFromABTasty completed');
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleNoData", function () {
      var _this$props = _this.props,
          proposals = _this$props.proposals,
          selectedProposal = _this$props.selectedProposal,
          router = _this$props.router; // Ideally, this doesn't happen. But who knows why, there can be issues with the API, and you
      // don't have a proposal. It makes no sense to continue

      if (_this.state.isDataFetched && (isEmpty_default()(proposals) || !selectedProposal)) {
        logger["default"].error(new errors_errors["e" /* ProposalNotFound */]());

        if (Object(contextUtils["f" /* isStrictlyProductionEnv */])()) {
          var locale = router.query.locale;
          return router.replace({
            pathname: '/500',
            query: Boolean(locale) && {
              locale: locale
            }
          });
        }

        return null;
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "loadStreetViews", /*#__PURE__*/function () {
      var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref2) {
        var resort, withLoader, _this$props2, endLoading, startLoading, accommodations, categoryIds;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                resort = _ref2.resort, withLoader = _ref2.withLoader;
                _this$props2 = _this.props, endLoading = _this$props2.endLoading, startLoading = _this$props2.startLoading;
                accommodations = (resort === null || resort === void 0 ? void 0 : resort.accommodations) || [];
                categoryIds = accommodations && accommodations.length > 0 ? Object(toConsumableArray["a" /* default */])(new Set(accommodations.map(function (_ref4) {
                  var categoryId = _ref4.categoryId;
                  return categoryId;
                }))) : null;

                if (!((resort === null || resort === void 0 ? void 0 : resort.id) && resort.type !== PRODUCT_TYPES.CRUISE && categoryIds && categoryIds.length > 0)) {
                  _context2.next = 9;
                  break;
                }

                if (withLoader) {
                  startLoading();
                }

                _context2.next = 8;
                return _this.props.fetchStreetViewsByAccommodationCategoryId({
                  accommodationCategoryIds: categoryIds,
                  appContext: _this.context,
                  productId: resort.id
                });

              case 8:
                if (withLoader) {
                  endLoading();
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "loadBookingStatus", /*#__PURE__*/function () {
      var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3(bookingId) {
        var _response$sellerBooki;

        var response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (bookingId) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", []);

              case 2:
                _context3.next = 4;
                return graphqlClient["a" /* default */].runNoCacheQuery("query {\n      sellerBooking (bookingId:\"".concat(bookingId, "\") {\n        bookingStatus\n        attendees {\n          customerId\n          hasPaid\n        }\n      }\n    }\n    "), _this.context, {
                  requestName: requestDictionary["wc" /* PAYMENT_BOOKING_STATUS */]
                });

              case 4:
                response = _context3.sent;
                return _context3.abrupt("return", (response === null || response === void 0 ? void 0 : (_response$sellerBooki = response.sellerBooking) === null || _response$sellerBooki === void 0 ? void 0 : _response$sellerBooki.attendees) || []);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getCurrentStepIndex", function () {
      var bookingStep = _this.props.router.query.bookingStep;
      return Object(BookingEngine_utils["g" /* getStepIndex */])(_this.getFilteredBreadcrumbPages(), bookingStep);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getCurrentPage", function () {
      var bookingStep = _this.props.router.query.bookingStep;

      var currentPage = _this.getFilteredBreadcrumbPages().find(function (page) {
        return page.name === bookingStep;
      });

      Object(invariant["a" /* invariant */])(currentPage, "The step ".concat(bookingStep, " doesn't exist"));
      return currentPage;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "updateStep", function (newStep, proposalId) {
      var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var pages = _this.getFilteredBreadcrumbPages();

      _this.changeURI(pages[newStep].name, proposalId, queryParams);

      _this.setState({
        isNextStep: true
      });

      if (true) {
        // setTimeout mandatory for IE
        setTimeout(function () {
          return window.scrollTo(0, 0);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToNextStep", function (validationCallback) {
      return function (params) {
        var validationPromise = validationCallback ? validationCallback() : Promise.resolve();
        return validationPromise.then(function () {
          var pages = _this.getFilteredBreadcrumbPages();

          var step = Object(BookingEngine_utils["g" /* getStepIndex */])(pages, _this.props.router.query.bookingStep);
          var maxPagesIndex = pages.length - 1;

          if (step === maxPagesIndex) {
            return;
          }

          _this.updateStep(Math.min(maxPagesIndex, step + 1), null, (params === null || params === void 0 ? void 0 : params.queryParams) || {});
        }).catch(function () {
          return null;
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToPreviousStep", function () {
      var stepIndex = _this.getCurrentStepIndex();

      _this.props.trackClickPreviousStep();

      if (stepIndex !== 0) {
        return _this.updateStep(stepIndex - 1);
      }

      var _this$props3 = _this.props,
          router = _this$props3.router,
          resort = _this$props3.resort;
      var previousUri;
      var queryParams = router.query;

      if (queryParams.fromSearches) {
        previousUri = new URI_default.a(Object(routeBuilder["b" /* urlPattern */])('accountSearches')).query(BookingEngine_objectSpread({}, omit_default()(queryParams, ['bookingStep', 'proposalIds', 'selectedProposalId', 'product', 'coderesort', 'fromSearches', 'catId']))).toString();
      } else {
        previousUri = new URI_default.a(get_default()(resort, 'href')).query(BookingEngine_objectSpread({}, omit_default()(queryParams, ['bookingStep', 'proposalIds', 'selectedProposalId', 'catId']))).toString();
      }

      return _this.props.router.push(dist["url"].normalizeUrl(previousUri).toString());
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openLayer", function (layerName) {
      var router = _this.props.router;
      var uri = new URI_default.a(router.asPath).addQuery(Object(defineProperty["a" /* default */])({}, SHOW_LAYER_QUERY_NAME, layerName));
      router.push(uri.toString());
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeLayer", function (submitted, proposalId) {
      var router = _this.props.router;

      if (submitted) {
        // this function is sometimes plugged directly to a dom element's onClick
        // so we have to use "typeof" to avoid truthy cases with dom-event...
        // if we're in AdditionalTransportsLayer we want to stay in the same step to view the selected transport
        var nextStep = router.query.openLayer === 'AdditionalTransportsLayer' ? _this.state.step : _this.state.step + 1;

        _this.updateStep(nextStep, typeof proposalId === 'string' ? proposalId : undefined);
      } else {
        var newUrl = new URI_default.a(router.asPath).removeQuery(SHOW_LAYER_QUERY_NAME);
        /**
         * This case happens only after selecting an accommodation on more rooms layer, on a proposal with a flex rate
         * When use choose a new room on a proposal with Flex Rate, we should come back to accommodation page,
         * but remove other proposals ids from the url (preserve the selected one only)
         */

        if (proposalId && typeof proposalId === 'string') {
          newUrl.setQuery('proposalIds', Object(BookingEngine_utils["b" /* getAllProposalsIdWithAlternative */])(_this.props.selectedProposal));
        }

        router.push(newUrl.toString());
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "hideSaveCriteriaConfirmationModal", function () {
      var router = _this.props.router;

      _this.setState({
        shouldShowSaveCriteriaConfirmation: false
      });

      if (router.query.openSaveConfirmationModal) {
        var newUrl = new URI_default.a(router.asPath).removeQuery(['openSaveConfirmationModal', 'newAccount']);
        router.replace(newUrl.toString());
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "hideSaveCriteriaLoginModal", function () {
      _this.setState({
        shouldShowSaveCriteriaLogin: false
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleShareContextModal", function () {
      var shouldShowShareContext = _this.state.shouldShowShareContext;

      if (!shouldShowShareContext) {
        _this.props.trackClickShare();
      }

      _this.setState({
        shouldShowShareContext: !shouldShowShareContext
      });

      _this.props.closeToast();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "extendProposalPersistence", function (extend) {
      var _this$props4 = _this.props,
          router = _this$props4.router,
          startLoading = _this$props4.startLoading,
          endLoading = _this$props4.endLoading;
      var selectedProposalId = router.query.selectedProposalId;
      startLoading();

      _this.props.patchProposalHandler(selectedProposalId, _this.context, extend).then(function () {
        _this.setState({
          shouldShowSaveCriteriaConfirmation: true,
          persistenceExtended: extend
        });
      }).catch(function (error) {
        logger["default"].error(error);
      }).finally(function () {
        endLoading();
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "showSavedCriteriaPopIn", function () {
      var popupDisplayed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (_this.context.isUserLogged) {
        _this.props.trackAddToWishlist();

        var selectedProposalId = _this.props.router.query.selectedProposalId;
        var _customerId = _this.context.neolaneId;

        _this.props.saveCustomerProposalsHandler(selectedProposalId, _this.context, _customerId).then(function () {
          try {
            _this.setState({
              savedProposal: _this.props.selectedProposal,
              isProposalFavorite: true
            });

            if (_this.state.unlockedStep >= 4) {
              _this.extendProposalPersistence(true);
            } else {
              _this.setState({
                shouldShowSaveCriteriaConfirmation: popupDisplayed
              });
            }
          } catch (errors) {
            logger["default"].error(errors);
          }
        }).catch(function (error) {
          // When the error is indeed an API error, this is the model. But code error would return
          // a native JS Error object, which doesn't have this structure
          if (error && error.errors) {
            var _error$errors = Object(slicedToArray["a" /* default */])(error.errors, 1),
                statusCode = _error$errors[0].statusCode; // catch 401 (bad token) error code
            // display save criteria login modal


            if (statusCode === 401) {
              _this.setState({
                shouldShowSaveCriteriaLogin: popupDisplayed
              });
            }
          }
        });
      } else {
        _this.setState({
          shouldShowSaveCriteriaLogin: true
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickFavorite", function (origin) {
      var trackClickFavorite = _this.props.trackClickFavorite;

      if (!_this.state.isProposalFavorite) {
        trackClickFavorite(origin, 'travel_plans');

        _this.setState({
          clickOrigin: origin
        });

        _this.showSavedCriteriaPopIn();
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(BookingEngineComponent, [{
    key: "updateStepsFromProps",
    // this function is to make sure that the thing rerenders correctly when ab tasty data arrives later
    value: function updateStepsFromProps() {
      var _this$props5 = this.props,
          selectedProposal = _this$props5.selectedProposal,
          resort = _this$props5.resort,
          i18n = _this$props5.i18n,
          abTastyData = _this$props5.abTastyData,
          router = _this$props5.router,
          proposals = _this$props5.proposals;
      var _this$state = this.state,
          displayActivities = _this$state.displayActivities,
          optionHoldOnly = _this$state.optionHoldOnly,
          attendeesPaymentStatus = _this$state.attendeesPaymentStatus,
          unlockedStep = _this$state.unlockedStep,
          previousSelectedProposalId = _this$state.previousSelectedProposalId;
      var isAbDataReady = abTastyData && Object.keys(abTastyData).length > 0 && Object.values(abTastyData).every(function (v) {
        return v === '0' || v === '1';
      });
      console.info('CM_AB: updateStepsFromProps called', {
        abTastyData: abTastyData,
        isAbDataReady: isAbDataReady,
        hasProposals: !isEmpty_default()(proposals),
        hasResort: !!resort,
        hasI18n: !!i18n.booking,
        hasSelectedProposal: !!selectedProposal,
        willRender: !isEmpty_default()(proposals) && !!resort && !!i18n.booking && !!selectedProposal
      });

      if (isEmpty_default()(proposals) || !resort || !i18n.booking || !selectedProposal) {
        console.info('CM_AB: Skipping update - missing required data');
        return;
      } // Use AB Tasty data if available, otherwise default to showing activities step


      var shouldHideActivitiesStepAbTest = (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities']) === '1' || (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities-br']) === '1' || (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities-ca']) === '1' || (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities-jp']) === '1' || (abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities-uk']) === '1';
      var isPartiallyPaid = attendeesPaymentStatus.some(function (s) {
        return s.hasPaid;
      });
      console.info('CM_AB: Activities step visibility:', {
        shouldHideActivitiesStepAbTest: shouldHideActivitiesStepAbTest,
        abTestValue: abTastyData === null || abTastyData === void 0 ? void 0 : abTastyData['ab-test-activities']
      });

      var availableSteps = Object(BookingEngine_utils["f" /* getFilteredBreadcrumbPages */])({
        selectedProposal: selectedProposal,
        resort: resort,
        i18n: i18n,
        isActivitiesViewFeatureFlipped: displayActivities,
        isOptionHoldOnlyFeatureFlipped: optionHoldOnly,
        isPartiallyPaid: isPartiallyPaid,
        shouldHideActivitiesStepAbTest: shouldHideActivitiesStepAbTest
      });

      var path = new URI_default.a(router.asPath).pathname();
      var stepIndex = availableSteps.findIndex(function (el) {
        return path === el.path;
      });
      var newStep = Math.max(0, stepIndex);
      var newUnlockedStep = !previousSelectedProposalId || previousSelectedProposalId === selectedProposal.id ? Math.max(unlockedStep, stepIndex) : Math.min(unlockedStep, availableSteps.findIndex(function (el) {
        return el.path.includes('participants');
      }));
      var stepChanged = this.state.step !== newStep;
      var unlockedStepChanged = this.state.unlockedStep !== newUnlockedStep;
      var previousSelectedProposalIdChanged = this.state.previousSelectedProposalId !== selectedProposal.id;

      if (!stepChanged && !unlockedStepChanged && !previousSelectedProposalIdChanged) {
        return;
      }

      this.setState({
        step: newStep,
        unlockedStep: newUnlockedStep,
        previousSelectedProposalId: selectedProposal.id
      });
    }
  }, {
    key: "shouldFetchData",
    value: function shouldFetchData() {
      var _this$props6 = this.props,
          proposals = _this$props6.proposals,
          resort = _this$props6.resort,
          i18n = _this$props6.i18n,
          router = _this$props6.router;
      var proposalIds = router.query.proposalIds || [];
      var validProposals = proposals.every(function (_ref6) {
        var id = _ref6.id;
        return proposalIds.indexOf(id) !== -1;
      });
      var validI18n = ['common', 'filters', 'sorters', 'travelAdvisor', 'booking', 'footer'].every(function (namespace) {
        return !isNil_default()(get_default()(i18n, namespace));
      });
      return isEmpty_default()(proposals) || !validProposals || !resort || !validI18n;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props7 = this.props,
          i18n = _this$props7.i18n,
          getBookingEngineI18n = _this$props7.getBookingEngineI18n,
          resort = _this$props7.resort,
          router = _this$props7.router,
          fetchProposalsById = _this$props7.fetchProposalsById,
          fetchRefreshProposal = _this$props7.fetchRefreshProposal,
          selectProposal = _this$props7.selectProposal,
          startLoading = _this$props7.startLoading,
          endLoading = _this$props7.endLoading;
      var isDataFetched = this.state.isDataFetched;

      try {
        Object(BookingEngine_utils["h" /* handleWrongUrl */])(router);
      } catch (_unused) {
        return;
      }

      Object(BookingEngine_tracking["a" /* resetTrackingStorageBE */])(!!router.query.fromSearches);
      this.handleNoData();
      var queryParams = router.query;
      var proposalIds = queryParams.proposalIds,
          selectedProposalId = queryParams.selectedProposalId,
          openSaveConfirmationModal = queryParams.openSaveConfirmationModal;

      if (isDataFetched && resort) {
        this.loadStreetViews({
          resort: resort,
          withLoader: true
        }); // Check if favori from shopping

        this.checkIfFavoriFromShopping();
      }

      if (!isDataFetched) {
        startLoading();
        Promise.all([fetchProposalsById({
          proposalsId: proposalIds,
          appContext: this.context,
          shouldRequestPayment: this.isOnLastPage()
        }), getBookingEngineI18n(this.context), this.loadBookingStatus(queryParams === null || queryParams === void 0 ? void 0 : queryParams.bookingId)]).then( /*#__PURE__*/function () {
          var _ref8 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee4(_ref7) {
            var _resp$proposals, _resp$proposals2;

            var _ref9, resp, attendeesPaymentStatus, originalLocale, locale, hasSameLocale, proposals, responseResort, refreshedProposal;

            return regenerator_default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _ref9 = Object(slicedToArray["a" /* default */])(_ref7, 3), resp = _ref9[0], attendeesPaymentStatus = _ref9[2];
                    originalLocale = _this2.props.selectedProposal.originalLocale;
                    locale = _this2.context.locale;
                    hasSameLocale = locale === originalLocale; // The log below aims to investigate the origin of blank page bug

                    proposals = resp === null || resp === void 0 ? void 0 : (_resp$proposals = resp.proposals) === null || _resp$proposals === void 0 ? void 0 : _resp$proposals.proposals;
                    responseResort = resp === null || resp === void 0 ? void 0 : (_resp$proposals2 = resp.proposals) === null || _resp$proposals2 === void 0 ? void 0 : _resp$proposals2.resort; // Check if favori from shopping

                    _this2.checkIfFavoriFromShopping();

                    if (!(isEmpty_default()(proposals) || !responseResort)) {
                      _context4.next = 10;
                      break;
                    }

                    logger["default"].error('API response with empty proposals');
                    throw new errors_errors["e" /* ProposalNotFound */]("No proposal found for this id: ".concat(proposalIds.toString()));

                  case 10:
                    if (!(Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this2.context)('booking.refreshProposals') && hasSameLocale)) {
                      _context4.next = 16;
                      break;
                    }

                    _context4.next = 13;
                    return fetchRefreshProposal(_this2.props.selectedProposal.id, undefined, _this2.context);

                  case 13:
                    _context4.t0 = _context4.sent;
                    _context4.next = 17;
                    break;

                  case 16:
                    _context4.t0 = undefined;

                  case 17:
                    refreshedProposal = _context4.t0;

                    _this2.setState({
                      attendeesPaymentStatus: attendeesPaymentStatus,
                      refreshedProposal: refreshedProposal ? refreshedProposal === null || refreshedProposal === void 0 ? void 0 : refreshedProposal.refreshProposal : undefined
                    });

                    if (openSaveConfirmationModal && i18n.booking) {
                      _this2.showSavedCriteriaPopIn();
                    }

                    _this2.loadStreetViews({
                      resort: responseResort,
                      withLoader: false
                    });

                  case 21:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x3) {
            return _ref8.apply(this, arguments);
          };
        }()).catch(function (err) {
          logger["default"].error(err);
          endLoading();

          _this2.setState({
            hasInternalServerError: true,
            isDataFetched: true
          });

          if (Object(contextUtils["f" /* isStrictlyProductionEnv */])()) {
            var locale = router.query.locale;
            return router.replace({
              pathname: '/500',
              query: Boolean(locale) && {
                locale: locale
              }
            });
          }
        });
        var updatedUri = new URI_default.a(router.asPath).setQuery(dist["appQueryParameters"].booking.selectedProposalId, selectedProposalId || (proposalIds === null || proposalIds === void 0 ? void 0 : proposalIds[0]));
        router.replace(updatedUri.toString());
        return selectProposal(selectedProposalId || proposalIds[0]);
      }

      this.updateStepsFromProps();
      js_cookie_default.a.remove(BookingEngine_utils["a" /* SVRL_PMNTS */]); // Skip ABTasty event listeners in test environment to avoid performance issues

      if (true) {
        // Listen to the custom event for ABTasty changes
        this.handleABTastyUpdate = this.handleABTastyUpdate.bind(this);
        document.addEventListener('abTastyDataUpdated', this.handleABTastyUpdate); // Expose the force update method for tests (development only)

        if (false) {}
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _prevProps$selectedPr, _this$props$selectedP12, _prevProps$selectedPr2, _prevProps$selectedPr3, _this$props$selectedP13, _this$props$selectedP14, _prevProps$selectedPr4, _prevProps$selectedPr5, _prevProps$selectedPr6, _this$props$selectedP19, _this$props$selectedP20, _this$props$selectedP21, _prevProps$abTastyDat, _this$props$abTastyDa, _prevProps$selectedPr7, _this$props$selectedP22;

      var _this$props8 = this.props,
          endLoading = _this$props8.endLoading,
          i18n = _this$props8.i18n,
          resort = _this$props8.resort,
          router = _this$props8.router,
          selectedProposal = _this$props8.selectedProposal,
          streetViews = _this$props8.streetViews;
      var openSaveConfirmationModal = router.query.openSaveConfirmationModal;
      this.handleNoData();

      if (this.state.isDataFetched && isEmpty_default()(streetViews)) {
        this.loadStreetViews({
          resort: resort,
          withLoader: true
        });
      }

      if (!prevState.isDataFetched && this.state.isDataFetched) {
        endLoading();
      }

      if (this.state.isDataFetched && openSaveConfirmationModal && i18n.booking) {
        this.showSavedCriteriaPopIn();
        router.replace(new URI_default.a(router.asPath).removeQuery(['openSaveConfirmationModal']).toString());
      }

      if (!this.state.isDataFetched && !this.shouldFetchData()) {
        this.setState({
          isDataFetched: true
        });
      }

      if (typeof router.query.editCriteriaWarning !== 'undefined') {
        this.setState({
          unlockedStep: 0
        }, function () {
          var url = new URI_default.a(router.asPath);

          if (!url.toString().includes('accommodation')) {
            var newUrl = url.removeSearch('editCriteriaWarning');
            router.replace(newUrl.toString());
          }
        });
      } else if (selectedProposal && resort && i18n.booking) {
        // Once the user reached a step, they can always come back to it
        var currentStepIndex = this.getCurrentStepIndex();

        if (currentStepIndex > this.state.unlockedStep) {
          this.setState({
            unlockedStep: currentStepIndex
          });
        }
      }

      if (((_prevProps$selectedPr = prevProps.selectedProposal) === null || _prevProps$selectedPr === void 0 ? void 0 : _prevProps$selectedPr.persistenceExtended) !== ((_this$props$selectedP12 = this.props.selectedProposal) === null || _this$props$selectedP12 === void 0 ? void 0 : _this$props$selectedP12.persistenceExtended)) {
        this.setState({
          persistenceExtended: this.props.selectedProposal.persistenceExtended
        });
      }

      if (((_prevProps$selectedPr2 = prevProps.selectedProposal) === null || _prevProps$selectedPr2 === void 0 ? void 0 : (_prevProps$selectedPr3 = _prevProps$selectedPr2.households) === null || _prevProps$selectedPr3 === void 0 ? void 0 : _prevProps$selectedPr3.length) !== ((_this$props$selectedP13 = this.props.selectedProposal) === null || _this$props$selectedP13 === void 0 ? void 0 : (_this$props$selectedP14 = _this$props$selectedP13.households) === null || _this$props$selectedP14 === void 0 ? void 0 : _this$props$selectedP14.length)) {
        var _this$props$selectedP15, _this$props$selectedP16, _this$props$selectedP17, _this$props$selectedP18;

        var optionHoldOnly = (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.optionHoldOnly') || ((_this$props$selectedP15 = this.props.selectedProposal) === null || _this$props$selectedP15 === void 0 ? void 0 : (_this$props$selectedP16 = _this$props$selectedP15.households) === null || _this$props$selectedP16 === void 0 ? void 0 : _this$props$selectedP16.length) > 1 && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.multiHouseholdOptionOnly')) && ((_this$props$selectedP17 = this.props.selectedProposal) === null || _this$props$selectedP17 === void 0 ? void 0 : (_this$props$selectedP18 = _this$props$selectedP17.price) === null || _this$props$selectedP18 === void 0 ? void 0 : _this$props$selectedP18.currency) !== 'MXN';

        if (optionHoldOnly !== this.state.optionHoldOnly) {
          this.setState({
            optionHoldOnly: optionHoldOnly
          });
        }
      }

      if (((_prevProps$selectedPr4 = prevProps.selectedProposal) === null || _prevProps$selectedPr4 === void 0 ? void 0 : (_prevProps$selectedPr5 = _prevProps$selectedPr4.price) === null || _prevProps$selectedPr5 === void 0 ? void 0 : (_prevProps$selectedPr6 = _prevProps$selectedPr5.total) === null || _prevProps$selectedPr6 === void 0 ? void 0 : _prevProps$selectedPr6.value) !== ((_this$props$selectedP19 = this.props.selectedProposal) === null || _this$props$selectedP19 === void 0 ? void 0 : (_this$props$selectedP20 = _this$props$selectedP19.price) === null || _this$props$selectedP20 === void 0 ? void 0 : (_this$props$selectedP21 = _this$props$selectedP20.total) === null || _this$props$selectedP21 === void 0 ? void 0 : _this$props$selectedP21.value)) {
        this.setState({
          isProposalFavorite: false,
          isNextStep: false
        });
      } // improvement of the detection of ABTasty changes


      var abChanged = ((_prevProps$abTastyDat = prevProps.abTastyData) === null || _prevProps$abTastyDat === void 0 ? void 0 : _prevProps$abTastyDat['ab-test-activities']) !== ((_this$props$abTastyDa = this.props.abTastyData) === null || _this$props$abTastyDa === void 0 ? void 0 : _this$props$abTastyDa['ab-test-activities']);
      var proposalChanged = ((_prevProps$selectedPr7 = prevProps.selectedProposal) === null || _prevProps$selectedPr7 === void 0 ? void 0 : _prevProps$selectedPr7.id) !== ((_this$props$selectedP22 = this.props.selectedProposal) === null || _this$props$selectedP22 === void 0 ? void 0 : _this$props$selectedP22.id);
      var flagsChanged = prevState.displayActivities !== this.state.displayActivities || prevState.optionHoldOnly !== this.state.optionHoldOnly; // Forcer la mise à jour si ABTasty data change

      if (abChanged || proposalChanged || flagsChanged) {
        this.updateStepsFromProps();
      }
    }
  }, {
    key: "changeURI",
    value: function changeURI(pageName, proposalId, queryParams) {
      var _this$props9 = this.props,
          closeToast = _this$props9.closeToast,
          router = _this$props9.router,
          selectedProposal = _this$props9.selectedProposal;
      closeToast();
      var newUrl = new URI_default.a(router.asPath).filename(pageName).removeQuery(SHOW_LAYER_QUERY_NAME).removeQuery('catId');
      Object.keys(queryParams).forEach(function (key) {
        newUrl.setQuery(key, queryParams[key]);
      }); // Only when the user submits and closes a layer

      if (proposalId) {
        newUrl.setQuery('proposalIds', Object(BookingEngine_utils["b" /* getAllProposalsIdWithAlternative */])(selectedProposal));
      }

      return router.push(newUrl.toString());
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "getPageName",
    value: function getPageName() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentStepIndex();
      var currentPageData = this.getFilteredBreadcrumbPages()[step] || {};
      return currentPageData.name;
    }
  }, {
    key: "getFilteredBreadcrumbPages",
    value: function getFilteredBreadcrumbPages() {
      var _this$state3, _this$props$abTastyDa2, _this$props$abTastyDa3, _this$props$abTastyDa4, _this$props$abTastyDa5, _this$props$abTastyDa6;

      var _this$props10 = this.props,
          selectedProposal = _this$props10.selectedProposal,
          resort = _this$props10.resort,
          i18n = _this$props10.i18n;
      var _this$state2 = this.state,
          displayActivities = _this$state2.displayActivities,
          optionHoldOnly = _this$state2.optionHoldOnly;
      var attendeesPaymentStatus = ((_this$state3 = this.state) === null || _this$state3 === void 0 ? void 0 : _this$state3.attendeesPaymentStatus) || [];
      var isPartiallyPaid = attendeesPaymentStatus.some(function (status) {
        return status.hasPaid;
      });
      var shouldHideActivitiesStepAbTest = ((_this$props$abTastyDa2 = this.props.abTastyData) === null || _this$props$abTastyDa2 === void 0 ? void 0 : _this$props$abTastyDa2['ab-test-activities']) === '1' || ((_this$props$abTastyDa3 = this.props.abTastyData) === null || _this$props$abTastyDa3 === void 0 ? void 0 : _this$props$abTastyDa3['ab-test-activities-br']) === '1' || ((_this$props$abTastyDa4 = this.props.abTastyData) === null || _this$props$abTastyDa4 === void 0 ? void 0 : _this$props$abTastyDa4['ab-test-activities-ca']) === '1' || ((_this$props$abTastyDa5 = this.props.abTastyData) === null || _this$props$abTastyDa5 === void 0 ? void 0 : _this$props$abTastyDa5['ab-test-activities-jp']) === '1' || ((_this$props$abTastyDa6 = this.props.abTastyData) === null || _this$props$abTastyDa6 === void 0 ? void 0 : _this$props$abTastyDa6['ab-test-activities-uk']) === '1';
      return Object(BookingEngine_utils["f" /* getFilteredBreadcrumbPages */])({
        selectedProposal: selectedProposal,
        resort: resort,
        i18n: i18n,
        isActivitiesViewFeatureFlipped: displayActivities,
        isOptionHoldOnlyFeatureFlipped: optionHoldOnly,
        isPartiallyPaid: isPartiallyPaid,
        shouldHideActivitiesStepAbTest: shouldHideActivitiesStepAbTest
      });
    }
  }, {
    key: "isOnLastPage",
    value: function isOnLastPage() {
      return this.props.router.query.bookingStep === 'banking';
    }
  }, {
    key: "getActions",
    value: function getActions() {
      var _this3 = this;

      var _this$state4 = this.state,
          isProposalFavorite = _this$state4.isProposalFavorite,
          step = _this$state4.step,
          persistenceExtended = _this$state4.persistenceExtended;
      var isTablet = this.props.responsive.isTablet;
      var pages = this.getFilteredBreadcrumbPages();

      var isDisplaySaveFlipped = get_default()(this.props, 'i18n.booking.saveMyCriteria.display');

      var isDisplayShareFlippedMobile = get_default()(this.props, 'i18n.booking.common.share.displayMobile');

      var isDisplayShareFlippedDesktop = get_default()(this.props, 'i18n.booking.common.share.displayDesktop');

      var shouldDisplaySave = isDisplaySaveFlipped && pages[step].name !== booking_constants["p" /* PAGES */].BANKING;
      var shouldDisplayShare = (isTablet && isDisplayShareFlippedDesktop || !isTablet && isDisplayShareFlippedMobile) && pages[step].name !== booking_constants["p" /* PAGES */].BANKING;
      return [{
        id: persistenceExtended ? booking_constants["h" /* BE_UNSAVE_ACTION */] : booking_constants["d" /* BE_SAVE_ACTION */],
        iconName: persistenceExtended || isProposalFavorite ? icons["a" /* ICONS */].STAR_FILLED : icons["a" /* ICONS */].STAR_HOLLOW,
        label: get_default()(this.props, 'i18n.booking.common.save'),
        onClick: function onClick() {
          return _this3.onClickFavorite('header');
        },
        display: shouldDisplaySave
      }, {
        id: booking_constants["g" /* BE_SHARE_ACTION */],
        iconName: icons["a" /* ICONS */].SHARE,
        label: get_default()(this.props, 'i18n.booking.common.share.label'),
        display: shouldDisplayShare,
        onClick: this.toggleShareContextModal
      }];
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Cleanup event listeners
      if (this.handleABTastyUpdate) {
        document.removeEventListener('abTastyDataUpdated', this.handleABTastyUpdate);
      } // Cleanup the exposed function (development only)


      if (false) {}
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$i18n,
          _this$props$i18n$book,
          _this$props$i18n$book2,
          _this4 = this,
          _this$props$i18n2,
          _this$props$i18n2$boo,
          _this$props$i18n2$boo2;

      var _this$state5 = this.state,
          shouldShowSaveCriteriaConfirmation = _this$state5.shouldShowSaveCriteriaConfirmation,
          shouldShowSaveCriteriaLogin = _this$state5.shouldShowSaveCriteriaLogin,
          shouldShowShareContext = _this$state5.shouldShowShareContext,
          displayRefreshProposalError = _this$state5.displayRefreshProposalError,
          hasInternalServerError = _this$state5.hasInternalServerError,
          isDataFetched = _this$state5.isDataFetched;
      var _this$props11 = this.props,
          proposals = _this$props11.proposals,
          selectedProposal = _this$props11.selectedProposal,
          resort = _this$props11.resort,
          i18n = _this$props11.i18n,
          closeToast = _this$props11.closeToast,
          displayToastOnContextShare = _this$props11.displayToastOnContextShare,
          _this$props11$router$ = _this$props11.router.query,
          currentStep = _this$props11$router$.bookingStep,
          editCriteriaWarning = _this$props11$router$.editCriteriaWarning,
          newAccount = _this$props11$router$.newAccount,
          isAppMounted = _this$props11.responsive.isAppMounted,
          streetViews = _this$props11.streetViews;

      if (hasInternalServerError) {
        return null;
      }

      if (i18n.booking && displayRefreshProposalError) {
        return BookingEngine_jsx(SiteContainer["a" /* SiteContainer */], {
          isWide: true
        }, BookingEngine_jsx("div", {
          className: "min-h-screen bg-white"
        }, BookingEngine_jsx(SiteContainer["a" /* SiteContainer */], null, BookingEngine_jsx(QuickSearchUnavailability["a" /* QuickSearchUnavailability */], {
          title: i18n.booking.warnings.refreshFailedTitle,
          description: i18n.booking.warnings.refreshFailedDescription
        }))));
      } // i18n is initialized to an empty object, so we checked its properties to see if it's loaded


      if (!isDataFetched || !i18n.booking || !isAppMounted || isDataFetched && isEmpty_default()(proposals)) {
        return BookingEngine_jsx(AsyncLoader["a" /* AsyncLoader */], {
          className: "min-h-screen"
        });
      } // currentPage always should be an object since we destructure it on the next line


      var currentPage = this.getCurrentPage() || {};
      var name = currentPage.name,
          actionGA = currentPage.actionGA,
          seoTitle = currentPage.seoTitle,
          gridSize = currentPage.gridSize;
      var isTransportView = name === booking_constants["p" /* PAGES */].TRANSPORT;

      var isTransferView = isTransportView && isEmpty_default()(selectedProposal.transports);

      var isSkipTestVisible = isTransferView || name === booking_constants["p" /* PAGES */].SERVICES || name === booking_constants["p" /* PAGES */].ACTIVITIES;

      var alertMessageNewProposal = get_default()(i18n, 'booking.editCriteria.alertMessageNewProposal');

      var activeStep = this.getCurrentStepIndex();

      var selectedProposalPrice = get_default()(this.props.selectedProposal, 'price');

      return BookingEngine_jsx(BookingEngineContext["a" /* BookingEngineContext */].Provider, {
        // TODO: cleanup !!
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
          currentStep: currentPage
        }
      }, BookingEngine_jsx(BookingAccessibleTitle_BookingAccessibleTitle, {
        title: seoTitle
      }), BookingEngine_jsx("div", {
        className: "relative"
      }, BookingEngine_jsx(HeaderLite["a" /* HeaderLite */], {
        actions: this.getActions(),
        product: resort,
        proposal: selectedProposal
      }), BookingEngine_jsx("main", {
        role: "main"
      }, BookingEngine_jsx(BookingBreadcrumb["a" /* BookingBreadcrumb */], {
        resort: resort,
        selectedProposal: selectedProposal,
        activeStep: activeStep > 0 ? activeStep : 0,
        actionGA: actionGA,
        backgroundImageSrc: resort.image,
        items: this.getFilteredBreadcrumbPages().map(function (item) {
          return {
            iconName: item.icon,
            id: item.actionGA,
            label: item.title
          };
        }),
        label: (_this$props$i18n = this.props.i18n) === null || _this$props$i18n === void 0 ? void 0 : (_this$props$i18n$book = _this$props$i18n.booking) === null || _this$props$i18n$book === void 0 ? void 0 : (_this$props$i18n$book2 = _this$props$i18n$book.header) === null || _this$props$i18n$book2 === void 0 ? void 0 : _this$props$i18n$book2.bookingSteps,
        lastActiveStep: this.state.unlockedStep,
        onClickStep: this.updateStep,
        i18n: i18n
      }), BookingEngine_jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])('min-h-[60vh]', isTransportView ? 'py-10' : 'py-20')
      }, BookingEngine_jsx(SiteContainer["a" /* SiteContainer */], {
        size: gridSize ? // $FlowFixMe
        gridSize : 'small'
      }, BookingEngine_jsx("div", {
        className: "relative flex justify-between"
      }, editCriteriaWarning && name === booking_constants["p" /* PAGES */].ACCOMMODATION && alertMessageNewProposal && BookingEngine_jsx("div", {
        className: "mb-20 flex items-start justify-center gap-10 text-orange",
        "data-testid": "BookingEngine-accommodationEditWarning"
      }, BookingEngine_jsx(Icon["a" /* Icon */], {
        className: "shrink-0",
        name: icons["a" /* ICONS */].WARNING,
        width: "1.5rem"
      }), alertMessageNewProposal), isSkipTestVisible && BookingEngine_jsx("button", {
        className: "ms-auto flex items-center justify-center font-bold text-black",
        "data-selector": "skip-step",
        onClick: function onClick() {
          _this4.props.trackClickSkipStep();

          _this4.goToNextStep(undefined)();
        },
        type: "button",
        "data-testid": "skip"
      }, (_this$props$i18n2 = this.props.i18n) === null || _this$props$i18n2 === void 0 ? void 0 : (_this$props$i18n2$boo = _this$props$i18n2.booking) === null || _this$props$i18n2$boo === void 0 ? void 0 : (_this$props$i18n2$boo2 = _this$props$i18n2$boo.common) === null || _this$props$i18n2$boo2 === void 0 ? void 0 : _this$props$i18n2$boo2.skipThisStepLabel, BookingEngine_jsx(Icon["a" /* Icon */], {
        hasRtl: true,
        name: icons["a" /* ICONS */].ARROW_RIGHT,
        width: "1rem"
      }))), BookingEngine_jsx(BookingLayout["a" /* BookingLayout */], {
        selectedProposal: selectedProposal,
        price: selectedProposalPrice,
        goToNextStep: this.goToNextStep,
        i18n: i18n,
        proposals: proposals,
        resort: resort,
        isOptionHoldOnly: this.state.optionHoldOnly,
        previousAction: this.goToPreviousStep,
        isOnLastPage: this.isOnLastPage(),
        isFavorite: this.state.isProposalFavorite,
        shouldOpenPanel: this.state.shouldOpenPanel,
        onClickFavorite: function onClickFavorite() {
          return _this4.onClickFavorite('bottomBar');
        },
        isNextStep: this.state.isNextStep,
        currentPage: currentPage.name // $FlowFixMe
        ,
        closePanel: function closePanel() {
          _this4.setState({
            shouldOpenPanel: false
          });
        }
      }, BookingEngine_jsx(BookingStep_BookingStep, {
        actionGA: actionGA,
        attendeesPaymentStatus: this.state.attendeesPaymentStatus,
        closeLayer: this.closeLayer,
        currentStep: currentStep,
        goToNextStep: this.goToNextStep(),
        i18n: i18n,
        isFavorite: this.state.isProposalFavorite,
        isOptionHoldOnly: this.state.optionHoldOnly,
        openLayer: this.openLayer,
        proposals: proposals,
        resort: resort,
        selectedProposal: selectedProposal,
        streetViews: streetViews
      })), shouldShowSaveCriteriaConfirmation ? BookingEngine_jsx(SaveCriteriaConfirmation_SaveCriteriaConfirmation, {
        persistenceExtended: this.state.persistenceExtended,
        closeModal: this.hideSaveCriteriaConfirmationModal,
        newAccount: newAccount,
        i18n: i18n
      }) : null, shouldShowSaveCriteriaLogin ? BookingEngine_jsx(SaveCriteriaLogin, {
        closeModal: this.hideSaveCriteriaLoginModal,
        clickOrigin: this.state.clickOrigin,
        i18n: i18n
      }) : null, shouldShowShareContext ? BookingEngine_jsx(share_context_ShareContext, {
        actionGA: actionGA,
        closeToast: closeToast,
        dataSelector: "ShareContext",
        displayToastOnContextShare: displayToastOnContextShare,
        i18n: i18n,
        onToggleModal: this.toggleShareContextModal
      }) : null, !!this.state.refreshedProposal && BookingEngine_jsx(RefreshProposalModal, {
        resort: this.props.resort,
        refreshedProposal: this.state.refreshedProposal,
        selectedProposal: this.props.selectedProposal
      }))))), currentStep === BOOKING_STEPS.PARTICIPANTS.BE_RESPONSIVE && BookingEngine_jsx("div", {
        className: "relative m-auto max-w-site-medium border-t-1 border-grey px-20 py-60"
      }, BookingEngine_jsx(ParticipantsReassurance_ParticipantsReassurance, {
        i18n: i18n,
        proposal: selectedProposal,
        resort: resort
      })), BookingEngine_jsx(react_default.a.Fragment, null, BookingEngine_jsx(BookingFooter["a" /* BookingFooter */], {
        footer: i18n.footer,
        className: "mt-100"
      }), BookingEngine_jsx("div", {
        className: "h-[128px]"
      })), BookingEngine_jsx(TravelPlans_TravelPlansComponent, {
        savedProposal: this.state.savedProposal,
        selectedProposal: this.props.selectedProposal,
        resort: this.props.resort,
        setFavorite: this.setFavorite
      }), BookingEngine_jsx(BlockMismatchProposalCountry_BlockMismatchProposalCountry, {
        selectedProposal: selectedProposal,
        resort: resort
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var _props$abTastyData, _props$abTastyData2, _props$abTastyData3, _props$abTastyData4, _props$abTastyData5;

      if (isEmpty_default()(props.proposals) || !props.resort || !props.i18n.booking || !props.selectedProposal) {
        return null;
      }

      var path = new URI_default.a(props.router.asPath).pathname();
      /**
       * For indirect seller, the redirection to option page happens before BookingEngine unmount
       * BookingEngine calculates a wrong state from option url and add transport path to the option url
       * To avoid this behavior we stop calculating state from the option location
       */

      var shouldHideActivitiesStepAbTest = ((_props$abTastyData = props.abTastyData) === null || _props$abTastyData === void 0 ? void 0 : _props$abTastyData['ab-test-activities']) === '1' || ((_props$abTastyData2 = props.abTastyData) === null || _props$abTastyData2 === void 0 ? void 0 : _props$abTastyData2['ab-test-activities-br']) === '1' || ((_props$abTastyData3 = props.abTastyData) === null || _props$abTastyData3 === void 0 ? void 0 : _props$abTastyData3['ab-test-activities-ca']) === '1' || ((_props$abTastyData4 = props.abTastyData) === null || _props$abTastyData4 === void 0 ? void 0 : _props$abTastyData4['ab-test-activities-jp']) === '1' || ((_props$abTastyData5 = props.abTastyData) === null || _props$abTastyData5 === void 0 ? void 0 : _props$abTastyData5['ab-test-activities-uk']) === '1';
      var isPartiallyPaid = state.attendeesPaymentStatus.some(function (status) {
        return status.hasPaid;
      });

      var availableSteps = Object(BookingEngine_utils["f" /* getFilteredBreadcrumbPages */])({
        selectedProposal: props.selectedProposal,
        resort: props.resort,
        i18n: props.i18n,
        isActivitiesViewFeatureFlipped: state.displayActivities,
        isOptionHoldOnlyFeatureFlipped: state.optionHoldOnly,
        isPartiallyPaid: isPartiallyPaid,
        shouldHideActivitiesStepAbTest: shouldHideActivitiesStepAbTest
      });

      var step = availableSteps.findIndex(function (el) {
        return path === el.path;
      });
      var newStep = Math.max(0, step); // if the user is went further than the contact info page and come back to change the proposal (change the package or the comfort)
      // we disabled any further step to prevent some booking bug #11871

      var newUnlockedStep = !state.previousSelectedProposalId || state.previousSelectedProposalId === props.selectedProposal.id ? Math.max(state.unlockedStep, step) : Math.min(state.unlockedStep, availableSteps.findIndex(function (el) {
        return el.path.includes('participants');
      }));
      return {
        unlockedStep: newUnlockedStep,
        step: newStep,
        previousSelectedProposalId: props.selectedProposal.id
      };
    }
  }]);

  return BookingEngineComponent;
}(react_default.a.PureComponent);

Object(defineProperty["a" /* default */])(BookingEngine_BookingEngineComponent, "contextType", ReactAppContext["a" /* B2CAppContext */]);

var BookingEngine_BookingEngine = function BookingEngine(props) {
  var _ref10;

  var selectedProposal = props.selectedProposal,
      resort = props.resort,
      _props$router$query = props.router.query,
      step = _props$router$query.bookingStep,
      proposalIds = _props$router$query.proposalIds;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackEvent = _useTrackEvent.trackEvent,
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var shouldTrack = !!selectedProposal && !!resort; // in the case of a single proposal it comes as an item Otherwise as an Array ...

  var sortedProposalIds = (_ref10 = (Array.isArray(proposalIds) ? proposalIds : [proposalIds]) || []) === null || _ref10 === void 0 ? void 0 : _ref10. // $FlowFixMe : nevers happens with booleans
  sort(function (a, b) {
    return a < b;
  });
  var beginCheckoutCookie = sortedProposalIds.join('_') + '_co';
  Object(react["useEffect"])(function () {
    var _selectedProposal$pri, _selectedProposal$pri2, _selectedProposal$pri3;

    var hasAlreadyTracked = js_cookie_default.a.get(beginCheckoutCookie);

    if (hasAlreadyTracked || !selectedProposal || !resort) {
      return;
    }

    trackEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].BEGIN_CHECKOUT, {
      ecommerce: {
        items: [{
          item_id: resort.id,
          item_name: resort.name,
          price: selectedProposal.price.total.value
        }]
      }
    });
    trackEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].ADD_TO_CART, {
      ecommerce: {
        value: (_selectedProposal$pri = selectedProposal.price) === null || _selectedProposal$pri === void 0 ? void 0 : (_selectedProposal$pri2 = _selectedProposal$pri.total) === null || _selectedProposal$pri2 === void 0 ? void 0 : _selectedProposal$pri2.value,
        currency: (_selectedProposal$pri3 = selectedProposal.price) === null || _selectedProposal$pri3 === void 0 ? void 0 : _selectedProposal$pri3.currency,
        items: [{
          item_id: resort.id,
          item_name: resort.name,
          item_category: resort.destination.country,
          item_category2: resort.comfort,
          price: selectedProposal.price.total.value,
          quantity: 1
        }]
      }
    });
    js_cookie_default.a.set(beginCheckoutCookie, 'true', {
      expires: 1
    });
  }, [sortedProposalIds, resort, selectedProposal]);
  var trackAddToWishlist = Object(react["useCallback"])(function () {
    var _selectedProposal$acc, _selectedProposal$pri4, _selectedProposal$pri5, _selectedProposal$pri6, _selectedProposal$pri7, _selectedProposal$pri8;

    trackEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].ADD_TO_WISHLIST, {
      ecommerce: {
        items: [{
          item_id: selectedProposal.id,
          item_name: resort === null || resort === void 0 ? void 0 : resort.name,
          item_category: (_selectedProposal$acc = selectedProposal.accommodations) === null || _selectedProposal$acc === void 0 ? void 0 : _selectedProposal$acc.map(function (accommodation) {
            return accommodation.roomType;
          })[0],
          price: (_selectedProposal$pri4 = selectedProposal.price) === null || _selectedProposal$pri4 === void 0 ? void 0 : _selectedProposal$pri4.total.value,
          item_category2: moment_default()(selectedProposal.departureDate).format('L'),
          item_category3: selectedProposal.duration,
          item_category4: Object(TripDatePicker_utils["c" /* dateDiff */])(selectedProposal.departureDate, new Date()),
          item_category5: Boolean(selectedProposal.transports),
          coupon: (_selectedProposal$pri5 = selectedProposal.price) === null || _selectedProposal$pri5 === void 0 ? void 0 : (_selectedProposal$pri6 = _selectedProposal$pri5.promoCode) === null || _selectedProposal$pri6 === void 0 ? void 0 : _selectedProposal$pri6.offerId,
          discount: (_selectedProposal$pri7 = selectedProposal.price) === null || _selectedProposal$pri7 === void 0 ? void 0 : (_selectedProposal$pri8 = _selectedProposal$pri7.discounts) === null || _selectedProposal$pri8 === void 0 ? void 0 : _selectedProposal$pri8.reduce(function (acc, currentValue) {
            return acc + currentValue.amount.value;
          }, 0)
        }]
      }
    });
  }, [selectedProposal, resort]);
  var trackClickFavorite = Object(react["useCallback"])(function (origin, detailClick) {
    trackClickEvent(origin === 'bottomBar' ? tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_BOTTOM_BAR : tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
      detail_click: detailClick
    });
  }, []);
  var trackClickShare = Object(react["useCallback"])(function () {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
      detail_click: 'share'
    });
  }, []);
  var trackClickPreviousStep = Object(react["useCallback"])(function () {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_BOTTOM_BAR, {
      detail_click: 'back_step'
    });
  }, []);
  var trackClickSkipStep = Object(react["useCallback"])(function () {
    trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
      detail_click: 'skip_step'
    });
  }, []);
  var trackingContext = Object(react["useMemo"])(function () {
    var _selectedProposal$pri9, _resort$type, _selectedProposal$acc2, _selectedProposal$acc3, _selectedProposal$acc4, _ref11;

    if (!shouldTrack) {
      return undefined;
    }

    var arrivalDate = moment_default()(selectedProposal.arrivalDate);
    var daysBeforeDeparture = arrivalDate.diff(moment_default()(), 'days');

    var transportDeparture = get_default()(selectedProposal.transports, 'inbound.travelSections[0].departure', {});

    var isEclusiveCollectionAccommodation = get_default()(selectedProposal, 'accommodations[0].exclusiveCollection');

    return _ref11 = {}, Object(defineProperty["a" /* default */])(_ref11, "base_price_".concat(step), (_selectedProposal$pri9 = selectedProposal.price) === null || _selectedProposal$pri9 === void 0 ? void 0 : _selectedProposal$pri9.total.value), Object(defineProperty["a" /* default */])(_ref11, "reference_id", selectedProposal.id), Object(defineProperty["a" /* default */])(_ref11, "days_before_departure", daysBeforeDeparture), Object(defineProperty["a" /* default */])(_ref11, "departure_date_range", Object(BookingEngine_utils["c" /* getDepartureDateRange */])(daysBeforeDeparture)), Object(defineProperty["a" /* default */])(_ref11, "departure_quarter", arrivalDate.quarter()), Object(defineProperty["a" /* default */])(_ref11, "departure_semester", arrivalDate.quarter() > 2 ? 2 : 1), Object(defineProperty["a" /* default */])(_ref11, "resort_name", resort.name), Object(defineProperty["a" /* default */])(_ref11, "resort_code", resort.id), Object(defineProperty["a" /* default */])(_ref11, "resort_country", resort.destination.country), Object(defineProperty["a" /* default */])(_ref11, "resort_season_type", resort === null || resort === void 0 ? void 0 : resort.seasonName), Object(defineProperty["a" /* default */])(_ref11, "resort_region", resort.destination.area), Object(defineProperty["a" /* default */])(_ref11, "resort_exclusive_collection", Object(BookingEngine_utils["d" /* getExclusiveCollectionFromAccomodation */])(resort.hasECSpace, isEclusiveCollectionAccommodation)), Object(defineProperty["a" /* default */])(_ref11, "resort_type", (resort === null || resort === void 0 ? void 0 : (_resort$type = resort.type) === null || _resort$type === void 0 ? void 0 : _resort$type.toLowerCase()) || 'no'), Object(defineProperty["a" /* default */])(_ref11, "resort_adult", selectedProposal.attendees.adults.length), Object(defineProperty["a" /* default */])(_ref11, "resort_children", selectedProposal.attendees.children.length), Object(defineProperty["a" /* default */])(_ref11, "resort_departure_city_name", transportDeparture.label || 'no_transport'), Object(defineProperty["a" /* default */])(_ref11, "resort_departure_date", moment_default()(selectedProposal.arrivalDate).format('DD/MM/YYYY')), Object(defineProperty["a" /* default */])(_ref11, "resort_checkout_date", (selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.departureDate) ? moment_default()(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.departureDate).format('DD/MM/YYYY') : moment_default()(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.arrivalDate).add(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.duration, 'days').format('DD/MM/YYYY')), Object(defineProperty["a" /* default */])(_ref11, "resort_night_number", selectedProposal.duration), Object(defineProperty["a" /* default */])(_ref11, "resort_participants", selectedProposal.attendees.list.length), Object(defineProperty["a" /* default */])(_ref11, "resort_transport", selectedProposal.transports ? 'with_transport' : 'without_transport'), Object(defineProperty["a" /* default */])(_ref11, "resort_year_season", moment_default()(selectedProposal.departureDate || null, 'YYYYMMDD').format('YYYY')), Object(defineProperty["a" /* default */])(_ref11, "room_type", (_selectedProposal$acc2 = selectedProposal.accommodations[0].comfortId) === null || _selectedProposal$acc2 === void 0 ? void 0 : (_selectedProposal$acc3 = _selectedProposal$acc2.split('_')) === null || _selectedProposal$acc3 === void 0 ? void 0 : (_selectedProposal$acc4 = _selectedProposal$acc3.reverse()) === null || _selectedProposal$acc4 === void 0 ? void 0 : _selectedProposal$acc4[0]), _ref11;
  }, [selectedProposal, resort, shouldTrack, step]);
  return BookingEngine_jsx(BookingEngineTrackingContext["a" /* BookingEngineTrackingContext */].Provider, {
    value: trackingContext
  }, BookingEngine_jsx(BookingEngine_BookingEngineComponent, Object(esm_extends["a" /* default */])({}, props, {
    trackClickFavorite: trackClickFavorite,
    trackClickPreviousStep: trackClickPreviousStep,
    trackAddToWishlist: trackAddToWishlist,
    trackClickShare: trackClickShare,
    trackClickSkipStep: trackClickSkipStep,
    abTastyData: props.abTastyData
  })), shouldTrack && BookingEngine_jsx(TrackPage["a" /* TrackPage */], {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */]["BE_".concat(step.toUpperCase())],
    payload: BookingEngine_objectSpread({}, trackingContext)
  }));
};



var BookingEngine_BookingEngineWithAbTastyData = function BookingEngineWithAbTastyData(props) {
  var _useContext = Object(react["useContext"])(ABTestContext["a" /* ABTestContext */]),
      abTastyData = _useContext.abTastyData;

  return BookingEngine_jsx(BookingEngine_BookingEngine, Object(esm_extends["a" /* default */])({}, props, {
    abTastyData: abTastyData
  }));
};

/* harmony default export */ var booking_BookingEngine = (Object(Responsive["a" /* default */])(Object(next_router["withRouter"])(BookingEngine_BookingEngineWithAbTastyData)));
// CONCATENATED MODULE: ./src/client/views/booking/BookingEngine.container.js
















var BookingEngine_container_mapStateToProps = function mapStateToProps(state) {
  // if there is neolids we have identified attendees so we map the proposals with the attendees datas
  var proposals = Object(booking_selector["t" /* getProposals */])(state) || [];
  var resort = Object(booking_selector["j" /* getCurrentResort */])(state);
  var streetViews = Object(booking_selector["w" /* getStreetViews */])(state);
  return {
    i18n: state.cms,
    leadScore: Object(leadInfo_selector["a" /* getLeadScore */])(state),
    proposals: proposals,
    resort: resort,
    selectedProposal: find_default()(proposals, {
      id: Object(booking_selector["v" /* getSelectedProposalId */])(state)
    }) || Object(proposalUtils["d" /* getDefaultProposal */])(proposals, resort),
    streetViews: streetViews,
    tripInformation: state.tripInformation,
    userInfo: state.userInfo
  };
};
var mapDispatchToProps = {
  fetchProposalsById: proposals_action["l" /* fetchProposalsById */],
  fetchStreetViewsByAccommodationCategoryId: fetchStreetViewsByAccommodationCategoryId,
  selectProposal: selectedProposalId_action["d" /* selectProposal */],
  endLoading: globalLoader_action["c" /* endLoading */],
  startLoading: globalLoader_action["d" /* startLoading */],
  closeToast: toast_actions["c" /* closeToast */],
  patchProposalHandler: proposals_action["p" /* patchProposalHandler */],
  saveCustomerProposalsHandler: proposals_action["u" /* saveCustomerProposalsHandler */],
  displayToastOnContextShare: proposals_action["i" /* displayToastOnContextShare */],
  getBookingEngineI18n: cms_actions["c" /* getBookingEngineI18n */],
  fetchRefreshProposal: proposals_action["m" /* fetchRefreshProposal */]
};
var BookingEngineContainer = Object(errorBoundary["a" /* default */])(Object(es["c" /* connect */])(BookingEngine_container_mapStateToProps, mapDispatchToProps, undefined, // because of shallow routing used inside the BE, the page changes without the props changing,
// so redux prevents the re-rendering (why btw? There's a withRouter lower, this is still weird)
{
  pure: false
})(booking_BookingEngine));
BookingEngineContainer.pageId = routes_constants["b" /* BOOKING_ENGINE_PAGE_ID */];
BookingEngineContainer.pageType = tracking_constants["C" /* STATIC_PAGE_TYPES */].BE;
BookingEngineContainer.disableFooter = true;
BookingEngineContainer.disableHeader = true;
/* harmony default export */ var BookingEngine_container = (BookingEngineContainer);
// CONCATENATED MODULE: ./pages/booking/[bookingStep].js

/* harmony default export */ var _bookingStep_ = __webpack_exports__["default"] = (BookingEngine_container);

/***/ }),

/***/ "U6GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDown; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("05v4");
/* harmony import */ var _DropDown_themes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Q8Qh");











var __jsx = react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */




var DropDown = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(DropDown, _Component);

  var _super = _createSuper(DropDown);

  function DropDown(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, DropDown);

    _this = _super.call(this, props);

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "rootRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "contentRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "expand", function () {
      _this.setState({
        isExpanded: true
      }, _this.toggleEventListeners);
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "collapse", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      if (!_this.props.unmountsOnClose) {
        _this.setState({
          isExpanded: false
        }, _this.toggleEventListeners);
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onKeyDown", function (e) {
      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__[/* ESCAPE */ "g"]) {
        _this.collapse();
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onClickOutside", function (e) {
      if (!_this.contentRef || // $FlowFixMe
      _this.contentRef.current.contains(e.target) || // $FlowFixMe
      _this.rootRef.current.contains(e.target) || // $FlowFixMe
      lodash_get__WEBPACK_IMPORTED_MODULE_10___default()(_this.props, 'rootRef.current') && _this.props.rootRef.current.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      _this.collapse();
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }, _this.toggleEventListeners);
    });

    _this.state = {
      isExpanded: props.isExpanded || false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isExpanded) {
        this.removeEventListeners();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isExpanded !== this.props.isExpanded) {
        this.setState({
          isExpanded: nextProps.isExpanded
        }, this.toggleEventListeners);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      if (true) {
        document.addEventListener('mouseup', this.onClickOutside, false);
        document.addEventListener('touchstart', this.onClickOutside, false);
        document.addEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (true) {
        document.removeEventListener('mouseup', this.onClickOutside, false);
        document.removeEventListener('touchstart', this.onClickOutside, false);
        document.removeEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "toggleEventListeners",
    value: function toggleEventListeners() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      } else {
        this.removeEventListeners();
      }
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          contentStyle = _this$props.contentStyle,
          contentClassName = _this$props.contentClassName,
          hasArrow = _this$props.hasArrow,
          hasCloseOnClick = _this$props.hasCloseOnClick,
          noLayout = _this$props.noLayout,
          renderTrigger = _this$props.renderTrigger,
          theme = _this$props.theme;
      var thBody = Object(_DropDown_themes__WEBPACK_IMPORTED_MODULE_14__[/* themes */ "a"])({
        hasArrow: hasArrow
      })[theme].thBody;
      return __jsx("div", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__[/* classnames */ "a"])('inline-block', className),
        ref: this.rootRef
      }, renderTrigger && renderTrigger(this.toggle, this.state.isExpanded), this.state.isExpanded && __jsx("div", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__[/* classnames */ "a"])({
          'absolute left-1/2 w-full min-w-full -translate-x-1/2 transform': !noLayout
        }, contentClassName, thBody),
        "data-testid": "DropDown-body",
        onClick: hasCloseOnClick ? this.collapse : null,
        ref: this.contentRef,
        style: contentStyle
      }, children(this.toggle, this.state.isExpanded)));
    }
  }]);

  return DropDown;
}(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(DropDown, "defaultProps", {
  hasArrow: true,
  isExpanded: false,
  noLayout: false,
  theme: 'default',
  unmountsOnClose: false
});

/***/ }),

/***/ "U6Jk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ PAYMENT_PLAN_IFRAME; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ PAYMENT_PLAN_SELECTOR; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BUY_NOW_PAY_LATER_PRICING; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ BUY_NOW_PAY_LATER_PROVIDER; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfoContext.js
var PaymentInfoContext = __webpack_require__("lr0Z");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/client/views/account/pre-payment/PrePaymentView.utils.js
var PrePaymentView_utils = __webpack_require__("4Vo9");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/uplift-form/script.js
var script = __webpack_require__("MZRd");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/uplift-form/UpliftForm.utils.js
var UpliftForm_utils = __webpack_require__("NYMU");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/uplift-form/useUplift.js






var UpliftStatus = {
  OFFER_AVAILABLE: 'OFFER_AVAILABLE',
  TOKEN_AVAILABLE: 'TOKEN_AVAILABLE',
  TOKEN_RETRIEVED: 'TOKEN_RETRIEVED',
  OFFER_UNAVAILABLE: 'OFFER_UNAVAILABLE',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE'
};
var useUplift_useUplift = function useUplift(_ref) {
  var _ref$onLoaded = _ref.onLoaded,
      onLoaded = _ref$onLoaded === void 0 ? noop_default.a : _ref$onLoaded,
      _ref$onTokenAvailable = _ref.onTokenAvailable,
      onTokenAvailable = _ref$onTokenAvailable === void 0 ? noop_default.a : _ref$onTokenAvailable,
      _ref$onTokenRetrieved = _ref.onTokenRetrieved,
      onTokenRetrieved = _ref$onTokenRetrieved === void 0 ? noop_default.a : _ref$onTokenRetrieved,
      booking = _ref.booking,
      currency = _ref.currency,
      isReadyToDisplay = _ref.isReadyToDisplay,
      _ref$shouldInit = _ref.shouldInit,
      shouldInit = _ref$shouldInit === void 0 ? true : _ref$shouldInit,
      _ref$isPaymentPage = _ref.isPaymentPage,
      isPaymentPage = _ref$isPaymentPage === void 0 ? false : _ref$isPaymentPage;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale,
      country = _useAppContext.country;

  var _useState = Object(react["useState"])(false),
      isOfferAvailable = _useState[0],
      setIsOfferAvailable = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isUpliftModalOpen = _useState2[0],
      setIsUpliftModalOpen = _useState2[1];

  var shouldDisplay = isOfferAvailable && isReadyToDisplay;
  var upliftCode = config_default.a.get("psp.uplift.".concat(country, ".code"));
  var order = Object(UpliftForm_utils["a" /* buildOrder */])(booking);

  var onChange = function onChange(_ref2) {
    var status = _ref2.status,
        token = _ref2.token;

    if (status === UpliftStatus.OFFER_AVAILABLE) {
      onLoaded(true);
      setIsOfferAvailable(true);
    }

    if (status === UpliftStatus.TOKEN_AVAILABLE) {
      onTokenAvailable();
    }

    if (status === UpliftStatus.TOKEN_RETRIEVED) {
      var cardToken = token.card_token;
      window.Uplift.Analytics.orderSubmit(order, {
        mode_of_payment: 'pay monthly',
        payment_options: ['pay monthly']
      });
      onTokenRetrieved(cardToken);
    }

    if (status === UpliftStatus.OFFER_UNAVAILABLE || status === UpliftStatus.SERVICE_UNAVAILABLE) {
      onLoaded(false);
    }
  };

  var isUpliftInitialized = function isUpliftInitialized() {
    return !!window.Uplift;
  };

  var configuration = {
    apiKey: config_default.a.get('psp.uplift.apiKey'),
    locale: locale,
    currency: currency,
    checkout: isPaymentPage,
    channel: 'desktop',
    container: '#uplift-container',
    onChange: onChange
  };

  var initUplift = function initUplift() {
    // TO FIX: uplift info modal work only if is initialized twice on payment page
    window.Uplift.Payments.init(configuration);
    window.Uplift.Payments.load(order);
    window.Uplift.Payments.init(configuration);
    window.Uplift.Payments.load(order);
  };

  Object(react["useEffect"])(function () {
    if (isPaymentPage && shouldDisplay) {
      window.Uplift.Payments.select();
    }
  }, [shouldDisplay, isPaymentPage]);
  Object(react["useEffect"])(function () {
    if (!isPaymentPage && isUpliftInitialized()) {
      onLoaded(false);
      window.Uplift.Payments.load(order);
    }
  }, [order.order_amount, isPaymentPage]);
  Object(react["useEffect"])(function () {
    if (shouldDisplay) {
      setIsUpliftModalOpen(true);
    } else if (isUpliftModalOpen) {
      window.Uplift.Payments.deselect();
      setIsUpliftModalOpen(false);
    }
  }, [shouldDisplay, isUpliftModalOpen]);
  Object(react["useEffect"])(function () {
    if (shouldInit) {
      isUpliftInitialized() && window.Uplift.Payments.exit();
      upliftCode && Object(script["a" /* loadUplift */])(upliftCode);
      window.upReady = initUplift;
    }
  }, [shouldInit]);
  return {
    shouldDisplay: shouldDisplay
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/uplift-form/UpliftForm.jsx






var __jsx = react_default.a.createElement;













var getAttendeesQuery = function getAttendeesQuery(attendeesId) {
  return "query { \n  attendees(attendeesIds: [\"".concat(attendeesId.join('","'), "\"]) {\n          firstName\n          lastName\n          dateOfBirth\n          mobilePhoneNumber\n          email\n          address {\n            streetNumber\n            streetName\n            zipCode\n            city\n            stateOrDistrict\n            countryCode\n          }\n      }\n}");
};

var UpliftForm_UpliftForm = function UpliftForm(_ref) {
  var _onLoaded = _ref.onLoaded,
      price = _ref.price,
      display = _ref.display;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      onBuyNowPayLaterComplete = _useContext.onBuyNowPayLaterComplete,
      currency = _useContext.currency,
      _useContext$bookingRe = _useContext.bookingResume,
      _useContext$bookingRe2 = _useContext$bookingRe.attendees,
      attendeesResume = _useContext$bookingRe2 === void 0 ? [] : _useContext$bookingRe2,
      accommodations = _useContext$bookingRe.accommodations,
      transports = _useContext$bookingRe.transports,
      departureDate = _useContext$bookingRe.departureDate,
      arrivalDate = _useContext$bookingRe.arrivalDate,
      name = _useContext$bookingRe.name;

  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var router = Object(next_router["useRouter"])();
  var _router$query = router.query,
      a = _router$query.a,
      bnpl = _router$query.bnpl,
      paymentStatus = _router$query.paymentStatus;
  var isProposalLoading = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.isProposalLoading;
  });
  var attendees = Object(PrePaymentView_utils["b" /* extractPayload */])(a) || [];

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isUserLogged = _useAppContext.isUserLogged,
      isUserQuickLogged = _useAppContext.isUserQuickLogged;

  var onTokenAvailable = function onTokenAvailable() {
    onBuyNowPayLaterComplete();
  };

  var onTokenRetrieved = function onTokenRetrieved(token) {
    if (token) {
      formik.setFieldValue('token', token);
      formik.submitForm();
    }
  };

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: getAttendeesQuery(attendeesResume),
    ignore: !isUserLogged || attendeesResume.length === 0,
    cache: true
  }),
      data = _useGQL.data,
      isAttendeesLoading = _useGQL.isLoading;

  var booking = {
    price: price,
    attendees: (data === null || data === void 0 ? void 0 : data.attendees) || (isUserQuickLogged ? attendeesResume : attendees) || [],
    accommodations: accommodations,
    transports: transports,
    departureDate: departureDate,
    arrivalDate: arrivalDate,
    name: name
  };

  var _useUplift = useUplift_useUplift({
    shouldInit: !isAttendeesLoading && !isProposalLoading,
    isPaymentPage: true,
    isReadyToDisplay: display,
    booking: booking,
    currency: currency,
    onTokenAvailable: onTokenAvailable,
    onTokenRetrieved: onTokenRetrieved,
    onLoaded: function onLoaded(loaded) {
      _onLoaded(loaded);

      if (bnpl && paymentStatus) {
        Object(UpliftForm_utils["b" /* trackUplift */])({
          isErrored: true,
          errorMsg: paymentStatus
        });
        var newUri = new URI_default.a(router.asPath).removeQuery(['bnpl']);
        router.replace(newUri.toString());
      }
    }
  }),
      shouldDisplay = _useUplift.shouldDisplay;

  return __jsx(Capsule["a" /* Capsule */], {
    className: "".concat(shouldDisplay ? 'block' : 'hidden', " my-40")
  }, __jsx("div", {
    id: "uplift-container"
  }));
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.utils.jsx
var BuyNowPayLater_utils = __webpack_require__("AV+p");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/uplift-form/UpliftPrice.jsx


var UpliftPrice_jsx = react_default.a.createElement;







var UpliftPrice_UpliftPrice = function UpliftPrice(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      currency = _ref.currency,
      iconClassname = _ref.iconClassname,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "currency", "iconClassname"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale,
      language = _useAppContext.language;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      defaultCurrency = _useContext.currency;

  var _getCurrency = Object(currencyConfigForLocale["c" /* getCurrency */])(locale, currency || defaultCurrency),
      symbol = _getCurrency.symbol;

  var isFrench = language === 'fr';
  return UpliftPrice_jsx("span", Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('none cursor-pointer', className)
  }, props), !isFrench && symbol, UpliftPrice_jsx("span", {
    "data-up-from-currency-unit-major": ""
  }), isFrench && symbol, "/mo", UpliftPrice_jsx("span", {
    "data-up-tooltip": "",
    className: Object(classnames_utils["a" /* classnames */])('absolute', iconClassname)
  }, UpliftPrice_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].INFORMATION,
    width: "1.5rem"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/uplift-form/UpliftSelector.jsx
var UpliftSelector_jsx = react_default.a.createElement;




var UpliftSelector_UpliftSelector = function UpliftSelector(_ref) {
  var price = _ref.price,
      iconClassname = _ref.iconClassname;
  return UpliftSelector_jsx("div", {
    id: "up-pay-monthly-selector"
  }, UpliftSelector_jsx("span", null, Object(i18n["h" /* t */])('booking.banking.paymentSchedule.payMonthly')), UpliftSelector_jsx(UpliftPrice_UpliftPrice, {
    id: "up-pay-monthly-selector-from-pricing",
    iconClassname: iconClassname,
    className: "font-bold text-sienna",
    "data-up-price-type": "total",
    "data-up-price-value": Object(BuyNowPayLater_utils["a" /* computePriceInCents */])(price)
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/uplift-form/UplfitFromPricing.jsx

var UplfitFromPricing_jsx = react_default.a.createElement;







var UplfitFromPricing_UpliftFromPricing = function UpliftFromPricing(_ref) {
  var isPaymentPage = _ref.isPaymentPage,
      proposal = _ref.proposal,
      price = _ref.price,
      iconClassname = _ref.iconClassname;

  var _useState = Object(react["useState"])(null),
      isLoaded = _useState[0],
      setIsLoaded = _useState[1];

  var booking = {
    arrivalDate: proposal.departureDate,
    departureDate: proposal.arrivalDate,
    name: proposal.productId,
    accommodationsCount: proposal.accommodationsCount,
    attendees: [],
    price: price.total.value
  };
  useUplift_useUplift({
    onLoaded: setIsLoaded,
    currency: proposal.price.currency,
    booking: booking,
    isPaymentPage: isPaymentPage,
    shouldInit: !isPaymentPage
  });
  Object(react["useEffect"])(function () {
    setIsLoaded(isPaymentPage ? true : null);
  }, [isPaymentPage]);
  var isLoading = isLoaded === null;
  return UplfitFromPricing_jsx("div", {
    className: "flex text-center lg:justify-center"
  }, isLoading && UplfitFromPricing_jsx(AsyncLoader["a" /* AsyncLoader */], {
    size: "small"
  }), UplfitFromPricing_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('text-normal hidden font-sans text-14 lg:text-center', Object(defineProperty["a" /* default */])({}, '!hidden', isLoading)),
    "data-up-price-value": Object(BuyNowPayLater_utils["a" /* computePriceInCents */])(price.total.value),
    "data-up-price-type": "total"
  }, UplfitFromPricing_jsx("span", null, Object(i18n["h" /* t */])('booking.banking.paymentSchedule.fromPricing'), " "), UplfitFromPricing_jsx(UpliftPrice_UpliftPrice, {
    currency: proposal.price.currency,
    iconClassname: iconClassname
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/hooks/use-script-loader/useScriptLoader.js
var useScriptLoader = __webpack_require__("/WwO");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/pledg-form/usePledg.js

















var usePledg_usePledgSignature = function usePledgSignature(_ref, _ref2) {
  var _data$requestToken;

  var price = _ref.price;
  var _ref2$ignore = _ref2.ignore,
      ignore = _ref2$ignore === void 0 ? false : _ref2$ignore;
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      _useContext$bookingRe = _useContext.bookingResume,
      bookingId = _useContext$bookingRe.bookingId,
      proposalId = _useContext$bookingRe.proposalId,
      name = _useContext$bookingRe.name,
      getPaymentErrorMessagePath = _useContext.getPaymentErrorMessagePath;

  var track = Object(useTracking["a" /* useTracking */])();
  var currentPayingCustomerId = formik.values.currentPayingCustomerId;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: "mutation { \n      requestToken(\n        ".concat(proposalId ? "proposalId: \"".concat(proposalId, "\",") : '', "\n        ").concat(bookingId ? "bookingId: \"".concat(bookingId, "\",") : '', "\n        customerId: \"").concat(currentPayingCustomerId, "\",\n        providerId: \"").concat(PaymentInfo_const["o" /* PLEDG_PSP_ID */], "\",\n        amount: ").concat(price, ",\n        name: \"").concat(Object(i18n["h" /* t */])('booking.common.clubmed'), " ").concat(name, "\",\n        currency: \"EUR\") {\n          token\n      }\n    }"),
    cache: true,
    ignore: ignore
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading,
      error = _useGQL.error;

  return {
    signature: data === null || data === void 0 ? void 0 : (_data$requestToken = data.requestToken) === null || _data$requestToken === void 0 ? void 0 : _data$requestToken.token,
    isLoading: isLoading,
    error: !!error && getPaymentErrorMessagePath({
      statusCode: get_default()(error.errors, '[0].statusCode', statusCode_constants["b" /* STATUS_CODE_400 */]),
      errorCode: get_default()(error.errors[0], 'errorCode'),
      track: track
    })
  };
};

var usePledg_usePledg = function usePledg(_ref3) {
  var price = _ref3.price,
      onLoaded = _ref3.onLoaded,
      shouldInit = _ref3.shouldInit;
  var scriptUrl = config_default.a.get('psp.pledg.script_url');

  var _useState = Object(react["useState"])(false),
      isPledgLoading = _useState[0],
      setIsPledgLoading = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isPledgLoaded = _useState2[0],
      setIsPledgLoaded = _useState2[1];

  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useState3 = Object(react["useState"])(''),
      pledgError = _useState3[0],
      setPledgError = _useState3[1];

  var _usePledgSignature = usePledg_usePledgSignature({
    price: price
  }, {
    ignore: !shouldInit && !isPledgLoaded
  }),
      signature = _usePledgSignature.signature,
      isLoading = _usePledgSignature.isLoading,
      error = _usePledgSignature.error;

  var handleRedirect = function handleRedirect(_ref4) {
    var purchase = _ref4.purchase;
    formik.setFieldValue('paymentId', purchase.reference);
    formik.submitForm();
  };

  var handleError = function handleError(_ref5) {
    var e = _ref5.error;
    setPledgError(e === null || e === void 0 ? void 0 : e.message);
    formik.setFieldError('paymentId', '');
  };

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(scriptUrl),
      scriptLoaded = _useScriptLoader.scriptLoaded;

  Object(react["useEffect"])(function () {
    onLoaded(true);
  }, []);
  Object(react["useEffect"])(function () {
    isLoading && setIsPledgLoading(isLoading);
  }, [isLoading]);
  Object(react["useEffect"])(function () {
    setIsPledgLoaded(signature && scriptLoaded);
  }, [signature, scriptLoaded]);
  Object(react["useEffect"])(function () {
    if (signature && scriptUrl && scriptLoaded) {
      var button = document.querySelector('#pledg-button'); // eslint-disable-next-line no-new

      new window.Pledg(button, {
        showCloseButton: false,
        signature: signature,
        containerElement: document.querySelector('#pledg-funnel-container'),
        onSuccess: handleRedirect,
        onCheckValidity: handleError,
        onError: handleError
      });
      document.getElementById('pledg-button').click();
      setIsPledgLoading(false);
    }
  }, [signature, scriptLoaded]);
  return {
    isLoading: isPledgLoading,
    error: pledgError || error
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/pledg-form/PledgForm.jsx



var PledgForm_jsx = react_default.a.createElement;







var PledgForm_PledgForm = function PledgForm(_ref) {
  var onLoaded = _ref.onLoaded,
      price = _ref.price,
      display = _ref.display;

  var _usePledg = usePledg_usePledg({
    price: price,
    onLoaded: onLoaded,
    shouldInit: display
  }),
      isLoading = _usePledg.isLoading,
      error = _usePledg.error;

  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var cgv = formik.values.termsAndConditions.cgv;
  Object(react["useEffect"])(function () {
    if (error) {
      onLoaded(false);
      formik.resetForm();
    }
  }, [error]);
  return PledgForm_jsx(react_default.a.Fragment, null, PledgForm_jsx(Capsule["a" /* Capsule */], {
    header: "none",
    className: "".concat(display ? 'block' : 'hidden', " my-40")
  }, isLoading && PledgForm_jsx(AsyncLoader["a" /* AsyncLoader */], null), PledgForm_jsx("div", {
    id: "pledg-funnel-container"
  }), PledgForm_jsx("span", {
    id: "pledg-button",
    disabled: true
  })), !cgv && error && PledgForm_jsx(FormFeedback["a" /* FormFeedback */], {
    hasAutoScroll: true,
    className: "my-30",
    isError: true,
    message: Object(i18n["h" /* t */])(error)
  }));
};
// EXTERNAL MODULE: ./src/hooks/use-disclosure/useDisclosure.js
var useDisclosure = __webpack_require__("Re84");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/pledg-form/PledgForm.utils.js
var PledgForm_utils = __webpack_require__("+3y+");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/pledg-form/usePledgSchedule.js






var usePledgSchedule_simulatePaymentSchedule = function simulatePaymentSchedule(_ref) {
  var price = _ref.price;
  return Object(PledgForm_utils["a" /* fetchPledg */])('/simulate_payment_schedule', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      amount_cents: Math.round(price * 100),
      created: moment_default()().format('YYYY-MM-DD')
    })
  });
};

var usePledgSchedule_formatPrice = function formatPrice(price) {
  var _getCurrency = Object(currencyConfigForLocale["c" /* getCurrency */])('fr-FR', 'EUR'),
      symbol = _getCurrency.symbol;

  return "".concat((price / 100).toLocaleString('fr-FR'), " ").concat(symbol);
};

var usePledgSchedule_usePledgSchedule = function usePledgSchedule(_ref2) {
  var price = _ref2.price;

  var _useState = Object(react["useState"])({
    INSTALLMENT: [{
      amount_cents: 0
    }]
  }),
      paymentSchedule = _useState[0],
      setPaymentSchedule = _useState[1];

  Object(react["useEffect"])(function () {
    usePledgSchedule_simulatePaymentSchedule({
      price: price
    }).then(setPaymentSchedule);
  }, [price]);
  var installment = paymentSchedule.INSTALLMENT;
  var _installment$ = installment[0],
      amountCents = _installment$.amount_cents,
      fees = _installment$.fees;
  return {
    installment: installment,
    monthlyPayment: usePledgSchedule_formatPrice(amountCents),
    fees: usePledgSchedule_formatPrice(fees),
    firstPayment: usePledgSchedule_formatPrice(amountCents + fees)
  };
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/pledg-form/PledgTimelinesModal.jsx

var PledgTimelinesModal_jsx = react_default.a.createElement;






var PLEDG_INSTALLMENT_COUNT = 4;

var PledgTimelinesModal_formatPrice = function formatPrice(price) {
  return (price / 100).toLocaleString('fr-FR');
};

var PledgTimelinesModal_PledgTimelinesModal = function PledgTimelinesModal(_ref) {
  var onCloseModal = _ref.onCloseModal,
      installment = _ref.installment,
      total = _ref.total;
  return PledgTimelinesModal_jsx(Modal["a" /* Modal */], {
    className: "p-10",
    size: "small",
    onClose: onCloseModal
  }, PledgTimelinesModal_jsx("div", {
    className: "flex flex-col items-center p-20",
    "data-testid": "pledg-instalments"
  }, PledgTimelinesModal_jsx(Text["a" /* Text */], {
    className: "pb-20 text-12",
    text: Object(i18n["h" /* t */])('booking.banking.paymentSchedule.bnpl.title')
  }), PledgTimelinesModal_jsx("div", {
    className: "flex w-full flex-col"
  }, PledgTimelinesModal_jsx("div", {
    className: "flex flex-col pb-40 text-center"
  }, PledgTimelinesModal_jsx(TemplateString["a" /* TemplateString */], {
    className: "font-bold",
    template: Object(i18n["h" /* t */])('booking.banking.paymentSchedule.bnpl.orderAmount'),
    values: {
      amount: total
    }
  }), PledgTimelinesModal_jsx(TemplateString["a" /* TemplateString */], {
    className: "font-bold text-sienna",
    template: Object(i18n["h" /* t */])('booking.banking.paymentSchedule.bnpl.subtitle'),
    values: {
      count: PLEDG_INSTALLMENT_COUNT
    }
  })), installment.map(function (_ref2, index) {
    var amount = _ref2.amount_cents,
        fees = _ref2.fees,
        date = _ref2.payment_date;
    return PledgTimelinesModal_jsx("div", {
      key: date,
      className: "flex justify-between pb-20 text-14"
    }, PledgTimelinesModal_jsx("div", {
      className: "flex flex-col"
    }, PledgTimelinesModal_jsx(TemplateString["a" /* TemplateString */], {
      values: {
        count: index + 1
      },
      template: "".concat(Object(i18n["h" /* t */])(index ? 'booking.banking.paymentSchedule.bnpl.otherInstallment' : 'booking.banking.paymentSchedule.bnpl.firstInstallment'))
    }), PledgTimelinesModal_jsx(TemplateString["a" /* TemplateString */], {
      values: {
        date: moment_default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
      },
      valuesClassName: {
        date: 'font-bold'
      },
      template: "".concat(Object(i18n["h" /* t */])('common.transport.onDate').toLowerCase())
    })), PledgTimelinesModal_jsx("div", {
      className: "text-right"
    }, PledgTimelinesModal_jsx(Text["a" /* Text */], {
      className: "text-12 font-bold text-sienna",
      text: "".concat(PledgTimelinesModal_formatPrice(amount + fees), " \u20AC")
    }), !!fees && PledgTimelinesModal_jsx(TemplateString["a" /* TemplateString */], {
      values: {
        amount: PledgTimelinesModal_formatPrice(fees)
      },
      className: "text-10",
      template: "".concat(Object(i18n["h" /* t */])('booking.banking.paymentSchedule.bnpl.feesInclude'))
    })));
  })), PledgTimelinesModal_jsx("span", {
    className: "pb-10 pt-20 text-justify text-10 text-mediumGrey"
  }, Object(i18n["h" /* t */])('booking.banking.paymentSchedule.bnpl.legalpledg'))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/pledg-form/PledgPrice.jsx

var PledgPrice_jsx = react_default.a.createElement;








var PledgPrice_PledgPrice = function PledgPrice(_ref) {
  var _classnames;

  var price = _ref.price,
      label = _ref.label,
      iconClassname = _ref.iconClassname;

  var _usePledgSchedule = usePledgSchedule_usePledgSchedule({
    price: price
  }),
      monthlyPayment = _usePledgSchedule.monthlyPayment,
      fees = _usePledgSchedule.fees,
      firstPayment = _usePledgSchedule.firstPayment,
      installment = _usePledgSchedule.installment;

  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isOpen = _useDisclosure.isOpen,
      onClose = _useDisclosure.onClose,
      onOpen = _useDisclosure.onOpen;

  var isSinglePrice = !label;
  return PledgPrice_jsx(react_default.a.Fragment, null, PledgPrice_jsx("span", {
    className: "none cursor-pointer text-14",
    role: "button",
    "aria-hidden": "true"
  }, PledgPrice_jsx(TemplateString["a" /* TemplateString */], {
    template: label || '{monthlyPayment}',
    valuesClassName: {
      firstPayment: 'font-bold text-sienna',
      monthlyPayment: Object(classnames_utils["a" /* classnames */])((_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, 'font-bold text-sienna', !isSinglePrice), Object(defineProperty["a" /* default */])(_classnames, 'text-12', isSinglePrice), _classnames)),
      fees: 'font-bold text-sienna'
    },
    values: {
      firstPayment: firstPayment,
      monthlyPayment: monthlyPayment,
      fees: fees
    }
  }), PledgPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('absolute', iconClassname),
    onClick: function onClick(e) {
      e.preventDefault();
      onOpen();
    }
  }, PledgPrice_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].INFORMATION,
    width: "1.5rem",
    className: Object(classnames_utils["a" /* classnames */])(Object(defineProperty["a" /* default */])({}, 'text-sienna', !isSinglePrice))
  }))), isOpen && PledgPrice_jsx(PledgTimelinesModal_PledgTimelinesModal, {
    onCloseModal: onClose,
    installment: installment,
    total: price
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/pledg-form/PledgFromPricing.jsx
var PledgFromPricing_jsx = react_default.a.createElement;



var PledgFromPricing_PledgFromPricing = function PledgFromPricing(_ref) {
  var price = _ref.price,
      iconClassname = _ref.iconClassname;
  return PledgFromPricing_jsx("div", {
    className: "md:text-center"
  }, PledgFromPricing_jsx("span", {
    className: "text-12"
  }, Object(i18n["h" /* t */])('booking.banking.paymentSchedule.fromPricing')), PledgFromPricing_jsx(PledgPrice_PledgPrice, {
    price: price.total.value,
    iconClassname: iconClassname
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/oney-form/useOneySimulationPopin.jsx




var useOneySimulationPopin_useOneySimulationPopin = function useOneySimulationPopin(_ref) {
  var price = _ref.price;
  Object(useScriptLoader["a" /* useScriptLoader */])(config_default.a.get('psp.oney.script_url'));

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      country = _useAppContext.country,
      language = _useAppContext.language;

  var handlePopinClick = function handlePopinClick(e) {
    e.preventDefault();
    var options = {
      country: country,
      language: language.toUpperCase(),
      merchant_guid: config_default.a.get('psp.oney.merchand_id'),
      payment_amount: price,
      filter_by: 'filters',
      filters: [{
        payment_method: 'bnpl',
        payment_method_type: 'split',
        payment_mode: Object(i18n["h" /* t */])('booking.banking.paymentSchedule.bnpl.oneyInstallmentCount'),
        is_free: 'false',
        with_down_payment: 'true'
      }],
      hide_logo: true
    };
    window.loadOneyWidget(function () {
      window.oneyMerchantApp.loadSimulationPopin({
        options: options
      });
    });
  };

  return {
    handlePopinClick: handlePopinClick
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/oney-form/OneyLabel.jsx
var OneyLabel_jsx = react_default.a.createElement;





var OneyLabel_OneyLabel = function OneyLabel(_ref) {
  var price = _ref.price,
      iconClassname = _ref.iconClassname,
      payingLabel = _ref.payingLabel;

  var _useOneySimulationPop = useOneySimulationPopin_useOneySimulationPopin({
    price: price.total.value
  }),
      handlePopinClick = _useOneySimulationPop.handlePopinClick;

  var oneyInstalmentCount = Object(i18n["h" /* t */])('booking.banking.paymentSchedule.bnpl.oneyInstallmentCount');
  var oneyIconName = "oney_".concat(oneyInstalmentCount);
  return OneyLabel_jsx(react_default.a.Fragment, null, OneyLabel_jsx("div", {
    className: "gap-1 flex flex-col items-start md:flex-row md:items-center md:gap-4"
  }, OneyLabel_jsx("span", {
    className: "flex items-center gap-4"
  }, payingLabel, OneyLabel_jsx(Icon["a" /* Icon */], {
    name: oneyIconName,
    width: "1.5rem",
    isNotMonoChrome: true
  })), OneyLabel_jsx("span", {
    className: "ml-0 leading-tight md:ml-0"
  }, Object(i18n["h" /* t */])('booking.banking.paymentSchedule.byCreditCard'))), OneyLabel_jsx("span", {
    onClick: handlePopinClick,
    className: iconClassname
  }, OneyLabel_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].INFORMATION,
    width: "1.5rem",
    className: "cursor-pointer"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/oney-form/OneySelector.jsx
var OneySelector_jsx = react_default.a.createElement;


var OneySelector_OneySelector = function OneySelector(_ref) {
  var price = _ref.price,
      label = _ref.label;
  return OneySelector_jsx("div", {
    className: "flex items-start justify-start gap-4 md:items-center md:justify-center"
  }, OneySelector_jsx(OneyLabel_OneyLabel, {
    price: {
      total: {
        value: price
      }
    },
    iconClassname: "text-sienna",
    payingLabel: label
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/oney-form/OneyFromPricing.jsx
var OneyFromPricing_jsx = react_default.a.createElement;



var OneyFromPricing_OneyFromPricing = function OneyFromPricing(_ref) {
  var price = _ref.price,
      iconClassname = _ref.iconClassname;
  return OneyFromPricing_jsx("div", {
    className: "flex items-start justify-start gap-4 text-12 md:items-center md:justify-center"
  }, OneyFromPricing_jsx(OneyLabel_OneyLabel, {
    price: price,
    iconClassname: iconClassname,
    payingLabel: Object(i18n["h" /* t */])('booking.banking.paymentSchedule.fromPricing')
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/DefaultBuyNowPayLaterIframe.jsx

var DefaultBuyNowPayLaterIframe_DefaultBuyNowPayLaterIframe = function DefaultBuyNowPayLaterIframe(_ref) {
  var onLoaded = _ref.onLoaded;
  Object(react["useEffect"])(function () {
    onLoaded(true);
  }, []);
  return null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.const.jsx


var _PAYMENT_PLAN_IFRAME, _PAYMENT_PLAN_SELECTO, _BUY_NOW_PAY_LATER_PR;











var PAYMENT_PLAN_IFRAME = (_PAYMENT_PLAN_IFRAME = {}, Object(defineProperty["a" /* default */])(_PAYMENT_PLAN_IFRAME, PaymentInfo_const["p" /* UPLIFT_PSP_ID */], UpliftForm_UpliftForm), Object(defineProperty["a" /* default */])(_PAYMENT_PLAN_IFRAME, PaymentInfo_const["o" /* PLEDG_PSP_ID */], PledgForm_PledgForm), Object(defineProperty["a" /* default */])(_PAYMENT_PLAN_IFRAME, PaymentInfo_const["k" /* ONEY_PSP_ID */], DefaultBuyNowPayLaterIframe_DefaultBuyNowPayLaterIframe), _PAYMENT_PLAN_IFRAME);
var PAYMENT_PLAN_SELECTOR = (_PAYMENT_PLAN_SELECTO = {}, Object(defineProperty["a" /* default */])(_PAYMENT_PLAN_SELECTO, PaymentInfo_const["p" /* UPLIFT_PSP_ID */], UpliftSelector_UpliftSelector), Object(defineProperty["a" /* default */])(_PAYMENT_PLAN_SELECTO, PaymentInfo_const["o" /* PLEDG_PSP_ID */], PledgPrice_PledgPrice), Object(defineProperty["a" /* default */])(_PAYMENT_PLAN_SELECTO, PaymentInfo_const["k" /* ONEY_PSP_ID */], OneySelector_OneySelector), _PAYMENT_PLAN_SELECTO);
var BUY_NOW_PAY_LATER_PRICING = (_BUY_NOW_PAY_LATER_PR = {}, Object(defineProperty["a" /* default */])(_BUY_NOW_PAY_LATER_PR, PaymentInfo_const["p" /* UPLIFT_PSP_ID */], UplfitFromPricing_UpliftFromPricing), Object(defineProperty["a" /* default */])(_BUY_NOW_PAY_LATER_PR, PaymentInfo_const["o" /* PLEDG_PSP_ID */], PledgFromPricing_PledgFromPricing), Object(defineProperty["a" /* default */])(_BUY_NOW_PAY_LATER_PR, PaymentInfo_const["k" /* ONEY_PSP_ID */], OneyFromPricing_OneyFromPricing), _BUY_NOW_PAY_LATER_PR);
var BUY_NOW_PAY_LATER_PROVIDER = [PaymentInfo_const["p" /* UPLIFT_PSP_ID */], PaymentInfo_const["o" /* PLEDG_PSP_ID */], PaymentInfo_const["k" /* ONEY_PSP_ID */]];

/***/ }),

/***/ "U9DI":
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__("KGlL")
var RIPEMD160 = __webpack_require__("//Gm")
var sha = __webpack_require__("guqX")
var Buffer = __webpack_require__("KLyV").Buffer

var checkParameters = __webpack_require__("wKb0")
var defaultEncoding = __webpack_require__("yRAD")
var toBuffer = __webpack_require__("I3mq")

var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),

/***/ "UnYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildcareIncludedEquipmentCapsule; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hCOa");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("m9LP");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_capsule_collapse_lists_CapsuleCollapseLists__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("d4In");















var __jsx = react__WEBPACK_IMPORTED_MODULE_15___default.a.createElement;




var ChildcareIncludedEquipmentCapsule = function ChildcareIncludedEquipmentCapsule(_ref) {
  var className = _ref.className,
      facilities = _ref.facilities;
  var deduplicatedLists = Object(react__WEBPACK_IMPORTED_MODULE_15__["useMemo"])(function () {
    if (!facilities || facilities.length === 0) {
      return [];
    } // Group facilities by subtitle (merge facilities with the same subtitle)


    var groupedBySubtitle = facilities.reduce(function (acc, facility) {
      var subtitle = facility.subtitle || '';
      var title = facility.subtitle || facility.label || '';

      if (!acc[subtitle]) {
        acc[subtitle] = {
          title: title,
          equipments: new Map()
        };
      } // Merge equipments from facilities with same subtitle


      (facility.equipments || []).forEach(function (equipment) {
        if (equipment.id && !acc[subtitle].equipments.has(equipment.id)) {
          acc[subtitle].equipments.set(equipment.id, equipment);
        }
      });
      return acc;
    }, {}); // track which equipment appears in which facilities (by subtitle)

    var equipmentToFacilities = new Map();
    Object.keys(groupedBySubtitle).forEach(function (subtitle) {
      var group = groupedBySubtitle[subtitle];
      group.equipments.forEach(function (equipment) {
        if (!equipmentToFacilities.has(equipment.id)) {
          equipmentToFacilities.set(equipment.id, []);
        }

        var facilityList = equipmentToFacilities.get(equipment.id);

        if (facilityList) {
          facilityList.push(subtitle);
        }
      });
    }); // For each facility group, remove equipments that appear in other facilities
    // Keep equipment only in the first facility where it appears

    var facilityOrder = Object.keys(groupedBySubtitle);
    var processedLists = facilityOrder.map(function (subtitle, index) {
      var group = groupedBySubtitle[subtitle];
      var filteredEquipments = Array.from(group.equipments.values()).filter(function (equipment) {
        var facilitiesWithEquipment = equipmentToFacilities.get(equipment.id) || []; // If equipment appears in only one facility, keep it

        if (facilitiesWithEquipment.length === 1) {
          return true;
        } // If equipment appears in multiple facilities, keep it only in the first one


        var firstFacilityIndex = facilityOrder.findIndex(function (key) {
          return facilitiesWithEquipment.includes(key);
        });
        return firstFacilityIndex === index;
      });
      return {
        title: group.title,
        items: filteredEquipments.map(function (equipment) {
          return {
            iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"][equipment.id],
            label: equipment.label
          };
        })
      };
    });
    return processedLists;
  }, [facilities]);
  return __jsx(_frameworks_capsule_collapse_lists_CapsuleCollapseLists__WEBPACK_IMPORTED_MODULE_18__[/* CapsuleCollapseLists */ "a"], {
    className: className,
    header: {
      iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].ALL_INCLUSIVE,
      title: Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('common.allInclusive')
    },
    lists: deduplicatedLists
  });
};

/***/ }),

/***/ "UpHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ infoBanner_utils_renderInfoBanner; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/capitalize.js
var capitalize = __webpack_require__("h++M");
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/heading/Heading.jsx + 1 modules
var Heading = __webpack_require__("3jv5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/InfoBanner.themes.js
var InfoBanner_themes = __webpack_require__("cN29");

// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/InfoBanner.jsx




var __jsx = react_default.a.createElement;














var positions = {
  left: 'start-0',
  right: 'end-0',
  center: 'inset-x-0'
};
var InfoBanner_InfoBanner = function InfoBanner(_ref) {
  var className = _ref.className,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? 'w-800' : _ref$containerClassNa,
      contentClassName = _ref.contentClassName,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
      countdown = _ref.countdown,
      iconName = _ref.iconName,
      illustration = _ref.illustration,
      popin = _ref.popin,
      _ref$popinPosition = _ref.popinPosition,
      popinPosition = _ref$popinPosition === void 0 ? 'left' : _ref$popinPosition,
      subtitle = _ref.subtitle,
      title = _ref.title,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var hasModal = !!popin && (!!(popin === null || popin === void 0 ? void 0 : popin.title) || !!(popin === null || popin === void 0 ? void 0 : popin.text) || !!(popin === null || popin === void 0 ? void 0 : popin.subtitle));
  var hasCountdown = !isEmpty_default()(countdown) && countdown.dateTimeEnd;
  var hasIcon = Boolean(illustration || iconName);
  var _themes$theme = Object(InfoBanner_themes["a" /* themes */])({
    color: color
  })[theme],
      thDescriptionBloc = _themes$theme.thDescriptionBloc,
      thPopinContent = _themes$theme.thPopinContent,
      thPopinContentImage = _themes$theme.thPopinContentImage,
      thPopinColor = _themes$theme.thPopinColor,
      thPopinTextColor = _themes$theme.thPopinTextColor;

  if (!title && !subtitle && !hasIcon && !hasCountdown) {
    return null;
  }

  var content = __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('text-initial flex', contentClassName)
  }, hasIcon && __jsx("div", {
    className: "border-".concat(color, " h-56 shrink-0 overflow-hidden rounded-4 border-1")
  }, illustration ? __jsx("img", {
    alt: "",
    className: "h-full",
    src: illustration
  }) : __jsx(Icon["a" /* Icon */], {
    className: "text-".concat(color, " p-5"),
    name: iconName,
    width: "3.5rem"
  })), hasCountdown && __jsx("div", {
    className: "bg-white border-".concat(color, " flex h-56 grow flex-col items-center justify-center overflow-hidden rounded-4 border-1 sm:order-1 sm:grow-0 text-").concat(color)
  }, __jsx(Countdown["a" /* Countdown */], Object(esm_extends["a" /* default */])({}, countdown, {
    dateTimeEnd: countdown === null || countdown === void 0 ? void 0 : countdown.dateTimeEnd,
    theme: "infoBanner"
  }))), (title || subtitle) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thDescriptionBloc, 'h-56')
  }, __jsx("h6", {
    className: "text-10"
  }, subtitle), __jsx("h5", {
    className: "font-brand text-16 font-normal underline"
  }, title)));

  var imageProps = isDesktop ? {
    dimensions: {
      w: 300,
      h: 170
    }
  } : {
    dontChangeAnything: true
  };
  var tooltipContent = hasModal ? __jsx("div", {
    className: thPopinContent
  }, (popin === null || popin === void 0 ? void 0 : popin.image) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thPopinContentImage, 'lg:h-220')
  }, __jsx(Image["a" /* Image */], Object(esm_extends["a" /* default */])({
    className: "h-full overflow-hidden rounded-12",
    imageUrl: popin.image
  }, imageProps))), __jsx("div", {
    className: "p-20"
  }, (popin === null || popin === void 0 ? void 0 : popin.title) && __jsx(Heading["a" /* Heading */], {
    className: Object(classnames_utils["a" /* classnames */])('font-brand text-24 font-normal leading-tight', "text-".concat(thPopinColor)),
    hLevel: 3,
    theme: "none"
  }, popin.title), (popin === null || popin === void 0 ? void 0 : popin.subtitle) && __jsx(Heading["a" /* Heading */], {
    className: "text-14 font-bold leading-tight",
    hLevel: 4,
    theme: "none"
  }, popin.subtitle), (popin === null || popin === void 0 ? void 0 : popin.text) && __jsx(Text["a" /* Text */], {
    className: "py-10 text-14 leading-tight lg:leading-loose",
    text: popin.text
  }), (popin === null || popin === void 0 ? void 0 : popin.url) && __jsx(Button["a" /* Button */], {
    color: thPopinTextColor,
    colorBg: thPopinColor,
    url: popin.url
  }, popin.buttonLabel))) : null;
  var position = popinPosition === 'left' ? 'left' : 'right';
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate', className)
  }, hasModal ? __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: (popin === null || popin === void 0 ? void 0 : popin.title) ? popin.title : '',
    className: "flex justify-end",
    containerClassName: Object(classnames_utils["a" /* classnames */])("z-3 border-1 border-".concat(color, " ").concat(positions[popinPosition]), containerClassName),
    contentClassName: "arrow-bg arrow-bg-".concat(color, " arrow-up").concat(capitalize_default()(position)),
    content: tooltipContent,
    hasCloseButton: true,
    onClick: function onClick() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_INFOBANNER, {
        detail_click: title
      });
    },
    theme: "infoBanner"
  }, content) : content);
};
// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/infoBanner.utils.js













var infoBanner_utils_jsx = react["createElement"];

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






 // eslint-disable-next-line clubmed/no-fake-component

var infoBanner_utils_renderInfoBanner = function renderInfoBanner(_ref) {
  var infoBannerData = _ref.infoBannerData,
      departureDate = _ref.departureDate,
      arrivalDate = _ref.arrivalDate,
      currentStep = _ref.currentStep,
      containerClassName = _ref.containerClassName,
      theme = _ref.theme,
      contentClassName = _ref.contentClassName,
      popinPosition = _ref.popinPosition,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'mb-20 z-2' : _ref$className;
  var content = ((infoBannerData === null || infoBannerData === void 0 ? void 0 : infoBannerData.productInformationBanners) || []).map(function (productInformationBanner, index) {
    var theContextInfoBannerData = productInformationBanner.salesChannel.find(function (el) {
      return el.context === 'B2C';
    });
    var isDepartureDateIncludedInBannerDates = moment_default()(departureDate).isBetween(Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.startDate), Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate), null, []) || moment_default()(arrivalDate).isBetween(Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.startDate), Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate), null, []) || Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate).isSame(arrivalDate);

    if (!theContextInfoBannerData || !isDepartureDateIncludedInBannerDates || !theContextInfoBannerData.tags.includes(currentStep)) {
      return null;
    }

    var countdown = productInformationBanner.countdown,
        popin = productInformationBanner.popin,
        toaster = productInformationBanner.toaster;
    var infoBannerCountdown = countdown ? _objectSpread(_objectSpread({}, countdown), {}, {
      dateTimeEnd: moment_default()(countdown.dateTimeEnd, 'YYYYMMDD HH:mm:ss'),
      days: Object(i18n["h" /* t */])('options.countdownLabels.days'),
      hours: Object(i18n["h" /* t */])('options.countdownLabels.hours'),
      minutes: Object(i18n["h" /* t */])('options.countdownLabels.minutes'),
      seconds: Object(i18n["h" /* t */])('options.countdownLabels.seconds')
    }) : null;
    return infoBanner_utils_jsx(InfoBanner_InfoBanner, Object(esm_extends["a" /* default */])({
      key: "infoBanner_".concat(index)
    }, toaster, {
      containerClassName: containerClassName,
      contentClassName: contentClassName,
      countdown: infoBannerCountdown,
      popin: popin,
      popinPosition: popinPosition,
      theme: theme
    }));
  }).filter(Boolean);

  if (!content.length) {
    return null;
  }

  return infoBanner_utils_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate flex flex-col gap-10 sm:flex-row', className)
  }, content);
};

/***/ }),

/***/ "V+KB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useChidcareContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useChildcareContextPLE; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Qavd");
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uDfI");
/* harmony import */ var _client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("AnR0");
/* harmony import */ var _client_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("JOeK");
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("Ub5k");
/* harmony import */ var _client_components_widgets_cart_cart_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zhg9");
/* harmony import */ var _client_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("DqI1");
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("829J");









/* eslint-disable max-params */








 // COMMON TRACKING
// ON Error add Upsells

var trackErrorUnknownChildcare = function trackErrorUnknownChildcare(trackClickEvent) {
  trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_ERROR, {
    detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ERROR_UNKNOWN_CHILDCARE
  });
}; // advanced by day case


var getDaysOrFullStayLabelGA = function getDaysOrFullStayLabelGA(pricingInfo, attendees) {
  var currentAttendee = attendees.find(function (_ref) {
    var _ref$customerId = _ref.customerId,
        customerId = _ref$customerId === void 0 ? '' : _ref$customerId,
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? '' : _ref$id;
    return customerId === pricingInfo.childId || id === pricingInfo.childId;
  });
  var rentedSchedules = currentAttendee === null || currentAttendee === void 0 ? void 0 : currentAttendee.schedules;
  var rentedSchedulesNumber = (rentedSchedules === null || rentedSchedules === void 0 ? void 0 : rentedSchedules.length) || 0;

  if (rentedSchedules && (rentedSchedules === null || rentedSchedules === void 0 ? void 0 : rentedSchedules.length) > 1 || // $FlowFixMe we verify we have the item first
  rentedSchedulesNumber === 1 && rentedSchedules[0].startDate === rentedSchedules[0].endDate) {
    // here is the case of renting some n days but in the case of childcare by day
    return "dayslot_".concat(rentedSchedulesNumber);
  }

  if (rentedSchedulesNumber === 1 && // $FlowFixMe we verify we have the item first
  rentedSchedules[0].startDate !== rentedSchedules[0].endDate) {
    // here is the case of renting the full stay slot but in the case of childcare by day
    return 'all_journey';
  }
}; // morning afternoon or full day case for all stay case


var getMorningAfternoonOrFullDay = function getMorningAfternoonOrFullDay(pricingInfo, serviceId) {
  var _currentAttendee$sche, _currentAttendee$sche2;

  var currentAttendee = pricingInfo.attendees.find(function (_ref2) {
    var id = _ref2.id,
        _ref2$customerId = _ref2.customerId,
        customerId = _ref2$customerId === void 0 ? '' : _ref2$customerId;
    return id === pricingInfo.childId || customerId === pricingInfo.childId;
  });
  var rentedSlotName = currentAttendee === null || currentAttendee === void 0 ? void 0 : (_currentAttendee$sche = currentAttendee.schedules[0].timeSlots) === null || _currentAttendee$sche === void 0 ? void 0 : (_currentAttendee$sche2 = _currentAttendee$sche.find(function (_ref3) {
    var id = _ref3.id;
    return id === serviceId;
  })) === null || _currentAttendee$sche2 === void 0 ? void 0 : _currentAttendee$sche2.slotName;

  if (rentedSlotName === 'MORNING') {
    return 'morning';
  }

  if (rentedSlotName === 'AFTERNOON') {
    return 'afternoon';
  }

  if (rentedSlotName === 'DAY') {
    return 'all_day';
  }
}; // END COMMON TRACKING

/**
 * BE
 */
// get the childcare s context values for BE


var useChidcareContext = function useChidcareContext(_ref4) {
  var proposals = _ref4.proposals,
      appContext = _ref4.appContext;
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useDispatch */ "d"])();

  var _useTrackEvent = Object(_client_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_15__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var childcareContextServicesValuesBE = Object(react__WEBPACK_IMPORTED_MODULE_9__["useMemo"])(function () {
    var _proposals$, _proposals$$price;

    return {
      currency: proposals === null || proposals === void 0 ? void 0 : (_proposals$ = proposals[0]) === null || _proposals$ === void 0 ? void 0 : (_proposals$$price = _proposals$.price) === null || _proposals$$price === void 0 ? void 0 : _proposals$$price.currency,
      showRentAllSchedules: true,
      // FULL STAY SCHEDULE OR SINGLE DAY SCHEDULE
      // eslint-disable-next-line
      updateService: function () {
        var _updateService = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee(attendees, pricingInfo, serviceIds, attendeeIds) {
          var daysOrFullStayLabelGA;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (pricingInfo.isPartiallyRented) {
                    attendees.length === 0 && trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                      detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].REMOVE_CHILDCARE
                    });
                    dispatch(Object(_client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__[/* deleteAdditionalServices */ "g"])({
                      appContext: appContext,
                      attendeeIds: attendeeIds,
                      serviceIds: serviceIds,
                      showNotification: true,
                      proposals: proposals
                    }));
                  }

                  if (!(attendees.length > 0)) {
                    _context.next = 4;
                    break;
                  }

                  daysOrFullStayLabelGA = getDaysOrFullStayLabelGA(pricingInfo, attendees);
                  return _context.abrupt("return", dispatch(Object(_client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__[/* addOrReplaceAdditionalServices */ "d"])({
                    appContext: appContext,
                    attendees: attendees,
                    showNotification: true
                  })).then(function () {
                    trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                      detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ADD_CHILDCARE_POPIN,
                      childcare_timeslot: daysOrFullStayLabelGA
                    });
                  })["catch"](function () {
                    return trackErrorUnknownChildcare(trackClickEvent);
                  }));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function updateService(_x, _x2, _x3, _x4) {
          return _updateService.apply(this, arguments);
        }

        return updateService;
      }(),
      deleteAttendeeChildcare: function () {
        var _deleteAttendeeChildcare = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee2(_ref5) {
          var attendeeId, pricingInfo, servicesIdsToRemove;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  attendeeId = _ref5.attendeeId, pricingInfo = _ref5.pricingInfo;
                  servicesIdsToRemove = pricingInfo.schedules[0].slots.map(function (slot) {
                    return slot.id;
                  }).filter(Boolean);

                  if (!(servicesIdsToRemove.length > 0 && proposals && (proposals === null || proposals === void 0 ? void 0 : proposals.length) > 0)) {
                    _context2.next = 4;
                    break;
                  }

                  return _context2.abrupt("return", dispatch(Object(_client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__[/* deleteAdditionalServices */ "g"])({
                    appContext: appContext,
                    attendeeIds: [attendeeId],
                    serviceIds: servicesIdsToRemove,
                    showNotification: true,
                    proposals: proposals
                  })).then(function () {
                    trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                      detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].REMOVE_CHILDCARE
                    });
                  }));

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function deleteAttendeeChildcare(_x5) {
          return _deleteAttendeeChildcare.apply(this, arguments);
        }

        return deleteAttendeeChildcare;
      }(),
      addAttendeeChildcare: function addAttendeeChildcare(_ref6) {
        var attendeeId = _ref6.attendeeId,
            pricingInfo = _ref6.pricingInfo,
            serviceId = _ref6.serviceId;
        var schedules = [{
          startDate: pricingInfo.schedules[0].startDate,
          endDate: pricingInfo.schedules[0].endDate
        }];
        return dispatch(Object(_client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__[/* addAdditionalService */ "b"])({
          proposalIds: proposals.map(function (_ref7) {
            var id = _ref7.id;
            return id;
          }),
          serviceId: serviceId,
          attendeeIds: [attendeeId],
          schedules: schedules,
          showNotification: true,
          appContext: appContext
        })).then(function () {
          var morningAfternoonOrFullDayLabelGA = getMorningAfternoonOrFullDay(pricingInfo, serviceId);
          trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
            detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ADD_CHILDCARE_POPIN,
            childcare_timeslot: morningAfternoonOrFullDayLabelGA
          });
        })["catch"](function () {
          return trackErrorUnknownChildcare(trackClickEvent);
        });
      }
    };
  }, []);
  return {
    childcareContextServicesValuesBE: childcareContextServicesValuesBE
  };
};
/**
 * END BE
 */

/**
 * PLE
 */

var useChildcareContextPLE = function useChildcareContextPLE(_ref8) {
  var cartState = _ref8.cartState,
      stay = _ref8.stay,
      addOrRemoveChildcareCC = _ref8.addOrRemoveChildcareCC,
      cartChildcares = _ref8.cartChildcares;
  var appContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_13__[/* useAppContext */ "c"])();
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useDispatch */ "d"])();

  var _useTrackEvent2 = Object(_client_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_15__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent2.trackClickEvent;

  var childcareContextValuesPLE = Object(react__WEBPACK_IMPORTED_MODULE_9__["useMemo"])(function () {
    return {
      // Case update multi-schedule
      updateService: function updateService(updatedService, pricingInfo, serviceIds) {
        var _pricingInfo$attendee, _pricingInfo$attendee2, _pricingInfo$attendee3;

        var alreadyPaidSchedulesNumber = ((_pricingInfo$attendee = pricingInfo.attendees.find(function (_ref9) {
          var id = _ref9.id;
          return id === pricingInfo.childId;
        })) === null || _pricingInfo$attendee === void 0 ? void 0 : (_pricingInfo$attendee2 = _pricingInfo$attendee.schedules) === null || _pricingInfo$attendee2 === void 0 ? void 0 : (_pricingInfo$attendee3 = _pricingInfo$attendee2.filter(function (_ref10) {
          var isPartiallyPaid = _ref10.isPartiallyPaid;
          return isPartiallyPaid;
        })) === null || _pricingInfo$attendee3 === void 0 ? void 0 : _pricingInfo$attendee3.length) || 0;
        var isAdded = updatedService.some(function (customerService) {
          return !!(customerService.schedules.length - alreadyPaidSchedulesNumber) && customerService.customerId === pricingInfo.childId;
        });

        if (isAdded) {
          var daysOrFullStayLabelGA = getDaysOrFullStayLabelGA(pricingInfo, updatedService);
          trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
            detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ADD_CHILDCARE_POPIN,
            childcare_timeslot: daysOrFullStayLabelGA
          });
        } else {
          trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
            detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].REMOVE_CHILDCARE
          });
        } // format the services to the adequat data structure


        var cart = Object(_client_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_12__[/* formatServiceToUpdateBookingCart */ "d"])({
          appContext: appContext,
          bookingId: stay.booking.id,
          serviceIds: serviceIds,
          stay: stay,
          type: pricingInfo.type,
          updatedService: Object(_client_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_12__[/* excludePaidSlots */ "c"])(updatedService, stay.upsells.childcares)
        });
        return Object(_client_components_widgets_cart_cart_actions__WEBPACK_IMPORTED_MODULE_14__[/* updateBookingCartSequencially */ "d"])(cart, cartState)["finally"](function () {
          return dispatch(Object(_client_components_widgets_cart_cart_actions__WEBPACK_IMPORTED_MODULE_14__[/* fetchBookingsCart */ "b"])(((cartState === null || cartState === void 0 ? void 0 : cartState.cartBookings) || []).map(function (b) {
            return b.bookingId;
          }), appContext));
        });
      },
      // Case delete and add ( different slots and one schedule )
      deleteAttendeeChildcare: function () {
        var _deleteAttendeeChildcare2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee3(_ref11) {
          var _currentAttendee$sche3, _currentAttendee$sche4;

          var attendeeId, pricingInfo, currentAttendee, currentAttendeeRentedSlotsIds;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  attendeeId = _ref11.attendeeId, pricingInfo = _ref11.pricingInfo;
                  currentAttendee = pricingInfo.attendees.find(function (_ref12) {
                    var id = _ref12.id;
                    return id === attendeeId;
                  }); // $FlowFixMe : always found

                  currentAttendeeRentedSlotsIds = (_currentAttendee$sche3 = currentAttendee.schedules[0].timeSlots) === null || _currentAttendee$sche3 === void 0 ? void 0 : (_currentAttendee$sche4 = _currentAttendee$sche3.filter(function (_ref13) {
                    var isRented = _ref13.isRented,
                        isPaid = _ref13.isPaid;
                    return isRented && !isPaid;
                  })) === null || _currentAttendee$sche4 === void 0 ? void 0 : _currentAttendee$sche4.map(function (_ref14) {
                    var id = _ref14.id;
                    return id;
                  });

                  if ((currentAttendeeRentedSlotsIds === null || currentAttendeeRentedSlotsIds === void 0 ? void 0 : currentAttendeeRentedSlotsIds.length) > 0) {
                    currentAttendeeRentedSlotsIds.map(function (serviceId) {
                      trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                        detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].REMOVE_CHILDCARE
                      }); // always deletes because we check if added to cart or not

                      return addOrRemoveChildcareCC({
                        childcareId: serviceId,
                        attendeeId: attendeeId,
                        startDate: pricingInfo.schedules[0].startDate,
                        endDate: pricingInfo.schedules[0].endDate
                      });
                    });
                  }

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function deleteAttendeeChildcare(_x6) {
          return _deleteAttendeeChildcare2.apply(this, arguments);
        }

        return deleteAttendeeChildcare;
      }(),
      addAttendeeChildcare: function () {
        var _addAttendeeChildcare = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee4(_ref15) {
          var attendeeId, pricingInfo, serviceId, morningAfternoonOrFullDayLabelGA;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  attendeeId = _ref15.attendeeId, pricingInfo = _ref15.pricingInfo, serviceId = _ref15.serviceId;
                  morningAfternoonOrFullDayLabelGA = getMorningAfternoonOrFullDay(pricingInfo, serviceId);
                  trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                    detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ADD_CHILDCARE_POPIN,
                    childcare_timeslot: morningAfternoonOrFullDayLabelGA
                  });
                  return _context4.abrupt("return", addOrRemoveChildcareCC({
                    childcareId: serviceId,
                    attendeeId: attendeeId,
                    startDate: pricingInfo.schedules[0].startDate,
                    endDate: pricingInfo.schedules[0].endDate
                  }));

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function addAttendeeChildcare(_x7) {
          return _addAttendeeChildcare.apply(this, arguments);
        }

        return addAttendeeChildcare;
      }()
    };
  }, [cartChildcares]);
  return {
    childcareContextValuesPLE: childcareContextValuesPLE
  };
};
/**
 * END PLE
 */

/***/ }),

/***/ "VDhN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var e=__webpack_require__("W/Kd"),t=__webpack_require__("ERkP");function s(e){return e&&e.__esModule?e:{default:e}}var n=s(e),i=s(t);function o(e){return e&&e.stopPropagation&&e.stopPropagation(),e&&e.preventDefault&&e.preventDefault(),!1}function r(e){return null==e?[]:Array.isArray(e)?e.slice():[e]}function a(e){return null!==e&&1===e.length?e[0]:e.slice()}function p(e){Object.keys(e).forEach((t=>{"undefined"!=typeof document&&document.addEventListener(t,e[t],!1)}))}function u(e,t){return l(function(e,t){let s=e;s<=t.min&&(s=t.min);s>=t.max&&(s=t.max);return s}(e,t),t)}function l(e,t){const s=(e-t.min)%t.step;let n=e-s;return 2*Math.abs(s)>=t.step&&(n+=s>0?t.step:-t.step),parseFloat(n.toFixed(5))}let h=function(e){function t(t){var s;(s=e.call(this,t)||this).onKeyUp=()=>{s.onEnd()},s.onMouseUp=()=>{s.onEnd(s.getMouseEventMap())},s.onTouchEnd=e=>{e.preventDefault(),s.onEnd(s.getTouchEventMap())},s.onBlur=()=>{s.setState({index:-1},s.onEnd(s.getKeyDownEventMap()))},s.onMouseMove=e=>{s.setState({pending:!0});const t=s.getMousePosition(e),n=s.getDiffPosition(t[0]),i=s.getValueFromPosition(n);s.move(i)},s.onTouchMove=e=>{if(e.touches.length>1)return;s.setState({pending:!0});const t=s.getTouchPosition(e);if(void 0===s.isScrolling){const e=t[0]-s.startPosition[0],n=t[1]-s.startPosition[1];s.isScrolling=Math.abs(n)>Math.abs(e)}if(s.isScrolling)return void s.setState({index:-1});const n=s.getDiffPosition(t[0]),i=s.getValueFromPosition(n);s.move(i)},s.onKeyDown=e=>{if(!(e.ctrlKey||e.shiftKey||e.altKey||e.metaKey))switch(s.setState({pending:!0}),e.key){case"ArrowLeft":case"ArrowDown":case"Left":case"Down":e.preventDefault(),s.moveDownByStep();break;case"ArrowRight":case"ArrowUp":case"Right":case"Up":e.preventDefault(),s.moveUpByStep();break;case"Home":e.preventDefault(),s.move(s.props.min);break;case"End":e.preventDefault(),s.move(s.props.max);break;case"PageDown":e.preventDefault(),s.moveDownByStep(s.props.pageFn(s.props.step));break;case"PageUp":e.preventDefault(),s.moveUpByStep(s.props.pageFn(s.props.step))}},s.onSliderMouseDown=e=>{if(!s.props.disabled&&2!==e.button){if(s.setState({pending:!0}),!s.props.snapDragDisabled){const t=s.getMousePosition(e);s.forceValueFromPosition(t[0],(e=>{s.start(e,t[0]),p(s.getMouseEventMap())}))}o(e)}},s.onSliderClick=e=>{if(!s.props.disabled&&s.props.onSliderClick&&!s.hasMoved){const t=s.getMousePosition(e),n=u(s.calcValue(s.calcOffsetFromPosition(t[0])),s.props);s.props.onSliderClick(n)}},s.createOnKeyDown=e=>t=>{s.props.disabled||(s.start(e),p(s.getKeyDownEventMap()),o(t))},s.createOnMouseDown=e=>t=>{if(s.props.disabled||2===t.button)return;s.setState({pending:!0});const n=s.getMousePosition(t);s.start(e,n[0]),p(s.getMouseEventMap()),o(t)},s.createOnTouchStart=e=>t=>{if(s.props.disabled||t.touches.length>1)return;s.setState({pending:!0});const n=s.getTouchPosition(t);s.startPosition=n,s.isScrolling=void 0,s.start(e,n[0]),p(s.getTouchEventMap()),function(e){e.stopPropagation&&e.stopPropagation()}(t)},s.handleResize=()=>{const e=window.setTimeout((()=>{s.pendingResizeTimeouts.shift(),s.resize()}),0);s.pendingResizeTimeouts.push(e)},s.renderThumb=(e,t)=>{const n=s.props.thumbClassName+" "+s.props.thumbClassName+"-"+t+" "+(s.state.index===t?s.props.thumbActiveClassName:""),i={ref:e=>{s["thumb"+t]=e},key:s.props.thumbClassName+"-"+t,className:n,style:e,onMouseDown:s.createOnMouseDown(t),onTouchStart:s.createOnTouchStart(t),onFocus:s.createOnKeyDown(t),tabIndex:0,role:"slider","aria-orientation":s.props.orientation,"aria-valuenow":s.state.value[t],"aria-valuemin":s.props.min,"aria-valuemax":s.props.max,"aria-label":Array.isArray(s.props.ariaLabel)?s.props.ariaLabel[t]:s.props.ariaLabel,"aria-labelledby":Array.isArray(s.props.ariaLabelledby)?s.props.ariaLabelledby[t]:s.props.ariaLabelledby,"aria-disabled":s.props.disabled},o={index:t,value:a(s.state.value),valueNow:s.state.value[t]};return s.props.ariaValuetext&&(i["aria-valuetext"]="string"==typeof s.props.ariaValuetext?s.props.ariaValuetext:s.props.ariaValuetext(o)),s.props.renderThumb(i,o)},s.renderTrack=(e,t,n)=>{const i={key:s.props.trackClassName+"-"+e,className:s.props.trackClassName+" "+s.props.trackClassName+"-"+e,style:s.buildTrackStyle(t,s.state.upperBound-n)},o={index:e,value:a(s.state.value)};return s.props.renderTrack(i,o)};let n=r(t.value);n.length||(n=r(t.defaultValue)),s.pendingResizeTimeouts=[];const l=[];for(let e=0;e<n.length;e+=1)n[e]=u(n[e],t),l.push(e);return s.resizeObserver=null,s.resizeElementRef=i.default.createRef(),s.state={index:-1,upperBound:0,sliderLength:0,value:n,zIndices:l},s}n.default(t,e);var s=t.prototype;return s.componentDidMount=function(){"undefined"!=typeof window&&(this.resizeObserver=new ResizeObserver(this.handleResize),this.resizeObserver.observe(this.resizeElementRef.current),this.resize())},t.getDerivedStateFromProps=function(e,t){const s=r(e.value);return s.length?t.pending?null:{value:s.map((t=>u(t,e)))}:null},s.componentDidUpdate=function(){0===this.state.upperBound&&this.resize()},s.componentWillUnmount=function(){this.clearPendingResizeTimeouts(),this.resizeObserver&&this.resizeObserver.disconnect()},s.onEnd=function(e){e&&function(e){Object.keys(e).forEach((t=>{"undefined"!=typeof document&&document.removeEventListener(t,e[t],!1)}))}(e),this.hasMoved&&this.fireChangeEvent("onAfterChange"),this.setState({pending:!1}),this.hasMoved=!1},s.getValue=function(){return a(this.state.value)},s.getClosestIndex=function(e){let t=Number.MAX_VALUE,s=-1;const{value:n}=this.state,i=n.length;for(let o=0;o<i;o+=1){const i=this.calcOffset(n[o]),r=Math.abs(e-i);r<t&&(t=r,s=o)}return s},s.getMousePosition=function(e){return[e["page"+this.axisKey()],e["page"+this.orthogonalAxisKey()]]},s.getTouchPosition=function(e){const t=e.touches[0];return[t["page"+this.axisKey()],t["page"+this.orthogonalAxisKey()]]},s.getKeyDownEventMap=function(){return{keydown:this.onKeyDown,keyup:this.onKeyUp,focusout:this.onBlur}},s.getMouseEventMap=function(){return{mousemove:this.onMouseMove,mouseup:this.onMouseUp}},s.getTouchEventMap=function(){return{touchmove:this.onTouchMove,touchend:this.onTouchEnd}},s.getValueFromPosition=function(e){const t=e/(this.state.sliderLength-this.state.thumbSize)*(this.props.max-this.props.min);return u(this.state.startValue+t,this.props)},s.getDiffPosition=function(e){let t=e-this.state.startPosition;return this.props.invert&&(t*=-1),t},s.resize=function(){const{slider:e,thumb0:t}=this;if(!e||!t)return;const s=this.sizeKey(),n=e.getBoundingClientRect(),i=e[s],o=n[this.posMaxKey()],r=n[this.posMinKey()],a=t.getBoundingClientRect()[s.replace("client","").toLowerCase()],p=i-a,u=Math.abs(o-r);this.state.upperBound===p&&this.state.sliderLength===u&&this.state.thumbSize===a||this.setState({upperBound:p,sliderLength:u,thumbSize:a})},s.calcOffset=function(e){const t=this.props.max-this.props.min;if(0===t)return 0;return(e-this.props.min)/t*this.state.upperBound},s.calcValue=function(e){return e/this.state.upperBound*(this.props.max-this.props.min)+this.props.min},s.calcOffsetFromPosition=function(e){const{slider:t}=this,s=t.getBoundingClientRect(),n=s[this.posMaxKey()],i=s[this.posMinKey()];let o=e-(window["page"+this.axisKey()+"Offset"]+(this.props.invert?n:i));return this.props.invert&&(o=this.state.sliderLength-o),o-=this.state.thumbSize/2,o},s.forceValueFromPosition=function(e,t){const s=this.calcOffsetFromPosition(e),n=this.getClosestIndex(s),i=u(this.calcValue(s),this.props),o=this.state.value.slice();o[n]=i;for(let e=0;e<o.length-1;e+=1)if(o[e+1]-o[e]<this.props.minDistance)return;this.fireChangeEvent("onBeforeChange"),this.hasMoved=!0,this.setState({value:o},(()=>{t(n),this.fireChangeEvent("onChange")}))},s.clearPendingResizeTimeouts=function(){do{const e=this.pendingResizeTimeouts.shift();clearTimeout(e)}while(this.pendingResizeTimeouts.length)},s.start=function(e,t){const s=this["thumb"+e];s&&s.focus();const{zIndices:n}=this.state;n.splice(n.indexOf(e),1),n.push(e),this.setState((s=>({startValue:s.value[e],startPosition:void 0!==t?t:s.startPosition,index:e,zIndices:n})))},s.moveUpByStep=function(e){void 0===e&&(e=this.props.step);const t=this.state.value[this.state.index],s=u(this.props.invert&&"horizontal"===this.props.orientation?t-e:t+e,this.props);this.move(Math.min(s,this.props.max))},s.moveDownByStep=function(e){void 0===e&&(e=this.props.step);const t=this.state.value[this.state.index],s=u(this.props.invert&&"horizontal"===this.props.orientation?t+e:t-e,this.props);this.move(Math.max(s,this.props.min))},s.move=function(e){const t=this.state.value.slice(),{index:s}=this.state,{length:n}=t,i=t[s];if(e===i)return;this.hasMoved||this.fireChangeEvent("onBeforeChange"),this.hasMoved=!0;const{pearling:o,max:r,min:a,minDistance:p}=this.props;if(!o){if(s>0){const n=t[s-1];e<n+p&&(e=n+p)}if(s<n-1){const n=t[s+1];e>n-p&&(e=n-p)}}t[s]=e,o&&n>1&&(e>i?(this.pushSucceeding(t,p,s),function(e,t,s,n){for(let i=0;i<e;i+=1){const o=n-i*s;t[e-1-i]>o&&(t[e-1-i]=o)}}(n,t,p,r)):e<i&&(this.pushPreceding(t,p,s),function(e,t,s,n){for(let i=0;i<e;i+=1){const e=n+i*s;t[i]<e&&(t[i]=e)}}(n,t,p,a))),this.setState({value:t},this.fireChangeEvent.bind(this,"onChange"))},s.pushSucceeding=function(e,t,s){let n,i;for(n=s,i=e[n]+t;null!==e[n+1]&&i>e[n+1];n+=1,i=e[n]+t)e[n+1]=l(i,this.props)},s.pushPreceding=function(e,t,s){for(let n=s,i=e[n]-t;null!==e[n-1]&&i<e[n-1];n-=1,i=e[n]-t)e[n-1]=l(i,this.props)},s.axisKey=function(){return"vertical"===this.props.orientation?"Y":"X"},s.orthogonalAxisKey=function(){return"vertical"===this.props.orientation?"X":"Y"},s.posMinKey=function(){return"vertical"===this.props.orientation?this.props.invert?"bottom":"top":this.props.invert?"right":"left"},s.posMaxKey=function(){return"vertical"===this.props.orientation?this.props.invert?"top":"bottom":this.props.invert?"left":"right"},s.sizeKey=function(){return"vertical"===this.props.orientation?"clientHeight":"clientWidth"},s.fireChangeEvent=function(e){this.props[e]&&this.props[e](a(this.state.value),this.state.index)},s.buildThumbStyle=function(e,t){const s={position:"absolute",touchAction:"none",willChange:this.state.index>=0?this.posMinKey():void 0,zIndex:this.state.zIndices.indexOf(t)+1};return s[this.posMinKey()]=e+"px",s},s.buildTrackStyle=function(e,t){const s={position:"absolute",willChange:this.state.index>=0?this.posMinKey()+","+this.posMaxKey():void 0};return s[this.posMinKey()]=e,s[this.posMaxKey()]=t,s},s.buildMarkStyle=function(e){var t;return(t={position:"absolute"})[this.posMinKey()]=e,t},s.renderThumbs=function(e){const{length:t}=e,s=[];for(let n=0;n<t;n+=1)s[n]=this.buildThumbStyle(e[n],n);const n=[];for(let e=0;e<t;e+=1)n[e]=this.renderThumb(s[e],e);return n},s.renderTracks=function(e){const t=[],s=e.length-1;t.push(this.renderTrack(0,0,e[0]));for(let n=0;n<s;n+=1)t.push(this.renderTrack(n+1,e[n],e[n+1]));return t.push(this.renderTrack(s+1,e[s],this.state.upperBound)),t},s.renderMarks=function(){let{marks:e}=this.props;const t=this.props.max-this.props.min+1;return"boolean"==typeof e?e=Array.from({length:t}).map(((e,t)=>t)):"number"==typeof e&&(e=Array.from({length:t}).map(((e,t)=>t)).filter((t=>t%e==0))),e.map(parseFloat).sort(((e,t)=>e-t)).map((e=>{const t=this.calcOffset(e),s={key:e,className:this.props.markClassName,style:this.buildMarkStyle(t)};return this.props.renderMark(s)}))},s.render=function(){const e=[],{value:t}=this.state,s=t.length;for(let n=0;n<s;n+=1)e[n]=this.calcOffset(t[n],n);const n=this.props.withTracks?this.renderTracks(e):null,o=this.renderThumbs(e),r=this.props.marks?this.renderMarks():null;return i.default.createElement("div",{ref:e=>{this.slider=e,this.resizeElementRef.current=e},style:{position:"relative"},className:this.props.className+(this.props.disabled?" disabled":""),onMouseDown:this.onSliderMouseDown,onClick:this.onSliderClick},n,o,r)},t}(i.default.Component);h.displayName="ReactSlider",h.defaultProps={min:0,max:100,step:1,pageFn:e=>10*e,minDistance:0,defaultValue:0,orientation:"horizontal",className:"slider",thumbClassName:"thumb",thumbActiveClassName:"active",trackClassName:"track",markClassName:"mark",withTracks:!0,pearling:!1,disabled:!1,snapDragDisabled:!1,invert:!1,marks:[],renderThumb:e=>i.default.createElement("div",e),renderTrack:e=>i.default.createElement("div",e),renderMark:e=>i.default.createElement("span",e)};var c=h;exports.default=c;


/***/ }),

/***/ "VWRg":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*global module, process*/
var Buffer = __webpack_require__("KLyV").Buffer;
var Stream = __webpack_require__("6dwG");
var util = __webpack_require__("XLvf");

function DataStream(data) {
  this.buffer = null;
  this.writable = true;
  this.readable = true;

  // No input
  if (!data) {
    this.buffer = Buffer.alloc(0);
    return this;
  }

  // Stream
  if (typeof data.pipe === 'function') {
    this.buffer = Buffer.alloc(0);
    data.pipe(this);
    return this;
  }

  // Buffer or String
  // or Object (assumedly a passworded key)
  if (data.length || typeof data === 'object') {
    this.buffer = data;
    this.writable = false;
    process.nextTick(function () {
      this.emit('end', data);
      this.readable = false;
      this.emit('close');
    }.bind(this));
    return this;
  }

  throw new TypeError('Unexpected data type ('+ typeof data + ')');
}
util.inherits(DataStream, Stream);

DataStream.prototype.write = function write(data) {
  this.buffer = Buffer.concat([this.buffer, Buffer.from(data)]);
  this.emit('data', data);
};

DataStream.prototype.end = function end(data) {
  if (data)
    this.write(data);
  this.emit('end', data);
  this.emit('close');
  this.writable = false;
  this.readable = false;
};

module.exports = DataStream;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "VYiD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;


/***/ }),

/***/ "Vgbh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const constants = exports;

// Helper
constants._reverse = function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__("vqf+");


/***/ }),

/***/ "VkvE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("G+mE").PassThrough


/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPricesByDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClosingDatesRanges; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ldK3");














var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n              siblingId\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n                offerId\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_CALENDAR */ "cd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit;
  var bookableDatesQueryArs = {
    productId: productId,
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_BOOKABLE_DATES */ "bd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_7___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_7___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__[/* getSpecificQueryParam */ "k"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__[/* QUERY_DEPARTURE_DATE */ "g"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_7___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer,
              siblingId = _ref6.siblingId;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2, _priceConfig$termsAnd5;

            var available = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_OPEN */ "g"];
            var closed = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_CLOSED */ "a"];
            var exclusivity = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_EXCLUSIVITY */ "b"];
            var full = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_FULL */ "c"];
            var lastAvailability = offer === 'urgentisation';
            var noAvailability = availability === '';
            var noDeparture = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_DEPARTURE */ "e"];
            var noFlight = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_FLIGHT */ "f"];
            var siblingOpen = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_SUMMER */ "h"] || availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_WINTER */ "i"];
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              rate: priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd5 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd5 === void 0 ? void 0 : _priceConfig$termsAnd5.offerId,
              siblingId: siblingId,
              siblingOpen: siblingOpen,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}
var getClosingDatesRanges = function getClosingDatesRanges(openingDatesRanges) {
  return openingDatesRanges.sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  }).map(function (openingDate, index, openingDates) {
    var _openingDates;

    return {
      after: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "j"])(openingDate.closing).toDate(),
      before: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "j"])(((_openingDates = openingDates[index + 1]) === null || _openingDates === void 0 ? void 0 : _openingDates.opening) || openingDates[0].opening).toDate()
    };
  });
};

/***/ }),

/***/ "W+NJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputButton_InputButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var InputButton_themes_defaultTheme = function defaultTheme(_ref) {
  var isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled;
  var hasDefaultStyle = !isActive && !isFilled && !isDisabled;
  var hasFilledStyle = isFilled && !isDisabled;
  var hasActiveStyle = isActive && !isDisabled && !isFilled;
  return {
    thRoot: Object(classnames_utils["a" /* classnames */])('flex w-full items-center rounded-pill border text-14 leading-normal text-black transition-all duration-250 ease-in', {
      'border-lightGrey hocus:border-black': hasDefaultStyle,
      'border-black': hasActiveStyle,
      'border-success text-black': hasFilledStyle,
      'cursor-not-allowed border-grey bg-pearl text-grey': isDisabled
    }),
    thButton: 'flex gap-10 items-center flex-1 h-48 px-20 py-10',
    thIcon: Object(classnames_utils["a" /* classnames */])('flex-none shrink-0', {
      'text-success': isFilled
    }),
    thIconSize: '1.25em',
    thChildren: 'flex-1 text-initial',
    thBadge: 'size-24 text-black bg-saffron border-saffron',
    thIconRight: 'leading-0 pe-20 py-10 shrink-0',
    thSpinner: 'shrink-0 text-current',
    thIconCaret: 'transition-all duration-250 ease-in',
    thClear: 'leading-0 pe-20 py-10 shrink-0',
    thClearSize: '0.625rem',
    thSwitchButton: 'leading-0 pe-20 py-10 shrink-0',
    thSwitch: Object(classnames_utils["a" /* classnames */])('flex h-24 w-40 overflow-hidden rounded-pill border-current bg-current p-2 leading-0 transition-all duration-250 ease-in', {
      'text-lightGrey': !isFilled,
      'text-success': isFilled
    }),
    thSwitchToggler: Object(classnames_utils["a" /* classnames */])('flex size-20 items-center justify-center rounded-pill bg-white text-center text-10 font-bold leading-0 shadow', {
      'text-lightGrey': !isFilled,
      'transform text-success ltr:translate-x-[16px] rtl:-translate-x-[16px]': isFilled
    })
  };
};

var themes = function themes(props) {
  var d = InputButton_themes_defaultTheme(props);
  return {
    "default": d,
    remote: _objectSpread(_objectSpread({}, d), {}, {
      thButton: 'flex gap-5 items-center justify-center flex-1 h-48 p-10',
      thChildren: 'text-initial',
      thBadge: 'hidden',
      thClear: 'hidden',
      thIconRight: 'hidden',
      thSwitchButton: 'hidden'
    })
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx
var __jsx = react_default.a.createElement;

/* eslint-disable react/jsx-no-useless-fragment */







var InputButton_InputButton = function InputButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      badgeCount = _ref.badgeCount,
      _ref$hasSwitch = _ref.hasSwitch,
      hasSwitch = _ref$hasSwitch === void 0 ? false : _ref$hasSwitch,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var _themes$theme = themes({
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isLoading: isLoading
  })[theme],
      thBadge = _themes$theme.thBadge,
      thButton = _themes$theme.thButton,
      thChildren = _themes$theme.thChildren,
      thClear = _themes$theme.thClear,
      thClearSize = _themes$theme.thClearSize,
      thIcon = _themes$theme.thIcon,
      thIconRight = _themes$theme.thIconRight,
      thIconCaret = _themes$theme.thIconCaret,
      thIconSize = _themes$theme.thIconSize,
      thSpinner = _themes$theme.thSpinner,
      thRoot = _themes$theme.thRoot,
      thSwitch = _themes$theme.thSwitch,
      thSwitchButton = _themes$theme.thSwitchButton,
      thSwitchToggler = _themes$theme.thSwitchToggler;

  if (!iconName && !children) {
    return null;
  }

  var hasClear = onClear && isFilled && !isLoading && !isDisabled;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, __jsx("button", {
    className: thButton,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: onClick,
    title: title,
    type: "button"
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])(thIcon),
    name: iconName,
    width: thIconSize
  }), __jsx("span", {
    className: thChildren
  }, children), !!badgeCount && __jsx(Badge["a" /* Badge */], {
    className: thBadge,
    label: __jsx("span", {
      className: "-me-1 mt-1"
    }, badgeCount),
    variant: "pill"
  })), !hasSwitch && __jsx(react["Fragment"], null, hasClear ? __jsx("button", {
    "data-testid": "InputButtonClear",
    className: thClear,
    disabled: isDisabled,
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearSize
  })) : __jsx("button", {
    className: thIconRight,
    onClick: onClick,
    type: "button"
  }, isLoading ? __jsx(Spinner["a" /* Spinner */], {
    className: thSpinner,
    size: "small"
  }) : __jsx(Icon["a" /* Icon */], {
    className: thIconCaret,
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: "0.625rem"
  }))), hasSwitch && __jsx("button", {
    className: thSwitchButton,
    "data-testid": "InputButtonClear",
    onClick: hasClear ? onClear : onClick,
    type: "button"
  }, __jsx("span", {
    className: thSwitch
  }, __jsx("span", {
    "aria-hidden": true,
    className: thSwitchToggler
  }, __jsx(Icon["a" /* Icon */], {
    name: isFilled ? icons["a" /* ICONS */].ON : icons["a" /* ICONS */].OFF,
    width: "0.5rem"
  })))));
};

/***/ }),

/***/ "W/Kd":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("695J");
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "W3Hu":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var jws = __webpack_require__("FbvT");
var ms = __webpack_require__("W7RI");
var timespan = __webpack_require__("mWK7");
var xtend = __webpack_require__("GKv7");

var JWT = module.exports;

var JsonWebTokenError = JWT.JsonWebTokenError = __webpack_require__("hXSc");
var NotBeforeError = module.exports.NotBeforeError = __webpack_require__("nWHK");
var TokenExpiredError = JWT.TokenExpiredError = __webpack_require__("A110");

JWT.decode = function (jwt, options) {
  options = options || {};
  var decoded = jws.decode(jwt, options);
  if (!decoded) { return null; }
  var payload = decoded.payload;

  //try parse the payload
  if(typeof payload === 'string') {
    try {
      var obj = JSON.parse(payload);
      if(typeof obj === 'object') {
        payload = obj;
      }
    } catch (e) { }
  }

  //return header if `complete` option is enabled.  header includes claims
  //such as `kid` and `alg` used to select the key within a JWKS needed to
  //verify the signature
  if (options.complete === true) {
    return {
      header: decoded.header,
      payload: payload,
      signature: decoded.signature
    };
  }
  return payload;
};

var payload_options = [
  'expiresIn',
  'notBefore',
  'expiresInMinutes',
  'expiresInSeconds',
  'audience',
  'issuer',
  'subject',
  'jwtid'
];

JWT.sign = function(payload, secretOrPrivateKey, options, callback) {
  options = options || {};
  var header = {};

  if (typeof payload === 'object') {
    header.typ = 'JWT';
    payload = xtend(payload);
  } else {
    var invalid_option = payload_options.filter(function (key) {
      return typeof options[key] !== 'undefined';
    })[0];

    if (invalid_option) {
      console.warn('invalid "' + invalid_option + '" option for ' + (typeof payload) + ' payload');
    }
  }


  header.alg = options.algorithm || 'HS256';

  if (options.headers) {
    Object.keys(options.headers).forEach(function (k) {
      header[k] = options.headers[k];
    });
  }

  var timestamp = Math.floor(Date.now() / 1000);
  if (!options.noTimestamp) {
    payload.iat = payload.iat || timestamp;
  }

  if (typeof options.notBefore !== 'undefined') {
    payload.nbf = timespan(options.notBefore);
    if (typeof payload.nbf === 'undefined') {
      throw new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60');
    }
  }

  if (options.expiresInSeconds || options.expiresInMinutes) {
    var deprecated_line;
    try {
      deprecated_line = /.*\((.*)\).*/.exec((new Error()).stack.split('\n')[2])[1];
    } catch(err) {
      deprecated_line = '';
    }

    console.warn('jsonwebtoken: expiresInMinutes and expiresInSeconds is deprecated. (' + deprecated_line + ')\n' +
                 'Use "expiresIn" expressed in seconds.');

    var expiresInSeconds = options.expiresInMinutes ?
        options.expiresInMinutes * 60 :
        options.expiresInSeconds;

    payload.exp = timestamp + expiresInSeconds;
  } else if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
    payload.exp = timespan(options.expiresIn);
    if (typeof payload.exp === 'undefined') {
      throw new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60');
    }
  }

  if (options.audience)
    payload.aud = options.audience;

  if (options.issuer)
    payload.iss = options.issuer;

  if (options.subject)
    payload.sub = options.subject;

  if (options.jwtid)
    payload.jti = options.jwtid;

  var encoding = 'utf8';
  if (options.encoding) {
    encoding = options.encoding;
  }

  if(typeof callback === 'function') {
    jws.createSign({
      header: header,
      privateKey: secretOrPrivateKey,
      payload: JSON.stringify(payload)
    }).on('done', callback);
  } else {
    return jws.sign({header: header, payload: payload, secret: secretOrPrivateKey, encoding: encoding});
  }
};

JWT.verify = function(jwtString, secretOrPublicKey, options, callback) {
  if ((typeof options === 'function') && !callback) {
    callback = options;
    options = {};
  }

  if (!options) options = {};

  var done;

  if (callback) {
    done = function() {
      var args = Array.prototype.slice.call(arguments, 0);
      return process.nextTick(function() {
        callback.apply(null, args);
      });
    };
  } else {
    done = function(err, data) {
      if (err) throw err;
      return data;
    };
  }

  if (!jwtString){
    return done(new JsonWebTokenError('jwt must be provided'));
  }

  var parts = jwtString.split('.');

  if (parts.length !== 3){
    return done(new JsonWebTokenError('jwt malformed'));
  }

  if (parts[2].trim() === '' && secretOrPublicKey){
    return done(new JsonWebTokenError('jwt signature is required'));
  }

  if (!secretOrPublicKey) {
    return done(new JsonWebTokenError('secret or public key must be provided'));
  }

  if (!options.algorithms) {
    options.algorithms = ~secretOrPublicKey.toString().indexOf('BEGIN CERTIFICATE') ||
                         ~secretOrPublicKey.toString().indexOf('BEGIN PUBLIC KEY') ?
                          [ 'RS256','RS384','RS512','ES256','ES384','ES512' ] :
                         ~secretOrPublicKey.toString().indexOf('BEGIN RSA PUBLIC KEY') ?
                          [ 'RS256','RS384','RS512' ] :
                          [ 'HS256','HS384','HS512' ];

  }

  var decodedToken;
  try {
    decodedToken = jws.decode(jwtString);
  } catch(err) {
    return done(new JsonWebTokenError('invalid token'));
  }

  if (!decodedToken) {
    return done(new JsonWebTokenError('invalid token'));
  }

  var header = decodedToken.header;

  if (!~options.algorithms.indexOf(header.alg)) {
    return done(new JsonWebTokenError('invalid algorithm'));
  }

  var valid;

  try {
    valid = jws.verify(jwtString, header.alg, secretOrPublicKey);
  } catch (e) {
    return done(e);
  }

  if (!valid)
    return done(new JsonWebTokenError('invalid signature'));

  var payload;

  try {
    payload = JWT.decode(jwtString);
  } catch(err) {
    return done(err);
  }

  if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
    if (typeof payload.nbf !== 'number') {
      return done(new JsonWebTokenError('invalid nbf value'));
    }
    if (payload.nbf > Math.floor(Date.now() / 1000)) {
      return done(new NotBeforeError('jwt not active', new Date(payload.nbf * 1000)));
    }
  }

  if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
    if (typeof payload.exp !== 'number') {
      return done(new JsonWebTokenError('invalid exp value'));
    }
    if (Math.floor(Date.now() / 1000) >= payload.exp)
      return done(new TokenExpiredError('jwt expired', new Date(payload.exp * 1000)));
  }

  if (options.audience) {
    var audiences = Array.isArray(options.audience)? options.audience : [options.audience];
    var target = Array.isArray(payload.aud) ? payload.aud : [payload.aud];

    var match = target.some(function(aud) { return audiences.indexOf(aud) != -1; });

    if (!match)
      return done(new JsonWebTokenError('jwt audience invalid. expected: ' + audiences.join(' or ')));
  }

  if (options.issuer) {
    var invalid_issuer =
        (typeof options.issuer === 'string' && payload.iss !== options.issuer) ||
        (Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1);

    if (invalid_issuer) {
      return done(new JsonWebTokenError('jwt issuer invalid. expected: ' + options.issuer));
    }
  }

  if (options.subject) {
    if (payload.sub !== options.subject) {
      return done(new JsonWebTokenError('jwt subject invalid. expected: ' + options.subject));
    }
  }

  if (options.jwtid) {
    if (payload.jti !== options.jwtid) {
      return done(new JsonWebTokenError('jwt jwtid invalid. expected: ' + options.jwtid));
    }
  }

  if (options.maxAge) {
    var maxAge = ms(options.maxAge);
    if (typeof payload.iat !== 'number') {
      return done(new JsonWebTokenError('iat required when maxAge is specified'));
    }
    if (Date.now() - (payload.iat * 1000) > maxAge) {
      return done(new TokenExpiredError('maxAge exceeded', new Date(payload.iat * 1000 + maxAge)));
    }
  }

  return done(null, payload);
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "W5pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ HeaderLite_HeaderLite; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/widgets/product-block-header/ProductBlockHeader.jsx + 1 modules
var ProductBlockHeader = __webpack_require__("8Cfg");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/B2BProposalPdfDownloadButton.jsx















var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var getFilename = function getFilename(resort, proposal) {
  var _resort$name;

  return "".concat(resort === null || resort === void 0 ? void 0 : (_resort$name = resort.name) === null || _resort$name === void 0 ? void 0 : _resort$name.replace(/ /g, '_'), "-").concat(proposal.arrivalDate, "_").concat(proposal.departureDate);
};

var B2BProposalPdfDownloadButton_handleSubmit = function handleSubmit(proposal, appContext, router, dispatch, track) {
  return function (event) {
    event.preventDefault();
    event.stopPropagation();
    track({});
    var hasIdentifiedAttendees = proposal.households.some(function (household) {
      return household.attendees.some(function (attendee) {
        return attendee.customerId;
      });
    });

    if (appContext.isCxo && hasIdentifiedAttendees) {
      var _router$query, _router$query2;

      Object(proposals_action["p" /* patchProposalHandler */])(proposal.id, appContext, true)(dispatch);
      Object(proposals_action["v" /* saveCustomerProposalsOpportunityIdHandler */])(proposal.id, appContext, (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.cxo_primarycontact, (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.cxo_opportunity_guid)(dispatch);
    }

    event.target.submit();
  };
};

var B2BProposalPdfDownloadButton_PdfActionsModal = function PdfActionsModal(props) {
  var proposal = props.proposal,
      _props$isOnComparator = props.isOnComparator,
      isOnComparator = _props$isOnComparator === void 0 ? false : _props$isOnComparator,
      onClose = props.onClose,
      resort = props.resort;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var noIdentifiedAttendee = proposal.households.every(function (_ref) {
    var attendees = _ref.attendees;
    return attendees.every(function (_ref2) {
      var customerId = _ref2.customerId;
      return !customerId;
    });
  });
  var track = Object(useTracking["a" /* useTracking */])(_objectSpread(_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'banking',
    labelGA: isOnComparator ? 'downloadPDF' : 'CTA_download'
  }));

  function onClickSendEmail() {
    var _router$query3, _router$query4;

    var pageTypeParam = 'pagetype=entityrecord';
    var entityTypeParam = 'etn=email';
    var extraQueryParams = "extraqs=cxo_proposalids%3D".concat(proposal.id);
    window.open("".concat(config_default.a.get('dynamics.url'), "&").concat(pageTypeParam, "&").concat(entityTypeParam, "&").concat(extraQueryParams));
    Object(proposals_action["v" /* saveCustomerProposalsOpportunityIdHandler */])(proposal.id, appContext, (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.cxo_primarycontact, (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.cxo_opportunity_guid)(dispatch);
  }

  var filename = getFilename(resort, proposal);
  var apiKey = config_default.a.get('api.seller.api_key');
  return __jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(i18n["h" /* t */])('seller.downloadPdf.shareProposals'),
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: onClose
  }, __jsx("div", {
    className: "text-blue p-20 text-center text-24 font-bold"
  }, Object(i18n["h" /* t */])('seller.downloadPdf.shareProposals')), __jsx("div", {
    className: "mb-40 flex w-full justify-center px-40"
  }, __jsx("div", null, __jsx("div", {
    className: classnames_default()({
      'mb-20': !noIdentifiedAttendee
    })
  }, Object(i18n["h" /* t */])('seller.downloadPdf.chooseMethod')), noIdentifiedAttendee && __jsx("div", {
    className: "text-danger text-sm mb-20 flex items-center font-bold"
  }, __jsx(Icon["a" /* Icon */], {
    className: "mr-5 flex-shrink self-start",
    color: colors["a" /* COLORS */].DANGER,
    name: icons["a" /* ICONS */].WARNING,
    width: "1.5em"
  }), Object(i18n["h" /* t */])('seller.downloadPdf.missingPaxInfo')), __jsx("div", {
    className: "flex w-full justify-center"
  }, __jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BLUE,
    className: "rounded-5 mr-20",
    isDisabled: noIdentifiedAttendee,
    onClick: onClickSendEmail,
    size: "mediumLarge"
  }, __jsx("span", {
    className: "px-4 text-16"
  }, Object(i18n["h" /* t */])('seller.downloadPdf.sendEmail'))), __jsx("form", {
    action: "/proposal-pdf",
    method: "post",
    onSubmit: B2BProposalPdfDownloadButton_handleSubmit(proposal, appContext, router, dispatch, track)
  }, __jsx("input", {
    type: "hidden",
    name: "proposalId",
    value: proposal.id
  }), __jsx("input", {
    type: "hidden",
    name: "filename",
    value: filename
  }), __jsx("input", {
    type: "hidden",
    name: "x-api-key",
    value: apiKey
  }), __jsx("input", {
    type: "hidden",
    name: "type",
    value: "attachment"
  }), __jsx("input", {
    type: "hidden",
    name: "downloadType",
    value: "attachment"
  }), __jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    className: "rounded-5",
    type: "submit",
    size: "mediumLarge"
  }, __jsx("span", {
    className: "px-4 text-16"
  }, Object(i18n["h" /* t */])('seller.downloadPdf.downloadPDF'))))))));
};

var B2BProposalPdfDownloadButton_B2BProposalPdfDownloadButton = function B2BProposalPdfDownloadButton(props) {
  var proposal = props.proposal,
      resort = props.resort;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var track = Object(useTracking["a" /* useTracking */])(_objectSpread(_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'banking',
    labelGA: 'CTA_download'
  }));
  var shouldDisplay = (appContext.isDirectCxo || appContext.isIndirectCxo) && !!Object(i18n["d" /* getKeyValue */])('seller.downloadPdf.displayCxo') || appContext.isCmta && !!Object(i18n["d" /* getKeyValue */])('seller.downloadPdf.displayCmta');

  if (!shouldDisplay) {
    return null;
  }

  var filename = getFilename(resort, proposal);
  var apiKey = config_default.a.get('api.seller.api_key');
  var shouldShareProposalByEmail = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.shareProposalByEmail') && appContext.isCxo && appContext.isDirectCxo;

  function onClick(event) {
    if (shouldShareProposalByEmail) {
      event.preventDefault();
      event.stopPropagation();
      setIsOpen(true);
    } else {
      B2BProposalPdfDownloadButton_handleSubmit(proposal, appContext, router, dispatch, track)(event);
    }
  }

  return __jsx(react["Fragment"], null, __jsx("form", {
    action: "/proposal-pdf",
    method: "post",
    onSubmit: onClick
  }, __jsx("input", {
    type: "hidden",
    name: "proposalId",
    value: proposal.id
  }), __jsx("input", {
    type: "hidden",
    name: "filename",
    value: filename
  }), __jsx("input", {
    type: "hidden",
    name: "x-api-key",
    value: apiKey
  }), __jsx("input", {
    type: "hidden",
    name: "type",
    value: "attachment"
  }), __jsx("input", {
    type: "hidden",
    name: "downloadType",
    value: "attachment"
  }), __jsx("button", {
    "data-testid": "pdf-download-button",
    className: classnames_default()('reset-button mx-10 flex flex-col items-center text-12 font-bold text-turquoise'),
    type: "submit"
  }, __jsx(Icon["a" /* Icon */], {
    className: classnames_default()('h-auto'),
    name: icons["a" /* ICONS */].DOWNLOAD,
    width: "1.25rem"
  }), __jsx("span", {
    className: "sr-only md:not-sr-only"
  }, Object(i18n["h" /* t */])('seller.downloadPdf.label')))), isOpen && __jsx(B2BProposalPdfDownloadButton_PdfActionsModal, Object(esm_extends["a" /* default */])({}, props, {
    onClose: function onClose() {
      return setIsOpen(false);
    }
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/header-lite/HeaderLite.jsx





var HeaderLite_jsx = react_default.a.createElement;










var HeaderLite_HeaderLite = function HeaderLite(_ref) {
  var actions = _ref.actions,
      product = _ref.product,
      proposal = _ref.proposal;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var isJoyview = !!(product === null || product === void 0 ? void 0 : product.isJoyview);

  var trackNavigation = function trackNavigation() {
    return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
      detail_click: 'back_resort_page'
    });
  }; // Build home URL with locale if not default locale


  var isDefaultLocale = appContext.locale === appContext.defaultLocale;
  var homeUrl = isDefaultLocale ? '/' : new URI_default.a('/').addQuery('locale', appContext.locale).toString();
  return HeaderLite_jsx("header", {
    className: "bg-white",
    role: "banner"
  }, HeaderLite_jsx("div", {
    className: "relative m-auto h-auto max-w-site md:flex md:justify-between lg:h-60"
  }, HeaderLite_jsx("div", {
    className: "relative flex items-center border-b-1 border-grey px-20 py-10 md:border-b-0 md:ps-0"
  }, HeaderLite_jsx(ProductBlockHeader["a" /* ProductBlockHeader */], {
    hasBackIcon: !appContext.isSeller,
    onClick: trackNavigation,
    product: product,
    queryParamsToIgnore: ['proposalIds', 'selectedProposalId', 'fromSearches', 'coderesort'],
    theme: "headerLite"
  })), HeaderLite_jsx("a", {
    rel: "noopener noreferrer",
    className: "absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 transform cursor-pointer self-center md:block",
    href: homeUrl
  }, HeaderLite_jsx(Icon["a" /* Icon */], {
    className: isJoyview ? 'text-blueWave' : 'text-black',
    "data-testid": "cm-logo",
    isNotSquare: true,
    name: isJoyview ? icons["a" /* ICONS */].CLUBMED_JOYVIEW : icons["a" /* ICONS */].CLUBMED,
    width: "9.125rem"
  })), HeaderLite_jsx("div", {
    className: "flex items-center justify-between px-20 py-10 md:px-0 md:py-0"
  }, HeaderLite_jsx("p", {
    className: "truncate font-sans text-14 font-bold md:px-20",
    "data-testid": "reference-number"
  }, [Object(i18n["h" /* t */])('common.reference'), proposal.id].join(' ')), HeaderLite_jsx("div", {
    className: "flex border-grey md:items-center md:self-stretch md:border-s-1 md:px-10"
  }, actions.filter(function (action) {
    return action.display;
  }).map(function (_ref2) {
    var iconName = _ref2.iconName,
        id = _ref2.id,
        label = _ref2.label,
        onClick = _ref2.onClick;
    return HeaderLite_jsx("button", {
      className: "mx-10 flex flex-col items-center text-12 font-bold text-black",
      "data-testid": "HeaderLite-action-btn-".concat(label),
      key: id,
      onClick: onClick,
      type: "button"
    }, HeaderLite_jsx(Icon["a" /* Icon */], {
      className: "h-auto",
      name: iconName,
      width: "1.25rem"
    }), HeaderLite_jsx("span", {
      className: "sr-only md:not-sr-only"
    }, label));
  }), HeaderLite_jsx(B2BProposalPdfDownloadButton_B2BProposalPdfDownloadButton, {
    proposal: proposal,
    resort: product
  })))));
};

/***/ }),

/***/ "W7RI":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}


/***/ }),

/***/ "Wtu2":
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("qW1w")
var Sha256 = __webpack_require__("KLYN")
var Hash = __webpack_require__("4rhd")
var Buffer = __webpack_require__("KLyV").Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),

/***/ "WxfE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__("KLyV").Buffer;

var getParamBytesForAlg = __webpack_require__("Aa57");

var MAX_OCTET = 0x80,
	CLASS_UNIVERSAL = 0,
	PRIMITIVE_BIT = 0x20,
	TAG_SEQ = 0x10,
	TAG_INT = 0x02,
	ENCODED_TAG_SEQ = (TAG_SEQ | PRIMITIVE_BIT) | (CLASS_UNIVERSAL << 6),
	ENCODED_TAG_INT = TAG_INT | (CLASS_UNIVERSAL << 6);

function base64Url(base64) {
	return base64
		.replace(/=/g, '')
		.replace(/\+/g, '-')
		.replace(/\//g, '_');
}

function signatureAsBuffer(signature) {
	if (Buffer.isBuffer(signature)) {
		return signature;
	} else if ('string' === typeof signature) {
		return Buffer.from(signature, 'base64');
	}

	throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
}

function derToJose(signature, alg) {
	signature = signatureAsBuffer(signature);
	var paramBytes = getParamBytesForAlg(alg);

	// the DER encoded param should at most be the param size, plus a padding
	// zero, since due to being a signed integer
	var maxEncodedParamLength = paramBytes + 1;

	var inputLength = signature.length;

	var offset = 0;
	if (signature[offset++] !== ENCODED_TAG_SEQ) {
		throw new Error('Could not find expected "seq"');
	}

	var seqLength = signature[offset++];
	if (seqLength === (MAX_OCTET | 1)) {
		seqLength = signature[offset++];
	}

	if (inputLength - offset < seqLength) {
		throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
	}

	if (signature[offset++] !== ENCODED_TAG_INT) {
		throw new Error('Could not find expected "int" for "r"');
	}

	var rLength = signature[offset++];

	if (inputLength - offset - 2 < rLength) {
		throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
	}

	if (maxEncodedParamLength < rLength) {
		throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
	}

	var rOffset = offset;
	offset += rLength;

	if (signature[offset++] !== ENCODED_TAG_INT) {
		throw new Error('Could not find expected "int" for "s"');
	}

	var sLength = signature[offset++];

	if (inputLength - offset !== sLength) {
		throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
	}

	if (maxEncodedParamLength < sLength) {
		throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
	}

	var sOffset = offset;
	offset += sLength;

	if (offset !== inputLength) {
		throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
	}

	var rPadding = paramBytes - rLength,
		sPadding = paramBytes - sLength;

	var dst = Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);

	for (offset = 0; offset < rPadding; ++offset) {
		dst[offset] = 0;
	}
	signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);

	offset = paramBytes;

	for (var o = offset; offset < o + sPadding; ++offset) {
		dst[offset] = 0;
	}
	signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);

	dst = dst.toString('base64');
	dst = base64Url(dst);

	return dst;
}

function countPadding(buf, start, stop) {
	var padding = 0;
	while (start + padding < stop && buf[start + padding] === 0) {
		++padding;
	}

	var needsSign = buf[start + padding] >= MAX_OCTET;
	if (needsSign) {
		--padding;
	}

	return padding;
}

function joseToDer(signature, alg) {
	signature = signatureAsBuffer(signature);
	var paramBytes = getParamBytesForAlg(alg);

	var signatureBytes = signature.length;
	if (signatureBytes !== paramBytes * 2) {
		throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
	}

	var rPadding = countPadding(signature, 0, paramBytes);
	var sPadding = countPadding(signature, paramBytes, signature.length);
	var rLength = paramBytes - rPadding;
	var sLength = paramBytes - sPadding;

	var rsBytes = 1 + 1 + rLength + 1 + 1 + sLength;

	var shortLength = rsBytes < MAX_OCTET;

	var dst = Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);

	var offset = 0;
	dst[offset++] = ENCODED_TAG_SEQ;
	if (shortLength) {
		// Bit 8 has value "0"
		// bits 7-1 give the length.
		dst[offset++] = rsBytes;
	} else {
		// Bit 8 of first octet has value "1"
		// bits 7-1 give the number of additional length octets.
		dst[offset++] = MAX_OCTET	| 1;
		// length, base 256
		dst[offset++] = rsBytes & 0xff;
	}
	dst[offset++] = ENCODED_TAG_INT;
	dst[offset++] = rLength;
	if (rPadding < 0) {
		dst[offset++] = 0;
		offset += signature.copy(dst, offset, 0, paramBytes);
	} else {
		offset += signature.copy(dst, offset, rPadding, paramBytes);
	}
	dst[offset++] = ENCODED_TAG_INT;
	dst[offset++] = sLength;
	if (sPadding < 0) {
		dst[offset++] = 0;
		signature.copy(dst, offset, paramBytes);
	} else {
		signature.copy(dst, offset, paramBytes + sPadding);
	}

	return dst;
}

module.exports = {
	derToJose: derToJose,
	joseToDer: joseToDer
};


/***/ }),

/***/ "X05J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "XAoU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("P2aG")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("xc2Q");
/*</replacement>*/

var Buffer = __webpack_require__("+ZX+").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__("kzMc");
var _require = __webpack_require__("OX+y"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__("1037").codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__("qW1w")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("ulH6");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__("ulH6");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq"), __webpack_require__("F63i")))

/***/ }),

/***/ "Xvk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID; });
var FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID = 'FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID';

/***/ }),

/***/ "Y0Mb":
/***/ (function(module) {

module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

/***/ }),

/***/ "Y4pH":
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),

/***/ "YVWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCtaTypeChildcare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return includedAndNotIncludedChildcares; });
/* unused harmony export getFormattedPricePerDay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasChildrenAgedXOrLess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFormatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOverloadChildcareDataForChalet; });
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wz9x");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ldK3");










var API_DATE_FORMAT = 'YYYYMMDD';

function getCtaTypeChildcare(childcare) {
  var _childcare$pricingInf, _childcare$pricingInf2, _currentChildInfos$sc;

  var childId = childcare.pricingInfo.childId;
  var currentChildData = (_childcare$pricingInf = childcare.pricingInfo.attendees) === null || _childcare$pricingInf === void 0 ? void 0 : _childcare$pricingInf.find(function (attendee) {
    return attendee.id === childId;
  });
  var currentChildHasRentedChildcare = (currentChildData === null || currentChildData === void 0 ? void 0 : currentChildData.rentedAmount) && currentChildData.rentedAmount.value > 0;

  if (currentChildHasRentedChildcare) {
    return {
      type: 'remove',
      tracking: 'removeFromCart'
    };
  }

  if (childcare.pricingInfo.isFullyPaid) {
    return {
      type: 'none'
    };
  }

  var currentChildInfos = (_childcare$pricingInf2 = childcare.pricingInfo.attendees) === null || _childcare$pricingInf2 === void 0 ? void 0 : _childcare$pricingInf2.find(function (attendee) {
    return attendee.id === childId;
  }); // the mini clubmed is always included

  var isChildcarePetitOrBaby = childcare.productInfo.ageInMonths.min === 4 || 24;
  var allScheduleSlotsAreFullOrPaid = currentChildInfos === null || currentChildInfos === void 0 ? void 0 : (_currentChildInfos$sc = currentChildInfos.schedules) === null || _currentChildInfos$sc === void 0 ? void 0 : _currentChildInfos$sc.every(function (_ref) {
    var timeSlots = _ref.timeSlots;
    return timeSlots.every(function (_ref2) {
      var remainingStock = _ref2.remainingStock,
          isPaid = _ref2.isPaid;
      return remainingStock === 0 || isPaid;
    });
  });
  var childcareIsFull = isChildcarePetitOrBaby && allScheduleSlotsAreFullOrPaid;

  if (childcareIsFull) {
    return {
      type: 'full'
    };
  }

  return {
    type: 'add',
    tracking: 'addToCart'
  };
}

function getFormattedPricePerDay(price, tripDuration, locale) {
  var pricePerDay = price / tripDuration;
  return Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__[/* formatAmountForLocale */ "b"])(pricePerDay, locale);
}

function isChildAgedXOrLess(birthdate, targetAge) {
  return moment__WEBPACK_IMPORTED_MODULE_7___default()(birthdate, API_DATE_FORMAT).isAfter(moment__WEBPACK_IMPORTED_MODULE_7___default()().startOf('day').subtract(targetAge, 'years'));
}

function hasChildrenAgedXOrLess(attendees, targetAge) {
  return attendees.filter(function (attendee) {
    return isChildAgedXOrLess(attendee.birthdate, targetAge);
  }).length > 0;
}

function getCurrentChild(items, itemId) {
  return items.find(function (_ref3) {
    var id = _ref3.id;
    return id === itemId;
  });
} // $FlowFixMe Always found


function getCurrentKid(items, currentChild) {
  return items.find(function (item) {
    if (item.id) {
      return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* timestampToApiDate */ "n"])(item.birthdate) === currentChild.birthdate && item.id === currentChild.id;
    }

    if (item.neolid && currentChild.customerId) {
      return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* timestampToApiDate */ "n"])(item.birthdate) === currentChild.birthdate && item.neolid === currentChild.customerId;
    }

    return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* timestampToApiDate */ "n"])(item.birthdate) === currentChild.birthdate;
  });
}

function getFormatDate(item, message) {
  return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* formatApiDate */ "g"])(lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(item, 'birthdate', ''), message);
}

var includedAndNotIncludedChildcares = function includedAndNotIncludedChildcares(childcareList) {
  return childcareList.reduce(function (acc, childcare) {
    if (childcare.productInfo.isIncluded) {
      acc.includedChildcares.push(childcare);
    } else {
      acc.notIncludedChildcares.push(childcare);
    }

    return acc;
  }, {
    includedChildcares: [],
    notIncludedChildcares: []
  });
};

var getOverloadChildcareDataForChalet = function getOverloadChildcareDataForChalet(_ref4) {
  var _proposalsWithDiffere;

  var proposals = _ref4.proposals,
      currentChildcareId = _ref4.currentChildcareId,
      currentChildId = _ref4.currentChildId;

  if (proposals.every(function (_ref5) {
    var additionalServices = _ref5.additionalServices;
    return additionalServices.childcares.some(function (_ref6) {
      var pricingInfo = _ref6.pricingInfo;
      return pricingInfo.schedules.some(function (_ref7) {
        var slots = _ref7.slots;
        var r = slots.some(function (_ref8) {
          var attendees = _ref8.attendees,
              id = _ref8.id;
          return id === currentChildcareId && attendees.some(function (_ref9) {
            var idChild = _ref9.id;
            return idChild === currentChildId;
          });
        });
        return r;
      });
    });
  })) {
    return;
  }

  var proposalsWithDifferentChildcare = proposals.filter(function (_ref10) {
    var additionalServices = _ref10.additionalServices;
    return !additionalServices.childcares.some(function (_ref11) {
      var pricingInfo = _ref11.pricingInfo;
      return pricingInfo.schedules.some(function (_ref12) {
        var slots = _ref12.slots;
        var r = slots.some(function (_ref13) {
          var attendees = _ref13.attendees,
              id = _ref13.id;
          return id === currentChildcareId && attendees.some(function (_ref14) {
            var idChild = _ref14.id;
            return idChild === currentChildId;
          });
        });
        return r;
      });
    });
  });
  var payload = {
    proposalIds: proposalsWithDifferentChildcare.map(function (_ref15) {
      var id = _ref15.id;
      return id;
    }),
    serviceIds: [((_proposalsWithDiffere = proposalsWithDifferentChildcare[0].additionalServices.childcares.find(function (_ref16) {
      var _pricingInfo$attendee;

      var pricingInfo = _ref16.pricingInfo;
      return (_pricingInfo$attendee = pricingInfo.attendees) === null || _pricingInfo$attendee === void 0 ? void 0 : _pricingInfo$attendee.some(function (_ref17) {
        var id = _ref17.id;
        return id === currentChildId;
      });
    } // $FlowFixMe always found
    )) === null || _proposalsWithDiffere === void 0 ? void 0 : _proposalsWithDiffere.pricingInfo.schedules[0].slots[0].id) || '']
  };
  return payload;
};



/***/ }),

/***/ "YbGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = __webpack_require__("VYiD").codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__("ekAB");
__webpack_require__("qW1w")(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ "YjXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSwitch_InputSwitch; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isString.js
var isString = __webpack_require__("nDih");
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.themes.js










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var themes = {
  "default": function _default(props) {
    var color = props.color,
        isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        isRequired = props.isRequired,
        validationState = props.validationState;
    var hasValidStyle = validationState === 'IS_VALID' && !isDisabled && !isReadOnly;
    var hasInvalidStyle = validationState === 'IS_INVALID' && !isDisabled && !isReadOnly;
    return {
      thRoot: 'flex gap-10 items-center',
      thLabel: Object(classnames_utils["a" /* classnames */])('mt-1 inline-block text-14 font-bold leading-tight text-black', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props))),
      thChecked: Object(classnames_utils["a" /* classnames */])('outline-custom-sibling flex h-24 w-24 shrink-0 items-center justify-center rounded-8 border p-2 text-14', {
        'border-black': !isDisabled,
        'border-grey bg-pearl text-grey': isDisabled,
        'border-success text-success': hasValidStyle && isRequired,
        'formik-errored border-red text-red': hasInvalidStyle && isRequired
      }),
      thSwitch: Object(classnames_utils["a" /* classnames */])('flex h-32 w-56 items-center rounded-pill border-1 p-4 transition-all duration-250 ease-in', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), Object(defineProperty["a" /* default */])({
        'border-lightGrey bg-lightGrey text-lightGrey': !isChecked || isDisabled
      }, "bg-".concat(color, " border-").concat(color), isChecked && !isDisabled)),
      thSwitchToggler: Object(classnames_utils["a" /* classnames */])('block flex h-24 w-24 items-center justify-center rounded-full bg-white leading-0 text-lightGrey transition-all duration-250 ease-in', Object(defineProperty["a" /* default */])({
        'transform ltr:translate-x-full rtl:-translate-x-full': isChecked
      }, "text-".concat(color), isChecked && !isDisabled))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx




















var __jsx = react_default.a.createElement;

function InputSwitch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InputSwitch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InputSwitch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InputSwitch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }










var defaultProps = {
  color: colors["a" /* COLORS */].SAFFRON,
  iconChecked: icons["a" /* ICONS */].CHECK,
  iconUnChecked: null,
  isDisabled: false,
  isLoading: false,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
};
var InputSwitch_InputSwitch = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSwitch, _Component);

  var _super = _createSuper(InputSwitch);

  function InputSwitch(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSwitch);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function () {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? '' : _this$props$value;

      if (!isReadOnly && !isDisabled && !isLoading) {
        var isChecked = !_this.state.isChecked;

        _this.setState({
          isChecked: isChecked
        }, function () {
          return onChange(name, isChecked, value);
        });
      }
    });

    _this.state = {
      isChecked: props.isChecked || false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSwitch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isChecked !== this.props.isChecked) {
        this.setState({
          isChecked: this.props.isChecked
        });
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props2 = this.props,
          _this$props2$iconChec = _this$props2.iconChecked,
          iconChecked = _this$props2$iconChec === void 0 ? null : _this$props2$iconChec,
          _this$props2$iconUnCh = _this$props2.iconUnChecked,
          iconUnChecked = _this$props2$iconUnCh === void 0 ? null : _this$props2$iconUnCh;
      return this.state.isChecked ? iconChecked : iconUnChecked;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          ariaDescribedby = _this$props3.ariaDescribedby,
          ariaLabelledby = _this$props3.ariaLabelledby,
          className = _this$props3.className,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? "InputSwitch_".concat(shortid_default.a.generate()) : _this$props3$id,
          inputTestId = _this$props3.inputTestId,
          isDisabled = _this$props3.isDisabled,
          isLoading = _this$props3.isLoading,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          isSwitch = _this$props3.isSwitch,
          label = _this$props3.label,
          name = _this$props3.name,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme,
          value = _this$props3.value,
          dataTestId = _this$props3.dataTestId;
      var isChecked = this.state.isChecked;

      var _themes$theme = themes[theme](InputSwitch_objectSpread({
        isChecked: isChecked
      }, this.props)),
          thChecked = _themes$theme.thChecked,
          thLabel = _themes$theme.thLabel,
          thRoot = _themes$theme.thRoot,
          thSwitch = _themes$theme.thSwitch,
          thSwitchToggler = _themes$theme.thSwitchToggler;

      return __jsx("div", {
        "data-testid": dataTestId,
        className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
      }, isSwitch ? __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: thSwitch,
        "data-testid": id,
        onClick: this.onChange,
        role: "checkbox",
        type: "button"
      }, __jsx("span", {
        className: thSwitchToggler
      }, __jsx(Icon["a" /* Icon */], {
        className: Object(classnames_utils["a" /* classnames */])({
          'opacity-0 transition-opacity': isChecked
        }),
        name: icons["a" /* ICONS */].FAT_DOT,
        width: "0.5rem"
      }))) : __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: thChecked,
        "data-testid": id,
        disabled: isDisabled,
        onClick: this.onChange,
        role: "checkbox",
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: this.getIcon(),
        width: "1em"
      })), __jsx("input", {
        checked: isChecked,
        className: "hidden",
        disabled: isDisabled,
        id: id,
        "data-testid": inputTestId,
        label: label,
        name: name,
        onChange: this.onChange,
        onClick: onClick,
        required: isRequired,
        type: "checkbox",
        value: value
      }), isLoading && !isDisabled && !isReadOnly && __jsx(Spinner["a" /* Spinner */], {
        size: "small"
      }), !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, isString_default()(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label));
    }
  }]);

  return InputSwitch;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSwitch_InputSwitch, "defaultProps", defaultProps);

/***/ }),

/***/ "Z/bG":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('flatten', __webpack_require__("1xil"), __webpack_require__("zUlE"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "Z0Tt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("1Ll7");


/***/ }),

/***/ "Z2BD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCountriesQuery; });
var getCountriesQuery = function getCountriesQuery() {
  return "\nquery {\n  countries {\n    value\n    name\n    phoneCode\n  }\n}";
};

/***/ }),

/***/ "Z2QO":
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__("5WMi");
} else {}


/***/ }),

/***/ "ZK3j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("Y4pH");
var inherits = __webpack_require__("qW1w");

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),

/***/ "ZP1f":
/***/ (function(module, exports, __webpack_require__) {

/*global module*/
var Buffer = __webpack_require__("KLyV").Buffer;
var DataStream = __webpack_require__("VWRg");
var jwa = __webpack_require__("5MfQ");
var Stream = __webpack_require__("6dwG");
var toString = __webpack_require__("6sN/");
var util = __webpack_require__("XLvf");
var JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;

function isObject(thing) {
  return Object.prototype.toString.call(thing) === '[object Object]';
}

function safeJsonParse(thing) {
  if (isObject(thing))
    return thing;
  try { return JSON.parse(thing); }
  catch (e) { return undefined; }
}

function headerFromJWS(jwsSig) {
  var encodedHeader = jwsSig.split('.', 1)[0];
  return safeJsonParse(Buffer.from(encodedHeader, 'base64').toString('binary'));
}

function securedInputFromJWS(jwsSig) {
  return jwsSig.split('.', 2).join('.');
}

function signatureFromJWS(jwsSig) {
  return jwsSig.split('.')[2];
}

function payloadFromJWS(jwsSig, encoding) {
  encoding = encoding || 'utf8';
  var payload = jwsSig.split('.')[1];
  return Buffer.from(payload, 'base64').toString(encoding);
}

function isValidJws(string) {
  return JWS_REGEX.test(string) && !!headerFromJWS(string);
}

function jwsVerify(jwsSig, algorithm, secretOrKey) {
  if (!algorithm) {
    var err = new Error("Missing algorithm parameter for jws.verify");
    err.code = "MISSING_ALGORITHM";
    throw err;
  }
  jwsSig = toString(jwsSig);
  var signature = signatureFromJWS(jwsSig);
  var securedInput = securedInputFromJWS(jwsSig);
  var algo = jwa(algorithm);
  return algo.verify(securedInput, signature, secretOrKey);
}

function jwsDecode(jwsSig, opts) {
  opts = opts || {};
  jwsSig = toString(jwsSig);

  if (!isValidJws(jwsSig))
    return null;

  var header = headerFromJWS(jwsSig);

  if (!header)
    return null;

  var payload = payloadFromJWS(jwsSig);
  if (header.typ === 'JWT' || opts.json)
    payload = JSON.parse(payload, opts.encoding);

  return {
    header: header,
    payload: payload,
    signature: signatureFromJWS(jwsSig)
  };
}

function VerifyStream(opts) {
  opts = opts || {};
  var secretOrKey = opts.secret||opts.publicKey||opts.key;
  var secretStream = new DataStream(secretOrKey);
  this.readable = true;
  this.algorithm = opts.algorithm;
  this.encoding = opts.encoding;
  this.secret = this.publicKey = this.key = secretStream;
  this.signature = new DataStream(opts.signature);
  this.secret.once('close', function () {
    if (!this.signature.writable && this.readable)
      this.verify();
  }.bind(this));

  this.signature.once('close', function () {
    if (!this.secret.writable && this.readable)
      this.verify();
  }.bind(this));
}
util.inherits(VerifyStream, Stream);
VerifyStream.prototype.verify = function verify() {
  try {
    var valid = jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
    var obj = jwsDecode(this.signature.buffer, this.encoding);
    this.emit('done', valid, obj);
    this.emit('data', valid);
    this.emit('end');
    this.readable = false;
    return valid;
  } catch (e) {
    this.readable = false;
    this.emit('error', e);
    this.emit('close');
  }
};

VerifyStream.decode = jwsDecode;
VerifyStream.isValid = isValidJws;
VerifyStream.verify = jwsVerify;

module.exports = VerifyStream;


/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qqKu");
/* harmony import */ var _rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tuzA");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("EkOT");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;









var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      _ref$rate = _ref.rate,
      rate = _ref$rate === void 0 ? '' : _ref$rate,
      startDate = _ref.startDate,
      unit = _ref.unit;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_9__[/* usePageContext */ "b"])(),
      pageType = _usePageContext.pageType;

  var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].isMicePage(pageType);
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.buttonLabel');

  var _getRateMessagesPrope = Object(_rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_8__[/* getRateMessagesProperties */ "a"])(rate),
      rateContent = _getRateMessagesPrope.rateContent,
      rateTitle = _getRateMessagesPrope.rateTitle; // Display text only in product Thumbnails popin


  var rateObject = onClick ? {
    rateContent: rateContent,
    rateTitle: rateTitle
  } : {};
  return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__[/* Text */ "a"], {
    className: "p-20",
    text: isMice ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionForME', {
      unit: unit
    }) : [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.roomAvailability'), rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateTitle, rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateContent].join(' '),
    theme: "text-sans-n2"
  }), (isAllInclusive || isJoyview || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-lightGrey p-20"
  }, isAllInclusive && __jsx("p", {
    className: "flex max-w-full flex-col gap-5 text-center text-12 text-black sm:flex-row sm:flex-wrap sm:items-center sm:justify-center"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "flex items-center gap-5 font-brand text-16 text-sienna"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "text-sienna",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.startingPrice.allInclusive'))), isJoyview && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "-mt-5 text-blueWave",
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].CLUBMED_JOYVIEW,
    width: "10rem"
  }), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "a"], {
    className: "mt-10",
    "data-testid": "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "ZpYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ StripButton_StripButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.themes.js

var themes = function themes(_ref) {
  var color = _ref.color,
      colorBorder = _ref.colorBorder,
      orientation = _ref.orientation;
  return {
    "default": {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse relative',
      thInner: "bg-".concat(color, " border-").concat(orientation === 'top' ? 't' : 'b', "-1 border-").concat(colorBorder, " -m").concat(orientation === 'top' ? 'x' : '', "-1 overflow-hidden px-5 p").concat(orientation === 'top' ? 't' : 'b', "-5 text-center whitespace-nowrap")
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx

var __jsx = react_default.a.createElement;





var StripButton_StripButtonSvg = function StripButtonSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      colorBorder = _ref.colorBorder,
      height = _ref.height,
      hasBottomOrientation = _ref.hasBottomOrientation;
  return __jsx("svg", {
    className: Object(classnames_utils["a" /* classnames */])('fill-current', "text-".concat(color), className),
    viewBox: "0 0 15 30",
    height: height,
    style: {
      flexBasis: height / 2
    }
  }, __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    d: "M10,21H-5L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))), __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    style: {
      strokeWidth: '1px'
    },
    className: "fill-transparent stroke-current text-".concat(colorBorder),
    d: "M-5,21L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))));
};

var StripButton_StripButton = function StripButton(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
      _ref2$colorBorder = _ref2.colorBorder,
      colorBorder = _ref2$colorBorder === void 0 ? colors["a" /* COLORS */].LIGHT_GREY : _ref2$colorBorder,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? 'strip-button' : _ref2$dataTestId,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 30 : _ref2$height,
      onClick = _ref2.onClick,
      _ref2$orientation = _ref2.orientation,
      orientation = _ref2$orientation === void 0 ? 'top' : _ref2$orientation,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes({
    color: color,
    colorBorder: colorBorder,
    onClick: onClick,
    orientation: orientation
  })[theme],
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  var hasBottomOrientation = orientation === 'bottom';
  var svgProps = {
    color: color,
    colorBorder: colorBorder,
    height: height,
    hasBottomOrientation: hasBottomOrientation
  };
  var TagName = onClick ? 'button' : 'div';
  var btnProps = onClick ? {
    onClick: onClick,
    type: 'button'
  } : null;
  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-testid": dataTestId
  }, btnProps), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('transform', {
      '-scale-y-1': hasBottomOrientation
    })
  }, svgProps)), __jsx("span", {
    className: thInner,
    style: {
      height: height
    }
  }, children), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('-scale-x-1 transform', {
      '-scale-y-1': hasBottomOrientation
    })
  }, svgProps)));
};

/***/ }),

/***/ "ZsTA":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__("0770")
var randomBytes = __webpack_require__("i+/A")

function blind (priv) {
  var r = getr(priv)
  var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed()
  return { blinder: blinder, unblinder: r.invm(priv.modulus) }
}

function getr (priv) {
  var len = priv.modulus.byteLength()
  var r
  do {
    r = new BN(randomBytes(len))
  } while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))
  return r
}

function crt (msg, priv) {
  var blinds = blind(priv)
  var len = priv.modulus.byteLength()
  var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus)
  var c1 = blinded.toRed(BN.mont(priv.prime1))
  var c2 = blinded.toRed(BN.mont(priv.prime2))
  var qinv = priv.coefficient
  var p = priv.prime1
  var q = priv.prime2
  var m1 = c1.redPow(priv.exponent1).fromRed()
  var m2 = c2.redPow(priv.exponent2).fromRed()
  var h = m1.isub(m2).imul(qinv).umod(p).imul(q)
  return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len)
}
crt.getr = getr

module.exports = crt

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("+ZX+").Buffer))

/***/ }),

/***/ "a1wc":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("+ZX+").Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


/***/ }),

/***/ "aGPO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Paginate_Paginate; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// CONCATENATED MODULE: ./src/hooks/use-paginate/usePaginate.js


var usePaginate_usePaginate = function usePaginate(_ref) {
  var _ref$iterationNumber = _ref.iterationNumber,
      iterationNumber = _ref$iterationNumber === void 0 ? 5 : _ref$iterationNumber,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$forceInitialShow = _ref.forceInitialShowingItemsNumber,
      forceInitialShowingItemsNumber = _ref$forceInitialShow === void 0 ? 0 : _ref$forceInitialShow;
  var totalOfItems = items.length;

  var _useReducer = Object(react["useReducer"])(function (state) {
    var newNumberOfItemsToShow = state + iterationNumber;
    return newNumberOfItemsToShow > totalOfItems ? totalOfItems : newNumberOfItemsToShow;
  }, iterationNumber),
      showThisNumberOfItems = _useReducer[0],
      setShowThisNumberOfItems = _useReducer[1];

  var forcedOrNotShowingItemNumber = forceInitialShowingItemsNumber || showThisNumberOfItems;
  var itemsToShow = items.slice(0, forcedOrNotShowingItemNumber);
  var itemsShowing = forcedOrNotShowingItemNumber < totalOfItems ? forcedOrNotShowingItemNumber : totalOfItems;
  return {
    paginatedItems: itemsToShow,
    totalOfItems: totalOfItems,
    itemsShowing: itemsShowing,
    seeMoreAction: setShowThisNumberOfItems,
    shouldShowSeeMore: totalOfItems > itemsToShow.length
  };
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx + 1 modules
var ProgressBar = __webpack_require__("woxT");

// CONCATENATED MODULE: ./src/client/components/widgets/paginate/Paginate.jsx
var __jsx = react_default.a.createElement;





var Paginate_Paginate = function Paginate(_ref) {
  var children = _ref.children,
      forceInitialShowingItemsNumber = _ref.forceInitialShowingItemsNumber,
      iterationNumber = _ref.iterationNumber,
      onClick = _ref.onClick,
      seeMoreLabel = _ref.seeMoreLabel,
      setForceInitialShowingItemsNumber = _ref.setForceInitialShowingItemsNumber;

  var _usePaginate = usePaginate_usePaginate({
    forceInitialShowingItemsNumber: forceInitialShowingItemsNumber,
    items: children,
    iterationNumber: iterationNumber
  }),
      paginatedItems = _usePaginate.paginatedItems,
      itemsShowing = _usePaginate.itemsShowing,
      totalOfItems = _usePaginate.totalOfItems,
      seeMoreAction = _usePaginate.seeMoreAction,
      shouldShowSeeMore = _usePaginate.shouldShowSeeMore;

  var onClickHandler = function onClickHandler() {
    seeMoreAction();
    onClick === null || onClick === void 0 ? void 0 : onClick();
    setForceInitialShowingItemsNumber === null || setForceInitialShowingItemsNumber === void 0 ? void 0 : setForceInitialShowingItemsNumber(forceInitialShowingItemsNumber + iterationNumber);
  };

  return __jsx(react["Fragment"], null, paginatedItems, shouldShowSeeMore && __jsx("div", {
    className: "mt-20 text-center",
    "data-testid": "paginated-seeMoreBlock"
  }, __jsx("p", {
    className: "mb-10 text-14 text-black"
  }, Object(i18n["h" /* t */])('booking.accommodation.moreRooms.numberOfProposalsSeen', {
    number: itemsShowing,
    totalProposalsNumber: totalOfItems
  })), __jsx(ProgressBar["a" /* ProgressBar */], {
    className: "mx-auto mb-20 w-180 bg-lightSand",
    min: 0,
    max: 100,
    value: itemsShowing / totalOfItems * 100
  }), __jsx(Button["a" /* Button */], {
    onClick: onClickHandler,
    size: "medium"
  }, seeMoreLabel)));
};

/***/ }),

/***/ "aLd+":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("qW1w")
var Hash = __webpack_require__("4rhd")
var Buffer = __webpack_require__("KLyV").Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),

/***/ "aMaj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCallbackURIFromProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCallbackUrlSeller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isHostedFieldsPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isIframePayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getIframeCallbackUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCancelCallbackURI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return shouldApprovePayment; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("3voH");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _routes_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("dNxv");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("L7OA");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("hi3+");










var DEFAULT_CALLBACK_PATH = '/pr';
var DEFAULT_CANCEL_CALLBACK_PATH = "".concat(DEFAULT_CALLBACK_PATH, "/cancel");
var POLLING_CALLBACK_PATH = '/payment-notification';
var POLLING_PROVIDERS = [_constants__WEBPACK_IMPORTED_MODULE_9__[/* PAYMENT_ID_WECHAT */ "j"]];
var SHORTENED_LOCALE_QUERY_PARAM = 'l';
var SHORTENED_PROPOSAL_ID_QUERY_PARAM = 'spi';
var VOXPAY_PROVIDER_PREFIX = 'EVOXPAY';

function getCallbackURIFromProvider(providerId, proposalId, appContext, location) {
  var callbackPath = POLLING_PROVIDERS.indexOf(providerId) !== -1 ? POLLING_CALLBACK_PATH : DEFAULT_CALLBACK_PATH;
  var callbackUri = location.clone().path(callbackPath).query('').setQuery(urijs__WEBPACK_IMPORTED_MODULE_4___default.a.parseQuery(location.query()).hasOwnProperty(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["appQueryParameters"].legacy.be) ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["appQueryParameters"].legacy.be : null).setQuery(SHORTENED_LOCALE_QUERY_PARAM, appContext.locale).setQuery('isCmta', appContext.isCmta ? 'true' : 'false');

  if (providerId.startsWith(VOXPAY_PROVIDER_PREFIX)) {
    callbackUri.setQuery(SHORTENED_PROPOSAL_ID_QUERY_PARAM, proposalId);
  }

  return callbackUri.toString();
}

function getCancelCallbackURI(appContext, uri) {
  return uri.path(DEFAULT_CANCEL_CALLBACK_PATH).query('').setQuery(SHORTENED_LOCALE_QUERY_PARAM, appContext.locale).toString();
}

function shouldApprovePayment(providerId) {
  return !!_config__WEBPACK_IMPORTED_MODULE_6___default.a.get("psp.".concat(providerId.toLowerCase(), ".approve"));
}

function isHostedFieldsPayment(providerId) {
  return !!_config__WEBPACK_IMPORTED_MODULE_6___default.a.get("psp.".concat(providerId.toLowerCase(), ".hosted_fields"));
}

function isIframePayment(providerId, appContext) {
  return Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_8__[/* isFeatureFlipped */ "a"])(appContext)("psp.iframe.".concat(providerId.toLowerCase()));
}

function getIframeCallbackUrl(location) {
  return location.clone().path(_routes_constants__WEBPACK_IMPORTED_MODULE_7__[/* IFRAME_CALLBACK_URL */ "g"]).query('').toString();
}

function getCallbackUrlSeller(location) {
  return location.clone().path(_routes_constants__WEBPACK_IMPORTED_MODULE_7__[/* VOXPAY_CALLBACK_URL */ "B"]).query('').toString();
}



/***/ }),

/***/ "aMao":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const asn1 = exports;

asn1.bignum = __webpack_require__("nXZ9");

asn1.define = __webpack_require__("IP+5").define;
asn1.base = __webpack_require__("fzR1");
asn1.constants = __webpack_require__("Vgbh");
asn1.decoders = __webpack_require__("qqtw");
asn1.encoders = __webpack_require__("Quze");


/***/ }),

/***/ "aMgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCodeFromStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStatusFromCode; });
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1__);


var values = {
  OPTION: 'o',
  VALIDATED: 'v',
  PACKAGE_UPGRADE: 'p',
  ADDITIONAL_SERVICE: 'a',
  PICK_YOUR_ROOM: 'y',
  UPGRADE_ROOM: 'r',
  UNKNOWN: 'u',
  CART: 'c',
  SERVICES_IN_OPTION: 's'
};
var reverseValues = Object.keys(values).reduce(function (acc, key) {
  acc[values[key]] = key;
  return acc;
}, {});
function getCodeFromStatus(status) {
  return values[status] || values.UNKNOWN;
}
function getStatusFromCode(code) {
  return reverseValues[code] || null;
}

/***/ }),

/***/ "aeZB":
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__("4Z+A")
var Buffer = __webpack_require__("KLyV").Buffer
var Transform = __webpack_require__("7IvJ")
var inherits = __webpack_require__("qW1w")
var GHASH = __webpack_require__("0I1U")
var xor = __webpack_require__("sPPR")
var incr32 = __webpack_require__("sXLC")

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),

/***/ "aikL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* eslint-disable node/no-deprecated-api */



var buffer = __webpack_require__("+ZX+")
var Buffer = buffer.Buffer

var safer = {}

var key

for (key in buffer) {
  if (!buffer.hasOwnProperty(key)) continue
  if (key === 'SlowBuffer' || key === 'Buffer') continue
  safer[key] = buffer[key]
}

var Safer = safer.Buffer = {}
for (key in Buffer) {
  if (!Buffer.hasOwnProperty(key)) continue
  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
  Safer[key] = Buffer[key]
}

safer.Buffer.prototype = Buffer.prototype

if (!Safer.from || Safer.from === Uint8Array.from) {
  Safer.from = function (value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
    }
    if (value && typeof value.length === 'undefined') {
      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
    }
    return Buffer(value, encodingOrOffset, length)
  }
}

if (!Safer.alloc) {
  Safer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
    }
    if (size < 0 || size >= 2 * (1 << 30)) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
    var buf = Buffer(size)
    if (!fill || fill.length === 0) {
      buf.fill(0)
    } else if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
    return buf
  }
}

if (!safer.kStringMaxLength) {
  try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
  } catch (e) {
    // we can't determine kStringMaxLength in environments where process.binding
    // is unsupported, so let's not set it
  }
}

if (!safer.constants) {
  safer.constants = {
    MAX_LENGTH: safer.kMaxLength
  }
  if (safer.kStringMaxLength) {
    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
  }
}

module.exports = safer

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "auLa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("ZK3j");
var common = __webpack_require__("roL5");
var shaCommon = __webpack_require__("xy6B");
var assert = __webpack_require__("Y4pH");

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ "aw2z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__("qW1w");

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  const state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  const state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  const state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  const state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  const state = this._reporterState;

  const prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  const state = this._reporterState;

  const now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  let err;
  const state = this._reporterState;

  const inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  const state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
}
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),

/***/ "b0q8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.resolve = resolve;
exports.reject = reject;
exports.unresolve = unresolve;
exports.unreject = unreject;
exports.isResolvedAction = isResolvedAction;
exports.isRejectedAction = isRejectedAction;
exports.isThenAction = isThenAction;
exports.default = optimistPromiseMiddleware;

var _fluxStandardAction = __webpack_require__("8soX");

function isPromise(val) {
  return val && typeof val.then === 'function';
}

var RESOLVED_NAME = '_RESOLVED',
    REJECTED_NAME = '_REJECTED';

var BEGIN = 'BEGIN';
var COMMIT = 'COMMIT';
var REVERT = 'REVERT';

function resolve(actionName) {
  return actionName + RESOLVED_NAME;
}

function reject(actionName) {
  return actionName + REJECTED_NAME;
}

function unresolve(resolvedActionName) {
  return resolvedActionName.split(RESOLVED_NAME)[0];
}

function unreject(rejectedActionName) {
  return rejectedActionName.split(REJECTED_NAME)[0];
}

function isResolvedAction(resolvedActionName) {
  return unresolve(resolvedActionName) !== resolvedActionName;
}

function isRejectedAction(rejectedActionName) {
  return unreject(rejectedActionName) !== rejectedActionName;
}

function isThenAction(thenActionName) {
  return isResolvedAction(thenActionName) || isRejectedAction(thenActionName);
}

function optimistPromiseMiddleware() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$throwOnReject = _ref.throwOnReject,
      throwOnReject = _ref$throwOnReject === undefined ? true : _ref$throwOnReject,
      _ref$resolvedName = _ref.resolvedName,
      resolvedName = _ref$resolvedName === undefined ? RESOLVED_NAME : _ref$resolvedName,
      _ref$rejectedName = _ref.rejectedName,
      rejectedName = _ref$rejectedName === undefined ? REJECTED_NAME : _ref$rejectedName;

  RESOLVED_NAME = resolvedName;
  REJECTED_NAME = rejectedName;

  var nextTransactionID = 0;
  return function (_ref2) {
    var dispatch = _ref2.dispatch;
    return function (next) {
      return function (action) {
        if (!(0, _fluxStandardAction.isFSA)(action) || !action.meta || !isPromise(action.meta.promise)) {
          return next(action);
        }

        var isOptimist = action.meta.optimist;

        var transactionID = void 0;

        if (isOptimist) {
          transactionID = nextTransactionID++;
        }

        // (1) Dispatch actionName with meta with arguments apart from promise

        // Clone original action
        var newAction = _extends({}, action, {
          meta: _extends({}, action.meta)
        });

        if (isOptimist) {
          // Adding optimistic meta
          newAction.optimist = { type: BEGIN, id: transactionID };
          delete newAction.meta.optimist;
        }

        if (Object.keys(newAction.meta).length === 1) {
          delete newAction.meta;
        } else {
          // Other arguments, delete promise and optimist only
          delete newAction.meta.promise;
        }

        var skipOptimist = action.meta.skipOptimist;

        if (!skipOptimist) {
          next(newAction);
        }

        // Create a base for the next action containing the metadata.
        var nextActionBase = {
          meta: _extends({}, newAction.meta, {
            payload: newAction.payload
          })
        };

        if (!nextActionBase.meta.payload) {
          // No payload, no need to include them in the meta.
          delete nextActionBase.meta.payload;
        }
        if (Object.keys(nextActionBase.meta).length === 0) {
          // No meta was included either, remove all meta.
          delete nextActionBase.meta;
        }

        // (2) Listen to promise and dispatch payload with new actionName
        return action.meta.promise.then(function (result) {
          var actionToDispatch = _extends({
            type: resolve(action.type),
            payload: result
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: COMMIT, id: transactionID };
          }
          dispatch(actionToDispatch);
          return result;
        }).catch(function (error) {
          var actionToDispatch = _extends({
            type: reject(action.type),
            payload: error
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: REVERT, id: transactionID };
          }
          dispatch(actionToDispatch);
          if (throwOnReject) {
            throw error;
          }
        });
      };
    };
  };
}

/***/ }),

/***/ "b45f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GreatMembersLoyaltyPoints; });
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ub5k");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("L7OA");
var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;






var GreatMembersLoyaltyPoints = function GreatMembersLoyaltyPoints(_ref) {
  var loyaltyPoints = _ref.loyaltyPoints,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'greatMembersLoyaltyPoints' : _ref$dataTestId;
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__[/* useAppContext */ "c"])();
  var isActive = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_5__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayGreatMembers');

  if (!isActive || !loyaltyPoints) {
    return null;
  }

  return __jsx("div", {
    className: "flex w-full flex-col rounded-12 bg-pearl p-20 md:flex-row md:p-30",
    "data-testid": dataTestId
  }, __jsx("div", {
    className: "order-3 md:order-3 p-4 flex w-full flex-1 justify-center md:w-auto md:flex-none"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_0__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].CLUBMED_GREAT_MEMBER_NEW,
    height: "6.25rem",
    width: "6.25rem",
    isNotMonoChrome: true
  })), __jsx("div", {
    className: "p-4 order-2 flex flex-1 flex-col items-center justify-center md:order-1 md:flex-2 md:items-baseline md:self-start md:px-30"
  }, __jsx("span", {
    className: "text-14 font-bold text-black md:text-16"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('booking.priceDetails.greatMembers.title')), __jsx("div", {
    className: "flex flex-col justify-center p-10"
  }, __jsx("ul", {
    className: "list-none"
  }, __jsx("li", {
    className: "list-disc"
  }, __jsx("span", {
    className: "text-14 text-black md:text-16"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('booking.priceDetails.greatMembers.label1'))), __jsx("li", {
    className: "list-disc"
  }, __jsx("span", {
    className: "text-14 text-black md:text-16"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('booking.priceDetails.greatMembers.label2')))))), __jsx("div", {
    className: "p-4 order-1 w-fit justify-center self-center md:order-2 md:self-start md:py-0"
  }, __jsx("div", {
    className: "flex w-fit rounded-pill bg-ultramarine px-10"
  }, __jsx("span", {
    className: "p-5 text-14 font-bold text-white md:text-16"
  }, "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('booking.priceDetails.greatMembers.loyaltyPoints', {
    points: loyaltyPoints
  }))))));
};

/***/ }),

/***/ "bOHI":
/***/ (function(module, exports) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ "bQLV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("P2aG")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("6kWf");
/*</replacement>*/

var Buffer = __webpack_require__("+ZX+").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__("tizd");
var _require = __webpack_require__("nnjZ"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__("VYiD").codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__("qW1w")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("ekAB");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__("ekAB");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq"), __webpack_require__("F63i")))

/***/ }),

/***/ "bn3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlternativePackageToolTip; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var AlternativePackageToolTip = function AlternativePackageToolTip(_ref) {
  var bundle = _ref.bundle;
  return __jsx("div", {
    className: "flex-1"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_3__[/* Image */ "a"], {
    imageUrl: bundle.image,
    ratioKey: "L"
  }), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], {
    className: "p-10",
    text: bundle.description
  }));
};

/***/ }),

/***/ "bsME":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("EmIl");
var BN = __webpack_require__("nXZ9");
var inherits = __webpack_require__("qW1w");
var Base = __webpack_require__("QoQd");

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  var e;
  var h;
  var j;
  if (this.curve.twisted) {
    // E = a * C
    e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      h = this.z.redSqr();
      // J = F - 2 * H
      j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    e = c.redAdd(d);
    // H = (c * Z1)^2
    h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),

/***/ "cGFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidationStateFromKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationStateFromKids; });
/* unused harmony export updateValidationStateForKid */
/* unused harmony export addOrRemoveKidFromValidationState */
/* unused harmony export addOrRemoveKidFromKidsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasKidWithoutAValidBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOnlyValidKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invalidateNotValidatedKids; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("i4UL");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("fGyu");
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wQ38");
/* harmony import */ var _facetingUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kNiU");
/* harmony import */ var _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("45yR");











var getValidationStateFromKid = function getValidationStateFromKid(kid, isKidBirthdateRequired) {
  if (typeof kid !== 'object') {
    return _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"];
  }

  if (!kid.birthdate) {
    return isKidBirthdateRequired ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* NOT_VALIDATED */ "c"];
  }

  return typeof kid === 'object' && Object(_facetingUtils__WEBPACK_IMPORTED_MODULE_9__[/* isKidMinor */ "n"])(kid.birthdate) ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_VALID */ "b"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"];
};
var getValidationStateFromKids = function getValidationStateFromKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return kids.map(function (kid) {
    return getValidationStateFromKid(kid);
  });
};
var updateValidationStateForKid = function updateValidationStateForKid(_ref) {
  var index = _ref.index,
      kid = _ref.kid,
      _ref$kidsValidationSt = _ref.kidsValidationState,
      kidsValidationState = _ref$kidsValidationSt === void 0 ? [] : _ref$kidsValidationSt;
  var validationState = getValidationStateFromKid(kid);
  return kidsValidationState.map(function (kidValidation, indexKid) {
    var isNewKid = kidValidation === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* NOT_VALIDATED */ "c"];
    var kidNeedsValidation = !!kid.birthdate || !isNewKid;
    return indexKid === index && kidNeedsValidation ? validationState : kidValidation;
  });
};
var addOrRemoveKidFromValidationState = function addOrRemoveKidFromValidationState(_ref2) {
  var _ref2$currentState = _ref2.currentState,
      currentState = _ref2$currentState === void 0 ? [] : _ref2$currentState,
      kidsNumber = _ref2.kidsNumber;

  if (kidsNumber > currentState.length) {
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(currentState), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Array(kidsNumber - currentState.length).fill(_client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_8__[/* VALIDATION_STATE_ENUM */ "f"].notvalidated)));
  }

  if (kidsNumber < currentState.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(currentState.slice(0, kidsNumber));
  }

  return currentState;
};
var addOrRemoveKidFromKidsList = function addOrRemoveKidFromKidsList(args) {
  var _args$kids = args.kids,
      kids = _args$kids === void 0 ? [] : _args$kids,
      kidsNumber = args.kidsNumber;

  if (kidsNumber > kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(kids).concat(Array(kidsNumber - kids.length).fill().map(function () {
      return _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_8__[/* DEFAULT_KID_VALUE */ "a"];
    }));
  }

  if (kidsNumber < kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(kids.slice(0, kidsNumber));
  }

  return kids;
};
var hasKidWithoutAValidBirthdate = function hasKidWithoutAValidBirthdate(kidsValidationState) {
  return Boolean(kidsValidationState && kidsValidationState.find(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"];
  }));
};
var hasOnlyValidKids = function hasOnlyValidKids(kidsValidationState) {
  return kidsValidationState.every(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_VALID */ "b"];
  });
};
var invalidateNotValidatedKids = function invalidateNotValidatedKids(kidsValidationState) {
  return kidsValidationState.reduce(function (acc, current) {
    if (current === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* NOT_VALIDATED */ "c"]) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(acc), [_client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"]]);
    }

    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(acc), [current]);
  }, []);
};

/***/ }),

/***/ "cHVg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("Y4pH");

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),

/***/ "cJUb":
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__("9FfZ")
var aesid = __webpack_require__("ct7g")
var fixProc = __webpack_require__("wO2t")
var ciphers = __webpack_require__("jRCX")
var compat = __webpack_require__("iRos")
var Buffer = __webpack_require__("KLyV").Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),

/***/ "cN29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");




var themes = function themes(_ref) {
  var color = _ref.color;
  var rColor = _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS_LIST */ "b"].includes(color) ? color : _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].TURQUOISE;
  var thDescriptionBloc = "bg-".concat(rColor, " px-5 flex flex-col grow sm:grow-0 justify-center pe-10 rounded-4 text-").concat(_utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor], " w-auto");
  var thPopinContent = "border-1 border-".concat(rColor, " lg:border-0 flex flex-col");
  return {
    "default": {
      thDescriptionBloc: thDescriptionBloc,
      thPopinContent: "".concat(thPopinContent, " lg:flex-row"),
      thPopinContentImage: 'shrink-0 px-20 pt-20 lg:ps-20 lg:pe-0 lg:py-15',
      thPopinColor: rColor,
      thPopinTextColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor]
    },
    comparator: {
      thDescriptionBloc: "".concat(thDescriptionBloc, " sm:w-full"),
      thPopinContent: thPopinContent,
      thPopinContentImage: 'shrink-0 lg:ps-10 lg:py-10 mt-15',
      thPopinColor: rColor,
      thPopinTextColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor]
    }
  };
};

/***/ }),

/***/ "cQOy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__("5cvY");
exports.Cipher = __webpack_require__("cHVg");
exports.DES = __webpack_require__("954z");
exports.CBC = __webpack_require__("s/+e");
exports.EDE = __webpack_require__("fDw9");


/***/ }),

/***/ "cTV+":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("KLyV").Buffer
var createHash = __webpack_require__("Deve")
var stream = __webpack_require__("sSce")
var inherits = __webpack_require__("qW1w")
var sign = __webpack_require__("OwY5")
var verify = __webpack_require__("8HVW")

var algorithms = __webpack_require__("2+UM")
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = Buffer.from(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}


/***/ }),

/***/ "cVzJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__("qW1w");
const Reporter = __webpack_require__("aw2z").Reporter;
const Buffer = __webpack_require__("aikL").Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
  if (data instanceof DecoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    Buffer.isBuffer(data.base) &&
    data.constructor.name === 'DecoderBuffer' &&
    typeof data.offset === 'number' &&
    typeof data.length === 'number' &&
    typeof data.save === 'function' &&
    typeof data.restore === 'function' &&
    typeof data.isEmpty === 'function' &&
    typeof data.readUInt8 === 'function' &&
    typeof data.skip === 'function' &&
    typeof data.raw === 'function';

  return isCompatible;
};

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  const res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
};

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  const res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
};

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
};

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!EncoderBuffer.isEncoderBuffer(item))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
  if (data instanceof EncoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    data.constructor.name === 'EncoderBuffer' &&
    typeof data.length === 'number' &&
    typeof data.join === 'function';

  return isCompatible;
};

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = Buffer.alloc(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),

/***/ "cg3U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__("qW1w");

const DEREncoder = __webpack_require__("1sYr");

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  const buf = DEREncoder.prototype.encode.call(this, data);

  const p = buf.toString('base64');
  const out = [ '-----BEGIN ' + options.label + '-----' ];
  for (let i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),

/***/ "ct7g":
/***/ (function(module) {

module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

/***/ }),

/***/ "dAFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAreaExclusiveCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getResortDistrictQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);

var isAreaExclusiveCollection = function isAreaExclusiveCollection(area) {
  var _area$comfort, _area$comfort2;

  return ((_area$comfort = area.comfort) === null || _area$comfort === void 0 ? void 0 : _area$comfort.id) === 'area_comfort_level_5_tridents' || ((_area$comfort2 = area.comfort) === null || _area$comfort2 === void 0 ? void 0 : _area$comfort2.id) === 'area_comfort_level_villas_and_chalets';
};
var getResortDistrictQuery = function getResortDistrictQuery(resortId) {
  return "query {\n  pickYourRoom {\n    resortSettings(resortId : \"".concat(resortId, "\") {\n      initialViewport { ...viewPort }\n      targetViewport { ...viewPort }\n      maxBounds { minLon maxLon minLat maxLat minZoom maxZoom }\n    }\n  }\n  resortAreas(resortId: \"").concat(resortId, "\") {\n    areas {\n      associatedAccess {\n        id\n        label\n      }\n      description\n      id\n      images\n      label\n      comfort {\n        id\n      }\n      shortDescription\n    }\n    geoData(resortId: \"").concat(resortId, "\") {\n      areas {\n        id\n        label\n        pickable\n      }\n      areas_geo_json {\n        features {\n          geometry {\n            coordinates\n            type\n          }\n          properties {\n            area_id: id\n          }\n          type\n        }\n        type\n      }\n      areas_center_geo_json {\n        features {\n          geometry {\n            coordinates\n            type\n          }\n          properties {\n            area_id: id\n          }\n          type\n        }\n        type\n      }\n    }\n  }\n}\n    \nfragment viewPort on ViewportType {\n  latitude\n  longitude\n  zoom\n  bearing\n  pitch\n}");
};

/***/ }),

/***/ "dATv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BookingFooter_BookingFooter; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// CONCATENATED MODULE: ./src/client/components/utils/booking-footer/bookingFooter.utils.js











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var mapFooterIconsToContactsBarTypes = {
  callMeBack: 'phone',
  phoneBubble: 'phone',
  storeLocator: 'storeLocator',
  faq: 'askQuestions',
  termsAndConditions: 'warning',
  mobileApp: 'smartphone',
  mail: 'mail'
};
var bookingFooter_utils_getDetailClickEventTrackingData = function getDetailClickEventTrackingData(type, href) {
  var _href$hostname, _href$hostname$call;

  var eventClick = _objectSpread({}, constants["k" /* EVENT_CLICK */]);

  var isWhatsapp = href === null || href === void 0 ? void 0 : (_href$hostname = href.hostname) === null || _href$hostname === void 0 ? void 0 : (_href$hostname$call = _href$hostname.call(href)) === null || _href$hostname$call === void 0 ? void 0 : _href$hostname$call.includes('whatsapp');
  eventClick.callMeBack = isWhatsapp ? constants["d" /* CALLMEBACK_EVENT */].whatsapp : constants["d" /* CALLMEBACK_EVENT */].phone;
  return eventClick[type];
};
// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-footer/BookingFooterItem.jsx

var __jsx = react_default.a.createElement;







var BookingFooterItem_BookingFooterItem = function BookingFooterItem(_ref) {
  var href = _ref.href,
      text = _ref.text,
      type = _ref.type;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return __jsx("a", {
    className: "flex flex-col items-center text-center",
    "data-testid": "BookingFooterItem-".concat(type),
    target: "_blank",
    rel: "noopener noreferrer",
    href: href,
    onClick: function onClick() {
      var detailClick = bookingFooter_utils_getDetailClickEventTrackingData(type, href);
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_FOOTER, {
        detail_click: detailClick
      });
    }
  }, __jsx(Icon["a" /* Icon */], {
    name: (mapFooterIconsToContactsBarTypes === null || mapFooterIconsToContactsBarTypes === void 0 ? void 0 : mapFooterIconsToContactsBarTypes[type]) || icons["a" /* ICONS */].WARNING,
    width: "1.4375rem",
    className: "m-15",
    dataTestid: "BookingFooterItem-icon"
  }), text.map(function (txt, index) {
    return __jsx("p", {
      key: txt[index],
      className: Object(classnames_utils["a" /* classnames */])('text-14', {
        'font-bold': index === 0
      }, {
        'mb-10': index !== 0
      })
    }, txt);
  }));
};
// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-footer/BookingFooter.jsx













var BookingFooter_jsx = react_default.a.createElement;

function BookingFooter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingFooter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingFooter_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingFooter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var BookingFooter_BookingFooter = function BookingFooter(_ref) {
  var _footer$contactsBarBE;

  var footer = _ref.footer,
      className = _ref.className;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale; // we add number phone callCenter to link on click booking.callCenterPopIn.number


  var completedItemsFooter = (_footer$contactsBarBE = footer.contactsBarBE) === null || _footer$contactsBarBE === void 0 ? void 0 : _footer$contactsBarBE.map(function (item) {
    // phone number link
    if (item.href === '' && item.type === 'callMeBack') {
      return BookingFooter_objectSpread(BookingFooter_objectSpread({}, item), {}, {
        href: 'tel://' + Object(i18n["h" /* t */])('booking.callCenterPopIn.number').replace(/\s+/g, '')
      });
    } // store Locator link


    if (item.type === 'storeLocator') {
      return item;
    } // other links with locale


    return BookingFooter_objectSpread(BookingFooter_objectSpread({}, item), {}, {
      href: new URI_default.a(item.href).addQuery('locale', locale)
    });
  }); // for now the maximum active class in tailwind grid column is grid-cols-6
  // so if we have 0 or > 6 items we will use 6 columns which is the maximum
  // doesn't seem to work with media queries so ...

  var MAX_ITEMS_FOR_GRID_CSS = 6;
  var nbItems = completedItemsFooter === null || completedItemsFooter === void 0 ? void 0 : completedItemsFooter.length;
  var numberOfItemsMax6 = nbItems <= MAX_ITEMS_FOR_GRID_CSS ? nbItems : MAX_ITEMS_FOR_GRID_CSS;
  var gridClassDynamic = "md:grid-cols-".concat(numberOfItemsMax6);

  if (!completedItemsFooter) {
    return null;
  }

  return BookingFooter_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('w-ful flex items-center justify-center border-t-1', className)
  }, BookingFooter_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('grid grid-cols-2 items-start gap-20 p-20 md:w-1/2', gridClassDynamic)
  }, completedItemsFooter.map(function (footerItem, index) {
    var _completedItemsFooter;

    return BookingFooter_jsx(BookingFooterItem_BookingFooterItem, Object(esm_extends["a" /* default */])({
      key: "".concat((_completedItemsFooter = completedItemsFooter[index]) === null || _completedItemsFooter === void 0 ? void 0 : _completedItemsFooter.type, "-").concat(index * 2)
    }, footerItem));
  })));
};

/***/ }),

/***/ "dEMF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "dGyR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECT_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UNSELECT_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return travelCompanionReducer; });
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_widgets_contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ZHrn");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _proposals_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("UIAR");









var ADD_TRAVEL_COMPANION = 'ADD_TRAVEL_COMPANION';
var EDIT_TRAVEL_COMPANION = 'EDIT_TRAVEL_COMPANION';
var SELECT_TRAVEL_COMPANION = 'SELECT_TRAVEL_COMPANION';
var UNSELECT_TRAVEL_COMPANION = 'UNSELECT_TRAVEL_COMPANION';
var initialState = {
  list: [],
  selectedIndexes: []
};
var travelCompanionReducer = function travelCompanionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__["resolve"])(_proposals_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_PROPOSALS_BY_ID */ "n"]):
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__["resolve"])(_proposals_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_PROPOSALS */ "m"]):
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__["resolve"])(_proposals_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */ "o"]):
      {
        var attendees = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(action, 'payload.proposals.proposals.0.attendees', {});

        var _filterSearchedChildr = Object(_components_widgets_contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_6__[/* filterSearchedChildren */ "b"])(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(action, 'payload.profile.travelCompanions', []), attendees),
            travelCompanions = _filterSearchedChildr.travelCompanions,
            selectedIndexes = _filterSearchedChildr.selectedIndexes;

        return {
          list: travelCompanions || [],
          selectedIndexes: selectedIndexes || []
        };
      }

    case ADD_TRAVEL_COMPANION:
      state.list.push(action.payload);
      return state;

    case EDIT_TRAVEL_COMPANION:
      var editedCompanionIndex = state.list.findIndex(function (_ref) {
        var companionId = _ref.companionId;
        return companionId === action.payload.companionId;
      });
      state.list[editedCompanionIndex] = action.payload;
      return state;

    case SELECT_TRAVEL_COMPANION:
      var selectedCompanionIndex = state.list.findIndex(function (_ref2) {
        var companionId = _ref2.companionId;
        return companionId === action.payload.companionId;
      });
      state.list[selectedCompanionIndex].isSelected = true;
      var parentIndex = action.payload.parentIndex;

      if (!state.selectedIndexes.map(function (_ref3) {
        var index = _ref3.index;
        return index;
      }).includes(parentIndex)) {
        state.selectedIndexes.push({
          index: parentIndex,
          position: action.payload.position
        });
      }

      return state;

    case UNSELECT_TRAVEL_COMPANION:
      var unselectedCompanionIndex = state.list.findIndex(function (_ref4) {
        var companionId = _ref4.companionId;
        return companionId === action.payload.companionId;
      });
      var unselectedParentIndex = state.selectedIndexes.findIndex(function (_ref5) {
        var index = _ref5.index,
            position = _ref5.position;
        return position === action.payload.position && index === action.payload.parentIndex;
      });
      state.list[unselectedCompanionIndex].isSelected = false;

      if (unselectedParentIndex !== -1) {
        state.selectedIndexes.splice(unselectedParentIndex, 1);
      }

      return state;

    default:
      return state;
  }
};

/***/ }),

/***/ "dLd+":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var parseInt = __webpack_require__("QkOM");

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});


/***/ }),

/***/ "ddHj":
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),

/***/ "eWVS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("wYax");


/***/ }),

/***/ "eYK6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("lozs");


/***/ }),

/***/ "ekAB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__("L7Jg");
var Writable = __webpack_require__("bQLV");
__webpack_require__("qW1w")(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "fDw9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("Y4pH");
var inherits = __webpack_require__("qW1w");

var Cipher = __webpack_require__("cHVg");
var DES = __webpack_require__("954z");

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),

/***/ "fXPz":
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),

/***/ "fXWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACK_BE_EVENT_GA_ACTIVITIES; });
/* unused harmony export TRACK_BE_EVENT_GA_CHILDCARE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRACK_CLICK_EVENT_BE_RENTALS; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var _events_trackings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Gh9m");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("taV1");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var TRACK_BE_EVENT_GA_ACTIVITIES = _objectSpread(_objectSpread({}, _views_booking_constants__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
  actionGA: 'activities'
});
var TRACK_BE_EVENT_GA_CHILDCARE = _objectSpread(_objectSpread({}, _views_booking_constants__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
  actionGA: 'childcare'
});
var TRACK_CLICK_EVENT_BE_RENTALS = _objectSpread(_objectSpread({}, _views_booking_constants__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), _events_trackings__WEBPACK_IMPORTED_MODULE_8__[/* TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL */ "a"]);

/***/ }),

/***/ "fzR1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const base = exports;

base.Reporter = __webpack_require__("aw2z").Reporter;
base.DecoderBuffer = __webpack_require__("cVzJ").DecoderBuffer;
base.EncoderBuffer = __webpack_require__("cVzJ").EncoderBuffer;
base.Node = __webpack_require__("4v7C");


/***/ }),

/***/ "gEL7":
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__("6yhU"),
  CBC: __webpack_require__("DehW"),
  CFB: __webpack_require__("NiGL"),
  CFB8: __webpack_require__("nmQK"),
  CFB1: __webpack_require__("1/tN"),
  OFB: __webpack_require__("lLE/"),
  CTR: __webpack_require__("1TSG"),
  GCM: __webpack_require__("1TSG")
}

var modes = __webpack_require__("Kk8D")

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),

/***/ "gX9k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackPaymentPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTrackPaymentFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapTransportResume; });
/* unused harmony export getPaymentData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getApproveRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPaymentErrorMessagePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return persistPaymentMethodInCookies; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("3voH");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CzFL");
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_snakeCase__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("6R5o");
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("9NGo");
/* harmony import */ var _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("BU6i");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("K0Lv");
/* harmony import */ var _utils_payment_constants__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("hi3+");
/* harmony import */ var _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("tI+f");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("igjW");


















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}











var APPROVE_ROUTE = '/approve-payment';
var ERROR_CODE_LABEL = {
  BOOKING_ALREADY_EXISTS: 'booking.banking.aBookingAlreadyExists2',
  BOOKING_UNAVAILABLE: 'booking.banking.confirmation.itemOfTheBookingNotAvailable',
  INVALID_EMAIL: 'booking.partners.linkPayment.email.invalidEmail',
  INVALID_PHONE_NUMBER: 'booking.partners.linkPayment.sms.invalidNumber',
  PAYMENT_ALREADY_SCHEDULED: 'booking.partners.errorMessages.automaticPaymentScheduled',
  PAYMENT_ALREADY_DONE: 'booking.banking.paymentAlreadyDone',
  PAYMENT_ALREADY_IN_PROGRESS: 'booking.banking.paymentAlreadyInProgress',
  FLIGHT_AVAILABILITY_EXPIRED: 'booking.banking.timeLimitExceeded'
};

function getPaymentData() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  return lodash_find__WEBPACK_IMPORTED_MODULE_16___default()(items, {
    id: id
  }) || items[0];
}

function getPaymentErrorMessagePath(_ref) {
  var errorCode = _ref.errorCode,
      track = _ref.track,
      _ref$isCmta = _ref.isCmta,
      isCmta = _ref$isCmta === void 0 ? false : _ref$isCmta;

  var trackingData = _objectSpread(_objectSpread({}, _tracking_constants__WEBPACK_IMPORTED_MODULE_22__[/* GA_DEFAULT_PAYLOAD */ "m"]), {}, {
    actionGA: 'banking'
  });

  var errorCodeLabel = ERROR_CODE_LABEL[errorCode] || (isCmta ? 'booking.partners.banking.paymentErrorMessage' : 'booking.banking.paymentErrorMessage');
  track === null || track === void 0 ? void 0 : track(_objectSpread(_objectSpread({}, trackingData), errorCode && {
    labelGA: "error_".concat(errorCode)
  }));
  return errorCodeLabel;
}

function getApproveRoute(_ref2) {
  var appContext = _ref2.appContext,
      router = _ref2.router,
      eventParams = _ref2.eventParams;
  return new urijs__WEBPACK_IMPORTED_MODULE_19___default.a(router.asPath).path(APPROVE_ROUTE).query(eventParams).setQuery(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__["appQueryParameters"].locale, appContext === null || appContext === void 0 ? void 0 : appContext.locale).toString();
}

var TRACKING_FULL_PAYMENT = 'full_payment';
var TRACKING_DOWN_PAYMENT = 'down_payment';
var TRACKING_FRACTION_PAYMENT = 'fraction_payment';

function getPaymentMethodLabel(paymentProviderId, paymentMethodLabel) {
  if (paymentProviderId === null || paymentProviderId === void 0 ? void 0 : paymentProviderId.startsWith(_PaymentInfo_const__WEBPACK_IMPORTED_MODULE_21__[/* VOXPAY_PSP_ID_PREFIX */ "q"])) {
    // on the api side, voxpay is one psp with 2 parameters (email, phone number) with 0 payment method
    // on the front side, voxpay is displayed as two different psp (one for email, one for phone number) with 0 payment method
    // on the tracking side, voxpay is tracked like one psp with 2 payment method (email and sms)
    return js_cookie__WEBPACK_IMPORTED_MODULE_17___default.a.get(_PaymentInfo_const__WEBPACK_IMPORTED_MODULE_21__[/* PAYMENT_METHOD_LABEL */ "m"]);
  }

  return paymentMethodLabel || js_cookie__WEBPACK_IMPORTED_MODULE_17___default.a.get(_PaymentInfo_const__WEBPACK_IMPORTED_MODULE_21__[/* PAYMENT_METHOD_LABEL */ "m"]) || _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_21__[/* CREDIT_CARD_LABEL */ "a"];
}

var trackPaymentPlan = function trackPaymentPlan(_ref3) {
  var paymentMethodCategory = _ref3.paymentMethodCategory,
      isFullPayment = _ref3.isFullPayment;
  var isBNPLPayment = paymentMethodCategory === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_21__[/* PAYMENT_METHOD_CATEGORY */ "l"].BUY_NOW_PAY_LATER;
  var fullPaymentPlan = isBNPLPayment ? TRACKING_FRACTION_PAYMENT : TRACKING_FULL_PAYMENT;
  return isFullPayment ? fullPaymentPlan : TRACKING_DOWN_PAYMENT;
};
var getTrackPaymentFunc = function getTrackPaymentFunc(_ref4) {
  var proposal = _ref4.proposal,
      track = _ref4.track,
      donationAmount = _ref4.donationAmount;
  return function (_ref5) {
    var orderId = _ref5.orderId,
        isErrored = _ref5.isErrored,
        bookingId = _ref5.bookingId,
        amountToPay = _ref5.amountToPay,
        paymentMethodLabel = _ref5.paymentMethodLabel,
        paymentProviderId = _ref5.paymentProviderId;
    var fullPayment = amountToPay === proposal.price.total.value;
    var paymentPlan = trackPaymentPlan({
      isFullPayment: fullPayment,
      paymentMethodCategory: paymentMethodLabel
    });
    var paymentMethod = getPaymentMethodLabel(paymentProviderId, paymentMethodLabel);
    track({
      orderID_PSP: orderId,
      labelGA: 'clickValidateBanking',
      paymentMethod: paymentMethod
    });
    track({
      labelGA: isErrored ? 'errorValidateBanking' : 'validateBanking',
      providerId: paymentProviderId,
      paymentPlan: paymentPlan
    });

    if (!isErrored) {
      var beTracking = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_22__[/* BE_TRACKING */ "c"]);
      var paymentType = paymentProviderId === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_21__[/* PAYPAL_PSP_ID */ "n"] ? 'PAYPAL' : paymentProviderId;
      var paymentTracking = {
        event: 'payment',
        basePriceConfirmation: proposal.price.total.value,
        paymentPlan: paymentPlan,
        paymentDeposit: fullPayment ? null : amountToPay,
        paymentType: paymentType,
        transactionID: bookingId,
        orderID_PSP: orderId,
        paymentMethod: paymentMethod
      };

      var paymentTrackingProps = _objectSpread(_objectSpread({}, beTracking), paymentTracking);

      _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* set */ "c"](paymentTrackingProps);
      /**
       * Store donation amount in session storage to show thanks message on booking confirmation page
       * It's not possible to use price_details api route : get /v1/customers/{customer_id}/bookings/{booking_id}/price_details
       * because it needs an authentication token, that we do not have for unauthenticated users
       */

      if (donationAmount) {
        Object(_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_20__[/* setInSessionStorage */ "d"])(_utils_payment_constants__WEBPACK_IMPORTED_MODULE_24__[/* DONATION_STORAGE_KEY */ "f"], donationAmount);
      } // store, when the proposal is joyview, the upSell price of package, for confirmation tracking purpose


      if (proposal.alternativePackages && proposal.alternativePackages.length > 0) {
        var basePackage = proposal.alternativePackages.find(function (_ref6) {
          var packageId = _ref6.packageId;
          return packageId === _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_25__[/* PACKAGE_ROOM_ONLY */ "h"];
        }) || // $FlowFixMe 🤬
        proposal.alternativePackages.find(function (_ref7) {
          var packageId = _ref7.packageId;
          return packageId === _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_25__[/* PACKAGE_FOOD_AND_BEVERAGE */ "g"];
        });

        if (basePackage) {
          Object(_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_20__[/* setInSessionStorage */ "d"])(_utils_payment_constants__WEBPACK_IMPORTED_MODULE_24__[/* JOYVIEW_UPSELL_STORAGE_KEY */ "h"], basePackage.upsellPrice.replace(/\D*/, ''));
        }
      }
    }
  };
};

var mapTransportResume = function mapTransportResume(transports) {
  return transports ? // $FlowFixMe
  [transports.inbound, transports.outbound].map(function (_ref8) {
    var travelSections = _ref8.travelSections;
    return travelSections.map(function (_ref9) {
      var transport = _ref9.transport,
          departure = _ref9.departure,
          arrival = _ref9.arrival;
      return {
        company: {
          name: transport.companyOperator.label,
          id: transport.companyOperator.id
        },
        origin: departure.cityId,
        destination: arrival.cityId,
        departure: {
          apc: departure.id,
          date: departure.date
        },
        arrival: {
          apc: arrival.id,
          date: arrival.date
        }
      };
    });
  }) : [];
};

var persistPaymentMethodInCookies = function persistPaymentMethodInCookies(_ref10) {
  var paymentProduct = _ref10.paymentProduct,
      paymentProvider = _ref10.paymentProvider,
      paymentMethodId = _ref10.paymentMethodId;
  var paymentMethodLabel = (paymentProvider === null || paymentProvider === void 0 ? void 0 : paymentProvider.categoryPaymentMethod) || 'unknown';

  if (paymentMethodLabel === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_21__[/* PAYMENT_METHOD_CATEGORY */ "l"].CREDIT_CARD) {
    var _paymentProvider$paym;

    paymentMethodLabel = paymentProduct || (paymentProvider === null || paymentProvider === void 0 ? void 0 : (_paymentProvider$paym = paymentProvider.paymentMethods.find(function (_ref11) {
      var id = _ref11.id;
      return id === paymentMethodId;
    })) === null || _paymentProvider$paym === void 0 ? void 0 : _paymentProvider$paym.label) || paymentMethodLabel;
  }

  js_cookie__WEBPACK_IMPORTED_MODULE_17___default.a.set(_PaymentInfo_const__WEBPACK_IMPORTED_MODULE_21__[/* PAYMENT_METHOD_LABEL */ "m"], lodash_snakeCase__WEBPACK_IMPORTED_MODULE_15___default()(paymentMethodLabel), {
    secure: !Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_26__[/* isStrictlyDevelopmentEnv */ "d"])()
  });
};



/***/ }),

/***/ "gbEP":
/***/ (function(module) {

module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

/***/ }),

/***/ "gdlE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),

/***/ "guqX":
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__("KucK")
exports.sha1 = __webpack_require__("9TIw")
exports.sha224 = __webpack_require__("Wtu2")
exports.sha256 = __webpack_require__("KLYN")
exports.sha384 = __webpack_require__("k/xG")
exports.sha512 = __webpack_require__("aLd+")


/***/ }),

/***/ "hXSc":
/***/ (function(module, exports) {

var JsonWebTokenError = function (message, error) {
  Error.call(this, message);
  Error.captureStackTrace(this, this.constructor);
  this.name = 'JsonWebTokenError';
  this.message = message;
  if (error) this.inner = error;
};

JsonWebTokenError.prototype = Object.create(Error.prototype);
JsonWebTokenError.prototype.constructor = JsonWebTokenError;

module.exports = JsonWebTokenError;

/***/ }),

/***/ "hfZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABTestContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ABTestContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "i+/A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__("KLyV").Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq"), __webpack_require__("F63i")))

/***/ }),

/***/ "i8+T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__("KLyV").Buffer
var Transform = __webpack_require__("Dzy0").Transform
var inherits = __webpack_require__("qW1w")

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),

/***/ "iRos":
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__("TxDk")
exports.pbkdf2Sync = __webpack_require__("U9DI")


/***/ }),

/***/ "ibuU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__("+ZX+"),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__(3),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ "idSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BookingLayout_BookingLayout; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js + 1 modules
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/utils/booking/booking-additional-services/BookingAddtionalServices.utils.js
var BookingAddtionalServices_utils = __webpack_require__("JOeK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/context/ActivitiesContext.js
var ActivitiesContext = __webpack_require__("76OQ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/hooks/use-previous/usePrevious.js
var usePrevious = __webpack_require__("AbLU");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/tracking/events/be.tracking.js
var be_tracking = __webpack_require__("fXWa");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-summary/AccommodationSummary.jsx
var AccommodationSummary = __webpack_require__("g5cf");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/BottomNavbarLayer.jsx + 2 modules
var BottomNavbarLayer = __webpack_require__("Dz6/");

// EXTERNAL MODULE: ./src/client/components/widgets/reserved-services-wrapper/ReservedServicesList.jsx + 3 modules
var ReservedServicesList = __webpack_require__("toM8");

// EXTERNAL MODULE: ./src/client/views/booking/summary/SummaryView.utils.js
var SummaryView_utils = __webpack_require__("X3Cs");

// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/PromoCode.jsx + 2 modules
var PromoCode = __webpack_require__("mCPI");

// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/DiscountsLine.jsx
var DiscountsLine = __webpack_require__("CYED");

// EXTERNAL MODULE: ./src/client/components/widgets/accordion-block/AccordionBlock.jsx
var AccordionBlock = __webpack_require__("sORq");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/PriceTicketFavorite.jsx
var PriceTicketFavorite = __webpack_require__("CvKO");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/BottomNavbarTotalPrice.jsx
var BottomNavbarTotalPrice = __webpack_require__("EceG");

// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/SelectedRate.jsx
var SelectedRate = __webpack_require__("sEDY");

// EXTERNAL MODULE: ./src/client/components/widgets/price-detail-block-lines/PriceDetailLines.jsx
var PriceDetailLines = __webpack_require__("y0X/");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.utils.jsx
var BuyNowPayLater_utils = __webpack_require__("AV+p");

// EXTERNAL MODULE: ./src/client/components/widgets/great-members-loyalty-points/GreatMembersLoyaltyPoints.jsx
var GreatMembersLoyaltyPoints = __webpack_require__("b45f");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.const.jsx + 16 modules
var BuyNowPayLater_const = __webpack_require__("U6Jk");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-bottom-navbar/OptionBlock.jsx
var __jsx = react_default.a.createElement;




var OptionBlock_OptionBlock = function OptionBlock() {
  return __jsx("div", {
    "data-testid": "OptionBlock",
    className: "mb-20 h-full rounded-12 border-1 border-lightGrey bg-white p-20"
  }, __jsx("div", {
    className: "flex items-start gap-20"
  }, __jsx(Badge["a" /* Badge */], {
    className: "size-48 border-lightSand bg-lightSand text-black",
    iconName: icons["a" /* ICONS */].CALENDAR_OPTION,
    variant: "pill"
  }), __jsx("div", {
    className: "text-start"
  }, __jsx("p", {
    className: "text-16 font-semibold leading-normal"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.optionTitle')), __jsx("p", {
    className: "mt-8 text-14 leading-normal"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.optionDescription')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-bottom-navbar/BookingBottomNavbar.jsx









var BookingBottomNavbar_jsx = react_default.a.createElement;








































var FLEX_RATES = dist["constants"].FLEX_RATES,
    _constants$PACKAGES = dist["constants"].PACKAGES,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;

var getTotalRentedServices = function getTotalRentedServices(services) {
  return (services || []).reduce(function (acc, s) {
    return acc + s.rentedServices.length;
  }, 0);
};

var BookingBottomNavbar_BookingBottomNavbar = function BookingBottomNavbar(_ref) {
  var _proposal$price;

  var continueAction = _ref.continueAction,
      hideContinueButton = _ref.hideContinueButton,
      currentPage = _ref.currentPage,
      isDisabled = _ref.isDisabled,
      i18n = _ref.i18n,
      isFavorite = _ref.isFavorite,
      isNextStep = _ref.isNextStep,
      isOnLastPage = _ref.isOnLastPage,
      isPriceLoading = _ref.isPriceLoading,
      navbarRef = _ref.navbarRef,
      continueBtn = _ref.continueBtn,
      noEdit = _ref.noEdit,
      overwriteContinueButton = _ref.overwriteContinueButton,
      _ref$portalPosition = _ref.portalPosition,
      portalPosition = _ref$portalPosition === void 0 ? Portal_constants["c" /* BEFORE_APP */] : _ref$portalPosition,
      previousAction = _ref.previousAction,
      price = _ref.price,
      proposal = _ref.proposal,
      resort = _ref.resort,
      shouldOpenPanel = _ref.shouldOpenPanel,
      closePanel = _ref.closePanel,
      nextPage = _ref.nextPage,
      previousPage = _ref.previousPage,
      _ref$paymentLabel = _ref.paymentLabel,
      paymentLabel = _ref$paymentLabel === void 0 ? Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.bookingLabel') : _ref$paymentLabel,
      onClickFavorite = _ref.onClickFavorite;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var isMobile = !isTablet;

  var _useState = Object(react["useState"])(false),
      shouldCloseAllLayers = _useState[0],
      setShouldCloseAllLayers = _useState[1];

  var reservedServicesByAttendee = Object(es["e" /* useSelector */])(booking_selector["u" /* getReservedServicesByAttendee */]);
  var layerRef = Object(react["useRef"])();
  var prevServicesLength = Object(usePrevious["a" /* usePrevious */])(getTotalRentedServices(reservedServicesByAttendee));

  var _useState2 = Object(react["useState"])(0),
      addedServicesNumber = _useState2[0],
      setAddedServicesNumber = _useState2[1];

  var priceWithDonation = Object(price_util["c" /* getTotalPriceWithDonation */])(proposal.price, appContext.locale);
  var isJoyview = resort.isJoyview,
      isUrbanOasis = resort.isUrbanOasis;
  var isJoyViewAllInclusive = proposal.packageId === JOYVIEW_ALL_INCLUSIVE && isJoyview;
  var isUrbanOasisAllInclusive = proposal.packageId === JOYVIEW_ALL_INCLUSIVE && isUrbanOasis;
  var isUrbanOasisFoodAndBeverage = proposal.packageId === JOYVIEW_FOOD_AND_BEVERAGES && isUrbanOasis;
  var shouldShowPriceDetails = isJoyViewAllInclusive || isUrbanOasisAllInclusive || !isJoyview && !isUrbanOasis;
  var hasSelectedRate = Boolean((price === null || price === void 0 ? void 0 : price.hasFlexRates) && (price === null || price === void 0 ? void 0 : price.selectedRate) && !isPriceLoading);
  var displayOptionAvailable = proposal.optionAvailable && currentPage !== 'banking' && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.option');
  var displayPromoCode = currentPage !== 'banking';
  var isPromoCodeEnabled = Object(src_i18n["d" /* getKeyValue */])('booking.priceDetails.promoCode.enabled');

  var _getOffersAndDiscount = Object(SummaryView_utils["a" /* getOffersAndDiscounts */])((proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.discounts) || []),
      discounts = _getOffersAndDiscount.discounts,
      offers = _getOffersAndDiscount.offers;

  var enableBuyNowPayLaterProvider = BuyNowPayLater_const["b" /* BUY_NOW_PAY_LATER_PROVIDER */].find(function (id) {
    var _price$total;

    return Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)("psp.".concat(id.toLowerCase())) && Object(BuyNowPayLater_utils["b" /* isAllowedPaymentPlan */])({
      id: id,
      price: price === null || price === void 0 ? void 0 : (_price$total = price.total) === null || _price$total === void 0 ? void 0 : _price$total.value,
      startDate: proposal.arrivalDate
    });
  });
  var BuyNowPayLaterPricing = BuyNowPayLater_const["a" /* BUY_NOW_PAY_LATER_PRICING */][enableBuyNowPayLaterProvider];
  var dispatch = Object(es["d" /* useDispatch */])();
  var roomQuantity = proposal.accommodations.filter(function (accommodation) {
    return accommodation.quantity > 1;
  }).map(function (accommodation) {
    return accommodation.quantity;
  });
  Object(react["useEffect"])(function () {
    var daddedServicesNumber = getTotalRentedServices(reservedServicesByAttendee) - prevServicesLength;
    setAddedServicesNumber(daddedServicesNumber);
    var timer = setTimeout(function () {
      return setAddedServicesNumber(0);
    }, BookingAddtionalServices_utils["a" /* TOAST_DURATION */]);
    return function () {
      return clearTimeout(timer);
    };
  }, [reservedServicesByAttendee]);
  var track = Object(useTracking["a" /* useTracking */])(be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */]);
  var displayInstalment = Object(src_i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice') && Price["a" /* INSTALMENT_LOCALES */].includes(appContext.locale);
  var hidePriceInfo = displayInstalment && isOnLastPage;

  if (!isAppMounted) {
    return null;
  }

  return BookingBottomNavbar_jsx(ActivitiesContext["a" /* ActivitiesContext */].Provider, {
    // TODO: cleanup !!
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value: {
      deleteService: function deleteService(services, attendeeIds) {
        track({
          labelGA: Object(bookingUtils["b" /* getActivityTypeName */])(services[0].pricingInfo.type),
          actionGA: 'removeFromCart'
        }); // find the serviceIds to be deleted

        var serviceIds = services.reduce(function (acc, service) {
          var _service$pricingInfo$ = service.pricingInfo.attendees.filter(function (a) {
            return a.id === attendeeIds;
          }),
              _service$pricingInfo$2 = Object(slicedToArray["a" /* default */])(_service$pricingInfo$, 1),
              attendee = _service$pricingInfo$2[0];

          return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(attendee.schedules.reduce(function (scheduleAccumulator, schedule) {
            return schedule.timeSlots.reduce(function (timeSlotAccumulator, timeSlot) {
              return timeSlotAccumulator.includes(timeSlot.id) ? timeSlotAccumulator : [].concat(Object(toConsumableArray["a" /* default */])(timeSlotAccumulator), [timeSlot.id]);
            }, scheduleAccumulator);
          }, acc)));
        }, []);
        return dispatch(Object(proposals_action["g" /* deleteAdditionalServices */])({
          showNotification: true,
          serviceIds: serviceIds,
          attendeeIds: attendeeIds,
          appContext: appContext
        }));
      },
      currency: proposal.price.currency,
      trackingData: be_tracking["a" /* TRACK_BE_EVENT_GA_ACTIVITIES */]
    }
  }, BookingBottomNavbar_jsx(BottomNavbarLayer["a" /* BottomNavbarLayer */], {
    addedServicesNumber: addedServicesNumber,
    continueBtn: continueBtn,
    backLabel: !appContext.isCmta ? Object(src_i18n["h" /* t */])('common.backNavigation') : '',
    buyNowPayLaterPricing: enableBuyNowPayLaterProvider && BookingBottomNavbar_jsx(BuyNowPayLaterPricing, {
      isPaymentPage: isOnLastPage,
      proposal: proposal,
      price: price,
      iconClassname: Object(classnames_utils["a" /* classnames */])('-bottom-[0.375rem] ml-5', {
        'bottom-[1.225rem]': isMobile && hasSelectedRate,
        '-bottom-[0.4rem]': isDesktop
      })
    }),
    closeLabel: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.closeReceipt'),
    continueAction: continueAction,
    continueLabel: isOnLastPage ? paymentLabel : Object(src_i18n["h" /* t */])('common.continue'),
    forwardRef: layerRef,
    hasSelectedRate: hasSelectedRate,
    hideContinueButton: hideContinueButton,
    isDisabled: isDisabled,
    isFavorite: isFavorite,
    isNextStep: isNextStep,
    isPriceLoading: isPriceLoading,
    navbarRef: navbarRef,
    nextPage: nextPage,
    onClickFavorite: onClickFavorite,
    onCloseAllLayers: function onCloseAllLayers() {
      return setShouldCloseAllLayers(false);
    },
    openLabel: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.openReceipt'),
    overwriteContinueButton: overwriteContinueButton,
    previousPage: previousPage,
    price: price,
    isOnLastPage: isOnLastPage,
    portalPosition: portalPosition,
    previousAction: previousAction,
    shouldCloseAllLayers: shouldCloseAllLayers,
    showPanel: shouldOpenPanel,
    toggleReceiptPanel: closePanel,
    trackClickOpenReceipt: function trackClickOpenReceipt() {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BOTTOM_BAR, {
        detail_click: 'open_receipt'
      });
    }
  }, onClickFavorite && BookingBottomNavbar_jsx("div", {
    className: "fixed inset-x-0 top-[10vh] isolate w-full bg-white"
  }, BookingBottomNavbar_jsx(PriceTicketFavorite["a" /* PriceTicketFavorite */], {
    isFilled: isFavorite,
    isNextStep: isNextStep,
    isSticky: true,
    onClick: onClickFavorite
  })), !hidePriceInfo && BookingBottomNavbar_jsx("div", {
    className: "flex flex-wrap items-end justify-between gap-10 p-20 py-10 lg:flex-nowrap lg:py-20"
  }, BookingBottomNavbar_jsx("div", {
    className: "flex-1"
  }), BookingBottomNavbar_jsx("div", {
    className: "relative flex items-end gap-10"
  }, BookingBottomNavbar_jsx(BottomNavbarTotalPrice["a" /* BottomNavbarTotalPrice */], {
    isLoading: isPriceLoading,
    price: price,
    showPrice: !!Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.closeReceipt'),
    className: "items-center text-center"
  })), BookingBottomNavbar_jsx("div", {
    className: "flex flex-1"
  }, price && price.hasFlexRates && price.selectedRate ? BookingBottomNavbar_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('rounded-pill px-10 py-5', {
      'bg-green': [FLEX_RATES.STANDARD, FLEX_RATES.EBB].includes(price.selectedRate),
      'bg-sienna': [FLEX_RATES.NRR, FLEX_RATES.FLR].includes(price.selectedRate)
    })
  }, BookingBottomNavbar_jsx(SelectedRate["a" /* SelectedRate */], {
    price: price
  })) : null)), BookingBottomNavbar_jsx(SiteContainer["a" /* SiteContainer */], null, BookingBottomNavbar_jsx("p", {
    className: "mb-10 mt-30 font-brand text-24 text-black"
  }, Object(src_i18n["h" /* t */])('booking.summary.pageTitle')), BookingBottomNavbar_jsx("div", {
    className: "flex gap-20"
  }, BookingBottomNavbar_jsx(Icon["a" /* Icon */], {
    className: "text-green",
    name: icons["a" /* ICONS */].CHECK_FILLED
  }), BookingBottomNavbar_jsx("p", {
    className: "mb-10 font-brand text-green"
  }, Object(src_i18n["h" /* t */])('booking.summary.discount.bestRateGuarantee'))), displayOptionAvailable && BookingBottomNavbar_jsx(OptionBlock_OptionBlock, null), BookingBottomNavbar_jsx("div", {
    className: "mb-100 rounded-12 bg-white p-20 shadow-sm",
    "data-testid": "stay-summary-ticket"
  }, BookingBottomNavbar_jsx(AccordionBlock["a" /* AccordionBlock */], {
    trackingEventName: constants["F" /* TRACK_EVENT_NAMES */].CLICK_RECEIPT_TICKET,
    lines: Object(SummaryView_utils["c" /* getSummaryViewLinesByProposal */])({
      accommodationSummary: BookingBottomNavbar_jsx(AccommodationSummary["a" /* AccommodationSummary */], {
        accommodations: proposal.accommodations,
        resort: resort,
        roomQuantity: roomQuantity
      }),
      i18n: i18n,
      locale: appContext.locale,
      selectedProposal: proposal,
      isJoyViewOrUrbanOasisAllInclusive: isJoyViewAllInclusive || isUrbanOasisAllInclusive,
      isUrbanOasisFoodAndBeverage: isUrbanOasisFoodAndBeverage
    })
  }, BookingBottomNavbar_jsx("div", {
    className: "mt-40"
  }, shouldShowPriceDetails && BookingBottomNavbar_jsx("p", {
    className: "mb-20 font-bold"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.priceDetails')), BookingBottomNavbar_jsx(PriceDetailLines["a" /* PriceDetailLines */], {
    trackingEventName: constants["F" /* TRACK_EVENT_NAMES */].CLICK_RECEIPT_TICKET,
    priceDetail: Object(SummaryView_utils["b" /* getPriceDetail */])({
      selectedProposal: proposal,
      priceWithDonation: priceWithDonation,
      showPriceDetailLines: shouldShowPriceDetails,
      promoCode: displayPromoCode ? BookingBottomNavbar_jsx("div", {
        className: "mb-20"
      }, BookingBottomNavbar_jsx(DiscountsLine["a" /* DiscountsLine */], {
        discounts: offers
      }), isPromoCodeEnabled && !!proposal && BookingBottomNavbar_jsx(PromoCode["a" /* PromoCode */], {
        proposalId: proposal.id,
        customerId: parseInt(proposal.attendees.list[0].customerId, 10),
        discounts: discounts
      })) : BookingBottomNavbar_jsx("div", {
        className: "mb-20"
      }, BookingBottomNavbar_jsx(DiscountsLine["a" /* DiscountsLine */], {
        discounts: proposal.price.discounts
      }))
    })
  })), !!(proposal === null || proposal === void 0 ? void 0 : proposal.greatMembersLoyaltyPoints) && BookingBottomNavbar_jsx(GreatMembersLoyaltyPoints["a" /* GreatMembersLoyaltyPoints */], {
    loyaltyPoints: proposal === null || proposal === void 0 ? void 0 : proposal.greatMembersLoyaltyPoints,
    dataTestId: "greatMembersLoyaltyPoints"
  })))), reservedServicesByAttendee.length > 0 && BookingBottomNavbar_jsx(SiteContainer["a" /* SiteContainer */], {
    size: "small"
  }, BookingBottomNavbar_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.activities.myPackage.title')), BookingBottomNavbar_jsx(ReservedServicesList["a" /* ReservedServicesList */], {
    currency: proposal.price.currency,
    noEditMode: noEdit,
    reservedServicesByAttendee: reservedServicesByAttendee,
    scrollBackwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  }))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/booking-navbar/BookingNavbarContext.jsx
var BookingNavbarContext = __webpack_require__("4ryf");

// CONCATENATED MODULE: ./src/client/views/booking/BookingLayout.jsx
var BookingLayout_jsx = react_default.a.createElement;






var BookingLayout_BookingLayout = function BookingLayout(_ref) {
  var selectedProposal = _ref.selectedProposal,
      currentPage = _ref.currentPage,
      previousPage = _ref.previousPage,
      nextPage = _ref.nextPage,
      price = _ref.price,
      goToNextStep = _ref.goToNextStep,
      i18n = _ref.i18n,
      resort = _ref.resort,
      isFavorite = _ref.isFavorite,
      isOptionHoldOnly = _ref.isOptionHoldOnly,
      previousAction = _ref.previousAction,
      isOnLastPage = _ref.isOnLastPage,
      shouldOpenPanel = _ref.shouldOpenPanel,
      closePanel = _ref.closePanel,
      onClickFavorite = _ref.onClickFavorite,
      isNextStep = _ref.isNextStep,
      children = _ref.children;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var navbarRef = Object(react["useRef"])();

  var _useState = Object(react["useState"])(false),
      hideContinueButton = _useState[0],
      setHideContinueButton = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isPriceLoading = _useState2[0],
      setIsPriceLoading = _useState2[1];

  var _useState3 = Object(react["useState"])(true),
      noEdit = _useState3[0],
      setNoEdit = _useState3[1];

  var _useState4 = Object(react["useState"])(false),
      overwriteContinueButton = _useState4[0],
      setOverwriteContinueButton = _useState4[1];

  var _useState5 = Object(react["useState"])(null),
      continueBtn = _useState5[0],
      setContinueBtn = _useState5[1];

  var _useState6 = Object(react["useState"])(),
      portalPosition = _useState6[0],
      setPortalPosition = _useState6[1];

  var _useState7 = Object(react["useState"])(false),
      isDisabled = _useState7[0],
      setIsDisabled = _useState7[1];

  var _useState8 = Object(react["useState"])(true),
      priceShouldIncludeDonation = _useState8[0],
      setPriceShouldIncludeDonation = _useState8[1];

  var _useState9 = Object(react["useState"])(null),
      validationCallback = _useState9[0],
      setValidationCallback = _useState9[1];

  var _useState10 = Object(react["useState"])(),
      paymentLabel = _useState10[0],
      setPaymentLabel = _useState10[1];

  var _getTotalPriceWithDon = Object(price_util["c" /* getTotalPriceWithDonation */])(price, appContext.locale),
      withDonation = _getTotalPriceWithDon.withDonation;

  return BookingLayout_jsx(BookingNavbarContext["a" /* BookingNavbarProvider */], {
    currentPage: currentPage,
    hideContinueButton: hideContinueButton,
    setHideContinueButton: setHideContinueButton,
    setIsPriceLoading: setIsPriceLoading,
    setPriceShouldIncludeDonation: setPriceShouldIncludeDonation,
    navbarRef: navbarRef,
    setNoEdit: setNoEdit,
    setContinueBtn: setContinueBtn,
    setOverwriteContinueButton: setOverwriteContinueButton,
    setPortalPosition: setPortalPosition,
    setIsDisabled: setIsDisabled,
    setValidationCallback: setValidationCallback,
    setPaymentLabel: setPaymentLabel
  }, children, BookingLayout_jsx(BookingBottomNavbar_BookingBottomNavbar, {
    continueBtn: continueBtn,
    overwriteContinueButton: overwriteContinueButton,
    i18n: i18n,
    previousAction: previousAction,
    price: priceShouldIncludeDonation ? withDonation : price,
    proposal: selectedProposal,
    resort: resort,
    currentPage: currentPage,
    portalPosition: portalPosition,
    previousPage: previousPage,
    nextPage: nextPage,
    paymentLabel: paymentLabel || Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.bookingLabel'),
    noEdit: noEdit,
    isOnLastPage: isOnLastPage,
    hideContinueButton: hideContinueButton,
    isDisabled: !!isDisabled,
    isPriceLoading: isPriceLoading // $FlowFixMe
    ,
    continueAction: goToNextStep(validationCallback),
    shouldOpenPanel: shouldOpenPanel,
    closePanel: closePanel,
    isOptionHoldOnly: isOptionHoldOnly,
    navbarRef: navbarRef,
    onClickFavorite: onClickFavorite,
    isFavorite: isFavorite,
    isNextStep: isNextStep
  }));
};

/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "iglS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("ZK3j");
var common = __webpack_require__("roL5");
var assert = __webpack_require__("Y4pH");

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),

/***/ "jEE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuickSearchUnavailability; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var QuickSearchUnavailability = function QuickSearchUnavailability(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return __jsx("div", {
    className: "flex flex-col items-center",
    "data-testid": "QuickSearchUnavailability"
  }, __jsx("div", {
    className: "QuickSearchUnavailability-header flex w-full items-center p-25 md:py-50"
  }, __jsx("div", {
    className: "mr-40"
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    className: "shrink self-start text-orange",
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].WARNING,
    width: "3rem",
    hasRtl: true
  })), __jsx("h1", {
    className: "m-0 text-20 text-black lg:text-24"
  }, title)), description != null && __jsx("p", {
    className: "QuickSearchUnavailability-descriptions m-0 w-full px-25 text-12"
  }, description));
};

/***/ }),

/***/ "jFIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FiltersBar_FiltersBar; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/check-button/CheckButton.themes.js

var themes = {
  "default": function _default(_ref) {
    var isChecked = _ref.isChecked,
        isDisabled = _ref.isDisabled;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('relative flex flex-col items-center justify-center rounded-12 border-1 border-solid bg-white p-10 text-14 font-bold transition-colors duration-250 ease-in', {
        'cursor-not-allowed border-grey bg-pearl': isDisabled,
        'border-lightGrey': !isChecked,
        'border-success': isChecked && !isDisabled
      }),
      thIcon: Object(classnames_utils["a" /* classnames */])('absolute end-0 top-0 m-5 text-grey', {
        'text-success': !isDisabled
      }),
      thIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/check-button/CheckButton.jsx
var __jsx = react_default.a.createElement;





var CheckButton_CheckButton = function CheckButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _themes$theme = themes[theme]({
    isChecked: isChecked,
    isDisabled: isDisabled
  }),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot;

  return __jsx("button", {
    "aria-checked": isChecked,
    "aria-disabled": isDisabled,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    onClick: !isDisabled && onClick,
    role: "checkbox",
    type: "button"
  }, isChecked && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].CHECK,
    width: thIconWidth
  }), children);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-option/FilterOption.jsx

var FilterOption_jsx = react_default.a.createElement;




var FilterOption_FilterOption = function FilterOption(_ref) {
  var className = _ref.className,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      id = _ref.id,
      imageSrc = _ref.imageSrc,
      isButton = _ref.isButton,
      isDisabled = _ref.isDisabled,
      isIconNotSquare = _ref.isIconNotSquare,
      isSelected = _ref.isSelected,
      label = _ref.label,
      matched = _ref.matched,
      name = _ref.name,
      _onChange = _ref.onChange,
      subLabel = _ref.subLabel,
      value = _ref.value;
  return isButton ? FilterOption_jsx(CheckButton_CheckButton, {
    className: className,
    isChecked: isSelected,
    isDisabled: isDisabled,
    onClick: function onClick() {
      return _onChange(value);
    }
  }, iconName && FilterOption_jsx(Icon["a" /* Icon */], {
    className: "mb-5",
    hasRtl: true,
    isNotSquare: isIconNotSquare,
    name: iconName,
    width: iconSize || '1.5rem'
  }), imageSrc && FilterOption_jsx("img", {
    alt: "",
    className: "mb-5 w-4/5 max-w-100",
    src: imageSrc
  }), label, subLabel && FilterOption_jsx("span", {
    className: "text-12 text-mediumGrey"
  }, subLabel), FilterOption_jsx("span", {
    className: "text-12 text-black"
  }, "(", matched, ")")) : FilterOption_jsx(InputSwitch["a" /* InputSwitch */], {
    className: className,
    id: id,
    isChecked: isSelected,
    isDisabled: isDisabled,
    label: FilterOption_jsx("span", {
      className: "inline-flex items-center gap-5"
    }, iconName && FilterOption_jsx(Icon["a" /* Icon */], {
      name: iconName,
      width: "1.5rem"
    }), label, subLabel && FilterOption_jsx("span", {
      className: "text-12 text-mediumGrey"
    }, subLabel), FilterOption_jsx("span", {
      className: "text-12 text-mediumGrey"
    }, "(", matched, ")")),
    name: name,
    onChange: function onChange() {
      return _onChange(value);
    },
    value: value
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/filter-options/FilterOptions.jsx



var FilterOptions_jsx = react_default.a.createElement;




var FilterOptions_FilterOptions = function FilterOptions(_ref) {
  var className = _ref.className,
      name = _ref.name,
      onChange = _ref.onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return FilterOptions_jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])('sm:flex sm:flex-wrap -m-5', className)
  }, options.map(function (option) {
    return FilterOptions_jsx("li", {
      className: "p-5 sm:w-1/4 md:w-1/6",
      key: option.id
    }, FilterOptions_jsx(FilterOption_FilterOption, Object(esm_extends["a" /* default */])({}, option, {
      className: isTablet ? 'h-full text-black shadow-diffuse w-full' : '',
      isButton: isTablet,
      name: name,
      onChange: onChange
    })));
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx + 1 modules
var InputButton = __webpack_require__("W+NJ");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-toggler/FilterToggler.jsx


var FilterToggler_jsx = react_default.a.createElement;




var FilterToggler_FilterToggler = function FilterToggler(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$selectedOptionsN = _ref.selectedOptionsNumber,
      selectedOptionsNumber = _ref$selectedOptionsN === void 0 ? 0 : _ref$selectedOptionsN;
  return FilterToggler_jsx(InputButton["a" /* InputButton */], {
    className: className,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: Boolean(selectedOptionsNumber),
    onClear: onClear,
    onClick: onClick
  }, FilterToggler_jsx("span", {
    className: "truncate"
  }, children, !!selectedOptionsNumber && FilterToggler_jsx(TemplateString["a" /* TemplateString */], {
    className: "sr-only",
    template: selectedOptionsNumber > 1 ? Object(i18n["h" /* t */])('common.selectedCriteriasLabel.n') : Object(i18n["h" /* t */])('common.selectedCriteriasLabel._1'),
    values: {
      count: selectedOptionsNumber.toString()
    }
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/widgets/filter/Filter.jsx















var Filter_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Filter_getSelectedOptions = function getSelectedOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return options.reduce(function (acc, o) {
    return o.isSelected ? [].concat(Object(toConsumableArray["a" /* default */])(acc), [o.value]) : acc;
  }, []);
};

var Filter_Filter = function Filter(_ref) {
  var className = _ref.className,
      customRender = _ref.customRender,
      customRenderParent = _ref.customRenderParent,
      _ref$hasForceClose = _ref.hasForceClose,
      hasForceClose = _ref$hasForceClose === void 0 ? false : _ref$hasForceClose,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      _onClick = _ref.onClick,
      onClickOption = _ref.onClickOption,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      portalName = _ref.portalName,
      setOptions = _ref.setOptions;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var selectedOptions = Filter_getSelectedOptions(options);
  Object(react["useEffect"])(function () {
    if (isOpen && hasForceClose) {
      setIsOpen(false);
    }
  }, [hasForceClose]);

  var toggleOption = function toggleOption(option) {
    var newOptions = Object(toConsumableArray["a" /* default */])(options);

    var optionToggeledIndex = newOptions.findIndex(function (opt) {
      return opt.id === option.id;
    });

    var updatedOption = _objectSpread(_objectSpread({}, newOptions[optionToggeledIndex]), {}, {
      isSelected: !newOptions[optionToggeledIndex].isSelected
    });

    newOptions[optionToggeledIndex] = updatedOption;
    setOptions(newOptions);
    onChange(name, Filter_getSelectedOptions(newOptions), option.value);
    onClickOption === null || onClickOption === void 0 ? void 0 : onClickOption(updatedOption);
  };

  var clearAllSelected = function clearAllSelected() {
    var newOptions = options.map(function (opt) {
      return _objectSpread(_objectSpread({}, opt), {}, {
        isSelected: false
      });
    });
    setOptions(Object(toConsumableArray["a" /* default */])(newOptions));
    onClear && onClear(name);
  };

  return Filter_jsx(react["Fragment"], null, !customRenderParent ? Filter_jsx(FilterToggler_FilterToggler, {
    className: className,
    isActive: isOpen,
    isDisabled: options.length === 0,
    onClear: clearAllSelected,
    onClick: function onClick() {
      setIsOpen(!isOpen);
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(name);
    },
    selectedOptionsNumber: selectedOptions.length
  }, label) : Filter_jsx("div", {
    className: "flex items-center flex-1 whitespace-nowrap"
  }, customRenderParent(selectedOptions, onChange, options.length === 0)), isOpen && Filter_jsx(Portal["a" /* default */], {
    name: portalName
  }, Filter_jsx(ClickOutside["a" /* ClickOutside */], {
    className: "bg-white border-1 border-lightGrey mt-2 relative rounded-12 shadow-diffuse z-2",
    onClick: function onClick() {
      return setIsOpen(false);
    }
  }, customRender ? Filter_jsx("div", {
    className: "flex max-w-site mx-auto p-15"
  }, customRender(options, selectedOptions, toggleOption)) : Filter_jsx("div", {
    className: "max-w-site mx-auto p-15"
  }, Filter_jsx(FilterOptions_FilterOptions, {
    name: name,
    onChange: function onChange(value) {
      var clickedOption = options.find(function (opt) {
        return opt.value === value;
      });
      clickedOption && toggleOption(clickedOption);
    },
    options: options.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        isSelected: option.isSelected,
        label: Filter_jsx("span", {
          className: "capitalize"
        }, option.label.toLowerCase())
      });
    })
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/filters-bar/FiltersBarClearAllBtn.jsx
var FiltersBarClearAllBtn_jsx = react_default.a.createElement;



var FiltersBarClearAllBtn_FiltersBarClearAllBtn = function FiltersBarClearAllBtn(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  return FiltersBarClearAllBtn_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('text-12 md:text-14 lg:text-16 text-black underline', className),
    "data-testid": "removeAllFilters",
    onClick: onClick,
    type: "button"
  }, Object(i18n["h" /* t */])('filters.removeAll'));
};
// CONCATENATED MODULE: ./src/client/components/widgets/filters-bar/FiltersBar.jsx












var FiltersBar_jsx = react_default.a.createElement;

function FiltersBar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FiltersBar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FiltersBar_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FiltersBar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var FiltersBar_FiltersBar = function FiltersBar(_ref) {
  var caption = _ref.caption,
      className = _ref.className,
      dataTestid = _ref.dataTestid,
      _ref$hasClearAll = _ref.hasClearAll,
      hasClearAll = _ref$hasClearAll === void 0 ? false : _ref$hasClearAll,
      _ref$hasForceClose = _ref.hasForceClose,
      hasForceClose = _ref$hasForceClose === void 0 ? false : _ref$hasForceClose,
      isLarge = _ref.isLarge,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      onClearAll = _ref.onClearAll,
      onClick = _ref.onClick,
      onClickOption = _ref.onClickOption,
      portalName = _ref.portalName,
      propsFilters = _ref.filters,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["caption", "className", "dataTestid", "hasClearAll", "hasForceClose", "isLarge", "onChange", "onClear", "onClearAll", "onClick", "onClickOption", "portalName", "filters"]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(propsFilters ? Object(toConsumableArray["a" /* default */])(propsFilters) : []),
      filters = _useState[0],
      setFilters = _useState[1];

  Object(react["useEffect"])(function () {
    propsFilters && setFilters(propsFilters);
  }, [propsFilters]);

  var renderFilters = function renderFilters() {
    return filters.map(function (filter, index) {
      return FiltersBar_jsx(Filter_Filter, {
        className: Object(classnames_utils["a" /* classnames */])('flex-1', {
          'last:scroll-x-ghost-m-10 last:scroll-x-ghost-m': index === filters.length - 1 && !isDesktop
        }),
        customRender: filter.customRender,
        customRenderParent: filter.customRenderParent,
        id: filter.id,
        key: filter.id,
        label: filter.label,
        name: filter.id,
        onChange: onChange,
        onClear: onClear,
        onClick: onClick,
        onClickOption: onClickOption,
        hasForceClose: hasForceClose,
        options: filter.options,
        portalName: portalName,
        setOptions: function setOptions(newOptions) {
          var newFilters = Object(toConsumableArray["a" /* default */])(filters);

          newFilters[index] = FiltersBar_objectSpread(FiltersBar_objectSpread({}, newFilters[index]), {}, {
            options: newOptions
          });
          setFilters(newFilters);
        }
      });
    });
  };

  var clearFiltersAndSelectedOptions = function clearFiltersAndSelectedOptions() {
    var newFilters = filters.map(function (filter) {
      return FiltersBar_objectSpread(FiltersBar_objectSpread({}, filter), {}, {
        options: filter.options.map(function (opt) {
          return FiltersBar_objectSpread(FiltersBar_objectSpread({}, opt), {}, {
            isSelected: false
          });
        })
      });
    });
    setFilters(Object(toConsumableArray["a" /* default */])(newFilters));
    onClearAll === null || onClearAll === void 0 ? void 0 : onClearAll();
  };

  return FiltersBar_jsx(react["Fragment"], null, FiltersBar_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'animation-duration-500 animate-slideInTop border-b-1 border-t-1 border-grey bg-white': isLarge
    })
  }, FiltersBar_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: !isDesktop
  }, FiltersBar_jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])('flex w-full flex-wrap items-center justify-between gap-10 bg-white p-10', {
      'border-1 border-grey shadow-diffuse': !isLarge
    }, className),
    "data-testid": dataTestid
  }), caption && FiltersBar_jsx("p", {
    className: "w-1/2 text-12 font-bold md:text-14 lg:w-auto lg:text-16"
  }, caption), hasClearAll && FiltersBar_jsx(FiltersBarClearAllBtn_FiltersBarClearAllBtn, {
    className: "shrink lg:order-last",
    onClick: clearFiltersAndSelectedOptions
  }), isDesktop ? renderFilters() : FiltersBar_jsx(Scrollable["a" /* Scrollable */], {
    className: "-mx-10",
    childrenWrapperClassNames: "flex gap-10 px-10"
  }, renderFilters())))), FiltersBar_jsx("div", {
    id: portalName
  }));
};

/***/ }),

/***/ "jL7K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("qW1w")
var Buffer = __webpack_require__("KLyV").Buffer

var Base = __webpack_require__("7IvJ")

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),

/***/ "jRCX":
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__("T0Kn")
var deciphers = __webpack_require__("PxjX")
var modes = __webpack_require__("Kk8D")

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "jggy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__("NKBa").version;
elliptic.utils = __webpack_require__("EmIl");
elliptic.rand = __webpack_require__("ufvR");
elliptic.curve = __webpack_require__("v05O");
elliptic.curves = __webpack_require__("3870");

// Protocols
elliptic.ec = __webpack_require__("IS/a");
elliptic.eddsa = __webpack_require__("0sSj");


/***/ }),

/***/ "jwfn":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/[bookingStep]",
      function () {
        return __webpack_require__("Tz41");
      }
    ]);
  

/***/ }),

/***/ "k/xG":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("qW1w")
var SHA512 = __webpack_require__("aLd+")
var Hash = __webpack_require__("4rhd")
var Buffer = __webpack_require__("KLyV").Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),

/***/ "kKSj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("ZK3j");
var assert = __webpack_require__("Y4pH");

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),

/***/ "kkwi":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__("nXZ9");
var MillerRabin = __webpack_require__("1DFk");
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__("Imk+");
var randomBytes = __webpack_require__("i+/A");
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("+ZX+").Buffer))

/***/ }),

/***/ "kzMc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "lAqc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__("SjZQ");
__webpack_require__("qW1w")(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "lLE/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__("sPPR")

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("+ZX+").Buffer))

/***/ }),

/***/ "ldqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_TRANSPORT_STATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchTransportStations; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("WGoB");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");







var FETCH_TRANSPORT_STATIONS = 'FETCH_TRANSPORT_STATIONS';

var formatTransportStationsNames = function formatTransportStationsNames(node) {
  return node.map(function (transport) {
    return {
      value: transport.id,
      label: transport.label,
      name: Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_4__[/* getTravelSectionSummary */ "c"])({
        travelSection: transport
      })
    };
  });
};

var transportStationFragment = "\n    fragment transportStation on TransportStationType {\n      id\n      label\n      city_id\n      type\n      is_main_city_station\n    }";

function fetchTransportStationsQuery(cityId, appContext) {
  var query = "{\n      transportStations(cityId: \"".concat(cityId, "\"){\n        airports {\n          ...transportStation\n        }\n        trainStations {\n          ...transportStation\n        }\n        ports {\n          ...transportStation\n        }\n      }\n    }\n    ").concat(transportStationFragment);
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* CITIES_GET_TRANSPORT_STATIONS */ "b"]
  }).then(function (_ref) {
    var _ref$transportStation = _ref.transportStations,
        airports = _ref$transportStation.airports,
        trainStations = _ref$transportStation.trainStations,
        ports = _ref$transportStation.ports;
    return {
      airports: formatTransportStationsNames(airports),
      trainStations: formatTransportStationsNames(trainStations),
      ports: formatTransportStationsNames(ports)
    };
  });
}

function fetchTransportStations(cityId, appContext) {
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(FETCH_TRANSPORT_STATIONS, cityId));
    return fetchTransportStationsQuery(cityId, appContext).then(function (response) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(FETCH_TRANSPORT_STATIONS), response));
      return response;
    })["catch"](function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(FETCH_TRANSPORT_STATIONS)));
      throw error;
    });
  };
}



/***/ }),

/***/ "lr0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentInfoContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PaymentInfoProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

 // $FlowFixMe

var PaymentInfoContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createContext({
  isFreeDeposit: false
});
var PaymentInfoProvider = function PaymentInfoProvider(_ref) {
  var children = _ref.children,
      value = _ref.value;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_8__["useState"])(false),
      isBuyNowPayLaterProcessComplete = _useState[0],
      setIsBuyNowPayLaterProcessComplete = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_8__["useState"])(0),
      cardFeesPercentage = _useState2[0],
      setCardFeesPercentage = _useState2[1];

  var paymentInfoContextValue = Object(react__WEBPACK_IMPORTED_MODULE_8__["useMemo"])(function () {
    return _objectSpread(_objectSpread({}, value), {}, {
      isBuyNowPayLaterProcessComplete: isBuyNowPayLaterProcessComplete,
      onBuyNowPayLaterComplete: function onBuyNowPayLaterComplete() {
        return setIsBuyNowPayLaterProcessComplete(true);
      },
      cardFeesPercentage: cardFeesPercentage,
      setCardFeesPercentage: setCardFeesPercentage
    });
  }, [value, isBuyNowPayLaterProcessComplete, cardFeesPercentage]);
  return __jsx(PaymentInfoContext.Provider, {
    value: paymentInfoContextValue
  }, children);
};

/***/ }),

/***/ "mC9x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("EmIl");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),

/***/ "mCPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PromoCode_PromoCode; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniq.js
var uniq = __webpack_require__("jLkM");
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/use-gql-errors-handler/useGQLErrorsHandler.js
var useGQLErrorsHandler = __webpack_require__("Kl3I");

// EXTERNAL MODULE: ./src/hooks/use-authentication/useAuthentication.js
var useAuthentication = __webpack_require__("Iev9");

// EXTERNAL MODULE: ./src/client/views/account/queries/account.queries.js
var account_queries = __webpack_require__("QRI5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 14 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// CONCATENATED MODULE: ./src/client/components/widgets/promo-code/PromoCodeForm.jsx



var __jsx = react_default.a.createElement;









 // THIS SPECIFIC CODE IS NOT A GOOD PRACTICE, REFUSE ANY DEMANDS THAT WOULD ADD MORE CODE LIKE THIS https://github.com/ClubMediterranee/cm-b2c/issues/21598

var PROMO_CODE_MAX_LENGTH = 15;
var PROMO_CODE_VALIDATOR = lib["string"]().max(PROMO_CODE_MAX_LENGTH).required();
var promoCodeErrorToCmsKey = {
  SUCCESS: '',
  AUTHORIZATION_ERROR: 'customerNotEligible',
  INVALID_PROMO_CODE: 'invalidPromoCode',
  WRONG_PROMO_CODE: 'wrongPromoCode',
  PROMO_CODE_QUOTA_EXCEEDED: 'quotaExceeded',
  PROMO_CANNOT_BE_APPLIED: 'criteriaNotApplicable',
  BEST_PROMOTION_ALREADY_APPLIED: 'bestPromotionAlreadyApplied',
  COMMERCIAL_OFFER_ALREADY_USED: 'alreadyUsed',
  ALREADY_APPLIED_PROMOTION: 'alreadyAppliedOnProposal',
  REQUIRED_IDENTIFIED_ATTENDEES: 'requiredIdentifiedAttendees'
};

var PromoCodeForm_getPromocodeFeedbackMessage = function getPromocodeFeedbackMessage(valuesPromoCode, isPromoCodeRequestOnError, promoCodeStatus, selectedVouchers) // eslint-disable-next-line max-params
{
  if (isPromoCodeRequestOnError && promoCodeStatus !== null) {
    var _promoCodeErrorToCmsK;

    return Object(i18n["h" /* t */])("booking.priceDetails.promoCode.".concat((_promoCodeErrorToCmsK = promoCodeErrorToCmsKey === null || promoCodeErrorToCmsKey === void 0 ? void 0 : promoCodeErrorToCmsKey[promoCodeStatus]) !== null && _promoCodeErrorToCmsK !== void 0 ? _promoCodeErrorToCmsK : 'error'));
  }

  if (selectedVouchers.length > 0) {
    return Object(i18n["h" /* t */])('booking.priceDetails.promoCode.success');
  }

  return '';
};

var PromoCodeForm_PromoCodeForm = function PromoCodeForm(_ref) {
  var selectedVouchers = _ref.selectedVouchers,
      shouldDisplayIsUnfolded = _ref.shouldDisplayIsUnfolded,
      promoCodeStatus = _ref.promoCodeStatus,
      setPromoCodeStatus = _ref.setPromoCodeStatus;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      setFieldError = _useFormikContext.setFieldError,
      submitForm = _useFormikContext.submitForm,
      values = _useFormikContext.values,
      errors = _useFormikContext.errors;

  var isPromoCodeRequestOnError = promoCodeStatus !== 'SUCCESS' && promoCodeStatus !== null;
  var isPromoCodeRequestOnSuccess = promoCodeStatus === 'SUCCESS';

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var alreadyHasVoucher = selectedVouchers.length > 0;
  var feedbackMessage = PromoCodeForm_getPromocodeFeedbackMessage(values.promoCode, isPromoCodeRequestOnError, promoCodeStatus, selectedVouchers);
  Object(react["useEffect"])(function () {
    if (isPromoCodeRequestOnError) {
      setFieldError('promoCode', 'Request failed');
    }
  }, [isPromoCodeRequestOnError]);
  return __jsx("div", null, shouldDisplayIsUnfolded && __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "togglePromoCodeField",
    className: "mt-20",
    label: alreadyHasVoucher ? Object(i18n["h" /* t */])('booking.priceDetails.promoCode.triggerAnotherText') : Object(i18n["h" /* t */])('booking.priceDetails.promoCode.triggerText'),
    name: "isUnfolded",
    type: "checkbox",
    onClick: function onClick() {
      if (!values.isUnfolded) {
        trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY, {
          detail_click: 'promotional_code'
        });
      }

      if (promoCodeStatus !== null) {
        setPromoCodeStatus(null);
        setFieldError('promoCode', '');
      }
    }
  }), __jsx("div", {
    className: "PromoCode-trigger inline-block text-right"
  }), values.isUnfolded && __jsx("div", null, __jsx("div", {
    className: "-mt-10 flex items-end gap-15"
  }, __jsx("div", {
    className: "md:w-1/3",
    "data-selector": "PromoCode-inputContainer"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    className: Object(classnames_utils["a" /* classnames */])('air360-replay-ignore h-48 w-full appearance-none rounded-pill border border-lightGrey bg-white px-20 py-10 text-14 leading-normal text-black outline-none transition-all duration-250 ease-in focus:border-black', {
      'border-success': isPromoCodeRequestOnSuccess,
      'border-red': errors.promoCode
    }),
    hideErrorMessage: true,
    label: Object(i18n["h" /* t */])('booking.priceDetails.promoCode.label'),
    placeholder: Object(i18n["h" /* t */])('booking.priceDetails.promoCode.fieldLabel'),
    maxLength: PROMO_CODE_MAX_LENGTH,
    name: "promoCode",
    type: "text",
    validate: PROMO_CODE_VALIDATOR,
    dataTestId: "PromoCodeForm-input"
  })), __jsx(Button["a" /* Button */], {
    className: "mt-10",
    "data-testid": "PromoCodeForm-submit",
    onClick: submitForm
  }, Object(i18n["h" /* t */])('booking.priceDetails.promoCode.apply')))), __jsx("div", null, promoCodeStatus !== null && !!feedbackMessage && __jsx(FormFeedback["a" /* FormFeedback */], {
    message: feedbackMessage,
    isError: isPromoCodeRequestOnError
  })));
};
// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/widgets/promo-code/PromoCodeModal.jsx
var PromoCodeModal_jsx = react_default.a.createElement;








var CIEL_VALIDATOR = lib["string"]().required();
var PromoCodeModal_PromoCodeModal = function PromoCodeModal(_ref) {
  var codeCiel = _ref.codeCiel,
      setCodeCiel = _ref.setCodeCiel,
      applyPromoCode = _ref.applyPromoCode;
  return PromoCodeModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(i18n["h" /* t */])('booking.summary.cielPopIn.title'),
    ariaLabelledby: identifiers_constants["u" /* ID_MODAL_HEADER__BE__PROMO_CODE */],
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose() {
      return setCodeCiel(null);
    },
    size: "small"
  }, PromoCodeModal_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      partnerId: null,
      accessCode: null
    },
    onSubmit: function onSubmit(_ref2) {
      var partnerId = _ref2.partnerId,
          accessCode = _ref2.accessCode;
      applyPromoCode({
        promoCode: codeCiel || '',
        partnerId: partnerId,
        accessCode: accessCode
      });
      setCodeCiel(null);
    }
  }, function (formik) {
    return PromoCodeModal_jsx("div", {
      className: "p-20",
      "data-testid": "PromoCodeModal-form"
    }, PromoCodeModal_jsx("div", {
      className: "mb-20 font-bold",
      id: identifiers_constants["u" /* ID_MODAL_HEADER__BE__PROMO_CODE */]
    }, Object(i18n["h" /* t */])('booking.summary.cielPopIn.title')), PromoCodeModal_jsx("div", null, PromoCodeModal_jsx(FormikInput["a" /* FormikInput */], {
      type: "text",
      name: "partnerId",
      label: Object(i18n["h" /* t */])('booking.summary.cielPopIn.collectivityID'),
      validate: CIEL_VALIDATOR
    })), PromoCodeModal_jsx("div", {
      className: "mt-10"
    }, PromoCodeModal_jsx(FormikInput["a" /* FormikInput */], {
      type: "text",
      name: "accessCode",
      label: Object(i18n["h" /* t */])('booking.summary.cielPopIn.password'),
      validate: CIEL_VALIDATOR
    })), PromoCodeModal_jsx(Button["a" /* Button */], {
      className: "mt-20",
      "data-testid": "PromoCodeModal-submit",
      isDisabled: !formik.isValid,
      onClick: formik.submitForm
    }, Object(i18n["h" /* t */])('booking.common.validate')), PromoCodeModal_jsx("div", {
      className: "mt-15 text-14"
    }, Object(i18n["h" /* t */])('booking.summary.cielPopIn.legalInfo')));
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/promo-code/DiscountsLine.jsx
var DiscountsLine = __webpack_require__("CYED");

// CONCATENATED MODULE: ./src/client/components/widgets/promo-code/PromoCode.jsx











var PromoCode_jsx = react_default.a.createElement;
























var CODE_CIEL = 'CMCOLL';
var CODE_CIEL_2 = 'COLLR4';
var PromoCode_PromoCode = function PromoCode(_ref) {
  var proposalId = _ref.proposalId,
      customerId = _ref.customerId,
      discounts = _ref.discounts;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var dispatch = Object(es["d" /* useDispatch */])();
  var context = Object(react["useContext"])(ReactAppContext["a" /* B2CAppContext */]);

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isLogged = _useAuthentication.isLogged;

  var initialDiscounts = discounts === null || discounts === void 0 ? void 0 : discounts.map(function (discount) {
    var _discount$currentProp;

    return (_discount$currentProp = discount.currentProposalCode) === null || _discount$currentProp === void 0 ? void 0 : _discount$currentProp.id;
  }).filter(Boolean);

  var _useState = Object(react["useState"])(null),
      codeCiel = _useState[0],
      setCodeCiel = _useState[1];

  var _useState2 = Object(react["useState"])(null),
      promoCodeStatus = _useState2[0],
      setPromoCodeStatus = _useState2[1];

  var _useState3 = Object(react["useState"])(initialDiscounts),
      vouchers = _useState3[0],
      setVouchers = _useState3[1];

  var _useState4 = Object(react["useState"])(initialDiscounts),
      selectedVouchers = _useState4[0],
      setSelectedVouchers = _useState4[1];

  var formikSetValues = Object(react["useRef"])();
  var shouldDisplayIsUnfolded = isLogged || selectedVouchers.length > 0 || !isLogged && vouchers.length > 0;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: Object(account_queries["p" /* getVouchersQuery */])(),
    queryOptions: {
      cacheFront: {
        key: requestDictionary["F" /* CUSTOMER_ACCOUNT_GET_VOUCHERS */]
      },
      requestName: requestDictionary["F" /* CUSTOMER_ACCOUNT_GET_VOUCHERS */]
    },
    cache: false,
    ignore: !isLogged
  }),
      data = _useGQL.data,
      error = _useGQL.error;

  Object(react["useEffect"])(function () {
    // filter removed discounts from selectedVouchers
    var filteredSelectedVouchers = selectedVouchers.filter(function (voucher) {
      return initialDiscounts.includes(voucher);
    });
    setSelectedVouchers(filteredSelectedVouchers);
  }, [discounts]);
  Object(react["useEffect"])(function () {
    if (data && data.vouchers) {
      var codes = [];
      data.vouchers.forEach(function (voucher) {
        voucher.items.forEach(function (item) {
          if (item.advantageCode) {
            codes.push(item.advantageCode);
          }
        });
      });
      setVouchers(uniq_default()([].concat(Object(toConsumableArray["a" /* default */])(vouchers), codes)));
    }
  }, [data]);
  Object(react["useEffect"])(function () {
    if (vouchers.length > 0) {
      var dicountsValue = discounts.reduce(function (acc, discount) {
        var amount = discount.amount;

        if (amount && amount.value) {
          return acc + amount.value;
        }

        return acc;
      }, 0);
      js_cookie_default.a.set(constants["K" /* VOUCHER_CODE */], JSON.stringify(vouchers));
      js_cookie_default.a.set(constants["L" /* VOUCHER_DISCOUNT */], dicountsValue);
    } else {
      js_cookie_default.a.remove(constants["K" /* VOUCHER_CODE */]);
      js_cookie_default.a.remove(constants["L" /* VOUCHER_DISCOUNT */]);
    }
  }, [vouchers]);
  Object(useGQLErrorsHandler["a" /* useGQLErrorsHandler */])(error, {
    catchAuthError: true
  });

  var applyPromoCode = /*#__PURE__*/function () {
    var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
      var promoCode, partnerId, accessCode, normalizedPromoCode, params, _formikSetValues$curr, errorCode;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              promoCode = _ref2.promoCode, partnerId = _ref2.partnerId, accessCode = _ref2.accessCode;
              normalizedPromoCode = promoCode.toUpperCase();
              params = {
                promoCode: normalizedPromoCode,
                partnerId: partnerId,
                accessCode: accessCode,
                customerId: customerId
              };
              _context.prev = 3;
              setPromoCodeStatus(null);
              _context.next = 7;
              return dispatch(Object(proposals_action["e" /* applyProposalPromoCode */])(proposalId, params, context));

            case 7:
              setPromoCodeStatus('SUCCESS');
              trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_SUMMARY, {
                detail_click: 'validate_promotional_code'
              });
              setSelectedVouchers([].concat(Object(toConsumableArray["a" /* default */])(selectedVouchers), [normalizedPromoCode]));

              if (vouchers && !vouchers.includes(normalizedPromoCode)) {
                setVouchers([].concat(Object(toConsumableArray["a" /* default */])(vouchers), [normalizedPromoCode]));
              }

              (_formikSetValues$curr = formikSetValues.current) === null || _formikSetValues$curr === void 0 ? void 0 : _formikSetValues$curr.call(formikSetValues, {
                isUnfolded: false,
                promoCode: null
              }, false);
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              errorCode = get_default()(_context.t0, 'errors[0].errorCode');
              setPromoCodeStatus(errorCode);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 14]]);
    }));

    return function applyPromoCode(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var removePromoCode = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4) {
      var promoCode, normalizedPromoCode, params, errorCode;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              promoCode = _ref4.promoCode;
              normalizedPromoCode = promoCode.toUpperCase();
              params = {
                promoCode: normalizedPromoCode,
                customerId: customerId
              };
              _context2.prev = 3;
              setPromoCodeStatus(null);
              _context2.next = 7;
              return dispatch(Object(proposals_action["t" /* removeProposalPromoCode */])(proposalId, params, context));

            case 7:
              setSelectedVouchers(selectedVouchers.filter(function (v) {
                return v !== normalizedPromoCode;
              }));
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              errorCode = get_default()(_context2.t0, 'errors[0].errorCode');
              setPromoCodeStatus(errorCode);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 10]]);
    }));

    return function removePromoCode(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  return PromoCode_jsx("div", {
    "data-testid": "PromoCode"
  }, PromoCode_jsx("div", {
    className: "rounded-12 bg-pearl p-20"
  }, PromoCode_jsx("div", {
    className: "flex items-center gap-10 md:gap-20"
  }, PromoCode_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PROMO_CODE,
    width: "1.875rem"
  }), isLogged ? Object(i18n["h" /* t */])('booking.priceDetails.promoCode.enableOrMoreLabel') : Object(i18n["h" /* t */])('booking.priceDetails.promoCode.enableLabel')), vouchers && vouchers.length > 0 && PromoCode_jsx("div", {
    "data-testid": "PromoCode-vouchers",
    className: "my-10 grid w-full gap-10 md:flex md:flex-wrap"
  }, vouchers.map(function (voucher) {
    return PromoCode_jsx(Button["a" /* Button */], {
      key: voucher,
      colorBg: selectedVouchers.includes(voucher) ? colors["a" /* COLORS */].BLACK : colors["a" /* COLORS */].WHITE,
      color: selectedVouchers.includes(voucher) ? colors["a" /* COLORS */].WHITE : colors["a" /* COLORS */].BLACK,
      colorBorder: colors["a" /* COLORS */].BLACK,
      iconRight: selectedVouchers.includes(voucher) ? {
        name: icons["a" /* ICONS */].CROSS
      } : null,
      minWidth: "auto",
      onClick: function onClick() {
        if (selectedVouchers.includes(voucher)) {
          removePromoCode({
            promoCode: voucher
          });
        } else {
          applyPromoCode({
            promoCode: voucher
          });
        }
      }
    }, voucher);
  })), PromoCode_jsx(DiscountsLine["a" /* DiscountsLine */], {
    discounts: discounts
  }), PromoCode_jsx(formik_esm["d" /* Formik */], {
    validateOnBlur: true,
    initialValues: {
      isUnfolded: !isLogged && selectedVouchers.length === 0 && vouchers.length === 0,
      promoCode: null
    },
    onSubmit: function onSubmit(_ref6, _ref7) {
      var promoCode = _ref6.promoCode;
      var setValues = _ref7.setValues;
      formikSetValues.current = setValues;

      if (promoCode.toUpperCase() === CODE_CIEL || promoCode.toUpperCase() === CODE_CIEL_2) {
        return setCodeCiel(promoCode);
      }

      applyPromoCode({
        promoCode: promoCode,
        setValues: setValues
      });
    }
  }, PromoCode_jsx(PromoCodeForm_PromoCodeForm, {
    selectedVouchers: selectedVouchers,
    shouldDisplayIsUnfolded: shouldDisplayIsUnfolded,
    promoCodeStatus: promoCodeStatus,
    setPromoCodeStatus: setPromoCodeStatus
  }))), codeCiel && PromoCode_jsx(PromoCodeModal_PromoCodeModal, {
    codeCiel: codeCiel,
    customerId: customerId,
    setCodeCiel: setCodeCiel,
    applyPromoCode: applyPromoCode
  }));
};

/***/ }),

/***/ "mFNI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("nXZ9");

var utils = __webpack_require__("EmIl");
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),

/***/ "mWK7":
/***/ (function(module, exports, __webpack_require__) {

var ms = __webpack_require__("W7RI");

module.exports = function (time) {
  var timestamp = Math.floor(Date.now() / 1000);

  if (typeof time === 'string') {
    var milliseconds = ms(time);
    if (typeof milliseconds === 'undefined') {
      return;
    }
    return Math.floor(timestamp + milliseconds / 1000);
  } else if (typeof time === 'number' ) {
    return timestamp + time;
  } else {
    return;
  }

};

/***/ }),

/***/ "mYZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransferBulletPoints; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("VHif");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var TransferBulletPoints = function TransferBulletPoints(_ref) {
  var title = _ref.title,
      bulletPoints = _ref.bulletPoints;
  var filteredBulletPoints = bulletPoints.map(function (bulletPoint) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])(bulletPoint);
  }) // this filter is keep only translated bullet points and non null
  .filter(function (bulletPoint, index) {
    return bulletPoint !== bulletPoints[index] && bulletPoint !== '';
  });
  return __jsx("div", {
    "data-testid": "TransferBulletPoints",
    className: "h-full rounded-16 border-1 border-lightGrey bg-white p-20"
  }, __jsx("div", {
    "data-testid": "TransferBulletPoints-icon",
    className: "flex items-start gap-20"
  }, __jsx(_components_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__[/* Badge */ "a"], {
    className: "size-48 border-lightSand bg-lightSand text-black",
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CAR,
    iconSize: "24px",
    variant: "pill"
  }), __jsx("div", {
    className: "text-start text-16 leading-normal"
  }, __jsx("p", {
    className: "mb-8 font-semibold"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])(title)), __jsx("ul", {
    className: "list-none"
  }, filteredBulletPoints === null || filteredBulletPoints === void 0 ? void 0 : filteredBulletPoints.map(function (bulletPointSingleInfo, index) {
    return __jsx("li", {
      className: "list-disc",
      key: "TransferBulletPoints-".concat(index * 1)
    }, bulletPointSingleInfo);
  })))));
};

/***/ }),

/***/ "nT1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadDurationValidity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isBookingOptionEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return doesDepartureDateAllowBookingOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMinimumBookingOptionMinDeltaBeforeDepartureDate; });
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ldK3");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("L7OA");






var loadDurationValidity = function loadDurationValidity(appContext) {
  var query = "\n    query {\n      locale {\n        optionValidity {\n          minDeltaBeforeDepartureDate\n          duration\n        }\n      }\n    }\n  ";
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* PROPOSAL_OPTION_VALIDITY */ "Tc"]
  });
};
var isBookingOptionEnabled = function isBookingOptionEnabled(appContext) {
  return Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_5__[/* isFeatureFlipped */ "a"])(appContext)('booking.option');
};
var doesDepartureDateAllowBookingOption = function doesDepartureDateAllowBookingOption(departureDate, minDeltaBeforeDepartureDate) {
  var todayM = moment__WEBPACK_IMPORTED_MODULE_3___default()().format(_date_apiDate__WEBPACK_IMPORTED_MODULE_4__[/* API_DATE_FORMAT */ "a"]);
  var departureDateM = moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate, _date_apiDate__WEBPACK_IMPORTED_MODULE_4__[/* API_DATE_FORMAT */ "a"]);
  var diff = departureDateM.diff(todayM, 'days');
  return diff >= minDeltaBeforeDepartureDate;
};
var getMinimumBookingOptionMinDeltaBeforeDepartureDate = function getMinimumBookingOptionMinDeltaBeforeDepartureDate(optionValidityDuration) {
  return optionValidityDuration.reduce(function (prev, _ref) {
    var minDeltaBeforeDepartureDate = _ref.minDeltaBeforeDepartureDate;
    return prev === -1 || minDeltaBeforeDepartureDate < prev ? minDeltaBeforeDepartureDate : prev;
  }, -1);
};

/***/ }),

/***/ "nWHK":
/***/ (function(module, exports, __webpack_require__) {

var JsonWebTokenError = __webpack_require__("hXSc");

var NotBeforeError = function (message, date) {
  JsonWebTokenError.call(this, message);
  this.name = 'NotBeforeError';
  this.date = date;
};

NotBeforeError.prototype = Object.create(JsonWebTokenError.prototype);

NotBeforeError.prototype.constructor = NotBeforeError;

module.exports = NotBeforeError;

/***/ }),

/***/ "nXZ9":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(4).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "nYca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__("5zYZ");
exports.sha224 = __webpack_require__("rm/1");
exports.sha256 = __webpack_require__("auLa");
exports.sha384 = __webpack_require__("tB8f");
exports.sha512 = __webpack_require__("iglS");


/***/ }),

/***/ "nmQK":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("KLyV").Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "nnjZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = __webpack_require__("VYiD").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ "o8kQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ctaActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaidService; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("i3Ve");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;











var ctaActionTypes = {
  add: 'add',
  remove: 'remove',
  disabled: 'disabled',
  included: 'included',
  none: 'none'
};

var AddRemoveButton = function AddRemoveButton(_ref) {
  var isAdd = _ref.isAdd,
      price = _ref.price,
      ctaLabel = _ref.ctaLabel,
      _ref$prestation = _ref.prestation,
      prestation = _ref$prestation === void 0 ? '' : _ref$prestation,
      _ref$dataSelector = _ref.dataSelector,
      dataSelector = _ref$dataSelector === void 0 ? '' : _ref$dataSelector,
      _ref$ctaType = _ref.ctaType,
      ctaType = _ref$ctaType === void 0 ? '' : _ref$ctaType,
      isLoading = _ref.isLoading,
      getTrackingData = _ref.getTrackingData,
      handleClick = _ref.handleClick,
      isColumn = _ref.isColumn;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_7__[/* useTracking */ "a"])();
  var buttonAction = isAdd ? ctaActionTypes.add : ctaActionTypes.remove;
  var label = price ? "".concat(ctaLabel, " ").concat(prestation, " ").concat(price) : ctaLabel;
  return __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_8__[/* Button */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__[/* classnames */ "a"])('w-full', {
      'sm:w-auto': !isColumn
    }),
    color: isAdd ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLACK : _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLACK,
    colorBg: isAdd ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].SAFFRON : _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].TRANSPARENT,
    colorBorder: isAdd ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].SAFFRON : _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLACK,
    "data-selector": "".concat(dataSelector, "-").concat(ctaType),
    isDisabled: ctaType === 'disabled',
    isLoading: isLoading,
    onClick: function onClick() {
      handleClick(buttonAction);

      if (getTrackingData) {
        track(getTrackingData(buttonAction));
      }
    }
  }, label);
};

var ButtonRenderer = function ButtonRenderer(_ref2) {
  var ctaType = _ref2.ctaType,
      ctaButton = _ref2.ctaButton,
      includedLabel = _ref2.includedLabel,
      addLabel = _ref2.addLabel,
      removeLabel = _ref2.removeLabel,
      price = _ref2.price,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_ref2, ["ctaType", "ctaButton", "includedLabel", "addLabel", "removeLabel", "price"]);

  if (ctaButton) {
    return ctaButton;
  }

  switch (ctaType) {
    case ctaActionTypes.add:
    case ctaActionTypes.disabled:
      return __jsx(AddRemoveButton, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
        isAdd: true,
        ctaType: ctaType,
        ctaLabel: addLabel,
        price: price ? "+".concat(price) : ''
      }, props));

    case ctaActionTypes.remove:
      return __jsx(AddRemoveButton, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
        ctaType: ctaType,
        ctaLabel: removeLabel,
        price: price ? "-".concat(price) : ''
      }, props));

    case ctaActionTypes.included:
      return __jsx("span", {
        className: "font-brand text-18 text-saffron"
      }, includedLabel);

    default:
      return null;
  }
};

var PaidService = function PaidService(_ref3) {
  var className = _ref3.className,
      _ref3$ctaButton = _ref3.ctaButton,
      ctaButton = _ref3$ctaButton === void 0 ? '' : _ref3$ctaButton,
      _ref3$headColor = _ref3.headColor,
      headColor = _ref3$headColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].SIENNA : _ref3$headColor,
      _ref3$icon = _ref3.icon,
      icon = _ref3$icon === void 0 ? null : _ref3$icon,
      _ref3$imageUrl = _ref3.imageUrl,
      imageUrl = _ref3$imageUrl === void 0 ? '' : _ref3$imageUrl,
      _ref3$isColumn = _ref3.isColumn,
      isColumn = _ref3$isColumn === void 0 ? false : _ref3$isColumn,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? '' : _ref3$label,
      _ref3$reassurance = _ref3.reassurance,
      reassurance = _ref3$reassurance === void 0 ? '' : _ref3$reassurance,
      _ref3$text = _ref3.text,
      text = _ref3$text === void 0 ? '' : _ref3$text,
      _ref3$tooltip = _ref3.tooltip,
      tooltip = _ref3$tooltip === void 0 ? '' : _ref3$tooltip,
      trackOpenTooltip = _ref3.trackOpenTooltip,
      _ref3$getTrackingData = _ref3.getTrackingData,
      getTrackingData = _ref3$getTrackingData === void 0 ? '' : _ref3$getTrackingData,
      _ref3$dataSelector = _ref3.dataSelector,
      dataSelector = _ref3$dataSelector === void 0 ? 'PaidService' : _ref3$dataSelector,
      _ref3$prestation = _ref3.prestation,
      prestation = _ref3$prestation === void 0 ? '' : _ref3$prestation,
      _ref3$removeLabel = _ref3.removeLabel,
      removeLabel = _ref3$removeLabel === void 0 ? '' : _ref3$removeLabel,
      _ref3$addLabel = _ref3.addLabel,
      addLabel = _ref3$addLabel === void 0 ? '' : _ref3$addLabel,
      _ref3$price = _ref3.price,
      price = _ref3$price === void 0 ? '' : _ref3$price,
      _ref3$includedLabel = _ref3.includedLabel,
      includedLabel = _ref3$includedLabel === void 0 ? '' : _ref3$includedLabel,
      _ref3$ctaType = _ref3.ctaType,
      ctaType = _ref3$ctaType === void 0 ? ctaActionTypes.none : _ref3$ctaType,
      onClick = _ref3.onClick;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    if (isLoading) {
      setIsLoading(false);
    }
  }, [ctaType]);

  var handleClick = function handleClick(buttonAction) {
    setIsLoading(true);
    onClick && onClick(buttonAction);
  };

  return __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_9__[/* Capsule */ "a"], {
    className: className,
    header: "none"
  }, __jsx("div", {
    className: "isolate flex-wrap sm:flex",
    "data-testid": "PaidService"
  }, !!imageUrl && !isColumn && __jsx("div", {
    className: "sm:w-2/5"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_11__[/* Image */ "a"], {
    className: "relative h-full",
    classNameImg: "md:absolute",
    imageUrl: imageUrl,
    dimensions: {
      w: 600,
      h: 428
    },
    transformation: "resize"
  })), __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__[/* classnames */ "a"])('p-20', {
      'sm:w-3/5': !!imageUrl && !isColumn
    })
  }, __jsx("div", {
    className: "mb-20 flex items-center gap-10 font-brand text-18 font-bold"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_10__[/* Icon */ "a"], {
    className: "shrink-0 text-".concat(headColor),
    name: icon,
    width: "2.125rem"
  }), __jsx("div", {
    className: "leading-tight text-".concat(headColor),
    "data-testid": "PaidService-label"
  }, label), !!tooltip && __jsx(_frameworks_tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_13__[/* Tooltip */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, tooltip, {
    renderTrigger: function renderTrigger(toggle) {
      return __jsx("button", {
        className: "ms-10 leading-0 text-saffron",
        "data-selector": tooltip.dataSelector,
        onClick: function onClick() {
          trackOpenTooltip && trackOpenTooltip();
          toggle();
        },
        type: "button"
      }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_10__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].INFORMATION,
        width: "1.25rem"
      }));
    }
  }))), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "a"], {
    text: text
  }), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "a"], {
    className: "mt-10",
    text: reassurance,
    theme: "text-sans-n2"
  })), __jsx("div", {
    className: "border-t-1 p-20 sm:w-full"
  }, __jsx(ButtonRenderer, {
    ctaButton: ctaButton,
    ctaType: ctaType,
    includedLabel: includedLabel,
    price: price,
    addLabel: addLabel,
    removeLabel: removeLabel,
    prestation: prestation,
    dataSelector: dataSelector,
    isLoading: isLoading,
    getTrackingData: getTrackingData,
    handleClick: handleClick,
    isColumn: isColumn
  }))));
};

/***/ }),

/***/ "oGbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reassurance; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("C/y5");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;




var Reassurance = function Reassurance(_ref) {
  var className = _ref.className,
      i18n = _ref.i18n;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__[/* classnames */ "a"])('flex flex-col items-center', className)
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].PADLOCK,
    width: "3rem"
  }), __jsx("div", {
    className: "my-10 font-bold text-black"
  }, i18n.booking.banking.reassurance.paymentReassuranceSentence), __jsx("p", {
    className: "text-center text-black"
  }, i18n.booking.banking.reassurance.paymentReassuranceSentenceSubtitle), __jsx("div", {
    className: "flex justify-center"
  }, i18n.booking.banking.reassurance.paymentReassuranceLogos.map(function (logo) {
    return __jsx("img", {
      alt: "",
      className: "m-10 block h-80",
      key: logo,
      src: logo
    });
  })));
};

/***/ }),

/***/ "oJjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return paymentRedirectMutation; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);





var buildBillingDetailsQueryParams = function buildBillingDetailsQueryParams(billingDetails) {
  if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(billingDetails)) {
    return '';
  }

  var email = billingDetails.email,
      mobilePhone = billingDetails.mobilePhone,
      firstName = billingDetails.firstName,
      lastName = billingDetails.lastName,
      streetNumber = billingDetails.streetNumber,
      streetName = billingDetails.streetName,
      city = billingDetails.city,
      zipCode = billingDetails.zipCode,
      stateOrDistrict = billingDetails.stateOrDistrict,
      countryCode = billingDetails.countryCode;
  return "billingDetails: {\n    ".concat(email ? "email: \"".concat(email, "\"") : '', "\n    ").concat(mobilePhone ? "mobile_phone: \"".concat(mobilePhone, "\"") : '', "\n    first_name: \"").concat(firstName || '', "\",\n    last_name: \"").concat(lastName || '', "\",\n    address1: \"").concat(streetNumber || '', " ").concat(streetName || '', "\",\n    locality: \"").concat(city || '', "\",\n    postal_code: \"").concat(zipCode || '', "\",\n    administrative_area: \"").concat(stateOrDistrict || '', "\",\n    country_code: \"").concat(countryCode || '', "\",\n  }");
};

function paymentRedirectMutation(params) {
  var paymentConditionId = params.paymentConditionId ? "paymentConditionId: \"".concat(params.paymentConditionId, "\"") : '';
  var token = params.token ? "token: \"".concat(params.token, "\"") : '';
  var browserInfo = params.browserInfo ? "browserInfo: \"".concat(params.browserInfo, "\"") : '';
  var donationAmount = params.donationAmount ? "donationAmount: ".concat(params.donationAmount) : '';
  var billingDetails = buildBillingDetailsQueryParams(params.billingDetails);
  var callReference = params.callReference ? "callReference: \"".concat(params === null || params === void 0 ? void 0 : params.callReference, "\"") : '';
  var contactID = params.contactID ? "contactID: \"".concat(params === null || params === void 0 ? void 0 : params.contactID, "\"") : '';
  var customerId = params.customerId ? "customerId: \"".concat(params === null || params === void 0 ? void 0 : params.customerId, "\"") : '';
  var device = params.device ? "device: \"".concat(params.device, "\"") : '';
  var bookingId = params.bookingId ? "bookingId: \"".concat(params === null || params === void 0 ? void 0 : params.bookingId, "\"") : '';
  var proposalId = params.proposalId ? "proposalId: \"".concat(params === null || params === void 0 ? void 0 : params.proposalId, "\"") : '';
  var comments = params.comments ? "comments: \"".concat(params === null || params === void 0 ? void 0 : params.comments, "\"") : '';
  var salesmanCode = params.salesmanCode ? "salesmanCode: \"".concat(params.salesmanCode, "\"") : '';
  var salesNetworkId = params.salesNetworkId ? "salesNetworkId: \"".concat(params.salesNetworkId, "\"") : '';
  var cxoOpportunityGuid = params.cxoOpportunityGuid ? "cxoOpportunityGuid: \"".concat(params.cxoOpportunityGuid, "\"") : '';
  return "\n    mutation {\n      paymentRedirect(\n        callbackUrl: \"".concat(params.callbackUrl, "\"\n        callbackUrlSeller: \"").concat(params.callbackUrlSeller, "\"\n        cancelUrl: \"").concat(params.cancelUrl, "\"\n        currency: \"").concat(params.currency, "\"\n        iframeCallbackUrl: \"").concat(params.iframeCallbackUrl, "\"\n        isIframePayment: ").concat((params.isIframe || false).toString(), "\n        price: ").concat(params.price, "\n        providerId: \"").concat(params.providerId, "\"\n        action: \"").concat(params.action, "\"\n        shouldSkipPayment: ").concat(String(!!params.shouldSkipPayment), "\n        ").concat(device, "\n        ").concat(donationAmount, "\n        ").concat(browserInfo, "\n        ").concat(paymentConditionId, "\n        ").concat(proposalId, "\n        ").concat(token, "\n        ").concat(billingDetails, "\n        ").concat(callReference, "\n        ").concat(contactID, "\n        ").concat(customerId, "\n        ").concat(comments, "\n        ").concat(bookingId, "\n        ").concat(salesmanCode, "\n        ").concat(salesNetworkId, "\n        ").concat(cxoOpportunityGuid, "\n      ) {\n          method\n          url\n          fields\n          bookingId\n          orderId\n          customerId\n          price {\n            value\n          }\n          donationAmount\n        }\n      }");
}



/***/ }),

/***/ "oMl1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BookingBreadcrumb_BookingBreadcrumb; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/criteria/EditMyCriteriaPopin.jsx
var __jsx = react_default.a.createElement;





var EditMyCriteriaPopin_EditMyCriteriaPopin = function EditMyCriteriaPopin(_ref) {
  var onCloseModal = _ref.onCloseModal,
      onClickCancel = _ref.onClickCancel,
      onClickConfirm = _ref.onClickConfirm,
      mainIconName = _ref.mainIconName,
      cancelLabel = _ref.cancelLabel,
      confirmLabel = _ref.confirmLabel,
      titleLabel = _ref.titleLabel,
      messageLabel = _ref.messageLabel,
      _ref$isErrored = _ref.isErrored,
      isErrored = _ref$isErrored === void 0 ? false : _ref$isErrored,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'EditMyCriteriaPopin' : _ref$dataTestId;
  var textColor = isErrored ? 'text-red' : 'text-black';
  return __jsx(Modal["a" /* Modal */], {
    className: "overflow-hidden p-20",
    onClose: onCloseModal,
    size: "small"
  }, __jsx("div", {
    className: "flex flex-col items-center p-30",
    "data-testid": dataTestId
  }, __jsx("div", {
    className: "flex flex-1 pb-10"
  }, __jsx(Icon["a" /* Icon */], {
    className: textColor,
    name: mainIconName,
    width: "5em"
  })), __jsx("div", {
    className: "flex flex-1 pb-10"
  }, __jsx(Text["a" /* Text */], {
    className: "text-20 font-bold ".concat(textColor),
    text: titleLabel
  })), __jsx("div", {
    className: "flex flex-2 pb-10"
  }, __jsx(Text["a" /* Text */], {
    className: "text-center text-12 ".concat(textColor),
    text: messageLabel
  })), __jsx("div", {
    className: "flex w-full flex-1 justify-evenly"
  }, !!onClickCancel && __jsx(Button["a" /* Button */], {
    "data-testid": "modal-criteria-cancel-button",
    onClick: onClickCancel,
    theme: "link"
  }, cancelLabel), __jsx(Button["a" /* Button */], {
    isDisabled: false //add condition to disable validate if necessary towdow
    ,
    "data-testid": "modal-criteria-validation-button",
    onClick: onClickConfirm
  }, confirmLabel))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/step-nav/StepNav.themes.js
var themes = {
  "default": {
    thRoot: 'text-white',
    thList: 'flex items-end leading-0 text-12 sm:text-16',
    thListItem: 'mx-5 sm:mx-10',
    thListButton: 'border-0 border-b-2 border-solid border-transparent leading-0 pb-5 text-current transition-colors duration-250 ease-in',
    thListButtonActive: 'border-white text-28 sm:text-36',
    thListButtonDisabled: 'cursor-default',
    thListButtonVisited: 'text-18 sm:text-24',
    thListIconWidth: '0.9em',
    thButtonLabel: 'sr-only',
    thLabels: 'font-brand font-normal leading-1 mt-5 text-14',
    thActiveNumber: 'text-18 sm:text-20',
    thLabel: 'ms-10 text-18 sm:text-20'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/step-nav/StepNav.jsx


var StepNav_jsx = react_default.a.createElement;




var StepNav_StepNav = function StepNav(_ref) {
  var _ref$activeStep = _ref.activeStep,
      activeStep = _ref$activeStep === void 0 ? 0 : _ref$activeStep,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'progress' : _ref$ariaLabel,
      className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$lastActiveStep = _ref.lastActiveStep,
      lastActiveStep = _ref$lastActiveStep === void 0 ? 0 : _ref$lastActiveStep,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!items.length) {
    return null;
  }

  var _themes$theme = themes[theme],
      thActiveNumber = _themes$theme.thActiveNumber,
      thButtonLabel = _themes$theme.thButtonLabel,
      thLabel = _themes$theme.thLabel,
      thLabels = _themes$theme.thLabels,
      thList = _themes$theme.thList,
      thListButton = _themes$theme.thListButton,
      thListButtonActive = _themes$theme.thListButtonActive,
      thListButtonDisabled = _themes$theme.thListButtonDisabled,
      thListButtonVisited = _themes$theme.thListButtonVisited,
      thListIconWidth = _themes$theme.thListIconWidth,
      thListItem = _themes$theme.thListItem,
      thRoot = _themes$theme.thRoot;
  return StepNav_jsx("nav", {
    "aria-label": ariaLabel,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-testid": "breadcrumb-steps"
  }, StepNav_jsx("ol", {
    className: thList
  }, items.map(function (_ref2, i) {
    var _classnames;

    var iconName = _ref2.iconName,
        id = _ref2.id,
        label = _ref2.label;
    return StepNav_jsx("li", {
      className: thListItem,
      key: id
    }, StepNav_jsx("button", {
      "aria-current": activeStep === i ? 'step' : null,
      className: Object(classnames_utils["a" /* classnames */])(thListButton, (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, thListButtonActive, activeStep === i), Object(defineProperty["a" /* default */])(_classnames, thListButtonVisited, i <= lastActiveStep && activeStep !== i), Object(defineProperty["a" /* default */])(_classnames, thListButtonDisabled, i > lastActiveStep), _classnames)),
      disabled: i > lastActiveStep,
      onClick: function onClick() {
        return _onClick(i);
      },
      type: "button"
    }, StepNav_jsx(Icon["a" /* Icon */], {
      name: iconName,
      width: thListIconWidth
    }), StepNav_jsx("span", {
      className: thButtonLabel
    }, label)));
  })), StepNav_jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])(thLabels)
  }, StepNav_jsx("span", {
    className: thActiveNumber
  }, activeStep + 1), "/", items.length, ' ', StepNav_jsx("span", {
    className: thLabel
  }, items[activeStep].label)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/frameworks/drop-down/DropDown.themes.js
var DropDown_themes = __webpack_require__("Q8Qh");

// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down-simplified/DropDownSimplified.jsx
var DropDownSimplified_jsx = react_default.a.createElement;




var DropDownSimplified_DropDownSimplified = function DropDownSimplified(_ref) {
  var children = _ref.children,
      className = _ref.className,
      renderTrigger = _ref.renderTrigger,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      toggleExpansion = _ref.toggleExpansion,
      hasCloseOnClick = _ref.hasCloseOnClick,
      rootRef = _ref.rootRef,
      onClose = _ref.onClose,
      theme = _ref.theme;
  var contentRef = Object(react["useRef"])(null);
  var thisRootRef = Object(react["useRef"])(null);

  var collapse = function collapse() {
    if (onClose) {
      onClose();
    }
  };

  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === keyCodes["g" /* ESCAPE */]) {
      collapse();
    }
  };

  var onClickOutside = function onClickOutside(e) {
    var _rootRef$current;

    if (!contentRef || // $FlowFixMe
    contentRef.current.contains(e.target) || // $FlowFixMe
    thisRootRef.current.contains(e.target) || // $FlowFixMe
    e.offsetX > e.target.clientWidth || // $FlowFixMe
    e.offsetY > e.target.clientHeight || // $FlowFixMe
    (rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) && (rootRef === null || rootRef === void 0 ? void 0 : (_rootRef$current = rootRef.current) === null || _rootRef$current === void 0 ? void 0 : _rootRef$current.contains(e.target)) || e.button && e.button !== 0) {
      return;
    }

    collapse();
  };

  var removeEventListeners = function removeEventListeners() {
    if (true) {
      document.removeEventListener('mouseup', onClickOutside, false);
      document.removeEventListener('touchstart', onClickOutside, false);
      document.removeEventListener('keydown', onKeyDown, false);
    }
  };

  var addEventListeners = function addEventListeners() {
    if (true) {
      document.addEventListener('mouseup', onClickOutside, false);
      document.addEventListener('touchstart', onClickOutside, false);
      document.addEventListener('keydown', onKeyDown, false);
    }
  };

  Object(react["useEffect"])(function () {
    if (isExpanded) {
      addEventListeners();
    } else {
      removeEventListeners();
    }

    return function () {
      removeEventListeners();
    };
  }, [isExpanded]);
  var thBody = Object(DropDown_themes["a" /* themes */])({})[theme].thBody;
  return DropDownSimplified_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative inline-block', className),
    ref: thisRootRef
  }, renderTrigger && renderTrigger(toggleExpansion, isExpanded), isExpanded && DropDownSimplified_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('absolute left-1/2 z-6 w-500 min-w-full -translate-x-1/2 transform', thBody),
    "data-testid": "DropDown-body-simplified",
    onClick: hasCloseOnClick ? collapse : null,
    onKeyPress: hasCloseOnClick ? collapse : null,
    ref: contentRef,
    role: "button",
    tabIndex: 0
  }, children(toggleExpansion, isExpanded)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down-simplified/CriteriaFieldDropDownWrapper.jsx
var CriteriaFieldDropDownWrapper_jsx = react_default.a.createElement;






function CriteriaFieldDropDownWrapper(_ref) {
  var children = _ref.children,
      renderCriteriaButton = _ref.renderCriteriaButton,
      title = _ref.title,
      cancelEditCriteria = _ref.cancelEditCriteria,
      _ref$openByDefault = _ref.openByDefault,
      openByDefault = _ref$openByDefault === void 0 ? false : _ref$openByDefault,
      toggleEditCriteria = _ref.toggleEditCriteria,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;

  var _useState = Object(react["useState"])(openByDefault),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  Object(react["useEffect"])(function () {
    if (isExpanded !== openByDefault) {
      setIsExpanded(openByDefault);
    }
  }, [openByDefault]);

  var toggleExpanded = function toggleExpanded() {
    toggleEditCriteria && toggleEditCriteria(isExpanded);
    setIsExpanded(!isExpanded);
  };

  var onCancel = function onCancel() {
    cancelEditCriteria && cancelEditCriteria();
    toggleExpanded();
  };

  if (isTablet) {
    return CriteriaFieldDropDownWrapper_jsx(DropDownSimplified_DropDownSimplified, {
      isExpanded: isExpanded,
      onClose: onCancel,
      renderTrigger: renderCriteriaButton,
      toggleExpansion: toggleExpanded,
      theme: "hollow"
    }, children);
  }

  return CriteriaFieldDropDownWrapper_jsx("div", {
    "data-testid": dataTestId
  }, renderCriteriaButton(toggleExpanded, true), isExpanded ? CriteriaFieldDropDownWrapper_jsx(Layer["b" /* Layer */], {
    ariaLabel: title,
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: onCancel
    },
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    className: "z-4",
    hasAnimateEnter: true,
    onClose: onCancel
  }, CriteriaFieldDropDownWrapper_jsx("div", {
    className: "flex flex-col"
  }, children(toggleExpanded, isExpanded))) : null);
}
// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/criteria/EditMyCriteriaFieldWrapper.jsx

var EditMyCriteriaFieldWrapper_jsx = react_default.a.createElement;








var EditMyCriteriaFieldWrapper_EditMyCriteriaFieldWrapper = function EditMyCriteriaFieldWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disableValidateButton = _ref.disableValidateButton,
      toggleEditCriteria = _ref.toggleEditCriteria,
      updateCriteria = _ref.updateCriteria,
      trackCriteriaClick = _ref.trackCriteriaClick,
      cancelEditCriteria = _ref.cancelEditCriteria,
      triggerComponent = _ref.triggerComponent,
      openByDefault = _ref.openByDefault,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var isMobile = !isTablet;
  return EditMyCriteriaFieldWrapper_jsx(CriteriaFieldDropDownWrapper, {
    cancelEditCriteria: cancelEditCriteria,
    toggleEditCriteria: toggleEditCriteria,
    openByDefault: openByDefault,
    renderCriteriaButton: function renderCriteriaButton(toggleButtonCriteriaExpansion, isCriteriaExpanded) {
      return EditMyCriteriaFieldWrapper_jsx("button", {
        "aria-expanded": isCriteriaExpanded,
        className: Object(classnames_utils["a" /* classnames */])('flex h-full items-stretch gap-5', className),
        onClick: function onClick() {
          trackCriteriaClick(); // toggle local state

          toggleButtonCriteriaExpansion();
        },
        type: "button"
      }, triggerComponent, EditMyCriteriaFieldWrapper_jsx(Icon["a" /* Icon */], {
        className: "self-center",
        name: icons["a" /* ICONS */].ARROW_DOWN,
        rotation: isCriteriaExpanded ? 180 : 0,
        width: "1em"
      }));
    },
    title: Object(src_i18n["h" /* t */])('booking.editCriteria.buttonLabel'),
    dataTestId: dataTestId
  }, function (toggleCriteriaExpansion) {
    return EditMyCriteriaFieldWrapper_jsx(react["Fragment"], null, react_default.a.Children.map(children, function (child) {
      if (typeof child.type === 'string') {
        return child;
      }

      return /*#__PURE__*/Object(react["cloneElement"])(children, {
        toggleCriteriaExpansion: toggleCriteriaExpansion
      });
    }), EditMyCriteriaFieldWrapper_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])({
        'fixed bottom-0 mt-auto flex w-full justify-center border-t-1 bg-white p-15 shadow': isMobile,
        'my-20 text-center': !isMobile
      })
    }, EditMyCriteriaFieldWrapper_jsx(Button["a" /* Button */], {
      "data-selector": "EditMyCriteriaDropDown-apply",
      "data-testid": "criteria-validation-button",
      isDisabled: disableValidateButton,
      onClick: function onClick() {
        // toggle criteria
        toggleCriteriaExpansion(); // update criteria value in EditMyCriteria

        updateCriteria && updateCriteria();
      }
    }, Object(src_i18n["h" /* t */])('booking.editCriteria.validateCriteria'))));
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/headerPopins.reducer.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var initialPopinsState = {
  criteriaConfirmation: false,
  noProposalsFound: false
};
var popinsActions = {
  CLOSE_ALL_POPINS: 'CLOSE_ALL_POPINS',
  CRITERIA_CONFIRMATION_OPEN: 'CRITERIA_CONFIRMATION_OPEN',
  CRITERIA_CONFIRMATION_CLOSE: 'CRITERIA_CONFIRMATION_CLOSE',
  NO_PROPOSAL_OPEN: 'NO_PROPOSAL_OPEN',
  NO_PROPOSAL_CLOSE: 'NO_PROPOSAL_CLOSE'
};
var popinsReducer = function popinsReducer(popinsState, action) {
  switch (action.type) {
    case popinsActions.CRITERIA_CONFIRMATION_OPEN:
      return _objectSpread(_objectSpread({}, popinsState), {}, {
        criteriaConfirmation: true
      });

    case popinsActions.CRITERIA_CONFIRMATION_CLOSE:
      return _objectSpread(_objectSpread({}, popinsState), {}, {
        criteriaConfirmation: false
      });

    case popinsActions.NO_PROPOSAL_OPEN:
      return _objectSpread(_objectSpread({}, popinsState), {}, {
        noProposalsFound: true
      });

    case popinsActions.NO_PROPOSAL_CLOSE:
      return _objectSpread(_objectSpread({}, popinsState), {}, {
        noProposalsFound: false
      });

    case popinsActions.CLOSE_ALL_POPINS:
    default:
      return initialPopinsState;
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/CriteriaWithPopOver.jsx








var CriteriaWithPopOver_jsx = react_default.a.createElement;

function CriteriaWithPopOver_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CriteriaWithPopOver_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CriteriaWithPopOver_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CriteriaWithPopOver_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-unstable-nested-components */




var areEqualCriteria = function areEqualCriteria(criteria, newCriteria) {
  var criteriaString = JSON.stringify(criteria, null, 2);
  var newCriteriaString = JSON.stringify(newCriteria, null, 2);
  return criteriaString === newCriteriaString;
};

var CriteriaWithPopOver_CriteriaWithPopOver = function CriteriaWithPopOver(_ref) {
  var SelectorComponent = _ref.selectorComponent,
      PopOverComponent = _ref.popOverComponent,
      BlockBeforeValidateComponent = _ref.blockBeforeValidateComponent,
      selectedProposal = _ref.selectedProposal,
      criteria = _ref.criteria,
      setNewCriteria = _ref.setNewCriteria,
      newCriteria = _ref.newCriteria,
      dispatchPopin = _ref.dispatchPopin,
      onClickTracking = _ref.onClickTracking,
      validateButtonCriteriaSelectorTracking = _ref.validateButtonCriteriaSelectorTracking,
      i18n = _ref.i18n;
  var shouldDisableValidateButton = areEqualCriteria(criteria, newCriteria);

  var PopOverContent = function PopOverContent() {
    // $FlowFixMe
    return CriteriaWithPopOver_jsx(PopOverComponent, {
      criteria: criteria,
      setNewCriteria: setNewCriteria,
      newCriteria: newCriteria,
      i18n: i18n
    });
  };

  return CriteriaWithPopOver_jsx(EditMyCriteriaFieldWrapper_EditMyCriteriaFieldWrapper, {
    toggleEditCriteria: function toggleEditCriteria(isExpanded) {
      !isExpanded && setNewCriteria(CriteriaWithPopOver_objectSpread({}, criteria));
    },
    disableValidateButton: shouldDisableValidateButton,
    trackCriteriaClick: onClickTracking,
    openByDefault: false,
    triggerComponent: CriteriaWithPopOver_jsx(SelectorComponent, {
      newCriteria: newCriteria,
      criteria: criteria,
      selectedProposal: selectedProposal
    }),
    dataTestId: "EditMyCriteriaFieldWrapper",
    updateCriteria: function updateCriteria() {
      !!validateButtonCriteriaSelectorTracking && validateButtonCriteriaSelectorTracking();
      dispatchPopin({
        type: popinsActions.CRITERIA_CONFIRMATION_OPEN
      });
    }
  }, CriteriaWithPopOver_jsx("div", null, CriteriaWithPopOver_jsx(PopOverContent, {
    newCriteria: newCriteria
  }), !!BlockBeforeValidateComponent && CriteriaWithPopOver_jsx(BlockBeforeValidateComponent, null)));
};
// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/HeaderCriteriaDates.jsx
var HeaderCriteriaDates_jsx = react_default.a.createElement;





var HeaderCriteriaDates_HeaderCriteriaDates = function HeaderCriteriaDates(_ref) {
  var selectedProposal = _ref.selectedProposal;
  var CONDENSED_DATE_FORMAT = Object(src_i18n["h" /* t */])('booking.common.condensedDateFormat');
  var dates = {
    endDate: Object(apiDate["g" /* formatApiDate */])(selectedProposal.departureDate, CONDENSED_DATE_FORMAT),
    startDate: Object(apiDate["g" /* formatApiDate */])(selectedProposal.arrivalDate, CONDENSED_DATE_FORMAT)
  };
  return HeaderCriteriaDates_jsx("span", {
    className: "md:max-w-none flex min-w-100 max-w-100 flex-1 items-center justify-center gap-10 rounded-8 border-1 border-solid border-white p-10 text-12 text-white sm:flex-none",
    "data-testid": "edit-my-criteria-when"
  }, HeaderCriteriaDates_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].DATE,
    width: "1.25rem"
  }), HeaderCriteriaDates_jsx("span", {
    className: "block font-bold",
    "data-testid": "HeaderCriteriaDates-dates"
  }, HeaderCriteriaDates_jsx("span", {
    className: "block leading-1"
  }, dates.startDate), HeaderCriteriaDates_jsx("span", {
    className: "block leading-1"
  }, dates.endDate)));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx
var FilterWhen = __webpack_require__("qLhN");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/CriteriaDatesSelectorContent.jsx










var CriteriaDatesSelectorContent_jsx = react_default.a.createElement;

function CriteriaDatesSelectorContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CriteriaDatesSelectorContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CriteriaDatesSelectorContent_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CriteriaDatesSelectorContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var CriteriaDatesSelectorContent_CriteriaDatesSelectorContent = function CriteriaDatesSelectorContent(_ref) {
  var newCriteria = _ref.newCriteria,
      setNewCriteria = _ref.setNewCriteria,
      i18n = _ref.i18n;
  var dateFormat = Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.dateFormat');
  return CriteriaDatesSelectorContent_jsx("div", {
    className: "text-black"
  }, CriteriaDatesSelectorContent_jsx(FilterWhen["a" /* FilterWhen */], {
    openCalendarToDate: newCriteria.departure.date,
    isSubmittable: false,
    optionsDuration: i18n.faceting.when.durations,
    openingDates: newCriteria.search.openingDates,
    duration: newCriteria.departure.duration,
    departureDate: newCriteria.departure.date,
    dateFormat: dateFormat,
    changeDepartureDate: function changeDepartureDate(date) {
      if (date) {
        setNewCriteria(CriteriaDatesSelectorContent_objectSpread(CriteriaDatesSelectorContent_objectSpread({}, newCriteria), {}, {
          departure: {
            date: moment_default()(date),
            duration: null
          }
        }));
      }
    },
    changeTripDuration: function changeTripDuration(duration) {
      if (duration) {
        setNewCriteria(CriteriaDatesSelectorContent_objectSpread(CriteriaDatesSelectorContent_objectSpread({}, newCriteria), {}, {
          departure: CriteriaDatesSelectorContent_objectSpread(CriteriaDatesSelectorContent_objectSpread({}, newCriteria.departure), {}, {
            duration: duration
          })
        }));
      }
    },
    offsetCalendar: newCriteria.search.offsetSell
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/HeaderCriteriaAttendees.jsx
var HeaderCriteriaAttendees_jsx = react_default.a.createElement;



var HeaderCriteriaAttendees_HeaderCriteriaAttendees = function HeaderCriteriaAttendees(_ref) {
  var selectedProposal = _ref.selectedProposal;
  var attendeesNumber = selectedProposal.attendees.adults.length + selectedProposal.attendees.children.length;
  return HeaderCriteriaAttendees_jsx("span", {
    className: "flex min-w-80 max-w-80 flex-1 items-center justify-center gap-10 rounded-8 border-1 border-solid border-white p-10 text-12 leading-1 text-white sm:flex-none md:max-w-none",
    "data-testid": "edit-my-criteria-who"
  }, HeaderCriteriaAttendees_jsx(Icon["a" /* Icon */], {
    width: "1.25rem",
    name: icons["a" /* ICONS */].PEOPLE_DOUBLE
  }), HeaderCriteriaAttendees_jsx("span", {
    className: "font-bold underline",
    "data-testid": "HeaderCriteriaAttendees-attendeesNumber"
  }, attendeesNumber));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/filter-who/FilterWho.jsx + 2 modules
var FilterWho = __webpack_require__("tUgU");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/CriteriaAttendeesSelectorContent.jsx










var CriteriaAttendeesSelectorContent_jsx = react_default.a.createElement;

function CriteriaAttendeesSelectorContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CriteriaAttendeesSelectorContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CriteriaAttendeesSelectorContent_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CriteriaAttendeesSelectorContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var CriteriaAttendeesSelectorContent_CriteriaAttendeesSelectorContent = function CriteriaAttendeesSelectorContent(_ref) {
  var _newCriteria$attendee;

  var newCriteria = _ref.newCriteria,
      setNewCriteria = _ref.setNewCriteria;
  var dateFormat = Object(src_i18n["h" /* t */])('booking.form.dateFormat');
  var dayPlaceholder = Object(src_i18n["h" /* t */])('booking.form.dayPlaceholder');
  var monthPlaceholder = Object(src_i18n["h" /* t */])('booking.form.monthPlaceholder');
  var yearPlaceholder = Object(src_i18n["h" /* t */])('booking.form.yearPlaceholder');
  return CriteriaAttendeesSelectorContent_jsx("div", {
    className: "text-black"
  }, CriteriaAttendeesSelectorContent_jsx(FilterWho["a" /* FilterWho */], {
    addChildcareLabel: Object(src_i18n["h" /* t */])('faceting.who.addChildcare'),
    adultsLabel: Object(src_i18n["h" /* t */])('faceting.who.adults'),
    adultsNumber: newCriteria === null || newCriteria === void 0 ? void 0 : (_newCriteria$attendee = newCriteria.attendees) === null || _newCriteria$attendee === void 0 ? void 0 : _newCriteria$attendee.adults,
    changeKid: function changeKid(kidNumber, newKid) {
      var _newCriteria$attendee2;

      var newCriteriakidsWithUpdatedKid = newCriteria === null || newCriteria === void 0 ? void 0 : (_newCriteria$attendee2 = newCriteria.attendees) === null || _newCriteria$attendee2 === void 0 ? void 0 : _newCriteria$attendee2.kids.map(function (kid, idx) {
        return kidNumber === idx ? CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newKid), newKid.birthdate && !Object(dateUtils["f" /* isAdult */])(newKid.birthdate) ? {
          status: validationStates["b" /* IS_VALID */]
        } : {}), newKid.birthdate ? {
          birthdate: Object(apiDate["n" /* timestampToApiDate */])(newKid.birthdate)
        } : {}) : kid;
      });

      var newCriteriaUpdated = CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria), {}, {
        attendees: CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees), {}, {
          kids: newCriteriakidsWithUpdatedKid
        })
      }); // $FlowFixMe


      setNewCriteria(newCriteriaUpdated);
    },
    changeKidsNumber: function changeKidsNumber(newKidNumber) {
      var _newCriteria$attendee3, _Array$fill;

      var criteriaKids = newCriteria === null || newCriteria === void 0 ? void 0 : (_newCriteria$attendee3 = newCriteria.attendees) === null || _newCriteria$attendee3 === void 0 ? void 0 : _newCriteria$attendee3.kids;
      var newKids = (_Array$fill = new Array(newKidNumber).fill({
        status: validationStates["a" /* IS_INVALID */],
        childcareIncluded: false
      })) === null || _Array$fill === void 0 ? void 0 : _Array$fill.map(function (kid, index) {
        return CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, kid), criteriaKids[index]);
      }); // $FlowFixMe

      setNewCriteria(CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria), {}, {
        attendees: CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees), {}, {
          kids: newKids
        })
      }));
    },
    dateFormat: dateFormat,
    dayPlaceholder: dayPlaceholder,
    kids: (newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees.kids) || [],
    kidsAgeLabel: Object(src_i18n["h" /* t */])('faceting.who.ageSectionSubtitle'),
    kidsAgeLimitLabel: Object(src_i18n["h" /* t */])('faceting.who.kidsAgeLimit'),
    kidsLabel: Object(src_i18n["h" /* t */])('faceting.who.kids'),
    kidsValidationState: newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees.kids.map(function (_ref2) {
      var status = _ref2.status;
      return status;
    }),
    label: Object(src_i18n["h" /* t */])('faceting.who.subTitle'),
    minAdultsNumber: faceting_constants["b" /* ADULTS_NUMBER_MIN */],
    monthPlaceholder: monthPlaceholder,
    setAdultsNumber: function setAdultsNumber(newAdultNumber) {
      // $FlowFixMe
      setNewCriteria(CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria), {}, {
        attendees: CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, newCriteria === null || newCriteria === void 0 ? void 0 : newCriteria.attendees), {}, {
          adults: newAdultNumber
        })
      }));
    },
    updateOnInvalidBirthDate: true,
    validateKidsBirthdate: function validateKidsBirthdate(kidIdx) {
      newCriteria.attendees.kids.map(function (kid, index) {
        return index === kidIdx ? CriteriaAttendeesSelectorContent_objectSpread(CriteriaAttendeesSelectorContent_objectSpread({}, kid), {}, {
          status: validationStates["a" /* IS_INVALID */]
        }) : kid;
      });
    },
    yearPlaceholder: yearPlaceholder
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/HeaderCriteriaTransport.jsx





var HeaderCriteriaTransport_jsx = react_default.a.createElement;






var HeaderCriteriaTransport_HeaderCriteriaTransport = function HeaderCriteriaTransport(_ref) {
  var _criteria$departureCi;

  var criteria = _ref.criteria;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var transportValue = criteria === null || criteria === void 0 ? void 0 : (_criteria$departureCi = criteria.departureCity) === null || _criteria$departureCi === void 0 ? void 0 : _criteria$departureCi.value;

  var _useState = Object(react["useState"])([]),
      departureCitiesByProductId = _useState[0],
      setDepartureCitiesByProductId = _useState[1];

  Object(react["useEffect"])(function () {
    // this is to get the translated version of the departure city
    Object(BookingPagesUtils["h" /* getBookingCriteriaDepartureCities */])(criteria.search.value, appContext).then(function (_ref2) {
      var departureCities = _ref2.bookingCriteria.departureCities;
      var formattedDepartureCities = departureCities.map(function (_ref3) {
        var name = _ref3.name,
            value = _ref3.value;
        return {
          label: name,
          value: value
        };
      });
      setDepartureCitiesByProductId(formattedDepartureCities);
    });
  }, []);
  var selectedDepartureCity = Object(react["useMemo"])(function () {
    return departureCitiesByProductId.find(function (_ref4) {
      var value = _ref4.value;
      return value === transportValue;
    });
  }, [transportValue, departureCitiesByProductId]);
  return HeaderCriteriaTransport_jsx("div", {
    className: "flex min-w-80 max-w-80 flex-1 items-center justify-center gap-10 rounded-8 border-1 border-solid border-white p-10 text-14 leading-1 text-white sm:flex-none md:max-w-none",
    "data-testid": "edit-my-criteria-transport"
  }, HeaderCriteriaTransport_jsx(Icon["a" /* Icon */], {
    width: "1.25rem",
    name: transportValue !== 'NO' ? icons["a" /* ICONS */].TRANSPORT : icons["a" /* ICONS */].NO_TRANSPORT
  }), HeaderCriteriaTransport_jsx("span", {
    className: "hidden sm:block"
  }, (selectedDepartureCity === null || selectedDepartureCity === void 0 ? void 0 : selectedDepartureCity.label) || Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.noTransport')));
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/filter-transport/FilterTransport.jsx
var FilterTransport = __webpack_require__("M3jp");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/edit-criteria-header/CriteriaTransportsSelectorContent.jsx













var CriteriaTransportsSelectorContent_jsx = react_default.a.createElement;

function CriteriaTransportsSelectorContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CriteriaTransportsSelectorContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CriteriaTransportsSelectorContent_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CriteriaTransportsSelectorContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var CriteriaTransportsSelectorContent_CriteriaTransportsSelectorContent = function CriteriaTransportsSelectorContent(_ref) {
  var _newCriteria$departur;

  var newCriteria = _ref.newCriteria,
      setNewCriteria = _ref.setNewCriteria;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var noDepartureCitiesOptions = [{
    label: Object(src_i18n["h" /* t */])('booking.priceCalendar.priceStatus.noFlight'),
    value: ''
  }];

  var _useState = Object(react["useState"])([]),
      departureCitiesByProductId = _useState[0],
      setDepartureCitiesByProductId = _useState[1];

  Object(react["useEffect"])(function () {
    if (departureCitiesByProductId.length === 0) {
      Object(BookingPagesUtils["h" /* getBookingCriteriaDepartureCities */])(newCriteria.search.value, appContext).then(function (_ref2) {
        var departureCities = _ref2.bookingCriteria.departureCities;
        var formattedDepartureCities = departureCities.map(function (_ref3) {
          var name = _ref3.name,
              value = _ref3.value;
          return {
            label: name,
            value: value
          };
        });
        setDepartureCitiesByProductId(formattedDepartureCities);
      });
    }
  }, []);
  return CriteriaTransportsSelectorContent_jsx("div", {
    className: "text-black"
  }, CriteriaTransportsSelectorContent_jsx(FilterTransport["a" /* FilterTransport */], {
    changeDepartureCity: function changeDepartureCity(newDepartureCityId) {
      var newDepartureCity = (departureCitiesByProductId === null || departureCitiesByProductId === void 0 ? void 0 : departureCitiesByProductId.find(function (_ref4) {
        var value = _ref4.value;
        return value === newDepartureCityId;
      })) || {
        label: 'no transport',
        value: 'no'
      };
      !!newDepartureCity && setNewCriteria(CriteriaTransportsSelectorContent_objectSpread(CriteriaTransportsSelectorContent_objectSpread({}, newCriteria), {}, {
        departureCity: newDepartureCity
      }));
    },
    className: "h-full",
    dataTestId: "TransportCriteria-input",
    departureCity: (newCriteria === null || newCriteria === void 0 ? void 0 : (_newCriteria$departur = newCriteria.departureCity) === null || _newCriteria$departur === void 0 ? void 0 : _newCriteria$departur.value) || 'NO',
    isDisabled: !departureCitiesByProductId.length,
    labelDepartingFrom: Object(src_i18n["h" /* t */])('faceting.transport.departingFrom'),
    optionsDepartureCities: departureCitiesByProductId.length > 0 ? departureCitiesByProductId : noDepartureCitiesOptions,
    placeholderFrom: Object(src_i18n["h" /* t */])('faceting.transport.titleFrom'),
    selectPlaceholder: Object(src_i18n["h" /* t */])('faceting.transport.selectPlaceholder'),
    validateDepartureCity: function validateDepartureCity(noDepartureCityId) {
      var noDepartureCity = {
        value: noDepartureCityId || 'NO',
        label: ''
      };
      setNewCriteria(CriteriaTransportsSelectorContent_objectSpread(CriteriaTransportsSelectorContent_objectSpread({}, newCriteria), {}, {
        departureCity: noDepartureCity
      }));
    },
    shouldShowNoTransportButtonMobile: false,
    withNoTransport: true
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 2 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors = __webpack_require__("wNDy");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/EditCriteria.utils.js














function EditCriteria_utils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function EditCriteria_utils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? EditCriteria_utils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EditCriteria_utils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var EditCriteria_utils_getCriteriaFromProposal = function getCriteriaFromProposal(_ref) {
  var _proposal$transports, _proposal$transports$, _proposal$transports$2, _proposal$transports$3, _proposal$transports$4, _proposal$transports2, _proposal$transports3, _proposal$transports4, _proposal$transports5, _proposal$transports6, _resort$destination;

  var resort = _ref.resort,
      proposal = _ref.proposal,
      appContext = _ref.appContext;
  var departureCityId = ((_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : (_proposal$transports$ = _proposal$transports.inbound) === null || _proposal$transports$ === void 0 ? void 0 : (_proposal$transports$2 = _proposal$transports$.travelSections) === null || _proposal$transports$2 === void 0 ? void 0 : (_proposal$transports$3 = _proposal$transports$2[0]) === null || _proposal$transports$3 === void 0 ? void 0 : (_proposal$transports$4 = _proposal$transports$3.departure) === null || _proposal$transports$4 === void 0 ? void 0 : _proposal$transports$4.cityId) || 'NO';
  var departureCityLabel = (_proposal$transports2 = proposal.transports) === null || _proposal$transports2 === void 0 ? void 0 : (_proposal$transports3 = _proposal$transports2.inbound) === null || _proposal$transports3 === void 0 ? void 0 : (_proposal$transports4 = _proposal$transports3.travelSections) === null || _proposal$transports4 === void 0 ? void 0 : (_proposal$transports5 = _proposal$transports4[0]) === null || _proposal$transports5 === void 0 ? void 0 : (_proposal$transports6 = _proposal$transports5.departure) === null || _proposal$transports6 === void 0 ? void 0 : _proposal$transports6.label;
  var criteria = {
    search: {
      label: resort.name,
      value: resort.id,
      country: (_resort$destination = resort.destination) === null || _resort$destination === void 0 ? void 0 : _resort$destination.country,
      offsetSell: appContext.isSeller ? 0 : resort.offsetSell,
      openingDates: resort.openingDates || []
    },
    departure: {
      duration: proposal.duration,
      date: Object(apiDate["j" /* momentFromApiDate */])(proposal.arrivalDate)
    },
    attendees: {
      adults: proposal.attendees.adults.length,
      // $FlowFixMe birthdate is always defined in this case
      kids: proposal.attendees.children.map(function (_ref2) {
        var birthdate = _ref2.birthdate;
        return {
          birthdate: birthdate,
          status: validationStates["b" /* IS_VALID */],
          childcareIncluded: false
        };
      })
    },
    departureCity: {
      label: departureCityLabel,
      value: departureCityId
    }
  };
  return criteria;
};
var EditCriteria_utils_searchNewProposalsNewCriteria = function searchNewProposalsNewCriteria(_ref3) {
  var resort = _ref3.resort,
      criteria = _ref3.criteria,
      selectedProposal = _ref3.selectedProposal,
      router = _ref3.router,
      context = _ref3.context,
      dispatch = _ref3.dispatch,
      dispatchPopin = _ref3.dispatchPopin,
      setNewCriteria = _ref3.setNewCriteria,
      proposalsLoaderLabel = _ref3.proposalsLoaderLabel;
  var query = router.query;

  if ((criteria === null || criteria === void 0 ? void 0 : criteria.departure) && moment_default()(criteria.departure.date).isBefore(moment_default()().add(criteria.search.offsetSell, 'd'), 'day')) {
    // check if valid dates
    setNewCriteria(criteria);
  }

  dispatch(Object(proposals_action["j" /* editCriteriaFetchProposals */])(EditCriteria_utils_objectSpread(EditCriteria_utils_objectSpread({}, criteria), {}, {
    isJoyView: resort.isJoyview,
    isUrbanOasis: resort.isUrbanOasis
  }), proposalsLoaderLabel, context, query)).then(function (_ref4) {
    var _proposals$proposals, _proposals$proposals2;

    var proposals = _ref4.proposals;
    var newResort = proposals.resort;
    var newSelectedProposal = proposals === null || proposals === void 0 ? void 0 : (_proposals$proposals = proposals.proposals) === null || _proposals$proposals === void 0 ? void 0 : _proposals$proposals[0];

    if (proposals.errors || !selectedProposal || !(proposals === null || proposals === void 0 ? void 0 : (_proposals$proposals2 = proposals.proposals) === null || _proposals$proposals2 === void 0 ? void 0 : _proposals$proposals2.length)) {
      // no Availabilities or erros
      dispatchPopin({
        type: popinsActions.CRITERIA_CONFIRMATION_CLOSE
      });
      dispatchPopin({
        type: popinsActions.NO_PROPOSAL_OPEN
      });
      throw new errors["a" /* ApiException */](proposals.errors || 'No proposals found for this criteria');
    } else {
      dispatchPopin({
        type: popinsActions.CRITERIA_CONFIRMATION_CLOSE
      });

      var catId = query.catId,
          openLayer = query.openLayer,
          params = Object(objectWithoutProperties["a" /* default */])(query, ["catId", "openLayer"]);

      var queryParams = EditCriteria_utils_objectSpread(EditCriteria_utils_objectSpread({
        editCriteriaWarning: 'true'
      }, params), {}, {
        departure_city: criteria.departureCity.value
      }); // we have new proposals so we prepare and execute redirection to PAGE_BE_ACCOMMODATION


      var bookingUrl = Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals, resort, newSelectedProposal.id, queryParams);
      dispatch(Object(proposals_action["q" /* prepareBe */])({
        proposalId: newSelectedProposal.id,
        proposals: proposals,
        resort: newResort
      })); // $FlowFixMe

      router.push(bookingUrl);
      window.scrollTo(0, 0);
    }
  })["catch"](function (err) {
    dispatchPopin({
      type: popinsActions.CLOSE_ALL_POPINS
    });
    dispatchPopin({
      type: popinsActions.NO_PROPOSAL_OPEN
    }); // Redirect to oidc if the statusCode is 401

    if (ple_utils["l" /* hasAuthResponseError */](err)) {
      Object(redirectUtils["a" /* redirectToOidc */])(context);
    }
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/TransportIncentive.jsx
var TransportIncentive_jsx = react_default.a.createElement;




var TransportIncentive_TransportIncentive = function TransportIncentive() {
  return TransportIncentive_jsx("div", {
    className: "m-20 text-12 text-black"
  }, TransportIncentive_jsx("div", {
    className: "mb-15 flex gap-15 text-16 font-bold"
  }, TransportIncentive_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-sienna",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE
  }), Object(src_i18n["h" /* t */])('faceting.transport.departureCities.reinsurance')), TransportIncentive_jsx("div", {
    className: "mb-10"
  }, Object(src_i18n["h" /* t */])('faceting.transport.departureCities.guarantee')), TransportIncentive_jsx("div", null, Object(src_i18n["h" /* t */])('faceting.transport.departureCities.schedule')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/BookingBreadcrumb.jsx




var BookingBreadcrumb_jsx = react_default.a.createElement;


























var EDIT_CRITERIA_TOAST_MS = 3000;
var BookingBreadcrumb_BookingBreadcrumb = function BookingBreadcrumb(_ref) {
  var resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      activeStep = _ref.activeStep,
      backgroundImageSrc = _ref.backgroundImageSrc,
      _ref$canEdit = _ref.canEdit,
      canEdit = _ref$canEdit === void 0 ? true : _ref$canEdit,
      className = _ref.className,
      items = _ref.items,
      label = _ref.label,
      lastActiveStep = _ref.lastActiveStep,
      i18n = _ref.i18n,
      onClickStep = _ref.onClickStep;
  var router = Object(next_router["useRouter"])();
  var context = Object(ReactAppContext["c" /* useAppContext */])();

  var _useReducer = Object(react["useReducer"])(popinsReducer, initialPopinsState),
      popinsState = _useReducer[0],
      dispatchPopin = _useReducer[1];

  var dispatch = Object(es["d" /* useDispatch */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var criteria = EditCriteria_utils_getCriteriaFromProposal({
    resort: resort,
    proposal: selectedProposal,
    appContext: context
  });

  var _useState = Object(react["useState"])(criteria),
      newCriteria = _useState[0],
      setNewCriteria = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      shouldShowToastTimeOut = _useState2[0],
      setShouldShowToastTimeOut = _useState2[1];

  var isComingFromEditCriteria = typeof router.query.editCriteriaWarning !== 'undefined';
  Object(react["useEffect"])(function () {
    if (isComingFromEditCriteria) {
      setShouldShowToastTimeOut(true);
      var toastTimer = setTimeout(function () {
        setShouldShowToastTimeOut(false);
        var newUri = new URI_default.a(router.asPath).removeQuery(['editCriteriaWarning']);
        router.replace(newUri.toString());
      }, EDIT_CRITERIA_TOAST_MS);
      return function () {
        return clearTimeout(toastTimer);
      };
    }
  }, [router.query.editCriteriaWarning]);

  var cancelConfirmationPopin = function cancelConfirmationPopin() {
    setNewCriteria(criteria);
    dispatchPopin({
      type: popinsActions.CRITERIA_CONFIRMATION_CLOSE
    });
  };

  return BookingBreadcrumb_jsx("div", {
    className: "relative z-3 bg-black"
  }, BookingBreadcrumb_jsx("div", {
    className: "absolute inset-0 flex items-center overflow-hidden opacity-50"
  }, BookingBreadcrumb_jsx(Hero["a" /* Hero */], {
    className: "flex-1",
    url: backgroundImageSrc
  })), BookingBreadcrumb_jsx(SiteContainer["a" /* SiteContainer */], null, BookingBreadcrumb_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative z-3 flex h-130 flex-col justify-between py-10 text-white sm:flex-row md:h-80', className),
    "data-testid": "breadcrumb"
  }, BookingBreadcrumb_jsx(StepNav_StepNav, {
    activeStep: activeStep,
    ariaLabel: label,
    className: "sm:self-end",
    items: items,
    lastActiveStep: lastActiveStep,
    onClick: onClickStep
  }), canEdit && BookingBreadcrumb_jsx("div", {
    className: "order-first mb-10 flex justify-between gap-10 sm:order-last sm:mb-0 sm:py-5 md:gap-20"
  }, BookingBreadcrumb_jsx(CriteriaWithPopOver_CriteriaWithPopOver, {
    i18n: i18n,
    criteria: criteria,
    newCriteria: newCriteria,
    selectedProposal: selectedProposal,
    selectorComponent: HeaderCriteriaDates_HeaderCriteriaDates,
    popOverComponent: CriteriaDatesSelectorContent_CriteriaDatesSelectorContent,
    setNewCriteria: setNewCriteria,
    dispatchPopin: dispatchPopin,
    onClickTracking: function onClickTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_date'
      });
    },
    validateButtonCriteriaSelectorTracking: function validateButtonCriteriaSelectorTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_date_validate'
      });
    }
  }), BookingBreadcrumb_jsx(CriteriaWithPopOver_CriteriaWithPopOver, {
    i18n: i18n,
    criteria: criteria,
    newCriteria: newCriteria,
    selectedProposal: selectedProposal,
    selectorComponent: HeaderCriteriaAttendees_HeaderCriteriaAttendees,
    popOverComponent: CriteriaAttendeesSelectorContent_CriteriaAttendeesSelectorContent,
    setNewCriteria: setNewCriteria,
    dispatchPopin: dispatchPopin,
    onClickTracking: function onClickTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_participants'
      });
    },
    validateButtonCriteriaSelectorTracking: function validateButtonCriteriaSelectorTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_participants_validate'
      });
    }
  }), BookingBreadcrumb_jsx(CriteriaWithPopOver_CriteriaWithPopOver, {
    i18n: i18n,
    criteria: criteria,
    newCriteria: newCriteria,
    selectedProposal: selectedProposal,
    selectorComponent: HeaderCriteriaTransport_HeaderCriteriaTransport,
    popOverComponent: CriteriaTransportsSelectorContent_CriteriaTransportsSelectorContent,
    setNewCriteria: setNewCriteria,
    dispatchPopin: dispatchPopin,
    onClickTracking: function onClickTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_transport'
      });
    },
    validateButtonCriteriaSelectorTracking: function validateButtonCriteriaSelectorTracking() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_transport_validate'
      });
    },
    blockBeforeValidateComponent: TransportIncentive_TransportIncentive
  }))), popinsState.criteriaConfirmation && BookingBreadcrumb_jsx(EditMyCriteriaPopin_EditMyCriteriaPopin, {
    mainIconName: icons["a" /* ICONS */].RECEIPT,
    onClickCancel: cancelConfirmationPopin,
    onClickConfirm: function onClickConfirm() {
      var searchNewProposalArgs = {
        resort: resort,
        criteria: newCriteria,
        router: router,
        context: context,
        proposalsLoaderLabel: Object(src_i18n["h" /* t */])('booking.form.proposalsLoaderLabel'),
        selectedProposal: selectedProposal,
        dispatch: dispatch,
        dispatchPopin: dispatchPopin,
        setNewCriteria: setNewCriteria
      };
      EditCriteria_utils_searchNewProposalsNewCriteria(searchNewProposalArgs);
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_BREADCRUMB, {
        detail_click: 'edit_confirmation'
      });
    },
    onCloseModal: cancelConfirmationPopin,
    confirmLabel: Object(src_i18n["h" /* t */])('common.confirm'),
    cancelLabel: Object(src_i18n["h" /* t */])('common.cancel'),
    titleLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.buttonLabel'),
    messageLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.alertMessage'),
    dataTestId: "EditMyCriteriaPopin-criteriaConfirmation"
  }), popinsState.noProposalsFound && BookingBreadcrumb_jsx(EditMyCriteriaPopin_EditMyCriteriaPopin, {
    mainIconName: icons["a" /* ICONS */].WARNING,
    onClickConfirm: function onClickConfirm() {
      setNewCriteria(criteria);
      dispatchPopin({
        type: popinsActions.CLOSE_ALL_POPINS
      });
    },
    onCloseModal: function onCloseModal() {
      return dispatchPopin({
        type: popinsActions.NO_PROPOSAL_CLOSE
      });
    },
    confirmLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.backCriteria'),
    titleLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.noAvailability'),
    messageLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.errorMessage'),
    dataTestId: "EditMyCriteriaPopin-noProposalsFound",
    isErrored: true
  }), isComingFromEditCriteria && shouldShowToastTimeOut && BookingBreadcrumb_jsx(Toast["a" /* Toast */], {
    color: colors["a" /* COLORS */].GREEN,
    icon: icons["a" /* ICONS */].CHECK_OUTLINE,
    label: Object(src_i18n["h" /* t */])('booking.editCriteria.modificationSuccessMessage'),
    onClose: function onClose() {
      setShouldShowToastTimeOut(false);
    },
    visible: true
  })));
};

/***/ }),

/***/ "ocZH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("nXZ9");
var utils = __webpack_require__("EmIl");
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),

/***/ "pc5U":
/***/ (function(module, exports, __webpack_require__) {

/*global module*/
var Buffer = __webpack_require__("KLyV").Buffer;
var DataStream = __webpack_require__("VWRg");
var jwa = __webpack_require__("5MfQ");
var Stream = __webpack_require__("6dwG");
var toString = __webpack_require__("6sN/");
var util = __webpack_require__("XLvf");

function base64url(string, encoding) {
  return Buffer
    .from(string, encoding)
    .toString('base64')
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}

function jwsSecuredInput(header, payload, encoding) {
  encoding = encoding || 'utf8';
  var encodedHeader = base64url(toString(header), 'binary');
  var encodedPayload = base64url(toString(payload), encoding);
  return util.format('%s.%s', encodedHeader, encodedPayload);
}

function jwsSign(opts) {
  var header = opts.header;
  var payload = opts.payload;
  var secretOrKey = opts.secret || opts.privateKey;
  var encoding = opts.encoding;
  var algo = jwa(header.alg);
  var securedInput = jwsSecuredInput(header, payload, encoding);
  var signature = algo.sign(securedInput, secretOrKey);
  return util.format('%s.%s', securedInput, signature);
}

function SignStream(opts) {
  var secret = opts.secret||opts.privateKey||opts.key;
  var secretStream = new DataStream(secret);
  this.readable = true;
  this.header = opts.header;
  this.encoding = opts.encoding;
  this.secret = this.privateKey = this.key = secretStream;
  this.payload = new DataStream(opts.payload);
  this.secret.once('close', function () {
    if (!this.payload.writable && this.readable)
      this.sign();
  }.bind(this));

  this.payload.once('close', function () {
    if (!this.secret.writable && this.readable)
      this.sign();
  }.bind(this));
}
util.inherits(SignStream, Stream);

SignStream.prototype.sign = function sign() {
  try {
    var signature = jwsSign({
      header: this.header,
      payload: this.payload.buffer,
      secret: this.secret.buffer,
      encoding: this.encoding
    });
    this.emit('done', signature);
    this.emit('data', signature);
    this.emit('end');
    this.readable = false;
    return signature;
  } catch (e) {
    this.readable = false;
    this.emit('error', e);
    this.emit('close');
  }
};

SignStream.sign = jwsSign;

module.exports = SignStream;


/***/ }),

/***/ "pjey":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("G+mE").Transform


/***/ }),

/***/ "ptRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TransfersSection_TransfersSection; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transportUtils = __webpack_require__("z8xc");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/transferUtils.js










var transferUtils_getTransferLabelKey = function getTransferLabelKey(transferType) {
  switch (transferType) {
    case constants["u" /* TRANSFER_TYPE_ENUM */].ROUND_TRIP:
      return 'common.transport.transfer.introduction';

    case constants["u" /* TRANSFER_TYPE_ENUM */].INBOUND:
      return 'common.transport.transfer.inbound';

    case constants["u" /* TRANSFER_TYPE_ENUM */].OUTBOUND:
      return 'common.transport.transfer.outbound';

    default:
      return 'common.transport.transfer.default';
  }
};

function getTransferOption(transfer) {
  var durationInMinutes = get_default()(transfer, 'productInfo.durationInMinutes');

  var durationInHours = durationInMinutes ? Object(transportUtils["p" /* transformMinutesInHours */])(durationInMinutes) : '';

  var label = get_default()(transfer, 'productInfo.label');

  return {
    value: get_default()(transfer, 'pricingInfo.id'),
    label: "".concat(label).concat(durationInHours ? ": ".concat(durationInHours) : '')
  };
}

function getCtaType(selectedTransfert, addedTransfer) {
  if (!selectedTransfert) {
    return 'disabled';
  }

  return addedTransfer ? 'remove' : 'add';
}

var transferUtils_getTransferOptions = function getTransferOptions(transfers, chooseTransfer) {
  if (isEmpty_default()(transfers)) {
    return [];
  }

  var emptyTransferOption = {
    value: '',
    label: chooseTransfer
  };
  return transfers.length === 1 ? transfers.map(getTransferOption) : [emptyTransferOption].concat(transfers.map(getTransferOption));
};

var getTransferFromValue = function getTransferFromValue(transfers, value) {
  return (transfers || []).find(function (transfer) {
    return transfer.pricingInfo.id === value;
  }) || null;
};

var transferUtils_getTransfersWithLabel = function getTransfersWithLabel(transfers) {
  return (transfers || []).filter(function (transfer) {
    return get_default()(transfer, 'productInfo.label');
  });
};

var transferUtils_getSelectedTransfer = function getSelectedTransfer(availableTransfers, selectedTransfers) {
  var validTransfers = transferUtils_getTransfersWithLabel(availableTransfers);
  var selectedTransfer = null;

  if (!isEmpty_default()(selectedTransfers)) {
    var _selectedTransfers = Object(slicedToArray["a" /* default */])(selectedTransfers, 1);

    selectedTransfer = _selectedTransfers[0];
  } else if (validTransfers.length === 1) {
    var _validTransfers = Object(slicedToArray["a" /* default */])(validTransfers, 1);

    selectedTransfer = _validTransfers[0];
  }

  return selectedTransfer;
};

var getInitiallySelectedTransfer = function getInitiallySelectedTransfer(_ref) {
  var isBE = _ref.isBE,
      addedTransfer = _ref.addedTransfer,
      selectedTransfers = _ref.selectedTransfers,
      availableTransfers = _ref.availableTransfers;

  if (isBE) {
    if (availableTransfers.length === 1) {
      return addedTransfer || availableTransfers[0];
    }

    return addedTransfer || null;
  }

  return transferUtils_getSelectedTransfer(selectedTransfers, availableTransfers);
};


// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx + 1 modules
var InputSelect = __webpack_require__("oWz2");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/ErrorNote.jsx
var ErrorNote = __webpack_require__("TuHz");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 2 modules
var ple_utils = __webpack_require__("6jSF");

// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/TransferSelectionButton.jsx




var __jsx = react_default.a.createElement;


/* eslint-disable clubmed/no-fake-component */







var TransferSelectionButton_TransferSelectionButton = function TransferSelectionButton(_ref) {
  var _selectedTransfer$pri, _selectedTransfer$pri2;

  var bookingId = _ref.bookingId,
      dataSelector = _ref.dataSelector,
      addedTransfer = _ref.addedTransfer,
      selectedTransfer = _ref.selectedTransfer,
      addTransfer = _ref.addTransfer,
      removeTransfer = _ref.removeTransfer,
      setHasError = _ref.setHasError;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      isLoading = _React$useState2[0],
      setIsLoading = _React$useState2[1];

  var _useCartLocked = Object(ple_utils["o" /* useCartLocked */])(bookingId),
      isCartLocked = _useCartLocked.isCartLocked;

  var ctaType = getCtaType(selectedTransfer, addedTransfer);
  var type = ctaType === 'disabled' ? 'add' : ctaType;
  var isAdd = type === 'add';
  var addLabel = Object(i18n["h" /* t */])("booking.transport.transfer.".concat(isAdd ? 'addTransfer' : 'removeTransfer'));
  var price = selectedTransfer === null || selectedTransfer === void 0 ? void 0 : (_selectedTransfer$pri = selectedTransfer.pricingInfo) === null || _selectedTransfer$pri === void 0 ? void 0 : (_selectedTransfer$pri2 = _selectedTransfer$pri.totalPrice) === null || _selectedTransfer$pri2 === void 0 ? void 0 : _selectedTransfer$pri2.formattedValue;
  var symbol = isAdd ? '+' : '-';
  var label = price ? "".concat(addLabel, " ").concat(symbol).concat(price) : addLabel;

  var onCtaClick = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var handler;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handler = addedTransfer ? removeTransfer : addTransfer;
              setIsLoading(true);
              trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
                detail_click: "".concat(type, "_transfer")
              });

              if (!selectedTransfer) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return handler(selectedTransfer);

            case 6:
              _context.next = 9;
              break;

            case 8:
              setHasError(true);

            case 9:
              setIsLoading(false);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onCtaClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (isCartLocked) {
    return null;
  }

  return __jsx(Button["a" /* Button */], {
    className: "w-full self-end md:w-auto",
    "data-selector": "".concat(dataSelector, "-").concat(ctaType),
    isLoading: isLoading,
    onClick: onCtaClick,
    "data-testid": isAdd ? 'transfer-add-cta' : 'transfer-remove-cta',
    size: "large"
  }, label);
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/TransferSelection.jsx

var TransferSelection_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */







var TransferSelection_TransferSelection = function TransferSelection(_ref) {
  var addedTransfer = _ref.addedTransfer,
      bookingId = _ref.bookingId,
      validTransfers = _ref.validTransfers,
      selectedTransfer = _ref.selectedTransfer,
      addTransfer = _ref.addTransfer,
      removeTransfer = _ref.removeTransfer,
      setSelectedTransfer = _ref.setSelectedTransfer;
  var isTransferAdded = !!addedTransfer;
  var isTransferSelected = !!selectedTransfer;
  var validationState = isTransferSelected && !isTransferAdded ? validationStates["b" /* IS_VALID */] : '';
  var transferLabel = Object(i18n["h" /* t */])(transferUtils_getTransferLabelKey(addedTransfer === null || addedTransfer === void 0 ? void 0 : addedTransfer.type));
  var dataSelector = 'transfersSection';

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      hasError = _React$useState2[0],
      setHasError = _React$useState2[1];

  var handleSelectChange = function handleSelectChange(name, value) {
    setHasError(false);
    setSelectedTransfer(getTransferFromValue(validTransfers, value));
  };

  var transfersOptions = transferUtils_getTransferOptions(validTransfers, Object(i18n["h" /* t */])('booking.transport.transfer.chooseTransfer'));
  return TransferSelection_jsx("div", {
    "data-testid": "TransferSelection",
    className: "w-full py-10"
  }, TransferSelection_jsx("div", {
    className: "gap-20 md:flex"
  }, TransferSelection_jsx("div", {
    className: "mb-15 md:mb-0 md:w-3/5"
  }, TransferSelection_jsx(InputSelect["a" /* InputSelect */], {
    label: transferLabel,
    dataTestId: "".concat(dataSelector, "TransfersOptions"),
    onChange: handleSelectChange,
    isReadOnly: isTransferAdded || isTransferSelected && validTransfers.length <= 1,
    options: transfersOptions,
    validationState: validationState,
    value: isTransferAdded ? addedTransfer.pricingInfo.id : selectedTransfer === null || selectedTransfer === void 0 ? void 0 : selectedTransfer.pricingInfo.id
  }), hasError && TransferSelection_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15 md:hidden",
    isErrored: hasError,
    errorMessage: Object(i18n["h" /* t */])('booking.transport.transfer.errorTransfer')
  })), TransferSelection_jsx(TransferSelectionButton_TransferSelectionButton, {
    bookingId: bookingId,
    dataSelector: dataSelector,
    addedTransfer: addedTransfer,
    addTransfer: addTransfer,
    removeTransfer: removeTransfer,
    selectedTransfer: selectedTransfer,
    setHasError: setHasError
  })), hasError && TransferSelection_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15 hidden md:block",
    isErrored: hasError,
    errorMessage: Object(i18n["h" /* t */])('booking.transport.transfer.errorTransfer')
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/TransfersSection.jsx






var TransfersSection_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */









var TransfersSection_TransfersSection = function TransfersSection(_ref) {
  var addTransfer = _ref.addTransfer,
      availableTransfers = _ref.availableTransfers,
      bookingId = _ref.bookingId,
      removeTransfer = _ref.removeTransfer,
      selectedTransfers = _ref.selectedTransfers,
      _ref$isBE = _ref.isBE,
      isBE = _ref$isBE === void 0 ? false : _ref$isBE,
      setHasSelectedTransfer = _ref.setHasSelectedTransfer;
  var addedTransfer = selectedTransfers === null || selectedTransfers === void 0 ? void 0 : selectedTransfers[0];
  var initiallySelectedTransfer = getInitiallySelectedTransfer({
    isBE: isBE,
    addedTransfer: addedTransfer,
    selectedTransfers: selectedTransfers,
    availableTransfers: availableTransfers
  });

  var _React$useState = react_default.a.useState(initiallySelectedTransfer),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      selectedTransfer = _React$useState2[0],
      setSelectedTransfer = _React$useState2[1];

  var _ref2 = selectedTransfer || {},
      _ref2$productInfo = _ref2.productInfo;

  _ref2$productInfo = _ref2$productInfo === void 0 ? {} : _ref2$productInfo;
  var _ref2$productInfo$dur = _ref2$productInfo.durationInMinutes,
      durationInMinutes = _ref2$productInfo$dur === void 0 ? '' : _ref2$productInfo$dur,
      vehicle = _ref2$productInfo.vehicle,
      description = _ref2$productInfo.description;

  var _ref3 = vehicle || {},
      _ref3$label = _ref3.label,
      vehicleLabel = _ref3$label === void 0 ? '' : _ref3$label;

  var shouldDisplayTransferInformationMessage = durationInMinutes || vehicleLabel;
  var durationInHours = Object(transportUtils["p" /* transformMinutesInHours */])(durationInMinutes);
  var transferInformationMessageKey = vehicleLabel ? 'durationAndMeanOfTransportation' : 'duration';
  var validTransfers = transferUtils_getTransfersWithLabel(availableTransfers);
  Object(react["useEffect"])(function () {
    if (setHasSelectedTransfer) {
      setHasSelectedTransfer(!!selectedTransfer);
    }
  }, [selectedTransfer]);

  if (isEmpty_default()(availableTransfers) && !selectedTransfer) {
    return null;
  }

  return !isEmpty_default()(validTransfers) ? TransfersSection_jsx("section", {
    className: "rounded-16 bg-lightSand p-20",
    "data-testid": "TransfersSection"
  }, TransfersSection_jsx(TransferSelection_TransferSelection, {
    addedTransfer: addedTransfer,
    bookingId: bookingId,
    validTransfers: validTransfers,
    selectedTransfer: selectedTransfer,
    addTransfer: addTransfer,
    removeTransfer: removeTransfer,
    setSelectedTransfer: setSelectedTransfer
  }), shouldDisplayTransferInformationMessage && TransfersSection_jsx("div", {
    className: "mt-20 flex gap-20"
  }, TransfersSection_jsx(Badge["a" /* Badge */], {
    className: "size-48 border-black bg-lightSand text-black",
    iconName: icons["a" /* ICONS */].CLOCK,
    iconSize: "24px",
    variant: "pill"
  }), TransfersSection_jsx("div", {
    className: "text-start text-16 leading-normal"
  }, TransfersSection_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(i18n["h" /* t */])("common.transport.transfer.".concat(transferInformationMessageKey)),
    values: {
      duration: durationInHours,
      label: vehicleLabel
    },
    valuesClassName: {
      duration: 'font-bold',
      label: 'font-bold'
    }
  }), TransfersSection_jsx("p", {
    className: "mt-8 text-14 text-mediumGrey"
  }, "".concat(Object(i18n["h" /* t */])('common.transport.transfer.note').trim(), " ").concat(description)), TransfersSection_jsx("p", {
    className: "mt-8 text-14 text-mediumGrey"
  }, Object(i18n["h" /* t */])('common.transport.transfer.waitingTime'))))) : TransfersSection_jsx(Notification["a" /* Notification */], {
    className: "text-orange",
    title: Object(i18n["h" /* t */])('booking.form.errors.transferUnavailable')
  });
};

/***/ }),

/***/ "pteD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TripDatePicker_TripDatePicker; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__("nFOY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx + 2 modules
var Datepicker = __webpack_require__("Dm6d");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.themes.js
var Datepicker_themes = __webpack_require__("MZFe");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/debounce.js
var debounce = __webpack_require__("RNvQ");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.themes.js

var TripDatePicker_themes_themes = function themes(_ref) {
  var isBestPrice = _ref.isBestPrice,
      isHighlighted = _ref.isHighlighted,
      isSelectable = _ref.isSelectable,
      isSelected = _ref.isSelected,
      isTablet = _ref.isTablet,
      lastAvailability = _ref.lastAvailability,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      siblingOpen = _ref.siblingOpen;
  return {
    "default": {
      thDay: Object(classnames_utils["a" /* classnames */])("group flex flex-1 cursor-pointer flex-col items-center justify-center ".concat(isTablet ? 'h-100 p-5' : 'h-52', " relative border-r border-t border-grey text-center text-14 transition-all duration-250 ease-in"), {
        'text-black hocus:text-white': isSelectable
      }),
      thDayCornerMark: Object(classnames_utils["a" /* classnames */])({
        'corner-mark-tr-turquoise': siblingOpen && isTablet,
        'corner-mark-tr-turquoise-sm': siblingOpen && !isTablet
      }),
      thDayMessage: 'hidden md:inline w-full font-normal text-12',
      thDayNumber: Object(classnames_utils["a" /* classnames */])('left-0 top-0 text-10 md:absolute md:p-5', {
        'font-normal md:text-12': !isSelectable,
        'font-bold md:text-16': isSelectable,
        'text-current': siblingOpen
      }),
      thDayOldPrice: 'text-12 line-through hidden md:block text-current',
      thDayPrice: 'text-12 md:text-16',
      thStatusMessage: shouldDisplayDoubleSeasonButton ? "bg-turquoise cursor-pointer font-bold p-1 md:px-5 rounded-2 text-10 md:text-18 text-white uppercase".concat(!isTablet ? ' w-full' : '') : 'hidden md:inline w-full font-normal',
      thFrom: 'hidden md:inline w-full font-normal'
    },
    compact: {
      thDay: 'cursor-pointer flex flex-1 flex-col group items-center justify-center h-48 leading-tight relative text-14 text-center',
      thDayMessage: 'hidden',
      thDayNumberContainer: Object(classnames_utils["a" /* classnames */])('relative isolate'),
      thDayNumber: Object(classnames_utils["a" /* classnames */])('relative z-1', {
        'text-white': (lastAvailability || isBestPrice || siblingOpen) && isHighlighted,
        'text-grey group-hover:text-white': !lastAvailability && !isBestPrice && !siblingOpen && isHighlighted
      }),
      thDayUnavailable: 'line-through',
      thDayHighlight: 'absolute bg-current group-hover:bg-transparent h-26 left-1/2 rounded-4 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-26',
      thDayOldPrice: 'hidden',
      thDayPrice: Object(classnames_utils["a" /* classnames */])('mx-auto -mb-5 mt-5 block self-end text-10 font-bold', {
        'text-black group-hover:text-white': !isSelected,
        'text-white': isSelected
      }),
      thStatusMessage: 'hidden',
      thFrom: 'hidden',
      thShowPricePlaceholder: true
    }
  };
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDetails.jsx
var __jsx = react_default.a.createElement;




var DayPriceDetails_DayPriceDetails = function DayPriceDetails(_ref) {
  var day = _ref.day,
      duration = _ref.duration,
      departureCity = _ref.departureCity,
      hasTransport = _ref.hasTransport,
      isJoyview = _ref.isJoyview,
      isVisible = _ref.isVisible,
      setIsVisible = _ref.setIsVisible,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      unit = _ref.unit;
  Object(react["useEffect"])(function () {
    setIsVisible(shouldDisplayDetails);
  }, [shouldDisplayDetails]);
  var dateFormat = Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  var startDate = moment_default()(day).format(dateFormat);
  var endDate = moment_default()(day).add({
    days: duration
  }).format(dateFormat);
  return isVisible && shouldDisplayDetails && __jsx("div", {
    className: "text-initial absolute left-1/2 top-0 z-2 w-400 -translate-x-1/2 transform font-normal"
  }, __jsx("div", {
    className: "animation-duration-500 absolute inset-x-0 bottom-full animate-fadeIn"
  }, __jsx("div", {
    className: "arrow-down arrow-large arrow-white rounded-12 bg-white shadow-md after:drop-shadow-md"
  }, __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
    city: departureCity,
    endDate: endDate,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    startDate: startDate,
    unit: unit
  }))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeasonPopin.jsx
var DayPriceDoubleSeasonPopin = __webpack_require__("uMuQ");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeason.jsx
var DayPriceDoubleSeason_jsx = react_default.a.createElement;





var DayPriceDoubleSeason_DayPriceDoubleSeason = function DayPriceDoubleSeason(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      isMouseOverDoubleSeasonPopin = _ref.isMouseOverDoubleSeasonPopin,
      isVisible = _ref.isVisible,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var stopEventBubbling = function stopEventBubbling(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var closeModal = function closeModal(e) {
    stopEventBubbling(e);
    setInvisible();
  };

  var trackingData = {
    actionGA: 'calendarPrice'
  };
  return (isVisible || isMouseOverDoubleSeasonPopin) && DayPriceDoubleSeason_jsx("div", {
    onClick: stopEventBubbling
  }, isTablet ? DayPriceDoubleSeason_jsx("aside", {
    className: "arrow arrow-bg-lightGrey arrow-down arrow-white animation-duration-500 absolute bottom-full left-1/2 z-3 w-280 -translate-x-1/2 transform animate-fadeIn font-normal shadow-diffuse"
  }, DayPriceDoubleSeason_jsx("div", {
    className: "text-initial overflow-hidden rounded-12 border border-lightGrey bg-white"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  }))) : DayPriceDoubleSeason_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayWithPrice.jsx




var DayWithPrice_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */











var COMPACT_MAX_CHARACTERS = 5;
var DayWithPrice_DayWithPrice = function DayWithPrice(_ref) {
  var day = _ref.day,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 7 : _ref$duration,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? false : _ref$hasInstalment,
      isJoyview = _ref.isJoyview,
      isLoading = _ref.isLoading,
      _ref$isSelectable = _ref.isSelectable,
      isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$isHighlighted = _ref.isHighlighted,
      isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
      locale = _ref.locale,
      _ref$price = _ref.price,
      availability = _ref$price.availability,
      currency = _ref$price.currency,
      departureCity = _ref$price.departureCity,
      hasTransport = _ref$price.hasTransport,
      isBestPrice = _ref$price.isBestPrice,
      lastAvailability = _ref$price.lastAvailability,
      formattedPriceValue = _ref$price.price,
      oldPrice = _ref$price.oldPrice,
      priceValue = _ref$price.priceValue,
      _ref$price$siblingOpe = _ref$price.siblingOpen,
      siblingOpen = _ref$price$siblingOpe === void 0 ? false : _ref$price$siblingOpe,
      unit = _ref$price.unit,
      product = _ref.product,
      selectedBestPrice = _ref.selectedBestPrice,
      selectedDuration = _ref.selectedDuration,
      selectedRealPrice = _ref.selectedRealPrice,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      shouldDisplayPrice = _ref.shouldDisplayPrice,
      shouldDisplaySelectedDepartureDateMessage = _ref.shouldDisplaySelectedDepartureDateMessage,
      shouldDisplaySelectedDepartureDateMessageWithPrice = _ref.shouldDisplaySelectedDepartureDateMessageWithPrice,
      shouldDisplaySelectedReturningDateMessage = _ref.shouldDisplaySelectedReturningDateMessage,
      shouldDisplayStatusMessage = _ref.shouldDisplayStatusMessage,
      theme = _ref.theme,
      withPriceDetails = _ref.withPriceDetails;

  var _useState = Object(react["useState"])(false),
      isMouseOverDoubleSeasonPopin = _useState[0],
      setIsMouseOverDoubleSeasonPopin = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isVisible = _useState2[0],
      setIsVisibleState = _useState2[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var statusMessageKey = "booking.priceCalendar.priceStatus.".concat(availability);
  var _themes$theme = TripDatePicker_themes_themes({
    isBestPrice: isBestPrice,
    isHighlighted: isHighlighted,
    isSelectable: isSelectable,
    isSelected: isSelected,
    isTablet: isTablet,
    lastAvailability: lastAvailability,
    shouldDisplayDoubleSeasonButton: shouldDisplayDoubleSeasonButton,
    siblingOpen: siblingOpen
  })[theme],
      thDayCornerMark = _themes$theme.thDayCornerMark,
      thDayMessage = _themes$theme.thDayMessage,
      thDayNumberContainer = _themes$theme.thDayNumberContainer,
      thDayNumber = _themes$theme.thDayNumber,
      thDayHighlight = _themes$theme.thDayHighlight,
      thDayOldPrice = _themes$theme.thDayOldPrice,
      thDayPrice = _themes$theme.thDayPrice,
      thStatusMessage = _themes$theme.thStatusMessage,
      thFrom = _themes$theme.thFrom,
      thShowPricePlaceholder = _themes$theme.thShowPricePlaceholder;

  var setIsVisible = debounce_default()(function (visible) {
    setIsVisibleState(visible);
  }, 150);

  var setVisible = function setVisible() {
    if (!isVisible) {
      setIsVisible(true);
    }
  };

  var setInvisible = function setInvisible() {
    setIsVisible(false);
  };

  var getCompactPrice = function getCompactPrice(rawPrice) {
    var compactPrice = (rawPrice === null || rawPrice === void 0 ? void 0 : rawPrice.replace(/[\s|.,]/gi, '')) || '';
    return compactPrice.length <= COMPACT_MAX_CHARACTERS ? compactPrice : DayWithPrice_jsx("span", {
      className: "text-8 md:mx-1 md:px-1 md:text-10"
    }, compactPrice);
  };

  var price = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])({
    currency: currency,
    formattedValue: formattedPriceValue,
    value: priceValue
  }, locale) : formattedPriceValue;
  var selectedPrice = selectedRealPrice || selectedBestPrice;
  var isDateSelectable = ['open', 'noDeparture'].includes(availability);
  return DayWithPrice_jsx(react["Fragment"], null, DayWithPrice_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'absolute inset-0 z-3 h-full w-full': withPriceDetails || shouldDisplayDoubleSeasonButton,
      'pointer-events-auto': shouldDisplayDoubleSeasonButton
    }),
    "data-testid": "price-calendar-date",
    onBlur: function onBlur() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onClick: function onClick(e) {
      if (shouldDisplayDoubleSeasonButton) {
        e.preventDefault();
        e.stopPropagation();

        if (!isDesktop) {
          setVisible();
        }
      }
    },
    onFocus: function onFocus() {
      if (isDesktop) {
        setVisible();
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onMouseOver: function onMouseOver() {
      if (isDesktop) {
        setVisible();
      }
    },
    tabIndex: 0
  }), siblingOpen && DayWithPrice_jsx("span", {
    className: thDayCornerMark
  }), withPriceDetails && DayWithPrice_jsx(DayPriceDetails_DayPriceDetails, {
    duration: duration,
    departureCity: departureCity,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    isVisible: isVisible,
    setIsVisible: setIsVisible,
    shouldDisplayDetails: !!price && shouldDisplayDetails,
    day: day,
    unit: unit
  }), product && siblingOpen && shouldDisplayDoubleSeasonButton && DayWithPrice_jsx(DayPriceDoubleSeason_DayPriceDoubleSeason, {
    availability: availability,
    product: product,
    isMouseOverDoubleSeasonPopin: isMouseOverDoubleSeasonPopin,
    isVisible: isVisible,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    setVisible: setVisible,
    statusMessageKey: statusMessageKey
  }), (!shouldDisplayDoubleSeasonButton || isTablet) && DayWithPrice_jsx("div", {
    className: thDayNumberContainer
  }, DayWithPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])(thDayNumber)
  }, moment_default()(day).format('D')), isHighlighted && DayWithPrice_jsx("div", {
    className: thDayHighlight
  })), shouldDisplayStatusMessage && Object(i18n["f" /* has */])(statusMessageKey) && !price && !isLoading && (siblingOpen ? shouldDisplayDoubleSeasonButton && DayWithPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])(thStatusMessage, {
      'shadow-md': isVisible || isMouseOverDoubleSeasonPopin
    })
  }, Object(i18n["h" /* t */])(statusMessageKey)) : DayWithPrice_jsx("span", {
    className: thStatusMessage
  }, Object(i18n["h" /* t */])(statusMessageKey))), shouldDisplaySelectedDepartureDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), ' ', DayWithPrice_jsx("div", {
    className: "mt-5"
  }, Object(i18n["h" /* t */])('booking.priceCalendar.endDateMessage'))), shouldDisplaySelectedDepartureDateMessageWithPrice && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), selectedPrice && selectedDuration && DayWithPrice_jsx("div", {
    className: "flex flex-col"
  }, DayWithPrice_jsx("span", null, Object(i18n["h" /* t */])('price.format.unitTotalPerTripIndicative').toUpperCase()), DayWithPrice_jsx("span", {
    className: "text-12 font-bold leading-tight md:text-16",
    "data-testid": "selected-date-best-price"
  }, theme === 'compact' ? getCompactPrice(selectedPrice) : selectedPrice))), shouldDisplaySelectedReturningDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedReturningDateMessage').toUpperCase()), isLoading ? DayWithPrice_jsx(Spinner["a" /* Spinner */], {
    size: "tiny",
    className: "text-black"
  }) : DayWithPrice_jsx(react["Fragment"], null, shouldDisplayPrice && !!price && DayWithPrice_jsx("div", {
    className: "flex flex-col text-current",
    "data-testid": "price-calendar-date-price"
  }, !!price && DayWithPrice_jsx("span", {
    className: thFrom
  }, Object(i18n["h" /* t */])('price.format.from')), DayWithPrice_jsx("span", {
    "data-testid": "price",
    className: thDayPrice
  }, theme === 'compact' ? getCompactPrice(price) : price), price !== oldPrice && DayWithPrice_jsx("span", {
    className: thDayOldPrice
  }, oldPrice)), thShowPricePlaceholder && (!shouldDisplayPrice || !price) && DayWithPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])(thDayPrice, {
      'opacity-0': !isDateSelectable
    })
  }, isDateSelectable ? Object(string_util["d" /* truncate */])(Object(i18n["h" /* t */])('faceting.when.dateSelect'), 6) : DayWithPrice_jsx(react_default.a.Fragment, null, "\xA0"))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx








var TripDatePicker_jsx = react_default.a.createElement;














var selector = function selector(state) {
  var _state$calendar;

  return {
    isBookableDatesLoading: state === null || state === void 0 ? void 0 : (_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.bookableDatesLoading
  };
}; // $FlowFixMe


var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return TripDatePicker_jsx("div", {
    className: className,
    title: weekdayName
  }, weekdayName);
};

var TripDatePicker_TripDatePicker = function TripDatePicker(_ref2) {
  var _modifiers;

  var className = _ref2.className,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      hasInstalment = _ref2.hasInstalment,
      isJoyview = _ref2.isJoyview,
      navbarElement = _ref2.navbarElement,
      navigationByYear = _ref2.navigationByYear,
      offsetCalendar = _ref2.offsetCalendar,
      onDayMouseOver = _ref2.onDayMouseOver,
      onSelect = _ref2.onSelect,
      openCalendarToDate = _ref2.openCalendarToDate,
      openingDates = _ref2.openingDates,
      optionsDuration = _ref2.optionsDuration,
      prices = _ref2.prices,
      product = _ref2.product,
      selectedBestPrice = _ref2.selectedBestPrice,
      _ref2$selectedDays = _ref2.selectedDays,
      from = _ref2$selectedDays.from,
      to = _ref2$selectedDays.to,
      selectedDuration = _ref2.selectedDuration,
      selectedMonth = _ref2.selectedMonth,
      selectedRealPrice = _ref2.selectedRealPrice,
      _ref2$shouldAllowSele = _ref2.shouldAllowSelectingSiblingOpenDays,
      shouldAllowSelectingSiblingOpenDays = _ref2$shouldAllowSele === void 0 ? false : _ref2$shouldAllowSele,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      withLongDayFormat = _ref2.withLongDayFormat,
      _ref2$withPriceDetail = _ref2.withPriceDetails,
      withPriceDetails = _ref2$withPriceDetail === void 0 ? false : _ref2$withPriceDetail,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["className", "departureDate", "duration", "hasInstalment", "isJoyview", "navbarElement", "navigationByYear", "offsetCalendar", "onDayMouseOver", "onSelect", "openCalendarToDate", "openingDates", "optionsDuration", "prices", "product", "selectedBestPrice", "selectedDays", "selectedDuration", "selectedMonth", "selectedRealPrice", "shouldAllowSelectingSiblingOpenDays", "theme", "withLongDayFormat", "withPriceDetails"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _props$displayPrices = props.displayPrices,
      displayPrices = _props$displayPrices === void 0 ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('datePicker.displayPrices') : _props$displayPrices;

  var _useSelector = Object(es["e" /* useSelector */])(selector),
      isBookableDatesLoading = _useSelector.isBookableDatesLoading;

  var onMouseOver = function onMouseOver(day) {
    onDayMouseOver && onDayMouseOver(day);
  };

  var pricesIds = Object.keys(prices || {});
  var flattenedPrices = prices ? Object(TripDatePicker_utils["f" /* flattenPrices */])(prices) : '';
  var hasPrices = pricesIds.length > 0;
  var doDisplayPricesInDatePicker = hasPrices && displayPrices || theme === 'compact';
  var bothDatesSelected = Boolean(from && to);
  var resolvePrice = Object(react["useCallback"])(function (dayId) {
    return get_default()(prices, "[".concat(dayId, "]"), {});
  }, [flattenedPrices]);
  var isSeller = appContext.isSeller,
      locale = appContext.locale;
  var disabledDays = Object(react["useMemo"])(function () {
    return Object(TripDatePicker_utils["g" /* getDisabledDays */])({
      from: from,
      to: to,
      prices: prices,
      isSeller: isSeller,
      optionsDuration: optionsDuration,
      openingDates: openingDates,
      resolvePrice: resolvePrice,
      shouldAllowSelectingSiblingOpenDays: shouldAllowSelectingSiblingOpenDays
    });
  }, [from, isSeller, optionsDuration.join(), flattenedPrices, to]);
  var dayIsClosed = Object(react["useCallback"])(Object(TripDatePicker_utils["b" /* closedDaysFactory */])(resolvePrice, from, moment_default()(to).subtract(1, 'day').toDate(), shouldAllowSelectingSiblingOpenDays), [from, to, flattenedPrices]);
  var modifiers = (_modifiers = {}, Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, '!text-lightGrey', disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "disabledDays", disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "firstSiblingOpenDayOfSelectedMonth", Object(TripDatePicker_utils["e" /* firstSiblingOpenDayOfSelectedMonthFactory */])(resolvePrice, selectedMonth)), Object(defineProperty["a" /* default */])(_modifiers, "siblingOpenDays", Object(TripDatePicker_utils["k" /* siblingOpenDaysFactory */])(resolvePrice)), Object(defineProperty["a" /* default */])(_modifiers, 'pointer-events-none', function pointerEventsNone(day) {
    var dayIsSelected = from && to && Object(TripDatePicker_utils["d" /* dateToInt */])(day) >= Object(TripDatePicker_utils["d" /* dateToInt */])(from) && Object(TripDatePicker_utils["d" /* dateToInt */])(day) <= Object(TripDatePicker_utils["d" /* dateToInt */])(to);

    if (hasPrices && dayIsSelected) {
      return dayIsClosed(day);
    }
  }), _modifiers);
  var firstDateWithPrices = Object(react["useMemo"])(function () {
    var today = Object(TripDatePicker_utils["d" /* dateToInt */])(new Date());
    var dayWithPrice = pricesIds.find(function (pricesKey) {
      return Object(TripDatePicker_utils["d" /* dateToInt */])(moment_default()(pricesKey, apiDate["a" /* API_DATE_FORMAT */]).toDate()) > today && prices && prices[pricesKey].available;
    });
    return dayWithPrice || null;
  }, [JSON.stringify(flattenedPrices)]);
  var firstDateOpened = Object(react["useMemo"])(function () {
    if (!Array.isArray(openingDates) || openingDates.length === 0) {
      return null;
    }

    var _openingDates = Object(slicedToArray["a" /* default */])(openingDates, 1),
        opening = _openingDates[0].opening;

    return opening;
  }, [JSON.stringify(openingDates)]);
  var thDay = TripDatePicker_themes_themes({
    isTablet: isTablet
  })[theme].thDay; // If bookable dates are loading only define current or selected day as range

  var datesRange = isBookableDatesLoading ? {
    min: moment_default()(from).toDate(),
    max: moment_default()(from).toDate()
  } : {
    min: Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar),
    max: Object(TripDatePicker_utils["i" /* maxDatepickerDate */])()
  };

  var _useState = Object(react["useState"])(openCalendarToDate),
      openCalendarDate = _useState[0],
      setOpenCalendarDate = _useState[1];

  Object(react["useEffect"])(function () {
    setOpenCalendarDate(openCalendarToDate);
  }, [moment_default()(openCalendarToDate).format(apiDate["a" /* API_DATE_FORMAT */])]);
  Object(react["useEffect"])(function () {
    if (from) {
      setOpenCalendarDate(from);
    }
  }, [moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */])]);
  var initialMonth = Object(react["useMemo"])(function () {
    return moment_default()(openCalendarDate || from || firstDateWithPrices || firstDateOpened || Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar)).toDate();
  }, [moment_default()(openCalendarDate).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateWithPrices).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateOpened).format(apiDate["a" /* API_DATE_FORMAT */]), offsetCalendar]);
  return TripDatePicker_jsx(Datepicker["a" /* Datepicker */], Object(esm_extends["a" /* default */])({
    hasRangeMode: true,
    className: className,
    selectedDays: {
      from: from,
      to: to
    },
    disabledDays: disabledDays,
    customModifiers: modifiers,
    hasNavigationByYear: navigationByYear,
    minDate: datesRange.min,
    maxDate: datesRange.max,
    navbarElement: navbarElement,
    initialMonth: initialMonth,
    onSelect: onSelect,
    onMouseOver: onMouseOver,
    onFocus: onMouseOver,
    theme: theme,
    shouldHoverSiblingOpenDays: shouldAllowSelectingSiblingOpenDays,
    weekdayElement: withLongDayFormat ? TripDatePicker_jsx(Weekday, null) : undefined
  }, doDisplayPricesInDatePicker ? {
    // eslint-disable-next-line clubmed/no-fake-component
    renderDay: function renderDay(day, dayModifiers) {
      var shouldDisplayPrice = theme === 'compact' ? hasPrices && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] : hasPrices && !to && !moment_default()(from).isSame(day, 'day');
      var price = resolvePrice(Object(TripDatePicker_utils["d" /* dateToInt */])(day));
      return TripDatePicker_jsx(DayWithPrice_DayWithPrice, {
        day: day,
        duration: duration,
        hasInstalment: hasInstalment,
        hasPrices: hasPrices,
        isSelectable: Boolean(!dayModifiers.disabledDays && from && !to && !DayPicker["DateUtils"].isSameDay(day, from)),
        isSelected: Boolean(dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected]),
        isLoading: departureDate && isBookableDatesLoading && moment_default()(day).isAfter(departureDate) ? true : false,
        isJoyview: isJoyview,
        locale: locale,
        price: price,
        product: product,
        selectedBestPrice: selectedBestPrice,
        selectedDuration: selectedDuration,
        selectedRealPrice: selectedRealPrice,
        isHighlighted: (dayModifiers.today || price.isBestPrice || price.lastAvailability || price.siblingOpen) && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected],
        shouldDisplayDetails: withPriceDetails && !!dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] && !from && !to,
        shouldDisplayDoubleSeasonButton: dayModifiers.firstSiblingOpenDayOfSelectedMonth,
        shouldDisplayPrice: shouldDisplayPrice,
        shouldDisplaySelectedDepartureDateMessage: !!from && !to && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedDepartureDateMessageWithPrice: bothDatesSelected && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedReturningDateMessage: bothDatesSelected && moment_default()(to).isSame(day, 'day'),
        shouldDisplayStatusMessage: !from,
        withPriceDetails: withPriceDetails,
        theme: theme
      });
    },
    datePickerClassNames: {
      day: thDay
    }
  } : null));
};

/***/ }),

/***/ "qqtw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const decoders = exports;

decoders.der = __webpack_require__("CgxS");
decoders.pem = __webpack_require__("HQvT");


/***/ }),

/***/ "qvEg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("2+UM")


/***/ }),

/***/ "qw6+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__("X05J");
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__("Rl48");
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("r2q8").EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("/kXe");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("KLyV").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__("a1wc"));
util.inherits = __webpack_require__("qW1w");
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(0);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__("FtZA");
var destroyImpl = __webpack_require__("NhVp");
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__("wYax");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("2wQW").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__("wYax");

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("2wQW").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, { hasUnpiped: false });
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq"), __webpack_require__("F63i")))

/***/ }),

/***/ "r2q8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ "rNwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ActivitiesThematics_ActivitiesThematics; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/layers/layers.constants.js
var layers_constants = __webpack_require__("RDfq");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ServicesContext.js
var ServicesContext = __webpack_require__("2Odu");

// EXTERNAL MODULE: ./src/hooks/use-layer/useLayer.js
var useLayer = __webpack_require__("1CQ+");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-thematic-card/ActivitiesThematicCard.jsx





var __jsx = react_default.a.createElement;














var ActivitiesThematicCard_ActivitiesThematicCard = function ActivitiesThematicCard(_ref) {
  var _thematic$activitiesC, _thematic$activitiesC2, _thematic$images, _thematic$activitiesC3, _thematic$activitiesC4;

  var className = _ref.className,
      _ref$firstItemDisplay = _ref.firstItemDisplay,
      firstItemDisplay = _ref$firstItemDisplay === void 0 ? false : _ref$firstItemDisplay,
      _ref$hasCounters = _ref.hasCounters,
      hasCounters = _ref$hasCounters === void 0 ? false : _ref$hasCounters,
      label = _ref.label,
      onClick = _ref.onClick,
      thematic = _ref.thematic,
      url = _ref.url,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "firstItemDisplay", "hasCounters", "label", "onClick", "thematic", "url"]);

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var isPle = pageType === constants["C" /* STATIC_PAGE_TYPES */].PLE;
  var onlineBookableActivitiesCount = (thematic === null || thematic === void 0 ? void 0 : thematic.onlineBookableCount) || 0; // in PLE we only show the online bookable activities count

  var totalActivities = isPle ? onlineBookableActivitiesCount : ((thematic === null || thematic === void 0 ? void 0 : (_thematic$activitiesC = thematic.activitiesCounters) === null || _thematic$activitiesC === void 0 ? void 0 : _thematic$activitiesC.included) || 0) + ((thematic === null || thematic === void 0 ? void 0 : (_thematic$activitiesC2 = thematic.activitiesCounters) === null || _thematic$activitiesC2 === void 0 ? void 0 : _thematic$activitiesC2.onDemand) || 0);
  var firstItemTextLength = isDesktop ? 40 : 25;
  var firstItemTitle = Object(string_util["d" /* truncate */])(thematic.name, isDesktop ? 35 : 25);
  var defaultItemTextLength = isDesktop ? 90 : 42;
  var defaultItemTitle = thematic.name;
  return __jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])('group relative isolate flex h-310 items-end justify-between overflow-hidden rounded-12 p-20 text-white', className),
    "data-testid": "thematics",
    onClick: onClick,
    shallow: true,
    url: url
  }), __jsx("div", {
    className: "absolute inset-0 -z-1 flex transform items-center transition-all duration-250 ease-in group-hover:scale-105"
  }, __jsx(Image["a" /* Image */], {
    className: "flex h-full w-full",
    imageUrl: (_thematic$images = thematic.images) === null || _thematic$images === void 0 ? void 0 : _thematic$images[0]
  }), __jsx("div", {
    className: "absolute bottom-0 h-1/2 w-full bg-gradient-to-t from-black/80"
  })), hasCounters && __jsx("div", {
    className: "absolute top-0 mt-10 flex flex-row items-center"
  }, (thematic === null || thematic === void 0 ? void 0 : (_thematic$activitiesC3 = thematic.activitiesCounters) === null || _thematic$activitiesC3 === void 0 ? void 0 : _thematic$activitiesC3.onDemand) > 0 && __jsx(Badge["a" /* Badge */], {
    className: "size-30 border-orange bg-orange text-white",
    iconName: icons["a" /* ICONS */].ON_DEMAND,
    iconSize: "0.875rem",
    variant: "pill"
  }), (thematic === null || thematic === void 0 ? void 0 : (_thematic$activitiesC4 = thematic.activitiesCounters) === null || _thematic$activitiesC4 === void 0 ? void 0 : _thematic$activitiesC4.included) > 0 && __jsx(Badge["a" /* Badge */], {
    className: "size-30 border-green bg-green text-white",
    iconName: icons["a" /* ICONS */].ALL_INCLUSIVE,
    iconSize: "0.875rem",
    variant: "pill"
  }), __jsx("span", {
    className: "ms-10 font-brand"
  }, Object(i18n["h" /* t */])(totalActivities > 1 ? 'common.activities.counters._n' : 'common.activities.counters._1', {
    count: totalActivities
  }))), __jsx("div", null, __jsx(Title["a" /* Title */], {
    className: "mb-5 text-white",
    theme: "title-brand-n0"
  }, firstItemDisplay ? firstItemTitle : defaultItemTitle), __jsx(Text["a" /* Text */], {
    className: "text-white",
    text: Object(string_util["d" /* truncate */])(thematic.description || '', firstItemDisplay ? firstItemTextLength : defaultItemTextLength),
    theme: "text-sans-n3"
  })), __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    width: "1rem"
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/rentals-cta/RentalsCta.jsx
var RentalsCta = __webpack_require__("38qS");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-thematics/ActivitiesThematics.jsx













var ActivitiesThematics_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ActivitiesThematics_ActivitiesThematics = function ActivitiesThematics(_ref) {
  var _ref$hasRentals = _ref.hasRentals,
      hasRentals = _ref$hasRentals === void 0 ? false : _ref$hasRentals,
      _ref$isProposal = _ref.isProposal,
      isProposal = _ref$isProposal === void 0 ? false : _ref$isProposal,
      layerName = _ref.layerName,
      rentalsLayerName = _ref.rentalsLayerName,
      thematics = _ref.thematics,
      _ref$trackRentals = _ref.trackRentals,
      trackRentals = _ref$trackRentals === void 0 ? function () {} : _ref$trackRentals;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      trackingData = _useContext.trackingData;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var isMobile = !isTablet;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      siteSection = _usePageContext.siteSection,
      pageMeta = _usePageContext.pageMeta,
      pageId = _usePageContext.pageId;

  var itemsNumber = thematics.length + (hasRentals ? 1 : 0);
  var isTwoColumnsItem = (isMobile && itemsNumber % 2) === 0;
  var track = Object(useTracking["a" /* useTracking */])(_objectSpread({
    actionGA: 'activities',
    siteSection: siteSection,
    pageName: // eslint-disable-next-line no-nested-ternary
    pageMeta.resortId && siteSection ? "".concat(siteSection, "_").concat(pageMeta.resortId) : isProposal ? 'BE_activities' : pageId
  }, trackingData));

  var _useLayer = Object(useLayer["a" /* useLayer */])(layerName || layers_constants["c" /* LAYER_NAME_UPSELL_ACTIVITIES */], {
    type: 'THEMATICS'
  }),
      nextUri = _useLayer.nextUri;

  var getUrl = function getUrl(catId) {
    return new URI_default.a(nextUri).addQuery({
      catId: catId
    }).toString();
  };

  return ActivitiesThematics_jsx("section", {
    className: "isolate grid grid-cols-2 gap-20 md:grid-cols-3",
    "data-testid": "Activities-all-componant"
  }, hasRentals && ActivitiesThematics_jsx(RentalsCta["a" /* RentalsCta */], {
    className: "col-span-2 h-310",
    layerName: rentalsLayerName,
    onClick: trackRentals
  }), thematics.filter(function (item) {
    return (item.activities || []).length > 0;
  }).map(function (item, index) {
    return ActivitiesThematics_jsx(ActivitiesThematicCard_ActivitiesThematicCard, {
      className: Object(classnames_utils["a" /* classnames */])({
        'col-span-2': !hasRentals && index === 0 || isTwoColumnsItem,
        'col-span-1': hasRentals || index > 0 && !isTwoColumnsItem
      }),
      firstItemDisplay: index > 0 && !hasRentals,
      key: item.id,
      label: Object(i18n["h" /* t */])('common.activities.label'),
      onClick: function onClick() {
        return track({
          labelGA: "themes_".concat(item.name)
        });
      },
      thematic: item,
      url: getUrl(item.id)
    });
  }));
};

/***/ }),

/***/ "rgjJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__("+ZX+"),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__(7),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ "rm/1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("ZK3j");
var SHA256 = __webpack_require__("auLa");

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),

/***/ "roL5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("ZK3j");
var assert = __webpack_require__("Y4pH");

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),

/***/ "s/+e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("Y4pH");
var inherits = __webpack_require__("qW1w");

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),

/***/ "s1v2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUpSellQuantity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return upSellTypeMapping; });
/* unused harmony export getDefaultUpsellTrackingProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackUpsell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackJoyViewUpsell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackAbTasty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return trackAdditionnalServicesRented; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computeTransferTrackingValue; });
/* unused harmony export eventTracking */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getConfirmationProps; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("IAdD");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("d1HQ");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("zwLB");
/* harmony import */ var _components_utils_ab_tasty_abTasty_utils__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("FtaI");
/* harmony import */ var _BookingEngine_utils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("47Eh");
/* harmony import */ var _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("K0Lv");
/* harmony import */ var _utils_payment_constants__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("hi3+");
/* harmony import */ var _utils_status_code_statusCode_constants__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("PSHn");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("taV1");




















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
} // flow














var upsellQuatityScheduleReducer = function upsellQuatityScheduleReducer(upsellQuantityAttendee, schedule) {
  if (!schedule.isPartiallyRented) {
    return upsellQuantityAttendee;
  }

  if (schedule.timeSlots && schedule.timeSlots.length > 0) {
    return upsellQuantityAttendee + schedule.timeSlots.filter(function (_ref) {
      var isRented = _ref.isRented;
      return isRented;
    }).length;
  }

  return upsellQuantityAttendee + 1;
};

var upsellQuantityAttendeeReducer = function upsellQuantityAttendeeReducer(upsellQuantity, attendee) {
  return upsellQuantity + attendee.schedules.reduce(upsellQuatityScheduleReducer, 0);
};

var getUpSellQuantity = function getUpSellQuantity(pricingInfo) {
  if (['TRANSFER', 'INSURANCE'].includes(pricingInfo.type)) {
    return 1;
  }

  if (!pricingInfo.isPartiallyRented) {
    return 0;
  } // new Format ski wellness ...


  if (pricingInfo.attendees) {
    return pricingInfo.attendees.reduce(upsellQuantityAttendeeReducer, 0);
  } // old format ie : childcare etc ..


  return pricingInfo.schedules.reduce(function (totalSchedules, _ref2) {
    var attendees = _ref2.attendees;
    return totalSchedules + attendees.reduce(function (totalAttendees, _ref3) {
      var isRented = _ref3.isRented;
      return totalAttendees + (isRented ? 1 : 0);
    }, 0);
  }, 0);
};
var upSellTypeMapping = {
  CHILDCARE: 'childcare',
  EXCURSION: 'excursion',
  LAND_SPORT: 'landSport',
  RENTAL: 'ski',
  TRANSFER: 'transfer',
  WATER_SPORT: 'waterSport',
  WINTER_SPORT: 'winterSport',
  WELLNESS: 'wellness',
  INSURANCE: 'insurance'
};
var getDefaultUpsellTrackingProps = function getDefaultUpsellTrackingProps(appContext, proposal) {
  var _proposal$resort, _proposal$resort$dest, _proposal$resort2, _proposal$additionalS, _proposal$additionalS2, _proposal$additionalS3;

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_29__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    categoryGA: 'upsellTransaction'
  }, appContext.isCmta && {
    agenceType: appContext.cmta.isDelCredere ? 'Ducroire' : 'NonDucroire'
  }), (proposal === null || proposal === void 0 ? void 0 : proposal.packageId) !== _utils_payment_constants__WEBPACK_IMPORTED_MODULE_27__[/* JOYVIEW_UPSELL_RON_PACKAGEID */ "g"] && {
    upsellTransaction: 1
  }), {}, {
    upsell: 'yes',
    actionGA: proposal === null || proposal === void 0 ? void 0 : (_proposal$resort = proposal.resort) === null || _proposal$resort === void 0 ? void 0 : (_proposal$resort$dest = _proposal$resort.destination) === null || _proposal$resort$dest === void 0 ? void 0 : _proposal$resort$dest.country,
    roomType: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_23__[/* getTrackingRoomType */ "l"])(proposal.accommodations),
    labelGA: proposal === null || proposal === void 0 ? void 0 : (_proposal$resort2 = proposal.resort) === null || _proposal$resort2 === void 0 ? void 0 : _proposal$resort2.id,
    insuranceSubscribed: (_proposal$additionalS = proposal.additionalServices.insurance) === null || _proposal$additionalS === void 0 ? void 0 : _proposal$additionalS.some(function (_ref4) {
      var pricingInfo = _ref4.pricingInfo;
      return pricingInfo.isPartiallyRented;
    }),
    transfer: (proposal === null || proposal === void 0 ? void 0 : (_proposal$additionalS2 = proposal.additionalServices) === null || _proposal$additionalS2 === void 0 ? void 0 : (_proposal$additionalS3 = _proposal$additionalS2.transfers) === null || _proposal$additionalS3 === void 0 ? void 0 : _proposal$additionalS3.some(function (_ref5) {
      var pricingInfo = _ref5.pricingInfo;
      return pricingInfo.isPartiallyRented;
    })) ? 'yes' : 'no'
  });
};
var trackUpsell = function trackUpsell(trackEvent, proposal, upsellRevenue) {
  var storage = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_26__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_21__[/* BE_TRACKING */ "c"]); // $FlowFixMe

  var roomFilters = storage.roomFilters || []; // $FlowFixMe

  var roomOptions = storage.roomOptions || {};
  var tracking = {
    upsell_revenue: upsellRevenue,
    upsell_category: 'room',
    upsell_name: proposal.accommodations[0].id,
    upsell_quantity: proposal.accommodations.reduce(function (quantity, accommodation) {
      return quantity + accommodation.quantity;
    }, 0)
  };

  if ('upsell' in roomOptions && roomOptions.upsell === 'yes' && roomOptions.proposalId === proposal.id) {
    Object.assign(tracking, {
      upsell_revenue: roomOptions.upsellRevenue,
      upsell_category: roomOptions.upsellCategory,
      upsell_name: roomOptions.upsellName,
      upsell_quantity: roomOptions.upsellQuantity
    });
  }

  if (roomFilters.length) {
    roomFilters.filter(function (roomFilter) {
      return roomFilter.proposalId === proposal.id;
    }).forEach(function (filter) {
      if (filter.upsellRevenue > 0) {
        trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_21__[/* TRACK_EVENT_NAMES */ "F"].UPSELL_TRANSACTION, lodash_omit__WEBPACK_IMPORTED_MODULE_17___default()(_objectSpread(_objectSpread({}, tracking), {}, {
          upsell_revenue: filter.upsellRevenue,
          upsell_category: filter.upsellCategory,
          upsell_name: filter.upsellName
        }), 'proposalId'));
      }
    });
  }

  if (tracking.upsell_revenue > 0) {
    trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_21__[/* TRACK_EVENT_NAMES */ "F"].UPSELL_TRANSACTION, lodash_omit__WEBPACK_IMPORTED_MODULE_17___default()(tracking, 'proposalId'));
  }

  _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_26__[/* set */ "c"](_objectSpread(_objectSpread({}, storage), {}, {
    roomFilters: [],
    roomOptions: {}
  }));
};
var trackJoyViewUpsell = function trackJoyViewUpsell(trackEvent, proposal, joyviewUpSell) {
  trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_21__[/* TRACK_EVENT_NAMES */ "F"].UPSELL_TRANSACTION, {
    upsell_category: 'joyview',
    upsell_name: proposal.packageId,
    upsell_quantity: 1,
    upsell_revenue: joyviewUpSell
  });
};
var trackAbTasty = function trackAbTasty(proposal, appContext, bookingId) {
  var _accommodations$, _price$total, _price$total2, _price$total3;

  var price = proposal.price,
      resort = proposal.resort,
      accommodations = proposal.accommodations;
  var exclusiveCollection = Object(_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_25__[/* getExclusiveCollectionFromAccomodation */ "d"])(resort === null || resort === void 0 ? void 0 : resort.hasECSpace, accommodations === null || accommodations === void 0 ? void 0 : (_accommodations$ = accommodations[0]) === null || _accommodations$ === void 0 ? void 0 : _accommodations$.exclusiveCollection);
  Object(_components_utils_ab_tasty_abTasty_utils__WEBPACK_IMPORTED_MODULE_24__[/* sendTransaction */ "c"])({
    affiliation: 'purchase',
    currency: (price === null || price === void 0 ? void 0 : (_price$total = price.total) === null || _price$total === void 0 ? void 0 : _price$total.currency) || '',
    id: bookingId,
    revenue: price === null || price === void 0 ? void 0 : (_price$total2 = price.total) === null || _price$total2 === void 0 ? void 0 : _price$total2.value
  });
  Object(_components_utils_ab_tasty_abTasty_utils__WEBPACK_IMPORTED_MODULE_24__[/* sendItem */ "b"])({
    id: bookingId,
    name: (resort === null || resort === void 0 ? void 0 : resort.name) || '',
    price: price === null || price === void 0 ? void 0 : (_price$total3 = price.total) === null || _price$total3 === void 0 ? void 0 : _price$total3.value,
    code: (resort === null || resort === void 0 ? void 0 : resort.id) || '',
    category: exclusiveCollection
  });
};
var trackAdditionnalServicesRented = function trackAdditionnalServicesRented(trackEvent, additionalServicesRented) {
  return additionalServicesRented.map(function (additionalService, index, additionalServices) {
    /* in case of services containing time slots each time slot is a unique service
     so to calculate the total amount and the quantity we need to iterate over
     each service sharing the same productInfo.id
    */
    var existingServiceIndex = additionalServices.findIndex(function (service) {
      return service.productInfo.id === additionalService.productInfo.id;
    });

    if (existingServiceIndex && existingServiceIndex !== index) {
      var existingService = additionalServices[existingServiceIndex];
      existingService.pricingInfo.schedules = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(existingService.pricingInfo.schedules), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(additionalService.pricingInfo.schedules));
      existingService.pricingInfo.rentedAmount.value += additionalService.pricingInfo.rentedAmount.value;
    } else {
      return additionalService;
    }
  }).filter(Boolean).forEach(function (_ref6) {
    var pricingInfo = _ref6.pricingInfo,
        productInfo = _ref6.productInfo;
    pricingInfo.rentedAmount.value > 0 && trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_21__[/* TRACK_EVENT_NAMES */ "F"].UPSELL_TRANSACTION, {
      upsell_category: upSellTypeMapping[pricingInfo.type],
      upsell_name: productInfo.id,
      upsell_revenue: pricingInfo.rentedAmount.value,
      upsell_quantity: getUpSellQuantity(pricingInfo)
    });
  });
};
var computeTransferTrackingValue = function computeTransferTrackingValue(proposal, selectedTransfers) {
  if (proposal.transports) {
    return 'yes with transport';
  }

  if (selectedTransfers.length > 0) {
    return 'yes without transport';
  }

  return 'no';
};
var eventTracking = function eventTracking(optionID, appContext, queryParams) {
  var data = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_26__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_21__[/* BE_TRACKING */ "c"]);
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_22__[/* setDataLayer */ "b"](_objectSpread({
    categoryGA: 'option',
    labelGA: lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(data, 'basePriceParticipant'),
    siteSection: 'Booking Engine'
  }, optionID ? {
    actionGA: optionID
  } : {}), appContext);

  if (queryParams.futureTravelCreditOption === 'true') {
    _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_22__[/* setDataLayer */ "b"]({
      categoryGA: 'optionFTC',
      labelGA: optionID,
      actionGA: 'confirmation',
      siteSection: 'Booking Engine'
    }, appContext);
  }
};
var getConfirmationProps = function getConfirmationProps(_ref7) {
  var location = _ref7.location,
      bookingId = _ref7.bookingId,
      config = _ref7.config,
      proposal = _ref7.proposal,
      isCmta = _ref7.isCmta,
      isSeller = _ref7.isSeller,
      isNotDelCredere = _ref7.isNotDelCredere,
      hasSaveOption = _ref7.hasSaveOption,
      expirationTime = _ref7.expirationTime,
      isReliable = _ref7.isReliable;
  var params = location.urlParams,
      queryParams = location.queryParams;

  var resortName = lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(proposal, 'resort.name');

  var _config$booking = config.booking,
      _config$booking$optio = _config$booking.option.confirmation,
      failureImmersiveTitle = _config$booking$optio.failureImmersiveTitle,
      failureDescription = _config$booking$optio.failureDescription,
      successTitle = _config$booking$optio.successTitle,
      successDescription2 = _config$booking$optio.successDescription2,
      aBookingAlreadyExistsTitle = _config$booking$optio.aBookingAlreadyExistsTitle,
      aBookingAlreadyExistsDescription = _config$booking$optio.aBookingAlreadyExistsDescription,
      aBookingAlreadyExistsDescription2 = _config$booking$optio.aBookingAlreadyExistsDescription2,
      itemOfTheBookingNotAvailableTitle = _config$booking$optio.itemOfTheBookingNotAvailableTitle,
      itemOfTheBookingNotAvailableDescription = _config$booking$optio.itemOfTheBookingNotAvailableDescription,
      partners = _config$booking.partners,
      failure = _config$booking.confirmation.failure;
  var isNotDelCredereCmta = isCmta && isNotDelCredere;
  var failureTitle = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["messageFormat"])(failure.headSentence).format({
    resortName: resortName
  });
  var failureMessage = failure.notCompletedMessage;
  var isFtcOption = queryParams.futureTravelCreditOption === 'true';

  switch (parseInt(params.status, 10)) {
    case _utils_status_code_statusCode_constants__WEBPACK_IMPORTED_MODULE_28__[/* STATUS_CODE_200 */ "a"]:
      var defaultSuccessProps = {
        type: 'OPTION',
        status: 'SUCCESS',
        bookingId: bookingId,
        expirationTime: expirationTime,
        isReliable: isReliable
      };

      if (isFtcOption) {
        return _objectSpread(_objectSpread({}, defaultSuccessProps), {}, {
          title: Object(_i18n__WEBPACK_IMPORTED_MODULE_20__[/* t */ "h"])('booking.summary.futureTravelCredit.confirmation.title'),
          message: Object(_i18n__WEBPACK_IMPORTED_MODULE_20__[/* t */ "h"])('booking.summary.futureTravelCredit.confirmation.information')
        });
      }

      if (isNotDelCredereCmta && !hasSaveOption) {
        return _objectSpread(_objectSpread({}, defaultSuccessProps), {}, {
          title: Object(_i18n__WEBPACK_IMPORTED_MODULE_20__[/* t */ "h"])('booking.partners.confirmation.noDelcredere.headSentence'),
          message: Object(_i18n__WEBPACK_IMPORTED_MODULE_20__[/* t */ "h"])('booking.partners.confirmation.noDelcredere.bookingCompleteAdditionalText')
        });
      }

      if (isCmta) {
        return _objectSpread(_objectSpread({}, defaultSuccessProps), {}, {
          title: Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["messageFormat"])(successTitle).format({
            resortName: resortName
          }),
          message: "".concat(partners.option.confirmation.successDescription, " ").concat(partners.phoneNumber)
        });
      }

      return {
        type: 'OPTION',
        status: 'SUCCESS',
        title: Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["messageFormat"])(successTitle).format({
          resortName: resortName
        }),
        message: successDescription2,
        bookingId: bookingId,
        expirationTime: expirationTime,
        isReliable: isReliable
      };

    case _utils_status_code_statusCode_constants__WEBPACK_IMPORTED_MODULE_28__[/* STATUS_CODE_409 */ "e"]:
      // BOOKING_ALREADY_EXISTS else BOOKING_UNAVAILABLE
      var aBookingAlreadyExistsMessageType = isSeller ? aBookingAlreadyExistsDescription : aBookingAlreadyExistsDescription2;
      return params.error_code === 'BOOKING_ALREADY_EXISTS' ? {
        bookingId: bookingId,
        status: 'FAILURE',
        type: 'OPTION',
        title: isNotDelCredereCmta ? failureTitle : aBookingAlreadyExistsTitle,
        message: isNotDelCredereCmta ? failureMessage : aBookingAlreadyExistsMessageType
      } : {
        bookingId: bookingId,
        status: 'FAILURE',
        type: 'OPTION',
        title: isNotDelCredereCmta ? failureTitle : itemOfTheBookingNotAvailableTitle,
        message: isNotDelCredereCmta ? failureMessage : itemOfTheBookingNotAvailableDescription
      };

    default:
      return {
        type: 'OPTION',
        status: 'FAILURE',
        title: isNotDelCredereCmta ? failureTitle : Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["messageFormat"])(failureImmersiveTitle).format({
          resortName: resortName
        }),
        message: isNotDelCredereCmta ? failureMessage : failureDescription,
        bookingId: bookingId
      };
  }
};

/***/ }),

/***/ "sPPR":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("+ZX+").Buffer))

/***/ }),

/***/ "sSce":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("0a30");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("XAoU");
exports.Duplex = __webpack_require__("ulH6");
exports.Transform = __webpack_require__("SjZQ");
exports.PassThrough = __webpack_require__("lAqc");
exports.finished = __webpack_require__("5yTO");
exports.pipeline = __webpack_require__("FBOC");


/***/ }),

/***/ "sXLC":
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),

/***/ "sZKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ useBankingView_useBankingView; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.utils.js
var PaymentInfo_utils = __webpack_require__("gX9k");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/payment-form/paymentProvidersUtils.js
var paymentProvidersUtils = __webpack_require__("y5B/");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/utils/payment/constants.js
var payment_constants = __webpack_require__("hi3+");

// EXTERNAL MODULE: ./src/client/components/utils/ab-tasty/abTasty.utils.js
var abTasty_utils = __webpack_require__("FtaI");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/payment-redirect/paymentRedirectQuery.js
var paymentRedirectQuery = __webpack_require__("oJjJ");

// EXTERNAL MODULE: ./src/utils/payment/payment.utils.js
var payment_utils = __webpack_require__("aMaj");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/views/booking/banking/BankingView.utils.js





var BankingView_utils_getPaymentRedirectMutation = function getPaymentRedirectMutation(_ref) {
  var proposal = _ref.proposal,
      appContext = _ref.appContext,
      params = _ref.params;
  return function (_ref2) {
    var _appContext$cxoQueryP, _appContext$cmta, _appContext$cxoQueryP2, _appContext$cxoQueryP3;

    var amountToPay = _ref2.amountToPay,
        donationAmount = _ref2.donationAmount,
        browserInfo = _ref2.browserInfo,
        isIframe = _ref2.isIframe,
        location = _ref2.location,
        device = _ref2.device,
        comments = _ref2.comments,
        paymentProviderId = _ref2.paymentProviderId,
        shouldSkipPayment = _ref2.shouldSkipPayment,
        paymentConditionId = _ref2.paymentConditionId,
        token = _ref2.token,
        callReference = _ref2.callReference,
        contactID = _ref2.contactID,
        billingDetails = _ref2.billingDetails,
        customerId = _ref2.customerId;
    var proposalId = proposal.id;
    var callbackUrl = Object(payment_utils["a" /* getCallbackURIFromProvider */])(paymentProviderId, proposalId, appContext, location);
    return graphqlClient["a" /* default */].runNoCacheQuery(Object(paymentRedirectQuery["a" /* paymentRedirectMutation */])({
      action: payment_constants["i" /* PAYMENT_ACTION */].PAYMENT_RESA,
      callbackUrl: callbackUrl,
      bookingId: params === null || params === void 0 ? void 0 : params.bookingId,
      proposalId: proposalId,
      cancelUrl: Object(payment_utils["c" /* getCancelCallbackURI */])(appContext, location),
      iframeCallbackUrl: Object(payment_utils["d" /* getIframeCallbackUrl */])(location),
      callbackUrlSeller: Object(payment_utils["b" /* getCallbackUrlSeller */])(location),
      price: amountToPay,
      comments: comments,
      currency: proposal.price.currency,
      shouldSkipPayment: shouldSkipPayment,
      donationAmount: donationAmount,
      browserInfo: browserInfo,
      isIframe: isIframe,
      device: device,
      providerId: paymentProviderId,
      paymentConditionId: paymentConditionId,
      token: token,
      billingDetails: billingDetails,
      customerId: customerId,
      callReference: callReference,
      contactID: contactID,
      salesmanCode: ((_appContext$cxoQueryP = appContext.cxoQueryParams) === null || _appContext$cxoQueryP === void 0 ? void 0 : _appContext$cxoQueryP.salesman_code) || ((_appContext$cmta = appContext.cmta) === null || _appContext$cmta === void 0 ? void 0 : _appContext$cmta.salesmanID),
      salesNetworkId: (_appContext$cxoQueryP2 = appContext.cxoQueryParams) === null || _appContext$cxoQueryP2 === void 0 ? void 0 : _appContext$cxoQueryP2.sales_network_id,
      cxoOpportunityGuid: (_appContext$cxoQueryP3 = appContext.cxoQueryParams) === null || _appContext$cxoQueryP3 === void 0 ? void 0 : _appContext$cxoQueryP3.opportunity_id
    }), appContext, {
      requestName: requestDictionary["Ec" /* PAYMENT_REDIRECT */]
    })["catch"](function (error) {
      throw error;
    });
  };
};
// CONCATENATED MODULE: ./src/client/views/booking/banking/useBankingView.jsx























function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var useBankingView_useBankingView = function useBankingView(_ref) {
  var selectedProposal = _ref.selectedProposal,
      _ref$additionalProvid = _ref.additionalProviders,
      additionalProviders = _ref$additionalProvid === void 0 ? [] : _ref$additionalProvid,
      resort = _ref.resort,
      attendeesPaymentStatus = _ref.attendeesPaymentStatus;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var queryParams = router.query;
  var paymentStatus = queryParams.paymentStatus,
      bookingId = queryParams.bookingId;

  var _useState = Object(react["useState"])(false),
      openFailedPaymentModal = _useState[0],
      setOpenFailedPaymentModal = _useState[1];

  var firstUnpaidHouseholdIndex = attendeesPaymentStatus.findIndex(function (status) {
    return !(status === null || status === void 0 ? void 0 : status.hasPaid);
  });

  var _useState2 = Object(react["useState"])(0),
      currentPayingHouseholdIndex = _useState2[0],
      setCurrentPayingHouseholdIndex = _useState2[1];

  Object(react["useEffect"])(function () {
    if (firstUnpaidHouseholdIndex !== -1) {
      setCurrentPayingHouseholdIndex(firstUnpaidHouseholdIndex);
    }
  }, [firstUnpaidHouseholdIndex]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var entryRoute = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.entryRoute;
  });
  var paymentProviders = Object(es["e" /* useSelector */])(booking_selector["s" /* getPaymentProviders */]).reduce(function (allProviders, provider) {
    if (!provider.shouldSkipPayment) {
      provider.selectorId = provider.id;
    }

    allProviders.push(provider);
    return allProviders;
  }, []);
  var track = Object(useTracking["a" /* useTracking */])(_objectSpread(_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'banking'
  }));
  var arrivalDate = selectedProposal.transports && selectedProposal.transports.inbound ? selectedProposal.transports.inbound.travelSections[0].departure.date : selectedProposal.arrivalDate;
  var paymentProvidersWithValidMethods = Object(paymentProvidersUtils["l" /* sanitizePaymentProviders */])({
    paymentProviders: [].concat(Object(toConsumableArray["a" /* default */])(paymentProviders), Object(toConsumableArray["a" /* default */])(additionalProviders)),
    arrivalDate: arrivalDate,
    locale: appContext.locale
  });

  var handleFailedPaymentModalClose = function handleFailedPaymentModalClose() {
    var newUri = new URI_default.a(router.asPath).removeQuery(['paymentStatus']);
    router.replace(newUri.toString());
    setOpenFailedPaymentModal(false);
  };

  Object(react["useEffect"])(function () {
    if ((paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.toUpperCase()) === payment_constants["r" /* PAYMENT_STATUS_REFUSED_PSP */]) {
      setOpenFailedPaymentModal(true);
      track({
        labelGA: 'validate_Popin_PaiementRefusedPSP',
        valueGA: 0,
        nonInteraction: 0,
        versionBooking: 'responsive'
      });
    }
  }, [paymentStatus]);
  var hasAllBasePaymentData = paymentProviders.length > 0 && selectedProposal.households.every(function (household) {
    return household.paymentSchedule;
  });
  Object(react["useEffect"])(function () {
    var _selectedProposal$add, _selectedProposal$hou, _selectedProposal$hou2;

    Object(abTasty_utils["d" /* storeAbTastyEvent */])();
    tracking_storage_api["c" /* set */](_objectSpread(_objectSpread({}, tracking_storage_api["b" /* get */](constants["c" /* BE_TRACKING */])), {}, {
      roomType: Object(utils["l" /* getTrackingRoomType */])(selectedProposal.accommodations),
      insuranceSubscribed: (_selectedProposal$add = selectedProposal.additionalServices.insurance) === null || _selectedProposal$add === void 0 ? void 0 : _selectedProposal$add.some(function (_ref2) {
        var pricingInfo = _ref2.pricingInfo;
        return pricingInfo.isPartiallyRented;
      })
    }));
    var priceHasChanged = selectedProposal.price.total.value !== ((_selectedProposal$hou = selectedProposal.households[currentPayingHouseholdIndex]) === null || _selectedProposal$hou === void 0 ? void 0 : (_selectedProposal$hou2 = _selectedProposal$hou.paymentSchedule) === null || _selectedProposal$hou2 === void 0 ? void 0 : _selectedProposal$hou2.total.value); // check for updates in price due to back browser button => re-Fetch the new selectedProposal Price
    // also prevent from double call in refresh for ex

    if (!hasAllBasePaymentData || priceHasChanged) {
      dispatch(Object(proposals_action["n" /* fetchSelectedProposalPayment */])(selectedProposal, appContext));
    }
  }, []);
  var bookingResume = {
    proposalId: selectedProposal.id,
    arrivalDate: selectedProposal.departureDate,
    departureDate: selectedProposal.arrivalDate,
    name: resort.name,
    accommodations: {
      count: selectedProposal.accommodationsCount,
      name: selectedProposal.accommodations[0].category
    },
    transports: Object(PaymentInfo_utils["d" /* mapTransportResume */])(selectedProposal.transports),
    attendees: selectedProposal.attendees.list.map(function (_ref3) {
      var customerId = _ref3.customerId;
      return customerId || '';
    })
  };
  var paymentInfoValue = Object(react["useMemo"])(function () {
    var _selectedProposal$pri, _selectedProposal$pri2;

    return {
      trackPayment: Object(PaymentInfo_utils["c" /* getTrackPaymentFunc */])({
        proposal: selectedProposal,
        track: track,
        donationAmount: ((_selectedProposal$pri = selectedProposal.price.donation) === null || _selectedProposal$pri === void 0 ? void 0 : _selectedProposal$pri.value) || 0
      }),
      paymentRedirectMutation: BankingView_utils_getPaymentRedirectMutation({
        proposal: selectedProposal,
        appContext: appContext,
        params: {
          bookingId: bookingId
        }
      }),
      bookingResume: bookingResume,
      currency: selectedProposal.price.currency,
      donationAmount: ((_selectedProposal$pri2 = selectedProposal.price.donation) === null || _selectedProposal$pri2 === void 0 ? void 0 : _selectedProposal$pri2.value) || '',
      getPaymentErrorMessagePath: PaymentInfo_utils["b" /* getPaymentErrorMessagePath */],
      onPaymentProgress: function onPaymentProgress(_location) {
        // EOgone psp cannot handle long urls (200 char max),
        // we save proposal id as cookie for the confirmation page
        // see buildRedirectionBE
        js_cookie_default.a.set(booking_constants["k" /* BOOKING_SELECTED_RESORT_ID */], selectedProposal.id, {
          sameSite: 'none',
          secure: true
        }); // The cancelUrl can be too long for the psp so we store in cookies for rehydrate if the user came back #8641

        js_cookie_default.a.set(booking_constants["j" /* BOOKING_QUERY_PARAMS */], _location.search(), {
          sameSite: 'none',
          secure: true
        }); // set the enryRoute in case we came from the comparator to use in confirmation page

        js_cookie_default.a.set(booking_constants["i" /* BOOKING_ENTRY_ROUTE */], entryRoute);
      }
    };
  }, [selectedProposal]);
  var household = selectedProposal.households[0];
  var payingHousehold = {
    paymentSchedule: household.paymentSchedule,
    // $FlowFixMe always present
    customerId: household.attendees[0].customerId
  };
  var hasBasePaymentData = household.paymentSchedule && paymentProviders.length > 0;
  var householdPaymentStatus = attendeesPaymentStatus.find(function (bookingAttendee) {
    return bookingAttendee.customerId === household.attendees[0].customerId;
  });
  var hasPaid = (householdPaymentStatus === null || householdPaymentStatus === void 0 ? void 0 : householdPaymentStatus.hasPaid) || false;
  return {
    openFailedPaymentModal: openFailedPaymentModal,
    handleFailedPaymentModalClose: handleFailedPaymentModalClose,
    paymentInfoValue: paymentInfoValue,
    hasBasePaymentData: hasBasePaymentData,
    hasPaid: hasPaid,
    paymentProvidersWithValidMethods: paymentProvidersWithValidMethods,
    paymentProviders: paymentProviders,
    household: household,
    payingHousehold: payingHousehold
  };
};

/***/ }),

/***/ "tB8f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("ZK3j");

var SHA512 = __webpack_require__("iglS");

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),

/***/ "tizd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "tuzA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRateMessagesProperties; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var FLEX_RATES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["constants"].FLEX_RATES;
var getRateMessagesProperties = function getRateMessagesProperties(rate) {
  switch (rate) {
    case FLEX_RATES.NRR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLegal')
      };

    case FLEX_RATES.FLR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLegal')
      };

    default:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLegal')
      };
  }
};

/***/ }),

/***/ "uFXj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var createHTML = __webpack_require__("gIHd");
var forcedStringHTMLMethod = __webpack_require__("sHxg");

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uMuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayPriceDoubleSeasonPopin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("fGyu");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("05v4");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("e0Ti");
/* harmony import */ var _product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("hA0C");
















var __jsx = react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */








var DayPriceDoubleSeasonPopin = function DayPriceDoubleSeasonPopin(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey,
      trackingData = _ref.trackingData;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__[/* useTracking */ "a"])();
  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_16__["useRouter"])();
  var uri = router.asPath;
  var doubleSeasonPopinMessageKey = "booking.priceCalendar.priceStatus.".concat(availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 'siblingDescriptionSummer' : 'siblingDescriptionWinter');
  var productCountry = product.destination.country,
      _product$href = product.href,
      href = _product$href === void 0 ? '' : _product$href,
      productName = product.name,
      iconName = product.resortId;
  var splittedHref = href.split('/');
  var siblingHref = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(splittedHref.slice(0, splittedHref.length - 1)), [availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 's' : 'w']).join('/');

  var handleBlur = function handleBlur() {
    if (setIsMouseOverDoubleSeasonPopin) {
      setTimeout(function () {
        setIsMouseOverDoubleSeasonPopin(false);
      }, 200);
    }

    setInvisible && setInvisible();
  };

  var handleFocus = function handleFocus() {
    return setIsMouseOverDoubleSeasonPopin && setIsMouseOverDoubleSeasonPopin(true);
  };

  return __jsx("div", {
    className: "pointer-events-auto flex cursor-default flex-col items-center justify-center gap-20 bg-white p-30",
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: function onKeyDown(e) {
      e.preventDefault();
      e.stopPropagation();

      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__[/* ENTER */ "f"]) {
        router.push(uri.replace(href, siblingHref));
      } else {
        handleBlur();
      }
    },
    onMouseOver: handleFocus,
    onMouseLeave: handleBlur,
    tabIndex: -1
  }, __jsx("div", {
    className: "flex flex-col items-center justify-center gap-10"
  }, __jsx(_product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__[/* ProductLogo */ "a"], {
    iconName: iconName,
    productCountry: productCountry,
    productName: productName,
    theme: "calendar"
  }), __jsx("p", {
    className: "rounded-4 bg-turquoise px-10 py-5 text-12 font-bold text-white"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(statusMessageKey))), __jsx("p", {
    className: "text-center text-14 leading-tight text-black sm:leading-normal"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(doubleSeasonPopinMessageKey)), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__[/* Button */ "a"], {
    className: "pointer-events-auto w-full",
    "data-testid": "DayWithPrice-DoubleSeasonPopin-seeOtherSeason",
    onBlur: handleBlur,
    onClick: function onClick(e) {
      track(_objectSpread({
        categoryGA: 'resort',
        labelGA: 'switchSeason'
      }, trackingData));
      e.preventDefault();
      e.stopPropagation();
      router.push(uri.replace(href, siblingHref));
    },
    onFocus: handleFocus,
    size: "medium",
    tabIndex: 0
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('booking.priceCalendar.priceStatus.siblingButton')));
};

/***/ }),

/***/ "ufvR":
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(5);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),

/***/ "ulH6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__("0a30");
var Writable = __webpack_require__("XAoU");
__webpack_require__("qW1w")(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "v05O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__("QoQd");
curve.short = __webpack_require__("RCYE");
curve.mont = __webpack_require__("F5Sq");
curve.edwards = __webpack_require__("bsME");


/***/ }),

/***/ "vF8l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__("Aa7t");

/*<replacement>*/
var util = Object.create(__webpack_require__("a1wc"));
util.inherits = __webpack_require__("qW1w");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "vqf+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Helper
function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
}

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = reverse(exports.tag);


/***/ }),

/***/ "w30G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__("X05J");
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite =  false ? undefined : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__("a1wc"));
util.inherits = __webpack_require__("qW1w");
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("P2aG")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("/kXe");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("KLyV").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__("NhVp");

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__("wYax");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__("wYax");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "wKb0":
/***/ (function(module, exports) {

var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

module.exports = function (iterations, keylen) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}


/***/ }),

/***/ "wO2t":
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m
var evp = __webpack_require__("JvEg")
var ciphers = __webpack_require__("jRCX")
var Buffer = __webpack_require__("KLyV").Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),

/***/ "wYax":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__("X05J");
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__("a1wc"));
util.inherits = __webpack_require__("qW1w");
/*</replacement>*/

var Readable = __webpack_require__("qw6+");
var Writable = __webpack_require__("w30G");

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),

/***/ "wyfB":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIntersection = __webpack_require__("1sLo"),
    baseIteratee = __webpack_require__("S3pA"),
    baseRest = __webpack_require__("R3TX"),
    castArrayLikeObject = __webpack_require__("VZDm"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = baseRest(function(arrays) {
  var iteratee = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  if (iteratee === last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, baseIteratee(iteratee, 2))
    : [];
});

module.exports = intersectionBy;


/***/ }),

/***/ "xGYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputNumber_InputNumber; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasColumnLayout = _ref.hasColumnLayout,
        hasValue = _ref.hasValue,
        isDisabled = _ref.isDisabled,
        isReadOnly = _ref.isReadOnly,
        validationState = _ref.validationState;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('flex items-center', {
        'flex-col gap-5 text-center': hasColumnLayout,
        'justify-between gap-10': !hasColumnLayout
      }),
      thLabel: Object(classnames_utils["a" /* classnames */])('text-14', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thNotes: 'block text-10',
      thInputs: 'flex gap-5 items-center shrink-0',
      thInput: Object(classnames_utils["a" /* classnames */])('outline-custom h-30 text-center text-18 font-bold leading-[1.875em]', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thButton: 'aspect-square cursor-pointer disabled:cursor-default bg-saffron hocus:enabled:bg-saffron-active disabled:bg-pearl rounded-pill shrink-0 disabled:text-grey transition-colors duration-250 ease-in size-48',
      thButtonIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx














var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var InputNumber_InputNumber = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputNumber, _Component);

  var _super = _createSuper(InputNumber);

  function InputNumber(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputNumber);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = Number(e.target.value);

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "decrease", function () {
      var _this$props2 = _this.props,
          _this$props2$name = _this$props2.name,
          name = _this$props2$name === void 0 ? '' : _this$props2$name,
          _this$props2$min = _this$props2.min,
          min = _this$props2$min === void 0 ? 0 : _this$props2$min,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? 1 : _this$props2$step,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? noop_default.a : _this$props2$onChange;
      var currentValue = _this.state.value || min;
      var decreasedValue = currentValue - step;
      var nextValue = decreasedValue >= min ? decreasedValue : min;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "increase", function () {
      var _this$props3 = _this.props,
          _this$props3$name = _this$props3.name,
          name = _this$props3$name === void 0 ? '' : _this$props3$name,
          _this$props3$min = _this$props3.min,
          min = _this$props3$min === void 0 ? 0 : _this$props3$min,
          _this$props3$max = _this$props3.max,
          max = _this$props3$max === void 0 ? 10 : _this$props3$max,
          _this$props3$step = _this$props3.step,
          step = _this$props3$step === void 0 ? 1 : _this$props3$step,
          _this$props3$onChange = _this$props3.onChange,
          onChange = _this$props3$onChange === void 0 ? noop_default.a : _this$props3$onChange;
      var currentValue = _this.state.value || min;
      var increasedValue = currentValue + step;
      var nextValue = increasedValue <= max ? increasedValue : max;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputNumber, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ariaLabel = _this$props4.ariaLabel,
          autoComplete = _this$props4.autoComplete,
          className = _this$props4.className,
          _this$props4$dataTest = _this$props4.dataTestId,
          dataTestId = _this$props4$dataTest === void 0 ? 'InputNumber' : _this$props4$dataTest,
          _this$props4$hasColum = _this$props4.hasColumnLayout,
          hasColumnLayout = _this$props4$hasColum === void 0 ? false : _this$props4$hasColum,
          _this$props4$id = _this$props4.id,
          id = _this$props4$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputNumber_') : _this$props4$id,
          isDisabled = _this$props4.isDisabled,
          isLoading = _this$props4.isLoading,
          isReadOnly = _this$props4.isReadOnly,
          isRequired = _this$props4.isRequired,
          label = _this$props4.label,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? 10 : _this$props4$max,
          _this$props4$min = _this$props4.min,
          min = _this$props4$min === void 0 ? 1 : _this$props4$min,
          name = _this$props4.name,
          notes = _this$props4.notes,
          onBlur = _this$props4.onBlur,
          onClick = _this$props4.onClick,
          onFocus = _this$props4.onFocus,
          onKeyDown = _this$props4.onKeyDown,
          onKeyUp = _this$props4.onKeyUp,
          placeholder = _this$props4.placeholder,
          step = _this$props4.step,
          theme = _this$props4.theme,
          validationState = _this$props4.validationState;
      var value = this.state.value;
      var hasValue = Boolean(value);
      var decreaseDisabled = isDisabled || isLoading || Number(value) <= min;
      var increaseDisabled = isDisabled || isLoading || Number(value) >= max;

      var _themes$theme = themes[theme]({
        hasColumnLayout: hasColumnLayout,
        hasValue: hasValue,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        validationState: validationState
      }),
          thButton = _themes$theme.thButton,
          thButtonIconWidth = _themes$theme.thButtonIconWidth,
          thInput = _themes$theme.thInput,
          thInputs = _themes$theme.thInputs,
          thLabel = _themes$theme.thLabel,
          thNotes = _themes$theme.thNotes,
          thRoot = _themes$theme.thRoot;

      if (false) {}

      return __jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
        "data-testid": dataTestId
      }, !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, label, !!notes && __jsx("span", {
        className: thNotes
      }, notes)), __jsx("div", {
        className: thInputs
      }, !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-decrease"),
        disabled: decreaseDisabled,
        onClick: this.decrease,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].MINUS,
        width: thButtonIconWidth
      })), __jsx("input", Object(esm_extends["a" /* default */])({
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        id: id,
        max: max,
        min: min // $FlowFixMe

      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
      }, placeholder ? {
        placeholder: placeholder
      } : null, {
        readOnly: true,
        required: isRequired,
        step: step,
        style: {
          width: "".concat(max.toString().length + 0.5, "em")
        },
        type: "number",
        value: value
      })), !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-increase"),
        disabled: increaseDisabled,
        onClick: this.increase,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PLUS,
        width: thButtonIconWidth
      }))));
    }
  }]);

  return InputNumber;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputNumber_InputNumber, "defaultProps", {
  autoComplete: 'off',
  max: 10,
  min: 0,
  step: 1,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "xc2Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("r2q8").EventEmitter;


/***/ }),

/***/ "xy6B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("ZK3j");
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),

/***/ "y0P9":
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__("4Z+A")
var Buffer = __webpack_require__("KLyV").Buffer
var Transform = __webpack_require__("7IvJ")
var inherits = __webpack_require__("qW1w")

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),

/***/ "y0X/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PriceDetailLines; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _accordion_block_AccordionItem__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("7E63");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var PriceDetailLines = function PriceDetailLines(_ref) {
  var trackingEventName = _ref.trackingEventName,
      priceDetail = _ref.priceDetail;
  return priceDetail && priceDetail.map(function (props, index) {
    return __jsx(_accordion_block_AccordionItem__WEBPACK_IMPORTED_MODULE_11__[/* AccordionItem */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({
      key: index
    }, props, {
      trackingData: _objectSpread(_objectSpread({}, props.trackingData), {}, {
        event: trackingEventName || props.trackingData.event
      })
    }));
  });
};

/***/ }),

/***/ "y5B/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEnabledPaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sanitizePaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return creditCardExpiryValidator; });
/* unused harmony export creditCardCVCValidator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isCreditCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isPayPal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isBuyNowPayLater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isVoxpayProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isCheque; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getOrderedPaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPaymentProviderLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleClickPaymentProviderBlock; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ulNE");
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("urw/");
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("3voH");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("BU6i");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("L7OA");
/* harmony import */ var _utils_payment_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("hi3+");

















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}








var getEnabledPaymentProviders = function getEnabledPaymentProviders(paymentProviders, isMobile, appContext) {
  return (paymentProviders || []).filter(function (provider) {
    return Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_21__[/* isFeatureFlipped */ "a"])(appContext, isMobile)("psp.".concat(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(provider, 'selectorId', '').toLowerCase())) || provider.ignore;
  });
};
var sanitizePaymentProviders = function sanitizePaymentProviders(_ref) {
  var paymentProviders = _ref.paymentProviders,
      arrivalDate = _ref.arrivalDate,
      locale = _ref.locale;
  var daysBeforeTravel = moment__WEBPACK_IMPORTED_MODULE_16___default()(arrivalDate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_20__[/* API_DATE_FORMAT */ "a"]).diff(moment__WEBPACK_IMPORTED_MODULE_16___default()(), 'days');
  var filteredPaymentProviders = paymentProviders.filter(function (_ref2) {
    var requiredDelayBeforeDeparture = _ref2.requiredDelayBeforeDeparture;
    return !requiredDelayBeforeDeparture || requiredDelayBeforeDeparture === 0 || requiredDelayBeforeDeparture < daysBeforeTravel;
  });

  if (locale === 'de-DE' && daysBeforeTravel <= 6) {
    return filteredPaymentProviders.map(function (psp) {
      return _objectSpread(_objectSpread({}, psp), {}, {
        paymentMethods: psp.paymentMethods.filter(function (_ref3) {
          var id = _ref3.id;
          return id !== _utils_payment_constants__WEBPACK_IMPORTED_MODULE_22__[/* PAYMENT_METHOD_ID_DIRECT_DEBIT */ "k"];
        })
      });
    });
  }

  return filteredPaymentProviders;
};
var creditCardExpiryValidator = yup__WEBPACK_IMPORTED_MODULE_17__["mixed"]().test('hasCreditCardExpired', 'Credit card has expired', function (value) {
  var expiryDate = moment__WEBPACK_IMPORTED_MODULE_16___default()(value);
  return expiryDate.isValid() && !expiryDate.isBefore(moment__WEBPACK_IMPORTED_MODULE_16___default()(), 'month');
}).required();
var creditCardCVCValidator = yup__WEBPACK_IMPORTED_MODULE_17__["string"]().min(3).max(4).matches(/^[0-9]*$/).required();
var isTransfer = function isTransfer(paymentProvider) {
  return paymentProvider.categoryPaymentMethod === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_18__[/* PAYMENT_METHOD_CATEGORY */ "l"].BANK_TRANSFER;
};
var isCreditCard = function isCreditCard(paymentProvider) {
  return paymentProvider.categoryPaymentMethod === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_18__[/* PAYMENT_METHOD_CATEGORY */ "l"].CREDIT_CARD;
};
var isPayPal = function isPayPal(paymentProvider) {
  return paymentProvider.categoryPaymentMethod === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_18__[/* PAYMENT_METHOD_CATEGORY */ "l"].PAYPAL;
};
var isBuyNowPayLater = function isBuyNowPayLater(paymentProvider) {
  return paymentProvider.categoryPaymentMethod === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_18__[/* PAYMENT_METHOD_CATEGORY */ "l"].BUY_NOW_PAY_LATER;
};
var isVoxpayProvider = function isVoxpayProvider(providerId) {
  return providerId === null || providerId === void 0 ? void 0 : providerId.startsWith(_PaymentInfo_const__WEBPACK_IMPORTED_MODULE_18__[/* VOXPAY_PSP_ID_PREFIX */ "q"]);
};
var isCheque = function isCheque(paymentProvider) {
  return paymentProvider.categoryPaymentMethod === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_18__[/* PAYMENT_METHOD_CATEGORY */ "l"].CHEQUE;
};
var getOrderedPaymentProviders = function getOrderedPaymentProviders(paymentProviders, displayOrder) {
  if (!displayOrder) {
    return paymentProviders;
  }

  var displayOrderSchema = displayOrder.split(',');
  return displayOrderSchema.map(function (id) {
    return paymentProviders.filter(function (paymentProvider) {
      return paymentProvider.id === id.trim() || paymentProvider.ignore;
    });
  }) // $FlowFixMe issue .flat() on map()
  .flat().filter(Boolean);
};
var getPaymentProviderLabel = function getPaymentProviderLabel(_ref4) {
  var paymentProvider = _ref4.paymentProvider,
      isTotalAmount = _ref4.isTotalAmount;
  var amountLabelKey = isTotalAmount ? 'totalAmount' : 'depositAmount';
  var amountShortLabelKey = isTotalAmount ? 'totalAmount' : 'deposit';

  if (isTransfer(paymentProvider)) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])("booking.banking.paymentProvider.bankTransfer.".concat(amountShortLabelKey));
  }

  if (isPayPal(paymentProvider)) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])("booking.banking.paymentProvider.paypal.".concat(amountLabelKey));
  }

  if (isBuyNowPayLater(paymentProvider)) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('booking.banking.paymentProvider.creditCard.totalAmount');
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])("booking.banking.paymentProvider.creditCard.".concat(amountShortLabelKey));
};
var handleClickPaymentProviderBlock = function handleClickPaymentProviderBlock(_ref5) {
  var paymentProvider = _ref5.paymentProvider,
      formik = _ref5.formik,
      isDisabled = _ref5.isDisabled,
      _ref5$mustKeepPayment = _ref5.mustKeepPaymentMethod,
      mustKeepPaymentMethod = _ref5$mustKeepPayment === void 0 ? false : _ref5$mustKeepPayment;

  if (!isDisabled) {
    formik.setFieldValue('paymentProviderId', paymentProvider.id);
    formik.setFieldValue('selectorPaymentProviderId', paymentProvider.selectorId);
    !mustKeepPaymentMethod && formik.setFieldValue('paymentMethodId', '');
  }
};

/***/ }),

/***/ "yBcK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentPlan; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("LqLs");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("fGyu");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ldK3");
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("Ohju");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("/HC4");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("MWZw");
/* harmony import */ var _PaymentInfoContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("lr0Z");
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("ljKo");
/* harmony import */ var _loading_async_loader_AsyncLoader__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("4A3Y");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("47Eh");
/* harmony import */ var _hooks_use_disclosure_useDisclosure__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Re84");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("EvYw");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("qqKu");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("L7OA");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("Ub5k");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;



















var PaymentPlan = function PaymentPlan(_ref) {
  var _paymentSchedule$tota, _paymentSchedule$tota2, _paymentSchedule$depo, _rePaymentSchedule$am;

  var depositSelectedLabel = _ref.depositSelectedLabel,
      hasFullAmount = _ref.hasFullAmount,
      isDisabled = _ref.isDisabled,
      payFullAmountLabel = _ref.payFullAmountLabel,
      paymentSchedule = _ref.paymentSchedule,
      setHasFullAmount = _ref.setHasFullAmount,
      _ref$displayTooltip = _ref.displayTooltip,
      displayTooltip = _ref$displayTooltip === void 0 ? true : _ref$displayTooltip,
      _ref$paymentPlans = _ref.paymentPlans,
      paymentPlans = _ref$paymentPlans === void 0 ? [] : _ref$paymentPlans,
      isLoading = _ref.isLoading;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_10__["useContext"])(_PaymentInfoContext__WEBPACK_IMPORTED_MODULE_18__[/* PaymentInfoContext */ "a"]),
      isFreeDeposit = _useContext.isFreeDeposit;

  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_28__[/* useAppContext */ "c"])();
  var rePaymentSchedule = paymentSchedule.repaymentSchedules[0] || {};
  var formik = Object(formik__WEBPACK_IMPORTED_MODULE_19__[/* useFormikContext */ "e"])();

  var _useDisclosure = Object(_hooks_use_disclosure_useDisclosure__WEBPACK_IMPORTED_MODULE_22__[/* useDisclosure */ "a"])(),
      isOpen = _useDisclosure.isOpen,
      onClose = _useDisclosure.onClose,
      onOpen = _useDisclosure.onOpen;

  var isDefaultPlanEnabled = !isFreeDeposit && paymentSchedule.repaymentSchedules.length > 0 || paymentSchedule.isUpsell;
  var payDepositRegulationsText = Object(_i18n__WEBPACK_IMPORTED_MODULE_12__[/* t */ "h"])('booking.banking.paymentSchedule.payDepositRegulations');
  var inThirtyMinutes = new Date(new Date().getTime() + 60 * 30 * 1000);
  Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
    !hasFullAmount && js_cookie__WEBPACK_IMPORTED_MODULE_11___default.a.set(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_21__[/* SVRL_PMNTS */ "a"], 1, {
      expires: inThirtyMinutes
    });
  }, []);

  if (!isDefaultPlanEnabled && !paymentPlans.length && !isLoading) {
    return null;
  }

  var totalPaymentPlan = {
    value: (_paymentSchedule$tota = paymentSchedule.total) === null || _paymentSchedule$tota === void 0 ? void 0 : _paymentSchedule$tota.value,
    label: payFullAmountLabel || 'booking.banking.paymentSchedule.payFullAmount',
    name: 'amountToPay',
    template: {
      values: {
        totalAmount: (_paymentSchedule$tota2 = paymentSchedule.total) === null || _paymentSchedule$tota2 === void 0 ? void 0 : _paymentSchedule$tota2.formattedValue
      },
      valuesClassName: {
        totalAmount: 'font-bold text-sienna'
      }
    },
    onChange: function onChange() {
      setHasFullAmount && setHasFullAmount(true);
      js_cookie__WEBPACK_IMPORTED_MODULE_11___default.a.remove(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_21__[/* SVRL_PMNTS */ "a"]);
    }
  };
  var depositPaymentPlan = {
    value: paymentSchedule.depositAmount.value,
    label: depositSelectedLabel || 'booking.banking.paymentSchedule.depositSelected',
    name: 'amountToPay',
    withModalInformation: Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_27__[/* isFeatureFlipped */ "a"])(appContext)('booking.banking.enableFreeDeposit') && displayTooltip,
    modalTitle: 'booking.banking.paymentSchedule.freeDeposit.title',
    modalDescription: 'booking.banking.paymentSchedule.freeDeposit.description',
    template: {
      values: {
        depositAmount: (_paymentSchedule$depo = paymentSchedule.depositAmount) === null || _paymentSchedule$depo === void 0 ? void 0 : _paymentSchedule$depo.formattedValue,
        balanceAmount: (_rePaymentSchedule$am = rePaymentSchedule.amount) === null || _rePaymentSchedule$am === void 0 ? void 0 : _rePaymentSchedule$am.formattedValue,
        balanceDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* formatApiDate */ "g"])(rePaymentSchedule.deadline, Object(_i18n__WEBPACK_IMPORTED_MODULE_12__[/* t */ "h"])('booking.form.dateFormat'))
      },
      valuesClassName: {
        depositAmount: 'font-bold text-sienna',
        balanceAmount: 'font-bold text-sienna',
        balanceDate: 'font-bold'
      }
    },
    onChange: function onChange() {
      setHasFullAmount && setHasFullAmount(false);
      js_cookie__WEBPACK_IMPORTED_MODULE_11___default.a.set(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_21__[/* SVRL_PMNTS */ "a"], 1, {
        expires: inThirtyMinutes
      });
    },
    regulations: payDepositRegulationsText && __jsx("p", {
      className: "text-sm italic",
      "data-testid": "payDepositRegulationsText"
    }, payDepositRegulationsText)
  };
  var defaultPaymentPlans = [isDefaultPlanEnabled || !!paymentPlans.length ? totalPaymentPlan : {}, isDefaultPlanEnabled ? depositPaymentPlan : {}].filter(function (_ref2) {
    var value = _ref2.value;
    return value;
  });
  var plans = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(defaultPaymentPlans), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(paymentPlans));
  return __jsx(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_17__[/* Title */ "a"], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_12__[/* t */ "h"])('booking.banking.paymentSchedule.selectPaymentSchedule')), __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_14__[/* Capsule */ "a"], {
    header: "none"
  }, __jsx("div", {
    className: "p-20"
  }, isLoading && __jsx(_loading_async_loader_AsyncLoader__WEBPACK_IMPORTED_MODULE_20__[/* AsyncLoader */ "a"], null), plans.map(function (_ref3) {
    var _paymentSchedule$tota3;

    var _onChange = _ref3.onChange,
        value = _ref3.value,
        _ref3$selector = _ref3.selector,
        Selector = _ref3$selector === void 0 ? null : _ref3$selector,
        label = _ref3.label,
        _ref3$modalTitle = _ref3.modalTitle,
        modalTitle = _ref3$modalTitle === void 0 ? '' : _ref3$modalTitle,
        _ref3$modalDescriptio = _ref3.modalDescription,
        modalDescription = _ref3$modalDescriptio === void 0 ? '' : _ref3$modalDescriptio,
        _ref3$withModalInform = _ref3.withModalInformation,
        withModalInformation = _ref3$withModalInform === void 0 ? false : _ref3$withModalInform,
        _ref3$template = _ref3.template;
    _ref3$template = _ref3$template === void 0 ? {} : _ref3$template;
    var values = _ref3$template.values,
        valuesClassName = _ref3$template.valuesClassName,
        _ref3$regulations = _ref3.regulations,
        regulations = _ref3$regulations === void 0 ? null : _ref3$regulations,
        name = _ref3.name;

    var fieldsToClear = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(new Set(plans.filter(function (plan) {
      return plan.name !== name;
    }).map(function (plan) {
      return plan.name;
    })));

    return __jsx("div", {
      key: label,
      className: "".concat(isLoading ? 'hidden' : 'block', " mt-10")
    }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_16__[/* FormikInput */ "a"], {
      type: "radio",
      name: "".concat(name),
      value: value,
      label: Selector ? __jsx(Selector, {
        price: (_paymentSchedule$tota3 = paymentSchedule.total) === null || _paymentSchedule$tota3 === void 0 ? void 0 : _paymentSchedule$tota3.value,
        label: label
      }) : __jsx("span", null, __jsx(_frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_15__[/* TemplateString */ "a"], {
        template: Object(_i18n__WEBPACK_IMPORTED_MODULE_12__[/* t */ "h"])(label),
        values: values,
        valuesClassName: valuesClassName
      }), !!withModalInformation && __jsx("span", {
        className: "absolute",
        onClick: function onClick(e) {
          e.preventDefault();
          onOpen();
        },
        role: "button",
        "aria-hidden": "true"
      }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_24__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_23__[/* ICONS */ "a"].INFORMATION,
        width: "1.5rem",
        className: "text-sienna"
      }))),
      onChange: function onChange() {
        fieldsToClear.map(function (field) {
          return formik.setFieldValue("".concat(field), '');
        });
        _onChange && _onChange();
      },
      isDisabled: isDisabled
    }), !!withModalInformation && isOpen && __jsx(_frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_25__[/* Modal */ "a"], {
      className: "p-10",
      size: "small",
      onClose: onClose
    }, __jsx("div", {
      className: "flex flex-col p-20"
    }, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_26__[/* Text */ "a"], {
      className: "pb-20 font-bold text-sienna",
      text: Object(_i18n__WEBPACK_IMPORTED_MODULE_12__[/* t */ "h"])(modalTitle)
    }), __jsx("div", {
      className: "flex w-full flex-col"
    }, __jsx("div", {
      className: "flex flex-col"
    }, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_26__[/* Text */ "a"], {
      text: Object(_i18n__WEBPACK_IMPORTED_MODULE_12__[/* t */ "h"])(modalDescription)
    }))))), regulations && regulations);
  }))));
};

/***/ }),

/***/ "yCYU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("ZK3j");
var common = __webpack_require__("roL5");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),

/***/ "yRAD":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var defaultEncoding
/* istanbul ignore next */
if (global.process && global.process.browser) {
  defaultEncoding = 'utf-8'
} else if (global.process && global.process.version) {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
} else {
  defaultEncoding = 'utf-8'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq"), __webpack_require__("F63i")))

/***/ }),

/***/ "yzIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PaymentInfo_PaymentInfo; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/partition.js
var partition = __webpack_require__("Zl10");
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/payment-form/paymentProvidersUtils.js
var paymentProvidersUtils = __webpack_require__("y5B/");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WeChatTutorial.jsx
var __jsx = react_default.a.createElement;







var WECHAT_TUTORIAL_IMAGE = 'https://ns.clubmed.com/it/2018/be/payment/wechat.png';
var WeChatTutorial_WeChatTutorial = function WeChatTutorial(_ref) {
  var _ref$hasTransactionEx = _ref.hasTransactionExpired,
      hasTransactionExpired = _ref$hasTransactionEx === void 0 ? false : _ref$hasTransactionEx;
  return __jsx("div", {
    className: "w-full"
  }, __jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('common.payment.wechat.qrCode.title')), __jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, hasTransactionExpired && __jsx(FormFeedback["a" /* FormFeedback */], {
    className: "flex justify-center text-red",
    isError: true,
    message: Object(src_i18n["h" /* t */])('common.payment.wechat.qrCode.expired')
  }), __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('text-center', {
      'pt-[33px]': !hasTransactionExpired
    })
  }, __jsx("div", {
    className: "highlited-text text-sienna"
  }, Object(src_i18n["h" /* t */])('common.payment.wechat.qrCode.subtitle')), __jsx("div", {
    className: "subheader"
  }, Object(src_i18n["h" /* t */])('common.payment.wechat.qrCode.label'))), __jsx(Image["b" /* default */], {
    altMsg: "tutorial to use wechat",
    className: "relative left-[30px] mx-auto my-20 w-[420px]",
    dimensions: {
      h: 313,
      w: 420
    },
    imageUrl: WECHAT_TUTORIAL_IMAGE
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfoContext.js
var PaymentInfoContext = __webpack_require__("lr0Z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/capitalize.js
var capitalize = __webpack_require__("h++M");
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./src/hooks/use-previous/usePrevious.js
var usePrevious = __webpack_require__("AbLU");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./logger/logger.js
var logger_logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WechatTimer.jsx
var WechatTimer_jsx = react_default.a.createElement;



var WechatTimer_WeChatTimer = function WeChatTimer(_ref) {
  var timeout = _ref.timeout;

  var _useState = Object(react["useState"])(timeout),
      timer = _useState[0],
      setTimer = _useState[1];

  var timerInterval = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    timerInterval.current = setInterval(function () {
      setTimer(function (prevTimer) {
        if (prevTimer === 1) {
          // $FlowFixMe
          clearInterval(timerInterval.current);
        }

        return prevTimer - 1;
      });
    }, 1000);
    return function () {
      clearInterval(timerInterval.current);
    };
  }, []);
  var timerInMinutes = timer / 60;
  var minutes = Math.floor(timerInMinutes % 60);
  var seconds = Math.floor(timer % 60);
  var secondsIn2digits = seconds < 10 ? "0".concat(seconds) : seconds;
  return WechatTimer_jsx("div", {
    className: "pt-15 text-center text-sienna"
  }, WechatTimer_jsx(Icon["a" /* Icon */], {
    className: "align-middle",
    name: icons["a" /* ICONS */].DURATION,
    width: "1rem"
  }), WechatTimer_jsx("div", {
    className: "ms-10 inline-block"
  }, minutes, ":", secondsIn2digits));
};
// EXTERNAL MODULE: ./src/utils/polling/polling.js
var polling = __webpack_require__("ICjN");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/payment/constants.js
var constants = __webpack_require__("hi3+");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WeChatQRCode.utils.js














function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





var BE_LEGACY_KEY = dist["appQueryParameters"].legacy.be,
    WeChatQRCode_utils_LOCALE_KEY = dist["appQueryParameters"].locale;
var WeChatQRCode_utils_handlePspResponse = function handlePspResponse(_ref) {
  var response = _ref.response,
      queryParams = _ref.queryParams,
      customerId = _ref.customerId,
      orderId = _ref.orderId,
      bookingStatus = _ref.bookingStatus;

  var paymentResult = get_default()(response, 'paymentStatus.finalPaymentResponse.payment.paymentStatus');

  var bookingId = get_default()(response, 'paymentStatus.finalPaymentResponse.booking.bookingId');

  var paymentStatus = paymentResult === constants["e" /* API_PAYMENT_STATUS_SUCCESS */] ? constants["s" /* PAYMENT_STATUS_SUCCESS */] : constants["m" /* PAYMENT_STATUS_FAILURE */];
  var confirmationUrl;

  if (bookingStatus) {
    confirmationUrl = new URI_default.a("/account/bookings/".concat(bookingId, "/payment-confirmation")).query(Object(defineProperty["a" /* default */])({
      paymentStatus: paymentStatus,
      bookingStatusBeforePayment: bookingStatus,
      currency: get_default()(response, 'paymentStatus.finalPaymentResponse.payment.currency'),
      amount: get_default()(response, 'paymentStatus.finalPaymentResponse.payment.paymentAmount'),
      provider: get_default()(response, 'paymentStatus.finalPaymentResponse.payment.providerId'),
      t: orderId
    }, WeChatQRCode_utils_LOCALE_KEY, queryParams.locale)).toString();
  } else {
    var params = _objectSpread(_objectSpread(_objectSpread({}, bookingId ? {
      bi: bookingId
    } : null), {}, {
      paymentStatus: paymentStatus
    }, customerId ? {
      ui: customerId
    } : null), {}, Object(defineProperty["a" /* default */])({
      selectedProposalId: queryParams.selectedProposalId
    }, WeChatQRCode_utils_LOCALE_KEY, queryParams.locale), queryParams.hasOwnProperty(BE_LEGACY_KEY) ? Object(defineProperty["a" /* default */])({}, BE_LEGACY_KEY, null) : null);

    confirmationUrl = routeBuilder["a" /* buildUrl */]('confirmation', {}, params);
  }

  window.location.replace(confirmationUrl);
};
// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WechatQRCode.jsx



var WechatQRCode_jsx = react_default.a.createElement;



















var QRCode = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 140).then(__webpack_require__.t.bind(null, "8Zi/", 7));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("8Zi/")];
    },
    modules: ['qrcode.react']
  }
});
var POLLING_CONFIG = config_default.a.get('psp.ewechat.polling');
var WechatQRCode_WeChatQRCode = function WeChatQRCode(_ref) {
  var currency = _ref.currency,
      qrCodeUrl = _ref.qrCodeUrl,
      amountToPay = _ref.amountToPay,
      orderId = _ref.orderId,
      customerId = _ref.customerId,
      timeoutCallback = _ref.timeoutCallback;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useRouter = Object(next_router["useRouter"])(),
      queryParams = _useRouter.query;

  var timeoutInSeconds = POLLING_CONFIG.timeout / 1000;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      bookingStatus = _useContext.bookingStatus;

  Object(react["useEffect"])(function () {
    var paymentStatusMutation = "\n      mutation {\n        paymentStatus(paymentId : \"".concat(orderId, "\") {\n          finalPaymentResponse {\n            payment {\n              paymentStatus\n              providerId\n              paymentAmount\n              currency\n            }\n            booking {\n              bookingId\n            }\n          }\n          errors\n        }\n      }\n    ");
    Object(polling["a" /* asyncPolling */])({
      delay: POLLING_CONFIG.frequency,
      // 10 seconds
      timeout: POLLING_CONFIG.timeout,
      // 5 minutes
      pollingFunction: function pollingFunction() {
        return graphqlClient["a" /* default */].runNoCacheQuery(paymentStatusMutation, appContext, {
          requestName: requestDictionary["Fc" /* PAYMENT_STATUS_MUTATION */]
        });
      },
      shouldPollAgain: function shouldPollAgain(response) {
        var paymentStatus = get_default()(response, 'paymentStatus.finalPaymentResponse.payment.paymentStatus');

        return paymentStatus === constants["b" /* API_PAYMENT_STATUS_PENDING */];
      },
      onResponse: function onResponse(response) {
        return WeChatQRCode_utils_handlePspResponse({
          response: response,
          customerId: customerId,
          queryParams: queryParams,
          orderId: orderId,
          bookingStatus: bookingStatus
        });
      }
    }).catch(function (e) {
      logger_logger["default"].error(e);
      timeoutCallback();
    });
  }, [orderId, customerId]);
  return WechatQRCode_jsx("div", {
    className: "w-full"
  }, WechatQRCode_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('common.payment.wechat.qrCode.title')), WechatQRCode_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, WechatQRCode_jsx("div", {
    className: "flex justify-center pt-[33px]"
  }, Object(src_i18n["h" /* t */])('common.payment.wechat.qrCode.pay'), ":", WechatQRCode_jsx("span", {
    className: "text-orange"
  }, Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.abs(amountToPay), appContext.locale, currency))), WechatQRCode_jsx(WechatTimer_WeChatTimer, {
    timeout: timeoutInSeconds
  }), WechatQRCode_jsx(QRCode, {
    value: qrCodeUrl,
    size: 239,
    className: "m-auto block p-30"
  }), WechatQRCode_jsx("div", {
    className: "pb-60 text-center"
  }, WechatQRCode_jsx(Icon["a" /* Icon */], {
    className: "align-middle",
    name: icons["a" /* ICONS */].WECHATPAYMENT,
    width: "1.5rem"
  }), WechatQRCode_jsx("div", {
    className: "ms-10 inline-block"
  }, Object(src_i18n["h" /* t */])('common.payment.wechat.qrCode.scan')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WeChatPayment.jsx
var WeChatPayment_jsx = react_default.a.createElement;



var WeChatPayment_WeChatPayment = function WeChatPayment(_ref) {
  var currency = _ref.currency,
      qrCodeUrl = _ref.qrCodeUrl,
      amountToPay = _ref.amountToPay,
      orderId = _ref.orderId,
      customerId = _ref.customerId,
      _timeoutCallback = _ref.timeoutCallback;

  var _useState = Object(react["useState"])(false),
      hasTransactionExpired = _useState[0],
      setHasTransactionExpired = _useState[1];

  if (hasTransactionExpired) {
    return WeChatPayment_jsx(WeChatTutorial_WeChatTutorial, {
      hasTransactionExpired: hasTransactionExpired
    });
  }

  return WeChatPayment_jsx(WechatQRCode_WeChatQRCode, {
    timeoutCallback: function timeoutCallback() {
      _timeoutCallback();

      setHasTransactionExpired(true);
    },
    currency: currency,
    qrCodeUrl: qrCodeUrl,
    orderId: orderId,
    customerId: customerId,
    amountToPay: amountToPay
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-dom/index.js
var react_dom = __webpack_require__("7nmT");

// EXTERNAL MODULE: ./src/utils/payment/payment.utils.js
var payment_utils = __webpack_require__("aMaj");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.utils.js
var PaymentInfo_utils = __webpack_require__("gX9k");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/utils/ple-utils/mapper.js
var mapper = __webpack_require__("aMgh");

// EXTERNAL MODULE: ./src/client/views/iframe-callback/IframeCallbackView.jsx
var IframeCallbackView = __webpack_require__("K7hX");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/usePaymentRedirection.js















function usePaymentRedirection_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function usePaymentRedirection_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? usePaymentRedirection_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : usePaymentRedirection_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}























function isBNPL(providerId) {
  return [PaymentInfo_const["p" /* UPLIFT_PSP_ID */], PaymentInfo_const["o" /* PLEDG_PSP_ID */]].includes(providerId);
}

function buildRedirectionPLE(currency, paymentAmountValue, bookingId, providerId, paymentId, bookingStatus, paymentStatus, locale) {
  var LOCALE_KEY = dist["appQueryParameters"].locale;
  var redirectUrl = new URI_default.a("/account/bookings/".concat(bookingId || js_cookie_default.a.get('bookingId'), "/payment-confirmation")).query(Object(defineProperty["a" /* default */])({
    paymentStatus: paymentStatus,
    bookingStatusBeforePayment: Object(mapper["b" /* getStatusFromCode */])(bookingStatus),
    currency: currency,
    amount: paymentAmountValue,
    provider: providerId,
    t: paymentId
  }, LOCALE_KEY, locale));
  return redirectUrl.toString();
}

function buildRedirectionBE(currency, paymentAmountValue, bookingId, providerId, paymentId, bookingStatus, paymentStatus, locale) {
  var normalizedPaymentStatus;
  var targetUrl = 'confirmation';
  var LOCALE_KEY = dist["appQueryParameters"].locale;

  switch (paymentStatus) {
    case constants["e" /* API_PAYMENT_STATUS_SUCCESS */]:
      normalizedPaymentStatus = constants["s" /* PAYMENT_STATUS_SUCCESS */];
      break;

    case constants["c" /* API_PAYMENT_STATUS_REFUSED_CM */]:
      normalizedPaymentStatus = constants["q" /* PAYMENT_STATUS_REFUSED_CM */].toLowerCase();
      break;

    case constants["d" /* API_PAYMENT_STATUS_REFUSED_PSP */]:
      normalizedPaymentStatus = constants["r" /* PAYMENT_STATUS_REFUSED_PSP */].toLowerCase();
      targetUrl = 'banking';
      break;

    case constants["a" /* API_PAYMENT_STATUS_CANCELED */]:
      normalizedPaymentStatus = constants["l" /* PAYMENT_STATUS_CANCELED */].toLowerCase();
      targetUrl = 'banking';
      break;

    default:
      normalizedPaymentStatus = constants["m" /* PAYMENT_STATUS_FAILURE */];
      break;
  }

  var bookingQueryParams = js_cookie_default.a.get(booking_constants["j" /* BOOKING_QUERY_PARAMS */]);
  var isCmtaInCookies = !!(bookingQueryParams === null || bookingQueryParams === void 0 ? void 0 : bookingQueryParams.includes('cm_ta'));

  var queryParams = usePaymentRedirection_objectSpread(usePaymentRedirection_objectSpread(usePaymentRedirection_objectSpread(usePaymentRedirection_objectSpread({}, bookingId ? {
    bi: bookingId
  } : null), {}, {
    paymentStatus: normalizedPaymentStatus
  }, isCmtaInCookies && {
    cm_ta: isCmtaInCookies
  }), {}, {
    selectedProposalId: js_cookie_default.a.get(booking_constants["k" /* BOOKING_SELECTED_RESORT_ID */])
  }, targetUrl !== 'confirmation' ? URI_default.a.parseQuery(bookingQueryParams) : null), {}, Object(defineProperty["a" /* default */])({}, LOCALE_KEY, locale));

  return routeBuilder["a" /* buildUrl */](targetUrl, {}, queryParams);
}

var usePaymentRedirection_usePaymentRedirection = function usePaymentRedirection(_ref) {
  var paymentProviderId = _ref.paymentProviderId,
      track = _ref.track;
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var asPath = router.asPath;
  var origin = new URI_default.a(appContext.originalUrl).origin();
  var location = new URI_default.a(origin + asPath);

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      onPaymentProgress = _useContext.onPaymentProgress;

  var makePaymentStatusMutation = function makePaymentStatusMutation(paymentId) {
    return "\n  mutation {\n    paymentStatus(paymentId : \"".concat(paymentId, "\") {\n      finalPaymentResponse {\n        payment {\n          paymentStatus\n          providerId\n          paymentAmount\n          currency\n        }\n        booking {\n          bookingId\n        }\n      }\n      errors\n    }\n  }\n");
  };

  var redirectToConfirmation = function redirectToConfirmation(event) {
    var _event$data;

    onPaymentProgress === null || onPaymentProgress === void 0 ? void 0 : onPaymentProgress(location);

    if ((event === null || event === void 0 ? void 0 : (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.eventType) !== IframeCallbackView["a" /* EVENT_TYPE_IFRAME */]) {
      return;
    }

    var _event$data2 = event.data,
        paymentId = _event$data2.paymentId,
        callbackUrl = _event$data2.callbackUrl,
        providerResponse = _event$data2.providerResponse;
    dispatch(Object(globalLoader_action["d" /* startLoading */])());
    var url = new URI_default.a(callbackUrl);

    var _url$segment = url.segment(),
        _url$segment2 = Object(slicedToArray["a" /* default */])(_url$segment, 5),
        locale = _url$segment2[2],
        bookingStatus = _url$segment2[3],
        isCart = _url$segment2[4];

    var isPLE = !!bookingStatus;

    var redirectMethod = function redirectMethod() {
      var getRedirectMethod = isPLE ? buildRedirectionPLE : buildRedirectionBE;
      var bnplQueryString = "bnpl=".concat(paymentProviderId);
      return "".concat(getRedirectMethod.apply(void 0, arguments)).concat(isBNPL(paymentProviderId) ? "&".concat(bnplQueryString) : '');
    };

    var bookingId;
    var currency;
    var paymentAmountValue;
    var providerId;
    var paymentStatus;

    if (!Object(payment_utils["g" /* shouldApprovePayment */])(paymentProviderId)) {
      if (([PaymentInfo_const["d" /* ECYBERSOURCE_PSP_ID */], PaymentInfo_const["o" /* PLEDG_PSP_ID */], PaymentInfo_const["e" /* EPAYGATE_PSP_ID */]].includes(paymentProviderId) || paymentProviderId.includes(PaymentInfo_const["g" /* IXOPAY_PSP_ID */])) && !!paymentId) {
        // Poll the server for the notification status only for cybersource
        return Object(polling["a" /* asyncPolling */])({
          delay: 3000,
          // 3 seconds
          timeout: 60 * 1000,
          // 5 minutes
          pollingFunction: function pollingFunction() {
            return graphqlClient["a" /* default */].runNoCacheQuery(makePaymentStatusMutation(paymentId), appContext, {
              requestName: requestDictionary["Fc" /* PAYMENT_STATUS_MUTATION */]
            });
          },
          shouldPollAgain: function shouldPollAgain(response) {
            var _response$paymentStat, _response$paymentStat2, _response$paymentStat3, _response$paymentStat4, _response$paymentStat5, _response$paymentStat6, _response$paymentStat7, _response$paymentStat8, _response$paymentStat9, _response$paymentStat10, _response$paymentStat11, _response$paymentStat12;

            bookingId = response === null || response === void 0 ? void 0 : (_response$paymentStat = response.paymentStatus) === null || _response$paymentStat === void 0 ? void 0 : (_response$paymentStat2 = _response$paymentStat.finalPaymentResponse) === null || _response$paymentStat2 === void 0 ? void 0 : (_response$paymentStat3 = _response$paymentStat2.booking) === null || _response$paymentStat3 === void 0 ? void 0 : _response$paymentStat3.bookingId;
            currency = response === null || response === void 0 ? void 0 : (_response$paymentStat4 = response.paymentStatus) === null || _response$paymentStat4 === void 0 ? void 0 : (_response$paymentStat5 = _response$paymentStat4.finalPaymentResponse) === null || _response$paymentStat5 === void 0 ? void 0 : (_response$paymentStat6 = _response$paymentStat5.payment) === null || _response$paymentStat6 === void 0 ? void 0 : _response$paymentStat6.currency;
            paymentAmountValue = response === null || response === void 0 ? void 0 : (_response$paymentStat7 = response.paymentStatus) === null || _response$paymentStat7 === void 0 ? void 0 : (_response$paymentStat8 = _response$paymentStat7.finalPaymentResponse) === null || _response$paymentStat8 === void 0 ? void 0 : (_response$paymentStat9 = _response$paymentStat8.payment) === null || _response$paymentStat9 === void 0 ? void 0 : _response$paymentStat9.paymentAmount;
            paymentStatus = response === null || response === void 0 ? void 0 : (_response$paymentStat10 = response.paymentStatus) === null || _response$paymentStat10 === void 0 ? void 0 : (_response$paymentStat11 = _response$paymentStat10.finalPaymentResponse) === null || _response$paymentStat11 === void 0 ? void 0 : (_response$paymentStat12 = _response$paymentStat11.payment) === null || _response$paymentStat12 === void 0 ? void 0 : _response$paymentStat12.paymentStatus;
            return paymentStatus === constants["b" /* API_PAYMENT_STATUS_PENDING */];
          },
          onResponse: function onResponse(response) {
            var _response$paymentStat13, _response$paymentStat14, _response$paymentStat15, _response$paymentStat16, _response$paymentStat17, _response$paymentStat18, _response$paymentStat19, _response$paymentStat20, _response$paymentStat21, _response$paymentStat22, _response$paymentStat23, _response$paymentStat24, _response$paymentStat25, _response$paymentStat26, _response$paymentStat27;

            bookingId = (response === null || response === void 0 ? void 0 : (_response$paymentStat13 = response.paymentStatus) === null || _response$paymentStat13 === void 0 ? void 0 : (_response$paymentStat14 = _response$paymentStat13.finalPaymentResponse) === null || _response$paymentStat14 === void 0 ? void 0 : (_response$paymentStat15 = _response$paymentStat14.booking) === null || _response$paymentStat15 === void 0 ? void 0 : _response$paymentStat15.bookingId) || '';
            currency = response === null || response === void 0 ? void 0 : (_response$paymentStat16 = response.paymentStatus) === null || _response$paymentStat16 === void 0 ? void 0 : (_response$paymentStat17 = _response$paymentStat16.finalPaymentResponse) === null || _response$paymentStat17 === void 0 ? void 0 : (_response$paymentStat18 = _response$paymentStat17.payment) === null || _response$paymentStat18 === void 0 ? void 0 : _response$paymentStat18.currency;
            paymentAmountValue = response === null || response === void 0 ? void 0 : (_response$paymentStat19 = response.paymentStatus) === null || _response$paymentStat19 === void 0 ? void 0 : (_response$paymentStat20 = _response$paymentStat19.finalPaymentResponse) === null || _response$paymentStat20 === void 0 ? void 0 : (_response$paymentStat21 = _response$paymentStat20.payment) === null || _response$paymentStat21 === void 0 ? void 0 : _response$paymentStat21.paymentAmount;
            providerId = response === null || response === void 0 ? void 0 : (_response$paymentStat22 = response.paymentStatus) === null || _response$paymentStat22 === void 0 ? void 0 : (_response$paymentStat23 = _response$paymentStat22.finalPaymentResponse) === null || _response$paymentStat23 === void 0 ? void 0 : (_response$paymentStat24 = _response$paymentStat23.payment) === null || _response$paymentStat24 === void 0 ? void 0 : _response$paymentStat24.providerId;
            paymentStatus = response === null || response === void 0 ? void 0 : (_response$paymentStat25 = response.paymentStatus) === null || _response$paymentStat25 === void 0 ? void 0 : (_response$paymentStat26 = _response$paymentStat25.finalPaymentResponse) === null || _response$paymentStat26 === void 0 ? void 0 : (_response$paymentStat27 = _response$paymentStat26.payment) === null || _response$paymentStat27 === void 0 ? void 0 : _response$paymentStat27.paymentStatus;
            var redirectUrl = redirectMethod(currency, paymentAmountValue, bookingId, providerId, paymentId, bookingStatus, paymentStatus, locale); // If the payment was successfully completed and it was initiated from the cart :
            // Send a request to the API for cleaning the Cart until the moment that they'll do their job.

            if (isCart) {
              return graphqlClient["a" /* default */].runNoCacheQuery("mutation {\n                      cleanCartService(bookingId : \"".concat(bookingId, "\") { status }\n                    }"), {
                authenticationToken: js_cookie_default.a.get('ACCESS_TOKEN')
              }, {
                requestName: requestDictionary["xc" /* PAYMENT_CLEAN_CART */]
              }).then(function () {
                return window.parent.location.href = redirectUrl;
              })["catch"](function () {
                return window.parent.location.href = redirectUrl;
              });
            }

            track === null || track === void 0 ? void 0 : track(paymentId);
            return window.parent.location.href = redirectUrl;
          }
        })["catch"](function (e) {
          logger_logger["default"].error(e);
          track === null || track === void 0 ? void 0 : track();
          paymentStatus = constants["c" /* API_PAYMENT_STATUS_REFUSED_CM */];
          var redirectUrl = redirectMethod(currency, paymentAmountValue, bookingId, providerId, paymentId, bookingStatus, paymentStatus, locale);
          return window.parent.location.href = redirectUrl;
        });
      } // redirect to notify server route


      return dist["windowWrapper"].setLocation(new URI_default.a(event.data.callbackUrl).setSearch(event.data.providerResponse).toString());
    } // redirect to approve/notify server route (approve, maybe 3ds, then the ol' classic notify)


    dist["windowWrapper"].setLocation(Object(PaymentInfo_utils["a" /* getApproveRoute */])({
      appContext: appContext,
      router: router,
      eventParams: usePaymentRedirection_objectSpread({
        callbackUrl: callbackUrl,
        paymentId: paymentId
      }, providerResponse)
    }));
  };

  return {
    redirectToConfirmation: redirectToConfirmation
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/IframePayment.jsx


var IframePayment_jsx = react_default.a.createElement;









var IframePayment_IframePayment = function IframePayment(_ref) {
  var children = _ref.children,
      paymentProviderId = _ref.paymentProviderId,
      paymentId = _ref.paymentId;

  var _useState = Object(react["useState"])(false),
      isMounted = _useState[0],
      setIsMounted = _useState[1];

  var iframe = Object(react["useRef"])();

  var _useRouter = Object(next_router["useRouter"])(),
      asPath = _useRouter.asPath;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      redirectUri = _useContext.redirectUri;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var origin = new URI_default.a(appContext.originalUrl).origin();
  var location = new URI_default.a(origin + asPath);
  var iframeValidationUrl = new URI_default.a(Object(payment_utils["d" /* getIframeCallbackUrl */])(location)).setQuery('callbackUrl', redirectUri).setQuery('paymentId', paymentId).toString();

  var _usePaymentRedirectio = usePaymentRedirection_usePaymentRedirection({
    paymentProviderId: paymentProviderId
  }),
      redirectToConfirmation = _usePaymentRedirectio.redirectToConfirmation;

  Object(react["useEffect"])(function () {
    // ⚠️ setTimeout is mandatory for work firefox (we don't know why)
    setTimeout(function () {
      setIsMounted(true);
    }, 0);
    window.addEventListener('message', redirectToConfirmation, false);
    return function () {
      return window.removeEventListener('message', redirectToConfirmation, false);
    };
  }, []);

  if (paymentId) {
    return IframePayment_jsx("iframe", {
      title: Object(src_i18n["h" /* t */])('booking.banking.pageTitle'),
      ref: iframe,
      className: "min-h-0",
      src: iframeValidationUrl
    });
  }

  return IframePayment_jsx(react["Fragment"], null, IframePayment_jsx("iframe", {
    "data-testid": "PaymentProcessIframe",
    title: Object(src_i18n["h" /* t */])('booking.banking.pageTitle'),
    ref: iframe,
    className: "min-h-1440 w-full border-0"
  }), isMounted && iframe.current && iframe.current.contentDocument &&
  /*#__PURE__*/
  // needed for prevent bug when it's rerender and we no longer had access to the iframe (there has been a redirection)
  // $FlowFixMe
  Object(react_dom["createPortal"])(children, iframe.current.contentDocument.body));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/FormAutoSubmit.jsx



var FormAutoSubmit_jsx = react_default.a.createElement;

var FormAutoSubmit_FormAutoSubmit = function FormAutoSubmit(_ref) {
  var pspData = _ref.pspData;
  var formRef = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    // $FlowFixMe current is always defined, useEffect is trigger after mount ...
    formRef.current.submit();
  }, []);
  return FormAutoSubmit_jsx("form", {
    ref: formRef,
    id: pspData.id,
    className: "ContactInfoRedirectForm",
    "data-testid": "PaymentProcess-FormAutoSubmit",
    method: pspData.method,
    action: pspData.url
  }, Object.entries(pspData.fields).map(function (_ref2) {
    var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 2),
        fieldName = _ref3[0],
        fieldValue = _ref3[1];

    return FormAutoSubmit_jsx("input", {
      key: fieldName,
      type: "hidden",
      name: fieldName,
      value: fieldValue
    });
  }));
};
// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 2 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/views/account/pre-payment/PrePaymentView.queries.js
var PrePaymentView_queries = __webpack_require__("2p0X");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/PaymentProcess.jsx





















var PaymentProcess_jsx = react_default.a.createElement;


function PaymentProcess_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PaymentProcess_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PaymentProcess_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PaymentProcess_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

































var PaymentProcess_isSellerNoDelcrederePSP = function isSellerNoDelcrederePSP(paymentProviderId) {
  return paymentProviderId === PaymentInfo_const["j" /* NODELCRERE_TRANSFER_PSP_ID */] || paymentProviderId === PaymentInfo_const["i" /* NODELCRERE_CHEQUE_PSP_ID */];
};

var PaymentProcess_PaymentProcess = function PaymentProcess(_ref) {
  var amountToPay = _ref.amountToPay,
      paymentConditionId = _ref.paymentConditionId,
      paymentProcessId = _ref.paymentProcessId,
      onErrorCallback = _ref.onErrorCallback,
      paymentMethod = _ref.paymentMethod,
      shouldSkipPayment = _ref.shouldSkipPayment;
  var dispatch = Object(es["d" /* useDispatch */])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var router = Object(next_router["useRouter"])();
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var _formik$values = formik.values,
      browserInfo = _formik$values.browserInfo,
      paymentProviderId = _formik$values.paymentProviderId,
      paymentId = _formik$values.paymentId,
      token = _formik$values.token,
      billingDetails = _formik$values.billingDetails,
      comments = _formik$values.comments,
      customerId = _formik$values.currentPayingCustomerId;
  var asPath = router.asPath,
      queryParams = router.query;
  var salesmanID = Object(es["e" /* useSelector */])(function (state) {
    return state.seller.sellerInfo.salesmanID;
  });
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["i" /* getCurrentProposal */]);
  var prevPaymentMethod = Object(usePrevious["a" /* usePrevious */])(paymentMethod);

  var _useState = Object(react["useState"])(null),
      errorPaymentMessageKey = _useState[0],
      setErrorPaymentMessageKey = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = Object(react["useState"])(null),
      pspData = _useState3[0],
      setPspData = _useState3[1];

  var elementToScroll = Object(react["useRef"])();

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      trackPayment = _useContext.trackPayment,
      paymentRedirectMutation = _useContext.paymentRedirectMutation,
      currency = _useContext.currency,
      onPaymentProgress = _useContext.onPaymentProgress,
      donationAmount = _useContext.donationAmount,
      sellerOptionRedirect = _useContext.sellerOptionRedirect;

  var track = Object(useTracking["a" /* useTracking */])();
  var origin = new URI_default.a(appContext.originalUrl).origin();
  var location = new URI_default.a(origin + asPath);
  var responsive = Object(ResponsiveContext["b" /* useResponsive */])();
  var isIframe = Object(payment_utils["f" /* isIframePayment */])(paymentProviderId, appContext);
  var isExternalProvider = !isIframe && paymentProviderId !== PaymentInfo_const["r" /* WECHAT_PSP_ID */];
  var explanatoryBillingInfoText = Object(src_i18n["h" /* t */])('booking.banking.billingAdressFilling');
  var shouldShowBillingInfo = isIframe && explanatoryBillingInfoText;
  Object(react["useEffect"])(function () {
    setErrorPaymentMessageKey(null);
  }, [paymentProviderId]);
  Object(react["useEffect"])(function () {
    var fetchPaymentInfos = /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _paymentRedirect$fiel;

        var _yield$paymentRedirec, paymentRedirect, paymentMethodLabel;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return paymentRedirectMutation(PaymentProcess_objectSpread(PaymentProcess_objectSpread({
                  amountToPay: amountToPay,
                  browserInfo: browserInfo,
                  paymentProviderId: paymentProviderId,
                  paymentConditionId: paymentConditionId,
                  isMobile: !isTablet,
                  isIframe: isIframe,
                  device: Object(PrePaymentView_queries["a" /* getDevice */])(responsive),
                  shouldSkipPayment: shouldSkipPayment
                }, shouldSkipPayment ? {
                  comments: comments
                } : {}), {}, {
                  token: token,
                  donationAmount: donationAmount || null,
                  location: location,
                  billingDetails: billingDetails,
                  callReference: appContext.callReference,
                  contactID: appContext.contactID,
                  customerId: customerId
                }));

              case 2:
                _yield$paymentRedirec = _context.sent;
                paymentRedirect = _yield$paymentRedirec.paymentRedirect;
                paymentMethodLabel = (paymentRedirect === null || paymentRedirect === void 0 ? void 0 : (_paymentRedirect$fiel = paymentRedirect.fields) === null || _paymentRedirect$fiel === void 0 ? void 0 : _paymentRedirect$fiel.pp) ? paymentRedirect.fields.pp.split(' ').map(capitalize_default.a).join(' ') : js_cookie_default.a.get(PaymentInfo_const["m" /* PAYMENT_METHOD_LABEL */]);
                trackPayment === null || trackPayment === void 0 ? void 0 : trackPayment({
                  orderId: paymentRedirect.orderId,
                  bookingId: paymentRedirect.bookingId,
                  amountToPay: amountToPay,
                  paymentProviderId: paymentProviderId,
                  paymentMethodLabel: paymentMethodLabel
                });

                if (!(isExternalProvider && paymentRedirect.method === 'GET')) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", window.location.replace(new URI_default.a(paymentRedirect.url).addQuery(paymentRedirect.fields).toString()));

              case 8:
                setPspData(paymentRedirect);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchPaymentInfos() {
        return _ref2.apply(this, arguments);
      };
    }();

    var continuePaymentProcess = /*#__PURE__*/function () {
      var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var errors;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!isLoading) {
                  setIsLoading(true);
                }

                if (errorPaymentMessageKey) {
                  setErrorPaymentMessageKey(null);
                }

                if (isExternalProvider) {
                  dispatch(Object(globalLoader_action["d" /* startLoading */])(Object(src_i18n["h" /* t */])('booking.banking.loadingLabel')));
                }

                if (onPaymentProgress) {
                  onPaymentProgress(location);
                }

                if (!(appContext.isCmta && !appContext.cmta.isDelCredere && PaymentProcess_isSellerNoDelcrederePSP(paymentProviderId))) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return sellerOptionRedirect === null || sellerOptionRedirect === void 0 ? void 0 : sellerOptionRedirect(paymentProviderId);

              case 8:
                _context2.next = 20;
                break;

              case 10:
                if (!(paymentProviderId === PaymentInfo_const["h" /* NAPAY_PSP_ID */])) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 13;
                return Object(sellerUtils["i" /* saveCustomerProposalAndSendContextToCxO */])({
                  proposalId: selectedProposal.id,
                  // $FlowFixMe
                  step: booking_constants["m" /* CXO_STEP */].PAYMENT,
                  appContext: appContext,
                  proposal: selectedProposal,
                  // $FlowFixMe
                  queryParams: queryParams,
                  salesmanID: salesmanID,
                  shouldSendDocument: false
                });

              case 13:
                return _context2.abrupt("return", _context2.sent);

              case 16:
                _context2.t0 = !paymentId;

                if (!_context2.t0) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 20;
                return fetchPaymentInfos();

              case 20:
                _context2.next = 32;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t1 = _context2["catch"](0);
                errors = _context2.t1.errors || [];
                trackPayment === null || trackPayment === void 0 ? void 0 : trackPayment({
                  orderId: null,
                  isErrored: true,
                  amountToPay: amountToPay,
                  paymentProviderId: paymentProviderId,
                  paymentMethodLabel: js_cookie_default.a.get(PaymentInfo_const["m" /* PAYMENT_METHOD_LABEL */])
                });

                if (!ple_utils["l" /* hasAuthResponseError */](_context2.t1)) {
                  _context2.next = 28;
                  break;
                }

                return _context2.abrupt("return", Object(redirectUtils["a" /* redirectToOidc */])(appContext));

              case 28:
                if (isExternalProvider) {
                  dispatch(Object(globalLoader_action["c" /* endLoading */])());
                }

                logger_default.a.error(_context2.t1);
                onErrorCallback();
                setErrorPaymentMessageKey(Object(PaymentInfo_utils["b" /* getPaymentErrorMessagePath */])({
                  errorCode: get_default()(errors[0], 'errorCode'),
                  track: track,
                  isCmta: appContext.isCmta
                }));

              case 32:
                _context2.prev = 32;
                setIsLoading(false);
                return _context2.finish(32);

              case 35:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 22, 32, 35]]);
      }));

      return function continuePaymentProcess() {
        return _ref3.apply(this, arguments);
      };
    }();

    continuePaymentProcess();

    if (elementToScroll.current) {
      Object(scrollToElement["a" /* scrollToElement */])(elementToScroll.current);
    }
  }, [paymentProcessId]);
  /**
   * if the paymentMethod change and there is still pspData we don't want to do anything and reset pspData
   * e.g. when the user for EOgone change from visa to paypal we don't want to redirect before the data for paypal are retrieved
   */

  if (prevPaymentMethod !== paymentMethod && pspData) {
    setPspData(null);
    return null;
  }

  if (errorPaymentMessageKey) {
    return PaymentProcess_jsx("div", {
      ref: elementToScroll
    }, PaymentProcess_jsx(FormFeedback["a" /* FormFeedback */], {
      className: "my-30",
      isError: true,
      message: Object(src_i18n["h" /* t */])(errorPaymentMessageKey)
    }));
  } // external psp with post redirect


  if (isExternalProvider) {
    if (!pspData) {
      if (paymentId) {
        return PaymentProcess_jsx(IframePayment_IframePayment, {
          paymentProviderId: paymentProviderId,
          paymentId: paymentId
        }, null);
      }

      return null;
    }

    return PaymentProcess_jsx(FormAutoSubmit_FormAutoSubmit, {
      pspData: pspData
    });
  }

  if (isLoading || !pspData) {
    return PaymentProcess_jsx("div", {
      className: "relative flex h-[371px] w-full items-center justify-center bg-white",
      "data-testid": "PaymentProcess-loader",
      ref: elementToScroll
    }, PaymentProcess_jsx(AsyncLoader["a" /* AsyncLoader */], null));
  }

  return PaymentProcess_jsx("div", {
    className: "mt-20",
    ref: elementToScroll
  }, paymentProviderId === PaymentInfo_const["r" /* WECHAT_PSP_ID */] ? PaymentProcess_jsx(WeChatPayment_WeChatPayment, {
    currency: currency,
    qrCodeUrl: pspData.url,
    orderId: pspData.orderId,
    customerId: pspData.customerId,
    amountToPay: amountToPay,
    timeoutCallback: onErrorCallback
  }) : PaymentProcess_jsx(react["Fragment"], null, shouldShowBillingInfo && PaymentProcess_jsx(Notification["a" /* Notification */], {
    className: "my-10 w-full px-30 py-5 text-orange",
    iconName: icons["a" /* ICONS */].WARNING,
    iconWidth: "1.3rem"
  }, PaymentProcess_jsx("p", {
    className: "font-sans text-14 text-orange"
  }, explanatoryBillingInfoText)), formik.isValid && PaymentProcess_jsx(IframePayment_IframePayment, {
    paymentProviderId: paymentProviderId
  }, PaymentProcess_jsx(FormAutoSubmit_FormAutoSubmit, {
    pspData: pspData
  }))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfoFormContent.jsx + 5 modules
var PersonInfoFormContent = __webpack_require__("DhzB");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 14 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/hooks/use-country-list/useCountryList.js
var useCountryList = __webpack_require__("IGWl");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// EXTERNAL MODULE: ./src/client/views/account/profile/ProfileView.queries.js
var ProfileView_queries = __webpack_require__("1XP9");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: /opt/webapp/node_modules/lz-string/libs/lz-string.js
var lz_string = __webpack_require__("O2W8");

// CONCATENATED MODULE: ./src/client/components/widgets/billing-address-form/BillingAddressForm.jsx













var BillingAddressForm_jsx = react_default.a.createElement;



















var billingPersonField = [{
  display: true,
  type: 'string',
  name: 'last_name',
  required: true,
  validators: []
}, {
  display: true,
  type: 'string',
  name: 'first_name',
  required: true,
  validators: []
}];
var BillingAddressForm_BillingAddressForm = function BillingAddressForm(_ref) {
  var _billingAddressSchema, _billingAddressSchema2, _billingAddressSchema3;

  var i18n = _ref.i18n,
      path = _ref.path;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var billingDetails = formik.values.billingDetails;
  var countries = Object(useCountryList["a" /* useCountryList */])();

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: Object(BookingEngine_query["d" /* getValidationSchema */])('', 'billing', billingDetails.countryCode),
    queryOptions: {
      requestName: requestDictionary["Qc" /* PROPOSAL_GET_SCHEMA */]
    }
  }),
      billingAddressSchema = _useGQL.data;

  var _useGQL2 = Object(useGQL["a" /* useGQL */])({
    query: Object(ProfileView_queries["e" /* getProfileQuery */])(),
    queryOptions: {
      requestName: requestDictionary["z" /* CUSTOMER_ACCOUNT_GET_PROFILE_DATA */]
    },
    ignore: !appContext.isUserLogged && !appContext.isSellerLogged || appContext.isCmta && !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.cmta.billingAddressPrefill')
  }),
      profileData = _useGQL2.data;

  var profile = (profileData === null || profileData === void 0 ? void 0 : profileData.profile) || JSON.parse(Object(lz_string["decompressFromBase64"])(Object(sessionStorageApi["b" /* getFromSessionStorage */])('profile') || ''));
  var billingAddressFields = (billingAddressSchema === null || billingAddressSchema === void 0 ? void 0 : (_billingAddressSchema = billingAddressSchema.validationSchema) === null || _billingAddressSchema === void 0 ? void 0 : (_billingAddressSchema2 = _billingAddressSchema[0]) === null || _billingAddressSchema2 === void 0 ? void 0 : (_billingAddressSchema3 = _billingAddressSchema2.fields) === null || _billingAddressSchema3 === void 0 ? void 0 : _billingAddressSchema3.filter(function (_ref2) {
    var name = _ref2.name;
    return name !== 'countryCode';
  })) || [];
  var validators = Object(ContactInfoUtils["n" /* getSchemaValidators */])(billingAddressFields, {
    withRequired: true,
    requiredMessage: function requiredMessage() {
      return Object(src_i18n["h" /* t */])('common.form.errors.requiredField');
    }
  });
  Object(react["useEffect"])(function () {
    var _profile$address;

    if ((billingAddressFields === null || billingAddressFields === void 0 ? void 0 : billingAddressFields.length) && billingDetails.countryCode === (profile === null || profile === void 0 ? void 0 : (_profile$address = profile.address) === null || _profile$address === void 0 ? void 0 : _profile$address.countryCode)) {
      [].concat(Object(toConsumableArray["a" /* default */])(billingAddressFields), [{
        name: 'countryCode'
      }, {
        name: 'firstName'
      }, {
        name: 'lastName'
      }]).forEach(function (_ref3) {
        var _profile$address2;

        var name = _ref3.name,
            _ref3$values = _ref3.values,
            values = _ref3$values === void 0 ? [] : _ref3$values;
        var profileValue = (profile === null || profile === void 0 ? void 0 : profile[name]) || (profile === null || profile === void 0 ? void 0 : (_profile$address2 = profile.address) === null || _profile$address2 === void 0 ? void 0 : _profile$address2[name]) || '';

        if (values === null || values === void 0 ? void 0 : values.length) {
          var value = values.find(function (_ref4) {
            var code = _ref4.code,
                label = _ref4.label;
            return [code, label].includes(profileValue.toUpperCase());
          });
          value && formik.setFieldValue("".concat(path, ".").concat(name), value.code, false);
        } else {
          formik.setFieldValue("".concat(path, ".").concat(name), profileValue, false);
        }
      });
    }
  }, [JSON.stringify(profile), billingAddressFields === null || billingAddressFields === void 0 ? void 0 : billingAddressFields.length]);
  return BillingAddressForm_jsx(react["Fragment"], null, BillingAddressForm_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.banking.billingAddressTitle')), BillingAddressForm_jsx(Capsule["a" /* Capsule */], {
    className: "mb-20",
    header: "none"
  }, BillingAddressForm_jsx("div", {
    className: "px-20 py-10"
  }, BillingAddressForm_jsx(FormikInput["a" /* FormikInput */], {
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('common.participants.address.countryCode'),
    name: "".concat(path, ".countryCode"),
    options: countries,
    type: "select"
  })), BillingAddressForm_jsx(PersonInfoFormContent["a" /* PersonInfoFormContent */], {
    id: "".concat(path, "-person"),
    i18n: i18n,
    attendeeIdentifier: path,
    attendeeSchema: billingPersonField,
    addressSchema: []
  }), BillingAddressForm_jsx("div", {
    className: "flex w-full flex-wrap px-10"
  }, billingAddressFields.map(function (_ref5) {
    var fieldName = _ref5.name,
        values = _ref5.values,
        required = _ref5.required;
    return BillingAddressForm_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('w-full p-10 pb-20 pt-0', contact_info_constants["b" /* ADDRESS_FIELDS_CLASSES */][fieldName] || 'w-full'),
      key: fieldName
    }, BillingAddressForm_jsx(FormikInput["a" /* FormikInput */], {
      autoComplete: "nope",
      fieldName: fieldName,
      label: Object(src_i18n["h" /* t */])("common.participants.address.".concat(fieldName)),
      name: "".concat(path, ".").concat(fieldName),
      key: fieldName,
      type: (values === null || values === void 0 ? void 0 : values.length) ? 'select' : 'default',
      placeholder: (values === null || values === void 0 ? void 0 : values.length) && Object(src_i18n["h" /* t */])('common.form.labels.fieldSelection', {
        field: Object(src_i18n["h" /* t */])("common.participants.address.".concat(fieldName))
      }),
      options: (values === null || values === void 0 ? void 0 : values.length) && values.map(function (_ref6) {
        var code = _ref6.code,
            label = _ref6.label;
        return {
          name: label,
          value: code
        };
      }),
      namePrefix: path,
      isRequired: required,
      validate: validators === null || validators === void 0 ? void 0 : validators[fieldName]
    }));
  }))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// CONCATENATED MODULE: ./src/hooks/use-is-first-render/useIsFirstRender.js

var useIsFirstRender_useIsFirstRender = function useIsFirstRender() {
  var isFirstRender = Object(react["useRef"])(true);
  Object(react["useEffect"])(function () {
    isFirstRender.current = false;
  }, []);
  return isFirstRender.current;
};
// EXTERNAL MODULE: ./src/hooks/use-disclosure/useDisclosure.js
var useDisclosure = __webpack_require__("Re84");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/radio-button/RadioButton.jsx
var RadioButton = __webpack_require__("zwQs");

// CONCATENATED MODULE: ./src/client/components/widgets/donation/Donation.jsx




var Donation_jsx = react_default.a.createElement;


















var Donation_Donation = function Donation(_ref) {
  var currency = _ref.currency,
      isDisabled = _ref.isDisabled;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isFreeAmountOpen = _useDisclosure.isOpen,
      onFreeAmountOpen = _useDisclosure.onOpen,
      onFreeAmountClose = _useDisclosure.onClose;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      donationAmount = _useContext.donationAmount;

  var isFirstRender = useIsFirstRender_useIsFirstRender();
  var options = [{
    value: Object(src_i18n["d" /* getKeyValue */])('booking.banking.donation.amount1'),
    formattedValue: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Object(src_i18n["d" /* getKeyValue */])('booking.banking.donation.amount1'), locale, currency)
  }, {
    value: Object(src_i18n["d" /* getKeyValue */])('booking.banking.donation.amount2'),
    formattedValue: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Object(src_i18n["d" /* getKeyValue */])('booking.banking.donation.amount2'), locale, currency)
  }, {
    value: Object(src_i18n["d" /* getKeyValue */])('booking.banking.donation.amount3'),
    formattedValue: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Object(src_i18n["d" /* getKeyValue */])('booking.banking.donation.amount3'), locale, currency)
  }];
  var modalTitleId = 'ModalTitleId';
  Object(react["useEffect"])(function () {
    if (donationAmount || !isFirstRender) {
      formik.setFieldValue('donation', +donationAmount);
    }
  }, [donationAmount]);

  var handleDonationChange = function handleDonationChange(donation) {
    // when the user change his mind and don't want donate it must reset the donation cgu if already checked
    if (!donation.value) {
      formik.setFieldValue('donation', undefined);

      if (formik.values.termsAndConditions.donation) {
        formik.setFieldValue('termsAndConditions.donation', false);
      }
    }

    dispatch(Object(proposals_action["w" /* saveDonationToProposals */])(donation));
  };

  return Donation_jsx(react["Fragment"], null, Donation_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.banking.donation.title')), Donation_jsx("div", {
    className: "flex flex-row gap-20 rounded-12 border-1 bg-white p-20 text-14"
  }, Donation_jsx("div", null, Donation_jsx("div", {
    className: "flex w-3/4 md:w-full"
  }, Donation_jsx("p", {
    className: "mb-15"
  }, Object(src_i18n["h" /* t */])('booking.banking.donation.blockTitle'), Donation_jsx(Tooltip["a" /* Tooltip */] // $FlowFixMe does not understand children prop comes from nested cmp
  , {
    modalProps: {
      ariaLabel: Object(src_i18n["h" /* t */])('booking.banking.donation.popinTitle'),
      ariaLabelledby: modalTitleId,
      closeLabel: Object(src_i18n["h" /* t */])('common.close'),
      size: 'small'
    },
    renderTrigger: function renderTrigger(toggle) {
      return Donation_jsx("button", {
        className: "self-start",
        onClick: toggle,
        type: "button"
      }, Donation_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].INFORMATION,
        width: "1.25rem"
      }));
    }
  }, Donation_jsx(Image["b" /* default */], {
    imageUrl: Object(src_i18n["d" /* getKeyValue */])('booking.banking.donation.imageUrl'),
    ratioKey: "L"
  }), Donation_jsx("div", {
    className: "flex flex-col gap-10 p-20"
  }, Donation_jsx(Title["a" /* Title */], {
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('booking.banking.donation.popinTitle')), Donation_jsx(Text["a" /* Text */], {
    text: Object(src_i18n["h" /* t */])('booking.banking.donation.popinDescription'),
    theme: "text-sans-n2"
  }), Donation_jsx(Text["a" /* Text */], {
    text: Object(src_i18n["h" /* t */])('booking.banking.donation.popinFiscalInfo'),
    theme: "text-sans-n2"
  }))))), Donation_jsx("div", {
    className: "w-full md:max-w-3/5"
  }, Donation_jsx("div", {
    className: "mb-15 mt-10 flex w-full cursor-pointer items-center gap-10 text-14"
  }, Donation_jsx(RadioButton["a" /* RadioButton */], {
    isDisabled: isDisabled,
    onClick: function onClick() {
      onFreeAmountClose();
      formik.setFieldValue('donation', 0);
      handleDonationChange({
        value: 0
      });
    },
    dataTestid: "donation-no-radio",
    isChecked: !formik.values.donation && !isFreeAmountOpen
  }), Donation_jsx("span", {
    className: "mt-1 inline-block text-14 leading-tight text-black"
  }, Object(src_i18n["h" /* t */])('booking.banking.donation.noAmount'))), Donation_jsx("div", {
    className: "flex flex-col justify-between md:flex-row"
  }, options.map(function (option) {
    return Donation_jsx("div", {
      key: option.value
    }, Donation_jsx(FormikInput["a" /* FormikInput */], {
      isDisabled: isDisabled,
      label: option.formattedValue,
      name: "donation",
      onChange: function onChange() {
        onFreeAmountClose();
        handleDonationChange(option);
      },
      type: "radio",
      value: option.value
    }));
  })), Donation_jsx("div", {
    className: "mb-15 mt-10 flex w-full cursor-pointer items-center gap-10 text-14"
  }, Donation_jsx(RadioButton["a" /* RadioButton */], {
    isDisabled: isDisabled,
    onClick: function onClick() {
      onFreeAmountOpen();
      handleDonationChange({
        value: 0
      });
    },
    dataTestid: "donation-free-amount-radio",
    isChecked: isFreeAmountOpen
  }), Donation_jsx("span", {
    className: "mt-1 inline-block text-14 leading-tight text-black"
  }, Object(src_i18n["h" /* t */])('booking.banking.donation.freeAmount'))), isFreeAmountOpen && Donation_jsx("div", {
    className: "ml-0 flex gap-10 md:ml-30"
  }, Donation_jsx("div", {
    className: "relative"
  }, Donation_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: isDisabled,
    type: "number",
    name: "freeAmount",
    dataTestId: "donation-input",
    value: formik.values.donation || '',
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return handleDonationChange({
        value: +value
      });
    }
  }), Donation_jsx("span", {
    className: "absolute right-5 top-1/2 -translate-y-1/2"
  }, Object(currencyConfigForLocale["c" /* getCurrency */])(locale, currency).symbol))))), Donation_jsx(Icon["a" /* Icon */], {
    className: "absolute right-5 shrink-0 md:relative md:right-0",
    name: icons["a" /* ICONS */].DONATION,
    width: "5rem"
  })));
};
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/FreeDeposit.jsx

var FreeDeposit_jsx = react_default.a.createElement;









var FreeDeposit_FreeDeposit = function FreeDeposit(_ref) {
  var price = _ref.price,
      totalPrice = _ref.totalPrice,
      touched = _ref.touched,
      paymentSchedule = _ref.paymentSchedule,
      deadlineDate = _ref.deadlineDate;
  var validateFreeDeposit = lib["number"]().typeError(Object(src_i18n["h" /* t */])('booking.banking.splitPayment.paymentField')).positive(Object(src_i18n["h" /* t */])('booking.banking.splitPayment.amountError')).max(price.value, Object(src_i18n["h" /* t */])('booking.banking.splitPayment.amountError'));
  var repaymentSchedules = paymentSchedule.repaymentSchedules,
      depositAmount = paymentSchedule.depositAmount;
  var hasPaymentPlan = repaymentSchedules.length;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var paymentsBefore = hasPaymentPlan ? [{
    deadline: undefined,
    amount: depositAmount.formattedValue
  }, {
    deadline: repaymentSchedules[0].deadline,
    amount: repaymentSchedules[0].amount.formattedValue
  }] : [{
    deadline: deadlineDate,
    amount: price.formattedValue
  }];
  Object(react["useEffect"])(function () {
    if (hasPaymentPlan) {
      formik.setFieldValue('freeDeposit', depositAmount.value);
    }
  }, [hasPaymentPlan]);
  return FreeDeposit_jsx("div", {
    "data-testid": "Free-AmountBlock"
  }, FreeDeposit_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('stays.linkLabels.splitPaymentLabel')), FreeDeposit_jsx(Capsule["a" /* Capsule */], {
    header: "none",
    contentClassName: "p-20"
  }, FreeDeposit_jsx("div", {
    className: "mb-10 flex flex-col gap-5 text-14 md:flex-row md:items-baseline"
  }, FreeDeposit_jsx("p", {
    className: "text-18 font-bold text-black"
  }, Object(src_i18n["h" /* t */])('booking.banking.splitPayment.totalDue')), FreeDeposit_jsx("ul", {
    className: "flex-1"
  }, paymentsBefore.map(function (_ref2) {
    var deadline = _ref2.deadline,
        amount = _ref2.amount;
    return FreeDeposit_jsx("li", {
      className: "flex items-center justify-between gap-5 text-orange",
      key: amount
    }, Object(src_i18n["h" /* t */])('booking.banking.splitPayment.paymentBefore'), ' ', moment_default()(deadline).format(Object(src_i18n["h" /* t */])('booking.form.dateFormat')), ' ', FreeDeposit_jsx("span", {
      className: "whitespace-no-wrap text-20 font-bold"
    }, amount));
  }), (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.formattedValue) && paymentsBefore.length === 1 && FreeDeposit_jsx("li", {
    className: "flex justify-end text-20"
  }, FreeDeposit_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(src_i18n["h" /* t */])('booking.banking.totalAmount'),
    values: {
      amount: totalPrice.formattedValue
    }
  })))), FreeDeposit_jsx(FormikInput["a" /* FormikInput */], {
    label: Object(src_i18n["h" /* t */])('booking.banking.splitPayment.title'),
    name: "freeDeposit",
    onWheel: function onWheel() {
      var _document, _document$activeEleme;

      (_document = document) === null || _document === void 0 ? void 0 : (_document$activeEleme = _document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.blur();
    },
    placeholder: !touched ? Object(src_i18n["h" /* t */])('booking.banking.splitPayment.paymentField') : '',
    title: Object(src_i18n["h" /* t */])('booking.banking.splitPayment.paymentField'),
    type: "number",
    validate: validateFreeDeposit
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentPlan.jsx
var PaymentPlan = __webpack_require__("yBcK");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentProvidersOldImplementation.jsx



var PaymentProvidersOldImplementation_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */




var PaymentProvidersOldImplementation_PaymentProvidersOldImplementation = function PaymentProvidersOldImplementation(_ref) {
  var isDisabled = _ref.isDisabled,
      orderedPaymentProviders = _ref.orderedPaymentProviders;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  return orderedPaymentProviders.map(function (paymentProvider) {
    return PaymentProvidersOldImplementation_jsx("div", {
      className: "flex w-full cursor-pointer items-center border-0 border-t-1 border-solid border-lightGrey p-10 md:w-1/2 md:flex-col md:border-r-1",
      "data-testid": "PaymentProviders-".concat(paymentProvider.id),
      key: paymentProvider.id,
      onClick: function onClick() {
        return Object(paymentProvidersUtils["e" /* handleClickPaymentProviderBlock */])({
          paymentProvider: paymentProvider,
          formik: formik,
          isDisabled: isDisabled
        });
      },
      type: "button"
    }, PaymentProvidersOldImplementation_jsx("input", {
      name: "paymentProviderId",
      type: "hidden",
      value: paymentProvider.id
    }), PaymentProvidersOldImplementation_jsx("div", {
      className: "shrink-0"
    }, PaymentProvidersOldImplementation_jsx(FormikInput["a" /* FormikInput */], {
      isDisabled: isDisabled,
      name: "selectorPaymentProviderId",
      type: "radio",
      value: paymentProvider.selectorId
    })), PaymentProvidersOldImplementation_jsx("div", {
      className: "gap-1\xE0 flex flex-1 items-center md:order-first md:flex-col"
    }, paymentProvider.logo && PaymentProvidersOldImplementation_jsx("img", {
      alt: paymentProvider.label,
      className: "w-90",
      src: paymentProvider.logo
    }), paymentProvider.description));
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lowerFirst.js
var lowerFirst = __webpack_require__("KqwS");
var lowerFirst_default = /*#__PURE__*/__webpack_require__.n(lowerFirst);

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/CreditCardPaymentBlock.jsx


var CreditCardPaymentBlock_jsx = react_default.a.createElement;








var CreditCardPaymentBlock_CreditCardContent = function CreditCardContent(_ref) {
  var hasFullAmount = _ref.hasFullAmount,
      rePaymentSchedule = _ref.rePaymentSchedule,
      paymentSchedule = _ref.paymentSchedule,
      totalAmount = _ref.totalAmount;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      isFreeDeposit = _useContext.isFreeDeposit;

  return CreditCardPaymentBlock_jsx(TemplateString["a" /* TemplateString */], {
    template: isFreeDeposit || hasFullAmount || !rePaymentSchedule ? Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.creditCard.totalAmount') : Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.creditCard.deposit'),
    values: !isFreeDeposit && !hasFullAmount && rePaymentSchedule ? {
      depositAmount: paymentSchedule.depositAmount.formattedValue,
      balanceAmount: rePaymentSchedule.amount.formattedValue,
      balanceDate: Object(apiDate["g" /* formatApiDate */])(rePaymentSchedule.deadline, Object(src_i18n["h" /* t */])('booking.form.dateFormat'))
    } : {
      totalAmount: totalAmount
    },
    valuesClassName: {
      depositAmount: 'font-bold text-sienna',
      balanceAmount: 'font-bold text-sienna',
      totalAmount: 'font-bold text-sienna',
      balanceDate: 'font-bold'
    }
  });
};

var CreditCardPaymentBlock_FormatedCardsAccepted = function FormatedCardsAccepted() {
  var cardsAccepted = Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.creditCard.cardsAccepted');
  var cardsAcceptedParts = cardsAccepted === null || cardsAccepted === void 0 ? void 0 : cardsAccepted.split(':');

  if (cardsAcceptedParts.length === 2) {
    return CreditCardPaymentBlock_jsx(react["Fragment"], null, CreditCardPaymentBlock_jsx("span", {
      className: "font-bold"
    }, cardsAcceptedParts[0]), ": ", cardsAcceptedParts[1]);
  } // eslint-disable-next-line react/jsx-no-useless-fragment


  return CreditCardPaymentBlock_jsx(react["Fragment"], null, cardsAccepted);
};

var CreditCardPaymentBlock_CreditCardPaymentBlock = function CreditCardPaymentBlock(_ref2) {
  var hasFullAmount = _ref2.hasFullAmount,
      isDisabled = _ref2.isDisabled,
      paymentSchedule = _ref2.paymentSchedule,
      rePaymentSchedule = _ref2.rePaymentSchedule,
      totalAmount = _ref2.totalAmount,
      hasNoPaymentMethods = _ref2.hasNoPaymentMethods;
  return hasNoPaymentMethods ? CreditCardPaymentBlock_jsx("div", {
    className: "text-14 my-25 max-w-full sm:max-w-4/5"
  }, CreditCardPaymentBlock_jsx("input", {
    type: "hidden",
    name: "paymentProviderId",
    value: PaymentInfo_const["f" /* HIPAY_PSP_ID */]
  }), CreditCardPaymentBlock_jsx(FormikInput["a" /* FormikInput */], {
    type: "radio",
    name: "selectorPaymentProviderId",
    isDisabled: isDisabled,
    value: PaymentInfo_const["f" /* HIPAY_PSP_ID */],
    label: CreditCardPaymentBlock_jsx("div", {
      className: "max-w-full"
    }, CreditCardPaymentBlock_jsx(CreditCardPaymentBlock_CreditCardContent, {
      hasFullAmount: hasFullAmount,
      rePaymentSchedule: rePaymentSchedule,
      paymentSchedule: paymentSchedule,
      totalAmount: totalAmount
    }), CreditCardPaymentBlock_jsx("span", {
      className: "block"
    }, CreditCardPaymentBlock_jsx(CreditCardPaymentBlock_FormatedCardsAccepted, null)))
  })) : CreditCardPaymentBlock_jsx("div", {
    className: "text-14 ml-20 mt-5"
  }, CreditCardPaymentBlock_jsx(CreditCardPaymentBlock_CreditCardContent, {
    hasFullAmount: hasFullAmount,
    rePaymentSchedule: rePaymentSchedule,
    paymentSchedule: paymentSchedule,
    totalAmount: totalAmount
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/B2BPaymentProvidersUtils.js



var B2BPaymentProvidersUtils_getB2BPaymentProviderLabel = function getB2BPaymentProviderLabel(_ref) {
  var paymentProvider = _ref.paymentProvider,
      isTotalAmount = _ref.isTotalAmount,
      getLabelByCanal = _ref.getLabelByCanal;
  var amountLabelKey = isTotalAmount ? 'totalAmount' : 'deposit';

  if (Object(paymentProvidersUtils["j" /* isTransfer */])(paymentProvider)) {
    return getLabelByCanal({
      cxoLabel: Object(src_i18n["h" /* t */])("booking.sellers.banking.paymentProvider.bankTransfer.".concat(amountLabelKey)),
      cmtaLabel: Object(src_i18n["h" /* t */])("booking.partners.banking.paymentProvider.bankTransfer.".concat(amountLabelKey))
    });
  }

  if (paymentProvider.selectorId === PaymentInfo_const["h" /* NAPAY_PSP_ID */]) {
    return Object(src_i18n["h" /* t */])("booking.partners.paymentNA.".concat(amountLabelKey));
  }

  if (Object(paymentProvidersUtils["i" /* isPayPal */])(paymentProvider)) {
    return Object(src_i18n["h" /* t */])("booking.sellers.banking.paymentProvider.paypal.".concat(amountLabelKey));
  }

  if (Object(paymentProvidersUtils["g" /* isCheque */])(paymentProvider)) {
    return Object(src_i18n["h" /* t */])("booking.banking.paymentProvider.cheque.".concat(amountLabelKey));
  }

  if (paymentProvider.shouldSkipPayment) {
    return Object(src_i18n["h" /* t */])("booking.banking.paymentSchedule.".concat(isTotalAmount ? 'payFullAmount' : 'depositSelected'));
  }

  return getLabelByCanal({
    cxoLabel: Object(src_i18n["h" /* t */])("booking.sellers.banking.paymentProvider.creditCard.".concat(amountLabelKey)),
    cmtaLabel: Object(src_i18n["h" /* t */])("booking.partners.banking.paymentProvider.creditCard.".concat(amountLabelKey))
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/B2BPaymentViewContext.jsx
var B2BPaymentViewContext_jsx = react_default.a.createElement;



var B2BPaymentViewContext = /*#__PURE__*/Object(react["createContext"])({
  getB2BPaymentProviderLabel: function getB2BPaymentProviderLabel() {
    return false;
  }
});
var B2BPaymentViewContext_B2BPaymentViewProvider = function B2BPaymentViewProvider(_ref) {
  var children = _ref.children;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isCxo = appContext.isCxo,
      isCmta = appContext.isCmta;

  var getLabelByCanal = function getLabelByCanal(_ref2) {
    var cxoLabel = _ref2.cxoLabel,
        cmtaLabel = _ref2.cmtaLabel;

    if (isCmta) {
      return cmtaLabel;
    }

    if (isCxo) {
      return cxoLabel;
    }

    return cxoLabel;
  };

  var isSeller = appContext.isSeller;

  var getB2BPaymentProviderLabel = function getB2BPaymentProviderLabel(_ref3) {
    var paymentProvider = _ref3.paymentProvider,
        isTotalAmount = _ref3.isTotalAmount;
    return isSeller && B2BPaymentProvidersUtils_getB2BPaymentProviderLabel({
      paymentProvider: paymentProvider,
      isTotalAmount: isTotalAmount,
      getLabelByCanal: getLabelByCanal
    });
  };

  return B2BPaymentViewContext_jsx(B2BPaymentViewContext.Provider, {
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value: {
      getB2BPaymentProviderLabel: getB2BPaymentProviderLabel
    }
  }, children);
};
var B2BPaymentViewContext_useB2BPaymentViewContext = function useB2BPaymentViewContext() {
  return Object(react["useContext"])(B2BPaymentViewContext);
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/GenericPaymentBlock.jsx


var GenericPaymentBlock_jsx = react_default.a.createElement;








var GenericPaymentBlock_GenericPaymentBlock = function GenericPaymentBlock(_ref) {
  var hasFullAmount = _ref.hasFullAmount,
      isDisabled = _ref.isDisabled,
      paymentProvider = _ref.paymentProvider,
      isProviderSelectable = _ref.isProviderSelectable,
      rePaymentSchedule = _ref.rePaymentSchedule,
      fees = _ref.fees,
      totalAmount = _ref.totalAmount,
      totalAmountWithFees = _ref.totalAmountWithFees,
      depositAmount = _ref.depositAmount,
      depositAmountWithFees = _ref.depositAmountWithFees,
      paymentMethodCategoryWithFees = _ref.paymentMethodCategoryWithFees;

  var _useB2BPaymentViewCon = B2BPaymentViewContext_useB2BPaymentViewContext(),
      getB2BPaymentProviderLabel = _useB2BPaymentViewCon.getB2BPaymentProviderLabel;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      isFreeDeposit = _useContext.isFreeDeposit;

  var isTotalAmount = isFreeDeposit || hasFullAmount || !rePaymentSchedule;
  var displayWithFees = paymentMethodCategoryWithFees.includes(paymentProvider.categoryPaymentMethod);
  var providerLabel = getB2BPaymentProviderLabel({
    paymentProvider: paymentProvider,
    isTotalAmount: isTotalAmount
  }) || Object(paymentProvidersUtils["d" /* getPaymentProviderLabel */])({
    paymentProvider: paymentProvider,
    isTotalAmount: isTotalAmount
  });
  var PaymentProviderLabel = /*#__PURE__*/Object(react["memo"])(function () {
    return GenericPaymentBlock_jsx(TemplateString["a" /* TemplateString */], {
      template: providerLabel,
      values: !isTotalAmount ? {
        depositAmount: displayWithFees ? depositAmountWithFees : depositAmount,
        balanceAmount: rePaymentSchedule.amount.formattedValue,
        balanceDate: Object(apiDate["g" /* formatApiDate */])(rePaymentSchedule.deadline, Object(src_i18n["h" /* t */])('booking.form.dateFormat'))
      } : {
        totalAmount: displayWithFees ? totalAmountWithFees : totalAmount
      },
      valuesClassName: {
        depositAmount: 'font-bold text-sienna',
        balanceAmount: 'font-bold text-sienna',
        totalAmount: 'font-bold text-sienna',
        balanceDate: 'font-bold',
        fees: 'font-bold text-blueWave'
      }
    });
  });
  return GenericPaymentBlock_jsx("div", {
    className: "my-10"
  }, GenericPaymentBlock_jsx("input", {
    type: "hidden",
    name: "paymentProviderId",
    value: paymentProvider.id
  }), isProviderSelectable ? GenericPaymentBlock_jsx(FormikInput["a" /* FormikInput */], {
    type: "radio",
    name: "selectorPaymentProviderId",
    "data-testid": "radioInput-paymentProviderId-".concat(paymentProvider.selectorId),
    isDisabled: isDisabled,
    value: paymentProvider.selectorId,
    label: GenericPaymentBlock_jsx(react_default.a.Fragment, null, GenericPaymentBlock_jsx(PaymentProviderLabel, null), ' ', !!fees && displayWithFees && GenericPaymentBlock_jsx(TemplateString["a" /* TemplateString */], {
      template: Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.feesApplied'),
      className: "text-12",
      values: {
        fees: fees
      },
      valuesClassName: {
        fees: 'font-bold text-blueWave'
      }
    }))
  }) : GenericPaymentBlock_jsx("div", {
    className: "text-14",
    "data-testid": "label-paymentProviderId-".concat(paymentProvider.selectorId)
  }, GenericPaymentBlock_jsx(PaymentProviderLabel, null)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-method/PaymentMethodsCardList.jsx





var PaymentMethodsCardList_jsx = react_default.a.createElement;







var PaymentMethodsCardList_PaymentMethodsCardList = function PaymentMethodsCardList(_ref) {
  var _formik$errors;

  var paymentProvider = _ref.paymentProvider,
      requiredRule = _ref.requiredRule,
      shouldSubmitFormOnPaymentChosen = _ref.shouldSubmitFormOnPaymentChosen;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  return PaymentMethodsCardList_jsx("div", {
    className: "mt-20"
  }, PaymentMethodsCardList_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('common.payment.hipay.cardListTitle')), PaymentMethodsCardList_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, PaymentMethodsCardList_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentMethodId",
    validate: requiredRule
  }), PaymentMethodsCardList_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentConditionId",
    validate: requiredRule
  }), PaymentMethodsCardList_jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-wrap', {
      'formik-errored': (_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.paymentMethodId
    })
  }, paymentProvider.paymentMethods.map(function (paymentMethod) {
    var _formik$errors2;

    var timePaymentCondition = paymentMethod.timePaymentConditions.find(function (condition) {
      return condition.id === paymentMethod.id;
    });
    return PaymentMethodsCardList_jsx("li", {
      key: paymentMethod.id,
      className: Object(classnames_utils["a" /* classnames */])('relative flex basis-1/4 flex-col justify-center', {
        'my-10 h-45': !timePaymentCondition,
        'basis-1/2 sm:basis-1/4': timePaymentCondition
      })
    }, PaymentMethodsCardList_jsx("img", {
      "data-testid": "PaymentMethodsCardList-".concat(paymentMethod.id),
      alt: paymentMethod.label || '',
      className: Object(classnames_utils["a" /* classnames */])('w-64 cursor-pointer rounded-2 p-10', {
        'border-1 border-saffron': formik.values.paymentMethodId === paymentMethod.id,
        'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2': !timePaymentCondition,
        'static left-auto top-auto mx-auto transform-none': timePaymentCondition,
        'border-1 border-red': (_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : _formik$errors2.paymentMethodId
      }),
      src: paymentMethod.image,
      onClick: function onClick() {
        formik.setFieldValue('paymentMethodId', paymentMethod.id);

        if (shouldSubmitFormOnPaymentChosen) {
          // should wait for validation to be done
          setTimeout(formik.submitForm, 0);
        }
      }
    }), timePaymentCondition && timePaymentCondition.chargePercentage > 0 ? PaymentMethodsCardList_jsx("p", {
      className: "m-0 text-center text-10 text-mediumGrey"
    }, Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.cardFeesLabel'), PaymentMethodsCardList_jsx("span", {
      className: "block font-bold text-blueWave"
    }, Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.chargePercentage', {
      charge_percentage: timePaymentCondition.chargePercentage
    }))) : null, PaymentMethodsCardList_jsx("span", {
      className: "sr-only"
    }, paymentMethod.label));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-method/PaymentMethodsCardListPaymentProvider.jsx





var PaymentMethodsCardListPaymentProvider_jsx = react_default.a.createElement;





var PaymentMethodsCardListPaymentProvider_PaymentMethodsCardListPaymentProvider = function PaymentMethodsCardListPaymentProvider(_ref) {
  var _formik$errors;

  var paymentProvider = _ref.paymentProvider,
      requiredRule = _ref.requiredRule,
      shouldSubmitFormOnPaymentChosen = _ref.shouldSubmitFormOnPaymentChosen;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  return PaymentMethodsCardListPaymentProvider_jsx("div", {
    className: "mt-20 flex flex-col"
  }, PaymentMethodsCardListPaymentProvider_jsx("span", {
    className: "text-14"
  }, Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.creditCard.cardList')), PaymentMethodsCardListPaymentProvider_jsx("div", null, PaymentMethodsCardListPaymentProvider_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentProviderId",
    validate: requiredRule
  }), PaymentMethodsCardListPaymentProvider_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentMethodId"
  }), PaymentMethodsCardListPaymentProvider_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentConditionId"
  }), PaymentMethodsCardListPaymentProvider_jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-wrap', {
      'formik-errored': (_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.paymentMethodId
    })
  }, paymentProvider.paymentMethods.map(function (paymentMethod) {
    var _paymentMethod$timePa, _formik$errors2;

    var timePaymentCondition = paymentMethod === null || paymentMethod === void 0 ? void 0 : (_paymentMethod$timePa = paymentMethod.timePaymentConditions) === null || _paymentMethod$timePa === void 0 ? void 0 : _paymentMethod$timePa.find(function (condition) {
      return condition.id === paymentMethod.id;
    });
    var isPaymentMethodSelected = formik.values.paymentProviderId === paymentProvider.id && formik.values.paymentMethodId === paymentMethod.id;
    return PaymentMethodsCardListPaymentProvider_jsx("li", {
      key: paymentMethod.id,
      className: Object(classnames_utils["a" /* classnames */])('relative flex basis-1/4 flex-col justify-center', {
        'my-10 h-45': !timePaymentCondition,
        'basis-1/2 sm:basis-1/4': timePaymentCondition
      })
    }, PaymentMethodsCardListPaymentProvider_jsx("img", {
      "data-testid": "PaymentMethodsCardList-".concat(paymentMethod.id),
      alt: paymentMethod.label || '',
      className: Object(classnames_utils["a" /* classnames */])('w-64 cursor-pointer rounded-2 p-10', {
        'border-1 border-saffron': isPaymentMethodSelected,
        'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2': !timePaymentCondition,
        'static left-auto top-auto mx-auto transform-none': timePaymentCondition,
        'border-1 border-red': (_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : _formik$errors2.paymentMethodId
      }),
      src: paymentMethod.image,
      onClick: function onClick() {
        formik.setFieldValue('paymentProviderId', paymentProvider.id);
        formik.setFieldValue('selectorPaymentProviderId', paymentProvider.selectorId);
        formik.setFieldValue('paymentMethodId', paymentMethod.id);

        if (shouldSubmitFormOnPaymentChosen) {
          // should wait for validation to be done
          setTimeout(formik.submitForm, 0);
        }
      }
    }), timePaymentCondition && timePaymentCondition.chargePercentage > 0 ? PaymentMethodsCardListPaymentProvider_jsx("p", {
      className: "m-0 text-center text-10 text-mediumGrey"
    }, Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.cardFeesLabel'), PaymentMethodsCardListPaymentProvider_jsx("span", {
      className: "block font-bold text-blueWave"
    }, Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.chargePercentage', {
      charge_percentage: timePaymentCondition.chargePercentage
    }))) : null, PaymentMethodsCardListPaymentProvider_jsx("span", {
      className: "sr-only"
    }, paymentMethod.label));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentMethods.jsx




var PaymentMethods_jsx = react_default.a.createElement;







var PaymentMethods_requiredRule = lib["string"]().required();
var PaymentMethods_PaymentMethods = function PaymentMethods(_ref) {
  var _formik$errors, _formik$touched, _formik$errors2, _formik$touched2;

  var paymentProvider = _ref.paymentProvider,
      shouldSubmitFormOnPaymentChosen = _ref.shouldSubmitFormOnPaymentChosen,
      _ref$isPaymentProvide = _ref.isPaymentProvider,
      isPaymentProvider = _ref$isPaymentProvide === void 0 ? false : _ref$isPaymentProvide;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var CardListComponent = isPaymentProvider ? PaymentMethodsCardListPaymentProvider_PaymentMethodsCardListPaymentProvider : PaymentMethodsCardList_PaymentMethodsCardList;
  Object(react["useEffect"])(function () {
    var accordingPaymentMethod = paymentProvider.paymentMethods.find(function (_ref2) {
      var id = _ref2.id;
      return id === formik.values.paymentMethodId;
    });

    if (formik.values.paymentMethodId && accordingPaymentMethod) {
      formik.setFieldValue('paymentConditionId', // $FlowFixMe always found
      accordingPaymentMethod.timePaymentConditions[0].id);
    }
  }, [formik.values.paymentMethodId]);
  return PaymentMethods_jsx(react["Fragment"], null, PaymentMethods_jsx(CardListComponent, {
    paymentProvider: paymentProvider,
    requiredRule: PaymentMethods_requiredRule,
    shouldSubmitFormOnPaymentChosen: shouldSubmitFormOnPaymentChosen
  }), (((_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.paymentMethodId) && ((_formik$touched = formik.touched) === null || _formik$touched === void 0 ? void 0 : _formik$touched.paymentMethodId) || ((_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : _formik$errors2.paymentConditionId) && ((_formik$touched2 = formik.touched) === null || _formik$touched2 === void 0 ? void 0 : _formik$touched2.paymentConditionId)) && PaymentMethods_jsx(FormFeedback["a" /* FormFeedback */], {
    isError: true,
    message: Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.errorMessageSelectCardType')
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentMethodsWrapper.jsx
var PaymentMethodsWrapper_jsx = react_default.a.createElement;




var PaymentMethodsWrapper_PaymentMethodsWrapper = function PaymentMethodsWrapper(_ref) {
  var paymentProvider = _ref.paymentProvider,
      shouldAutoSubmitForm = _ref.shouldAutoSubmitForm;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isCloselyIntegratedPaymentsProvider = paymentProvider.paymentMethods.length > 0;

  if (isCloselyIntegratedPaymentsProvider) {
    return PaymentMethodsWrapper_jsx(PaymentMethods_PaymentMethods, {
      paymentProvider: paymentProvider,
      isPaymentProvider: true,
      shouldSubmitFormOnPaymentChosen: !!shouldAutoSubmitForm
    });
  }

  if (appContext.isCmta && !appContext.cmta.isDelCredere) {
    // Card payment for seller wich are not del credere
    return null;
  }

  return PaymentMethodsWrapper_jsx("div", {
    className: "mb-10 flex justify-end text-12"
  }, PaymentMethodsWrapper_jsx("span", {
    className: "mr-10 mt-2"
  }, Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.Safedebit')), PaymentMethodsWrapper_jsx("img", {
    alt: paymentProvider.label,
    className: "h-20",
    src: paymentProvider.logo
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PayPalPaymentBlock.jsx
var PayPalPaymentBlock_jsx = react_default.a.createElement;








var PayPalPaymentBlock_PayPalPaymentBlock = function PayPalPaymentBlock(_ref) {
  var hasFullAmount = _ref.hasFullAmount,
      isDisabled = _ref.isDisabled,
      rePaymentSchedule = _ref.rePaymentSchedule,
      totalAmount = _ref.totalAmount,
      totalAmountWithFees = _ref.totalAmountWithFees,
      depositAmount = _ref.depositAmount,
      depositAmountWithFees = _ref.depositAmountWithFees,
      paymentProvider = _ref.paymentProvider,
      fees = _ref.fees;

  var _useB2BPaymentViewCon = B2BPaymentViewContext_useB2BPaymentViewContext(),
      getB2BPaymentProviderLabel = _useB2BPaymentViewCon.getB2BPaymentProviderLabel;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      isFreeDeposit = _useContext.isFreeDeposit;

  var isTotalAmount = isFreeDeposit || hasFullAmount || !rePaymentSchedule;
  var providerLabel = getB2BPaymentProviderLabel({
    paymentProvider: paymentProvider,
    isTotalAmount: isTotalAmount
  }) || Object(paymentProvidersUtils["d" /* getPaymentProviderLabel */])({
    paymentProvider: paymentProvider,
    isTotalAmount: isTotalAmount
  });
  return PayPalPaymentBlock_jsx("div", {
    "data-testid": "Type-payment-PayPal",
    className: "my-25 max-w-full text-14 sm:max-w-4/5"
  }, PayPalPaymentBlock_jsx("input", {
    type: "hidden",
    name: "paymentProviderId",
    value: paymentProvider.id
  }), PayPalPaymentBlock_jsx(FormikInput["a" /* FormikInput */], {
    type: "radio",
    name: "selectorPaymentProviderId",
    isDisabled: isDisabled,
    value: paymentProvider.id,
    label: PayPalPaymentBlock_jsx("div", {
      className: "text-14 leading-normal text-black"
    }, PayPalPaymentBlock_jsx(TemplateString["a" /* TemplateString */], {
      template: providerLabel,
      values: !isTotalAmount ? {
        depositAmount: fees ? depositAmountWithFees : depositAmount,
        balanceAmount: rePaymentSchedule.amount.formattedValue,
        balanceDate: Object(apiDate["g" /* formatApiDate */])(rePaymentSchedule.deadline, Object(src_i18n["h" /* t */])('booking.form.dateFormat'))
      } : {
        totalAmount: fees ? totalAmountWithFees : totalAmount
      },
      valuesClassName: {
        depositAmount: 'font-bold text-sienna',
        balanceAmount: 'font-bold text-sienna',
        totalAmount: 'font-bold text-sienna',
        balanceDate: 'font-bold'
      }
    }), ' ', !!fees && PayPalPaymentBlock_jsx(TemplateString["a" /* TemplateString */], {
      template: Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.feesApplied'),
      className: "text-12",
      values: {
        fees: fees
      },
      valuesClassName: {
        fees: 'font-bold text-blueWave'
      }
    }))
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentProviders.jsx






















var PaymentProviders_jsx = react_default.a.createElement;

function PaymentProviders_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PaymentProviders_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PaymentProviders_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PaymentProviders_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

















var PaymentProviders_isPaymentProviderWithLogo = function isPaymentProviderWithLogo(_ref) {
  var categoryPaymentMethod = _ref.categoryPaymentMethod;
  return [PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].BANK_TRANSFER, PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].PAYPAL].includes(categoryPaymentMethod);
};

var PaymentProviders_PaymentProviderTitle = function PaymentProviderTitle(_ref2) {
  var paymentProvider = _ref2.paymentProvider;
  var title = paymentProvider.description;

  if (paymentProvider.selectorId === PaymentInfo_const["h" /* NAPAY_PSP_ID */]) {
    title = Object(src_i18n["h" /* t */])('booking.partners.paymentNA.title');
  }

  if (Object(paymentProvidersUtils["i" /* isPayPal */])(paymentProvider)) {
    title = Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.paypal.title');
  }

  return PaymentProviders_jsx("div", {
    className: "flex items-start justify-between"
  }, PaymentProviders_jsx("label", {
    key: paymentProvider.selectorId,
    "data-testid": "PaymentProviders-".concat(paymentProvider.selectorId),
    className: Object(classnames_utils["a" /* classnames */])('text-18', 'font-bold', 'text-black', 'pb-10')
  }, title), PaymentProviders_isPaymentProviderWithLogo(paymentProvider) && paymentProvider.logo && PaymentProviders_jsx("img", {
    src: paymentProvider.logo,
    alt: "".concat(paymentProvider.categoryPaymentMethod || '', " logo")
  }));
};

var PaymentProviders_BankTransferChecks = function BankTransferChecks(_ref3) {
  var isFramed = _ref3.isFramed;
  return PaymentProviders_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('mb-25 w-fit', {
      'border-1 border-sienna p-5': isFramed
    })
  }, PaymentProviders_jsx("div", {
    className: "flex items-center py-2"
  }, PaymentProviders_jsx(Icon["a" /* Icon */], {
    className: "text-sienna",
    name: icons["a" /* ICONS */].CHECK,
    width: "1rem"
  }), PaymentProviders_jsx("span", {
    className: "ms-10 text-12"
  }, Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.bankTransfer.security'))), PaymentProviders_jsx("div", {
    className: "flex items-center py-2"
  }, PaymentProviders_jsx(Icon["a" /* Icon */], {
    className: "text-sienna",
    name: icons["a" /* ICONS */].CHECK,
    width: "1rem"
  }), PaymentProviders_jsx("span", {
    className: "ms-10 text-12"
  }, Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.bankTransfer.paymentCap'))));
};

var PaymentProviders_PaymentProviders = function PaymentProviders(_ref4) {
  var hasFullAmount = _ref4.hasFullAmount,
      isDisabled = _ref4.isDisabled,
      orderedPaymentProviders = _ref4.orderedPaymentProviders,
      paymentSchedule = _ref4.paymentSchedule,
      rePaymentSchedule = _ref4.rePaymentSchedule,
      shouldAutoSubmitForm = _ref4.shouldAutoSubmitForm,
      amountToPay = _ref4.amountToPay,
      onProviderSelection = _ref4.onProviderSelection;
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      cardFeesPercentage = _useContext.cardFeesPercentage,
      currency = _useContext.currency;

  var handlePaymentBlockClick = function handlePaymentBlockClick(_ref5) {
    var _paymentProvider$paym;

    var paymentProvider = _ref5.paymentProvider,
        hasTimePaymentConditions = _ref5.hasTimePaymentConditions;
    var isVoxpayPaymentProvider = Object(paymentProvidersUtils["k" /* isVoxpayProvider */])(paymentProvider.id);
    var hasPaymentMethods = !!((_paymentProvider$paym = paymentProvider.paymentMethods) === null || _paymentProvider$paym === void 0 ? void 0 : _paymentProvider$paym.length);

    if (!hasPaymentMethods || hasTimePaymentConditions || isVoxpayPaymentProvider) {
      paymentProvider.categoryPaymentMethod && (onProviderSelection === null || onProviderSelection === void 0 ? void 0 : onProviderSelection(paymentProvider.categoryPaymentMethod));
      Object(paymentProvidersUtils["e" /* handleClickPaymentProviderBlock */])({
        paymentProvider: paymentProvider,
        formik: formik,
        isDisabled: isDisabled,
        mustKeepPaymentMethod: isVoxpayPaymentProvider && hasPaymentMethods
      });

      if (!isDisabled) {
        if (!isVoxpayPaymentProvider) {
          setTimeout(function () {
            Object(scrollToElement["a" /* scrollToElement */])('#HealthRegulationsTitleId');
          }, 500);
        }
      }
    }
  };

  var isBankTransferChecksFramed = orderedPaymentProviders[0].id === PaymentInfo_const["f" /* HIPAY_PSP_ID */] && orderedPaymentProviders[0].paymentMethods.length === 0;
  var paymentProviderId = formik.values.paymentProviderId;
  var paymentProviders = orderedPaymentProviders.map(function (provider) {
    return PaymentProviders_objectSpread(PaymentProviders_objectSpread({}, provider), {}, {
      paymentMethods: provider.paymentMethods.length === 1 ? [] : provider.paymentMethods
    });
  });
  var autoSelectPaymentMethodFns = orderedPaymentProviders.reduce(function (fns, _ref6) {
    var paymentMethods = _ref6.paymentMethods,
        selectorId = _ref6.selectorId;
    var shouldAutoSelectPaymentMethod = paymentMethods.length === 1;
    var paymentMethod = shouldAutoSelectPaymentMethod && paymentMethods[0];

    var autoSelectPaymentMethod = function autoSelectPaymentMethod() {
      if (paymentMethod) {
        formik.setFieldValue('paymentMethodId', paymentMethod.id);
        formik.setFieldValue('paymentConditionId', paymentMethod.id);
      }
    };

    fns[selectorId] = autoSelectPaymentMethod;
    return fns;
  }, {});
  Object(react["useEffect"])(function () {
    var _autoSelectPaymentMet;

    (_autoSelectPaymentMet = autoSelectPaymentMethodFns[paymentProviderId]) === null || _autoSelectPaymentMet === void 0 ? void 0 : _autoSelectPaymentMet.call(autoSelectPaymentMethodFns);
  }, [paymentProviderId]);
  var isCardFeesOnly = !!cardFeesPercentage;
  return PaymentProviders_jsx("div", {
    "data-testid": "Payment-method-block"
  }, paymentProviders.map(function (paymentProvider, index) {
    var _paymentProvider$paym2;

    var hasNoPaymentMethods = paymentProvider.paymentMethods.length === 0;
    var borderBottom = index + 1 < orderedPaymentProviders.length && 'border-b-1';
    var cursorPointer = hasNoPaymentMethods && 'cursor-pointer';
    var isHipayPaymentProvider = paymentProvider.id === PaymentInfo_const["f" /* HIPAY_PSP_ID */];
    var isPayPalPaymentProvider = Object(paymentProvidersUtils["i" /* isPayPal */])(paymentProvider);
    var feesRate = cardFeesPercentage || Number(Object(src_i18n["h" /* t */])("booking.banking.paymentProvider.".concat(lowerFirst_default()((paymentProvider === null || paymentProvider === void 0 ? void 0 : paymentProvider.categoryPaymentMethod) || ''), ".feesRate"))) || 0;

    var _map = [amountToPay, paymentSchedule.depositAmount.value].map(function (amount) {
      return Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(amount, locale, currency, {
        precision: 2
      });
    }),
        _map2 = Object(slicedToArray["a" /* default */])(_map, 2),
        totalAmount = _map2[0],
        depositAmount = _map2[1];

    var _map3 = [amountToPay, paymentSchedule.depositAmount.value].map(function (amount) {
      return Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(amount * (1 + feesRate), locale, currency, {
        precision: 2
      });
    }),
        _map4 = Object(slicedToArray["a" /* default */])(_map3, 2),
        totalAmountWithFees = _map4[0],
        depositAmountWithFees = _map4[1];

    var hasTimePaymentConditions = paymentProvider === null || paymentProvider === void 0 ? void 0 : (_paymentProvider$paym2 = paymentProvider.paymentMethods) === null || _paymentProvider$paym2 === void 0 ? void 0 : _paymentProvider$paym2.some(function (_ref7) {
      var timePaymentConditions = _ref7.timePaymentConditions;
      return timePaymentConditions.length > 1;
    });
    var isGenericPaymentProvider = !isHipayPaymentProvider && !isPayPalPaymentProvider;
    var shouldDisplayPaymentMethods = !hasNoPaymentMethods && !hasTimePaymentConditions;
    var isProviderSelectable = Object(paymentProvidersUtils["k" /* isVoxpayProvider */])(paymentProvider.id) || paymentProvider.paymentMethods.length <= 1 || hasTimePaymentConditions && orderedPaymentProviders.length > 1;
    var paymentBlockProps = {
      isDisabled: isDisabled,
      hasFullAmount: hasFullAmount,
      rePaymentSchedule: rePaymentSchedule,
      totalAmount: totalAmount,
      totalAmountWithFees: totalAmountWithFees,
      depositAmount: depositAmount,
      depositAmountWithFees: depositAmountWithFees,
      fees: feesRate ? "".concat(feesRate * 100, "%") : ''
    };
    return PaymentProviders_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('relative isolate m-0 flex flex-row-reverse', borderBottom, cursorPointer),
      "data-testid": paymentProvider.selectorId,
      key: paymentProvider.selectorId,
      onClick: function onClick() {
        return handlePaymentBlockClick({
          paymentProvider: paymentProvider,
          hasTimePaymentConditions: hasTimePaymentConditions
        });
      }
    }, hasNoPaymentMethods && (isHipayPaymentProvider || Object(paymentProvidersUtils["h" /* isCreditCard */])(paymentProvider)) && PaymentProviders_jsx(Icon["a" /* Icon */], {
      className: "end-0 mx-20 mt-30",
      name: icons["a" /* ICONS */].CREDIT_CARD,
      width: "5rem"
    }), PaymentProviders_jsx("div", {
      className: "w-full p-20"
    }, PaymentProviders_jsx(PaymentProviders_PaymentProviderTitle, {
      paymentProvider: paymentProvider
    }), isHipayPaymentProvider && PaymentProviders_jsx(CreditCardPaymentBlock_CreditCardPaymentBlock, Object(esm_extends["a" /* default */])({}, paymentBlockProps, {
      paymentSchedule: paymentSchedule,
      hasNoPaymentMethods: hasNoPaymentMethods
    })), isPayPalPaymentProvider && PaymentProviders_jsx(PayPalPaymentBlock_PayPalPaymentBlock, Object(esm_extends["a" /* default */])({}, paymentBlockProps, {
      paymentProvider: paymentProvider
    })), Object(paymentProvidersUtils["j" /* isTransfer */])(paymentProvider) && PaymentProviders_jsx(PaymentProviders_BankTransferChecks, {
      isFramed: isBankTransferChecksFramed
    }), isGenericPaymentProvider && PaymentProviders_jsx(GenericPaymentBlock_GenericPaymentBlock, Object(esm_extends["a" /* default */])({}, paymentBlockProps, {
      paymentProvider: paymentProvider,
      isProviderSelectable: isProviderSelectable,
      paymentMethodCategoryWithFees: isCardFeesOnly ? [PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].CREDIT_CARD] : Object.values(PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */]).map(String)
    })), shouldDisplayPaymentMethods && PaymentProviders_jsx(PaymentMethodsWrapper_PaymentMethodsWrapper, {
      paymentProvider: paymentProvider,
      shouldAutoSubmitForm: shouldAutoSubmitForm
    })));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentProvidersForm.jsx



var PaymentProvidersForm_jsx = react_default.a.createElement;










var PaymentProvidersForm_PaymentProvidersForm = function PaymentProvidersForm(_ref) {
  var displayNewPaymentProvidersImplementation = _ref.displayNewPaymentProvidersImplementation,
      hasFullAmount = _ref.hasFullAmount,
      isDisabled = _ref.isDisabled,
      paymentProviders = _ref.paymentProviders,
      paymentSchedule = _ref.paymentSchedule,
      shouldAutoSubmitForm = _ref.shouldAutoSubmitForm,
      showPaymentMethodWithConditions = _ref.showPaymentMethodWithConditions,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'booking.banking.paymentProvider.blockTitle' : _ref$title,
      onProviderSelection = _ref.onProviderSelection;
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      isOrderedProviders = _useContext.isOrderedProviders,
      isFreeDeposit = _useContext.isFreeDeposit;

  var freeDeposit = formik.values.freeDeposit;
  var amountToPay;

  if (isFreeDeposit) {
    amountToPay = freeDeposit;
  } else {
    amountToPay = paymentSchedule.total.value;
  }

  var rePaymentSchedule = paymentSchedule.repaymentSchedules[0];
  var orderedPaymentProviders = !isOrderedProviders && !isTablet ? Object(paymentProvidersUtils["c" /* getOrderedPaymentProviders */])(paymentProviders, Object(src_i18n["h" /* t */])('booking.banking.paymentProvider.displayOrder.mobile')) : paymentProviders;
  return displayNewPaymentProvidersImplementation ? PaymentProvidersForm_jsx("div", {
    className: "w-full"
  }, PaymentProvidersForm_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])(title)), PaymentProvidersForm_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, PaymentProvidersForm_jsx(PaymentProviders_PaymentProviders, {
    orderedPaymentProviders: orderedPaymentProviders,
    hasFullAmount: hasFullAmount,
    rePaymentSchedule: rePaymentSchedule,
    showPaymentMethodWithConditions: showPaymentMethodWithConditions,
    shouldAutoSubmitForm: shouldAutoSubmitForm,
    paymentSchedule: paymentSchedule,
    amountToPay: amountToPay,
    isDisabled: isDisabled,
    onProviderSelection: onProviderSelection
  }))) : PaymentProvidersForm_jsx("div", {
    className: "w-full"
  }, PaymentProvidersForm_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])(title)), PaymentProvidersForm_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, PaymentProvidersForm_jsx("div", {
    className: "flex flex-wrap"
  }, PaymentProvidersForm_jsx(PaymentProvidersOldImplementation_PaymentProvidersOldImplementation, {
    orderedPaymentProviders: orderedPaymentProviders,
    isDisabled: isDisabled
  }))));
};
// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: ./src/utils/ple-utils/phoneUtils.js + 33 modules
var phoneUtils = __webpack_require__("3gnk");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/VoxpayForm/VoxpayEmailInput.jsx
var VoxpayEmailInput_jsx = react_default.a.createElement;





var VoxpayEmailInput_VoxpayEmailInput = function VoxpayEmailInput(_ref) {
  var isDisabled = _ref.isDisabled,
      fieldName = _ref.fieldName,
      _ref$withValidation = _ref.withValidation,
      withValidation = _ref$withValidation === void 0 ? true : _ref$withValidation;
  var validateEmail = lib["string"]().matches(RegexHelper["a" /* emailRegex */], Object(src_i18n["h" /* t */])('booking.partners.linkPayment.email.invalidEmail')).required();
  return VoxpayEmailInput_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: isDisabled,
    name: fieldName,
    label: Object(src_i18n["h" /* t */])('common.form.labels.email'),
    type: "email",
    validate: withValidation ? validateEmail : undefined
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/VoxpayForm/VoxpayPhoneInput.jsx

var VoxpayPhoneInput_jsx = react_default.a.createElement;







var VoxpayPhoneInput_VoxpayPhoneInput = function VoxpayPhoneInput(_ref) {
  var isDisabled = _ref.isDisabled,
      fieldName = _ref.fieldName,
      _ref$withValidation = _ref.withValidation,
      withValidation = _ref$withValidation === void 0 ? true : _ref$withValidation;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var phoneRegex = Object(RegexHelper["b" /* getPhoneRegex */])(appContext.locale);
  var validatePhone = lib["string"]().matches(phoneRegex, Object(src_i18n["h" /* t */])('booking.partners.linkPayment.sms.invalidNumber')).matches(RegexHelper["c" /* internationalPhoneRegex */], Object(src_i18n["h" /* t */])('booking.partners.linkPayment.sms.wrongFormatInternational')).required();
  return VoxpayPhoneInput_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: isDisabled,
    name: fieldName,
    onChange: function onChange(e) {
      return formik.setFieldValue(fieldName, e.target.value.trim());
    },
    label: Object(src_i18n["h" /* t */])('common.form.labels.mobilePhoneNumber'),
    type: "tel",
    validate: withValidation ? validatePhone : undefined
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/VoxpayForm/useCustomerId.js




var useCustomerId_useCustomerId = function useCustomerId(customerNeolaneId) {
  var _selectedProposal$hou, _selectedProposal$hou2, _selectedProposal$hou3, _selectedProposal$hou4;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      _useContext$selectedH = _useContext.selectedHouseholdIndex,
      selectedHouseholdIndex = _useContext$selectedH === void 0 ? 0 : _useContext$selectedH;

  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["i" /* getCurrentProposal */]);
  return (selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$hou = selectedProposal.households) === null || _selectedProposal$hou === void 0 ? void 0 : (_selectedProposal$hou2 = _selectedProposal$hou[selectedHouseholdIndex]) === null || _selectedProposal$hou2 === void 0 ? void 0 : (_selectedProposal$hou3 = _selectedProposal$hou2.attendees) === null || _selectedProposal$hou3 === void 0 ? void 0 : (_selectedProposal$hou4 = _selectedProposal$hou3[0]) === null || _selectedProposal$hou4 === void 0 ? void 0 : _selectedProposal$hou4.customerId) || customerNeolaneId || '';
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/VoxpayForm/VoxpayForm.jsx







var VoxpayForm_jsx = react_default.a.createElement;













var VOXPAY_PHONE = 'phone';
var VOXPAY_SMS = 'sms';
var VOXPAY_EMAIL = 'email';
var VoxpayForm_VoxpayForm = function VoxpayForm(_ref) {
  var isDisabled = _ref.isDisabled,
      isCreditCardMethod = _ref.isCreditCardMethod;

  var _useRouter = Object(next_router["useRouter"])(),
      queryParams = _useRouter.query;

  var location = {
    queryParams: queryParams
  };

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale,
      customerNeolaneId = _useAppContext.customerNeolaneId;

  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var locationSearch = Object(uriUtils["g" /* getLocationSearch */])(location);
  var customerId = useCustomerId_useCustomerId(customerNeolaneId);
  var selectedVoxpayMethod = formik.values.selectedVoxpayMethod;
  var emailFieldName = 'billingDetails.email';
  var phoneFieldName = 'billingDetails.mobilePhone';
  var isVoxpayPhoneAllowed = isCreditCardMethod && (locationSearch.includes(dist["appQueryParameters"].cxo.call_reference) || locationSearch.includes(dist["appQueryParameters"].cxo.contact_id));
  Object(useGQL["a" /* useGQL */])({
    query: "{\n          profile(userId: \"".concat(customerId, "\", throw401Error: true) {\n            email\n            phone:mobilePhoneNumber\n          }\n        }\n        "),
    queryOptions: {
      requestName: 'PROFILE_EMAIL_PHONE'
    },
    cache: false,
    map: function map(result) {
      var _ref2 = result.profile || {},
          _ref2$email = _ref2.email,
          email = _ref2$email === void 0 ? '' : _ref2$email,
          _ref2$phone = _ref2.phone,
          phone = _ref2$phone === void 0 ? '' : _ref2$phone;

      formik.setFieldValue(emailFieldName, email);
      formik.setFieldValue(phoneFieldName, Object(phoneUtils["b" /* formatPhoneToInternationalFormat */])(phone, locale));
    }
  });
  Object(react["useEffect"])(function () {
    formik.setFieldValue('selectedVoxpayMethod', VOXPAY_SMS);
  }, []);
  Object(react["useEffect"])(function () {
    var fieldToEmpty = [];

    if (selectedVoxpayMethod !== VOXPAY_SMS) {
      fieldToEmpty.push(phoneFieldName);
    }

    if (selectedVoxpayMethod !== VOXPAY_EMAIL) {
      fieldToEmpty.push(emailFieldName);
    }

    if (formik.isSubmitting && formik.isValidating) {
      fieldToEmpty.forEach(function (fieldname) {
        formik.setFieldValue(fieldname, undefined);
      });
    }
  }, [formik.isSubmitting]);
  var voxpayMethodsFields = [{
    value: VOXPAY_SMS,
    Input: VoxpayPhoneInput_VoxpayPhoneInput
  }, {
    value: VOXPAY_EMAIL,
    Input: VoxpayEmailInput_VoxpayEmailInput
  }, {
    value: VOXPAY_PHONE,
    isVisible: isVoxpayPhoneAllowed
  }];
  return VoxpayForm_jsx("div", {
    className: "p-20"
  }, VoxpayForm_jsx("div", {
    className: "my-5 text-sienna"
  }, Object(src_i18n["h" /* t */])("booking.partners.linkPayment.".concat(selectedVoxpayMethod, ".sendEmail"))), VoxpayForm_jsx("div", {
    className: "flex justify-around"
  }, voxpayMethodsFields.map(function (_ref3) {
    var _ref3$isVisible = _ref3.isVisible,
        isVisible = _ref3$isVisible === void 0 ? true : _ref3$isVisible,
        value = _ref3.value,
        _ref3$Input = _ref3.Input,
        Input = _ref3$Input === void 0 ? null : _ref3$Input;
    return isVisible && VoxpayForm_jsx("div", {
      className: "w-full",
      key: value
    }, VoxpayForm_jsx(FormikInput["a" /* FormikInput */], {
      label: Object(src_i18n["h" /* t */])("booking.partners.linkPayment.".concat(value, ".title")),
      name: "selectedVoxpayMethod",
      value: value,
      type: "radio"
    }), Input && VoxpayForm_jsx("div", {
      className: "pl-30"
    }, VoxpayForm_jsx(Input, {
      isDisabled: isDisabled,
      withValidation: selectedVoxpayMethod === value,
      fieldName: value === VOXPAY_SMS ? phoneFieldName : emailFieldName
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/VoxpayBlock.jsx
var VoxpayBlock_jsx = react_default.a.createElement;






var VoxpayBlock_VoxpayBlock = function VoxpayBlock(_ref) {
  var isDisabled = _ref.isDisabled,
      selectedPaymentMethod = _ref.selectedPaymentMethod;
  return VoxpayBlock_jsx("div", {
    className: "mt-20 w-full"
  }, VoxpayBlock_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.partners.linkPayment.title')), VoxpayBlock_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, VoxpayBlock_jsx(VoxpayForm_VoxpayForm, {
    isDisabled: isDisabled,
    isCreditCardMethod: selectedPaymentMethod === PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].CREDIT_CARD
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/B2BPaymentProvidersForm.jsx



var B2BPaymentProvidersForm_jsx = react_default.a.createElement;











var B2BPaymentProvidersForm_B2BPaymentProvidersForm = function B2BPaymentProvidersForm(_ref) {
  var _selectedPaymentProvi;

  var hasPaymentProvidersMatchingBlock = _ref.hasPaymentProvidersMatchingBlock,
      displayNewPaymentProvidersImplementation = _ref.displayNewPaymentProvidersImplementation,
      hasFullAmount = _ref.hasFullAmount,
      isDisabled = _ref.isDisabled,
      paymentProviders = _ref.paymentProviders,
      selectedPaymentProvider = _ref.selectedPaymentProvider,
      paymentSchedule = _ref.paymentSchedule,
      shouldAutoSubmitForm = _ref.shouldAutoSubmitForm,
      showPaymentMethodWithConditions = _ref.showPaymentMethodWithConditions;
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useState = Object(react["useState"])(''),
      selectedPaymentMethod = _useState[0],
      setSelectedPaymentMethod = _useState[1];

  var paymentProviderId = formik.values.paymentProviderId;
  var isVoxpayPaymentProvider = Object(paymentProvidersUtils["k" /* isVoxpayProvider */])(paymentProviderId);
  var hasPaymentMethods = !!((_selectedPaymentProvi = selectedPaymentProvider.paymentMethods) === null || _selectedPaymentProvi === void 0 ? void 0 : _selectedPaymentProvi.length);
  Object(react["useEffect"])(function () {
    !hasPaymentMethods && formik.setFieldValue('paymentConditionId', '');
  }, [hasPaymentMethods]);
  Object(react["useEffect"])(function () {
    setSelectedPaymentMethod((selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.categoryPaymentMethod) || '');
  }, [paymentProviderId]); // TO DO: check if we can delete this component to use common b2c method

  return B2BPaymentProvidersForm_jsx(react["Fragment"], null, B2BPaymentProvidersForm_jsx(PaymentProvidersForm_PaymentProvidersForm, {
    displayNewPaymentProvidersImplementation: displayNewPaymentProvidersImplementation,
    hasFullAmount: hasFullAmount,
    isDisabled: isDisabled,
    paymentProviders: paymentProviders,
    paymentSchedule: paymentSchedule,
    shouldAutoSubmitForm: shouldAutoSubmitForm,
    showPaymentMethodWithConditions: showPaymentMethodWithConditions,
    onProviderSelection: setSelectedPaymentMethod
  }), hasPaymentProvidersMatchingBlock && isVoxpayPaymentProvider && B2BPaymentProvidersForm_jsx(VoxpayBlock_VoxpayBlock, {
    selectedPaymentMethod: selectedPaymentMethod,
    isDisabled: isDisabled
  }), paymentProviderId === PaymentInfo_const["c" /* DEPOSIT_OFFSET_PSP_ID */] && B2BPaymentProvidersForm_jsx("div", {
    className: "full mt-20 w-full"
  }, B2BPaymentProvidersForm_jsx(Title["a" /* Title */], {
    className: "mb-10"
  }, Object(src_i18n["h" /* t */])('booking.partners.banking.comments.title')), B2BPaymentProvidersForm_jsx(Capsule["a" /* Capsule */], {
    header: "none",
    contentClassName: "p-20"
  }, B2BPaymentProvidersForm_jsx(FormikInput["a" /* FormikInput */], {
    placeholder: Object(src_i18n["h" /* t */])('booking.partners.banking.comments.fieldPlaceholder'),
    name: "comments",
    type: "textarea",
    validate: lib["string"]().required(Object(src_i18n["h" /* t */])('booking.partners.banking.comments.error'))
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/HealthRegulations.jsx





var HealthRegulations_jsx = react_default.a.createElement;









var HealthRegulations_HealthRegulations = function HealthRegulations(_ref) {
  var _formik$errors, _formik$touched, _formik$errors2, _formik$touched2;

  var shouldSubmitFormOnAccept = _ref.shouldSubmitFormOnAccept,
      isDisabled = _ref.isDisabled,
      healthRegulations = _ref.healthRegulations,
      _ref$hasNoPaymentMeth = _ref.hasNoPaymentMethods,
      hasNoPaymentMethods = _ref$hasNoPaymentMeth === void 0 ? false : _ref$hasNoPaymentMeth;
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var submitFormOnAccept = function submitFormOnAccept(_ref2) {
    var currentTarget = _ref2.currentTarget;
    var shouldProceedToSubmit = currentTarget.checked;

    if (shouldSubmitFormOnAccept && shouldProceedToSubmit && formik.values.paymentMethodId) {
      // submit form if asked and all the cgv are checked and a paymentMethodId is selected
      // should wait for validation to be done
      setTimeout(formik.submitForm, 0);
    }

    if (hasNoPaymentMethods && shouldProceedToSubmit && formik.values.paymentProviderId === PaymentInfo_const["f" /* HIPAY_PSP_ID */] && formik.values.termsAndConditions.cgv) {
      setTimeout(function () {
        formik.submitForm();
        Object(scrollToElement["a" /* scrollToElement */])('#payment-form-iframe');
      }, 500);
    }
  };

  var hasCGVError = ((_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.HealthRegulations) && ((_formik$touched = formik.touched) === null || _formik$touched === void 0 ? void 0 : _formik$touched.HealthRegulations) && ((_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : _formik$errors2.HealthRegulations.cgv) && ((_formik$touched2 = formik.touched) === null || _formik$touched2 === void 0 ? void 0 : _formik$touched2.HealthRegulations.cgv);
  return HealthRegulations_jsx("div", {
    "data-testid": "Contract-info-block"
  }, HealthRegulations_jsx(Title["a" /* Title */], {
    className: "mb-10",
    id: "HealthRegulationsTitleId",
    theme: "title-brand-n2"
  }, healthRegulations.label), HealthRegulations_jsx(Capsule["a" /* Capsule */], {
    header: "none",
    contentClassName: "p-20"
  }, HealthRegulations_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: isDisabled,
    isRequired: true,
    label: HealthRegulations_jsx(react_default.a.Fragment, null, HealthRegulations_jsx("span", null, healthRegulations.description), HealthRegulations_jsx("span", null, HealthRegulations_jsx("a", {
      className: "text-inherit underline",
      href: healthRegulations.url,
      rel: "noreferrer noopener",
      target: "_blank"
    }, Object(src_i18n["h" /* t */])('booking.banking.healthRegulation.termsOfSales')))),
    name: "HealthRegulations.cgv",
    onChange: submitFormOnAccept,
    type: "checkbox"
  })), hasCGVError && HealthRegulations_jsx("div", {
    id: "HealthRegulations-cgv-error",
    "aria-live": "polite"
  }, HealthRegulations_jsx(FormFeedback["a" /* FormFeedback */], {
    isError: true,
    message: Object(src_i18n["h" /* t */])('booking.banking.healthRegulation.errorMessage')
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/payment-form/TermsAndConditions.jsx
var TermsAndConditions = __webpack_require__("LhnV");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.const.jsx + 16 modules
var BuyNowPayLater_const = __webpack_require__("U6Jk");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.jsx





var BuyNowPayLater_jsx = react_default.a.createElement;



var BuyNowPayLater_BuyNowPayLater = function BuyNowPayLater(_ref) {
  var paymentPlans = _ref.paymentPlans,
      price = _ref.price,
      displayIframe = _ref.displayIframe,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["paymentPlans", "price", "displayIframe"]);

  var formik = Object(formik_esm["e" /* useFormikContext */])();
  Object(react["useEffect"])(function () {
    paymentPlans.map(function (_ref2) {
      var id = _ref2.value;
      return !BuyNowPayLater_const["c" /* PAYMENT_PLAN_IFRAME */][id] && props.onLoaded({
        id: id,
        display: false
      });
    });
  }, []);
  return paymentPlans.map(function (_ref3) {
    var id = _ref3.value;
    var PlanIframe = BuyNowPayLater_const["c" /* PAYMENT_PLAN_IFRAME */][id];

    var onPaymentPlanLoaded = function onPaymentPlanLoaded(display) {
      return props.onLoaded({
        id: id,
        display: display
      });
    };

    return PlanIframe && BuyNowPayLater_jsx(PlanIframe, {
      key: id,
      onLoaded: onPaymentPlanLoaded,
      price: price,
      display: displayIframe && formik.values.paymentProviderId === id
    });
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__("Jhhs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("uFXj");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Label.jsx
var Label = __webpack_require__("vJSV");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/inputsUtils.js
var inputsUtils = __webpack_require__("vpua");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/ErrorNote.jsx
var ErrorNote = __webpack_require__("TuHz");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/HostedField.jsx

var HostedField_jsx = react_default.a.createElement;





var HostedField_HostedField = function HostedField(_ref) {
  var label = _ref.label,
      id = _ref.id,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      children = _ref.children,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      errorMessage = _ref.errorMessage,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? true : _ref$container;
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: !hasError && !isValid,
    isErrored: hasError,
    isValidated: isValid
  });
  return HostedField_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('pt-20 px-10 pb-10 w-full', {
      'basis-full': !small,
      'basis-1/2': small
    })
  }, HostedField_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: id,
    isErrored: hasError,
    isRequired: isRequired,
    label: label
  }), HostedField_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(container ? classes : {}, {
      'border-red': hasError,
      'border-success': isValid
    }),
    id: id
  }, children), hasError && errorMessage && HostedField_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: true,
    errorMessage: errorMessage
  }));
};
// EXTERNAL MODULE: ./src/hooks/use-script-loader/useScriptLoader.js
var useScriptLoader = __webpack_require__("/WwO");

// EXTERNAL MODULE: /opt/webapp/node_modules/jsonwebtoken/index.js
var jsonwebtoken = __webpack_require__("W3Hu");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/CybersourceForm.jsx





















var CybersourceForm_jsx = react_default.a.createElement;

function CybersourceForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CybersourceForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CybersourceForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CybersourceForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var CYBERSOURCE_FIELD_CARD_NUMBER = 'cybersource-card-number';
var CYBERSOURCE_FIELD_EXPIRY_DATE = 'cybersource-card-expiry';
var CYBERSOURCE_FIELD_CVC = 'cybersource-card-cvc';
var defaultHostedFieldState = {
  valid: false,
  dirty: false,
  empty: true
};
var CybersourceForm_CyberSourceForm = function CyberSourceForm(_ref) {
  var _formik$errors2, _formik$errors3, _formik$touched, _formik$errors4;

  var token = _ref.token;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();

  var _ref2 = Object(jsonwebtoken["decode"])(token) || {
    ctx: [{
      data: {}
    }]
  },
      _ref2$ctx = Object(slicedToArray["a" /* default */])(_ref2.ctx, 1),
      _ref2$ctx$0$data = _ref2$ctx[0].data,
      scriptUrl = _ref2$ctx$0$data.clientLibrary,
      scriptIntegrity = _ref2$ctx$0$data.clientLibraryIntegrity;

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(scriptUrl, {
    integrity: scriptIntegrity,
    crossorigin: 'anonymous'
  }),
      scriptLoaded = _useScriptLoader.scriptLoaded;

  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isFormSubmitted = _useDisclosure.isOpen,
      setIsFormSubmitted = _useDisclosure.onOpen;

  var _useState = Object(react["useState"])({
    number: defaultHostedFieldState,
    securityCode: defaultHostedFieldState
  }),
      creditCardFieldsValidation = _useState[0],
      setCreditCardFieldsValidation = _useState[1];

  Object(react["useEffect"])(function () {
    formik.isSubmitting && setIsFormSubmitted();
  }, [formik.isSubmitting]);
  var cardNumberValidation = creditCardFieldsValidation.number,
      securityCodeValidation = creditCardFieldsValidation.securityCode;
  var hostedFieldsState = Object.keys(creditCardFieldsValidation).reduce(function (acc, key) {
    var _creditCardFieldsVali = creditCardFieldsValidation[key],
        isDirty = _creditCardFieldsVali.dirty,
        isValid = _creditCardFieldsVali.valid,
        isEmpty = _creditCardFieldsVali.empty;
    var isTouched = isDirty || isFormSubmitted;
    acc[key] = {
      hasError: isTouched && (!isValid || isEmpty),
      errorMessage: isEmpty ? Object(src_i18n["h" /* t */])('common.form.errors.requiredField') : Object(src_i18n["h" /* t */])('common.form.errors.invalidFieldFormat'),
      isValid: isDirty && isValid
    };
    return acc;
  }, {});
  var microformInstanceRef = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    if (scriptLoaded && token) {
      var options = {
        keyId: token,
        keystore: token,
        container: "#".concat(CYBERSOURCE_FIELD_CARD_NUMBER),
        label: '.HostedField-label',
        placeholder: Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderCardNumber'),
        styles: {
          input: {
            'font-size': '14px',
            color: '#000'
          },
          '::placeholder': {
            color: '#9ca3af'
          }
        }
      };
      var form = new window.Flex(token);
      var microform = form.microform(options);
      microformInstanceRef.current = microform;
      [{
        type: 'number',
        placeholder: Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderCardNumber'),
        id: CYBERSOURCE_FIELD_CARD_NUMBER
      }, {
        type: 'securityCode',
        placeholder: Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderCvc'),
        id: CYBERSOURCE_FIELD_CVC
      }].map(function (_ref3) {
        var type = _ref3.type,
            placeholder = _ref3.placeholder,
            id = _ref3.id;
        var field = microform.createField(type, {
          placeholder: placeholder
        });
        field.load("#".concat(id));
        field.on('change', function (_ref4) {
          var _card$;

          var valid = _ref4.valid,
              card = _ref4.card,
              empty = _ref4.empty;

          if (card === null || card === void 0 ? void 0 : (_card$ = card[0]) === null || _card$ === void 0 ? void 0 : _card$.name) {
            var _card$2;

            formik.setFieldValue('paymentProduct', (_card$2 = card[0]) === null || _card$2 === void 0 ? void 0 : _card$2.name);
          }

          setCreditCardFieldsValidation(function (validation) {
            return CybersourceForm_objectSpread(CybersourceForm_objectSpread({}, validation), {}, Object(defineProperty["a" /* default */])({}, type, {
              valid: valid,
              empty: empty,
              dirty: true
            }));
          });
        });
      });
    }
  }, [scriptLoaded]);

  var _formik$errors = formik.errors,
      tokenError = _formik$errors.token,
      errors = Object(objectWithoutProperties["a" /* default */])(_formik$errors, ["token"]);

  var isFormValid = !Object.keys(errors).length;
  var shouldRequestToken = microformInstanceRef.current && cardNumberValidation.valid && securityCodeValidation.valid && !((_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : _formik$errors2[CYBERSOURCE_FIELD_EXPIRY_DATE]) && !formik.values.token && isFormValid && formik.isSubmitting;
  Object(react["useEffect"])(function () {
    if (shouldRequestToken) {
      dispatch(Object(globalLoader_action["d" /* startLoading */])());
      var creditCardExpiryDateObject = new Date(formik.values[CYBERSOURCE_FIELD_EXPIRY_DATE]);
      var expirationMonth = (creditCardExpiryDateObject.getMonth() + 1).toString().padStart(2, '0');
      var expirationYear = creditCardExpiryDateObject.getFullYear().toString(); // $FlowFixMe: microformInstanceRef.current is defined at this point

      microformInstanceRef.current.createToken({
        expirationMonth: expirationMonth,
        expirationYear: expirationYear
      }, function (err, tokenizedCard) {
        if (err) {
          dispatch(Object(globalLoader_action["c" /* endLoading */])());
          throw Error(err.message || 'Could not generate token');
        }

        formik.setFieldValue('token', tokenizedCard);
        setTimeout(formik.submitForm, 0);
      });
    }
    /**
     * If we have a token and the form payment process is on error, we must delete the old token
     * because the user could update his credit card data, so we must request a new token on the next submit
     */


    var shouldDeleteToken = formik.values.token && formik.status && formik.status.paymentProcessOnError;

    if (shouldDeleteToken) {
      formik.setFieldValue('token', '');
    }
  }, [formik.isSubmitting, formik.status]);
  var inputStyle = 'outline-none rounded-2 text-14 text-black duration-250 ease-in transition-all w-full';

  var _t$toUpperCase$split = Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderExpiryDate').toUpperCase().split('/'),
      _t$toUpperCase$split2 = Object(slicedToArray["a" /* default */])(_t$toUpperCase$split, 2),
      monthExpiryPlaceholder = _t$toUpperCase$split2[0],
      yearExpiryPlaceholder = _t$toUpperCase$split2[1];

  return CybersourceForm_jsx(react["Fragment"], null, CybersourceForm_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    isRequired: true,
    name: "token"
  }), CybersourceForm_jsx(Title["a" /* Title */], {
    className: Object(classnames_utils["a" /* classnames */])('mb-10', {
      'formik-errored': !formik.values.token
    }),
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('common.payment.hipay.cardDetailTitle')), CybersourceForm_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, CybersourceForm_jsx("div", {
    className: "flex flex-wrap px-0 py-15"
  }, CybersourceForm_jsx(HostedField_HostedField, Object(esm_extends["a" /* default */])({
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.cardNumberLabel'),
    id: "".concat(CYBERSOURCE_FIELD_CARD_NUMBER)
  }, hostedFieldsState.number)), CybersourceForm_jsx("div", {
    className: "flex w-full flex-col sm:flex-row"
  }, CybersourceForm_jsx(HostedField_HostedField, {
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.expiryDateLabel'),
    id: "".concat(CYBERSOURCE_FIELD_EXPIRY_DATE),
    small: true,
    hasError: (_formik$errors3 = formik.errors) === null || _formik$errors3 === void 0 ? void 0 : _formik$errors3[CYBERSOURCE_FIELD_EXPIRY_DATE],
    isValid: ((_formik$touched = formik.touched) === null || _formik$touched === void 0 ? void 0 : _formik$touched[CYBERSOURCE_FIELD_EXPIRY_DATE]) && !((_formik$errors4 = formik.errors) === null || _formik$errors4 === void 0 ? void 0 : _formik$errors4[CYBERSOURCE_FIELD_EXPIRY_DATE]),
    container: false
  }, CybersourceForm_jsx(FormikInput["a" /* FormikInput */], {
    type: "creditCardExpiry",
    name: "".concat(CYBERSOURCE_FIELD_EXPIRY_DATE),
    className: "w-full",
    dateFormat: Object(src_i18n["h" /* t */])('booking.form.dateFormat'),
    monthPlaceholder: monthExpiryPlaceholder,
    yearPlaceholder: yearExpiryPlaceholder,
    validate: paymentProvidersUtils["a" /* creditCardExpiryValidator */],
    customClasses: inputStyle
  })), CybersourceForm_jsx(HostedField_HostedField, Object(esm_extends["a" /* default */])({
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.cvcLabel'),
    id: "".concat(CYBERSOURCE_FIELD_CVC),
    small: true
  }, hostedFieldsState.securityCode))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/HipayForm.jsx














var HipayForm_jsx = react_default.a.createElement;


function HipayForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function HipayForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HipayForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HipayForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var HIPAY_FIELD_FULL_NAME = 'hipay-card-holder';
var HIPAY_FIELD_CARD_NUMBER = 'hipay-card-number';
var HIPAY_FIELD_EXPIRY_DATE = 'hipay-card-expiry';
var HIPAY_FIELD_CVC = 'hipay-card-cvc';
var HipayForm_HipayForm = function HipayForm() {
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(config_default.a.get('psp.mhipay.script_url')),
      scriptLoaded = _useScriptLoader.scriptLoaded;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useState = Object(react["useState"])({
    cardNumber: '',
    cvc: '',
    expiryDate: '',
    cardHolder: ''
  }),
      errors = _useState[0],
      setErrors = _useState[1];

  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isHipayFormReady = _useDisclosure.isOpen,
      setIsHipayFormReady = _useDisclosure.onOpen;

  var hipayCardCreated = Object(react["useRef"])({});

  var setHipayErrorsAsObject = function setHipayErrorsAsObject(hipayErrors) {
    setErrors(hipayErrors.reduce(function (acc, _ref) {
      var field = _ref.field,
          error = _ref.error;
      return HipayForm_objectSpread(HipayForm_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, field, error));
    }, {}));
  };

  Object(react["useEffect"])(function () {
    if (formik.isSubmitting && isHipayFormReady && !formik.values.token) {
      hipayCardCreated.current.getPaymentData().catch(setHipayErrorsAsObject);
    }
  }, [formik.isSubmitting, isHipayFormReady]);
  Object(react["useEffect"])(function () {
    if (scriptLoaded) {
      // eslint-disable-next-line new-cap
      var hipay = window.HiPay({
        environment: config_default.a.get('psp.mhipay.environment'),
        password: config_default.a.get('psp.mhipay.password'),
        username: config_default.a.get('psp.mhipay.username')
      });
      hipayCardCreated.current = hipay.create('card', {
        multi_use: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('psp.tokenize.mhipay'),
        fields: {
          cardHolder: {
            placeholder: Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderFullName'),
            selector: "".concat(HIPAY_FIELD_FULL_NAME)
          },
          cardNumber: {
            placeholder: Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderCardNumber'),
            selector: "".concat(HIPAY_FIELD_CARD_NUMBER)
          },
          cvc: {
            placeholder: Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderCvc'),
            selector: "".concat(HIPAY_FIELD_CVC)
          },
          expiryDate: {
            placeholder: Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderExpiryDate'),
            selector: "".concat(HIPAY_FIELD_EXPIRY_DATE)
          }
        }
      });
      hipayCardCreated.current.on('ready', setIsHipayFormReady);
      hipayCardCreated.current.on('change', /*#__PURE__*/function () {
        var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
          var valid, hipayErrors, data;
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  valid = _ref2.valid, hipayErrors = _ref2.errors;
                  setHipayErrorsAsObject(hipayErrors);

                  if (valid) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", formik.setFieldValue('token', ''));

                case 4:
                  _context.next = 6;
                  return hipayCardCreated.current.getPaymentData();

                case 6:
                  data = _context.sent;

                  /**
                   * Even if browserInfo is not related to uri state or oidc, this helper is very handy in this case
                   * to store it as form field and send the object to gql as string
                   * */
                  formik.setFieldValue('browserInfo', dist["oidc"].toUriEncodedState(data.browser_info));
                  formik.setFieldValue('paymentProduct', data.payment_product);
                  formik.setFieldValue('token', data.token);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, [scriptLoaded]);
  return HipayForm_jsx("div", {
    "data-testid": "Payment-Credit-Card-Block"
  }, HipayForm_jsx(FormikInput["a" /* FormikInput */], {
    isRequired: true,
    name: "browserInfo",
    type: "hidden"
  }), HipayForm_jsx(FormikInput["a" /* FormikInput */], {
    isRequired: true,
    name: "token",
    type: "hidden"
  }), HipayForm_jsx(FormikInput["a" /* FormikInput */], {
    name: "paymentProduct",
    type: "hidden"
  }), HipayForm_jsx(Title["a" /* Title */], {
    className: Object(classnames_utils["a" /* classnames */])('mb-10', {
      'formik-errored': !formik.values.token
    }),
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('common.payment.hipay.cardDetailTitle')), HipayForm_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, HipayForm_jsx("div", {
    className: "flex flex-wrap px-0 py-20"
  }, HipayForm_jsx(HostedField_HostedField, {
    id: "".concat(HIPAY_FIELD_FULL_NAME),
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.fullNameLabel'),
    errorMessage: errors.cardHolder,
    hasError: !!errors.cardHolder
  }), HipayForm_jsx(HostedField_HostedField, {
    id: "".concat(HIPAY_FIELD_CARD_NUMBER),
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.cardNumberLabel'),
    errorMessage: errors.cardNumber,
    hasError: !!errors.cardNumber
  }), HipayForm_jsx(HostedField_HostedField, {
    id: "".concat(HIPAY_FIELD_EXPIRY_DATE),
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.expiryDateLabel'),
    errorMessage: errors.expiryDate,
    hasError: !!errors.expiryDate
  }), HipayForm_jsx(HostedField_HostedField, {
    id: "".concat(HIPAY_FIELD_CVC),
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.cvcLabel'),
    errorMessage: errors.cvc,
    hasError: !!errors.cvc,
    small: true
  }))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("aLgo");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("hCOa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/IxopayCardForm.jsx















var IxopayCardForm_jsx = react_default.a.createElement;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }














var IxopayCardForm_IxopayCardForm = function IxopayCardForm() {
  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      country = _useAppContext.country;

  var dispatch = Object(es["d" /* useDispatch */])();

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(config_default.a.get("psp.ixopay.".concat(country, ".scriptUrl")), {
    'data-main': 'payment-js'
  }),
      scriptLoaded = _useScriptLoader.scriptLoaded;

  var paymentJs = Object(react["useRef"])(null);

  var _React$useState = react_default.a.useState({
    valid: true,
    length: 0
  }),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      cvvState = _React$useState2[0],
      setCvvState = _React$useState2[1];

  var _React$useState3 = react_default.a.useState({
    valid: true,
    length: 0
  }),
      _React$useState4 = Object(slicedToArray["a" /* default */])(_React$useState3, 2),
      numberState = _React$useState4[0],
      setNumberState = _React$useState4[1];

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      submitForm = _useFormikContext.submitForm,
      isSubmitting = _useFormikContext.isSubmitting,
      setFieldValue = _useFormikContext.setFieldValue,
      setErrors = _useFormikContext.setErrors;

  Object(react["useEffect"])(function () {
    if (scriptLoaded) {
      paymentJs.current = new window.PaymentJs('1.3');
      paymentJs.current.init(config_default.a.get("psp.ixopay.".concat(country, ".integrationKey")), 'number', 'cvv', function (payment) {
        var style = {
          border: '0px ',
          width: '100%',
          height: '24px',
          outline: 'none',
          boxShadow: 'none',
          '::placeholder': {
            color: '#9ca3af'
          }
        };
        payment.setNumberStyle(style);
        payment.setCvvStyle(style);
        payment.setNumberPlaceholder(Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderCardNumber'));
        payment.setCvvPlaceholder(Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderCvc'));
        payment.numberOn('input', function (_ref) {
          var validNumber = _ref.validNumber,
              numberLength = _ref.numberLength;
          return setNumberState({
            valid: validNumber,
            length: numberLength
          });
        });
        payment.cvvOn('input', function (_ref2) {
          var validCvv = _ref2.validCvv,
              cvvLength = _ref2.cvvLength;
          return setCvvState({
            valid: validCvv,
            length: cvvLength
          });
        });
      });
    }
  }, [scriptLoaded]);
  Object(react["useEffect"])(function () {
    if (isSubmitting && !values.token) {
      dispatch(Object(globalLoader_action["d" /* startLoading */])());
      var creditCardExpiryDateObject = new Date(values.year);
      var expirationMonth = (creditCardExpiryDateObject.getMonth() + 1).toString().padStart(2, '0');
      var expirationYear = creditCardExpiryDateObject.getFullYear().toString();
      paymentJs.current.tokenize({
        card_holder: values.card_holder,
        month: expirationMonth,
        year: expirationYear
      }, function (token) {
        setFieldValue('token', token);
        submitForm();
      }, function (errors) {
        var formikErrors = {};

        var _iterator = _createForOfIteratorHelper(errors),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var error = _step.value;
            formikErrors[error.attribute] = error.message;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (errors.length !== 0) {
          dispatch(Object(globalLoader_action["c" /* endLoading */])());
        }

        setErrors({
          card_holder: formikErrors.card_holder,
          year: formikErrors.year
        });
        setCvvState({
          valid: false,
          length: 0,
          errorMessage: formikErrors.cvv
        });
        setNumberState({
          valid: false,
          length: 0,
          errorMessage: formikErrors.number
        });
      });
    }
  }, [isSubmitting]);

  var _t$toUpperCase$split = Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderExpiryDate').toUpperCase().split('/'),
      _t$toUpperCase$split2 = Object(slicedToArray["a" /* default */])(_t$toUpperCase$split, 2),
      monthExpiryPlaceholder = _t$toUpperCase$split2[0],
      yearExpiryPlaceholder = _t$toUpperCase$split2[1];

  return IxopayCardForm_jsx("div", null, IxopayCardForm_jsx(Title["a" /* Title */], {
    className: "mb-10"
  }, Object(src_i18n["h" /* t */])('common.payment.hipay.cardDetailTitle')), IxopayCardForm_jsx(Capsule["a" /* Capsule */], {
    className: "flex flex-col",
    header: "none",
    contentClassName: "p-20"
  }, IxopayCardForm_jsx(FormikInput["a" /* FormikInput */], {
    isRequired: true,
    name: "token",
    type: "hidden"
  }), IxopayCardForm_jsx("div", {
    className: "px-10"
  }, IxopayCardForm_jsx(FormikInput["a" /* FormikInput */], {
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.fullNameLabel'),
    name: "card_holder",
    id: "card_holder",
    placeholder: Object(src_i18n["h" /* t */])('common.payment.hipay.placeholderFullName')
  })), IxopayCardForm_jsx(HostedField_HostedField, {
    type: "number",
    name: "number",
    id: "number",
    className: "w-full",
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.cardNumberLabel'),
    hasError: !numberState.valid,
    isValid: numberState.valid && numberState.length > 0,
    errorMessage: numberState.errorMessage || Object(src_i18n["h" /* t */])('common.form.errors.invalidFieldFormat')
  }), IxopayCardForm_jsx("div", {
    className: "flex flex-col md:flex-row"
  }, IxopayCardForm_jsx(HostedField_HostedField, {
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.expiryDateLabel'),
    small: true,
    container: false
  }, IxopayCardForm_jsx(FormikInput["a" /* FormikInput */], {
    type: "creditCardExpiry",
    name: "year",
    dateFormat: Object(src_i18n["h" /* t */])('booking.form.dateFormat'),
    monthPlaceholder: monthExpiryPlaceholder,
    validate: paymentProvidersUtils["a" /* creditCardExpiryValidator */],
    yearPlaceholder: yearExpiryPlaceholder
  })), IxopayCardForm_jsx(HostedField_HostedField, {
    type: "number",
    name: "cvv",
    id: "cvv",
    className: "w-full",
    label: Object(src_i18n["h" /* t */])('common.payment.hipay.cvcLabel'),
    hasError: !cvvState.valid,
    isValid: cvvState.valid && cvvState.length > 0,
    errorMessage: cvvState.errorMessage || Object(src_i18n["h" /* t */])('common.form.errors.invalidFieldFormat')
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentProviderForm.jsx
var PaymentProviderForm_jsx = react_default.a.createElement;





var PaymentProviderForm_PaymentProviderForm = function PaymentProviderForm(_ref) {
  var selectedPaymentProvider = _ref.selectedPaymentProvider;
  return PaymentProviderForm_jsx("div", {
    className: "mt-20",
    id: "payment-form-iframe"
  }, selectedPaymentProvider.id === PaymentInfo_const["f" /* HIPAY_PSP_ID */] && PaymentProviderForm_jsx(HipayForm_HipayForm, null), selectedPaymentProvider.id === PaymentInfo_const["b" /* CYBERSOURCE_PSP_ID */] && // $FlowFixMe: CyberSource provider always has a token
  PaymentProviderForm_jsx(CybersourceForm_CyberSourceForm, {
    token: selectedPaymentProvider.token.value
  }), selectedPaymentProvider.id === PaymentInfo_const["g" /* IXOPAY_PSP_ID */] && PaymentProviderForm_jsx(IxopayCardForm_IxopayCardForm, null));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var lodash_isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty);

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/ScrollToErrorHook.js
var ScrollToErrorHook = __webpack_require__("I7/a");

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js + 1 modules
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.utils.jsx
var BuyNowPayLater_utils = __webpack_require__("AV+p");

// EXTERNAL MODULE: ./src/client/components/widgets/booking-navbar/useBookingNavbar.js
var useBookingNavbar = __webpack_require__("IOWS");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaypalForm/PaypalForm.jsx


var PaypalForm_jsx = react_default.a.createElement;





var PaypalForm_PaypalForm = function PaypalForm(_ref) {
  var isAbleToPay = _ref.isAbleToPay,
      onSuccess = _ref.onSuccess,
      amount = _ref.amount;

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(config_default.a.get('psp.mhipay.script_url')),
      scriptLoaded = _useScriptLoader.scriptLoaded;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale,
      currency = _useAppContext.currency;

  Object(react["useEffect"])(function () {
    if (scriptLoaded) {
      // eslint-disable-next-line new-cap
      var hipay = window.HiPay({
        environment: config_default.a.get('psp.mhipay.environment'),
        password: config_default.a.get('psp.mhipay.password'),
        username: config_default.a.get('psp.mhipay.username')
      });
      var instancePayPal = hipay.create('paypal', {
        canPayLater: false,
        request: {
          amount: amount,
          currency: currency,
          locale: locale.replace('-', '_')
        },
        paypalButtonStyle: {
          shape: 'pill',
          color: 'gold',
          height: 45
        },
        template: 'auto',
        selector: 'paypal-button'
      });
      instancePayPal.on('paymentAuthorized', function (data) {
        onSuccess(data.orderID);
      });
    }
  }, [scriptLoaded]);
  return PaypalForm_jsx("div", {
    id: "paypal-button",
    className: Object(classnames_utils["a" /* classnames */])('h-45', {
      hidden: !isAbleToPay
    })
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaypalForm/usePaypalForm.js




var usePaypalForm_jsx = react_default.a.createElement;







var usePaypalForm_usePaypalForm = function usePaypalForm() {
  var _formik$errors;

  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var _formik$values = formik.values,
      paymentProviderId = _formik$values.paymentProviderId,
      amountToPay = _formik$values.amountToPay;

  var isAbleToPay = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('psp.paypal.enable_button') && paymentProviderId === PaymentInfo_const["n" /* PAYPAL_PSP_ID */] && isEmpty_default()((_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.termsAndConditions);

  var onSuccess = Object(react["useCallback"])(function (token) {
    formik.setFieldValue('token', token);
    formik.submitForm();
  }, [formik]);
  var onError = Object(react["useCallback"])(function () {
    formik.setFieldValue('token', '');
  }, [formik]);
  var paypalButton = Object(react["useMemo"])(function () {
    if (!isAbleToPay) {
      return null;
    }

    return usePaypalForm_jsx(PaypalForm_PaypalForm, {
      isAbleToPay: isAbleToPay,
      onSuccess: onSuccess,
      amount: amountToPay,
      onError: onError
    });
  }, [isAbleToPay, onSuccess, amountToPay, onError]);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    continueBtn: paypalButton
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/hooks/useBankingNavbar.jsx













var useBankingNavbar_useBankingNavbar = function useBankingNavbar(_ref) {
  var selectedPaymentProvider = _ref.selectedPaymentProvider,
      paymentPlans = _ref.paymentPlans,
      isIframe = _ref.isIframe,
      showPaymentMethodWithConditions = _ref.showPaymentMethodWithConditions,
      paymentMethodLabel = _ref.paymentMethodLabel;
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      isFreeDeposit = _useContext.isFreeDeposit,
      isBuyNowPayLaterProcessComplete = _useContext.isBuyNowPayLaterProcessComplete;

  var dispatch = Object(es["d" /* useDispatch */])();
  var selectedBuyNowPayLaterPlan = paymentPlans.find(function (_ref2) {
    var value = _ref2.value;
    return value === formik.values.paymentProviderId;
  });
  var isBuyNowPayLaterProcess = !!(selectedBuyNowPayLaterPlan === null || selectedBuyNowPayLaterPlan === void 0 ? void 0 : selectedBuyNowPayLaterPlan.isIframe);
  var hideContinueButton = isIframe && formik.isValid || isIframe && showPaymentMethodWithConditions || isBuyNowPayLaterProcess && !isBuyNowPayLaterProcessComplete;
  var isPaymentMethodNotSelected = (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.paymentMethods) && selectedPaymentProvider.paymentMethods.length > 1 && !formik.values.paymentMethodId;
  var validationCallback = Object(react["useCallback"])(function () {
    if (isFreeDeposit) {
      formik.values.amountToPay = formik.values.freeDeposit;
    }

    if (isBuyNowPayLaterProcess) {
      dispatch(Object(globalLoader_action["d" /* startLoading */])());
      Object(BuyNowPayLater_utils["d" /* submitBuyNowPayLater */])(selectedBuyNowPayLaterPlan === null || selectedBuyNowPayLaterPlan === void 0 ? void 0 : selectedBuyNowPayLaterPlan.value);
    } else {
      formik.submitForm();
    }

    return Promise.reject();
  }, [isFreeDeposit, paymentMethodLabel, isBuyNowPayLaterProcess]);
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    priceShouldIncludeDonation: !isBuyNowPayLaterProcess,
    isDisabled: isPaymentMethodNotSelected && !isBuyNowPayLaterProcessComplete,
    hideContinueButton: hideContinueButton,
    validationCallback: validationCallback,
    paymentLabel: isBuyNowPayLaterProcess && Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.completeBookingLabel')
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/useB2BPaymentForm.js














function useB2BPaymentForm_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function useB2BPaymentForm_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? useB2BPaymentForm_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : useB2BPaymentForm_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}









var useB2BPaymentForm_useB2BPaymentForm = function useB2BPaymentForm(props) {
  var _props$paymentProvide = props.paymentProviders,
      paymentProviders = _props$paymentProvide === void 0 ? [] : _props$paymentProvide,
      paymentFormDisplay = Object(objectWithoutProperties["a" /* default */])(props, ["paymentProviders"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      isIndirectBooking = _useContext.isIndirectBooking;

  var isCmta = appContext.isCmta,
      isCxo = appContext.isCxo,
      isSeller = appContext.isSeller;
  var selectedPaymentProvider = paymentProviders.find(function (_ref) {
    var selectorId = _ref.selectorId;
    return selectorId === formik.values.selectorPaymentProviderId;
  });
  var hideContinueButton = isCmta && (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.paymentMethods.length) !== 0 && !formik.values.paymentMethodId;
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    hideContinueButton: hideContinueButton
  });

  if (!isSeller) {
    return props;
  }

  var hasOnlyNaPaymentForCxo = isCxo && (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.id) === PaymentInfo_const["h" /* NAPAY_PSP_ID */];
  var isVoxpay = Object(paymentProvidersUtils["k" /* isVoxpayProvider */])(formik.values.paymentProviderId);
  var displayB2BPaymentProvidersForm = !!(hasOnlyNaPaymentForCxo || isSeller && Object(paymentProvidersUtils["k" /* isVoxpayProvider */])(selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.id) || isCmta && paymentProviders.length && !paymentFormDisplay.displayPaymentMethodsWithConditions);
  var displayPaymentProvidersForm = paymentFormDisplay.displayPaymentProvidersForm && !displayB2BPaymentProvidersForm;
  var displayNewPaymentProvidersImplementation = isSeller;
  var displayB2BFreeDeposit = paymentFormDisplay.displayFreeDeposit && (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('opcTax') && isIndirectBooking || isCxo && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('exceedTotalAmount'));
  return useB2BPaymentForm_objectSpread(useB2BPaymentForm_objectSpread({}, paymentFormDisplay), {}, {
    displayB2BPaymentPlan: true,
    displayPaymentPlan: false,
    displayNewPaymentProvidersImplementation: displayNewPaymentProvidersImplementation,
    displayB2BPaymentProvidersForm: displayB2BPaymentProvidersForm,
    displayPaymentProvidersForm: displayPaymentProvidersForm,
    displayPaymentMethods: paymentFormDisplay.displayPaymentMethods && !isVoxpay,
    displayB2BFreeDeposit: displayB2BFreeDeposit
  }, displayB2BFreeDeposit ? {
    displayFreeDeposit: false
  } : {});
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/hooks/usePaymentFormDisplay.js












var usePaymentFormDisplay_usePaymentFormDisplay = function usePaymentFormDisplay(_ref) {
  var _formik$errors, _selectedPaymentProvi, _selectedPaymentProvi2, _selectedPaymentProvi3;

  var isBuyNowPayLaterPlan = _ref.isBuyNowPayLaterPlan,
      paymentProviders = _ref.paymentProviders,
      paymentPlans = _ref.paymentPlans,
      hasPaymentProvidersMatchingBlock = _ref.hasPaymentProvidersMatchingBlock,
      selectedPaymentProvider = _ref.selectedPaymentProvider,
      showPaymentMethodWithConditions = _ref.showPaymentMethodWithConditions,
      hasNoPaymentMethods = _ref.hasNoPaymentMethods,
      healthRegulations = _ref.healthRegulations,
      isHealthRegulationsChecked = _ref.isHealthRegulationsChecked,
      isHostedFields = _ref.isHostedFields;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      donationAmount = _useContext.donationAmount,
      isFreeDeposit = _useContext.isFreeDeposit;

  var isTermsAndConditionsChecked = isEmpty_default()((_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.termsAndConditions);

  var selectedPaymentMethod = selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : (_selectedPaymentProvi = selectedPaymentProvider.paymentMethods) === null || _selectedPaymentProvi === void 0 ? void 0 : _selectedPaymentProvi.find(function (_ref2) {
    var id = _ref2.id;
    return id === formik.values.paymentMethodId;
  });
  var shouldShowPaymentProviderOfSpecificCard = isHostedFields && isTermsAndConditionsChecked && formik.values.paymentMethodId && formik.values.paymentConditionId && isHealthRegulationsChecked && selectedPaymentMethod && (selectedPaymentMethod.category === PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].CREDIT_CARD || selectedPaymentMethod.category === PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].CARD);
  var shouldShowPaymentProviderWithNoPaymentMethods = isHostedFields && isTermsAndConditionsChecked && isHealthRegulationsChecked;
  var displayDonation = !isBuyNowPayLaterPlan && !!(donationAmount !== undefined) && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayDonation');
  var displayPaymentProviderForm = !!(hasNoPaymentMethods ? shouldShowPaymentProviderWithNoPaymentMethods : shouldShowPaymentProviderOfSpecificCard);
  var displayPaymentProvidersForm = !!((paymentProviders.length > 1 || paymentProviders.length === 1 && (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : (_selectedPaymentProvi2 = selectedPaymentProvider.paymentMethods) === null || _selectedPaymentProvi2 === void 0 ? void 0 : _selectedPaymentProvi2.length)) && !isBuyNowPayLaterPlan);
  var displayPaymentMethods = !!((selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : (_selectedPaymentProvi3 = selectedPaymentProvider.paymentMethods) === null || _selectedPaymentProvi3 === void 0 ? void 0 : _selectedPaymentProvi3.length) && !hasPaymentProvidersMatchingBlock);
  return useB2BPaymentForm_useB2BPaymentForm({
    displayFreeDeposit: !!isFreeDeposit,
    displayDonation: displayDonation,
    displayHealthRegulations: !!healthRegulations,
    displayTermsAndConditions: true,
    displayPaymentPlan: true,
    displayPaymentMethodsWithConditions: !!showPaymentMethodWithConditions,
    displayBuyNowPayLater: !!paymentPlans.length,
    displayBillingAddressForm: !!(selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.withBillingAddress) && (!isHostedFields || shouldShowPaymentProviderWithNoPaymentMethods),
    displayPaymentProviderForm: displayPaymentProviderForm,
    displayPaymentProvidersForm: displayPaymentProvidersForm,
    displayPaymentMethods: displayPaymentMethods,
    paymentProviders: paymentProviders
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/hooks/usePaymentForm.jsx




























var usePaymentForm_usePaymentForm = function usePaymentForm(_ref) {
  var _formik$values, _formik$values$Health, _formik$errors, _selectedPaymentProvi2, _selectedPaymentProvi3;

  var i18n = _ref.i18n,
      paymentSchedule = _ref.paymentSchedule,
      _ref$buyNowPayLaterPr = _ref.buyNowPayLaterProviders,
      buyNowPayLaterProviders = _ref$buyNowPayLaterPr === void 0 ? [] : _ref$buyNowPayLaterPr,
      paymentProviders = _ref.paymentProviders,
      totalPrice = _ref.totalPrice,
      shouldShowPaymentProcess = _ref.shouldShowPaymentProcess,
      paymentProcessOnError = _ref.paymentProcessOnError;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      donationAmount = _useContext.donationAmount,
      isFreeDeposit = _useContext.isFreeDeposit,
      bookingResume = _useContext.bookingResume;

  var _useState = Object(react["useState"])(formik.values.amountToPay === paymentSchedule.total.value),
      hasFullAmount = _useState[0],
      setHasFullAmount = _useState[1];

  var _useState2 = Object(react["useState"])([]),
      loadedPaymentPlans = _useState2[0],
      setLoadedPaymentPlans = _useState2[1];

  usePaypalForm_usePaypalForm();
  var paymentPlans = buyNowPayLaterProviders.filter(function (_ref2) {
    var id = _ref2.id;
    return Object(BuyNowPayLater_utils["b" /* isAllowedPaymentPlan */])({
      id: id,
      price: totalPrice,
      startDate: bookingResume.departureDate
    });
  }).map(function (_ref3) {
    var id = _ref3.id,
        description = _ref3.description;
    return {
      value: id,
      selector: BuyNowPayLater_const["d" /* PAYMENT_PLAN_SELECTOR */][id],
      label: description || '',
      name: 'paymentProviderId',
      isIframe: Object(BuyNowPayLater_utils["c" /* isIframeBuyNowPayLaterProvider */])(id)
    };
  });
  var paymentInProgress = shouldShowPaymentProcess && !paymentProcessOnError; // $FlowFixMe always found

  var selectedPaymentProvider = Object(react["useMemo"])(function () {
    return [].concat(Object(toConsumableArray["a" /* default */])(buyNowPayLaterProviders), Object(toConsumableArray["a" /* default */])(paymentProviders)).find(function (_ref4) {
      var id = _ref4.id;
      return id === formik.values.paymentProviderId;
    });
  }, [formik.values.paymentProviderId]);
  var paymentMethod = Object(react["useMemo"])(function () {
    var _selectedPaymentProvi;

    return (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : (_selectedPaymentProvi = selectedPaymentProvider.paymentMethods) === null || _selectedPaymentProvi === void 0 ? void 0 : _selectedPaymentProvi.find(function (_ref5) {
      var id = _ref5.id;
      return id === formik.values.paymentMethodId;
    })) || {
      category: '',
      id: (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.id) || '',
      image: (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.logo) || '',
      label: (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.categoryPaymentMethod) || '',
      timePaymentConditions: []
    };
  }, [selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.id, formik.values.paymentMethodId]);
  var isHipayProvider = formik.values.paymentProviderId === PaymentInfo_const["f" /* HIPAY_PSP_ID */]; // in case of hosted fields we pick the paymentProduct instead
  // if the payment isHipay

  var paymentConditionId = isHipayProvider && formik.values.paymentProduct || formik.values.paymentConditionId;
  var availablePaymentPlans = paymentPlans.filter(function (_ref6) {
    var value = _ref6.value;
    return loadedPaymentPlans.find(function (_ref7) {
      var id = _ref7.id,
          display = _ref7.display;
      return display && id === value;
    });
  });
  var isPaymentPlansLoading = !!paymentPlans.length && !(paymentPlans.length === loadedPaymentPlans.length); // Health Regulations Checkbox (legal_infos)

  var healthRegulations = Object(bookingUtils["f" /* getHealthRegulationsFromLegalInfos */])(i18n.bookingProcess);
  var hasHealthRegulations = !!healthRegulations;
  var isHealthRegulationsChecked = !hasHealthRegulations || hasHealthRegulations && !!((_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : (_formik$values$Health = _formik$values.HealthRegulations) === null || _formik$values$Health === void 0 ? void 0 : _formik$values$Health.cgv);

  var isTermsAndConditionsChecked = isEmpty_default()((_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.termsAndConditions);

  var paymentProviderId = formik.values.paymentProviderId || '';
  var showPaymentMethodWithConditions = selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : (_selectedPaymentProvi2 = selectedPaymentProvider.paymentMethods) === null || _selectedPaymentProvi2 === void 0 ? void 0 : _selectedPaymentProvi2.some(function (_ref8) {
    var timePaymentConditions = _ref8.timePaymentConditions;
    return timePaymentConditions.length > 1;
  });
  var hasPaymentProvidersMatchingBlock = paymentProviders.some(function (_ref9) {
    var categoryPaymentMethod = _ref9.categoryPaymentMethod;
    return [PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].PAYPAL, PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].DIRECT_DEBIT, PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].BANK_TRANSFER, PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].CREDIT_CARD].includes(categoryPaymentMethod);
  });
  var hasNoPaymentMethods = ((selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : (_selectedPaymentProvi3 = selectedPaymentProvider.paymentMethods) === null || _selectedPaymentProvi3 === void 0 ? void 0 : _selectedPaymentProvi3.length) || 0) <= 1;
  var isHostedFields = Object(payment_utils["e" /* isHostedFieldsPayment */])(paymentProviderId);
  var isIframe = Object(payment_utils["f" /* isIframePayment */])(paymentProviderId, appContext);
  var shouldAutoSubmitForm = (isIframe || isHostedFields) && isHealthRegulationsChecked && !hasNoPaymentMethods;
  var selectedBuyNowPayLaterPlan = availablePaymentPlans.find(function (_ref10) {
    var value = _ref10.value;
    return value === paymentProviderId;
  });
  var isBuyNowPayLaterPlan = !!selectedBuyNowPayLaterPlan;
  var amountToPay = isFreeDeposit ? Number(formik.values.freeDeposit) : Number(formik.values.amountToPay);
  var totalAmountToPay = isBuyNowPayLaterPlan ? totalPrice : amountToPay;
  var shouldDisplayBNPLIframe = isTermsAndConditionsChecked && isHealthRegulationsChecked;
  var disableFields = paymentInProgress || !!((selectedBuyNowPayLaterPlan === null || selectedBuyNowPayLaterPlan === void 0 ? void 0 : selectedBuyNowPayLaterPlan.isIframe) && shouldDisplayBNPLIframe);

  var setLoadedPlan = function setLoadedPlan(plan) {
    var isExistingPaymentPlan = false;

    var newLoadedPaymentPlans = Object(toConsumableArray["a" /* default */])(loadedPaymentPlans.map(function (loadedPaymentPlan) {
      if (loadedPaymentPlan.id === plan.id) {
        isExistingPaymentPlan = true;
        return plan;
      }

      return loadedPaymentPlan;
    }));

    setLoadedPaymentPlans([].concat(Object(toConsumableArray["a" /* default */])(newLoadedPaymentPlans), Object(toConsumableArray["a" /* default */])(isExistingPaymentPlan ? [] : [plan])));
  };

  Object(react["useEffect"])(function () {
    if (!paymentProviderId) {
      var _paymentProviders$;

      var defaultPaymentProviderId = paymentProviders === null || paymentProviders === void 0 ? void 0 : (_paymentProviders$ = paymentProviders[0]) === null || _paymentProviders$ === void 0 ? void 0 : _paymentProviders$.id;
      formik.setFieldValue('paymentProviderId', defaultPaymentProviderId);
      formik.setFieldValue('selectorPaymentProviderId', defaultPaymentProviderId);
    }
  }, [paymentProviderId]);
  Object(ScrollToErrorHook["a" /* useAutoScrollToError */])(formik);
  Object(react["useEffect"])(function () {
    // validate form on mount to make initial validation
    formik.validateForm();
  }, []);
  Object(react["useEffect"])(function () {
    if (isIframe && hasNoPaymentMethods && formik.dirty && formik.isValid) {
      formik.submitForm();
    }
  }, [isIframe, formik.isValid, formik.values.amountToPay, hasNoPaymentMethods, formik.dirty]);
  var paymentFormDisplay = usePaymentFormDisplay_usePaymentFormDisplay({
    isBuyNowPayLaterPlan: isBuyNowPayLaterPlan,
    paymentProviders: paymentProviders,
    paymentPlans: paymentPlans,
    showPaymentMethodWithConditions: showPaymentMethodWithConditions,
    hasPaymentProvidersMatchingBlock: hasPaymentProvidersMatchingBlock,
    selectedPaymentProvider: selectedPaymentProvider,
    hasNoPaymentMethods: hasNoPaymentMethods,
    healthRegulations: healthRegulations,
    isHealthRegulationsChecked: isHealthRegulationsChecked,
    isHostedFields: isHostedFields
  });
  useBankingNavbar_useBankingNavbar({
    selectedPaymentProvider: selectedPaymentProvider,
    paymentPlans: paymentPlans,
    showPaymentMethodWithConditions: showPaymentMethodWithConditions,
    isIframe: isIframe,
    paymentMethodLabel: formik.values.paymentProduct || paymentMethod.label
  });
  return {
    hasFullAmount: hasFullAmount,
    currentPaymentPlans: isPaymentPlansLoading ? paymentPlans : availablePaymentPlans,
    isPaymentPlansLoading: isPaymentPlansLoading,
    showPaymentMethodWithConditions: showPaymentMethodWithConditions,
    shouldAutoSubmitForm: shouldAutoSubmitForm,
    hasPaymentProvidersMatchingBlock: hasPaymentProvidersMatchingBlock,
    selectedPaymentProvider: selectedPaymentProvider,
    disableFields: disableFields,
    hasNoPaymentMethods: hasNoPaymentMethods,
    healthRegulations: healthRegulations,
    displayNewPaymentProvidersImplementation: hasPaymentProvidersMatchingBlock || paymentFormDisplay.displayNewPaymentProvidersImplementation,
    shouldDisplayDonationTerms: !isBuyNowPayLaterPlan && !!(donationAmount && donationAmount > 0),
    shouldDisplayBNPLIframe: shouldDisplayBNPLIframe,
    paymentConditionId: paymentConditionId,
    paymentPlans: paymentPlans,
    paymentMethod: paymentMethod,
    paymentInProgress: paymentInProgress,
    totalAmountToPay: totalAmountToPay,
    setLoadedPlan: setLoadedPlan,
    setHasFullAmount: setHasFullAmount,
    paymentFormDisplay: paymentFormDisplay
  };
};
// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/widgets/booking-navbar/BookingNavbarContext.jsx
var BookingNavbarContext = __webpack_require__("4ryf");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/b2b-payment-info/B2BFreeDeposit.jsx












var B2BFreeDeposit_jsx = react_default.a.createElement;

function B2BFreeDeposit_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function B2BFreeDeposit_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { B2BFreeDeposit_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { B2BFreeDeposit_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var ALLOWED_EXCEEDANCE_PERCENTAGE = 0.5;
var ALLOWED_EXCEEDANCE_AMOUNT = 100000;
var B2BFreeDeposit_B2BFreeDeposit = function B2BFreeDeposit(props) {
  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isOpen = _useDisclosure.isOpen,
      onClose = _useDisclosure.onClose,
      onOpen = _useDisclosure.onOpen;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isCxo = _useAppContext.isCxo,
      locale = _useAppContext.locale;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      currency = _useContext.currency;

  var withExceedancePrice = isCxo && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('exceedTotalAmount') ? ALLOWED_EXCEEDANCE_AMOUNT : props.price.value + props.totalPrice.value * ALLOWED_EXCEEDANCE_PERCENTAGE / 100;

  var _useBookingNavbarCont = Object(BookingNavbarContext["b" /* useBookingNavbarContext */])(),
      validationCallback = _useBookingNavbarCont.validationCallback;

  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var isExceededDuePrice = formik.values.freeDeposit > props.price.value;
  Object(useBookingNavbar["a" /* useBookingNavbar */])({
    processValidation: isExceededDuePrice ? onOpen : undefined
  });
  return B2BFreeDeposit_jsx(react_default.a.Fragment, null, B2BFreeDeposit_jsx(FreeDeposit_FreeDeposit, Object(esm_extends["a" /* default */])({}, props, {
    price: B2BFreeDeposit_objectSpread(B2BFreeDeposit_objectSpread({}, props.price), {}, {
      value: withExceedancePrice
    })
  })), isOpen && B2BFreeDeposit_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: onClose
  }, B2BFreeDeposit_jsx("div", {
    className: "flex flex-col p-25 text-sienna"
  }, B2BFreeDeposit_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(src_i18n["h" /* t */])('booking.partners.banking.freeDeposit.maxAmountExceeded'),
    valuesClassName: {
      value: 'font-bold text-16 text-sienna'
    },
    values: {
      value: Object(currencyConfigForLocale["a" /* formatAmount */])(formik.values.freeDeposit, currency, locale)
    }
  })), B2BFreeDeposit_jsx("div", null, B2BFreeDeposit_jsx("div", {
    className: "flex justify-center md:justify-end mt-15 mb-20 mx-20 gap-5"
  }, B2BFreeDeposit_jsx(Button["a" /* Button */], {
    colorBg: "transparent",
    colorBorder: "black",
    onClick: onClose,
    size: "medium"
  }, Object(src_i18n["h" /* t */])('common.cancel')), B2BFreeDeposit_jsx(Button["a" /* Button */], {
    className: "font-bold text-12",
    onClick: function onClick() {
      onClose();
      validationCallback === null || validationCallback === void 0 ? void 0 : validationCallback();
    },
    size: "medium"
  }, Object(src_i18n["h" /* t */])('common.continue'))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-method/PaymentFees.jsx
var PaymentFees_jsx = react_default.a.createElement;



var PaymentFees_PaymentFees = function PaymentFees(_ref) {
  var chargePercentage = _ref.chargePercentage;
  return PaymentFees_jsx("div", {
    className: "m-15 text-14",
    "data-testid": "paymentMethodFees"
  }, PaymentFees_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.percentageChargedDescription'),
    values: {
      percentage_value: "".concat(chargePercentage, "%")
    },
    valuesClassName: {
      percentage_value: 'font-bold text-saffron'
    }
  }));
};
// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-method/PaymentMethodsWithConditions.jsx









var PaymentMethodsWithConditions_jsx = react_default.a.createElement;













var PaymentMethodsWithConditions_PaymentMethodsWithConditions = function PaymentMethodsWithConditions(_ref) {
  var _availableTimePayment, _paymentMethodSelecte3;

  var paymentProvider = _ref.paymentProvider,
      _ref$requiredRule = _ref.requiredRule,
      requiredRule = _ref$requiredRule === void 0 ? lib["string"]().required() : _ref$requiredRule;
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      currency = _useContext.currency,
      setCardFeesPercentage = _useContext.setCardFeesPercentage;

  var _useBookingNavbarCont = Object(BookingNavbarContext["b" /* useBookingNavbarContext */])(),
      hideContinueButton = _useBookingNavbarCont.hideContinueButton;

  var paymentConditionId = formik.values.paymentConditionId;
  Object(react["useEffect"])(function () {
    if (!formik.values.paymentMethodId) {
      formik.setFieldValue('paymentMethodId', paymentProvider.paymentMethods[0].id);
      formik.setFieldValue('paymentConditionId', paymentProvider.paymentMethods[0].timePaymentConditions[0].id);
    }
  }, [formik.values.paymentMethodId]);
  var availableTimePaymentConditions = paymentProvider.paymentMethods.reduce(function (acc, _ref2) {
    var timePaymentConditions = _ref2.timePaymentConditions;
    return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(timePaymentConditions));
  }, []);
  var paymentCountSelected = (_availableTimePayment = availableTimePaymentConditions.find(function (_ref3) {
    var id = _ref3.id;
    return id === paymentConditionId;
  })) === null || _availableTimePayment === void 0 ? void 0 : _availableTimePayment.paymentCount; // $FlowFixMe always found

  var paymentMethodSelected = paymentProvider.paymentMethods.find(function (_ref4) {
    var id = _ref4.id;
    return id === formik.values.paymentMethodId;
  });

  var computeInstallments = function computeInstallments(_ref5) {
    var paymentCount = _ref5.paymentCount,
        chargePercentage = _ref5.chargePercentage;
    var _formik$values = formik.values,
        amountToPay = _formik$values.amountToPay,
        freeDeposit = _formik$values.freeDeposit;
    var amount = freeDeposit || amountToPay;
    var fees = amount * (chargePercentage / 100);
    var installment = (amount + fees) / paymentCount;
    return {
      amount: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(installment, locale, currency, {
        precision: 2
      }),
      fees: fees
    };
  };

  Object(react["useEffect"])(function () {
    if (paymentMethodSelected) {
      var _paymentMethodSelecte;

      formik.setFieldValue('paymentConditionId', ((_paymentMethodSelecte = paymentMethodSelected.timePaymentConditions.find(function (_ref6) {
        var paymentCount = _ref6.paymentCount;
        return paymentCount === paymentCountSelected;
      })) === null || _paymentMethodSelecte === void 0 ? void 0 : _paymentMethodSelecte.id) || paymentMethodSelected.timePaymentConditions[0].id);
    }
  }, [paymentMethodSelected]);
  Object(react["useEffect"])(function () {
    if (paymentMethodSelected && paymentConditionId) {
      var _paymentMethodSelecte2 = paymentMethodSelected.timePaymentConditions.find(function (_ref7) {
        var id = _ref7.id;
        return id === formik.values.paymentConditionId;
      }),
          chargePercentage = _paymentMethodSelecte2.chargePercentage;

      setCardFeesPercentage(chargePercentage / 100);
    }
  }, [paymentConditionId]);
  var isFormValid = formik.isValid && Object.values(formik.touched).length;
  var paymentConditionSelected = paymentMethodSelected === null || paymentMethodSelected === void 0 ? void 0 : (_paymentMethodSelecte3 = paymentMethodSelected.timePaymentConditions) === null || _paymentMethodSelecte3 === void 0 ? void 0 : _paymentMethodSelecte3.find(function (_ref8) {
    var id = _ref8.id;
    return id === formik.values.paymentConditionId;
  });
  Object(react["useEffect"])(function () {
    hideContinueButton && isFormValid && paymentConditionSelected && setTimeout(formik.submitForm, 0);
  }, [formik.values.paymentConditionId, hideContinueButton]);

  if (!paymentConditionSelected) {
    return null;
  }

  return PaymentMethodsWithConditions_jsx("div", {
    className: "mt-20"
  }, PaymentMethodsWithConditions_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n2"
  }, Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.title')), PaymentMethodsWithConditions_jsx(Capsule["a" /* Capsule */], {
    header: "none",
    contentClassName: "p-20"
  }, PaymentMethodsWithConditions_jsx("div", {
    className: "-m-10 flex flex-wrap items-end"
  }, PaymentMethodsWithConditions_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PaymentMethodsWithConditions_jsx(FormikInput["a" /* FormikInput */], {
    type: "select",
    name: "paymentMethodId",
    label: Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.selectCardTypeLabel'),
    showValidateState: false,
    options: paymentProvider.paymentMethods.map(function (_ref9) {
      var id = _ref9.id,
          label = _ref9.label;
      return {
        name: label,
        value: id
      };
    })
  })), PaymentMethodsWithConditions_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PaymentMethodsWithConditions_jsx(FormikInput["a" /* FormikInput */], {
    type: "select",
    name: "paymentConditionId",
    label: Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.selectNumberOfMonthsLabel'),
    showValidateState: false,
    options: paymentMethodSelected.timePaymentConditions.map(function (_ref10) {
      var id = _ref10.id,
          paymentCount = _ref10.paymentCount,
          chargePercentage = _ref10.chargePercentage;

      var _computeInstallments = computeInstallments({
        paymentCount: paymentCount,
        chargePercentage: chargePercentage
      }),
          amount = _computeInstallments.amount,
          fees = _computeInstallments.fees;

      return {
        name: Object(src_i18n["h" /* t */])(Object(labelUtils["d" /* pluralizeLabel */])('booking.banking.paymentMethod.monthLabel', 'booking.banking.paymentMethod.monthsLabel', paymentCount), {
          month_payment_count: paymentCount,
          amount: amount
        }) + ' ' + (fees ? Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.withFees') : Object(src_i18n["h" /* t */])('booking.banking.paymentMethod.withoutFees')),
        value: id
      };
    }),
    validate: requiredRule,
    isRequired: true
  }))), paymentConditionSelected.chargePercentage > 0 && PaymentMethodsWithConditions_jsx(PaymentFees_PaymentFees, {
    chargePercentage: paymentConditionSelected.chargePercentage
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/PaymentForm.jsx













var PaymentForm_jsx = react_default.a.createElement;

function PaymentForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PaymentForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PaymentForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PaymentForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















var PaymentForm_PaymentForm = function PaymentForm(_ref) {
  var _formik$touched;

  var i18n = _ref.i18n,
      shouldShowPaymentProcess = _ref.shouldShowPaymentProcess,
      paymentProcessId = _ref.paymentProcessId,
      paymentProcessOnError = _ref.paymentProcessOnError,
      paymentProviders = _ref.paymentProviders,
      buyNowPayLaterProviders = _ref.buyNowPayLaterProviders,
      paymentSchedule = _ref.paymentSchedule,
      price = _ref.price,
      totalPrice = _ref.totalPrice,
      deadlineDate = _ref.deadlineDate,
      dispatch = _ref.dispatch;
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      currency = _useContext.currency;

  var _usePaymentForm = usePaymentForm_usePaymentForm({
    i18n: i18n,
    paymentSchedule: paymentSchedule,
    buyNowPayLaterProviders: buyNowPayLaterProviders,
    paymentProviders: paymentProviders,
    totalPrice: price.value,
    shouldShowPaymentProcess: shouldShowPaymentProcess,
    paymentProcessOnError: paymentProcessOnError
  }),
      hasFullAmount = _usePaymentForm.hasFullAmount,
      currentPaymentPlans = _usePaymentForm.currentPaymentPlans,
      isPaymentPlansLoading = _usePaymentForm.isPaymentPlansLoading,
      showPaymentMethodWithConditions = _usePaymentForm.showPaymentMethodWithConditions,
      shouldAutoSubmitForm = _usePaymentForm.shouldAutoSubmitForm,
      hasPaymentProvidersMatchingBlock = _usePaymentForm.hasPaymentProvidersMatchingBlock,
      displayNewPaymentProvidersImplementation = _usePaymentForm.displayNewPaymentProvidersImplementation,
      selectedPaymentProvider = _usePaymentForm.selectedPaymentProvider,
      disableFields = _usePaymentForm.disableFields,
      hasNoPaymentMethods = _usePaymentForm.hasNoPaymentMethods,
      healthRegulations = _usePaymentForm.healthRegulations,
      shouldDisplayDonationTerms = _usePaymentForm.shouldDisplayDonationTerms,
      shouldDisplayBNPLIframe = _usePaymentForm.shouldDisplayBNPLIframe,
      setLoadedPlan = _usePaymentForm.setLoadedPlan,
      setHasFullAmount = _usePaymentForm.setHasFullAmount,
      paymentInProgress = _usePaymentForm.paymentInProgress,
      paymentPlans = _usePaymentForm.paymentPlans,
      totalAmountToPay = _usePaymentForm.totalAmountToPay,
      paymentConditionId = _usePaymentForm.paymentConditionId,
      paymentMethod = _usePaymentForm.paymentMethod,
      paymentFormDisplay = _usePaymentForm.paymentFormDisplay;

  var freeDepositProps = {
    paymentSchedule: paymentSchedule,
    deadlineDate: deadlineDate || -Infinity,
    price: price,
    touched: (_formik$touched = formik.touched) === null || _formik$touched === void 0 ? void 0 : _formik$touched.freeDeposit
  };
  var paymentFormComponents = [{
    component: FreeDeposit_FreeDeposit,
    name: 'FreeDeposit',
    props: freeDepositProps
  }, {
    component: B2BFreeDeposit_B2BFreeDeposit,
    name: 'B2BFreeDeposit',
    props: PaymentForm_objectSpread(PaymentForm_objectSpread({}, freeDepositProps), {}, {
      totalPrice: totalPrice
    })
  }, {
    component: PaymentPlan["a" /* PaymentPlan */],
    name: 'B2BPaymentPlan',
    props: {
      setHasFullAmount: setHasFullAmount,
      paymentSchedule: paymentSchedule,
      displayTooltip: false,
      isDisabled: paymentInProgress,
      hasFullAmount: hasFullAmount,
      payFullAmountLabel: 'booking.partners.banking.paymentSchedule.payFullAmount',
      depositSelectedLabel: 'booking.partners.banking.paymentSchedule.depositSelected'
    }
  }, {
    component: PaymentPlan["a" /* PaymentPlan */],
    name: 'PaymentPlan',
    props: {
      paymentPlans: currentPaymentPlans,
      isLoading: isPaymentPlansLoading,
      setHasFullAmount: setHasFullAmount,
      paymentSchedule: paymentSchedule,
      hasFullAmount: hasFullAmount
    }
  }, {
    component: PaymentProvidersForm_PaymentProvidersForm,
    name: 'PaymentProvidersForm',
    props: {
      hasFullAmount: hasFullAmount,
      paymentProviders: paymentProviders,
      paymentSchedule: paymentSchedule,
      shouldAutoSubmitForm: shouldAutoSubmitForm,
      showPaymentMethodWithConditions: showPaymentMethodWithConditions,
      displayNewPaymentProvidersImplementation: displayNewPaymentProvidersImplementation
    }
  }, {
    component: B2BPaymentProvidersForm_B2BPaymentProvidersForm,
    name: 'B2BPaymentProvidersForm',
    props: {
      selectedPaymentProvider: selectedPaymentProvider,
      hasFullAmount: hasFullAmount,
      isDisabled: paymentInProgress,
      paymentProviders: paymentProviders,
      paymentSchedule: paymentSchedule,
      showPaymentMethodWithConditions: showPaymentMethodWithConditions,
      shouldAutoSubmitForm: shouldAutoSubmitForm,
      hasPaymentProvidersMatchingBlock: hasPaymentProvidersMatchingBlock,
      displayNewPaymentProvidersImplementation: displayNewPaymentProvidersImplementation
    }
  }, {
    component: PaymentMethodsWithConditions_PaymentMethodsWithConditions,
    name: 'PaymentMethodsWithConditions',
    props: {
      paymentProvider: selectedPaymentProvider
    }
  }, {
    component: Donation_Donation,
    name: 'Donation',
    testId: 'donation-block',
    props: {
      currency: currency,
      isDisabled: disableFields
    }
  }, {
    component: HealthRegulations_HealthRegulations,
    name: 'HealthRegulations',
    testId: 'contract-info-block',
    props: {
      isDisabled: disableFields,
      shouldSubmitFormOnAccept: false,
      hasNoPaymentMethods: hasNoPaymentMethods,
      healthRegulations: healthRegulations
    }
  }, {
    component: TermsAndConditions["a" /* TermsAndConditions */],
    name: 'TermsAndConditions',
    testId: 'cgv-block',
    props: {
      i18n: i18n,
      shouldDisplayDonationTerms: shouldDisplayDonationTerms,
      isDisabled: disableFields,
      shouldSubmitFormOnAccept: shouldAutoSubmitForm,
      hasNoPaymentMethods: hasNoPaymentMethods
    }
  }, {
    component: BuyNowPayLater_BuyNowPayLater,
    name: 'BuyNowPayLater',
    props: {
      onLoaded: setLoadedPlan,
      price: price.value,
      displayIframe: shouldDisplayBNPLIframe,
      paymentPlans: paymentPlans
    }
  }, {
    component: PaymentMethods_PaymentMethods,
    name: 'PaymentMethods',
    props: {
      paymentProvider: selectedPaymentProvider,
      showPaymentMethodWithConditions: showPaymentMethodWithConditions,
      shouldSubmitFormOnPaymentChosen: shouldAutoSubmitForm
    }
  }, {
    component: BillingAddressForm_BillingAddressForm,
    name: 'BillingAddressForm',
    props: {
      i18n: i18n,
      path: 'billingDetails'
    }
  }, {
    component: PaymentProviderForm_PaymentProviderForm,
    name: 'PaymentProviderForm',
    props: {
      hasNoPaymentMethods: hasNoPaymentMethods,
      selectedPaymentProvider: selectedPaymentProvider
    }
  }].filter(function (_ref2) {
    var name = _ref2.name;
    return paymentFormDisplay["display".concat(name)];
  });
  return PaymentForm_jsx(react["Fragment"], null, PaymentForm_jsx(formik_esm["c" /* Form */], {
    className: "flex flex-col"
  }, PaymentForm_jsx("input", {
    name: "currentPayingCustomerId",
    type: "hidden",
    value: formik.values.currentPayingCustomerId
  }), paymentFormComponents.map(function (_ref3, index) {
    var Component = _ref3.component,
        _ref3$testId = _ref3.testId,
        testId = _ref3$testId === void 0 ? '' : _ref3$testId,
        props = _ref3.props;
    return PaymentForm_jsx("div", {
      className: "".concat(index && 'mt-20'),
      key: Component.name,
      "data-testId": testId
    }, PaymentForm_jsx(Component, props));
  })), shouldShowPaymentProcess ? PaymentForm_jsx("div", {
    className: "mt-20"
  }, PaymentForm_jsx(PaymentProcess_PaymentProcess, {
    amountToPay: totalAmountToPay,
    paymentConditionId: paymentConditionId // $FlowFixMe paymentProcessId is never null at this point
    ,
    paymentProcessId: paymentProcessId,
    onErrorCallback: function onErrorCallback() {
      dispatch({
        type: 'paymentProcessError'
      });
      formik.setStatus({
        paymentProcessOnError: true
      });
      formik.setSubmitting(false);
    },
    paymentMethod: paymentMethod,
    shouldSkipPayment: !!(selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.shouldSkipPayment)
  })) : formik.values.paymentProviderId === PaymentInfo_const["r" /* WECHAT_PSP_ID */] && PaymentForm_jsx(WeChatTutorial_WeChatTutorial, null));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.jsx












var PaymentInfo_jsx = react_default.a.createElement;

function PaymentInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PaymentInfo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PaymentInfo_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PaymentInfo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var defaultState = {
  shouldShowPaymentProcess: false,
  paymentProcessOnError: false,
  paymentProcessId: null
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'showPaymentProcess':
      return {
        shouldShowPaymentProcess: true,
        paymentProcessOnError: false,
        paymentProcessId: Date.now() // just for trigger the re-fetch of data in payment process

      };

    case 'paymentProcessError':
      return PaymentInfo_objectSpread(PaymentInfo_objectSpread({}, state), {}, {
        paymentProcessOnError: true
      });

    case 'reset':
      return defaultState;

    default:
      throw new Error();
  }
};

var PaymentInfo_PaymentInfo = function PaymentInfo(_ref) {
  var _payingHousehold$paym, _availablePaymentProv, _availablePaymentProv2;

  var className = _ref.className,
      i18n = _ref.i18n,
      paymentProviders = _ref.paymentProviders,
      paymentSchedule = _ref.paymentSchedule,
      totalPrice = _ref.totalPrice,
      deadlineDate = _ref.deadlineDate,
      price = _ref.price,
      payingHousehold = _ref.payingHousehold;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useReducer = Object(react["useReducer"])(reducer, defaultState),
      _useReducer$ = _useReducer[0],
      shouldShowPaymentProcess = _useReducer$.shouldShowPaymentProcess,
      paymentProcessId = _useReducer$.paymentProcessId,
      paymentProcessOnError = _useReducer$.paymentProcessOnError,
      dispatch = _useReducer[1];

  var enabledPaymentProviders = Object(paymentProvidersUtils["b" /* getEnabledPaymentProviders */])(paymentProviders, !isTablet, appContext);

  var _partition2 = partition_default()(enabledPaymentProviders, function (provider) {
    return !Object(paymentProvidersUtils["f" /* isBuyNowPayLater */])(provider);
  }),
      _partition3 = Object(slicedToArray["a" /* default */])(_partition2, 2),
      availablePaymentProviders = _partition3[0],
      buyNowPayLaterProviders = _partition3[1];

  var shouldPrioritizeFullPayment = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.prioritizeFullPayment');
  var isBillingAddressMandatory = availablePaymentProviders.some(function (_ref2) {
    var withBillingAddress = _ref2.withBillingAddress;
    return withBillingAddress;
  });
  var amountToPay = shouldPrioritizeFullPayment ? payingHousehold.paymentSchedule.total.value : ((_payingHousehold$paym = payingHousehold.paymentSchedule.depositAmount) === null || _payingHousehold$paym === void 0 ? void 0 : _payingHousehold$paym.value) || payingHousehold.paymentSchedule.total.value;

  var initialValues = PaymentInfo_objectSpread(PaymentInfo_objectSpread({
    freeDeposit: appContext.isSeller ? amountToPay : '',
    amountToPay: amountToPay,
    paymentProviderId: availablePaymentProviders === null || availablePaymentProviders === void 0 ? void 0 : (_availablePaymentProv = availablePaymentProviders[0]) === null || _availablePaymentProv === void 0 ? void 0 : _availablePaymentProv.id
  }, isBillingAddressMandatory && {
    billingDetails: {
      countryCode: appContext.country
    }
  }), {}, {
    selectorPaymentProviderId: availablePaymentProviders === null || availablePaymentProviders === void 0 ? void 0 : (_availablePaymentProv2 = availablePaymentProviders[0]) === null || _availablePaymentProv2 === void 0 ? void 0 : _availablePaymentProv2.selectorId,
    paymentMethodId: '',
    paymentConditionId: '',
    termsAndConditions: {
      cgv: false,
      donation: false
    },
    HealthRegulations: {
      cgv: false
    },
    currentPayingCustomerId: payingHousehold.customerId
  });

  return PaymentInfo_jsx(SiteContainer["a" /* SiteContainer */], {
    className: className,
    size: "small"
  }, PaymentInfo_jsx(formik_esm["d" /* Formik */], {
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: function onSubmit(_ref3, actions) {
      var paymentProduct = _ref3.paymentProduct,
          paymentProviderId = _ref3.paymentProviderId,
          paymentMethodId = _ref3.paymentMethodId;
      Object(PaymentInfo_utils["e" /* persistPaymentMethodInCookies */])({
        paymentProduct: paymentProduct,
        paymentMethodId: paymentMethodId,
        paymentProvider: enabledPaymentProviders.find(function (_ref4) {
          var id = _ref4.id;
          return id === paymentProviderId;
        })
      });
      dispatch({
        type: 'showPaymentProcess'
      });
      actions.setStatus({
        paymentProcessOnError: false
      });
    },
    validateOnMount: true,
    validateOnBlur: false
  }, PaymentInfo_jsx("div", null, PaymentInfo_jsx(B2BPaymentViewContext_B2BPaymentViewProvider, null, PaymentInfo_jsx(PaymentForm_PaymentForm, {
    i18n: i18n,
    shouldShowPaymentProcess: shouldShowPaymentProcess,
    paymentProcessId: paymentProcessId,
    paymentProcessOnError: paymentProcessOnError,
    paymentProviders: availablePaymentProviders,
    totalPrice: totalPrice,
    buyNowPayLaterProviders: buyNowPayLaterProviders,
    paymentSchedule: paymentSchedule,
    price: price,
    deadlineDate: deadlineDate,
    dispatch: dispatch
  })))));
};

/***/ }),

/***/ "z+NW":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('uniqBy', __webpack_require__("yjkv"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "zCbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WITH_TRANSPORT; });
/* unused harmony export WITHOUT_TRANSPORT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_PREFIX_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTrackingTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCityCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDepartureCityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isSummer; });
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_toUpper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9BmX");
/* harmony import */ var lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_toUpper__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_inRange__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("+ILc");
/* harmony import */ var lodash_inRange__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_inRange__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("829J");





var WITH_TRANSPORT = 'with_transport';
var WITHOUT_TRANSPORT = 'without_transport';
var NO_DEPARTURE_CITY = 'NO';
var TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare'
};
function getTrackingTransport(departureCityCode) {
  return departureCityCode && lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default()(departureCityCode) !== NO_DEPARTURE_CITY ? WITH_TRANSPORT : WITHOUT_TRANSPORT;
}
function getDepartureCityCode(departureCityCode) {
  return departureCityCode && lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default()(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityCode : WITHOUT_TRANSPORT;
}
function getDepartureCityName(departureCityCode, departureCityName) {
  return departureCityName && departureCityCode && lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default()(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityName : '';
}
function isSummer(date) {
  return lodash_inRange__WEBPACK_IMPORTED_MODULE_2___default()(Number(moment__WEBPACK_IMPORTED_MODULE_3___default()(date).format('MMDD')), _client_tracking_constants__WEBPACK_IMPORTED_MODULE_4__[/* SUMMER_DATE_START */ "E"], _client_tracking_constants__WEBPACK_IMPORTED_MODULE_4__[/* SUMMER_DATE_END */ "D"]);
}

/***/ }),

/***/ "zuLC":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(9).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ })

},[["jwfn",3,4,1,6,0,5,7,8,9,11,10,12,15,13,14,17,16,18,21,25,29,28,30,26,27]]]);